// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.8.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23a6b0cf%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28116, 120, 141, 0.55%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2334c38f%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f46a6a%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f46a6a%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2873, 80, 87, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23222c5c%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%2399a8f0%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/sidebar/img1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/sidebar/img2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/sidebar/img3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/sidebar/img4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/bg-auth-overlay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/crypto/bg-ico-hero.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.8.55" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Template Name: Skote - Admin & Dashboard Template
Author: Themesbrand
Version: 4.1.0.
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.mdi-ab-testing::before {
  content: "\\F01C9"; }

.mdi-abjad-arabic::before {
  content: "\\F1328"; }

.mdi-abjad-hebrew::before {
  content: "\\F1329"; }

.mdi-abugida-devanagari::before {
  content: "\\F132A"; }

.mdi-abugida-thai::before {
  content: "\\F132B"; }

.mdi-access-point::before {
  content: "\\F0003"; }

.mdi-access-point-check::before {
  content: "\\F1538"; }

.mdi-access-point-minus::before {
  content: "\\F1539"; }

.mdi-access-point-network::before {
  content: "\\F0002"; }

.mdi-access-point-network-off::before {
  content: "\\F0BE1"; }

.mdi-access-point-off::before {
  content: "\\F1511"; }

.mdi-access-point-plus::before {
  content: "\\F153A"; }

.mdi-access-point-remove::before {
  content: "\\F153B"; }

.mdi-account::before {
  content: "\\F0004"; }

.mdi-account-alert::before {
  content: "\\F0005"; }

.mdi-account-alert-outline::before {
  content: "\\F0B50"; }

.mdi-account-arrow-left::before {
  content: "\\F0B51"; }

.mdi-account-arrow-left-outline::before {
  content: "\\F0B52"; }

.mdi-account-arrow-right::before {
  content: "\\F0B53"; }

.mdi-account-arrow-right-outline::before {
  content: "\\F0B54"; }

.mdi-account-box::before {
  content: "\\F0006"; }

.mdi-account-box-multiple::before {
  content: "\\F0934"; }

.mdi-account-box-multiple-outline::before {
  content: "\\F100A"; }

.mdi-account-box-outline::before {
  content: "\\F0007"; }

.mdi-account-cancel::before {
  content: "\\F12DF"; }

.mdi-account-cancel-outline::before {
  content: "\\F12E0"; }

.mdi-account-cash::before {
  content: "\\F1097"; }

.mdi-account-cash-outline::before {
  content: "\\F1098"; }

.mdi-account-check::before {
  content: "\\F0008"; }

.mdi-account-check-outline::before {
  content: "\\F0BE2"; }

.mdi-account-child::before {
  content: "\\F0A89"; }

.mdi-account-child-circle::before {
  content: "\\F0A8A"; }

.mdi-account-child-outline::before {
  content: "\\F10C8"; }

.mdi-account-circle::before {
  content: "\\F0009"; }

.mdi-account-circle-outline::before {
  content: "\\F0B55"; }

.mdi-account-clock::before {
  content: "\\F0B56"; }

.mdi-account-clock-outline::before {
  content: "\\F0B57"; }

.mdi-account-cog::before {
  content: "\\F1370"; }

.mdi-account-cog-outline::before {
  content: "\\F1371"; }

.mdi-account-convert::before {
  content: "\\F000A"; }

.mdi-account-convert-outline::before {
  content: "\\F1301"; }

.mdi-account-cowboy-hat::before {
  content: "\\F0E9B"; }

.mdi-account-details::before {
  content: "\\F0631"; }

.mdi-account-details-outline::before {
  content: "\\F1372"; }

.mdi-account-edit::before {
  content: "\\F06BC"; }

.mdi-account-edit-outline::before {
  content: "\\F0FFB"; }

.mdi-account-group::before {
  content: "\\F0849"; }

.mdi-account-group-outline::before {
  content: "\\F0B58"; }

.mdi-account-hard-hat::before {
  content: "\\F05B5"; }

.mdi-account-heart::before {
  content: "\\F0899"; }

.mdi-account-heart-outline::before {
  content: "\\F0BE3"; }

.mdi-account-key::before {
  content: "\\F000B"; }

.mdi-account-key-outline::before {
  content: "\\F0BE4"; }

.mdi-account-lock::before {
  content: "\\F115E"; }

.mdi-account-lock-outline::before {
  content: "\\F115F"; }

.mdi-account-minus::before {
  content: "\\F000D"; }

.mdi-account-minus-outline::before {
  content: "\\F0AEC"; }

.mdi-account-multiple::before {
  content: "\\F000E"; }

.mdi-account-multiple-check::before {
  content: "\\F08C5"; }

.mdi-account-multiple-check-outline::before {
  content: "\\F11FE"; }

.mdi-account-multiple-minus::before {
  content: "\\F05D3"; }

.mdi-account-multiple-minus-outline::before {
  content: "\\F0BE5"; }

.mdi-account-multiple-outline::before {
  content: "\\F000F"; }

.mdi-account-multiple-plus::before {
  content: "\\F0010"; }

.mdi-account-multiple-plus-outline::before {
  content: "\\F0800"; }

.mdi-account-multiple-remove::before {
  content: "\\F120A"; }

.mdi-account-multiple-remove-outline::before {
  content: "\\F120B"; }

.mdi-account-music::before {
  content: "\\F0803"; }

.mdi-account-music-outline::before {
  content: "\\F0CE9"; }

.mdi-account-network::before {
  content: "\\F0011"; }

.mdi-account-network-outline::before {
  content: "\\F0BE6"; }

.mdi-account-off::before {
  content: "\\F0012"; }

.mdi-account-off-outline::before {
  content: "\\F0BE7"; }

.mdi-account-outline::before {
  content: "\\F0013"; }

.mdi-account-plus::before {
  content: "\\F0014"; }

.mdi-account-plus-outline::before {
  content: "\\F0801"; }

.mdi-account-question::before {
  content: "\\F0B59"; }

.mdi-account-question-outline::before {
  content: "\\F0B5A"; }

.mdi-account-reactivate::before {
  content: "\\F152B"; }

.mdi-account-reactivate-outline::before {
  content: "\\F152C"; }

.mdi-account-remove::before {
  content: "\\F0015"; }

.mdi-account-remove-outline::before {
  content: "\\F0AED"; }

.mdi-account-search::before {
  content: "\\F0016"; }

.mdi-account-search-outline::before {
  content: "\\F0935"; }

.mdi-account-settings::before {
  content: "\\F0630"; }

.mdi-account-settings-outline::before {
  content: "\\F10C9"; }

.mdi-account-star::before {
  content: "\\F0017"; }

.mdi-account-star-outline::before {
  content: "\\F0BE8"; }

.mdi-account-supervisor::before {
  content: "\\F0A8B"; }

.mdi-account-supervisor-circle::before {
  content: "\\F0A8C"; }

.mdi-account-supervisor-circle-outline::before {
  content: "\\F14EC"; }

.mdi-account-supervisor-outline::before {
  content: "\\F112D"; }

.mdi-account-switch::before {
  content: "\\F0019"; }

.mdi-account-switch-outline::before {
  content: "\\F04CB"; }

.mdi-account-tie::before {
  content: "\\F0CE3"; }

.mdi-account-tie-outline::before {
  content: "\\F10CA"; }

.mdi-account-tie-voice::before {
  content: "\\F1308"; }

.mdi-account-tie-voice-off::before {
  content: "\\F130A"; }

.mdi-account-tie-voice-off-outline::before {
  content: "\\F130B"; }

.mdi-account-tie-voice-outline::before {
  content: "\\F1309"; }

.mdi-account-voice::before {
  content: "\\F05CB"; }

.mdi-adjust::before {
  content: "\\F001A"; }

.mdi-adobe::before {
  content: "\\F0936"; }

.mdi-adobe-acrobat::before {
  content: "\\F0F9D"; }

.mdi-air-conditioner::before {
  content: "\\F001B"; }

.mdi-air-filter::before {
  content: "\\F0D43"; }

.mdi-air-horn::before {
  content: "\\F0DAC"; }

.mdi-air-humidifier::before {
  content: "\\F1099"; }

.mdi-air-humidifier-off::before {
  content: "\\F1466"; }

.mdi-air-purifier::before {
  content: "\\F0D44"; }

.mdi-airbag::before {
  content: "\\F0BE9"; }

.mdi-airballoon::before {
  content: "\\F001C"; }

.mdi-airballoon-outline::before {
  content: "\\F100B"; }

.mdi-airplane::before {
  content: "\\F001D"; }

.mdi-airplane-landing::before {
  content: "\\F05D4"; }

.mdi-airplane-off::before {
  content: "\\F001E"; }

.mdi-airplane-takeoff::before {
  content: "\\F05D5"; }

.mdi-airport::before {
  content: "\\F084B"; }

.mdi-alarm::before {
  content: "\\F0020"; }

.mdi-alarm-bell::before {
  content: "\\F078E"; }

.mdi-alarm-check::before {
  content: "\\F0021"; }

.mdi-alarm-light::before {
  content: "\\F078F"; }

.mdi-alarm-light-outline::before {
  content: "\\F0BEA"; }

.mdi-alarm-multiple::before {
  content: "\\F0022"; }

.mdi-alarm-note::before {
  content: "\\F0E71"; }

.mdi-alarm-note-off::before {
  content: "\\F0E72"; }

.mdi-alarm-off::before {
  content: "\\F0023"; }

.mdi-alarm-panel::before {
  content: "\\F15C4"; }

.mdi-alarm-panel-outline::before {
  content: "\\F15C5"; }

.mdi-alarm-plus::before {
  content: "\\F0024"; }

.mdi-alarm-snooze::before {
  content: "\\F068E"; }

.mdi-album::before {
  content: "\\F0025"; }

.mdi-alert::before {
  content: "\\F0026"; }

.mdi-alert-box::before {
  content: "\\F0027"; }

.mdi-alert-box-outline::before {
  content: "\\F0CE4"; }

.mdi-alert-circle::before {
  content: "\\F0028"; }

.mdi-alert-circle-check::before {
  content: "\\F11ED"; }

.mdi-alert-circle-check-outline::before {
  content: "\\F11EE"; }

.mdi-alert-circle-outline::before {
  content: "\\F05D6"; }

.mdi-alert-decagram::before {
  content: "\\F06BD"; }

.mdi-alert-decagram-outline::before {
  content: "\\F0CE5"; }

.mdi-alert-minus::before {
  content: "\\F14BB"; }

.mdi-alert-minus-outline::before {
  content: "\\F14BE"; }

.mdi-alert-octagon::before {
  content: "\\F0029"; }

.mdi-alert-octagon-outline::before {
  content: "\\F0CE6"; }

.mdi-alert-octagram::before {
  content: "\\F0767"; }

.mdi-alert-octagram-outline::before {
  content: "\\F0CE7"; }

.mdi-alert-outline::before {
  content: "\\F002A"; }

.mdi-alert-plus::before {
  content: "\\F14BA"; }

.mdi-alert-plus-outline::before {
  content: "\\F14BD"; }

.mdi-alert-remove::before {
  content: "\\F14BC"; }

.mdi-alert-remove-outline::before {
  content: "\\F14BF"; }

.mdi-alert-rhombus::before {
  content: "\\F11CE"; }

.mdi-alert-rhombus-outline::before {
  content: "\\F11CF"; }

.mdi-alien::before {
  content: "\\F089A"; }

.mdi-alien-outline::before {
  content: "\\F10CB"; }

.mdi-align-horizontal-center::before {
  content: "\\F11C3"; }

.mdi-align-horizontal-left::before {
  content: "\\F11C2"; }

.mdi-align-horizontal-right::before {
  content: "\\F11C4"; }

.mdi-align-vertical-bottom::before {
  content: "\\F11C5"; }

.mdi-align-vertical-center::before {
  content: "\\F11C6"; }

.mdi-align-vertical-top::before {
  content: "\\F11C7"; }

.mdi-all-inclusive::before {
  content: "\\F06BE"; }

.mdi-allergy::before {
  content: "\\F1258"; }

.mdi-alpha::before {
  content: "\\F002B"; }

.mdi-alpha-a::before {
  content: "\\F0AEE"; }

.mdi-alpha-a-box::before {
  content: "\\F0B08"; }

.mdi-alpha-a-box-outline::before {
  content: "\\F0BEB"; }

.mdi-alpha-a-circle::before {
  content: "\\F0BEC"; }

.mdi-alpha-a-circle-outline::before {
  content: "\\F0BED"; }

.mdi-alpha-b::before {
  content: "\\F0AEF"; }

.mdi-alpha-b-box::before {
  content: "\\F0B09"; }

.mdi-alpha-b-box-outline::before {
  content: "\\F0BEE"; }

.mdi-alpha-b-circle::before {
  content: "\\F0BEF"; }

.mdi-alpha-b-circle-outline::before {
  content: "\\F0BF0"; }

.mdi-alpha-c::before {
  content: "\\F0AF0"; }

.mdi-alpha-c-box::before {
  content: "\\F0B0A"; }

.mdi-alpha-c-box-outline::before {
  content: "\\F0BF1"; }

.mdi-alpha-c-circle::before {
  content: "\\F0BF2"; }

.mdi-alpha-c-circle-outline::before {
  content: "\\F0BF3"; }

.mdi-alpha-d::before {
  content: "\\F0AF1"; }

.mdi-alpha-d-box::before {
  content: "\\F0B0B"; }

.mdi-alpha-d-box-outline::before {
  content: "\\F0BF4"; }

.mdi-alpha-d-circle::before {
  content: "\\F0BF5"; }

.mdi-alpha-d-circle-outline::before {
  content: "\\F0BF6"; }

.mdi-alpha-e::before {
  content: "\\F0AF2"; }

.mdi-alpha-e-box::before {
  content: "\\F0B0C"; }

.mdi-alpha-e-box-outline::before {
  content: "\\F0BF7"; }

.mdi-alpha-e-circle::before {
  content: "\\F0BF8"; }

.mdi-alpha-e-circle-outline::before {
  content: "\\F0BF9"; }

.mdi-alpha-f::before {
  content: "\\F0AF3"; }

.mdi-alpha-f-box::before {
  content: "\\F0B0D"; }

.mdi-alpha-f-box-outline::before {
  content: "\\F0BFA"; }

.mdi-alpha-f-circle::before {
  content: "\\F0BFB"; }

.mdi-alpha-f-circle-outline::before {
  content: "\\F0BFC"; }

.mdi-alpha-g::before {
  content: "\\F0AF4"; }

.mdi-alpha-g-box::before {
  content: "\\F0B0E"; }

.mdi-alpha-g-box-outline::before {
  content: "\\F0BFD"; }

.mdi-alpha-g-circle::before {
  content: "\\F0BFE"; }

.mdi-alpha-g-circle-outline::before {
  content: "\\F0BFF"; }

.mdi-alpha-h::before {
  content: "\\F0AF5"; }

.mdi-alpha-h-box::before {
  content: "\\F0B0F"; }

.mdi-alpha-h-box-outline::before {
  content: "\\F0C00"; }

.mdi-alpha-h-circle::before {
  content: "\\F0C01"; }

.mdi-alpha-h-circle-outline::before {
  content: "\\F0C02"; }

.mdi-alpha-i::before {
  content: "\\F0AF6"; }

.mdi-alpha-i-box::before {
  content: "\\F0B10"; }

.mdi-alpha-i-box-outline::before {
  content: "\\F0C03"; }

.mdi-alpha-i-circle::before {
  content: "\\F0C04"; }

.mdi-alpha-i-circle-outline::before {
  content: "\\F0C05"; }

.mdi-alpha-j::before {
  content: "\\F0AF7"; }

.mdi-alpha-j-box::before {
  content: "\\F0B11"; }

.mdi-alpha-j-box-outline::before {
  content: "\\F0C06"; }

.mdi-alpha-j-circle::before {
  content: "\\F0C07"; }

.mdi-alpha-j-circle-outline::before {
  content: "\\F0C08"; }

.mdi-alpha-k::before {
  content: "\\F0AF8"; }

.mdi-alpha-k-box::before {
  content: "\\F0B12"; }

.mdi-alpha-k-box-outline::before {
  content: "\\F0C09"; }

.mdi-alpha-k-circle::before {
  content: "\\F0C0A"; }

.mdi-alpha-k-circle-outline::before {
  content: "\\F0C0B"; }

.mdi-alpha-l::before {
  content: "\\F0AF9"; }

.mdi-alpha-l-box::before {
  content: "\\F0B13"; }

.mdi-alpha-l-box-outline::before {
  content: "\\F0C0C"; }

.mdi-alpha-l-circle::before {
  content: "\\F0C0D"; }

.mdi-alpha-l-circle-outline::before {
  content: "\\F0C0E"; }

.mdi-alpha-m::before {
  content: "\\F0AFA"; }

.mdi-alpha-m-box::before {
  content: "\\F0B14"; }

.mdi-alpha-m-box-outline::before {
  content: "\\F0C0F"; }

.mdi-alpha-m-circle::before {
  content: "\\F0C10"; }

.mdi-alpha-m-circle-outline::before {
  content: "\\F0C11"; }

.mdi-alpha-n::before {
  content: "\\F0AFB"; }

.mdi-alpha-n-box::before {
  content: "\\F0B15"; }

.mdi-alpha-n-box-outline::before {
  content: "\\F0C12"; }

.mdi-alpha-n-circle::before {
  content: "\\F0C13"; }

.mdi-alpha-n-circle-outline::before {
  content: "\\F0C14"; }

.mdi-alpha-o::before {
  content: "\\F0AFC"; }

.mdi-alpha-o-box::before {
  content: "\\F0B16"; }

.mdi-alpha-o-box-outline::before {
  content: "\\F0C15"; }

.mdi-alpha-o-circle::before {
  content: "\\F0C16"; }

.mdi-alpha-o-circle-outline::before {
  content: "\\F0C17"; }

.mdi-alpha-p::before {
  content: "\\F0AFD"; }

.mdi-alpha-p-box::before {
  content: "\\F0B17"; }

.mdi-alpha-p-box-outline::before {
  content: "\\F0C18"; }

.mdi-alpha-p-circle::before {
  content: "\\F0C19"; }

.mdi-alpha-p-circle-outline::before {
  content: "\\F0C1A"; }

.mdi-alpha-q::before {
  content: "\\F0AFE"; }

.mdi-alpha-q-box::before {
  content: "\\F0B18"; }

.mdi-alpha-q-box-outline::before {
  content: "\\F0C1B"; }

.mdi-alpha-q-circle::before {
  content: "\\F0C1C"; }

.mdi-alpha-q-circle-outline::before {
  content: "\\F0C1D"; }

.mdi-alpha-r::before {
  content: "\\F0AFF"; }

.mdi-alpha-r-box::before {
  content: "\\F0B19"; }

.mdi-alpha-r-box-outline::before {
  content: "\\F0C1E"; }

.mdi-alpha-r-circle::before {
  content: "\\F0C1F"; }

.mdi-alpha-r-circle-outline::before {
  content: "\\F0C20"; }

.mdi-alpha-s::before {
  content: "\\F0B00"; }

.mdi-alpha-s-box::before {
  content: "\\F0B1A"; }

.mdi-alpha-s-box-outline::before {
  content: "\\F0C21"; }

.mdi-alpha-s-circle::before {
  content: "\\F0C22"; }

.mdi-alpha-s-circle-outline::before {
  content: "\\F0C23"; }

.mdi-alpha-t::before {
  content: "\\F0B01"; }

.mdi-alpha-t-box::before {
  content: "\\F0B1B"; }

.mdi-alpha-t-box-outline::before {
  content: "\\F0C24"; }

.mdi-alpha-t-circle::before {
  content: "\\F0C25"; }

.mdi-alpha-t-circle-outline::before {
  content: "\\F0C26"; }

.mdi-alpha-u::before {
  content: "\\F0B02"; }

.mdi-alpha-u-box::before {
  content: "\\F0B1C"; }

.mdi-alpha-u-box-outline::before {
  content: "\\F0C27"; }

.mdi-alpha-u-circle::before {
  content: "\\F0C28"; }

.mdi-alpha-u-circle-outline::before {
  content: "\\F0C29"; }

.mdi-alpha-v::before {
  content: "\\F0B03"; }

.mdi-alpha-v-box::before {
  content: "\\F0B1D"; }

.mdi-alpha-v-box-outline::before {
  content: "\\F0C2A"; }

.mdi-alpha-v-circle::before {
  content: "\\F0C2B"; }

.mdi-alpha-v-circle-outline::before {
  content: "\\F0C2C"; }

.mdi-alpha-w::before {
  content: "\\F0B04"; }

.mdi-alpha-w-box::before {
  content: "\\F0B1E"; }

.mdi-alpha-w-box-outline::before {
  content: "\\F0C2D"; }

.mdi-alpha-w-circle::before {
  content: "\\F0C2E"; }

.mdi-alpha-w-circle-outline::before {
  content: "\\F0C2F"; }

.mdi-alpha-x::before {
  content: "\\F0B05"; }

.mdi-alpha-x-box::before {
  content: "\\F0B1F"; }

.mdi-alpha-x-box-outline::before {
  content: "\\F0C30"; }

.mdi-alpha-x-circle::before {
  content: "\\F0C31"; }

.mdi-alpha-x-circle-outline::before {
  content: "\\F0C32"; }

.mdi-alpha-y::before {
  content: "\\F0B06"; }

.mdi-alpha-y-box::before {
  content: "\\F0B20"; }

.mdi-alpha-y-box-outline::before {
  content: "\\F0C33"; }

.mdi-alpha-y-circle::before {
  content: "\\F0C34"; }

.mdi-alpha-y-circle-outline::before {
  content: "\\F0C35"; }

.mdi-alpha-z::before {
  content: "\\F0B07"; }

.mdi-alpha-z-box::before {
  content: "\\F0B21"; }

.mdi-alpha-z-box-outline::before {
  content: "\\F0C36"; }

.mdi-alpha-z-circle::before {
  content: "\\F0C37"; }

.mdi-alpha-z-circle-outline::before {
  content: "\\F0C38"; }

.mdi-alphabet-aurebesh::before {
  content: "\\F132C"; }

.mdi-alphabet-cyrillic::before {
  content: "\\F132D"; }

.mdi-alphabet-greek::before {
  content: "\\F132E"; }

.mdi-alphabet-latin::before {
  content: "\\F132F"; }

.mdi-alphabet-piqad::before {
  content: "\\F1330"; }

.mdi-alphabet-tengwar::before {
  content: "\\F1337"; }

.mdi-alphabetical::before {
  content: "\\F002C"; }

.mdi-alphabetical-off::before {
  content: "\\F100C"; }

.mdi-alphabetical-variant::before {
  content: "\\F100D"; }

.mdi-alphabetical-variant-off::before {
  content: "\\F100E"; }

.mdi-altimeter::before {
  content: "\\F05D7"; }

.mdi-amazon::before {
  content: "\\F002D"; }

.mdi-amazon-alexa::before {
  content: "\\F08C6"; }

.mdi-ambulance::before {
  content: "\\F002F"; }

.mdi-ammunition::before {
  content: "\\F0CE8"; }

.mdi-ampersand::before {
  content: "\\F0A8D"; }

.mdi-amplifier::before {
  content: "\\F0030"; }

.mdi-amplifier-off::before {
  content: "\\F11B5"; }

.mdi-anchor::before {
  content: "\\F0031"; }

.mdi-android::before {
  content: "\\F0032"; }

.mdi-android-auto::before {
  content: "\\F0A8E"; }

.mdi-android-debug-bridge::before {
  content: "\\F0033"; }

.mdi-android-messages::before {
  content: "\\F0D45"; }

.mdi-android-studio::before {
  content: "\\F0034"; }

.mdi-angle-acute::before {
  content: "\\F0937"; }

.mdi-angle-obtuse::before {
  content: "\\F0938"; }

.mdi-angle-right::before {
  content: "\\F0939"; }

.mdi-angular::before {
  content: "\\F06B2"; }

.mdi-angularjs::before {
  content: "\\F06BF"; }

.mdi-animation::before {
  content: "\\F05D8"; }

.mdi-animation-outline::before {
  content: "\\F0A8F"; }

.mdi-animation-play::before {
  content: "\\F093A"; }

.mdi-animation-play-outline::before {
  content: "\\F0A90"; }

.mdi-ansible::before {
  content: "\\F109A"; }

.mdi-antenna::before {
  content: "\\F1119"; }

.mdi-anvil::before {
  content: "\\F089B"; }

.mdi-apache-kafka::before {
  content: "\\F100F"; }

.mdi-api::before {
  content: "\\F109B"; }

.mdi-api-off::before {
  content: "\\F1257"; }

.mdi-apple::before {
  content: "\\F0035"; }

.mdi-apple-airplay::before {
  content: "\\F001F"; }

.mdi-apple-finder::before {
  content: "\\F0036"; }

.mdi-apple-icloud::before {
  content: "\\F0038"; }

.mdi-apple-ios::before {
  content: "\\F0037"; }

.mdi-apple-keyboard-caps::before {
  content: "\\F0632"; }

.mdi-apple-keyboard-command::before {
  content: "\\F0633"; }

.mdi-apple-keyboard-control::before {
  content: "\\F0634"; }

.mdi-apple-keyboard-option::before {
  content: "\\F0635"; }

.mdi-apple-keyboard-shift::before {
  content: "\\F0636"; }

.mdi-apple-safari::before {
  content: "\\F0039"; }

.mdi-application::before {
  content: "\\F0614"; }

.mdi-application-cog::before {
  content: "\\F1577"; }

.mdi-application-export::before {
  content: "\\F0DAD"; }

.mdi-application-import::before {
  content: "\\F0DAE"; }

.mdi-application-settings::before {
  content: "\\F1555"; }

.mdi-approximately-equal::before {
  content: "\\F0F9E"; }

.mdi-approximately-equal-box::before {
  content: "\\F0F9F"; }

.mdi-apps::before {
  content: "\\F003B"; }

.mdi-apps-box::before {
  content: "\\F0D46"; }

.mdi-arch::before {
  content: "\\F08C7"; }

.mdi-archive::before {
  content: "\\F003C"; }

.mdi-archive-alert::before {
  content: "\\F14FD"; }

.mdi-archive-alert-outline::before {
  content: "\\F14FE"; }

.mdi-archive-arrow-down::before {
  content: "\\F1259"; }

.mdi-archive-arrow-down-outline::before {
  content: "\\F125A"; }

.mdi-archive-arrow-up::before {
  content: "\\F125B"; }

.mdi-archive-arrow-up-outline::before {
  content: "\\F125C"; }

.mdi-archive-outline::before {
  content: "\\F120E"; }

.mdi-arm-flex::before {
  content: "\\F0FD7"; }

.mdi-arm-flex-outline::before {
  content: "\\F0FD6"; }

.mdi-arrange-bring-forward::before {
  content: "\\F003D"; }

.mdi-arrange-bring-to-front::before {
  content: "\\F003E"; }

.mdi-arrange-send-backward::before {
  content: "\\F003F"; }

.mdi-arrange-send-to-back::before {
  content: "\\F0040"; }

.mdi-arrow-all::before {
  content: "\\F0041"; }

.mdi-arrow-bottom-left::before {
  content: "\\F0042"; }

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F09B7"; }

.mdi-arrow-bottom-left-thick::before {
  content: "\\F09B8"; }

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\F1596"; }

.mdi-arrow-bottom-right::before {
  content: "\\F0043"; }

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F09B9"; }

.mdi-arrow-bottom-right-thick::before {
  content: "\\F09BA"; }

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\F1595"; }

.mdi-arrow-collapse::before {
  content: "\\F0615"; }

.mdi-arrow-collapse-all::before {
  content: "\\F0044"; }

.mdi-arrow-collapse-down::before {
  content: "\\F0792"; }

.mdi-arrow-collapse-horizontal::before {
  content: "\\F084C"; }

.mdi-arrow-collapse-left::before {
  content: "\\F0793"; }

.mdi-arrow-collapse-right::before {
  content: "\\F0794"; }

.mdi-arrow-collapse-up::before {
  content: "\\F0795"; }

.mdi-arrow-collapse-vertical::before {
  content: "\\F084D"; }

.mdi-arrow-decision::before {
  content: "\\F09BB"; }

.mdi-arrow-decision-auto::before {
  content: "\\F09BC"; }

.mdi-arrow-decision-auto-outline::before {
  content: "\\F09BD"; }

.mdi-arrow-decision-outline::before {
  content: "\\F09BE"; }

.mdi-arrow-down::before {
  content: "\\F0045"; }

.mdi-arrow-down-bold::before {
  content: "\\F072E"; }

.mdi-arrow-down-bold-box::before {
  content: "\\F072F"; }

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F0730"; }

.mdi-arrow-down-bold-circle::before {
  content: "\\F0047"; }

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F0048"; }

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F0049"; }

.mdi-arrow-down-bold-outline::before {
  content: "\\F09BF"; }

.mdi-arrow-down-box::before {
  content: "\\F06C0"; }

.mdi-arrow-down-circle::before {
  content: "\\F0CDB"; }

.mdi-arrow-down-circle-outline::before {
  content: "\\F0CDC"; }

.mdi-arrow-down-drop-circle::before {
  content: "\\F004A"; }

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F004B"; }

.mdi-arrow-down-thick::before {
  content: "\\F0046"; }

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\F1599"; }

.mdi-arrow-expand::before {
  content: "\\F0616"; }

.mdi-arrow-expand-all::before {
  content: "\\F004C"; }

.mdi-arrow-expand-down::before {
  content: "\\F0796"; }

.mdi-arrow-expand-horizontal::before {
  content: "\\F084E"; }

.mdi-arrow-expand-left::before {
  content: "\\F0797"; }

.mdi-arrow-expand-right::before {
  content: "\\F0798"; }

.mdi-arrow-expand-up::before {
  content: "\\F0799"; }

.mdi-arrow-expand-vertical::before {
  content: "\\F084F"; }

.mdi-arrow-horizontal-lock::before {
  content: "\\F115B"; }

.mdi-arrow-left::before {
  content: "\\F004D"; }

.mdi-arrow-left-bold::before {
  content: "\\F0731"; }

.mdi-arrow-left-bold-box::before {
  content: "\\F0732"; }

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F0733"; }

.mdi-arrow-left-bold-circle::before {
  content: "\\F004F"; }

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F0050"; }

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F0051"; }

.mdi-arrow-left-bold-outline::before {
  content: "\\F09C0"; }

.mdi-arrow-left-box::before {
  content: "\\F06C1"; }

.mdi-arrow-left-circle::before {
  content: "\\F0CDD"; }

.mdi-arrow-left-circle-outline::before {
  content: "\\F0CDE"; }

.mdi-arrow-left-drop-circle::before {
  content: "\\F0052"; }

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F0053"; }

.mdi-arrow-left-right::before {
  content: "\\F0E73"; }

.mdi-arrow-left-right-bold::before {
  content: "\\F0E74"; }

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F09C1"; }

.mdi-arrow-left-thick::before {
  content: "\\F004E"; }

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\F159A"; }

.mdi-arrow-right::before {
  content: "\\F0054"; }

.mdi-arrow-right-bold::before {
  content: "\\F0734"; }

.mdi-arrow-right-bold-box::before {
  content: "\\F0735"; }

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F0736"; }

.mdi-arrow-right-bold-circle::before {
  content: "\\F0056"; }

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F0057"; }

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F0058"; }

.mdi-arrow-right-bold-outline::before {
  content: "\\F09C2"; }

.mdi-arrow-right-box::before {
  content: "\\F06C2"; }

.mdi-arrow-right-circle::before {
  content: "\\F0CDF"; }

.mdi-arrow-right-circle-outline::before {
  content: "\\F0CE0"; }

.mdi-arrow-right-drop-circle::before {
  content: "\\F0059"; }

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F005A"; }

.mdi-arrow-right-thick::before {
  content: "\\F0055"; }

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\F1598"; }

.mdi-arrow-split-horizontal::before {
  content: "\\F093B"; }

.mdi-arrow-split-vertical::before {
  content: "\\F093C"; }

.mdi-arrow-top-left::before {
  content: "\\F005B"; }

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F09C3"; }

.mdi-arrow-top-left-bottom-right::before {
  content: "\\F0E75"; }

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\F0E76"; }

.mdi-arrow-top-left-thick::before {
  content: "\\F09C4"; }

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\F1593"; }

.mdi-arrow-top-right::before {
  content: "\\F005C"; }

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F09C5"; }

.mdi-arrow-top-right-bottom-left::before {
  content: "\\F0E77"; }

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\F0E78"; }

.mdi-arrow-top-right-thick::before {
  content: "\\F09C6"; }

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\F1594"; }

.mdi-arrow-up::before {
  content: "\\F005D"; }

.mdi-arrow-up-bold::before {
  content: "\\F0737"; }

.mdi-arrow-up-bold-box::before {
  content: "\\F0738"; }

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F0739"; }

.mdi-arrow-up-bold-circle::before {
  content: "\\F005F"; }

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F0060"; }

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F0061"; }

.mdi-arrow-up-bold-outline::before {
  content: "\\F09C7"; }

.mdi-arrow-up-box::before {
  content: "\\F06C3"; }

.mdi-arrow-up-circle::before {
  content: "\\F0CE1"; }

.mdi-arrow-up-circle-outline::before {
  content: "\\F0CE2"; }

.mdi-arrow-up-down::before {
  content: "\\F0E79"; }

.mdi-arrow-up-down-bold::before {
  content: "\\F0E7A"; }

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F09C8"; }

.mdi-arrow-up-drop-circle::before {
  content: "\\F0062"; }

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F0063"; }

.mdi-arrow-up-thick::before {
  content: "\\F005E"; }

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\F1597"; }

.mdi-arrow-vertical-lock::before {
  content: "\\F115C"; }

.mdi-artstation::before {
  content: "\\F0B5B"; }

.mdi-aspect-ratio::before {
  content: "\\F0A24"; }

.mdi-assistant::before {
  content: "\\F0064"; }

.mdi-asterisk::before {
  content: "\\F06C4"; }

.mdi-at::before {
  content: "\\F0065"; }

.mdi-atlassian::before {
  content: "\\F0804"; }

.mdi-atm::before {
  content: "\\F0D47"; }

.mdi-atom::before {
  content: "\\F0768"; }

.mdi-atom-variant::before {
  content: "\\F0E7B"; }

.mdi-attachment::before {
  content: "\\F0066"; }

.mdi-audio-video::before {
  content: "\\F093D"; }

.mdi-audio-video-off::before {
  content: "\\F11B6"; }

.mdi-augmented-reality::before {
  content: "\\F0850"; }

.mdi-auto-download::before {
  content: "\\F137E"; }

.mdi-auto-fix::before {
  content: "\\F0068"; }

.mdi-auto-upload::before {
  content: "\\F0069"; }

.mdi-autorenew::before {
  content: "\\F006A"; }

.mdi-av-timer::before {
  content: "\\F006B"; }

.mdi-aws::before {
  content: "\\F0E0F"; }

.mdi-axe::before {
  content: "\\F08C8"; }

.mdi-axis::before {
  content: "\\F0D48"; }

.mdi-axis-arrow::before {
  content: "\\F0D49"; }

.mdi-axis-arrow-info::before {
  content: "\\F140E"; }

.mdi-axis-arrow-lock::before {
  content: "\\F0D4A"; }

.mdi-axis-lock::before {
  content: "\\F0D4B"; }

.mdi-axis-x-arrow::before {
  content: "\\F0D4C"; }

.mdi-axis-x-arrow-lock::before {
  content: "\\F0D4D"; }

.mdi-axis-x-rotate-clockwise::before {
  content: "\\F0D4E"; }

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\F0D4F"; }

.mdi-axis-x-y-arrow-lock::before {
  content: "\\F0D50"; }

.mdi-axis-y-arrow::before {
  content: "\\F0D51"; }

.mdi-axis-y-arrow-lock::before {
  content: "\\F0D52"; }

.mdi-axis-y-rotate-clockwise::before {
  content: "\\F0D53"; }

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\F0D54"; }

.mdi-axis-z-arrow::before {
  content: "\\F0D55"; }

.mdi-axis-z-arrow-lock::before {
  content: "\\F0D56"; }

.mdi-axis-z-rotate-clockwise::before {
  content: "\\F0D57"; }

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\F0D58"; }

.mdi-babel::before {
  content: "\\F0A25"; }

.mdi-baby::before {
  content: "\\F006C"; }

.mdi-baby-bottle::before {
  content: "\\F0F39"; }

.mdi-baby-bottle-outline::before {
  content: "\\F0F3A"; }

.mdi-baby-buggy::before {
  content: "\\F13E0"; }

.mdi-baby-carriage::before {
  content: "\\F068F"; }

.mdi-baby-carriage-off::before {
  content: "\\F0FA0"; }

.mdi-baby-face::before {
  content: "\\F0E7C"; }

.mdi-baby-face-outline::before {
  content: "\\F0E7D"; }

.mdi-backburger::before {
  content: "\\F006D"; }

.mdi-backspace::before {
  content: "\\F006E"; }

.mdi-backspace-outline::before {
  content: "\\F0B5C"; }

.mdi-backspace-reverse::before {
  content: "\\F0E7E"; }

.mdi-backspace-reverse-outline::before {
  content: "\\F0E7F"; }

.mdi-backup-restore::before {
  content: "\\F006F"; }

.mdi-bacteria::before {
  content: "\\F0ED5"; }

.mdi-bacteria-outline::before {
  content: "\\F0ED6"; }

.mdi-badge-account::before {
  content: "\\F0DA7"; }

.mdi-badge-account-alert::before {
  content: "\\F0DA8"; }

.mdi-badge-account-alert-outline::before {
  content: "\\F0DA9"; }

.mdi-badge-account-horizontal::before {
  content: "\\F0E0D"; }

.mdi-badge-account-horizontal-outline::before {
  content: "\\F0E0E"; }

.mdi-badge-account-outline::before {
  content: "\\F0DAA"; }

.mdi-badminton::before {
  content: "\\F0851"; }

.mdi-bag-carry-on::before {
  content: "\\F0F3B"; }

.mdi-bag-carry-on-check::before {
  content: "\\F0D65"; }

.mdi-bag-carry-on-off::before {
  content: "\\F0F3C"; }

.mdi-bag-checked::before {
  content: "\\F0F3D"; }

.mdi-bag-personal::before {
  content: "\\F0E10"; }

.mdi-bag-personal-off::before {
  content: "\\F0E11"; }

.mdi-bag-personal-off-outline::before {
  content: "\\F0E12"; }

.mdi-bag-personal-outline::before {
  content: "\\F0E13"; }

.mdi-bag-suitcase::before {
  content: "\\F158B"; }

.mdi-bag-suitcase-off::before {
  content: "\\F158D"; }

.mdi-bag-suitcase-off-outline::before {
  content: "\\F158E"; }

.mdi-bag-suitcase-outline::before {
  content: "\\F158C"; }

.mdi-baguette::before {
  content: "\\F0F3E"; }

.mdi-balloon::before {
  content: "\\F0A26"; }

.mdi-ballot::before {
  content: "\\F09C9"; }

.mdi-ballot-outline::before {
  content: "\\F09CA"; }

.mdi-ballot-recount::before {
  content: "\\F0C39"; }

.mdi-ballot-recount-outline::before {
  content: "\\F0C3A"; }

.mdi-bandage::before {
  content: "\\F0DAF"; }

.mdi-bandcamp::before {
  content: "\\F0675"; }

.mdi-bank::before {
  content: "\\F0070"; }

.mdi-bank-check::before {
  content: "\\F1655"; }

.mdi-bank-minus::before {
  content: "\\F0DB0"; }

.mdi-bank-off::before {
  content: "\\F1656"; }

.mdi-bank-off-outline::before {
  content: "\\F1657"; }

.mdi-bank-outline::before {
  content: "\\F0E80"; }

.mdi-bank-plus::before {
  content: "\\F0DB1"; }

.mdi-bank-remove::before {
  content: "\\F0DB2"; }

.mdi-bank-transfer::before {
  content: "\\F0A27"; }

.mdi-bank-transfer-in::before {
  content: "\\F0A28"; }

.mdi-bank-transfer-out::before {
  content: "\\F0A29"; }

.mdi-barcode::before {
  content: "\\F0071"; }

.mdi-barcode-off::before {
  content: "\\F1236"; }

.mdi-barcode-scan::before {
  content: "\\F0072"; }

.mdi-barley::before {
  content: "\\F0073"; }

.mdi-barley-off::before {
  content: "\\F0B5D"; }

.mdi-barn::before {
  content: "\\F0B5E"; }

.mdi-barrel::before {
  content: "\\F0074"; }

.mdi-baseball::before {
  content: "\\F0852"; }

.mdi-baseball-bat::before {
  content: "\\F0853"; }

.mdi-baseball-diamond::before {
  content: "\\F15EC"; }

.mdi-baseball-diamond-outline::before {
  content: "\\F15ED"; }

.mdi-bash::before {
  content: "\\F1183"; }

.mdi-basket::before {
  content: "\\F0076"; }

.mdi-basket-fill::before {
  content: "\\F0077"; }

.mdi-basket-minus::before {
  content: "\\F1523"; }

.mdi-basket-minus-outline::before {
  content: "\\F1524"; }

.mdi-basket-off::before {
  content: "\\F1525"; }

.mdi-basket-off-outline::before {
  content: "\\F1526"; }

.mdi-basket-outline::before {
  content: "\\F1181"; }

.mdi-basket-plus::before {
  content: "\\F1527"; }

.mdi-basket-plus-outline::before {
  content: "\\F1528"; }

.mdi-basket-remove::before {
  content: "\\F1529"; }

.mdi-basket-remove-outline::before {
  content: "\\F152A"; }

.mdi-basket-unfill::before {
  content: "\\F0078"; }

.mdi-basketball::before {
  content: "\\F0806"; }

.mdi-basketball-hoop::before {
  content: "\\F0C3B"; }

.mdi-basketball-hoop-outline::before {
  content: "\\F0C3C"; }

.mdi-bat::before {
  content: "\\F0B5F"; }

.mdi-battery::before {
  content: "\\F0079"; }

.mdi-battery-10::before {
  content: "\\F007A"; }

.mdi-battery-10-bluetooth::before {
  content: "\\F093E"; }

.mdi-battery-20::before {
  content: "\\F007B"; }

.mdi-battery-20-bluetooth::before {
  content: "\\F093F"; }

.mdi-battery-30::before {
  content: "\\F007C"; }

.mdi-battery-30-bluetooth::before {
  content: "\\F0940"; }

.mdi-battery-40::before {
  content: "\\F007D"; }

.mdi-battery-40-bluetooth::before {
  content: "\\F0941"; }

.mdi-battery-50::before {
  content: "\\F007E"; }

.mdi-battery-50-bluetooth::before {
  content: "\\F0942"; }

.mdi-battery-60::before {
  content: "\\F007F"; }

.mdi-battery-60-bluetooth::before {
  content: "\\F0943"; }

.mdi-battery-70::before {
  content: "\\F0080"; }

.mdi-battery-70-bluetooth::before {
  content: "\\F0944"; }

.mdi-battery-80::before {
  content: "\\F0081"; }

.mdi-battery-80-bluetooth::before {
  content: "\\F0945"; }

.mdi-battery-90::before {
  content: "\\F0082"; }

.mdi-battery-90-bluetooth::before {
  content: "\\F0946"; }

.mdi-battery-alert::before {
  content: "\\F0083"; }

.mdi-battery-alert-bluetooth::before {
  content: "\\F0947"; }

.mdi-battery-alert-variant::before {
  content: "\\F10CC"; }

.mdi-battery-alert-variant-outline::before {
  content: "\\F10CD"; }

.mdi-battery-bluetooth::before {
  content: "\\F0948"; }

.mdi-battery-bluetooth-variant::before {
  content: "\\F0949"; }

.mdi-battery-charging::before {
  content: "\\F0084"; }

.mdi-battery-charging-10::before {
  content: "\\F089C"; }

.mdi-battery-charging-100::before {
  content: "\\F0085"; }

.mdi-battery-charging-20::before {
  content: "\\F0086"; }

.mdi-battery-charging-30::before {
  content: "\\F0087"; }

.mdi-battery-charging-40::before {
  content: "\\F0088"; }

.mdi-battery-charging-50::before {
  content: "\\F089D"; }

.mdi-battery-charging-60::before {
  content: "\\F0089"; }

.mdi-battery-charging-70::before {
  content: "\\F089E"; }

.mdi-battery-charging-80::before {
  content: "\\F008A"; }

.mdi-battery-charging-90::before {
  content: "\\F008B"; }

.mdi-battery-charging-high::before {
  content: "\\F12A6"; }

.mdi-battery-charging-low::before {
  content: "\\F12A4"; }

.mdi-battery-charging-medium::before {
  content: "\\F12A5"; }

.mdi-battery-charging-outline::before {
  content: "\\F089F"; }

.mdi-battery-charging-wireless::before {
  content: "\\F0807"; }

.mdi-battery-charging-wireless-10::before {
  content: "\\F0808"; }

.mdi-battery-charging-wireless-20::before {
  content: "\\F0809"; }

.mdi-battery-charging-wireless-30::before {
  content: "\\F080A"; }

.mdi-battery-charging-wireless-40::before {
  content: "\\F080B"; }

.mdi-battery-charging-wireless-50::before {
  content: "\\F080C"; }

.mdi-battery-charging-wireless-60::before {
  content: "\\F080D"; }

.mdi-battery-charging-wireless-70::before {
  content: "\\F080E"; }

.mdi-battery-charging-wireless-80::before {
  content: "\\F080F"; }

.mdi-battery-charging-wireless-90::before {
  content: "\\F0810"; }

.mdi-battery-charging-wireless-alert::before {
  content: "\\F0811"; }

.mdi-battery-charging-wireless-outline::before {
  content: "\\F0812"; }

.mdi-battery-heart::before {
  content: "\\F120F"; }

.mdi-battery-heart-outline::before {
  content: "\\F1210"; }

.mdi-battery-heart-variant::before {
  content: "\\F1211"; }

.mdi-battery-high::before {
  content: "\\F12A3"; }

.mdi-battery-low::before {
  content: "\\F12A1"; }

.mdi-battery-medium::before {
  content: "\\F12A2"; }

.mdi-battery-minus::before {
  content: "\\F008C"; }

.mdi-battery-negative::before {
  content: "\\F008D"; }

.mdi-battery-off::before {
  content: "\\F125D"; }

.mdi-battery-off-outline::before {
  content: "\\F125E"; }

.mdi-battery-outline::before {
  content: "\\F008E"; }

.mdi-battery-plus::before {
  content: "\\F008F"; }

.mdi-battery-positive::before {
  content: "\\F0090"; }

.mdi-battery-unknown::before {
  content: "\\F0091"; }

.mdi-battery-unknown-bluetooth::before {
  content: "\\F094A"; }

.mdi-battlenet::before {
  content: "\\F0B60"; }

.mdi-beach::before {
  content: "\\F0092"; }

.mdi-beaker::before {
  content: "\\F0CEA"; }

.mdi-beaker-alert::before {
  content: "\\F1229"; }

.mdi-beaker-alert-outline::before {
  content: "\\F122A"; }

.mdi-beaker-check::before {
  content: "\\F122B"; }

.mdi-beaker-check-outline::before {
  content: "\\F122C"; }

.mdi-beaker-minus::before {
  content: "\\F122D"; }

.mdi-beaker-minus-outline::before {
  content: "\\F122E"; }

.mdi-beaker-outline::before {
  content: "\\F0690"; }

.mdi-beaker-plus::before {
  content: "\\F122F"; }

.mdi-beaker-plus-outline::before {
  content: "\\F1230"; }

.mdi-beaker-question::before {
  content: "\\F1231"; }

.mdi-beaker-question-outline::before {
  content: "\\F1232"; }

.mdi-beaker-remove::before {
  content: "\\F1233"; }

.mdi-beaker-remove-outline::before {
  content: "\\F1234"; }

.mdi-bed::before {
  content: "\\F02E3"; }

.mdi-bed-double::before {
  content: "\\F0FD4"; }

.mdi-bed-double-outline::before {
  content: "\\F0FD3"; }

.mdi-bed-empty::before {
  content: "\\F08A0"; }

.mdi-bed-king::before {
  content: "\\F0FD2"; }

.mdi-bed-king-outline::before {
  content: "\\F0FD1"; }

.mdi-bed-outline::before {
  content: "\\F0099"; }

.mdi-bed-queen::before {
  content: "\\F0FD0"; }

.mdi-bed-queen-outline::before {
  content: "\\F0FDB"; }

.mdi-bed-single::before {
  content: "\\F106D"; }

.mdi-bed-single-outline::before {
  content: "\\F106E"; }

.mdi-bee::before {
  content: "\\F0FA1"; }

.mdi-bee-flower::before {
  content: "\\F0FA2"; }

.mdi-beehive-off-outline::before {
  content: "\\F13ED"; }

.mdi-beehive-outline::before {
  content: "\\F10CE"; }

.mdi-beekeeper::before {
  content: "\\F14E2"; }

.mdi-beer::before {
  content: "\\F0098"; }

.mdi-beer-outline::before {
  content: "\\F130C"; }

.mdi-bell::before {
  content: "\\F009A"; }

.mdi-bell-alert::before {
  content: "\\F0D59"; }

.mdi-bell-alert-outline::before {
  content: "\\F0E81"; }

.mdi-bell-cancel::before {
  content: "\\F13E7"; }

.mdi-bell-cancel-outline::before {
  content: "\\F13E8"; }

.mdi-bell-check::before {
  content: "\\F11E5"; }

.mdi-bell-check-outline::before {
  content: "\\F11E6"; }

.mdi-bell-circle::before {
  content: "\\F0D5A"; }

.mdi-bell-circle-outline::before {
  content: "\\F0D5B"; }

.mdi-bell-minus::before {
  content: "\\F13E9"; }

.mdi-bell-minus-outline::before {
  content: "\\F13EA"; }

.mdi-bell-off::before {
  content: "\\F009B"; }

.mdi-bell-off-outline::before {
  content: "\\F0A91"; }

.mdi-bell-outline::before {
  content: "\\F009C"; }

.mdi-bell-plus::before {
  content: "\\F009D"; }

.mdi-bell-plus-outline::before {
  content: "\\F0A92"; }

.mdi-bell-remove::before {
  content: "\\F13EB"; }

.mdi-bell-remove-outline::before {
  content: "\\F13EC"; }

.mdi-bell-ring::before {
  content: "\\F009E"; }

.mdi-bell-ring-outline::before {
  content: "\\F009F"; }

.mdi-bell-sleep::before {
  content: "\\F00A0"; }

.mdi-bell-sleep-outline::before {
  content: "\\F0A93"; }

.mdi-beta::before {
  content: "\\F00A1"; }

.mdi-betamax::before {
  content: "\\F09CB"; }

.mdi-biathlon::before {
  content: "\\F0E14"; }

.mdi-bicycle::before {
  content: "\\F109C"; }

.mdi-bicycle-basket::before {
  content: "\\F1235"; }

.mdi-bicycle-electric::before {
  content: "\\F15B4"; }

.mdi-bicycle-penny-farthing::before {
  content: "\\F15E9"; }

.mdi-bike::before {
  content: "\\F00A3"; }

.mdi-bike-fast::before {
  content: "\\F111F"; }

.mdi-billboard::before {
  content: "\\F1010"; }

.mdi-billiards::before {
  content: "\\F0B61"; }

.mdi-billiards-rack::before {
  content: "\\F0B62"; }

.mdi-binoculars::before {
  content: "\\F00A5"; }

.mdi-bio::before {
  content: "\\F00A6"; }

.mdi-biohazard::before {
  content: "\\F00A7"; }

.mdi-bird::before {
  content: "\\F15C6"; }

.mdi-bitbucket::before {
  content: "\\F00A8"; }

.mdi-bitcoin::before {
  content: "\\F0813"; }

.mdi-black-mesa::before {
  content: "\\F00A9"; }

.mdi-blender::before {
  content: "\\F0CEB"; }

.mdi-blender-software::before {
  content: "\\F00AB"; }

.mdi-blinds::before {
  content: "\\F00AC"; }

.mdi-blinds-open::before {
  content: "\\F1011"; }

.mdi-block-helper::before {
  content: "\\F00AD"; }

.mdi-blogger::before {
  content: "\\F00AE"; }

.mdi-blood-bag::before {
  content: "\\F0CEC"; }

.mdi-bluetooth::before {
  content: "\\F00AF"; }

.mdi-bluetooth-audio::before {
  content: "\\F00B0"; }

.mdi-bluetooth-connect::before {
  content: "\\F00B1"; }

.mdi-bluetooth-off::before {
  content: "\\F00B2"; }

.mdi-bluetooth-settings::before {
  content: "\\F00B3"; }

.mdi-bluetooth-transfer::before {
  content: "\\F00B4"; }

.mdi-blur::before {
  content: "\\F00B5"; }

.mdi-blur-linear::before {
  content: "\\F00B6"; }

.mdi-blur-off::before {
  content: "\\F00B7"; }

.mdi-blur-radial::before {
  content: "\\F00B8"; }

.mdi-bolnisi-cross::before {
  content: "\\F0CED"; }

.mdi-bolt::before {
  content: "\\F0DB3"; }

.mdi-bomb::before {
  content: "\\F0691"; }

.mdi-bomb-off::before {
  content: "\\F06C5"; }

.mdi-bone::before {
  content: "\\F00B9"; }

.mdi-book::before {
  content: "\\F00BA"; }

.mdi-book-account::before {
  content: "\\F13AD"; }

.mdi-book-account-outline::before {
  content: "\\F13AE"; }

.mdi-book-alert::before {
  content: "\\F167C"; }

.mdi-book-alert-outline::before {
  content: "\\F167D"; }

.mdi-book-alphabet::before {
  content: "\\F061D"; }

.mdi-book-arrow-down::before {
  content: "\\F167E"; }

.mdi-book-arrow-down-outline::before {
  content: "\\F167F"; }

.mdi-book-arrow-left::before {
  content: "\\F1680"; }

.mdi-book-arrow-left-outline::before {
  content: "\\F1681"; }

.mdi-book-arrow-right::before {
  content: "\\F1682"; }

.mdi-book-arrow-right-outline::before {
  content: "\\F1683"; }

.mdi-book-arrow-up::before {
  content: "\\F1684"; }

.mdi-book-arrow-up-outline::before {
  content: "\\F1685"; }

.mdi-book-cancel::before {
  content: "\\F1686"; }

.mdi-book-cancel-outline::before {
  content: "\\F1687"; }

.mdi-book-check::before {
  content: "\\F14F3"; }

.mdi-book-check-outline::before {
  content: "\\F14F4"; }

.mdi-book-clock::before {
  content: "\\F1688"; }

.mdi-book-clock-outline::before {
  content: "\\F1689"; }

.mdi-book-cog::before {
  content: "\\F168A"; }

.mdi-book-cog-outline::before {
  content: "\\F168B"; }

.mdi-book-cross::before {
  content: "\\F00A2"; }

.mdi-book-edit::before {
  content: "\\F168C"; }

.mdi-book-edit-outline::before {
  content: "\\F168D"; }

.mdi-book-education::before {
  content: "\\F16C9"; }

.mdi-book-education-outline::before {
  content: "\\F16CA"; }

.mdi-book-information-variant::before {
  content: "\\F106F"; }

.mdi-book-lock::before {
  content: "\\F079A"; }

.mdi-book-lock-open::before {
  content: "\\F079B"; }

.mdi-book-lock-open-outline::before {
  content: "\\F168E"; }

.mdi-book-lock-outline::before {
  content: "\\F168F"; }

.mdi-book-marker::before {
  content: "\\F1690"; }

.mdi-book-marker-outline::before {
  content: "\\F1691"; }

.mdi-book-minus::before {
  content: "\\F05D9"; }

.mdi-book-minus-multiple::before {
  content: "\\F0A94"; }

.mdi-book-minus-multiple-outline::before {
  content: "\\F090B"; }

.mdi-book-minus-outline::before {
  content: "\\F1692"; }

.mdi-book-multiple::before {
  content: "\\F00BB"; }

.mdi-book-multiple-outline::before {
  content: "\\F0436"; }

.mdi-book-music::before {
  content: "\\F0067"; }

.mdi-book-music-outline::before {
  content: "\\F1693"; }

.mdi-book-off::before {
  content: "\\F1694"; }

.mdi-book-off-outline::before {
  content: "\\F1695"; }

.mdi-book-open::before {
  content: "\\F00BD"; }

.mdi-book-open-blank-variant::before {
  content: "\\F00BE"; }

.mdi-book-open-outline::before {
  content: "\\F0B63"; }

.mdi-book-open-page-variant::before {
  content: "\\F05DA"; }

.mdi-book-open-page-variant-outline::before {
  content: "\\F15D6"; }

.mdi-book-open-variant::before {
  content: "\\F14F7"; }

.mdi-book-outline::before {
  content: "\\F0B64"; }

.mdi-book-play::before {
  content: "\\F0E82"; }

.mdi-book-play-outline::before {
  content: "\\F0E83"; }

.mdi-book-plus::before {
  content: "\\F05DB"; }

.mdi-book-plus-multiple::before {
  content: "\\F0A95"; }

.mdi-book-plus-multiple-outline::before {
  content: "\\F0ADE"; }

.mdi-book-plus-outline::before {
  content: "\\F1696"; }

.mdi-book-refresh::before {
  content: "\\F1697"; }

.mdi-book-refresh-outline::before {
  content: "\\F1698"; }

.mdi-book-remove::before {
  content: "\\F0A97"; }

.mdi-book-remove-multiple::before {
  content: "\\F0A96"; }

.mdi-book-remove-multiple-outline::before {
  content: "\\F04CA"; }

.mdi-book-remove-outline::before {
  content: "\\F1699"; }

.mdi-book-search::before {
  content: "\\F0E84"; }

.mdi-book-search-outline::before {
  content: "\\F0E85"; }

.mdi-book-settings::before {
  content: "\\F169A"; }

.mdi-book-settings-outline::before {
  content: "\\F169B"; }

.mdi-book-sync::before {
  content: "\\F169C"; }

.mdi-book-sync-outline::before {
  content: "\\F16C8"; }

.mdi-book-variant::before {
  content: "\\F00BF"; }

.mdi-book-variant-multiple::before {
  content: "\\F00BC"; }

.mdi-bookmark::before {
  content: "\\F00C0"; }

.mdi-bookmark-check::before {
  content: "\\F00C1"; }

.mdi-bookmark-check-outline::before {
  content: "\\F137B"; }

.mdi-bookmark-minus::before {
  content: "\\F09CC"; }

.mdi-bookmark-minus-outline::before {
  content: "\\F09CD"; }

.mdi-bookmark-multiple::before {
  content: "\\F0E15"; }

.mdi-bookmark-multiple-outline::before {
  content: "\\F0E16"; }

.mdi-bookmark-music::before {
  content: "\\F00C2"; }

.mdi-bookmark-music-outline::before {
  content: "\\F1379"; }

.mdi-bookmark-off::before {
  content: "\\F09CE"; }

.mdi-bookmark-off-outline::before {
  content: "\\F09CF"; }

.mdi-bookmark-outline::before {
  content: "\\F00C3"; }

.mdi-bookmark-plus::before {
  content: "\\F00C5"; }

.mdi-bookmark-plus-outline::before {
  content: "\\F00C4"; }

.mdi-bookmark-remove::before {
  content: "\\F00C6"; }

.mdi-bookmark-remove-outline::before {
  content: "\\F137A"; }

.mdi-bookshelf::before {
  content: "\\F125F"; }

.mdi-boom-gate::before {
  content: "\\F0E86"; }

.mdi-boom-gate-alert::before {
  content: "\\F0E87"; }

.mdi-boom-gate-alert-outline::before {
  content: "\\F0E88"; }

.mdi-boom-gate-down::before {
  content: "\\F0E89"; }

.mdi-boom-gate-down-outline::before {
  content: "\\F0E8A"; }

.mdi-boom-gate-outline::before {
  content: "\\F0E8B"; }

.mdi-boom-gate-up::before {
  content: "\\F0E8C"; }

.mdi-boom-gate-up-outline::before {
  content: "\\F0E8D"; }

.mdi-boombox::before {
  content: "\\F05DC"; }

.mdi-boomerang::before {
  content: "\\F10CF"; }

.mdi-bootstrap::before {
  content: "\\F06C6"; }

.mdi-border-all::before {
  content: "\\F00C7"; }

.mdi-border-all-variant::before {
  content: "\\F08A1"; }

.mdi-border-bottom::before {
  content: "\\F00C8"; }

.mdi-border-bottom-variant::before {
  content: "\\F08A2"; }

.mdi-border-color::before {
  content: "\\F00C9"; }

.mdi-border-horizontal::before {
  content: "\\F00CA"; }

.mdi-border-inside::before {
  content: "\\F00CB"; }

.mdi-border-left::before {
  content: "\\F00CC"; }

.mdi-border-left-variant::before {
  content: "\\F08A3"; }

.mdi-border-none::before {
  content: "\\F00CD"; }

.mdi-border-none-variant::before {
  content: "\\F08A4"; }

.mdi-border-outside::before {
  content: "\\F00CE"; }

.mdi-border-right::before {
  content: "\\F00CF"; }

.mdi-border-right-variant::before {
  content: "\\F08A5"; }

.mdi-border-style::before {
  content: "\\F00D0"; }

.mdi-border-top::before {
  content: "\\F00D1"; }

.mdi-border-top-variant::before {
  content: "\\F08A6"; }

.mdi-border-vertical::before {
  content: "\\F00D2"; }

.mdi-bottle-soda::before {
  content: "\\F1070"; }

.mdi-bottle-soda-classic::before {
  content: "\\F1071"; }

.mdi-bottle-soda-classic-outline::before {
  content: "\\F1363"; }

.mdi-bottle-soda-outline::before {
  content: "\\F1072"; }

.mdi-bottle-tonic::before {
  content: "\\F112E"; }

.mdi-bottle-tonic-outline::before {
  content: "\\F112F"; }

.mdi-bottle-tonic-plus::before {
  content: "\\F1130"; }

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F1131"; }

.mdi-bottle-tonic-skull::before {
  content: "\\F1132"; }

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F1133"; }

.mdi-bottle-wine::before {
  content: "\\F0854"; }

.mdi-bottle-wine-outline::before {
  content: "\\F1310"; }

.mdi-bow-tie::before {
  content: "\\F0678"; }

.mdi-bowl::before {
  content: "\\F028E"; }

.mdi-bowl-mix::before {
  content: "\\F0617"; }

.mdi-bowl-mix-outline::before {
  content: "\\F02E4"; }

.mdi-bowl-outline::before {
  content: "\\F02A9"; }

.mdi-bowling::before {
  content: "\\F00D3"; }

.mdi-box::before {
  content: "\\F00D4"; }

.mdi-box-cutter::before {
  content: "\\F00D5"; }

.mdi-box-cutter-off::before {
  content: "\\F0B4A"; }

.mdi-box-shadow::before {
  content: "\\F0637"; }

.mdi-boxing-glove::before {
  content: "\\F0B65"; }

.mdi-braille::before {
  content: "\\F09D0"; }

.mdi-brain::before {
  content: "\\F09D1"; }

.mdi-bread-slice::before {
  content: "\\F0CEE"; }

.mdi-bread-slice-outline::before {
  content: "\\F0CEF"; }

.mdi-bridge::before {
  content: "\\F0618"; }

.mdi-briefcase::before {
  content: "\\F00D6"; }

.mdi-briefcase-account::before {
  content: "\\F0CF0"; }

.mdi-briefcase-account-outline::before {
  content: "\\F0CF1"; }

.mdi-briefcase-check::before {
  content: "\\F00D7"; }

.mdi-briefcase-check-outline::before {
  content: "\\F131E"; }

.mdi-briefcase-clock::before {
  content: "\\F10D0"; }

.mdi-briefcase-clock-outline::before {
  content: "\\F10D1"; }

.mdi-briefcase-download::before {
  content: "\\F00D8"; }

.mdi-briefcase-download-outline::before {
  content: "\\F0C3D"; }

.mdi-briefcase-edit::before {
  content: "\\F0A98"; }

.mdi-briefcase-edit-outline::before {
  content: "\\F0C3E"; }

.mdi-briefcase-minus::before {
  content: "\\F0A2A"; }

.mdi-briefcase-minus-outline::before {
  content: "\\F0C3F"; }

.mdi-briefcase-off::before {
  content: "\\F1658"; }

.mdi-briefcase-off-outline::before {
  content: "\\F1659"; }

.mdi-briefcase-outline::before {
  content: "\\F0814"; }

.mdi-briefcase-plus::before {
  content: "\\F0A2B"; }

.mdi-briefcase-plus-outline::before {
  content: "\\F0C40"; }

.mdi-briefcase-remove::before {
  content: "\\F0A2C"; }

.mdi-briefcase-remove-outline::before {
  content: "\\F0C41"; }

.mdi-briefcase-search::before {
  content: "\\F0A2D"; }

.mdi-briefcase-search-outline::before {
  content: "\\F0C42"; }

.mdi-briefcase-upload::before {
  content: "\\F00D9"; }

.mdi-briefcase-upload-outline::before {
  content: "\\F0C43"; }

.mdi-briefcase-variant::before {
  content: "\\F1494"; }

.mdi-briefcase-variant-off::before {
  content: "\\F165A"; }

.mdi-briefcase-variant-off-outline::before {
  content: "\\F165B"; }

.mdi-briefcase-variant-outline::before {
  content: "\\F1495"; }

.mdi-brightness-1::before {
  content: "\\F00DA"; }

.mdi-brightness-2::before {
  content: "\\F00DB"; }

.mdi-brightness-3::before {
  content: "\\F00DC"; }

.mdi-brightness-4::before {
  content: "\\F00DD"; }

.mdi-brightness-5::before {
  content: "\\F00DE"; }

.mdi-brightness-6::before {
  content: "\\F00DF"; }

.mdi-brightness-7::before {
  content: "\\F00E0"; }

.mdi-brightness-auto::before {
  content: "\\F00E1"; }

.mdi-brightness-percent::before {
  content: "\\F0CF2"; }

.mdi-broom::before {
  content: "\\F00E2"; }

.mdi-brush::before {
  content: "\\F00E3"; }

.mdi-bucket::before {
  content: "\\F1415"; }

.mdi-bucket-outline::before {
  content: "\\F1416"; }

.mdi-buddhism::before {
  content: "\\F094B"; }

.mdi-buffer::before {
  content: "\\F0619"; }

.mdi-buffet::before {
  content: "\\F0578"; }

.mdi-bug::before {
  content: "\\F00E4"; }

.mdi-bug-check::before {
  content: "\\F0A2E"; }

.mdi-bug-check-outline::before {
  content: "\\F0A2F"; }

.mdi-bug-outline::before {
  content: "\\F0A30"; }

.mdi-bugle::before {
  content: "\\F0DB4"; }

.mdi-bulldozer::before {
  content: "\\F0B22"; }

.mdi-bullet::before {
  content: "\\F0CF3"; }

.mdi-bulletin-board::before {
  content: "\\F00E5"; }

.mdi-bullhorn::before {
  content: "\\F00E6"; }

.mdi-bullhorn-outline::before {
  content: "\\F0B23"; }

.mdi-bullseye::before {
  content: "\\F05DD"; }

.mdi-bullseye-arrow::before {
  content: "\\F08C9"; }

.mdi-bulma::before {
  content: "\\F12E7"; }

.mdi-bunk-bed::before {
  content: "\\F1302"; }

.mdi-bunk-bed-outline::before {
  content: "\\F0097"; }

.mdi-bus::before {
  content: "\\F00E7"; }

.mdi-bus-alert::before {
  content: "\\F0A99"; }

.mdi-bus-articulated-end::before {
  content: "\\F079C"; }

.mdi-bus-articulated-front::before {
  content: "\\F079D"; }

.mdi-bus-clock::before {
  content: "\\F08CA"; }

.mdi-bus-double-decker::before {
  content: "\\F079E"; }

.mdi-bus-marker::before {
  content: "\\F1212"; }

.mdi-bus-multiple::before {
  content: "\\F0F3F"; }

.mdi-bus-school::before {
  content: "\\F079F"; }

.mdi-bus-side::before {
  content: "\\F07A0"; }

.mdi-bus-stop::before {
  content: "\\F1012"; }

.mdi-bus-stop-covered::before {
  content: "\\F1013"; }

.mdi-bus-stop-uncovered::before {
  content: "\\F1014"; }

.mdi-butterfly::before {
  content: "\\F1589"; }

.mdi-butterfly-outline::before {
  content: "\\F158A"; }

.mdi-cable-data::before {
  content: "\\F1394"; }

.mdi-cached::before {
  content: "\\F00E8"; }

.mdi-cactus::before {
  content: "\\F0DB5"; }

.mdi-cake::before {
  content: "\\F00E9"; }

.mdi-cake-layered::before {
  content: "\\F00EA"; }

.mdi-cake-variant::before {
  content: "\\F00EB"; }

.mdi-calculator::before {
  content: "\\F00EC"; }

.mdi-calculator-variant::before {
  content: "\\F0A9A"; }

.mdi-calculator-variant-outline::before {
  content: "\\F15A6"; }

.mdi-calendar::before {
  content: "\\F00ED"; }

.mdi-calendar-account::before {
  content: "\\F0ED7"; }

.mdi-calendar-account-outline::before {
  content: "\\F0ED8"; }

.mdi-calendar-alert::before {
  content: "\\F0A31"; }

.mdi-calendar-arrow-left::before {
  content: "\\F1134"; }

.mdi-calendar-arrow-right::before {
  content: "\\F1135"; }

.mdi-calendar-blank::before {
  content: "\\F00EE"; }

.mdi-calendar-blank-multiple::before {
  content: "\\F1073"; }

.mdi-calendar-blank-outline::before {
  content: "\\F0B66"; }

.mdi-calendar-check::before {
  content: "\\F00EF"; }

.mdi-calendar-check-outline::before {
  content: "\\F0C44"; }

.mdi-calendar-clock::before {
  content: "\\F00F0"; }

.mdi-calendar-cursor::before {
  content: "\\F157B"; }

.mdi-calendar-edit::before {
  content: "\\F08A7"; }

.mdi-calendar-end::before {
  content: "\\F166C"; }

.mdi-calendar-export::before {
  content: "\\F0B24"; }

.mdi-calendar-heart::before {
  content: "\\F09D2"; }

.mdi-calendar-import::before {
  content: "\\F0B25"; }

.mdi-calendar-lock::before {
  content: "\\F1641"; }

.mdi-calendar-lock-outline::before {
  content: "\\F1642"; }

.mdi-calendar-minus::before {
  content: "\\F0D5C"; }

.mdi-calendar-month::before {
  content: "\\F0E17"; }

.mdi-calendar-month-outline::before {
  content: "\\F0E18"; }

.mdi-calendar-multiple::before {
  content: "\\F00F1"; }

.mdi-calendar-multiple-check::before {
  content: "\\F00F2"; }

.mdi-calendar-multiselect::before {
  content: "\\F0A32"; }

.mdi-calendar-outline::before {
  content: "\\F0B67"; }

.mdi-calendar-plus::before {
  content: "\\F00F3"; }

.mdi-calendar-question::before {
  content: "\\F0692"; }

.mdi-calendar-range::before {
  content: "\\F0679"; }

.mdi-calendar-range-outline::before {
  content: "\\F0B68"; }

.mdi-calendar-refresh::before {
  content: "\\F01E1"; }

.mdi-calendar-refresh-outline::before {
  content: "\\F0203"; }

.mdi-calendar-remove::before {
  content: "\\F00F4"; }

.mdi-calendar-remove-outline::before {
  content: "\\F0C45"; }

.mdi-calendar-search::before {
  content: "\\F094C"; }

.mdi-calendar-star::before {
  content: "\\F09D3"; }

.mdi-calendar-start::before {
  content: "\\F166D"; }

.mdi-calendar-sync::before {
  content: "\\F0E8E"; }

.mdi-calendar-sync-outline::before {
  content: "\\F0E8F"; }

.mdi-calendar-text::before {
  content: "\\F00F5"; }

.mdi-calendar-text-outline::before {
  content: "\\F0C46"; }

.mdi-calendar-today::before {
  content: "\\F00F6"; }

.mdi-calendar-week::before {
  content: "\\F0A33"; }

.mdi-calendar-week-begin::before {
  content: "\\F0A34"; }

.mdi-calendar-weekend::before {
  content: "\\F0ED9"; }

.mdi-calendar-weekend-outline::before {
  content: "\\F0EDA"; }

.mdi-call-made::before {
  content: "\\F00F7"; }

.mdi-call-merge::before {
  content: "\\F00F8"; }

.mdi-call-missed::before {
  content: "\\F00F9"; }

.mdi-call-received::before {
  content: "\\F00FA"; }

.mdi-call-split::before {
  content: "\\F00FB"; }

.mdi-camcorder::before {
  content: "\\F00FC"; }

.mdi-camcorder-off::before {
  content: "\\F00FF"; }

.mdi-camera::before {
  content: "\\F0100"; }

.mdi-camera-account::before {
  content: "\\F08CB"; }

.mdi-camera-burst::before {
  content: "\\F0693"; }

.mdi-camera-control::before {
  content: "\\F0B69"; }

.mdi-camera-enhance::before {
  content: "\\F0101"; }

.mdi-camera-enhance-outline::before {
  content: "\\F0B6A"; }

.mdi-camera-flip::before {
  content: "\\F15D9"; }

.mdi-camera-flip-outline::before {
  content: "\\F15DA"; }

.mdi-camera-front::before {
  content: "\\F0102"; }

.mdi-camera-front-variant::before {
  content: "\\F0103"; }

.mdi-camera-gopro::before {
  content: "\\F07A1"; }

.mdi-camera-image::before {
  content: "\\F08CC"; }

.mdi-camera-iris::before {
  content: "\\F0104"; }

.mdi-camera-metering-center::before {
  content: "\\F07A2"; }

.mdi-camera-metering-matrix::before {
  content: "\\F07A3"; }

.mdi-camera-metering-partial::before {
  content: "\\F07A4"; }

.mdi-camera-metering-spot::before {
  content: "\\F07A5"; }

.mdi-camera-off::before {
  content: "\\F05DF"; }

.mdi-camera-outline::before {
  content: "\\F0D5D"; }

.mdi-camera-party-mode::before {
  content: "\\F0105"; }

.mdi-camera-plus::before {
  content: "\\F0EDB"; }

.mdi-camera-plus-outline::before {
  content: "\\F0EDC"; }

.mdi-camera-rear::before {
  content: "\\F0106"; }

.mdi-camera-rear-variant::before {
  content: "\\F0107"; }

.mdi-camera-retake::before {
  content: "\\F0E19"; }

.mdi-camera-retake-outline::before {
  content: "\\F0E1A"; }

.mdi-camera-switch::before {
  content: "\\F0108"; }

.mdi-camera-switch-outline::before {
  content: "\\F084A"; }

.mdi-camera-timer::before {
  content: "\\F0109"; }

.mdi-camera-wireless::before {
  content: "\\F0DB6"; }

.mdi-camera-wireless-outline::before {
  content: "\\F0DB7"; }

.mdi-campfire::before {
  content: "\\F0EDD"; }

.mdi-cancel::before {
  content: "\\F073A"; }

.mdi-candle::before {
  content: "\\F05E2"; }

.mdi-candycane::before {
  content: "\\F010A"; }

.mdi-cannabis::before {
  content: "\\F07A6"; }

.mdi-cannabis-off::before {
  content: "\\F166E"; }

.mdi-caps-lock::before {
  content: "\\F0A9B"; }

.mdi-car::before {
  content: "\\F010B"; }

.mdi-car-2-plus::before {
  content: "\\F1015"; }

.mdi-car-3-plus::before {
  content: "\\F1016"; }

.mdi-car-arrow-left::before {
  content: "\\F13B2"; }

.mdi-car-arrow-right::before {
  content: "\\F13B3"; }

.mdi-car-back::before {
  content: "\\F0E1B"; }

.mdi-car-battery::before {
  content: "\\F010C"; }

.mdi-car-brake-abs::before {
  content: "\\F0C47"; }

.mdi-car-brake-alert::before {
  content: "\\F0C48"; }

.mdi-car-brake-hold::before {
  content: "\\F0D5E"; }

.mdi-car-brake-parking::before {
  content: "\\F0D5F"; }

.mdi-car-brake-retarder::before {
  content: "\\F1017"; }

.mdi-car-child-seat::before {
  content: "\\F0FA3"; }

.mdi-car-clutch::before {
  content: "\\F1018"; }

.mdi-car-cog::before {
  content: "\\F13CC"; }

.mdi-car-connected::before {
  content: "\\F010D"; }

.mdi-car-convertible::before {
  content: "\\F07A7"; }

.mdi-car-coolant-level::before {
  content: "\\F1019"; }

.mdi-car-cruise-control::before {
  content: "\\F0D60"; }

.mdi-car-defrost-front::before {
  content: "\\F0D61"; }

.mdi-car-defrost-rear::before {
  content: "\\F0D62"; }

.mdi-car-door::before {
  content: "\\F0B6B"; }

.mdi-car-door-lock::before {
  content: "\\F109D"; }

.mdi-car-electric::before {
  content: "\\F0B6C"; }

.mdi-car-electric-outline::before {
  content: "\\F15B5"; }

.mdi-car-emergency::before {
  content: "\\F160F"; }

.mdi-car-esp::before {
  content: "\\F0C49"; }

.mdi-car-estate::before {
  content: "\\F07A8"; }

.mdi-car-hatchback::before {
  content: "\\F07A9"; }

.mdi-car-info::before {
  content: "\\F11BE"; }

.mdi-car-key::before {
  content: "\\F0B6D"; }

.mdi-car-lifted-pickup::before {
  content: "\\F152D"; }

.mdi-car-light-dimmed::before {
  content: "\\F0C4A"; }

.mdi-car-light-fog::before {
  content: "\\F0C4B"; }

.mdi-car-light-high::before {
  content: "\\F0C4C"; }

.mdi-car-limousine::before {
  content: "\\F08CD"; }

.mdi-car-multiple::before {
  content: "\\F0B6E"; }

.mdi-car-off::before {
  content: "\\F0E1C"; }

.mdi-car-outline::before {
  content: "\\F14ED"; }

.mdi-car-parking-lights::before {
  content: "\\F0D63"; }

.mdi-car-pickup::before {
  content: "\\F07AA"; }

.mdi-car-seat::before {
  content: "\\F0FA4"; }

.mdi-car-seat-cooler::before {
  content: "\\F0FA5"; }

.mdi-car-seat-heater::before {
  content: "\\F0FA6"; }

.mdi-car-settings::before {
  content: "\\F13CD"; }

.mdi-car-shift-pattern::before {
  content: "\\F0F40"; }

.mdi-car-side::before {
  content: "\\F07AB"; }

.mdi-car-sports::before {
  content: "\\F07AC"; }

.mdi-car-tire-alert::before {
  content: "\\F0C4D"; }

.mdi-car-traction-control::before {
  content: "\\F0D64"; }

.mdi-car-turbocharger::before {
  content: "\\F101A"; }

.mdi-car-wash::before {
  content: "\\F010E"; }

.mdi-car-windshield::before {
  content: "\\F101B"; }

.mdi-car-windshield-outline::before {
  content: "\\F101C"; }

.mdi-carabiner::before {
  content: "\\F14C0"; }

.mdi-caravan::before {
  content: "\\F07AD"; }

.mdi-card::before {
  content: "\\F0B6F"; }

.mdi-card-account-details::before {
  content: "\\F05D2"; }

.mdi-card-account-details-outline::before {
  content: "\\F0DAB"; }

.mdi-card-account-details-star::before {
  content: "\\F02A3"; }

.mdi-card-account-details-star-outline::before {
  content: "\\F06DB"; }

.mdi-card-account-mail::before {
  content: "\\F018E"; }

.mdi-card-account-mail-outline::before {
  content: "\\F0E98"; }

.mdi-card-account-phone::before {
  content: "\\F0E99"; }

.mdi-card-account-phone-outline::before {
  content: "\\F0E9A"; }

.mdi-card-bulleted::before {
  content: "\\F0B70"; }

.mdi-card-bulleted-off::before {
  content: "\\F0B71"; }

.mdi-card-bulleted-off-outline::before {
  content: "\\F0B72"; }

.mdi-card-bulleted-outline::before {
  content: "\\F0B73"; }

.mdi-card-bulleted-settings::before {
  content: "\\F0B74"; }

.mdi-card-bulleted-settings-outline::before {
  content: "\\F0B75"; }

.mdi-card-minus::before {
  content: "\\F1600"; }

.mdi-card-minus-outline::before {
  content: "\\F1601"; }

.mdi-card-off::before {
  content: "\\F1602"; }

.mdi-card-off-outline::before {
  content: "\\F1603"; }

.mdi-card-outline::before {
  content: "\\F0B76"; }

.mdi-card-plus::before {
  content: "\\F11FF"; }

.mdi-card-plus-outline::before {
  content: "\\F1200"; }

.mdi-card-remove::before {
  content: "\\F1604"; }

.mdi-card-remove-outline::before {
  content: "\\F1605"; }

.mdi-card-search::before {
  content: "\\F1074"; }

.mdi-card-search-outline::before {
  content: "\\F1075"; }

.mdi-card-text::before {
  content: "\\F0B77"; }

.mdi-card-text-outline::before {
  content: "\\F0B78"; }

.mdi-cards::before {
  content: "\\F0638"; }

.mdi-cards-club::before {
  content: "\\F08CE"; }

.mdi-cards-diamond::before {
  content: "\\F08CF"; }

.mdi-cards-diamond-outline::before {
  content: "\\F101D"; }

.mdi-cards-heart::before {
  content: "\\F08D0"; }

.mdi-cards-outline::before {
  content: "\\F0639"; }

.mdi-cards-playing-outline::before {
  content: "\\F063A"; }

.mdi-cards-spade::before {
  content: "\\F08D1"; }

.mdi-cards-variant::before {
  content: "\\F06C7"; }

.mdi-carrot::before {
  content: "\\F010F"; }

.mdi-cart::before {
  content: "\\F0110"; }

.mdi-cart-arrow-down::before {
  content: "\\F0D66"; }

.mdi-cart-arrow-right::before {
  content: "\\F0C4E"; }

.mdi-cart-arrow-up::before {
  content: "\\F0D67"; }

.mdi-cart-check::before {
  content: "\\F15EA"; }

.mdi-cart-minus::before {
  content: "\\F0D68"; }

.mdi-cart-off::before {
  content: "\\F066B"; }

.mdi-cart-outline::before {
  content: "\\F0111"; }

.mdi-cart-plus::before {
  content: "\\F0112"; }

.mdi-cart-remove::before {
  content: "\\F0D69"; }

.mdi-cart-variant::before {
  content: "\\F15EB"; }

.mdi-case-sensitive-alt::before {
  content: "\\F0113"; }

.mdi-cash::before {
  content: "\\F0114"; }

.mdi-cash-100::before {
  content: "\\F0115"; }

.mdi-cash-check::before {
  content: "\\F14EE"; }

.mdi-cash-lock::before {
  content: "\\F14EA"; }

.mdi-cash-lock-open::before {
  content: "\\F14EB"; }

.mdi-cash-marker::before {
  content: "\\F0DB8"; }

.mdi-cash-minus::before {
  content: "\\F1260"; }

.mdi-cash-multiple::before {
  content: "\\F0116"; }

.mdi-cash-plus::before {
  content: "\\F1261"; }

.mdi-cash-refund::before {
  content: "\\F0A9C"; }

.mdi-cash-register::before {
  content: "\\F0CF4"; }

.mdi-cash-remove::before {
  content: "\\F1262"; }

.mdi-cash-usd::before {
  content: "\\F1176"; }

.mdi-cash-usd-outline::before {
  content: "\\F0117"; }

.mdi-cassette::before {
  content: "\\F09D4"; }

.mdi-cast::before {
  content: "\\F0118"; }

.mdi-cast-audio::before {
  content: "\\F101E"; }

.mdi-cast-connected::before {
  content: "\\F0119"; }

.mdi-cast-education::before {
  content: "\\F0E1D"; }

.mdi-cast-off::before {
  content: "\\F078A"; }

.mdi-castle::before {
  content: "\\F011A"; }

.mdi-cat::before {
  content: "\\F011B"; }

.mdi-cctv::before {
  content: "\\F07AE"; }

.mdi-ceiling-light::before {
  content: "\\F0769"; }

.mdi-cellphone::before {
  content: "\\F011C"; }

.mdi-cellphone-android::before {
  content: "\\F011D"; }

.mdi-cellphone-arrow-down::before {
  content: "\\F09D5"; }

.mdi-cellphone-basic::before {
  content: "\\F011E"; }

.mdi-cellphone-charging::before {
  content: "\\F1397"; }

.mdi-cellphone-cog::before {
  content: "\\F0951"; }

.mdi-cellphone-dock::before {
  content: "\\F011F"; }

.mdi-cellphone-erase::before {
  content: "\\F094D"; }

.mdi-cellphone-information::before {
  content: "\\F0F41"; }

.mdi-cellphone-iphone::before {
  content: "\\F0120"; }

.mdi-cellphone-key::before {
  content: "\\F094E"; }

.mdi-cellphone-link::before {
  content: "\\F0121"; }

.mdi-cellphone-link-off::before {
  content: "\\F0122"; }

.mdi-cellphone-lock::before {
  content: "\\F094F"; }

.mdi-cellphone-message::before {
  content: "\\F08D3"; }

.mdi-cellphone-message-off::before {
  content: "\\F10D2"; }

.mdi-cellphone-nfc::before {
  content: "\\F0E90"; }

.mdi-cellphone-nfc-off::before {
  content: "\\F12D8"; }

.mdi-cellphone-off::before {
  content: "\\F0950"; }

.mdi-cellphone-play::before {
  content: "\\F101F"; }

.mdi-cellphone-screenshot::before {
  content: "\\F0A35"; }

.mdi-cellphone-settings::before {
  content: "\\F0123"; }

.mdi-cellphone-sound::before {
  content: "\\F0952"; }

.mdi-cellphone-text::before {
  content: "\\F08D2"; }

.mdi-cellphone-wireless::before {
  content: "\\F0815"; }

.mdi-celtic-cross::before {
  content: "\\F0CF5"; }

.mdi-centos::before {
  content: "\\F111A"; }

.mdi-certificate::before {
  content: "\\F0124"; }

.mdi-certificate-outline::before {
  content: "\\F1188"; }

.mdi-chair-rolling::before {
  content: "\\F0F48"; }

.mdi-chair-school::before {
  content: "\\F0125"; }

.mdi-charity::before {
  content: "\\F0C4F"; }

.mdi-chart-arc::before {
  content: "\\F0126"; }

.mdi-chart-areaspline::before {
  content: "\\F0127"; }

.mdi-chart-areaspline-variant::before {
  content: "\\F0E91"; }

.mdi-chart-bar::before {
  content: "\\F0128"; }

.mdi-chart-bar-stacked::before {
  content: "\\F076A"; }

.mdi-chart-bell-curve::before {
  content: "\\F0C50"; }

.mdi-chart-bell-curve-cumulative::before {
  content: "\\F0FA7"; }

.mdi-chart-box::before {
  content: "\\F154D"; }

.mdi-chart-box-outline::before {
  content: "\\F154E"; }

.mdi-chart-box-plus-outline::before {
  content: "\\F154F"; }

.mdi-chart-bubble::before {
  content: "\\F05E3"; }

.mdi-chart-donut::before {
  content: "\\F07AF"; }

.mdi-chart-donut-variant::before {
  content: "\\F07B0"; }

.mdi-chart-gantt::before {
  content: "\\F066C"; }

.mdi-chart-histogram::before {
  content: "\\F0129"; }

.mdi-chart-line::before {
  content: "\\F012A"; }

.mdi-chart-line-stacked::before {
  content: "\\F076B"; }

.mdi-chart-line-variant::before {
  content: "\\F07B1"; }

.mdi-chart-multiline::before {
  content: "\\F08D4"; }

.mdi-chart-multiple::before {
  content: "\\F1213"; }

.mdi-chart-pie::before {
  content: "\\F012B"; }

.mdi-chart-ppf::before {
  content: "\\F1380"; }

.mdi-chart-sankey::before {
  content: "\\F11DF"; }

.mdi-chart-sankey-variant::before {
  content: "\\F11E0"; }

.mdi-chart-scatter-plot::before {
  content: "\\F0E92"; }

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F066D"; }

.mdi-chart-timeline::before {
  content: "\\F066E"; }

.mdi-chart-timeline-variant::before {
  content: "\\F0E93"; }

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\F15B6"; }

.mdi-chart-tree::before {
  content: "\\F0E94"; }

.mdi-chat::before {
  content: "\\F0B79"; }

.mdi-chat-alert::before {
  content: "\\F0B7A"; }

.mdi-chat-alert-outline::before {
  content: "\\F12C9"; }

.mdi-chat-minus::before {
  content: "\\F1410"; }

.mdi-chat-minus-outline::before {
  content: "\\F1413"; }

.mdi-chat-outline::before {
  content: "\\F0EDE"; }

.mdi-chat-plus::before {
  content: "\\F140F"; }

.mdi-chat-plus-outline::before {
  content: "\\F1412"; }

.mdi-chat-processing::before {
  content: "\\F0B7B"; }

.mdi-chat-processing-outline::before {
  content: "\\F12CA"; }

.mdi-chat-remove::before {
  content: "\\F1411"; }

.mdi-chat-remove-outline::before {
  content: "\\F1414"; }

.mdi-chat-sleep::before {
  content: "\\F12D1"; }

.mdi-chat-sleep-outline::before {
  content: "\\F12D2"; }

.mdi-check::before {
  content: "\\F012C"; }

.mdi-check-all::before {
  content: "\\F012D"; }

.mdi-check-bold::before {
  content: "\\F0E1E"; }

.mdi-check-box-multiple-outline::before {
  content: "\\F0C51"; }

.mdi-check-box-outline::before {
  content: "\\F0C52"; }

.mdi-check-circle::before {
  content: "\\F05E0"; }

.mdi-check-circle-outline::before {
  content: "\\F05E1"; }

.mdi-check-decagram::before {
  content: "\\F0791"; }

.mdi-check-network::before {
  content: "\\F0C53"; }

.mdi-check-network-outline::before {
  content: "\\F0C54"; }

.mdi-check-outline::before {
  content: "\\F0855"; }

.mdi-check-underline::before {
  content: "\\F0E1F"; }

.mdi-check-underline-circle::before {
  content: "\\F0E20"; }

.mdi-check-underline-circle-outline::before {
  content: "\\F0E21"; }

.mdi-checkbook::before {
  content: "\\F0A9D"; }

.mdi-checkbox-blank::before {
  content: "\\F012E"; }

.mdi-checkbox-blank-circle::before {
  content: "\\F012F"; }

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F0130"; }

.mdi-checkbox-blank-off::before {
  content: "\\F12EC"; }

.mdi-checkbox-blank-off-outline::before {
  content: "\\F12ED"; }

.mdi-checkbox-blank-outline::before {
  content: "\\F0131"; }

.mdi-checkbox-intermediate::before {
  content: "\\F0856"; }

.mdi-checkbox-marked::before {
  content: "\\F0132"; }

.mdi-checkbox-marked-circle::before {
  content: "\\F0133"; }

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F0134"; }

.mdi-checkbox-marked-outline::before {
  content: "\\F0135"; }

.mdi-checkbox-multiple-blank::before {
  content: "\\F0136"; }

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F063B"; }

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F063C"; }

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F0137"; }

.mdi-checkbox-multiple-marked::before {
  content: "\\F0138"; }

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F063D"; }

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F063E"; }

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F0139"; }

.mdi-checkerboard::before {
  content: "\\F013A"; }

.mdi-checkerboard-minus::before {
  content: "\\F1202"; }

.mdi-checkerboard-plus::before {
  content: "\\F1201"; }

.mdi-checkerboard-remove::before {
  content: "\\F1203"; }

.mdi-cheese::before {
  content: "\\F12B9"; }

.mdi-cheese-off::before {
  content: "\\F13EE"; }

.mdi-chef-hat::before {
  content: "\\F0B7C"; }

.mdi-chemical-weapon::before {
  content: "\\F013B"; }

.mdi-chess-bishop::before {
  content: "\\F085C"; }

.mdi-chess-king::before {
  content: "\\F0857"; }

.mdi-chess-knight::before {
  content: "\\F0858"; }

.mdi-chess-pawn::before {
  content: "\\F0859"; }

.mdi-chess-queen::before {
  content: "\\F085A"; }

.mdi-chess-rook::before {
  content: "\\F085B"; }

.mdi-chevron-double-down::before {
  content: "\\F013C"; }

.mdi-chevron-double-left::before {
  content: "\\F013D"; }

.mdi-chevron-double-right::before {
  content: "\\F013E"; }

.mdi-chevron-double-up::before {
  content: "\\F013F"; }

.mdi-chevron-down::before {
  content: "\\F0140"; }

.mdi-chevron-down-box::before {
  content: "\\F09D6"; }

.mdi-chevron-down-box-outline::before {
  content: "\\F09D7"; }

.mdi-chevron-down-circle::before {
  content: "\\F0B26"; }

.mdi-chevron-down-circle-outline::before {
  content: "\\F0B27"; }

.mdi-chevron-left::before {
  content: "\\F0141"; }

.mdi-chevron-left-box::before {
  content: "\\F09D8"; }

.mdi-chevron-left-box-outline::before {
  content: "\\F09D9"; }

.mdi-chevron-left-circle::before {
  content: "\\F0B28"; }

.mdi-chevron-left-circle-outline::before {
  content: "\\F0B29"; }

.mdi-chevron-right::before {
  content: "\\F0142"; }

.mdi-chevron-right-box::before {
  content: "\\F09DA"; }

.mdi-chevron-right-box-outline::before {
  content: "\\F09DB"; }

.mdi-chevron-right-circle::before {
  content: "\\F0B2A"; }

.mdi-chevron-right-circle-outline::before {
  content: "\\F0B2B"; }

.mdi-chevron-triple-down::before {
  content: "\\F0DB9"; }

.mdi-chevron-triple-left::before {
  content: "\\F0DBA"; }

.mdi-chevron-triple-right::before {
  content: "\\F0DBB"; }

.mdi-chevron-triple-up::before {
  content: "\\F0DBC"; }

.mdi-chevron-up::before {
  content: "\\F0143"; }

.mdi-chevron-up-box::before {
  content: "\\F09DC"; }

.mdi-chevron-up-box-outline::before {
  content: "\\F09DD"; }

.mdi-chevron-up-circle::before {
  content: "\\F0B2C"; }

.mdi-chevron-up-circle-outline::before {
  content: "\\F0B2D"; }

.mdi-chili-hot::before {
  content: "\\F07B2"; }

.mdi-chili-medium::before {
  content: "\\F07B3"; }

.mdi-chili-mild::before {
  content: "\\F07B4"; }

.mdi-chili-off::before {
  content: "\\F1467"; }

.mdi-chip::before {
  content: "\\F061A"; }

.mdi-christianity::before {
  content: "\\F0953"; }

.mdi-christianity-outline::before {
  content: "\\F0CF6"; }

.mdi-church::before {
  content: "\\F0144"; }

.mdi-cigar::before {
  content: "\\F1189"; }

.mdi-cigar-off::before {
  content: "\\F141B"; }

.mdi-circle::before {
  content: "\\F0765"; }

.mdi-circle-box::before {
  content: "\\F15DC"; }

.mdi-circle-box-outline::before {
  content: "\\F15DD"; }

.mdi-circle-double::before {
  content: "\\F0E95"; }

.mdi-circle-edit-outline::before {
  content: "\\F08D5"; }

.mdi-circle-expand::before {
  content: "\\F0E96"; }

.mdi-circle-half::before {
  content: "\\F1395"; }

.mdi-circle-half-full::before {
  content: "\\F1396"; }

.mdi-circle-medium::before {
  content: "\\F09DE"; }

.mdi-circle-multiple::before {
  content: "\\F0B38"; }

.mdi-circle-multiple-outline::before {
  content: "\\F0695"; }

.mdi-circle-off-outline::before {
  content: "\\F10D3"; }

.mdi-circle-outline::before {
  content: "\\F0766"; }

.mdi-circle-slice-1::before {
  content: "\\F0A9E"; }

.mdi-circle-slice-2::before {
  content: "\\F0A9F"; }

.mdi-circle-slice-3::before {
  content: "\\F0AA0"; }

.mdi-circle-slice-4::before {
  content: "\\F0AA1"; }

.mdi-circle-slice-5::before {
  content: "\\F0AA2"; }

.mdi-circle-slice-6::before {
  content: "\\F0AA3"; }

.mdi-circle-slice-7::before {
  content: "\\F0AA4"; }

.mdi-circle-slice-8::before {
  content: "\\F0AA5"; }

.mdi-circle-small::before {
  content: "\\F09DF"; }

.mdi-circular-saw::before {
  content: "\\F0E22"; }

.mdi-city::before {
  content: "\\F0146"; }

.mdi-city-variant::before {
  content: "\\F0A36"; }

.mdi-city-variant-outline::before {
  content: "\\F0A37"; }

.mdi-clipboard::before {
  content: "\\F0147"; }

.mdi-clipboard-account::before {
  content: "\\F0148"; }

.mdi-clipboard-account-outline::before {
  content: "\\F0C55"; }

.mdi-clipboard-alert::before {
  content: "\\F0149"; }

.mdi-clipboard-alert-outline::before {
  content: "\\F0CF7"; }

.mdi-clipboard-arrow-down::before {
  content: "\\F014A"; }

.mdi-clipboard-arrow-down-outline::before {
  content: "\\F0C56"; }

.mdi-clipboard-arrow-left::before {
  content: "\\F014B"; }

.mdi-clipboard-arrow-left-outline::before {
  content: "\\F0CF8"; }

.mdi-clipboard-arrow-right::before {
  content: "\\F0CF9"; }

.mdi-clipboard-arrow-right-outline::before {
  content: "\\F0CFA"; }

.mdi-clipboard-arrow-up::before {
  content: "\\F0C57"; }

.mdi-clipboard-arrow-up-outline::before {
  content: "\\F0C58"; }

.mdi-clipboard-check::before {
  content: "\\F014E"; }

.mdi-clipboard-check-multiple::before {
  content: "\\F1263"; }

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F1264"; }

.mdi-clipboard-check-outline::before {
  content: "\\F08A8"; }

.mdi-clipboard-edit::before {
  content: "\\F14E5"; }

.mdi-clipboard-edit-outline::before {
  content: "\\F14E6"; }

.mdi-clipboard-file::before {
  content: "\\F1265"; }

.mdi-clipboard-file-outline::before {
  content: "\\F1266"; }

.mdi-clipboard-flow::before {
  content: "\\F06C8"; }

.mdi-clipboard-flow-outline::before {
  content: "\\F1117"; }

.mdi-clipboard-list::before {
  content: "\\F10D4"; }

.mdi-clipboard-list-outline::before {
  content: "\\F10D5"; }

.mdi-clipboard-minus::before {
  content: "\\F1618"; }

.mdi-clipboard-minus-outline::before {
  content: "\\F1619"; }

.mdi-clipboard-multiple::before {
  content: "\\F1267"; }

.mdi-clipboard-multiple-outline::before {
  content: "\\F1268"; }

.mdi-clipboard-off::before {
  content: "\\F161A"; }

.mdi-clipboard-off-outline::before {
  content: "\\F161B"; }

.mdi-clipboard-outline::before {
  content: "\\F014C"; }

.mdi-clipboard-play::before {
  content: "\\F0C59"; }

.mdi-clipboard-play-multiple::before {
  content: "\\F1269"; }

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F126A"; }

.mdi-clipboard-play-outline::before {
  content: "\\F0C5A"; }

.mdi-clipboard-plus::before {
  content: "\\F0751"; }

.mdi-clipboard-plus-outline::before {
  content: "\\F131F"; }

.mdi-clipboard-pulse::before {
  content: "\\F085D"; }

.mdi-clipboard-pulse-outline::before {
  content: "\\F085E"; }

.mdi-clipboard-remove::before {
  content: "\\F161C"; }

.mdi-clipboard-remove-outline::before {
  content: "\\F161D"; }

.mdi-clipboard-search::before {
  content: "\\F161E"; }

.mdi-clipboard-search-outline::before {
  content: "\\F161F"; }

.mdi-clipboard-text::before {
  content: "\\F014D"; }

.mdi-clipboard-text-multiple::before {
  content: "\\F126B"; }

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F126C"; }

.mdi-clipboard-text-off::before {
  content: "\\F1620"; }

.mdi-clipboard-text-off-outline::before {
  content: "\\F1621"; }

.mdi-clipboard-text-outline::before {
  content: "\\F0A38"; }

.mdi-clipboard-text-play::before {
  content: "\\F0C5B"; }

.mdi-clipboard-text-play-outline::before {
  content: "\\F0C5C"; }

.mdi-clipboard-text-search::before {
  content: "\\F1622"; }

.mdi-clipboard-text-search-outline::before {
  content: "\\F1623"; }

.mdi-clippy::before {
  content: "\\F014F"; }

.mdi-clock::before {
  content: "\\F0954"; }

.mdi-clock-alert::before {
  content: "\\F0955"; }

.mdi-clock-alert-outline::before {
  content: "\\F05CE"; }

.mdi-clock-check::before {
  content: "\\F0FA8"; }

.mdi-clock-check-outline::before {
  content: "\\F0FA9"; }

.mdi-clock-digital::before {
  content: "\\F0E97"; }

.mdi-clock-end::before {
  content: "\\F0151"; }

.mdi-clock-fast::before {
  content: "\\F0152"; }

.mdi-clock-in::before {
  content: "\\F0153"; }

.mdi-clock-out::before {
  content: "\\F0154"; }

.mdi-clock-outline::before {
  content: "\\F0150"; }

.mdi-clock-start::before {
  content: "\\F0155"; }

.mdi-clock-time-eight::before {
  content: "\\F1446"; }

.mdi-clock-time-eight-outline::before {
  content: "\\F1452"; }

.mdi-clock-time-eleven::before {
  content: "\\F1449"; }

.mdi-clock-time-eleven-outline::before {
  content: "\\F1455"; }

.mdi-clock-time-five::before {
  content: "\\F1443"; }

.mdi-clock-time-five-outline::before {
  content: "\\F144F"; }

.mdi-clock-time-four::before {
  content: "\\F1442"; }

.mdi-clock-time-four-outline::before {
  content: "\\F144E"; }

.mdi-clock-time-nine::before {
  content: "\\F1447"; }

.mdi-clock-time-nine-outline::before {
  content: "\\F1453"; }

.mdi-clock-time-one::before {
  content: "\\F143F"; }

.mdi-clock-time-one-outline::before {
  content: "\\F144B"; }

.mdi-clock-time-seven::before {
  content: "\\F1445"; }

.mdi-clock-time-seven-outline::before {
  content: "\\F1451"; }

.mdi-clock-time-six::before {
  content: "\\F1444"; }

.mdi-clock-time-six-outline::before {
  content: "\\F1450"; }

.mdi-clock-time-ten::before {
  content: "\\F1448"; }

.mdi-clock-time-ten-outline::before {
  content: "\\F1454"; }

.mdi-clock-time-three::before {
  content: "\\F1441"; }

.mdi-clock-time-three-outline::before {
  content: "\\F144D"; }

.mdi-clock-time-twelve::before {
  content: "\\F144A"; }

.mdi-clock-time-twelve-outline::before {
  content: "\\F1456"; }

.mdi-clock-time-two::before {
  content: "\\F1440"; }

.mdi-clock-time-two-outline::before {
  content: "\\F144C"; }

.mdi-close::before {
  content: "\\F0156"; }

.mdi-close-box::before {
  content: "\\F0157"; }

.mdi-close-box-multiple::before {
  content: "\\F0C5D"; }

.mdi-close-box-multiple-outline::before {
  content: "\\F0C5E"; }

.mdi-close-box-outline::before {
  content: "\\F0158"; }

.mdi-close-circle::before {
  content: "\\F0159"; }

.mdi-close-circle-multiple::before {
  content: "\\F062A"; }

.mdi-close-circle-multiple-outline::before {
  content: "\\F0883"; }

.mdi-close-circle-outline::before {
  content: "\\F015A"; }

.mdi-close-network::before {
  content: "\\F015B"; }

.mdi-close-network-outline::before {
  content: "\\F0C5F"; }

.mdi-close-octagon::before {
  content: "\\F015C"; }

.mdi-close-octagon-outline::before {
  content: "\\F015D"; }

.mdi-close-outline::before {
  content: "\\F06C9"; }

.mdi-close-thick::before {
  content: "\\F1398"; }

.mdi-closed-caption::before {
  content: "\\F015E"; }

.mdi-closed-caption-outline::before {
  content: "\\F0DBD"; }

.mdi-cloud::before {
  content: "\\F015F"; }

.mdi-cloud-alert::before {
  content: "\\F09E0"; }

.mdi-cloud-braces::before {
  content: "\\F07B5"; }

.mdi-cloud-check::before {
  content: "\\F0160"; }

.mdi-cloud-check-outline::before {
  content: "\\F12CC"; }

.mdi-cloud-circle::before {
  content: "\\F0161"; }

.mdi-cloud-download::before {
  content: "\\F0162"; }

.mdi-cloud-download-outline::before {
  content: "\\F0B7D"; }

.mdi-cloud-lock::before {
  content: "\\F11F1"; }

.mdi-cloud-lock-outline::before {
  content: "\\F11F2"; }

.mdi-cloud-off-outline::before {
  content: "\\F0164"; }

.mdi-cloud-outline::before {
  content: "\\F0163"; }

.mdi-cloud-print::before {
  content: "\\F0165"; }

.mdi-cloud-print-outline::before {
  content: "\\F0166"; }

.mdi-cloud-question::before {
  content: "\\F0A39"; }

.mdi-cloud-refresh::before {
  content: "\\F052A"; }

.mdi-cloud-search::before {
  content: "\\F0956"; }

.mdi-cloud-search-outline::before {
  content: "\\F0957"; }

.mdi-cloud-sync::before {
  content: "\\F063F"; }

.mdi-cloud-sync-outline::before {
  content: "\\F12D6"; }

.mdi-cloud-tags::before {
  content: "\\F07B6"; }

.mdi-cloud-upload::before {
  content: "\\F0167"; }

.mdi-cloud-upload-outline::before {
  content: "\\F0B7E"; }

.mdi-clover::before {
  content: "\\F0816"; }

.mdi-coach-lamp::before {
  content: "\\F1020"; }

.mdi-coat-rack::before {
  content: "\\F109E"; }

.mdi-code-array::before {
  content: "\\F0168"; }

.mdi-code-braces::before {
  content: "\\F0169"; }

.mdi-code-braces-box::before {
  content: "\\F10D6"; }

.mdi-code-brackets::before {
  content: "\\F016A"; }

.mdi-code-equal::before {
  content: "\\F016B"; }

.mdi-code-greater-than::before {
  content: "\\F016C"; }

.mdi-code-greater-than-or-equal::before {
  content: "\\F016D"; }

.mdi-code-json::before {
  content: "\\F0626"; }

.mdi-code-less-than::before {
  content: "\\F016E"; }

.mdi-code-less-than-or-equal::before {
  content: "\\F016F"; }

.mdi-code-not-equal::before {
  content: "\\F0170"; }

.mdi-code-not-equal-variant::before {
  content: "\\F0171"; }

.mdi-code-parentheses::before {
  content: "\\F0172"; }

.mdi-code-parentheses-box::before {
  content: "\\F10D7"; }

.mdi-code-string::before {
  content: "\\F0173"; }

.mdi-code-tags::before {
  content: "\\F0174"; }

.mdi-code-tags-check::before {
  content: "\\F0694"; }

.mdi-codepen::before {
  content: "\\F0175"; }

.mdi-coffee::before {
  content: "\\F0176"; }

.mdi-coffee-maker::before {
  content: "\\F109F"; }

.mdi-coffee-off::before {
  content: "\\F0FAA"; }

.mdi-coffee-off-outline::before {
  content: "\\F0FAB"; }

.mdi-coffee-outline::before {
  content: "\\F06CA"; }

.mdi-coffee-to-go::before {
  content: "\\F0177"; }

.mdi-coffee-to-go-outline::before {
  content: "\\F130E"; }

.mdi-coffin::before {
  content: "\\F0B7F"; }

.mdi-cog::before {
  content: "\\F0493"; }

.mdi-cog-box::before {
  content: "\\F0494"; }

.mdi-cog-clockwise::before {
  content: "\\F11DD"; }

.mdi-cog-counterclockwise::before {
  content: "\\F11DE"; }

.mdi-cog-off::before {
  content: "\\F13CE"; }

.mdi-cog-off-outline::before {
  content: "\\F13CF"; }

.mdi-cog-outline::before {
  content: "\\F08BB"; }

.mdi-cog-refresh::before {
  content: "\\F145E"; }

.mdi-cog-refresh-outline::before {
  content: "\\F145F"; }

.mdi-cog-sync::before {
  content: "\\F1460"; }

.mdi-cog-sync-outline::before {
  content: "\\F1461"; }

.mdi-cog-transfer::before {
  content: "\\F105B"; }

.mdi-cog-transfer-outline::before {
  content: "\\F105C"; }

.mdi-cogs::before {
  content: "\\F08D6"; }

.mdi-collage::before {
  content: "\\F0640"; }

.mdi-collapse-all::before {
  content: "\\F0AA6"; }

.mdi-collapse-all-outline::before {
  content: "\\F0AA7"; }

.mdi-color-helper::before {
  content: "\\F0179"; }

.mdi-comma::before {
  content: "\\F0E23"; }

.mdi-comma-box::before {
  content: "\\F0E2B"; }

.mdi-comma-box-outline::before {
  content: "\\F0E24"; }

.mdi-comma-circle::before {
  content: "\\F0E25"; }

.mdi-comma-circle-outline::before {
  content: "\\F0E26"; }

.mdi-comment::before {
  content: "\\F017A"; }

.mdi-comment-account::before {
  content: "\\F017B"; }

.mdi-comment-account-outline::before {
  content: "\\F017C"; }

.mdi-comment-alert::before {
  content: "\\F017D"; }

.mdi-comment-alert-outline::before {
  content: "\\F017E"; }

.mdi-comment-arrow-left::before {
  content: "\\F09E1"; }

.mdi-comment-arrow-left-outline::before {
  content: "\\F09E2"; }

.mdi-comment-arrow-right::before {
  content: "\\F09E3"; }

.mdi-comment-arrow-right-outline::before {
  content: "\\F09E4"; }

.mdi-comment-bookmark::before {
  content: "\\F15AE"; }

.mdi-comment-bookmark-outline::before {
  content: "\\F15AF"; }

.mdi-comment-check::before {
  content: "\\F017F"; }

.mdi-comment-check-outline::before {
  content: "\\F0180"; }

.mdi-comment-edit::before {
  content: "\\F11BF"; }

.mdi-comment-edit-outline::before {
  content: "\\F12C4"; }

.mdi-comment-eye::before {
  content: "\\F0A3A"; }

.mdi-comment-eye-outline::before {
  content: "\\F0A3B"; }

.mdi-comment-flash::before {
  content: "\\F15B0"; }

.mdi-comment-flash-outline::before {
  content: "\\F15B1"; }

.mdi-comment-minus::before {
  content: "\\F15DF"; }

.mdi-comment-minus-outline::before {
  content: "\\F15E0"; }

.mdi-comment-multiple::before {
  content: "\\F085F"; }

.mdi-comment-multiple-outline::before {
  content: "\\F0181"; }

.mdi-comment-off::before {
  content: "\\F15E1"; }

.mdi-comment-off-outline::before {
  content: "\\F15E2"; }

.mdi-comment-outline::before {
  content: "\\F0182"; }

.mdi-comment-plus::before {
  content: "\\F09E5"; }

.mdi-comment-plus-outline::before {
  content: "\\F0183"; }

.mdi-comment-processing::before {
  content: "\\F0184"; }

.mdi-comment-processing-outline::before {
  content: "\\F0185"; }

.mdi-comment-question::before {
  content: "\\F0817"; }

.mdi-comment-question-outline::before {
  content: "\\F0186"; }

.mdi-comment-quote::before {
  content: "\\F1021"; }

.mdi-comment-quote-outline::before {
  content: "\\F1022"; }

.mdi-comment-remove::before {
  content: "\\F05DE"; }

.mdi-comment-remove-outline::before {
  content: "\\F0187"; }

.mdi-comment-search::before {
  content: "\\F0A3C"; }

.mdi-comment-search-outline::before {
  content: "\\F0A3D"; }

.mdi-comment-text::before {
  content: "\\F0188"; }

.mdi-comment-text-multiple::before {
  content: "\\F0860"; }

.mdi-comment-text-multiple-outline::before {
  content: "\\F0861"; }

.mdi-comment-text-outline::before {
  content: "\\F0189"; }

.mdi-compare::before {
  content: "\\F018A"; }

.mdi-compare-horizontal::before {
  content: "\\F1492"; }

.mdi-compare-vertical::before {
  content: "\\F1493"; }

.mdi-compass::before {
  content: "\\F018B"; }

.mdi-compass-off::before {
  content: "\\F0B80"; }

.mdi-compass-off-outline::before {
  content: "\\F0B81"; }

.mdi-compass-outline::before {
  content: "\\F018C"; }

.mdi-compass-rose::before {
  content: "\\F1382"; }

.mdi-concourse-ci::before {
  content: "\\F10A0"; }

.mdi-connection::before {
  content: "\\F1616"; }

.mdi-console::before {
  content: "\\F018D"; }

.mdi-console-line::before {
  content: "\\F07B7"; }

.mdi-console-network::before {
  content: "\\F08A9"; }

.mdi-console-network-outline::before {
  content: "\\F0C60"; }

.mdi-consolidate::before {
  content: "\\F10D8"; }

.mdi-contactless-payment::before {
  content: "\\F0D6A"; }

.mdi-contactless-payment-circle::before {
  content: "\\F0321"; }

.mdi-contactless-payment-circle-outline::before {
  content: "\\F0408"; }

.mdi-contacts::before {
  content: "\\F06CB"; }

.mdi-contacts-outline::before {
  content: "\\F05B8"; }

.mdi-contain::before {
  content: "\\F0A3E"; }

.mdi-contain-end::before {
  content: "\\F0A3F"; }

.mdi-contain-start::before {
  content: "\\F0A40"; }

.mdi-content-copy::before {
  content: "\\F018F"; }

.mdi-content-cut::before {
  content: "\\F0190"; }

.mdi-content-duplicate::before {
  content: "\\F0191"; }

.mdi-content-paste::before {
  content: "\\F0192"; }

.mdi-content-save::before {
  content: "\\F0193"; }

.mdi-content-save-alert::before {
  content: "\\F0F42"; }

.mdi-content-save-alert-outline::before {
  content: "\\F0F43"; }

.mdi-content-save-all::before {
  content: "\\F0194"; }

.mdi-content-save-all-outline::before {
  content: "\\F0F44"; }

.mdi-content-save-cog::before {
  content: "\\F145B"; }

.mdi-content-save-cog-outline::before {
  content: "\\F145C"; }

.mdi-content-save-edit::before {
  content: "\\F0CFB"; }

.mdi-content-save-edit-outline::before {
  content: "\\F0CFC"; }

.mdi-content-save-move::before {
  content: "\\F0E27"; }

.mdi-content-save-move-outline::before {
  content: "\\F0E28"; }

.mdi-content-save-off::before {
  content: "\\F1643"; }

.mdi-content-save-off-outline::before {
  content: "\\F1644"; }

.mdi-content-save-outline::before {
  content: "\\F0818"; }

.mdi-content-save-settings::before {
  content: "\\F061B"; }

.mdi-content-save-settings-outline::before {
  content: "\\F0B2E"; }

.mdi-contrast::before {
  content: "\\F0195"; }

.mdi-contrast-box::before {
  content: "\\F0196"; }

.mdi-contrast-circle::before {
  content: "\\F0197"; }

.mdi-controller-classic::before {
  content: "\\F0B82"; }

.mdi-controller-classic-outline::before {
  content: "\\F0B83"; }

.mdi-cookie::before {
  content: "\\F0198"; }

.mdi-cookie-alert::before {
  content: "\\F16D0"; }

.mdi-cookie-alert-outline::before {
  content: "\\F16D1"; }

.mdi-cookie-check::before {
  content: "\\F16D2"; }

.mdi-cookie-check-outline::before {
  content: "\\F16D3"; }

.mdi-cookie-cog::before {
  content: "\\F16D4"; }

.mdi-cookie-cog-outline::before {
  content: "\\F16D5"; }

.mdi-cookie-minus::before {
  content: "\\F16DA"; }

.mdi-cookie-minus-outline::before {
  content: "\\F16DB"; }

.mdi-cookie-outline::before {
  content: "\\F16DE"; }

.mdi-cookie-plus::before {
  content: "\\F16D6"; }

.mdi-cookie-plus-outline::before {
  content: "\\F16D7"; }

.mdi-cookie-remove::before {
  content: "\\F16D8"; }

.mdi-cookie-remove-outline::before {
  content: "\\F16D9"; }

.mdi-cookie-settings::before {
  content: "\\F16DC"; }

.mdi-cookie-settings-outline::before {
  content: "\\F16DD"; }

.mdi-coolant-temperature::before {
  content: "\\F03C8"; }

.mdi-copyright::before {
  content: "\\F05E6"; }

.mdi-cordova::before {
  content: "\\F0958"; }

.mdi-corn::before {
  content: "\\F07B8"; }

.mdi-corn-off::before {
  content: "\\F13EF"; }

.mdi-cosine-wave::before {
  content: "\\F1479"; }

.mdi-counter::before {
  content: "\\F0199"; }

.mdi-cow::before {
  content: "\\F019A"; }

.mdi-cpu-32-bit::before {
  content: "\\F0EDF"; }

.mdi-cpu-64-bit::before {
  content: "\\F0EE0"; }

.mdi-crane::before {
  content: "\\F0862"; }

.mdi-creation::before {
  content: "\\F0674"; }

.mdi-creative-commons::before {
  content: "\\F0D6B"; }

.mdi-credit-card::before {
  content: "\\F0FEF"; }

.mdi-credit-card-check::before {
  content: "\\F13D0"; }

.mdi-credit-card-check-outline::before {
  content: "\\F13D1"; }

.mdi-credit-card-clock::before {
  content: "\\F0EE1"; }

.mdi-credit-card-clock-outline::before {
  content: "\\F0EE2"; }

.mdi-credit-card-marker::before {
  content: "\\F06A8"; }

.mdi-credit-card-marker-outline::before {
  content: "\\F0DBE"; }

.mdi-credit-card-minus::before {
  content: "\\F0FAC"; }

.mdi-credit-card-minus-outline::before {
  content: "\\F0FAD"; }

.mdi-credit-card-multiple::before {
  content: "\\F0FF0"; }

.mdi-credit-card-multiple-outline::before {
  content: "\\F019C"; }

.mdi-credit-card-off::before {
  content: "\\F0FF1"; }

.mdi-credit-card-off-outline::before {
  content: "\\F05E4"; }

.mdi-credit-card-outline::before {
  content: "\\F019B"; }

.mdi-credit-card-plus::before {
  content: "\\F0FF2"; }

.mdi-credit-card-plus-outline::before {
  content: "\\F0676"; }

.mdi-credit-card-refresh::before {
  content: "\\F1645"; }

.mdi-credit-card-refresh-outline::before {
  content: "\\F1646"; }

.mdi-credit-card-refund::before {
  content: "\\F0FF3"; }

.mdi-credit-card-refund-outline::before {
  content: "\\F0AA8"; }

.mdi-credit-card-remove::before {
  content: "\\F0FAE"; }

.mdi-credit-card-remove-outline::before {
  content: "\\F0FAF"; }

.mdi-credit-card-scan::before {
  content: "\\F0FF4"; }

.mdi-credit-card-scan-outline::before {
  content: "\\F019D"; }

.mdi-credit-card-search::before {
  content: "\\F1647"; }

.mdi-credit-card-search-outline::before {
  content: "\\F1648"; }

.mdi-credit-card-settings::before {
  content: "\\F0FF5"; }

.mdi-credit-card-settings-outline::before {
  content: "\\F08D7"; }

.mdi-credit-card-sync::before {
  content: "\\F1649"; }

.mdi-credit-card-sync-outline::before {
  content: "\\F164A"; }

.mdi-credit-card-wireless::before {
  content: "\\F0802"; }

.mdi-credit-card-wireless-off::before {
  content: "\\F057A"; }

.mdi-credit-card-wireless-off-outline::before {
  content: "\\F057B"; }

.mdi-credit-card-wireless-outline::before {
  content: "\\F0D6C"; }

.mdi-cricket::before {
  content: "\\F0D6D"; }

.mdi-crop::before {
  content: "\\F019E"; }

.mdi-crop-free::before {
  content: "\\F019F"; }

.mdi-crop-landscape::before {
  content: "\\F01A0"; }

.mdi-crop-portrait::before {
  content: "\\F01A1"; }

.mdi-crop-rotate::before {
  content: "\\F0696"; }

.mdi-crop-square::before {
  content: "\\F01A2"; }

.mdi-crosshairs::before {
  content: "\\F01A3"; }

.mdi-crosshairs-gps::before {
  content: "\\F01A4"; }

.mdi-crosshairs-off::before {
  content: "\\F0F45"; }

.mdi-crosshairs-question::before {
  content: "\\F1136"; }

.mdi-crown::before {
  content: "\\F01A5"; }

.mdi-crown-outline::before {
  content: "\\F11D0"; }

.mdi-cryengine::before {
  content: "\\F0959"; }

.mdi-crystal-ball::before {
  content: "\\F0B2F"; }

.mdi-cube::before {
  content: "\\F01A6"; }

.mdi-cube-off::before {
  content: "\\F141C"; }

.mdi-cube-off-outline::before {
  content: "\\F141D"; }

.mdi-cube-outline::before {
  content: "\\F01A7"; }

.mdi-cube-scan::before {
  content: "\\F0B84"; }

.mdi-cube-send::before {
  content: "\\F01A8"; }

.mdi-cube-unfolded::before {
  content: "\\F01A9"; }

.mdi-cup::before {
  content: "\\F01AA"; }

.mdi-cup-off::before {
  content: "\\F05E5"; }

.mdi-cup-off-outline::before {
  content: "\\F137D"; }

.mdi-cup-outline::before {
  content: "\\F130F"; }

.mdi-cup-water::before {
  content: "\\F01AB"; }

.mdi-cupboard::before {
  content: "\\F0F46"; }

.mdi-cupboard-outline::before {
  content: "\\F0F47"; }

.mdi-cupcake::before {
  content: "\\F095A"; }

.mdi-curling::before {
  content: "\\F0863"; }

.mdi-currency-bdt::before {
  content: "\\F0864"; }

.mdi-currency-brl::before {
  content: "\\F0B85"; }

.mdi-currency-btc::before {
  content: "\\F01AC"; }

.mdi-currency-cny::before {
  content: "\\F07BA"; }

.mdi-currency-eth::before {
  content: "\\F07BB"; }

.mdi-currency-eur::before {
  content: "\\F01AD"; }

.mdi-currency-eur-off::before {
  content: "\\F1315"; }

.mdi-currency-gbp::before {
  content: "\\F01AE"; }

.mdi-currency-ils::before {
  content: "\\F0C61"; }

.mdi-currency-inr::before {
  content: "\\F01AF"; }

.mdi-currency-jpy::before {
  content: "\\F07BC"; }

.mdi-currency-krw::before {
  content: "\\F07BD"; }

.mdi-currency-kzt::before {
  content: "\\F0865"; }

.mdi-currency-mnt::before {
  content: "\\F1512"; }

.mdi-currency-ngn::before {
  content: "\\F01B0"; }

.mdi-currency-php::before {
  content: "\\F09E6"; }

.mdi-currency-rial::before {
  content: "\\F0E9C"; }

.mdi-currency-rub::before {
  content: "\\F01B1"; }

.mdi-currency-sign::before {
  content: "\\F07BE"; }

.mdi-currency-try::before {
  content: "\\F01B2"; }

.mdi-currency-twd::before {
  content: "\\F07BF"; }

.mdi-currency-usd::before {
  content: "\\F01C1"; }

.mdi-currency-usd-circle::before {
  content: "\\F116B"; }

.mdi-currency-usd-circle-outline::before {
  content: "\\F0178"; }

.mdi-currency-usd-off::before {
  content: "\\F067A"; }

.mdi-current-ac::before {
  content: "\\F1480"; }

.mdi-current-dc::before {
  content: "\\F095C"; }

.mdi-cursor-default::before {
  content: "\\F01C0"; }

.mdi-cursor-default-click::before {
  content: "\\F0CFD"; }

.mdi-cursor-default-click-outline::before {
  content: "\\F0CFE"; }

.mdi-cursor-default-gesture::before {
  content: "\\F1127"; }

.mdi-cursor-default-gesture-outline::before {
  content: "\\F1128"; }

.mdi-cursor-default-outline::before {
  content: "\\F01BF"; }

.mdi-cursor-move::before {
  content: "\\F01BE"; }

.mdi-cursor-pointer::before {
  content: "\\F01BD"; }

.mdi-cursor-text::before {
  content: "\\F05E7"; }

.mdi-dance-ballroom::before {
  content: "\\F15FB"; }

.mdi-dance-pole::before {
  content: "\\F1578"; }

.mdi-data-matrix::before {
  content: "\\F153C"; }

.mdi-data-matrix-edit::before {
  content: "\\F153D"; }

.mdi-data-matrix-minus::before {
  content: "\\F153E"; }

.mdi-data-matrix-plus::before {
  content: "\\F153F"; }

.mdi-data-matrix-remove::before {
  content: "\\F1540"; }

.mdi-data-matrix-scan::before {
  content: "\\F1541"; }

.mdi-database::before {
  content: "\\F01BC"; }

.mdi-database-alert::before {
  content: "\\F163A"; }

.mdi-database-alert-outline::before {
  content: "\\F1624"; }

.mdi-database-arrow-down::before {
  content: "\\F163B"; }

.mdi-database-arrow-down-outline::before {
  content: "\\F1625"; }

.mdi-database-arrow-left::before {
  content: "\\F163C"; }

.mdi-database-arrow-left-outline::before {
  content: "\\F1626"; }

.mdi-database-arrow-right::before {
  content: "\\F163D"; }

.mdi-database-arrow-right-outline::before {
  content: "\\F1627"; }

.mdi-database-arrow-up::before {
  content: "\\F163E"; }

.mdi-database-arrow-up-outline::before {
  content: "\\F1628"; }

.mdi-database-check::before {
  content: "\\F0AA9"; }

.mdi-database-check-outline::before {
  content: "\\F1629"; }

.mdi-database-clock::before {
  content: "\\F163F"; }

.mdi-database-clock-outline::before {
  content: "\\F162A"; }

.mdi-database-cog::before {
  content: "\\F164B"; }

.mdi-database-cog-outline::before {
  content: "\\F164C"; }

.mdi-database-edit::before {
  content: "\\F0B86"; }

.mdi-database-edit-outline::before {
  content: "\\F162B"; }

.mdi-database-export::before {
  content: "\\F095E"; }

.mdi-database-export-outline::before {
  content: "\\F162C"; }

.mdi-database-import::before {
  content: "\\F095D"; }

.mdi-database-import-outline::before {
  content: "\\F162D"; }

.mdi-database-lock::before {
  content: "\\F0AAA"; }

.mdi-database-lock-outline::before {
  content: "\\F162E"; }

.mdi-database-marker::before {
  content: "\\F12F6"; }

.mdi-database-marker-outline::before {
  content: "\\F162F"; }

.mdi-database-minus::before {
  content: "\\F01BB"; }

.mdi-database-minus-outline::before {
  content: "\\F1630"; }

.mdi-database-off::before {
  content: "\\F1640"; }

.mdi-database-off-outline::before {
  content: "\\F1631"; }

.mdi-database-outline::before {
  content: "\\F1632"; }

.mdi-database-plus::before {
  content: "\\F01BA"; }

.mdi-database-plus-outline::before {
  content: "\\F1633"; }

.mdi-database-refresh::before {
  content: "\\F05C2"; }

.mdi-database-refresh-outline::before {
  content: "\\F1634"; }

.mdi-database-remove::before {
  content: "\\F0D00"; }

.mdi-database-remove-outline::before {
  content: "\\F1635"; }

.mdi-database-search::before {
  content: "\\F0866"; }

.mdi-database-search-outline::before {
  content: "\\F1636"; }

.mdi-database-settings::before {
  content: "\\F0D01"; }

.mdi-database-settings-outline::before {
  content: "\\F1637"; }

.mdi-database-sync::before {
  content: "\\F0CFF"; }

.mdi-database-sync-outline::before {
  content: "\\F1638"; }

.mdi-death-star::before {
  content: "\\F08D8"; }

.mdi-death-star-variant::before {
  content: "\\F08D9"; }

.mdi-deathly-hallows::before {
  content: "\\F0B87"; }

.mdi-debian::before {
  content: "\\F08DA"; }

.mdi-debug-step-into::before {
  content: "\\F01B9"; }

.mdi-debug-step-out::before {
  content: "\\F01B8"; }

.mdi-debug-step-over::before {
  content: "\\F01B7"; }

.mdi-decagram::before {
  content: "\\F076C"; }

.mdi-decagram-outline::before {
  content: "\\F076D"; }

.mdi-decimal::before {
  content: "\\F10A1"; }

.mdi-decimal-comma::before {
  content: "\\F10A2"; }

.mdi-decimal-comma-decrease::before {
  content: "\\F10A3"; }

.mdi-decimal-comma-increase::before {
  content: "\\F10A4"; }

.mdi-decimal-decrease::before {
  content: "\\F01B6"; }

.mdi-decimal-increase::before {
  content: "\\F01B5"; }

.mdi-delete::before {
  content: "\\F01B4"; }

.mdi-delete-alert::before {
  content: "\\F10A5"; }

.mdi-delete-alert-outline::before {
  content: "\\F10A6"; }

.mdi-delete-circle::before {
  content: "\\F0683"; }

.mdi-delete-circle-outline::before {
  content: "\\F0B88"; }

.mdi-delete-clock::before {
  content: "\\F1556"; }

.mdi-delete-clock-outline::before {
  content: "\\F1557"; }

.mdi-delete-empty::before {
  content: "\\F06CC"; }

.mdi-delete-empty-outline::before {
  content: "\\F0E9D"; }

.mdi-delete-forever::before {
  content: "\\F05E8"; }

.mdi-delete-forever-outline::before {
  content: "\\F0B89"; }

.mdi-delete-off::before {
  content: "\\F10A7"; }

.mdi-delete-off-outline::before {
  content: "\\F10A8"; }

.mdi-delete-outline::before {
  content: "\\F09E7"; }

.mdi-delete-restore::before {
  content: "\\F0819"; }

.mdi-delete-sweep::before {
  content: "\\F05E9"; }

.mdi-delete-sweep-outline::before {
  content: "\\F0C62"; }

.mdi-delete-variant::before {
  content: "\\F01B3"; }

.mdi-delta::before {
  content: "\\F01C2"; }

.mdi-desk::before {
  content: "\\F1239"; }

.mdi-desk-lamp::before {
  content: "\\F095F"; }

.mdi-deskphone::before {
  content: "\\F01C3"; }

.mdi-desktop-classic::before {
  content: "\\F07C0"; }

.mdi-desktop-mac::before {
  content: "\\F01C4"; }

.mdi-desktop-mac-dashboard::before {
  content: "\\F09E8"; }

.mdi-desktop-tower::before {
  content: "\\F01C5"; }

.mdi-desktop-tower-monitor::before {
  content: "\\F0AAB"; }

.mdi-details::before {
  content: "\\F01C6"; }

.mdi-dev-to::before {
  content: "\\F0D6E"; }

.mdi-developer-board::before {
  content: "\\F0697"; }

.mdi-deviantart::before {
  content: "\\F01C7"; }

.mdi-devices::before {
  content: "\\F0FB0"; }

.mdi-diabetes::before {
  content: "\\F1126"; }

.mdi-dialpad::before {
  content: "\\F061C"; }

.mdi-diameter::before {
  content: "\\F0C63"; }

.mdi-diameter-outline::before {
  content: "\\F0C64"; }

.mdi-diameter-variant::before {
  content: "\\F0C65"; }

.mdi-diamond::before {
  content: "\\F0B8A"; }

.mdi-diamond-outline::before {
  content: "\\F0B8B"; }

.mdi-diamond-stone::before {
  content: "\\F01C8"; }

.mdi-dice-1::before {
  content: "\\F01CA"; }

.mdi-dice-1-outline::before {
  content: "\\F114A"; }

.mdi-dice-2::before {
  content: "\\F01CB"; }

.mdi-dice-2-outline::before {
  content: "\\F114B"; }

.mdi-dice-3::before {
  content: "\\F01CC"; }

.mdi-dice-3-outline::before {
  content: "\\F114C"; }

.mdi-dice-4::before {
  content: "\\F01CD"; }

.mdi-dice-4-outline::before {
  content: "\\F114D"; }

.mdi-dice-5::before {
  content: "\\F01CE"; }

.mdi-dice-5-outline::before {
  content: "\\F114E"; }

.mdi-dice-6::before {
  content: "\\F01CF"; }

.mdi-dice-6-outline::before {
  content: "\\F114F"; }

.mdi-dice-d10::before {
  content: "\\F1153"; }

.mdi-dice-d10-outline::before {
  content: "\\F076F"; }

.mdi-dice-d12::before {
  content: "\\F1154"; }

.mdi-dice-d12-outline::before {
  content: "\\F0867"; }

.mdi-dice-d20::before {
  content: "\\F1155"; }

.mdi-dice-d20-outline::before {
  content: "\\F05EA"; }

.mdi-dice-d4::before {
  content: "\\F1150"; }

.mdi-dice-d4-outline::before {
  content: "\\F05EB"; }

.mdi-dice-d6::before {
  content: "\\F1151"; }

.mdi-dice-d6-outline::before {
  content: "\\F05ED"; }

.mdi-dice-d8::before {
  content: "\\F1152"; }

.mdi-dice-d8-outline::before {
  content: "\\F05EC"; }

.mdi-dice-multiple::before {
  content: "\\F076E"; }

.mdi-dice-multiple-outline::before {
  content: "\\F1156"; }

.mdi-digital-ocean::before {
  content: "\\F1237"; }

.mdi-dip-switch::before {
  content: "\\F07C1"; }

.mdi-directions::before {
  content: "\\F01D0"; }

.mdi-directions-fork::before {
  content: "\\F0641"; }

.mdi-disc::before {
  content: "\\F05EE"; }

.mdi-disc-alert::before {
  content: "\\F01D1"; }

.mdi-disc-player::before {
  content: "\\F0960"; }

.mdi-discord::before {
  content: "\\F066F"; }

.mdi-dishwasher::before {
  content: "\\F0AAC"; }

.mdi-dishwasher-alert::before {
  content: "\\F11B8"; }

.mdi-dishwasher-off::before {
  content: "\\F11B9"; }

.mdi-disqus::before {
  content: "\\F01D2"; }

.mdi-distribute-horizontal-center::before {
  content: "\\F11C9"; }

.mdi-distribute-horizontal-left::before {
  content: "\\F11C8"; }

.mdi-distribute-horizontal-right::before {
  content: "\\F11CA"; }

.mdi-distribute-vertical-bottom::before {
  content: "\\F11CB"; }

.mdi-distribute-vertical-center::before {
  content: "\\F11CC"; }

.mdi-distribute-vertical-top::before {
  content: "\\F11CD"; }

.mdi-diving-flippers::before {
  content: "\\F0DBF"; }

.mdi-diving-helmet::before {
  content: "\\F0DC0"; }

.mdi-diving-scuba::before {
  content: "\\F0DC1"; }

.mdi-diving-scuba-flag::before {
  content: "\\F0DC2"; }

.mdi-diving-scuba-tank::before {
  content: "\\F0DC3"; }

.mdi-diving-scuba-tank-multiple::before {
  content: "\\F0DC4"; }

.mdi-diving-snorkel::before {
  content: "\\F0DC5"; }

.mdi-division::before {
  content: "\\F01D4"; }

.mdi-division-box::before {
  content: "\\F01D5"; }

.mdi-dlna::before {
  content: "\\F0A41"; }

.mdi-dna::before {
  content: "\\F0684"; }

.mdi-dns::before {
  content: "\\F01D6"; }

.mdi-dns-outline::before {
  content: "\\F0B8C"; }

.mdi-do-not-disturb::before {
  content: "\\F0698"; }

.mdi-do-not-disturb-off::before {
  content: "\\F0699"; }

.mdi-dock-bottom::before {
  content: "\\F10A9"; }

.mdi-dock-left::before {
  content: "\\F10AA"; }

.mdi-dock-right::before {
  content: "\\F10AB"; }

.mdi-dock-top::before {
  content: "\\F1513"; }

.mdi-dock-window::before {
  content: "\\F10AC"; }

.mdi-docker::before {
  content: "\\F0868"; }

.mdi-doctor::before {
  content: "\\F0A42"; }

.mdi-dog::before {
  content: "\\F0A43"; }

.mdi-dog-service::before {
  content: "\\F0AAD"; }

.mdi-dog-side::before {
  content: "\\F0A44"; }

.mdi-dolby::before {
  content: "\\F06B3"; }

.mdi-dolly::before {
  content: "\\F0E9E"; }

.mdi-domain::before {
  content: "\\F01D7"; }

.mdi-domain-off::before {
  content: "\\F0D6F"; }

.mdi-domain-plus::before {
  content: "\\F10AD"; }

.mdi-domain-remove::before {
  content: "\\F10AE"; }

.mdi-dome-light::before {
  content: "\\F141E"; }

.mdi-domino-mask::before {
  content: "\\F1023"; }

.mdi-donkey::before {
  content: "\\F07C2"; }

.mdi-door::before {
  content: "\\F081A"; }

.mdi-door-closed::before {
  content: "\\F081B"; }

.mdi-door-closed-lock::before {
  content: "\\F10AF"; }

.mdi-door-open::before {
  content: "\\F081C"; }

.mdi-doorbell::before {
  content: "\\F12E6"; }

.mdi-doorbell-video::before {
  content: "\\F0869"; }

.mdi-dot-net::before {
  content: "\\F0AAE"; }

.mdi-dots-grid::before {
  content: "\\F15FC"; }

.mdi-dots-hexagon::before {
  content: "\\F15FF"; }

.mdi-dots-horizontal::before {
  content: "\\F01D8"; }

.mdi-dots-horizontal-circle::before {
  content: "\\F07C3"; }

.mdi-dots-horizontal-circle-outline::before {
  content: "\\F0B8D"; }

.mdi-dots-square::before {
  content: "\\F15FD"; }

.mdi-dots-triangle::before {
  content: "\\F15FE"; }

.mdi-dots-vertical::before {
  content: "\\F01D9"; }

.mdi-dots-vertical-circle::before {
  content: "\\F07C4"; }

.mdi-dots-vertical-circle-outline::before {
  content: "\\F0B8E"; }

.mdi-douban::before {
  content: "\\F069A"; }

.mdi-download::before {
  content: "\\F01DA"; }

.mdi-download-box::before {
  content: "\\F1462"; }

.mdi-download-box-outline::before {
  content: "\\F1463"; }

.mdi-download-circle::before {
  content: "\\F1464"; }

.mdi-download-circle-outline::before {
  content: "\\F1465"; }

.mdi-download-lock::before {
  content: "\\F1320"; }

.mdi-download-lock-outline::before {
  content: "\\F1321"; }

.mdi-download-multiple::before {
  content: "\\F09E9"; }

.mdi-download-network::before {
  content: "\\F06F4"; }

.mdi-download-network-outline::before {
  content: "\\F0C66"; }

.mdi-download-off::before {
  content: "\\F10B0"; }

.mdi-download-off-outline::before {
  content: "\\F10B1"; }

.mdi-download-outline::before {
  content: "\\F0B8F"; }

.mdi-drag::before {
  content: "\\F01DB"; }

.mdi-drag-horizontal::before {
  content: "\\F01DC"; }

.mdi-drag-horizontal-variant::before {
  content: "\\F12F0"; }

.mdi-drag-variant::before {
  content: "\\F0B90"; }

.mdi-drag-vertical::before {
  content: "\\F01DD"; }

.mdi-drag-vertical-variant::before {
  content: "\\F12F1"; }

.mdi-drama-masks::before {
  content: "\\F0D02"; }

.mdi-draw::before {
  content: "\\F0F49"; }

.mdi-drawing::before {
  content: "\\F01DE"; }

.mdi-drawing-box::before {
  content: "\\F01DF"; }

.mdi-dresser::before {
  content: "\\F0F4A"; }

.mdi-dresser-outline::before {
  content: "\\F0F4B"; }

.mdi-drone::before {
  content: "\\F01E2"; }

.mdi-dropbox::before {
  content: "\\F01E3"; }

.mdi-drupal::before {
  content: "\\F01E4"; }

.mdi-duck::before {
  content: "\\F01E5"; }

.mdi-dumbbell::before {
  content: "\\F01E6"; }

.mdi-dump-truck::before {
  content: "\\F0C67"; }

.mdi-ear-hearing::before {
  content: "\\F07C5"; }

.mdi-ear-hearing-off::before {
  content: "\\F0A45"; }

.mdi-earth::before {
  content: "\\F01E7"; }

.mdi-earth-arrow-right::before {
  content: "\\F1311"; }

.mdi-earth-box::before {
  content: "\\F06CD"; }

.mdi-earth-box-minus::before {
  content: "\\F1407"; }

.mdi-earth-box-off::before {
  content: "\\F06CE"; }

.mdi-earth-box-plus::before {
  content: "\\F1406"; }

.mdi-earth-box-remove::before {
  content: "\\F1408"; }

.mdi-earth-minus::before {
  content: "\\F1404"; }

.mdi-earth-off::before {
  content: "\\F01E8"; }

.mdi-earth-plus::before {
  content: "\\F1403"; }

.mdi-earth-remove::before {
  content: "\\F1405"; }

.mdi-egg::before {
  content: "\\F0AAF"; }

.mdi-egg-easter::before {
  content: "\\F0AB0"; }

.mdi-egg-off::before {
  content: "\\F13F0"; }

.mdi-egg-off-outline::before {
  content: "\\F13F1"; }

.mdi-egg-outline::before {
  content: "\\F13F2"; }

.mdi-eiffel-tower::before {
  content: "\\F156B"; }

.mdi-eight-track::before {
  content: "\\F09EA"; }

.mdi-eject::before {
  content: "\\F01EA"; }

.mdi-eject-outline::before {
  content: "\\F0B91"; }

.mdi-electric-switch::before {
  content: "\\F0E9F"; }

.mdi-electric-switch-closed::before {
  content: "\\F10D9"; }

.mdi-electron-framework::before {
  content: "\\F1024"; }

.mdi-elephant::before {
  content: "\\F07C6"; }

.mdi-elevation-decline::before {
  content: "\\F01EB"; }

.mdi-elevation-rise::before {
  content: "\\F01EC"; }

.mdi-elevator::before {
  content: "\\F01ED"; }

.mdi-elevator-down::before {
  content: "\\F12C2"; }

.mdi-elevator-passenger::before {
  content: "\\F1381"; }

.mdi-elevator-up::before {
  content: "\\F12C1"; }

.mdi-ellipse::before {
  content: "\\F0EA0"; }

.mdi-ellipse-outline::before {
  content: "\\F0EA1"; }

.mdi-email::before {
  content: "\\F01EE"; }

.mdi-email-alert::before {
  content: "\\F06CF"; }

.mdi-email-alert-outline::before {
  content: "\\F0D42"; }

.mdi-email-box::before {
  content: "\\F0D03"; }

.mdi-email-check::before {
  content: "\\F0AB1"; }

.mdi-email-check-outline::before {
  content: "\\F0AB2"; }

.mdi-email-edit::before {
  content: "\\F0EE3"; }

.mdi-email-edit-outline::before {
  content: "\\F0EE4"; }

.mdi-email-lock::before {
  content: "\\F01F1"; }

.mdi-email-mark-as-unread::before {
  content: "\\F0B92"; }

.mdi-email-minus::before {
  content: "\\F0EE5"; }

.mdi-email-minus-outline::before {
  content: "\\F0EE6"; }

.mdi-email-multiple::before {
  content: "\\F0EE7"; }

.mdi-email-multiple-outline::before {
  content: "\\F0EE8"; }

.mdi-email-newsletter::before {
  content: "\\F0FB1"; }

.mdi-email-off::before {
  content: "\\F13E3"; }

.mdi-email-off-outline::before {
  content: "\\F13E4"; }

.mdi-email-open::before {
  content: "\\F01EF"; }

.mdi-email-open-multiple::before {
  content: "\\F0EE9"; }

.mdi-email-open-multiple-outline::before {
  content: "\\F0EEA"; }

.mdi-email-open-outline::before {
  content: "\\F05EF"; }

.mdi-email-outline::before {
  content: "\\F01F0"; }

.mdi-email-plus::before {
  content: "\\F09EB"; }

.mdi-email-plus-outline::before {
  content: "\\F09EC"; }

.mdi-email-receive::before {
  content: "\\F10DA"; }

.mdi-email-receive-outline::before {
  content: "\\F10DB"; }

.mdi-email-remove::before {
  content: "\\F1661"; }

.mdi-email-remove-outline::before {
  content: "\\F1662"; }

.mdi-email-search::before {
  content: "\\F0961"; }

.mdi-email-search-outline::before {
  content: "\\F0962"; }

.mdi-email-send::before {
  content: "\\F10DC"; }

.mdi-email-send-outline::before {
  content: "\\F10DD"; }

.mdi-email-sync::before {
  content: "\\F12C7"; }

.mdi-email-sync-outline::before {
  content: "\\F12C8"; }

.mdi-email-variant::before {
  content: "\\F05F0"; }

.mdi-ember::before {
  content: "\\F0B30"; }

.mdi-emby::before {
  content: "\\F06B4"; }

.mdi-emoticon::before {
  content: "\\F0C68"; }

.mdi-emoticon-angry::before {
  content: "\\F0C69"; }

.mdi-emoticon-angry-outline::before {
  content: "\\F0C6A"; }

.mdi-emoticon-confused::before {
  content: "\\F10DE"; }

.mdi-emoticon-confused-outline::before {
  content: "\\F10DF"; }

.mdi-emoticon-cool::before {
  content: "\\F0C6B"; }

.mdi-emoticon-cool-outline::before {
  content: "\\F01F3"; }

.mdi-emoticon-cry::before {
  content: "\\F0C6C"; }

.mdi-emoticon-cry-outline::before {
  content: "\\F0C6D"; }

.mdi-emoticon-dead::before {
  content: "\\F0C6E"; }

.mdi-emoticon-dead-outline::before {
  content: "\\F069B"; }

.mdi-emoticon-devil::before {
  content: "\\F0C6F"; }

.mdi-emoticon-devil-outline::before {
  content: "\\F01F4"; }

.mdi-emoticon-excited::before {
  content: "\\F0C70"; }

.mdi-emoticon-excited-outline::before {
  content: "\\F069C"; }

.mdi-emoticon-frown::before {
  content: "\\F0F4C"; }

.mdi-emoticon-frown-outline::before {
  content: "\\F0F4D"; }

.mdi-emoticon-happy::before {
  content: "\\F0C71"; }

.mdi-emoticon-happy-outline::before {
  content: "\\F01F5"; }

.mdi-emoticon-kiss::before {
  content: "\\F0C72"; }

.mdi-emoticon-kiss-outline::before {
  content: "\\F0C73"; }

.mdi-emoticon-lol::before {
  content: "\\F1214"; }

.mdi-emoticon-lol-outline::before {
  content: "\\F1215"; }

.mdi-emoticon-neutral::before {
  content: "\\F0C74"; }

.mdi-emoticon-neutral-outline::before {
  content: "\\F01F6"; }

.mdi-emoticon-outline::before {
  content: "\\F01F2"; }

.mdi-emoticon-poop::before {
  content: "\\F01F7"; }

.mdi-emoticon-poop-outline::before {
  content: "\\F0C75"; }

.mdi-emoticon-sad::before {
  content: "\\F0C76"; }

.mdi-emoticon-sad-outline::before {
  content: "\\F01F8"; }

.mdi-emoticon-sick::before {
  content: "\\F157C"; }

.mdi-emoticon-sick-outline::before {
  content: "\\F157D"; }

.mdi-emoticon-tongue::before {
  content: "\\F01F9"; }

.mdi-emoticon-tongue-outline::before {
  content: "\\F0C77"; }

.mdi-emoticon-wink::before {
  content: "\\F0C78"; }

.mdi-emoticon-wink-outline::before {
  content: "\\F0C79"; }

.mdi-engine::before {
  content: "\\F01FA"; }

.mdi-engine-off::before {
  content: "\\F0A46"; }

.mdi-engine-off-outline::before {
  content: "\\F0A47"; }

.mdi-engine-outline::before {
  content: "\\F01FB"; }

.mdi-epsilon::before {
  content: "\\F10E0"; }

.mdi-equal::before {
  content: "\\F01FC"; }

.mdi-equal-box::before {
  content: "\\F01FD"; }

.mdi-equalizer::before {
  content: "\\F0EA2"; }

.mdi-equalizer-outline::before {
  content: "\\F0EA3"; }

.mdi-eraser::before {
  content: "\\F01FE"; }

.mdi-eraser-variant::before {
  content: "\\F0642"; }

.mdi-escalator::before {
  content: "\\F01FF"; }

.mdi-escalator-box::before {
  content: "\\F1399"; }

.mdi-escalator-down::before {
  content: "\\F12C0"; }

.mdi-escalator-up::before {
  content: "\\F12BF"; }

.mdi-eslint::before {
  content: "\\F0C7A"; }

.mdi-et::before {
  content: "\\F0AB3"; }

.mdi-ethereum::before {
  content: "\\F086A"; }

.mdi-ethernet::before {
  content: "\\F0200"; }

.mdi-ethernet-cable::before {
  content: "\\F0201"; }

.mdi-ethernet-cable-off::before {
  content: "\\F0202"; }

.mdi-ev-plug-ccs1::before {
  content: "\\F1519"; }

.mdi-ev-plug-ccs2::before {
  content: "\\F151A"; }

.mdi-ev-plug-chademo::before {
  content: "\\F151B"; }

.mdi-ev-plug-tesla::before {
  content: "\\F151C"; }

.mdi-ev-plug-type1::before {
  content: "\\F151D"; }

.mdi-ev-plug-type2::before {
  content: "\\F151E"; }

.mdi-ev-station::before {
  content: "\\F05F1"; }

.mdi-evernote::before {
  content: "\\F0204"; }

.mdi-excavator::before {
  content: "\\F1025"; }

.mdi-exclamation::before {
  content: "\\F0205"; }

.mdi-exclamation-thick::before {
  content: "\\F1238"; }

.mdi-exit-run::before {
  content: "\\F0A48"; }

.mdi-exit-to-app::before {
  content: "\\F0206"; }

.mdi-expand-all::before {
  content: "\\F0AB4"; }

.mdi-expand-all-outline::before {
  content: "\\F0AB5"; }

.mdi-expansion-card::before {
  content: "\\F08AE"; }

.mdi-expansion-card-variant::before {
  content: "\\F0FB2"; }

.mdi-exponent::before {
  content: "\\F0963"; }

.mdi-exponent-box::before {
  content: "\\F0964"; }

.mdi-export::before {
  content: "\\F0207"; }

.mdi-export-variant::before {
  content: "\\F0B93"; }

.mdi-eye::before {
  content: "\\F0208"; }

.mdi-eye-check::before {
  content: "\\F0D04"; }

.mdi-eye-check-outline::before {
  content: "\\F0D05"; }

.mdi-eye-circle::before {
  content: "\\F0B94"; }

.mdi-eye-circle-outline::before {
  content: "\\F0B95"; }

.mdi-eye-minus::before {
  content: "\\F1026"; }

.mdi-eye-minus-outline::before {
  content: "\\F1027"; }

.mdi-eye-off::before {
  content: "\\F0209"; }

.mdi-eye-off-outline::before {
  content: "\\F06D1"; }

.mdi-eye-outline::before {
  content: "\\F06D0"; }

.mdi-eye-plus::before {
  content: "\\F086B"; }

.mdi-eye-plus-outline::before {
  content: "\\F086C"; }

.mdi-eye-remove::before {
  content: "\\F15E3"; }

.mdi-eye-remove-outline::before {
  content: "\\F15E4"; }

.mdi-eye-settings::before {
  content: "\\F086D"; }

.mdi-eye-settings-outline::before {
  content: "\\F086E"; }

.mdi-eyedropper::before {
  content: "\\F020A"; }

.mdi-eyedropper-minus::before {
  content: "\\F13DD"; }

.mdi-eyedropper-off::before {
  content: "\\F13DF"; }

.mdi-eyedropper-plus::before {
  content: "\\F13DC"; }

.mdi-eyedropper-remove::before {
  content: "\\F13DE"; }

.mdi-eyedropper-variant::before {
  content: "\\F020B"; }

.mdi-face::before {
  content: "\\F0643"; }

.mdi-face-agent::before {
  content: "\\F0D70"; }

.mdi-face-mask::before {
  content: "\\F1586"; }

.mdi-face-mask-outline::before {
  content: "\\F1587"; }

.mdi-face-outline::before {
  content: "\\F0B96"; }

.mdi-face-profile::before {
  content: "\\F0644"; }

.mdi-face-profile-woman::before {
  content: "\\F1076"; }

.mdi-face-recognition::before {
  content: "\\F0C7B"; }

.mdi-face-shimmer::before {
  content: "\\F15CC"; }

.mdi-face-shimmer-outline::before {
  content: "\\F15CD"; }

.mdi-face-woman::before {
  content: "\\F1077"; }

.mdi-face-woman-outline::before {
  content: "\\F1078"; }

.mdi-face-woman-shimmer::before {
  content: "\\F15CE"; }

.mdi-face-woman-shimmer-outline::before {
  content: "\\F15CF"; }

.mdi-facebook::before {
  content: "\\F020C"; }

.mdi-facebook-gaming::before {
  content: "\\F07DD"; }

.mdi-facebook-messenger::before {
  content: "\\F020E"; }

.mdi-facebook-workplace::before {
  content: "\\F0B31"; }

.mdi-factory::before {
  content: "\\F020F"; }

.mdi-family-tree::before {
  content: "\\F160E"; }

.mdi-fan::before {
  content: "\\F0210"; }

.mdi-fan-alert::before {
  content: "\\F146C"; }

.mdi-fan-chevron-down::before {
  content: "\\F146D"; }

.mdi-fan-chevron-up::before {
  content: "\\F146E"; }

.mdi-fan-minus::before {
  content: "\\F1470"; }

.mdi-fan-off::before {
  content: "\\F081D"; }

.mdi-fan-plus::before {
  content: "\\F146F"; }

.mdi-fan-remove::before {
  content: "\\F1471"; }

.mdi-fan-speed-1::before {
  content: "\\F1472"; }

.mdi-fan-speed-2::before {
  content: "\\F1473"; }

.mdi-fan-speed-3::before {
  content: "\\F1474"; }

.mdi-fast-forward::before {
  content: "\\F0211"; }

.mdi-fast-forward-10::before {
  content: "\\F0D71"; }

.mdi-fast-forward-30::before {
  content: "\\F0D06"; }

.mdi-fast-forward-5::before {
  content: "\\F11F8"; }

.mdi-fast-forward-60::before {
  content: "\\F160B"; }

.mdi-fast-forward-outline::before {
  content: "\\F06D2"; }

.mdi-fax::before {
  content: "\\F0212"; }

.mdi-feather::before {
  content: "\\F06D3"; }

.mdi-feature-search::before {
  content: "\\F0A49"; }

.mdi-feature-search-outline::before {
  content: "\\F0A4A"; }

.mdi-fedora::before {
  content: "\\F08DB"; }

.mdi-fencing::before {
  content: "\\F14C1"; }

.mdi-ferris-wheel::before {
  content: "\\F0EA4"; }

.mdi-ferry::before {
  content: "\\F0213"; }

.mdi-file::before {
  content: "\\F0214"; }

.mdi-file-account::before {
  content: "\\F073B"; }

.mdi-file-account-outline::before {
  content: "\\F1028"; }

.mdi-file-alert::before {
  content: "\\F0A4B"; }

.mdi-file-alert-outline::before {
  content: "\\F0A4C"; }

.mdi-file-cabinet::before {
  content: "\\F0AB6"; }

.mdi-file-cad::before {
  content: "\\F0EEB"; }

.mdi-file-cad-box::before {
  content: "\\F0EEC"; }

.mdi-file-cancel::before {
  content: "\\F0DC6"; }

.mdi-file-cancel-outline::before {
  content: "\\F0DC7"; }

.mdi-file-certificate::before {
  content: "\\F1186"; }

.mdi-file-certificate-outline::before {
  content: "\\F1187"; }

.mdi-file-chart::before {
  content: "\\F0215"; }

.mdi-file-chart-outline::before {
  content: "\\F1029"; }

.mdi-file-check::before {
  content: "\\F0216"; }

.mdi-file-check-outline::before {
  content: "\\F0E29"; }

.mdi-file-clock::before {
  content: "\\F12E1"; }

.mdi-file-clock-outline::before {
  content: "\\F12E2"; }

.mdi-file-cloud::before {
  content: "\\F0217"; }

.mdi-file-cloud-outline::before {
  content: "\\F102A"; }

.mdi-file-code::before {
  content: "\\F022E"; }

.mdi-file-code-outline::before {
  content: "\\F102B"; }

.mdi-file-cog::before {
  content: "\\F107B"; }

.mdi-file-cog-outline::before {
  content: "\\F107C"; }

.mdi-file-compare::before {
  content: "\\F08AA"; }

.mdi-file-delimited::before {
  content: "\\F0218"; }

.mdi-file-delimited-outline::before {
  content: "\\F0EA5"; }

.mdi-file-document::before {
  content: "\\F0219"; }

.mdi-file-document-edit::before {
  content: "\\F0DC8"; }

.mdi-file-document-edit-outline::before {
  content: "\\F0DC9"; }

.mdi-file-document-multiple::before {
  content: "\\F1517"; }

.mdi-file-document-multiple-outline::before {
  content: "\\F1518"; }

.mdi-file-document-outline::before {
  content: "\\F09EE"; }

.mdi-file-download::before {
  content: "\\F0965"; }

.mdi-file-download-outline::before {
  content: "\\F0966"; }

.mdi-file-edit::before {
  content: "\\F11E7"; }

.mdi-file-edit-outline::before {
  content: "\\F11E8"; }

.mdi-file-excel::before {
  content: "\\F021B"; }

.mdi-file-excel-box::before {
  content: "\\F021C"; }

.mdi-file-excel-box-outline::before {
  content: "\\F102C"; }

.mdi-file-excel-outline::before {
  content: "\\F102D"; }

.mdi-file-export::before {
  content: "\\F021D"; }

.mdi-file-export-outline::before {
  content: "\\F102E"; }

.mdi-file-eye::before {
  content: "\\F0DCA"; }

.mdi-file-eye-outline::before {
  content: "\\F0DCB"; }

.mdi-file-find::before {
  content: "\\F021E"; }

.mdi-file-find-outline::before {
  content: "\\F0B97"; }

.mdi-file-hidden::before {
  content: "\\F0613"; }

.mdi-file-image::before {
  content: "\\F021F"; }

.mdi-file-image-outline::before {
  content: "\\F0EB0"; }

.mdi-file-import::before {
  content: "\\F0220"; }

.mdi-file-import-outline::before {
  content: "\\F102F"; }

.mdi-file-key::before {
  content: "\\F1184"; }

.mdi-file-key-outline::before {
  content: "\\F1185"; }

.mdi-file-link::before {
  content: "\\F1177"; }

.mdi-file-link-outline::before {
  content: "\\F1178"; }

.mdi-file-lock::before {
  content: "\\F0221"; }

.mdi-file-lock-outline::before {
  content: "\\F1030"; }

.mdi-file-move::before {
  content: "\\F0AB9"; }

.mdi-file-move-outline::before {
  content: "\\F1031"; }

.mdi-file-multiple::before {
  content: "\\F0222"; }

.mdi-file-multiple-outline::before {
  content: "\\F1032"; }

.mdi-file-music::before {
  content: "\\F0223"; }

.mdi-file-music-outline::before {
  content: "\\F0E2A"; }

.mdi-file-outline::before {
  content: "\\F0224"; }

.mdi-file-pdf::before {
  content: "\\F0225"; }

.mdi-file-pdf-box::before {
  content: "\\F0226"; }

.mdi-file-pdf-box-outline::before {
  content: "\\F0FB3"; }

.mdi-file-pdf-outline::before {
  content: "\\F0E2D"; }

.mdi-file-percent::before {
  content: "\\F081E"; }

.mdi-file-percent-outline::before {
  content: "\\F1033"; }

.mdi-file-phone::before {
  content: "\\F1179"; }

.mdi-file-phone-outline::before {
  content: "\\F117A"; }

.mdi-file-plus::before {
  content: "\\F0752"; }

.mdi-file-plus-outline::before {
  content: "\\F0EED"; }

.mdi-file-powerpoint::before {
  content: "\\F0227"; }

.mdi-file-powerpoint-box::before {
  content: "\\F0228"; }

.mdi-file-powerpoint-box-outline::before {
  content: "\\F1034"; }

.mdi-file-powerpoint-outline::before {
  content: "\\F1035"; }

.mdi-file-presentation-box::before {
  content: "\\F0229"; }

.mdi-file-question::before {
  content: "\\F086F"; }

.mdi-file-question-outline::before {
  content: "\\F1036"; }

.mdi-file-refresh::before {
  content: "\\F0918"; }

.mdi-file-refresh-outline::before {
  content: "\\F0541"; }

.mdi-file-remove::before {
  content: "\\F0B98"; }

.mdi-file-remove-outline::before {
  content: "\\F1037"; }

.mdi-file-replace::before {
  content: "\\F0B32"; }

.mdi-file-replace-outline::before {
  content: "\\F0B33"; }

.mdi-file-restore::before {
  content: "\\F0670"; }

.mdi-file-restore-outline::before {
  content: "\\F1038"; }

.mdi-file-search::before {
  content: "\\F0C7C"; }

.mdi-file-search-outline::before {
  content: "\\F0C7D"; }

.mdi-file-send::before {
  content: "\\F022A"; }

.mdi-file-send-outline::before {
  content: "\\F1039"; }

.mdi-file-settings::before {
  content: "\\F1079"; }

.mdi-file-settings-outline::before {
  content: "\\F107A"; }

.mdi-file-star::before {
  content: "\\F103A"; }

.mdi-file-star-outline::before {
  content: "\\F103B"; }

.mdi-file-swap::before {
  content: "\\F0FB4"; }

.mdi-file-swap-outline::before {
  content: "\\F0FB5"; }

.mdi-file-sync::before {
  content: "\\F1216"; }

.mdi-file-sync-outline::before {
  content: "\\F1217"; }

.mdi-file-table::before {
  content: "\\F0C7E"; }

.mdi-file-table-box::before {
  content: "\\F10E1"; }

.mdi-file-table-box-multiple::before {
  content: "\\F10E2"; }

.mdi-file-table-box-multiple-outline::before {
  content: "\\F10E3"; }

.mdi-file-table-box-outline::before {
  content: "\\F10E4"; }

.mdi-file-table-outline::before {
  content: "\\F0C7F"; }

.mdi-file-tree::before {
  content: "\\F0645"; }

.mdi-file-tree-outline::before {
  content: "\\F13D2"; }

.mdi-file-undo::before {
  content: "\\F08DC"; }

.mdi-file-undo-outline::before {
  content: "\\F103C"; }

.mdi-file-upload::before {
  content: "\\F0A4D"; }

.mdi-file-upload-outline::before {
  content: "\\F0A4E"; }

.mdi-file-video::before {
  content: "\\F022B"; }

.mdi-file-video-outline::before {
  content: "\\F0E2C"; }

.mdi-file-word::before {
  content: "\\F022C"; }

.mdi-file-word-box::before {
  content: "\\F022D"; }

.mdi-file-word-box-outline::before {
  content: "\\F103D"; }

.mdi-file-word-outline::before {
  content: "\\F103E"; }

.mdi-film::before {
  content: "\\F022F"; }

.mdi-filmstrip::before {
  content: "\\F0230"; }

.mdi-filmstrip-box::before {
  content: "\\F0332"; }

.mdi-filmstrip-box-multiple::before {
  content: "\\F0D18"; }

.mdi-filmstrip-off::before {
  content: "\\F0231"; }

.mdi-filter::before {
  content: "\\F0232"; }

.mdi-filter-menu::before {
  content: "\\F10E5"; }

.mdi-filter-menu-outline::before {
  content: "\\F10E6"; }

.mdi-filter-minus::before {
  content: "\\F0EEE"; }

.mdi-filter-minus-outline::before {
  content: "\\F0EEF"; }

.mdi-filter-off::before {
  content: "\\F14EF"; }

.mdi-filter-off-outline::before {
  content: "\\F14F0"; }

.mdi-filter-outline::before {
  content: "\\F0233"; }

.mdi-filter-plus::before {
  content: "\\F0EF0"; }

.mdi-filter-plus-outline::before {
  content: "\\F0EF1"; }

.mdi-filter-remove::before {
  content: "\\F0234"; }

.mdi-filter-remove-outline::before {
  content: "\\F0235"; }

.mdi-filter-variant::before {
  content: "\\F0236"; }

.mdi-filter-variant-minus::before {
  content: "\\F1112"; }

.mdi-filter-variant-plus::before {
  content: "\\F1113"; }

.mdi-filter-variant-remove::before {
  content: "\\F103F"; }

.mdi-finance::before {
  content: "\\F081F"; }

.mdi-find-replace::before {
  content: "\\F06D4"; }

.mdi-fingerprint::before {
  content: "\\F0237"; }

.mdi-fingerprint-off::before {
  content: "\\F0EB1"; }

.mdi-fire::before {
  content: "\\F0238"; }

.mdi-fire-alert::before {
  content: "\\F15D7"; }

.mdi-fire-extinguisher::before {
  content: "\\F0EF2"; }

.mdi-fire-hydrant::before {
  content: "\\F1137"; }

.mdi-fire-hydrant-alert::before {
  content: "\\F1138"; }

.mdi-fire-hydrant-off::before {
  content: "\\F1139"; }

.mdi-fire-truck::before {
  content: "\\F08AB"; }

.mdi-firebase::before {
  content: "\\F0967"; }

.mdi-firefox::before {
  content: "\\F0239"; }

.mdi-fireplace::before {
  content: "\\F0E2E"; }

.mdi-fireplace-off::before {
  content: "\\F0E2F"; }

.mdi-firework::before {
  content: "\\F0E30"; }

.mdi-fish::before {
  content: "\\F023A"; }

.mdi-fish-off::before {
  content: "\\F13F3"; }

.mdi-fishbowl::before {
  content: "\\F0EF3"; }

.mdi-fishbowl-outline::before {
  content: "\\F0EF4"; }

.mdi-fit-to-page::before {
  content: "\\F0EF5"; }

.mdi-fit-to-page-outline::before {
  content: "\\F0EF6"; }

.mdi-flag::before {
  content: "\\F023B"; }

.mdi-flag-checkered::before {
  content: "\\F023C"; }

.mdi-flag-minus::before {
  content: "\\F0B99"; }

.mdi-flag-minus-outline::before {
  content: "\\F10B2"; }

.mdi-flag-outline::before {
  content: "\\F023D"; }

.mdi-flag-plus::before {
  content: "\\F0B9A"; }

.mdi-flag-plus-outline::before {
  content: "\\F10B3"; }

.mdi-flag-remove::before {
  content: "\\F0B9B"; }

.mdi-flag-remove-outline::before {
  content: "\\F10B4"; }

.mdi-flag-triangle::before {
  content: "\\F023F"; }

.mdi-flag-variant::before {
  content: "\\F0240"; }

.mdi-flag-variant-outline::before {
  content: "\\F023E"; }

.mdi-flare::before {
  content: "\\F0D72"; }

.mdi-flash::before {
  content: "\\F0241"; }

.mdi-flash-alert::before {
  content: "\\F0EF7"; }

.mdi-flash-alert-outline::before {
  content: "\\F0EF8"; }

.mdi-flash-auto::before {
  content: "\\F0242"; }

.mdi-flash-circle::before {
  content: "\\F0820"; }

.mdi-flash-off::before {
  content: "\\F0243"; }

.mdi-flash-outline::before {
  content: "\\F06D5"; }

.mdi-flash-red-eye::before {
  content: "\\F067B"; }

.mdi-flashlight::before {
  content: "\\F0244"; }

.mdi-flashlight-off::before {
  content: "\\F0245"; }

.mdi-flask::before {
  content: "\\F0093"; }

.mdi-flask-empty::before {
  content: "\\F0094"; }

.mdi-flask-empty-minus::before {
  content: "\\F123A"; }

.mdi-flask-empty-minus-outline::before {
  content: "\\F123B"; }

.mdi-flask-empty-off::before {
  content: "\\F13F4"; }

.mdi-flask-empty-off-outline::before {
  content: "\\F13F5"; }

.mdi-flask-empty-outline::before {
  content: "\\F0095"; }

.mdi-flask-empty-plus::before {
  content: "\\F123C"; }

.mdi-flask-empty-plus-outline::before {
  content: "\\F123D"; }

.mdi-flask-empty-remove::before {
  content: "\\F123E"; }

.mdi-flask-empty-remove-outline::before {
  content: "\\F123F"; }

.mdi-flask-minus::before {
  content: "\\F1240"; }

.mdi-flask-minus-outline::before {
  content: "\\F1241"; }

.mdi-flask-off::before {
  content: "\\F13F6"; }

.mdi-flask-off-outline::before {
  content: "\\F13F7"; }

.mdi-flask-outline::before {
  content: "\\F0096"; }

.mdi-flask-plus::before {
  content: "\\F1242"; }

.mdi-flask-plus-outline::before {
  content: "\\F1243"; }

.mdi-flask-remove::before {
  content: "\\F1244"; }

.mdi-flask-remove-outline::before {
  content: "\\F1245"; }

.mdi-flask-round-bottom::before {
  content: "\\F124B"; }

.mdi-flask-round-bottom-empty::before {
  content: "\\F124C"; }

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F124D"; }

.mdi-flask-round-bottom-outline::before {
  content: "\\F124E"; }

.mdi-fleur-de-lis::before {
  content: "\\F1303"; }

.mdi-flip-horizontal::before {
  content: "\\F10E7"; }

.mdi-flip-to-back::before {
  content: "\\F0247"; }

.mdi-flip-to-front::before {
  content: "\\F0248"; }

.mdi-flip-vertical::before {
  content: "\\F10E8"; }

.mdi-floor-lamp::before {
  content: "\\F08DD"; }

.mdi-floor-lamp-dual::before {
  content: "\\F1040"; }

.mdi-floor-lamp-variant::before {
  content: "\\F1041"; }

.mdi-floor-plan::before {
  content: "\\F0821"; }

.mdi-floppy::before {
  content: "\\F0249"; }

.mdi-floppy-variant::before {
  content: "\\F09EF"; }

.mdi-flower::before {
  content: "\\F024A"; }

.mdi-flower-outline::before {
  content: "\\F09F0"; }

.mdi-flower-poppy::before {
  content: "\\F0D08"; }

.mdi-flower-tulip::before {
  content: "\\F09F1"; }

.mdi-flower-tulip-outline::before {
  content: "\\F09F2"; }

.mdi-focus-auto::before {
  content: "\\F0F4E"; }

.mdi-focus-field::before {
  content: "\\F0F4F"; }

.mdi-focus-field-horizontal::before {
  content: "\\F0F50"; }

.mdi-focus-field-vertical::before {
  content: "\\F0F51"; }

.mdi-folder::before {
  content: "\\F024B"; }

.mdi-folder-account::before {
  content: "\\F024C"; }

.mdi-folder-account-outline::before {
  content: "\\F0B9C"; }

.mdi-folder-alert::before {
  content: "\\F0DCC"; }

.mdi-folder-alert-outline::before {
  content: "\\F0DCD"; }

.mdi-folder-clock::before {
  content: "\\F0ABA"; }

.mdi-folder-clock-outline::before {
  content: "\\F0ABB"; }

.mdi-folder-cog::before {
  content: "\\F107F"; }

.mdi-folder-cog-outline::before {
  content: "\\F1080"; }

.mdi-folder-download::before {
  content: "\\F024D"; }

.mdi-folder-download-outline::before {
  content: "\\F10E9"; }

.mdi-folder-edit::before {
  content: "\\F08DE"; }

.mdi-folder-edit-outline::before {
  content: "\\F0DCE"; }

.mdi-folder-google-drive::before {
  content: "\\F024E"; }

.mdi-folder-heart::before {
  content: "\\F10EA"; }

.mdi-folder-heart-outline::before {
  content: "\\F10EB"; }

.mdi-folder-home::before {
  content: "\\F10B5"; }

.mdi-folder-home-outline::before {
  content: "\\F10B6"; }

.mdi-folder-image::before {
  content: "\\F024F"; }

.mdi-folder-information::before {
  content: "\\F10B7"; }

.mdi-folder-information-outline::before {
  content: "\\F10B8"; }

.mdi-folder-key::before {
  content: "\\F08AC"; }

.mdi-folder-key-network::before {
  content: "\\F08AD"; }

.mdi-folder-key-network-outline::before {
  content: "\\F0C80"; }

.mdi-folder-key-outline::before {
  content: "\\F10EC"; }

.mdi-folder-lock::before {
  content: "\\F0250"; }

.mdi-folder-lock-open::before {
  content: "\\F0251"; }

.mdi-folder-marker::before {
  content: "\\F126D"; }

.mdi-folder-marker-outline::before {
  content: "\\F126E"; }

.mdi-folder-move::before {
  content: "\\F0252"; }

.mdi-folder-move-outline::before {
  content: "\\F1246"; }

.mdi-folder-multiple::before {
  content: "\\F0253"; }

.mdi-folder-multiple-image::before {
  content: "\\F0254"; }

.mdi-folder-multiple-outline::before {
  content: "\\F0255"; }

.mdi-folder-multiple-plus::before {
  content: "\\F147E"; }

.mdi-folder-multiple-plus-outline::before {
  content: "\\F147F"; }

.mdi-folder-music::before {
  content: "\\F1359"; }

.mdi-folder-music-outline::before {
  content: "\\F135A"; }

.mdi-folder-network::before {
  content: "\\F0870"; }

.mdi-folder-network-outline::before {
  content: "\\F0C81"; }

.mdi-folder-open::before {
  content: "\\F0770"; }

.mdi-folder-open-outline::before {
  content: "\\F0DCF"; }

.mdi-folder-outline::before {
  content: "\\F0256"; }

.mdi-folder-plus::before {
  content: "\\F0257"; }

.mdi-folder-plus-outline::before {
  content: "\\F0B9D"; }

.mdi-folder-pound::before {
  content: "\\F0D09"; }

.mdi-folder-pound-outline::before {
  content: "\\F0D0A"; }

.mdi-folder-refresh::before {
  content: "\\F0749"; }

.mdi-folder-refresh-outline::before {
  content: "\\F0542"; }

.mdi-folder-remove::before {
  content: "\\F0258"; }

.mdi-folder-remove-outline::before {
  content: "\\F0B9E"; }

.mdi-folder-search::before {
  content: "\\F0968"; }

.mdi-folder-search-outline::before {
  content: "\\F0969"; }

.mdi-folder-settings::before {
  content: "\\F107D"; }

.mdi-folder-settings-outline::before {
  content: "\\F107E"; }

.mdi-folder-star::before {
  content: "\\F069D"; }

.mdi-folder-star-multiple::before {
  content: "\\F13D3"; }

.mdi-folder-star-multiple-outline::before {
  content: "\\F13D4"; }

.mdi-folder-star-outline::before {
  content: "\\F0B9F"; }

.mdi-folder-swap::before {
  content: "\\F0FB6"; }

.mdi-folder-swap-outline::before {
  content: "\\F0FB7"; }

.mdi-folder-sync::before {
  content: "\\F0D0B"; }

.mdi-folder-sync-outline::before {
  content: "\\F0D0C"; }

.mdi-folder-table::before {
  content: "\\F12E3"; }

.mdi-folder-table-outline::before {
  content: "\\F12E4"; }

.mdi-folder-text::before {
  content: "\\F0C82"; }

.mdi-folder-text-outline::before {
  content: "\\F0C83"; }

.mdi-folder-upload::before {
  content: "\\F0259"; }

.mdi-folder-upload-outline::before {
  content: "\\F10ED"; }

.mdi-folder-zip::before {
  content: "\\F06EB"; }

.mdi-folder-zip-outline::before {
  content: "\\F07B9"; }

.mdi-font-awesome::before {
  content: "\\F003A"; }

.mdi-food::before {
  content: "\\F025A"; }

.mdi-food-apple::before {
  content: "\\F025B"; }

.mdi-food-apple-outline::before {
  content: "\\F0C84"; }

.mdi-food-croissant::before {
  content: "\\F07C8"; }

.mdi-food-drumstick::before {
  content: "\\F141F"; }

.mdi-food-drumstick-off::before {
  content: "\\F1468"; }

.mdi-food-drumstick-off-outline::before {
  content: "\\F1469"; }

.mdi-food-drumstick-outline::before {
  content: "\\F1420"; }

.mdi-food-fork-drink::before {
  content: "\\F05F2"; }

.mdi-food-halal::before {
  content: "\\F1572"; }

.mdi-food-kosher::before {
  content: "\\F1573"; }

.mdi-food-off::before {
  content: "\\F05F3"; }

.mdi-food-steak::before {
  content: "\\F146A"; }

.mdi-food-steak-off::before {
  content: "\\F146B"; }

.mdi-food-variant::before {
  content: "\\F025C"; }

.mdi-food-variant-off::before {
  content: "\\F13E5"; }

.mdi-foot-print::before {
  content: "\\F0F52"; }

.mdi-football::before {
  content: "\\F025D"; }

.mdi-football-australian::before {
  content: "\\F025E"; }

.mdi-football-helmet::before {
  content: "\\F025F"; }

.mdi-forklift::before {
  content: "\\F07C9"; }

.mdi-form-dropdown::before {
  content: "\\F1400"; }

.mdi-form-select::before {
  content: "\\F1401"; }

.mdi-form-textarea::before {
  content: "\\F1095"; }

.mdi-form-textbox::before {
  content: "\\F060E"; }

.mdi-form-textbox-lock::before {
  content: "\\F135D"; }

.mdi-form-textbox-password::before {
  content: "\\F07F5"; }

.mdi-format-align-bottom::before {
  content: "\\F0753"; }

.mdi-format-align-center::before {
  content: "\\F0260"; }

.mdi-format-align-justify::before {
  content: "\\F0261"; }

.mdi-format-align-left::before {
  content: "\\F0262"; }

.mdi-format-align-middle::before {
  content: "\\F0754"; }

.mdi-format-align-right::before {
  content: "\\F0263"; }

.mdi-format-align-top::before {
  content: "\\F0755"; }

.mdi-format-annotation-minus::before {
  content: "\\F0ABC"; }

.mdi-format-annotation-plus::before {
  content: "\\F0646"; }

.mdi-format-bold::before {
  content: "\\F0264"; }

.mdi-format-clear::before {
  content: "\\F0265"; }

.mdi-format-color-fill::before {
  content: "\\F0266"; }

.mdi-format-color-highlight::before {
  content: "\\F0E31"; }

.mdi-format-color-marker-cancel::before {
  content: "\\F1313"; }

.mdi-format-color-text::before {
  content: "\\F069E"; }

.mdi-format-columns::before {
  content: "\\F08DF"; }

.mdi-format-float-center::before {
  content: "\\F0267"; }

.mdi-format-float-left::before {
  content: "\\F0268"; }

.mdi-format-float-none::before {
  content: "\\F0269"; }

.mdi-format-float-right::before {
  content: "\\F026A"; }

.mdi-format-font::before {
  content: "\\F06D6"; }

.mdi-format-font-size-decrease::before {
  content: "\\F09F3"; }

.mdi-format-font-size-increase::before {
  content: "\\F09F4"; }

.mdi-format-header-1::before {
  content: "\\F026B"; }

.mdi-format-header-2::before {
  content: "\\F026C"; }

.mdi-format-header-3::before {
  content: "\\F026D"; }

.mdi-format-header-4::before {
  content: "\\F026E"; }

.mdi-format-header-5::before {
  content: "\\F026F"; }

.mdi-format-header-6::before {
  content: "\\F0270"; }

.mdi-format-header-decrease::before {
  content: "\\F0271"; }

.mdi-format-header-equal::before {
  content: "\\F0272"; }

.mdi-format-header-increase::before {
  content: "\\F0273"; }

.mdi-format-header-pound::before {
  content: "\\F0274"; }

.mdi-format-horizontal-align-center::before {
  content: "\\F061E"; }

.mdi-format-horizontal-align-left::before {
  content: "\\F061F"; }

.mdi-format-horizontal-align-right::before {
  content: "\\F0620"; }

.mdi-format-indent-decrease::before {
  content: "\\F0275"; }

.mdi-format-indent-increase::before {
  content: "\\F0276"; }

.mdi-format-italic::before {
  content: "\\F0277"; }

.mdi-format-letter-case::before {
  content: "\\F0B34"; }

.mdi-format-letter-case-lower::before {
  content: "\\F0B35"; }

.mdi-format-letter-case-upper::before {
  content: "\\F0B36"; }

.mdi-format-letter-ends-with::before {
  content: "\\F0FB8"; }

.mdi-format-letter-matches::before {
  content: "\\F0FB9"; }

.mdi-format-letter-starts-with::before {
  content: "\\F0FBA"; }

.mdi-format-line-spacing::before {
  content: "\\F0278"; }

.mdi-format-line-style::before {
  content: "\\F05C8"; }

.mdi-format-line-weight::before {
  content: "\\F05C9"; }

.mdi-format-list-bulleted::before {
  content: "\\F0279"; }

.mdi-format-list-bulleted-square::before {
  content: "\\F0DD0"; }

.mdi-format-list-bulleted-triangle::before {
  content: "\\F0EB2"; }

.mdi-format-list-bulleted-type::before {
  content: "\\F027A"; }

.mdi-format-list-checkbox::before {
  content: "\\F096A"; }

.mdi-format-list-checks::before {
  content: "\\F0756"; }

.mdi-format-list-numbered::before {
  content: "\\F027B"; }

.mdi-format-list-numbered-rtl::before {
  content: "\\F0D0D"; }

.mdi-format-list-text::before {
  content: "\\F126F"; }

.mdi-format-overline::before {
  content: "\\F0EB3"; }

.mdi-format-page-break::before {
  content: "\\F06D7"; }

.mdi-format-paint::before {
  content: "\\F027C"; }

.mdi-format-paragraph::before {
  content: "\\F027D"; }

.mdi-format-pilcrow::before {
  content: "\\F06D8"; }

.mdi-format-quote-close::before {
  content: "\\F027E"; }

.mdi-format-quote-close-outline::before {
  content: "\\F11A8"; }

.mdi-format-quote-open::before {
  content: "\\F0757"; }

.mdi-format-quote-open-outline::before {
  content: "\\F11A7"; }

.mdi-format-rotate-90::before {
  content: "\\F06AA"; }

.mdi-format-section::before {
  content: "\\F069F"; }

.mdi-format-size::before {
  content: "\\F027F"; }

.mdi-format-strikethrough::before {
  content: "\\F0280"; }

.mdi-format-strikethrough-variant::before {
  content: "\\F0281"; }

.mdi-format-subscript::before {
  content: "\\F0282"; }

.mdi-format-superscript::before {
  content: "\\F0283"; }

.mdi-format-text::before {
  content: "\\F0284"; }

.mdi-format-text-rotation-angle-down::before {
  content: "\\F0FBB"; }

.mdi-format-text-rotation-angle-up::before {
  content: "\\F0FBC"; }

.mdi-format-text-rotation-down::before {
  content: "\\F0D73"; }

.mdi-format-text-rotation-down-vertical::before {
  content: "\\F0FBD"; }

.mdi-format-text-rotation-none::before {
  content: "\\F0D74"; }

.mdi-format-text-rotation-up::before {
  content: "\\F0FBE"; }

.mdi-format-text-rotation-vertical::before {
  content: "\\F0FBF"; }

.mdi-format-text-variant::before {
  content: "\\F0E32"; }

.mdi-format-text-variant-outline::before {
  content: "\\F150F"; }

.mdi-format-text-wrapping-clip::before {
  content: "\\F0D0E"; }

.mdi-format-text-wrapping-overflow::before {
  content: "\\F0D0F"; }

.mdi-format-text-wrapping-wrap::before {
  content: "\\F0D10"; }

.mdi-format-textbox::before {
  content: "\\F0D11"; }

.mdi-format-textdirection-l-to-r::before {
  content: "\\F0285"; }

.mdi-format-textdirection-r-to-l::before {
  content: "\\F0286"; }

.mdi-format-title::before {
  content: "\\F05F4"; }

.mdi-format-underline::before {
  content: "\\F0287"; }

.mdi-format-vertical-align-bottom::before {
  content: "\\F0621"; }

.mdi-format-vertical-align-center::before {
  content: "\\F0622"; }

.mdi-format-vertical-align-top::before {
  content: "\\F0623"; }

.mdi-format-wrap-inline::before {
  content: "\\F0288"; }

.mdi-format-wrap-square::before {
  content: "\\F0289"; }

.mdi-format-wrap-tight::before {
  content: "\\F028A"; }

.mdi-format-wrap-top-bottom::before {
  content: "\\F028B"; }

.mdi-forum::before {
  content: "\\F028C"; }

.mdi-forum-outline::before {
  content: "\\F0822"; }

.mdi-forward::before {
  content: "\\F028D"; }

.mdi-forwardburger::before {
  content: "\\F0D75"; }

.mdi-fountain::before {
  content: "\\F096B"; }

.mdi-fountain-pen::before {
  content: "\\F0D12"; }

.mdi-fountain-pen-tip::before {
  content: "\\F0D13"; }

.mdi-freebsd::before {
  content: "\\F08E0"; }

.mdi-frequently-asked-questions::before {
  content: "\\F0EB4"; }

.mdi-fridge::before {
  content: "\\F0290"; }

.mdi-fridge-alert::before {
  content: "\\F11B1"; }

.mdi-fridge-alert-outline::before {
  content: "\\F11B2"; }

.mdi-fridge-bottom::before {
  content: "\\F0292"; }

.mdi-fridge-industrial::before {
  content: "\\F15EE"; }

.mdi-fridge-industrial-alert::before {
  content: "\\F15EF"; }

.mdi-fridge-industrial-alert-outline::before {
  content: "\\F15F0"; }

.mdi-fridge-industrial-off::before {
  content: "\\F15F1"; }

.mdi-fridge-industrial-off-outline::before {
  content: "\\F15F2"; }

.mdi-fridge-industrial-outline::before {
  content: "\\F15F3"; }

.mdi-fridge-off::before {
  content: "\\F11AF"; }

.mdi-fridge-off-outline::before {
  content: "\\F11B0"; }

.mdi-fridge-outline::before {
  content: "\\F028F"; }

.mdi-fridge-top::before {
  content: "\\F0291"; }

.mdi-fridge-variant::before {
  content: "\\F15F4"; }

.mdi-fridge-variant-alert::before {
  content: "\\F15F5"; }

.mdi-fridge-variant-alert-outline::before {
  content: "\\F15F6"; }

.mdi-fridge-variant-off::before {
  content: "\\F15F7"; }

.mdi-fridge-variant-off-outline::before {
  content: "\\F15F8"; }

.mdi-fridge-variant-outline::before {
  content: "\\F15F9"; }

.mdi-fruit-cherries::before {
  content: "\\F1042"; }

.mdi-fruit-cherries-off::before {
  content: "\\F13F8"; }

.mdi-fruit-citrus::before {
  content: "\\F1043"; }

.mdi-fruit-citrus-off::before {
  content: "\\F13F9"; }

.mdi-fruit-grapes::before {
  content: "\\F1044"; }

.mdi-fruit-grapes-outline::before {
  content: "\\F1045"; }

.mdi-fruit-pineapple::before {
  content: "\\F1046"; }

.mdi-fruit-watermelon::before {
  content: "\\F1047"; }

.mdi-fuel::before {
  content: "\\F07CA"; }

.mdi-fullscreen::before {
  content: "\\F0293"; }

.mdi-fullscreen-exit::before {
  content: "\\F0294"; }

.mdi-function::before {
  content: "\\F0295"; }

.mdi-function-variant::before {
  content: "\\F0871"; }

.mdi-furigana-horizontal::before {
  content: "\\F1081"; }

.mdi-furigana-vertical::before {
  content: "\\F1082"; }

.mdi-fuse::before {
  content: "\\F0C85"; }

.mdi-fuse-alert::before {
  content: "\\F142D"; }

.mdi-fuse-blade::before {
  content: "\\F0C86"; }

.mdi-fuse-off::before {
  content: "\\F142C"; }

.mdi-gamepad::before {
  content: "\\F0296"; }

.mdi-gamepad-circle::before {
  content: "\\F0E33"; }

.mdi-gamepad-circle-down::before {
  content: "\\F0E34"; }

.mdi-gamepad-circle-left::before {
  content: "\\F0E35"; }

.mdi-gamepad-circle-outline::before {
  content: "\\F0E36"; }

.mdi-gamepad-circle-right::before {
  content: "\\F0E37"; }

.mdi-gamepad-circle-up::before {
  content: "\\F0E38"; }

.mdi-gamepad-down::before {
  content: "\\F0E39"; }

.mdi-gamepad-left::before {
  content: "\\F0E3A"; }

.mdi-gamepad-right::before {
  content: "\\F0E3B"; }

.mdi-gamepad-round::before {
  content: "\\F0E3C"; }

.mdi-gamepad-round-down::before {
  content: "\\F0E3D"; }

.mdi-gamepad-round-left::before {
  content: "\\F0E3E"; }

.mdi-gamepad-round-outline::before {
  content: "\\F0E3F"; }

.mdi-gamepad-round-right::before {
  content: "\\F0E40"; }

.mdi-gamepad-round-up::before {
  content: "\\F0E41"; }

.mdi-gamepad-square::before {
  content: "\\F0EB5"; }

.mdi-gamepad-square-outline::before {
  content: "\\F0EB6"; }

.mdi-gamepad-up::before {
  content: "\\F0E42"; }

.mdi-gamepad-variant::before {
  content: "\\F0297"; }

.mdi-gamepad-variant-outline::before {
  content: "\\F0EB7"; }

.mdi-gamma::before {
  content: "\\F10EE"; }

.mdi-gantry-crane::before {
  content: "\\F0DD1"; }

.mdi-garage::before {
  content: "\\F06D9"; }

.mdi-garage-alert::before {
  content: "\\F0872"; }

.mdi-garage-alert-variant::before {
  content: "\\F12D5"; }

.mdi-garage-open::before {
  content: "\\F06DA"; }

.mdi-garage-open-variant::before {
  content: "\\F12D4"; }

.mdi-garage-variant::before {
  content: "\\F12D3"; }

.mdi-gas-cylinder::before {
  content: "\\F0647"; }

.mdi-gas-station::before {
  content: "\\F0298"; }

.mdi-gas-station-off::before {
  content: "\\F1409"; }

.mdi-gas-station-off-outline::before {
  content: "\\F140A"; }

.mdi-gas-station-outline::before {
  content: "\\F0EB8"; }

.mdi-gate::before {
  content: "\\F0299"; }

.mdi-gate-and::before {
  content: "\\F08E1"; }

.mdi-gate-arrow-right::before {
  content: "\\F1169"; }

.mdi-gate-nand::before {
  content: "\\F08E2"; }

.mdi-gate-nor::before {
  content: "\\F08E3"; }

.mdi-gate-not::before {
  content: "\\F08E4"; }

.mdi-gate-open::before {
  content: "\\F116A"; }

.mdi-gate-or::before {
  content: "\\F08E5"; }

.mdi-gate-xnor::before {
  content: "\\F08E6"; }

.mdi-gate-xor::before {
  content: "\\F08E7"; }

.mdi-gatsby::before {
  content: "\\F0E43"; }

.mdi-gauge::before {
  content: "\\F029A"; }

.mdi-gauge-empty::before {
  content: "\\F0873"; }

.mdi-gauge-full::before {
  content: "\\F0874"; }

.mdi-gauge-low::before {
  content: "\\F0875"; }

.mdi-gavel::before {
  content: "\\F029B"; }

.mdi-gender-female::before {
  content: "\\F029C"; }

.mdi-gender-male::before {
  content: "\\F029D"; }

.mdi-gender-male-female::before {
  content: "\\F029E"; }

.mdi-gender-male-female-variant::before {
  content: "\\F113F"; }

.mdi-gender-non-binary::before {
  content: "\\F1140"; }

.mdi-gender-transgender::before {
  content: "\\F029F"; }

.mdi-gentoo::before {
  content: "\\F08E8"; }

.mdi-gesture::before {
  content: "\\F07CB"; }

.mdi-gesture-double-tap::before {
  content: "\\F073C"; }

.mdi-gesture-pinch::before {
  content: "\\F0ABD"; }

.mdi-gesture-spread::before {
  content: "\\F0ABE"; }

.mdi-gesture-swipe::before {
  content: "\\F0D76"; }

.mdi-gesture-swipe-down::before {
  content: "\\F073D"; }

.mdi-gesture-swipe-horizontal::before {
  content: "\\F0ABF"; }

.mdi-gesture-swipe-left::before {
  content: "\\F073E"; }

.mdi-gesture-swipe-right::before {
  content: "\\F073F"; }

.mdi-gesture-swipe-up::before {
  content: "\\F0740"; }

.mdi-gesture-swipe-vertical::before {
  content: "\\F0AC0"; }

.mdi-gesture-tap::before {
  content: "\\F0741"; }

.mdi-gesture-tap-box::before {
  content: "\\F12A9"; }

.mdi-gesture-tap-button::before {
  content: "\\F12A8"; }

.mdi-gesture-tap-hold::before {
  content: "\\F0D77"; }

.mdi-gesture-two-double-tap::before {
  content: "\\F0742"; }

.mdi-gesture-two-tap::before {
  content: "\\F0743"; }

.mdi-ghost::before {
  content: "\\F02A0"; }

.mdi-ghost-off::before {
  content: "\\F09F5"; }

.mdi-ghost-off-outline::before {
  content: "\\F165C"; }

.mdi-ghost-outline::before {
  content: "\\F165D"; }

.mdi-gif::before {
  content: "\\F0D78"; }

.mdi-gift::before {
  content: "\\F0E44"; }

.mdi-gift-outline::before {
  content: "\\F02A1"; }

.mdi-git::before {
  content: "\\F02A2"; }

.mdi-github::before {
  content: "\\F02A4"; }

.mdi-gitlab::before {
  content: "\\F0BA0"; }

.mdi-glass-cocktail::before {
  content: "\\F0356"; }

.mdi-glass-cocktail-off::before {
  content: "\\F15E6"; }

.mdi-glass-flute::before {
  content: "\\F02A5"; }

.mdi-glass-mug::before {
  content: "\\F02A6"; }

.mdi-glass-mug-off::before {
  content: "\\F15E7"; }

.mdi-glass-mug-variant::before {
  content: "\\F1116"; }

.mdi-glass-mug-variant-off::before {
  content: "\\F15E8"; }

.mdi-glass-pint-outline::before {
  content: "\\F130D"; }

.mdi-glass-stange::before {
  content: "\\F02A7"; }

.mdi-glass-tulip::before {
  content: "\\F02A8"; }

.mdi-glass-wine::before {
  content: "\\F0876"; }

.mdi-glasses::before {
  content: "\\F02AA"; }

.mdi-globe-light::before {
  content: "\\F12D7"; }

.mdi-globe-model::before {
  content: "\\F08E9"; }

.mdi-gmail::before {
  content: "\\F02AB"; }

.mdi-gnome::before {
  content: "\\F02AC"; }

.mdi-go-kart::before {
  content: "\\F0D79"; }

.mdi-go-kart-track::before {
  content: "\\F0D7A"; }

.mdi-gog::before {
  content: "\\F0BA1"; }

.mdi-gold::before {
  content: "\\F124F"; }

.mdi-golf::before {
  content: "\\F0823"; }

.mdi-golf-cart::before {
  content: "\\F11A4"; }

.mdi-golf-tee::before {
  content: "\\F1083"; }

.mdi-gondola::before {
  content: "\\F0686"; }

.mdi-goodreads::before {
  content: "\\F0D7B"; }

.mdi-google::before {
  content: "\\F02AD"; }

.mdi-google-ads::before {
  content: "\\F0C87"; }

.mdi-google-analytics::before {
  content: "\\F07CC"; }

.mdi-google-assistant::before {
  content: "\\F07CD"; }

.mdi-google-cardboard::before {
  content: "\\F02AE"; }

.mdi-google-chrome::before {
  content: "\\F02AF"; }

.mdi-google-circles::before {
  content: "\\F02B0"; }

.mdi-google-circles-communities::before {
  content: "\\F02B1"; }

.mdi-google-circles-extended::before {
  content: "\\F02B2"; }

.mdi-google-circles-group::before {
  content: "\\F02B3"; }

.mdi-google-classroom::before {
  content: "\\F02C0"; }

.mdi-google-cloud::before {
  content: "\\F11F6"; }

.mdi-google-controller::before {
  content: "\\F02B4"; }

.mdi-google-controller-off::before {
  content: "\\F02B5"; }

.mdi-google-downasaur::before {
  content: "\\F1362"; }

.mdi-google-drive::before {
  content: "\\F02B6"; }

.mdi-google-earth::before {
  content: "\\F02B7"; }

.mdi-google-fit::before {
  content: "\\F096C"; }

.mdi-google-glass::before {
  content: "\\F02B8"; }

.mdi-google-hangouts::before {
  content: "\\F02C9"; }

.mdi-google-home::before {
  content: "\\F0824"; }

.mdi-google-keep::before {
  content: "\\F06DC"; }

.mdi-google-lens::before {
  content: "\\F09F6"; }

.mdi-google-maps::before {
  content: "\\F05F5"; }

.mdi-google-my-business::before {
  content: "\\F1048"; }

.mdi-google-nearby::before {
  content: "\\F02B9"; }

.mdi-google-photos::before {
  content: "\\F06DD"; }

.mdi-google-play::before {
  content: "\\F02BC"; }

.mdi-google-plus::before {
  content: "\\F02BD"; }

.mdi-google-podcast::before {
  content: "\\F0EB9"; }

.mdi-google-spreadsheet::before {
  content: "\\F09F7"; }

.mdi-google-street-view::before {
  content: "\\F0C88"; }

.mdi-google-translate::before {
  content: "\\F02BF"; }

.mdi-gradient::before {
  content: "\\F06A0"; }

.mdi-grain::before {
  content: "\\F0D7C"; }

.mdi-graph::before {
  content: "\\F1049"; }

.mdi-graph-outline::before {
  content: "\\F104A"; }

.mdi-graphql::before {
  content: "\\F0877"; }

.mdi-grass::before {
  content: "\\F1510"; }

.mdi-grave-stone::before {
  content: "\\F0BA2"; }

.mdi-grease-pencil::before {
  content: "\\F0648"; }

.mdi-greater-than::before {
  content: "\\F096D"; }

.mdi-greater-than-or-equal::before {
  content: "\\F096E"; }

.mdi-grid::before {
  content: "\\F02C1"; }

.mdi-grid-large::before {
  content: "\\F0758"; }

.mdi-grid-off::before {
  content: "\\F02C2"; }

.mdi-grill::before {
  content: "\\F0E45"; }

.mdi-grill-outline::before {
  content: "\\F118A"; }

.mdi-group::before {
  content: "\\F02C3"; }

.mdi-guitar-acoustic::before {
  content: "\\F0771"; }

.mdi-guitar-electric::before {
  content: "\\F02C4"; }

.mdi-guitar-pick::before {
  content: "\\F02C5"; }

.mdi-guitar-pick-outline::before {
  content: "\\F02C6"; }

.mdi-guy-fawkes-mask::before {
  content: "\\F0825"; }

.mdi-hail::before {
  content: "\\F0AC1"; }

.mdi-hair-dryer::before {
  content: "\\F10EF"; }

.mdi-hair-dryer-outline::before {
  content: "\\F10F0"; }

.mdi-halloween::before {
  content: "\\F0BA3"; }

.mdi-hamburger::before {
  content: "\\F0685"; }

.mdi-hammer::before {
  content: "\\F08EA"; }

.mdi-hammer-screwdriver::before {
  content: "\\F1322"; }

.mdi-hammer-wrench::before {
  content: "\\F1323"; }

.mdi-hand::before {
  content: "\\F0A4F"; }

.mdi-hand-heart::before {
  content: "\\F10F1"; }

.mdi-hand-heart-outline::before {
  content: "\\F157E"; }

.mdi-hand-left::before {
  content: "\\F0E46"; }

.mdi-hand-okay::before {
  content: "\\F0A50"; }

.mdi-hand-peace::before {
  content: "\\F0A51"; }

.mdi-hand-peace-variant::before {
  content: "\\F0A52"; }

.mdi-hand-pointing-down::before {
  content: "\\F0A53"; }

.mdi-hand-pointing-left::before {
  content: "\\F0A54"; }

.mdi-hand-pointing-right::before {
  content: "\\F02C7"; }

.mdi-hand-pointing-up::before {
  content: "\\F0A55"; }

.mdi-hand-right::before {
  content: "\\F0E47"; }

.mdi-hand-saw::before {
  content: "\\F0E48"; }

.mdi-hand-wash::before {
  content: "\\F157F"; }

.mdi-hand-wash-outline::before {
  content: "\\F1580"; }

.mdi-hand-water::before {
  content: "\\F139F"; }

.mdi-handball::before {
  content: "\\F0F53"; }

.mdi-handcuffs::before {
  content: "\\F113E"; }

.mdi-handshake::before {
  content: "\\F1218"; }

.mdi-handshake-outline::before {
  content: "\\F15A1"; }

.mdi-hanger::before {
  content: "\\F02C8"; }

.mdi-hard-hat::before {
  content: "\\F096F"; }

.mdi-harddisk::before {
  content: "\\F02CA"; }

.mdi-harddisk-plus::before {
  content: "\\F104B"; }

.mdi-harddisk-remove::before {
  content: "\\F104C"; }

.mdi-hat-fedora::before {
  content: "\\F0BA4"; }

.mdi-hazard-lights::before {
  content: "\\F0C89"; }

.mdi-hdr::before {
  content: "\\F0D7D"; }

.mdi-hdr-off::before {
  content: "\\F0D7E"; }

.mdi-head::before {
  content: "\\F135E"; }

.mdi-head-alert::before {
  content: "\\F1338"; }

.mdi-head-alert-outline::before {
  content: "\\F1339"; }

.mdi-head-check::before {
  content: "\\F133A"; }

.mdi-head-check-outline::before {
  content: "\\F133B"; }

.mdi-head-cog::before {
  content: "\\F133C"; }

.mdi-head-cog-outline::before {
  content: "\\F133D"; }

.mdi-head-dots-horizontal::before {
  content: "\\F133E"; }

.mdi-head-dots-horizontal-outline::before {
  content: "\\F133F"; }

.mdi-head-flash::before {
  content: "\\F1340"; }

.mdi-head-flash-outline::before {
  content: "\\F1341"; }

.mdi-head-heart::before {
  content: "\\F1342"; }

.mdi-head-heart-outline::before {
  content: "\\F1343"; }

.mdi-head-lightbulb::before {
  content: "\\F1344"; }

.mdi-head-lightbulb-outline::before {
  content: "\\F1345"; }

.mdi-head-minus::before {
  content: "\\F1346"; }

.mdi-head-minus-outline::before {
  content: "\\F1347"; }

.mdi-head-outline::before {
  content: "\\F135F"; }

.mdi-head-plus::before {
  content: "\\F1348"; }

.mdi-head-plus-outline::before {
  content: "\\F1349"; }

.mdi-head-question::before {
  content: "\\F134A"; }

.mdi-head-question-outline::before {
  content: "\\F134B"; }

.mdi-head-remove::before {
  content: "\\F134C"; }

.mdi-head-remove-outline::before {
  content: "\\F134D"; }

.mdi-head-snowflake::before {
  content: "\\F134E"; }

.mdi-head-snowflake-outline::before {
  content: "\\F134F"; }

.mdi-head-sync::before {
  content: "\\F1350"; }

.mdi-head-sync-outline::before {
  content: "\\F1351"; }

.mdi-headphones::before {
  content: "\\F02CB"; }

.mdi-headphones-bluetooth::before {
  content: "\\F0970"; }

.mdi-headphones-box::before {
  content: "\\F02CC"; }

.mdi-headphones-off::before {
  content: "\\F07CE"; }

.mdi-headphones-settings::before {
  content: "\\F02CD"; }

.mdi-headset::before {
  content: "\\F02CE"; }

.mdi-headset-dock::before {
  content: "\\F02CF"; }

.mdi-headset-off::before {
  content: "\\F02D0"; }

.mdi-heart::before {
  content: "\\F02D1"; }

.mdi-heart-box::before {
  content: "\\F02D2"; }

.mdi-heart-box-outline::before {
  content: "\\F02D3"; }

.mdi-heart-broken::before {
  content: "\\F02D4"; }

.mdi-heart-broken-outline::before {
  content: "\\F0D14"; }

.mdi-heart-circle::before {
  content: "\\F0971"; }

.mdi-heart-circle-outline::before {
  content: "\\F0972"; }

.mdi-heart-cog::before {
  content: "\\F1663"; }

.mdi-heart-cog-outline::before {
  content: "\\F1664"; }

.mdi-heart-flash::before {
  content: "\\F0EF9"; }

.mdi-heart-half::before {
  content: "\\F06DF"; }

.mdi-heart-half-full::before {
  content: "\\F06DE"; }

.mdi-heart-half-outline::before {
  content: "\\F06E0"; }

.mdi-heart-minus::before {
  content: "\\F142F"; }

.mdi-heart-minus-outline::before {
  content: "\\F1432"; }

.mdi-heart-multiple::before {
  content: "\\F0A56"; }

.mdi-heart-multiple-outline::before {
  content: "\\F0A57"; }

.mdi-heart-off::before {
  content: "\\F0759"; }

.mdi-heart-off-outline::before {
  content: "\\F1434"; }

.mdi-heart-outline::before {
  content: "\\F02D5"; }

.mdi-heart-plus::before {
  content: "\\F142E"; }

.mdi-heart-plus-outline::before {
  content: "\\F1431"; }

.mdi-heart-pulse::before {
  content: "\\F05F6"; }

.mdi-heart-remove::before {
  content: "\\F1430"; }

.mdi-heart-remove-outline::before {
  content: "\\F1433"; }

.mdi-heart-settings::before {
  content: "\\F1665"; }

.mdi-heart-settings-outline::before {
  content: "\\F1666"; }

.mdi-helicopter::before {
  content: "\\F0AC2"; }

.mdi-help::before {
  content: "\\F02D6"; }

.mdi-help-box::before {
  content: "\\F078B"; }

.mdi-help-circle::before {
  content: "\\F02D7"; }

.mdi-help-circle-outline::before {
  content: "\\F0625"; }

.mdi-help-network::before {
  content: "\\F06F5"; }

.mdi-help-network-outline::before {
  content: "\\F0C8A"; }

.mdi-help-rhombus::before {
  content: "\\F0BA5"; }

.mdi-help-rhombus-outline::before {
  content: "\\F0BA6"; }

.mdi-hexadecimal::before {
  content: "\\F12A7"; }

.mdi-hexagon::before {
  content: "\\F02D8"; }

.mdi-hexagon-multiple::before {
  content: "\\F06E1"; }

.mdi-hexagon-multiple-outline::before {
  content: "\\F10F2"; }

.mdi-hexagon-outline::before {
  content: "\\F02D9"; }

.mdi-hexagon-slice-1::before {
  content: "\\F0AC3"; }

.mdi-hexagon-slice-2::before {
  content: "\\F0AC4"; }

.mdi-hexagon-slice-3::before {
  content: "\\F0AC5"; }

.mdi-hexagon-slice-4::before {
  content: "\\F0AC6"; }

.mdi-hexagon-slice-5::before {
  content: "\\F0AC7"; }

.mdi-hexagon-slice-6::before {
  content: "\\F0AC8"; }

.mdi-hexagram::before {
  content: "\\F0AC9"; }

.mdi-hexagram-outline::before {
  content: "\\F0ACA"; }

.mdi-high-definition::before {
  content: "\\F07CF"; }

.mdi-high-definition-box::before {
  content: "\\F0878"; }

.mdi-highway::before {
  content: "\\F05F7"; }

.mdi-hiking::before {
  content: "\\F0D7F"; }

.mdi-hinduism::before {
  content: "\\F0973"; }

.mdi-history::before {
  content: "\\F02DA"; }

.mdi-hockey-puck::before {
  content: "\\F0879"; }

.mdi-hockey-sticks::before {
  content: "\\F087A"; }

.mdi-hololens::before {
  content: "\\F02DB"; }

.mdi-home::before {
  content: "\\F02DC"; }

.mdi-home-account::before {
  content: "\\F0826"; }

.mdi-home-alert::before {
  content: "\\F087B"; }

.mdi-home-alert-outline::before {
  content: "\\F15D0"; }

.mdi-home-analytics::before {
  content: "\\F0EBA"; }

.mdi-home-assistant::before {
  content: "\\F07D0"; }

.mdi-home-automation::before {
  content: "\\F07D1"; }

.mdi-home-circle::before {
  content: "\\F07D2"; }

.mdi-home-circle-outline::before {
  content: "\\F104D"; }

.mdi-home-city::before {
  content: "\\F0D15"; }

.mdi-home-city-outline::before {
  content: "\\F0D16"; }

.mdi-home-currency-usd::before {
  content: "\\F08AF"; }

.mdi-home-edit::before {
  content: "\\F1159"; }

.mdi-home-edit-outline::before {
  content: "\\F115A"; }

.mdi-home-export-outline::before {
  content: "\\F0F9B"; }

.mdi-home-flood::before {
  content: "\\F0EFA"; }

.mdi-home-floor-0::before {
  content: "\\F0DD2"; }

.mdi-home-floor-1::before {
  content: "\\F0D80"; }

.mdi-home-floor-2::before {
  content: "\\F0D81"; }

.mdi-home-floor-3::before {
  content: "\\F0D82"; }

.mdi-home-floor-a::before {
  content: "\\F0D83"; }

.mdi-home-floor-b::before {
  content: "\\F0D84"; }

.mdi-home-floor-g::before {
  content: "\\F0D85"; }

.mdi-home-floor-l::before {
  content: "\\F0D86"; }

.mdi-home-floor-negative-1::before {
  content: "\\F0DD3"; }

.mdi-home-group::before {
  content: "\\F0DD4"; }

.mdi-home-heart::before {
  content: "\\F0827"; }

.mdi-home-import-outline::before {
  content: "\\F0F9C"; }

.mdi-home-lightbulb::before {
  content: "\\F1251"; }

.mdi-home-lightbulb-outline::before {
  content: "\\F1252"; }

.mdi-home-lock::before {
  content: "\\F08EB"; }

.mdi-home-lock-open::before {
  content: "\\F08EC"; }

.mdi-home-map-marker::before {
  content: "\\F05F8"; }

.mdi-home-minus::before {
  content: "\\F0974"; }

.mdi-home-minus-outline::before {
  content: "\\F13D5"; }

.mdi-home-modern::before {
  content: "\\F02DD"; }

.mdi-home-outline::before {
  content: "\\F06A1"; }

.mdi-home-plus::before {
  content: "\\F0975"; }

.mdi-home-plus-outline::before {
  content: "\\F13D6"; }

.mdi-home-remove::before {
  content: "\\F1247"; }

.mdi-home-remove-outline::before {
  content: "\\F13D7"; }

.mdi-home-roof::before {
  content: "\\F112B"; }

.mdi-home-search::before {
  content: "\\F13B0"; }

.mdi-home-search-outline::before {
  content: "\\F13B1"; }

.mdi-home-thermometer::before {
  content: "\\F0F54"; }

.mdi-home-thermometer-outline::before {
  content: "\\F0F55"; }

.mdi-home-variant::before {
  content: "\\F02DE"; }

.mdi-home-variant-outline::before {
  content: "\\F0BA7"; }

.mdi-hook::before {
  content: "\\F06E2"; }

.mdi-hook-off::before {
  content: "\\F06E3"; }

.mdi-hops::before {
  content: "\\F02DF"; }

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F10F3"; }

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F10F4"; }

.mdi-horse::before {
  content: "\\F15BF"; }

.mdi-horse-human::before {
  content: "\\F15C0"; }

.mdi-horse-variant::before {
  content: "\\F15C1"; }

.mdi-horseshoe::before {
  content: "\\F0A58"; }

.mdi-hospital::before {
  content: "\\F0FF6"; }

.mdi-hospital-box::before {
  content: "\\F02E0"; }

.mdi-hospital-box-outline::before {
  content: "\\F0FF7"; }

.mdi-hospital-building::before {
  content: "\\F02E1"; }

.mdi-hospital-marker::before {
  content: "\\F02E2"; }

.mdi-hot-tub::before {
  content: "\\F0828"; }

.mdi-hours-24::before {
  content: "\\F1478"; }

.mdi-hubspot::before {
  content: "\\F0D17"; }

.mdi-hulu::before {
  content: "\\F0829"; }

.mdi-human::before {
  content: "\\F02E6"; }

.mdi-human-baby-changing-table::before {
  content: "\\F138B"; }

.mdi-human-cane::before {
  content: "\\F1581"; }

.mdi-human-capacity-decrease::before {
  content: "\\F159B"; }

.mdi-human-capacity-increase::before {
  content: "\\F159C"; }

.mdi-human-child::before {
  content: "\\F02E7"; }

.mdi-human-edit::before {
  content: "\\F14E8"; }

.mdi-human-female::before {
  content: "\\F0649"; }

.mdi-human-female-boy::before {
  content: "\\F0A59"; }

.mdi-human-female-dance::before {
  content: "\\F15C9"; }

.mdi-human-female-female::before {
  content: "\\F0A5A"; }

.mdi-human-female-girl::before {
  content: "\\F0A5B"; }

.mdi-human-greeting::before {
  content: "\\F064A"; }

.mdi-human-greeting-proximity::before {
  content: "\\F159D"; }

.mdi-human-handsdown::before {
  content: "\\F064B"; }

.mdi-human-handsup::before {
  content: "\\F064C"; }

.mdi-human-male::before {
  content: "\\F064D"; }

.mdi-human-male-boy::before {
  content: "\\F0A5C"; }

.mdi-human-male-child::before {
  content: "\\F138C"; }

.mdi-human-male-female::before {
  content: "\\F02E8"; }

.mdi-human-male-girl::before {
  content: "\\F0A5D"; }

.mdi-human-male-height::before {
  content: "\\F0EFB"; }

.mdi-human-male-height-variant::before {
  content: "\\F0EFC"; }

.mdi-human-male-male::before {
  content: "\\F0A5E"; }

.mdi-human-pregnant::before {
  content: "\\F05CF"; }

.mdi-human-queue::before {
  content: "\\F1571"; }

.mdi-human-scooter::before {
  content: "\\F11E9"; }

.mdi-human-wheelchair::before {
  content: "\\F138D"; }

.mdi-humble-bundle::before {
  content: "\\F0744"; }

.mdi-hvac::before {
  content: "\\F1352"; }

.mdi-hvac-off::before {
  content: "\\F159E"; }

.mdi-hydraulic-oil-level::before {
  content: "\\F1324"; }

.mdi-hydraulic-oil-temperature::before {
  content: "\\F1325"; }

.mdi-hydro-power::before {
  content: "\\F12E5"; }

.mdi-ice-cream::before {
  content: "\\F082A"; }

.mdi-ice-cream-off::before {
  content: "\\F0E52"; }

.mdi-ice-pop::before {
  content: "\\F0EFD"; }

.mdi-id-card::before {
  content: "\\F0FC0"; }

.mdi-identifier::before {
  content: "\\F0EFE"; }

.mdi-ideogram-cjk::before {
  content: "\\F1331"; }

.mdi-ideogram-cjk-variant::before {
  content: "\\F1332"; }

.mdi-iframe::before {
  content: "\\F0C8B"; }

.mdi-iframe-array::before {
  content: "\\F10F5"; }

.mdi-iframe-array-outline::before {
  content: "\\F10F6"; }

.mdi-iframe-braces::before {
  content: "\\F10F7"; }

.mdi-iframe-braces-outline::before {
  content: "\\F10F8"; }

.mdi-iframe-outline::before {
  content: "\\F0C8C"; }

.mdi-iframe-parentheses::before {
  content: "\\F10F9"; }

.mdi-iframe-parentheses-outline::before {
  content: "\\F10FA"; }

.mdi-iframe-variable::before {
  content: "\\F10FB"; }

.mdi-iframe-variable-outline::before {
  content: "\\F10FC"; }

.mdi-image::before {
  content: "\\F02E9"; }

.mdi-image-album::before {
  content: "\\F02EA"; }

.mdi-image-area::before {
  content: "\\F02EB"; }

.mdi-image-area-close::before {
  content: "\\F02EC"; }

.mdi-image-auto-adjust::before {
  content: "\\F0FC1"; }

.mdi-image-broken::before {
  content: "\\F02ED"; }

.mdi-image-broken-variant::before {
  content: "\\F02EE"; }

.mdi-image-edit::before {
  content: "\\F11E3"; }

.mdi-image-edit-outline::before {
  content: "\\F11E4"; }

.mdi-image-filter-black-white::before {
  content: "\\F02F0"; }

.mdi-image-filter-center-focus::before {
  content: "\\F02F1"; }

.mdi-image-filter-center-focus-strong::before {
  content: "\\F0EFF"; }

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\F0F00"; }

.mdi-image-filter-center-focus-weak::before {
  content: "\\F02F2"; }

.mdi-image-filter-drama::before {
  content: "\\F02F3"; }

.mdi-image-filter-frames::before {
  content: "\\F02F4"; }

.mdi-image-filter-hdr::before {
  content: "\\F02F5"; }

.mdi-image-filter-none::before {
  content: "\\F02F6"; }

.mdi-image-filter-tilt-shift::before {
  content: "\\F02F7"; }

.mdi-image-filter-vintage::before {
  content: "\\F02F8"; }

.mdi-image-frame::before {
  content: "\\F0E49"; }

.mdi-image-minus::before {
  content: "\\F1419"; }

.mdi-image-move::before {
  content: "\\F09F8"; }

.mdi-image-multiple::before {
  content: "\\F02F9"; }

.mdi-image-multiple-outline::before {
  content: "\\F02EF"; }

.mdi-image-off::before {
  content: "\\F082B"; }

.mdi-image-off-outline::before {
  content: "\\F11D1"; }

.mdi-image-outline::before {
  content: "\\F0976"; }

.mdi-image-plus::before {
  content: "\\F087C"; }

.mdi-image-remove::before {
  content: "\\F1418"; }

.mdi-image-search::before {
  content: "\\F0977"; }

.mdi-image-search-outline::before {
  content: "\\F0978"; }

.mdi-image-size-select-actual::before {
  content: "\\F0C8D"; }

.mdi-image-size-select-large::before {
  content: "\\F0C8E"; }

.mdi-image-size-select-small::before {
  content: "\\F0C8F"; }

.mdi-image-text::before {
  content: "\\F160D"; }

.mdi-import::before {
  content: "\\F02FA"; }

.mdi-inbox::before {
  content: "\\F0687"; }

.mdi-inbox-arrow-down::before {
  content: "\\F02FB"; }

.mdi-inbox-arrow-down-outline::before {
  content: "\\F1270"; }

.mdi-inbox-arrow-up::before {
  content: "\\F03D1"; }

.mdi-inbox-arrow-up-outline::before {
  content: "\\F1271"; }

.mdi-inbox-full::before {
  content: "\\F1272"; }

.mdi-inbox-full-outline::before {
  content: "\\F1273"; }

.mdi-inbox-multiple::before {
  content: "\\F08B0"; }

.mdi-inbox-multiple-outline::before {
  content: "\\F0BA8"; }

.mdi-inbox-outline::before {
  content: "\\F1274"; }

.mdi-inbox-remove::before {
  content: "\\F159F"; }

.mdi-inbox-remove-outline::before {
  content: "\\F15A0"; }

.mdi-incognito::before {
  content: "\\F05F9"; }

.mdi-incognito-circle::before {
  content: "\\F1421"; }

.mdi-incognito-circle-off::before {
  content: "\\F1422"; }

.mdi-incognito-off::before {
  content: "\\F0075"; }

.mdi-infinity::before {
  content: "\\F06E4"; }

.mdi-information::before {
  content: "\\F02FC"; }

.mdi-information-outline::before {
  content: "\\F02FD"; }

.mdi-information-variant::before {
  content: "\\F064E"; }

.mdi-instagram::before {
  content: "\\F02FE"; }

.mdi-instrument-triangle::before {
  content: "\\F104E"; }

.mdi-invert-colors::before {
  content: "\\F0301"; }

.mdi-invert-colors-off::before {
  content: "\\F0E4A"; }

.mdi-iobroker::before {
  content: "\\F12E8"; }

.mdi-ip::before {
  content: "\\F0A5F"; }

.mdi-ip-network::before {
  content: "\\F0A60"; }

.mdi-ip-network-outline::before {
  content: "\\F0C90"; }

.mdi-ipod::before {
  content: "\\F0C91"; }

.mdi-islam::before {
  content: "\\F0979"; }

.mdi-island::before {
  content: "\\F104F"; }

.mdi-iv-bag::before {
  content: "\\F10B9"; }

.mdi-jabber::before {
  content: "\\F0DD5"; }

.mdi-jeepney::before {
  content: "\\F0302"; }

.mdi-jellyfish::before {
  content: "\\F0F01"; }

.mdi-jellyfish-outline::before {
  content: "\\F0F02"; }

.mdi-jira::before {
  content: "\\F0303"; }

.mdi-jquery::before {
  content: "\\F087D"; }

.mdi-jsfiddle::before {
  content: "\\F0304"; }

.mdi-judaism::before {
  content: "\\F097A"; }

.mdi-jump-rope::before {
  content: "\\F12FF"; }

.mdi-kabaddi::before {
  content: "\\F0D87"; }

.mdi-kangaroo::before {
  content: "\\F1558"; }

.mdi-karate::before {
  content: "\\F082C"; }

.mdi-keg::before {
  content: "\\F0305"; }

.mdi-kettle::before {
  content: "\\F05FA"; }

.mdi-kettle-alert::before {
  content: "\\F1317"; }

.mdi-kettle-alert-outline::before {
  content: "\\F1318"; }

.mdi-kettle-off::before {
  content: "\\F131B"; }

.mdi-kettle-off-outline::before {
  content: "\\F131C"; }

.mdi-kettle-outline::before {
  content: "\\F0F56"; }

.mdi-kettle-steam::before {
  content: "\\F1319"; }

.mdi-kettle-steam-outline::before {
  content: "\\F131A"; }

.mdi-kettlebell::before {
  content: "\\F1300"; }

.mdi-key::before {
  content: "\\F0306"; }

.mdi-key-arrow-right::before {
  content: "\\F1312"; }

.mdi-key-chain::before {
  content: "\\F1574"; }

.mdi-key-chain-variant::before {
  content: "\\F1575"; }

.mdi-key-change::before {
  content: "\\F0307"; }

.mdi-key-link::before {
  content: "\\F119F"; }

.mdi-key-minus::before {
  content: "\\F0308"; }

.mdi-key-outline::before {
  content: "\\F0DD6"; }

.mdi-key-plus::before {
  content: "\\F0309"; }

.mdi-key-remove::before {
  content: "\\F030A"; }

.mdi-key-star::before {
  content: "\\F119E"; }

.mdi-key-variant::before {
  content: "\\F030B"; }

.mdi-key-wireless::before {
  content: "\\F0FC2"; }

.mdi-keyboard::before {
  content: "\\F030C"; }

.mdi-keyboard-backspace::before {
  content: "\\F030D"; }

.mdi-keyboard-caps::before {
  content: "\\F030E"; }

.mdi-keyboard-close::before {
  content: "\\F030F"; }

.mdi-keyboard-esc::before {
  content: "\\F12B7"; }

.mdi-keyboard-f1::before {
  content: "\\F12AB"; }

.mdi-keyboard-f10::before {
  content: "\\F12B4"; }

.mdi-keyboard-f11::before {
  content: "\\F12B5"; }

.mdi-keyboard-f12::before {
  content: "\\F12B6"; }

.mdi-keyboard-f2::before {
  content: "\\F12AC"; }

.mdi-keyboard-f3::before {
  content: "\\F12AD"; }

.mdi-keyboard-f4::before {
  content: "\\F12AE"; }

.mdi-keyboard-f5::before {
  content: "\\F12AF"; }

.mdi-keyboard-f6::before {
  content: "\\F12B0"; }

.mdi-keyboard-f7::before {
  content: "\\F12B1"; }

.mdi-keyboard-f8::before {
  content: "\\F12B2"; }

.mdi-keyboard-f9::before {
  content: "\\F12B3"; }

.mdi-keyboard-off::before {
  content: "\\F0310"; }

.mdi-keyboard-off-outline::before {
  content: "\\F0E4B"; }

.mdi-keyboard-outline::before {
  content: "\\F097B"; }

.mdi-keyboard-return::before {
  content: "\\F0311"; }

.mdi-keyboard-settings::before {
  content: "\\F09F9"; }

.mdi-keyboard-settings-outline::before {
  content: "\\F09FA"; }

.mdi-keyboard-space::before {
  content: "\\F1050"; }

.mdi-keyboard-tab::before {
  content: "\\F0312"; }

.mdi-keyboard-variant::before {
  content: "\\F0313"; }

.mdi-khanda::before {
  content: "\\F10FD"; }

.mdi-kickstarter::before {
  content: "\\F0745"; }

.mdi-klingon::before {
  content: "\\F135B"; }

.mdi-knife::before {
  content: "\\F09FB"; }

.mdi-knife-military::before {
  content: "\\F09FC"; }

.mdi-kodi::before {
  content: "\\F0314"; }

.mdi-kubernetes::before {
  content: "\\F10FE"; }

.mdi-label::before {
  content: "\\F0315"; }

.mdi-label-multiple::before {
  content: "\\F1375"; }

.mdi-label-multiple-outline::before {
  content: "\\F1376"; }

.mdi-label-off::before {
  content: "\\F0ACB"; }

.mdi-label-off-outline::before {
  content: "\\F0ACC"; }

.mdi-label-outline::before {
  content: "\\F0316"; }

.mdi-label-percent::before {
  content: "\\F12EA"; }

.mdi-label-percent-outline::before {
  content: "\\F12EB"; }

.mdi-label-variant::before {
  content: "\\F0ACD"; }

.mdi-label-variant-outline::before {
  content: "\\F0ACE"; }

.mdi-ladder::before {
  content: "\\F15A2"; }

.mdi-ladybug::before {
  content: "\\F082D"; }

.mdi-lambda::before {
  content: "\\F0627"; }

.mdi-lamp::before {
  content: "\\F06B5"; }

.mdi-lamps::before {
  content: "\\F1576"; }

.mdi-lan::before {
  content: "\\F0317"; }

.mdi-lan-check::before {
  content: "\\F12AA"; }

.mdi-lan-connect::before {
  content: "\\F0318"; }

.mdi-lan-disconnect::before {
  content: "\\F0319"; }

.mdi-lan-pending::before {
  content: "\\F031A"; }

.mdi-language-c::before {
  content: "\\F0671"; }

.mdi-language-cpp::before {
  content: "\\F0672"; }

.mdi-language-csharp::before {
  content: "\\F031B"; }

.mdi-language-css3::before {
  content: "\\F031C"; }

.mdi-language-fortran::before {
  content: "\\F121A"; }

.mdi-language-go::before {
  content: "\\F07D3"; }

.mdi-language-haskell::before {
  content: "\\F0C92"; }

.mdi-language-html5::before {
  content: "\\F031D"; }

.mdi-language-java::before {
  content: "\\F0B37"; }

.mdi-language-javascript::before {
  content: "\\F031E"; }

.mdi-language-kotlin::before {
  content: "\\F1219"; }

.mdi-language-lua::before {
  content: "\\F08B1"; }

.mdi-language-markdown::before {
  content: "\\F0354"; }

.mdi-language-markdown-outline::before {
  content: "\\F0F5B"; }

.mdi-language-php::before {
  content: "\\F031F"; }

.mdi-language-python::before {
  content: "\\F0320"; }

.mdi-language-r::before {
  content: "\\F07D4"; }

.mdi-language-ruby::before {
  content: "\\F0D2D"; }

.mdi-language-ruby-on-rails::before {
  content: "\\F0ACF"; }

.mdi-language-rust::before {
  content: "\\F1617"; }

.mdi-language-swift::before {
  content: "\\F06E5"; }

.mdi-language-typescript::before {
  content: "\\F06E6"; }

.mdi-language-xaml::before {
  content: "\\F0673"; }

.mdi-laptop::before {
  content: "\\F0322"; }

.mdi-laptop-chromebook::before {
  content: "\\F0323"; }

.mdi-laptop-mac::before {
  content: "\\F0324"; }

.mdi-laptop-off::before {
  content: "\\F06E7"; }

.mdi-laptop-windows::before {
  content: "\\F0325"; }

.mdi-laravel::before {
  content: "\\F0AD0"; }

.mdi-laser-pointer::before {
  content: "\\F1484"; }

.mdi-lasso::before {
  content: "\\F0F03"; }

.mdi-lastpass::before {
  content: "\\F0446"; }

.mdi-latitude::before {
  content: "\\F0F57"; }

.mdi-launch::before {
  content: "\\F0327"; }

.mdi-lava-lamp::before {
  content: "\\F07D5"; }

.mdi-layers::before {
  content: "\\F0328"; }

.mdi-layers-minus::before {
  content: "\\F0E4C"; }

.mdi-layers-off::before {
  content: "\\F0329"; }

.mdi-layers-off-outline::before {
  content: "\\F09FD"; }

.mdi-layers-outline::before {
  content: "\\F09FE"; }

.mdi-layers-plus::before {
  content: "\\F0E4D"; }

.mdi-layers-remove::before {
  content: "\\F0E4E"; }

.mdi-layers-search::before {
  content: "\\F1206"; }

.mdi-layers-search-outline::before {
  content: "\\F1207"; }

.mdi-layers-triple::before {
  content: "\\F0F58"; }

.mdi-layers-triple-outline::before {
  content: "\\F0F59"; }

.mdi-lead-pencil::before {
  content: "\\F064F"; }

.mdi-leaf::before {
  content: "\\F032A"; }

.mdi-leaf-maple::before {
  content: "\\F0C93"; }

.mdi-leaf-maple-off::before {
  content: "\\F12DA"; }

.mdi-leaf-off::before {
  content: "\\F12D9"; }

.mdi-leak::before {
  content: "\\F0DD7"; }

.mdi-leak-off::before {
  content: "\\F0DD8"; }

.mdi-led-off::before {
  content: "\\F032B"; }

.mdi-led-on::before {
  content: "\\F032C"; }

.mdi-led-outline::before {
  content: "\\F032D"; }

.mdi-led-strip::before {
  content: "\\F07D6"; }

.mdi-led-strip-variant::before {
  content: "\\F1051"; }

.mdi-led-variant-off::before {
  content: "\\F032E"; }

.mdi-led-variant-on::before {
  content: "\\F032F"; }

.mdi-led-variant-outline::before {
  content: "\\F0330"; }

.mdi-leek::before {
  content: "\\F117D"; }

.mdi-less-than::before {
  content: "\\F097C"; }

.mdi-less-than-or-equal::before {
  content: "\\F097D"; }

.mdi-library::before {
  content: "\\F0331"; }

.mdi-library-shelves::before {
  content: "\\F0BA9"; }

.mdi-license::before {
  content: "\\F0FC3"; }

.mdi-lifebuoy::before {
  content: "\\F087E"; }

.mdi-light-switch::before {
  content: "\\F097E"; }

.mdi-lightbulb::before {
  content: "\\F0335"; }

.mdi-lightbulb-cfl::before {
  content: "\\F1208"; }

.mdi-lightbulb-cfl-off::before {
  content: "\\F1209"; }

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F1275"; }

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F12C3"; }

.mdi-lightbulb-group::before {
  content: "\\F1253"; }

.mdi-lightbulb-group-off::before {
  content: "\\F12CD"; }

.mdi-lightbulb-group-off-outline::before {
  content: "\\F12CE"; }

.mdi-lightbulb-group-outline::before {
  content: "\\F1254"; }

.mdi-lightbulb-multiple::before {
  content: "\\F1255"; }

.mdi-lightbulb-multiple-off::before {
  content: "\\F12CF"; }

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F12D0"; }

.mdi-lightbulb-multiple-outline::before {
  content: "\\F1256"; }

.mdi-lightbulb-off::before {
  content: "\\F0E4F"; }

.mdi-lightbulb-off-outline::before {
  content: "\\F0E50"; }

.mdi-lightbulb-on::before {
  content: "\\F06E8"; }

.mdi-lightbulb-on-outline::before {
  content: "\\F06E9"; }

.mdi-lightbulb-outline::before {
  content: "\\F0336"; }

.mdi-lighthouse::before {
  content: "\\F09FF"; }

.mdi-lighthouse-on::before {
  content: "\\F0A00"; }

.mdi-lightning-bolt::before {
  content: "\\F140B"; }

.mdi-lightning-bolt-outline::before {
  content: "\\F140C"; }

.mdi-lingerie::before {
  content: "\\F1476"; }

.mdi-link::before {
  content: "\\F0337"; }

.mdi-link-box::before {
  content: "\\F0D1A"; }

.mdi-link-box-outline::before {
  content: "\\F0D1B"; }

.mdi-link-box-variant::before {
  content: "\\F0D1C"; }

.mdi-link-box-variant-outline::before {
  content: "\\F0D1D"; }

.mdi-link-lock::before {
  content: "\\F10BA"; }

.mdi-link-off::before {
  content: "\\F0338"; }

.mdi-link-plus::before {
  content: "\\F0C94"; }

.mdi-link-variant::before {
  content: "\\F0339"; }

.mdi-link-variant-minus::before {
  content: "\\F10FF"; }

.mdi-link-variant-off::before {
  content: "\\F033A"; }

.mdi-link-variant-plus::before {
  content: "\\F1100"; }

.mdi-link-variant-remove::before {
  content: "\\F1101"; }

.mdi-linkedin::before {
  content: "\\F033B"; }

.mdi-linux::before {
  content: "\\F033D"; }

.mdi-linux-mint::before {
  content: "\\F08ED"; }

.mdi-lipstick::before {
  content: "\\F13B5"; }

.mdi-list-status::before {
  content: "\\F15AB"; }

.mdi-litecoin::before {
  content: "\\F0A61"; }

.mdi-loading::before {
  content: "\\F0772"; }

.mdi-location-enter::before {
  content: "\\F0FC4"; }

.mdi-location-exit::before {
  content: "\\F0FC5"; }

.mdi-lock::before {
  content: "\\F033E"; }

.mdi-lock-alert::before {
  content: "\\F08EE"; }

.mdi-lock-alert-outline::before {
  content: "\\F15D1"; }

.mdi-lock-check::before {
  content: "\\F139A"; }

.mdi-lock-check-outline::before {
  content: "\\F16A8"; }

.mdi-lock-clock::before {
  content: "\\F097F"; }

.mdi-lock-minus::before {
  content: "\\F16A9"; }

.mdi-lock-minus-outline::before {
  content: "\\F16AA"; }

.mdi-lock-off::before {
  content: "\\F1671"; }

.mdi-lock-off-outline::before {
  content: "\\F1672"; }

.mdi-lock-open::before {
  content: "\\F033F"; }

.mdi-lock-open-alert::before {
  content: "\\F139B"; }

.mdi-lock-open-alert-outline::before {
  content: "\\F15D2"; }

.mdi-lock-open-check::before {
  content: "\\F139C"; }

.mdi-lock-open-check-outline::before {
  content: "\\F16AB"; }

.mdi-lock-open-minus::before {
  content: "\\F16AC"; }

.mdi-lock-open-minus-outline::before {
  content: "\\F16AD"; }

.mdi-lock-open-outline::before {
  content: "\\F0340"; }

.mdi-lock-open-plus::before {
  content: "\\F16AE"; }

.mdi-lock-open-plus-outline::before {
  content: "\\F16AF"; }

.mdi-lock-open-remove::before {
  content: "\\F16B0"; }

.mdi-lock-open-remove-outline::before {
  content: "\\F16B1"; }

.mdi-lock-open-variant::before {
  content: "\\F0FC6"; }

.mdi-lock-open-variant-outline::before {
  content: "\\F0FC7"; }

.mdi-lock-outline::before {
  content: "\\F0341"; }

.mdi-lock-pattern::before {
  content: "\\F06EA"; }

.mdi-lock-plus::before {
  content: "\\F05FB"; }

.mdi-lock-plus-outline::before {
  content: "\\F16B2"; }

.mdi-lock-question::before {
  content: "\\F08EF"; }

.mdi-lock-remove::before {
  content: "\\F16B3"; }

.mdi-lock-remove-outline::before {
  content: "\\F16B4"; }

.mdi-lock-reset::before {
  content: "\\F0773"; }

.mdi-lock-smart::before {
  content: "\\F08B2"; }

.mdi-locker::before {
  content: "\\F07D7"; }

.mdi-locker-multiple::before {
  content: "\\F07D8"; }

.mdi-login::before {
  content: "\\F0342"; }

.mdi-login-variant::before {
  content: "\\F05FC"; }

.mdi-logout::before {
  content: "\\F0343"; }

.mdi-logout-variant::before {
  content: "\\F05FD"; }

.mdi-longitude::before {
  content: "\\F0F5A"; }

.mdi-looks::before {
  content: "\\F0344"; }

.mdi-lotion::before {
  content: "\\F1582"; }

.mdi-lotion-outline::before {
  content: "\\F1583"; }

.mdi-lotion-plus::before {
  content: "\\F1584"; }

.mdi-lotion-plus-outline::before {
  content: "\\F1585"; }

.mdi-loupe::before {
  content: "\\F0345"; }

.mdi-lumx::before {
  content: "\\F0346"; }

.mdi-lungs::before {
  content: "\\F1084"; }

.mdi-magnet::before {
  content: "\\F0347"; }

.mdi-magnet-on::before {
  content: "\\F0348"; }

.mdi-magnify::before {
  content: "\\F0349"; }

.mdi-magnify-close::before {
  content: "\\F0980"; }

.mdi-magnify-minus::before {
  content: "\\F034A"; }

.mdi-magnify-minus-cursor::before {
  content: "\\F0A62"; }

.mdi-magnify-minus-outline::before {
  content: "\\F06EC"; }

.mdi-magnify-plus::before {
  content: "\\F034B"; }

.mdi-magnify-plus-cursor::before {
  content: "\\F0A63"; }

.mdi-magnify-plus-outline::before {
  content: "\\F06ED"; }

.mdi-magnify-remove-cursor::before {
  content: "\\F120C"; }

.mdi-magnify-remove-outline::before {
  content: "\\F120D"; }

.mdi-magnify-scan::before {
  content: "\\F1276"; }

.mdi-mail::before {
  content: "\\F0EBB"; }

.mdi-mailbox::before {
  content: "\\F06EE"; }

.mdi-mailbox-open::before {
  content: "\\F0D88"; }

.mdi-mailbox-open-outline::before {
  content: "\\F0D89"; }

.mdi-mailbox-open-up::before {
  content: "\\F0D8A"; }

.mdi-mailbox-open-up-outline::before {
  content: "\\F0D8B"; }

.mdi-mailbox-outline::before {
  content: "\\F0D8C"; }

.mdi-mailbox-up::before {
  content: "\\F0D8D"; }

.mdi-mailbox-up-outline::before {
  content: "\\F0D8E"; }

.mdi-manjaro::before {
  content: "\\F160A"; }

.mdi-map::before {
  content: "\\F034D"; }

.mdi-map-check::before {
  content: "\\F0EBC"; }

.mdi-map-check-outline::before {
  content: "\\F0EBD"; }

.mdi-map-clock::before {
  content: "\\F0D1E"; }

.mdi-map-clock-outline::before {
  content: "\\F0D1F"; }

.mdi-map-legend::before {
  content: "\\F0A01"; }

.mdi-map-marker::before {
  content: "\\F034E"; }

.mdi-map-marker-alert::before {
  content: "\\F0F05"; }

.mdi-map-marker-alert-outline::before {
  content: "\\F0F06"; }

.mdi-map-marker-check::before {
  content: "\\F0C95"; }

.mdi-map-marker-check-outline::before {
  content: "\\F12FB"; }

.mdi-map-marker-circle::before {
  content: "\\F034F"; }

.mdi-map-marker-distance::before {
  content: "\\F08F0"; }

.mdi-map-marker-down::before {
  content: "\\F1102"; }

.mdi-map-marker-left::before {
  content: "\\F12DB"; }

.mdi-map-marker-left-outline::before {
  content: "\\F12DD"; }

.mdi-map-marker-minus::before {
  content: "\\F0650"; }

.mdi-map-marker-minus-outline::before {
  content: "\\F12F9"; }

.mdi-map-marker-multiple::before {
  content: "\\F0350"; }

.mdi-map-marker-multiple-outline::before {
  content: "\\F1277"; }

.mdi-map-marker-off::before {
  content: "\\F0351"; }

.mdi-map-marker-off-outline::before {
  content: "\\F12FD"; }

.mdi-map-marker-outline::before {
  content: "\\F07D9"; }

.mdi-map-marker-path::before {
  content: "\\F0D20"; }

.mdi-map-marker-plus::before {
  content: "\\F0651"; }

.mdi-map-marker-plus-outline::before {
  content: "\\F12F8"; }

.mdi-map-marker-question::before {
  content: "\\F0F07"; }

.mdi-map-marker-question-outline::before {
  content: "\\F0F08"; }

.mdi-map-marker-radius::before {
  content: "\\F0352"; }

.mdi-map-marker-radius-outline::before {
  content: "\\F12FC"; }

.mdi-map-marker-remove::before {
  content: "\\F0F09"; }

.mdi-map-marker-remove-outline::before {
  content: "\\F12FA"; }

.mdi-map-marker-remove-variant::before {
  content: "\\F0F0A"; }

.mdi-map-marker-right::before {
  content: "\\F12DC"; }

.mdi-map-marker-right-outline::before {
  content: "\\F12DE"; }

.mdi-map-marker-star::before {
  content: "\\F1608"; }

.mdi-map-marker-star-outline::before {
  content: "\\F1609"; }

.mdi-map-marker-up::before {
  content: "\\F1103"; }

.mdi-map-minus::before {
  content: "\\F0981"; }

.mdi-map-outline::before {
  content: "\\F0982"; }

.mdi-map-plus::before {
  content: "\\F0983"; }

.mdi-map-search::before {
  content: "\\F0984"; }

.mdi-map-search-outline::before {
  content: "\\F0985"; }

.mdi-mapbox::before {
  content: "\\F0BAA"; }

.mdi-margin::before {
  content: "\\F0353"; }

.mdi-marker::before {
  content: "\\F0652"; }

.mdi-marker-cancel::before {
  content: "\\F0DD9"; }

.mdi-marker-check::before {
  content: "\\F0355"; }

.mdi-mastodon::before {
  content: "\\F0AD1"; }

.mdi-material-design::before {
  content: "\\F0986"; }

.mdi-material-ui::before {
  content: "\\F0357"; }

.mdi-math-compass::before {
  content: "\\F0358"; }

.mdi-math-cos::before {
  content: "\\F0C96"; }

.mdi-math-integral::before {
  content: "\\F0FC8"; }

.mdi-math-integral-box::before {
  content: "\\F0FC9"; }

.mdi-math-log::before {
  content: "\\F1085"; }

.mdi-math-norm::before {
  content: "\\F0FCA"; }

.mdi-math-norm-box::before {
  content: "\\F0FCB"; }

.mdi-math-sin::before {
  content: "\\F0C97"; }

.mdi-math-tan::before {
  content: "\\F0C98"; }

.mdi-matrix::before {
  content: "\\F0628"; }

.mdi-medal::before {
  content: "\\F0987"; }

.mdi-medal-outline::before {
  content: "\\F1326"; }

.mdi-medical-bag::before {
  content: "\\F06EF"; }

.mdi-meditation::before {
  content: "\\F117B"; }

.mdi-memory::before {
  content: "\\F035B"; }

.mdi-menu::before {
  content: "\\F035C"; }

.mdi-menu-down::before {
  content: "\\F035D"; }

.mdi-menu-down-outline::before {
  content: "\\F06B6"; }

.mdi-menu-left::before {
  content: "\\F035E"; }

.mdi-menu-left-outline::before {
  content: "\\F0A02"; }

.mdi-menu-open::before {
  content: "\\F0BAB"; }

.mdi-menu-right::before {
  content: "\\F035F"; }

.mdi-menu-right-outline::before {
  content: "\\F0A03"; }

.mdi-menu-swap::before {
  content: "\\F0A64"; }

.mdi-menu-swap-outline::before {
  content: "\\F0A65"; }

.mdi-menu-up::before {
  content: "\\F0360"; }

.mdi-menu-up-outline::before {
  content: "\\F06B7"; }

.mdi-merge::before {
  content: "\\F0F5C"; }

.mdi-message::before {
  content: "\\F0361"; }

.mdi-message-alert::before {
  content: "\\F0362"; }

.mdi-message-alert-outline::before {
  content: "\\F0A04"; }

.mdi-message-arrow-left::before {
  content: "\\F12F2"; }

.mdi-message-arrow-left-outline::before {
  content: "\\F12F3"; }

.mdi-message-arrow-right::before {
  content: "\\F12F4"; }

.mdi-message-arrow-right-outline::before {
  content: "\\F12F5"; }

.mdi-message-bookmark::before {
  content: "\\F15AC"; }

.mdi-message-bookmark-outline::before {
  content: "\\F15AD"; }

.mdi-message-bulleted::before {
  content: "\\F06A2"; }

.mdi-message-bulleted-off::before {
  content: "\\F06A3"; }

.mdi-message-cog::before {
  content: "\\F06F1"; }

.mdi-message-cog-outline::before {
  content: "\\F1172"; }

.mdi-message-draw::before {
  content: "\\F0363"; }

.mdi-message-flash::before {
  content: "\\F15A9"; }

.mdi-message-flash-outline::before {
  content: "\\F15AA"; }

.mdi-message-image::before {
  content: "\\F0364"; }

.mdi-message-image-outline::before {
  content: "\\F116C"; }

.mdi-message-lock::before {
  content: "\\F0FCC"; }

.mdi-message-lock-outline::before {
  content: "\\F116D"; }

.mdi-message-minus::before {
  content: "\\F116E"; }

.mdi-message-minus-outline::before {
  content: "\\F116F"; }

.mdi-message-off::before {
  content: "\\F164D"; }

.mdi-message-off-outline::before {
  content: "\\F164E"; }

.mdi-message-outline::before {
  content: "\\F0365"; }

.mdi-message-plus::before {
  content: "\\F0653"; }

.mdi-message-plus-outline::before {
  content: "\\F10BB"; }

.mdi-message-processing::before {
  content: "\\F0366"; }

.mdi-message-processing-outline::before {
  content: "\\F1170"; }

.mdi-message-reply::before {
  content: "\\F0367"; }

.mdi-message-reply-text::before {
  content: "\\F0368"; }

.mdi-message-settings::before {
  content: "\\F06F0"; }

.mdi-message-settings-outline::before {
  content: "\\F1171"; }

.mdi-message-text::before {
  content: "\\F0369"; }

.mdi-message-text-clock::before {
  content: "\\F1173"; }

.mdi-message-text-clock-outline::before {
  content: "\\F1174"; }

.mdi-message-text-lock::before {
  content: "\\F0FCD"; }

.mdi-message-text-lock-outline::before {
  content: "\\F1175"; }

.mdi-message-text-outline::before {
  content: "\\F036A"; }

.mdi-message-video::before {
  content: "\\F036B"; }

.mdi-meteor::before {
  content: "\\F0629"; }

.mdi-metronome::before {
  content: "\\F07DA"; }

.mdi-metronome-tick::before {
  content: "\\F07DB"; }

.mdi-micro-sd::before {
  content: "\\F07DC"; }

.mdi-microphone::before {
  content: "\\F036C"; }

.mdi-microphone-minus::before {
  content: "\\F08B3"; }

.mdi-microphone-off::before {
  content: "\\F036D"; }

.mdi-microphone-outline::before {
  content: "\\F036E"; }

.mdi-microphone-plus::before {
  content: "\\F08B4"; }

.mdi-microphone-settings::before {
  content: "\\F036F"; }

.mdi-microphone-variant::before {
  content: "\\F0370"; }

.mdi-microphone-variant-off::before {
  content: "\\F0371"; }

.mdi-microscope::before {
  content: "\\F0654"; }

.mdi-microsoft::before {
  content: "\\F0372"; }

.mdi-microsoft-access::before {
  content: "\\F138E"; }

.mdi-microsoft-azure::before {
  content: "\\F0805"; }

.mdi-microsoft-azure-devops::before {
  content: "\\F0FD5"; }

.mdi-microsoft-bing::before {
  content: "\\F00A4"; }

.mdi-microsoft-dynamics-365::before {
  content: "\\F0988"; }

.mdi-microsoft-edge::before {
  content: "\\F01E9"; }

.mdi-microsoft-edge-legacy::before {
  content: "\\F1250"; }

.mdi-microsoft-excel::before {
  content: "\\F138F"; }

.mdi-microsoft-internet-explorer::before {
  content: "\\F0300"; }

.mdi-microsoft-office::before {
  content: "\\F03C6"; }

.mdi-microsoft-onedrive::before {
  content: "\\F03CA"; }

.mdi-microsoft-onenote::before {
  content: "\\F0747"; }

.mdi-microsoft-outlook::before {
  content: "\\F0D22"; }

.mdi-microsoft-powerpoint::before {
  content: "\\F1390"; }

.mdi-microsoft-sharepoint::before {
  content: "\\F1391"; }

.mdi-microsoft-teams::before {
  content: "\\F02BB"; }

.mdi-microsoft-visual-studio::before {
  content: "\\F0610"; }

.mdi-microsoft-visual-studio-code::before {
  content: "\\F0A1E"; }

.mdi-microsoft-windows::before {
  content: "\\F05B3"; }

.mdi-microsoft-windows-classic::before {
  content: "\\F0A21"; }

.mdi-microsoft-word::before {
  content: "\\F1392"; }

.mdi-microsoft-xbox::before {
  content: "\\F05B9"; }

.mdi-microsoft-xbox-controller::before {
  content: "\\F05BA"; }

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\F074B"; }

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\F0A22"; }

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\F074C"; }

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\F074D"; }

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\F074E"; }

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\F074F"; }

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\F0750"; }

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\F0E6F"; }

.mdi-microsoft-xbox-controller-off::before {
  content: "\\F05BB"; }

.mdi-microsoft-xbox-controller-view::before {
  content: "\\F0E70"; }

.mdi-microsoft-yammer::before {
  content: "\\F0789"; }

.mdi-microwave::before {
  content: "\\F0C99"; }

.mdi-microwave-off::before {
  content: "\\F1423"; }

.mdi-middleware::before {
  content: "\\F0F5D"; }

.mdi-middleware-outline::before {
  content: "\\F0F5E"; }

.mdi-midi::before {
  content: "\\F08F1"; }

.mdi-midi-port::before {
  content: "\\F08F2"; }

.mdi-mine::before {
  content: "\\F0DDA"; }

.mdi-minecraft::before {
  content: "\\F0373"; }

.mdi-mini-sd::before {
  content: "\\F0A05"; }

.mdi-minidisc::before {
  content: "\\F0A06"; }

.mdi-minus::before {
  content: "\\F0374"; }

.mdi-minus-box::before {
  content: "\\F0375"; }

.mdi-minus-box-multiple::before {
  content: "\\F1141"; }

.mdi-minus-box-multiple-outline::before {
  content: "\\F1142"; }

.mdi-minus-box-outline::before {
  content: "\\F06F2"; }

.mdi-minus-circle::before {
  content: "\\F0376"; }

.mdi-minus-circle-multiple::before {
  content: "\\F035A"; }

.mdi-minus-circle-multiple-outline::before {
  content: "\\F0AD3"; }

.mdi-minus-circle-off::before {
  content: "\\F1459"; }

.mdi-minus-circle-off-outline::before {
  content: "\\F145A"; }

.mdi-minus-circle-outline::before {
  content: "\\F0377"; }

.mdi-minus-network::before {
  content: "\\F0378"; }

.mdi-minus-network-outline::before {
  content: "\\F0C9A"; }

.mdi-minus-thick::before {
  content: "\\F1639"; }

.mdi-mirror::before {
  content: "\\F11FD"; }

.mdi-mixed-martial-arts::before {
  content: "\\F0D8F"; }

.mdi-mixed-reality::before {
  content: "\\F087F"; }

.mdi-molecule::before {
  content: "\\F0BAC"; }

.mdi-molecule-co::before {
  content: "\\F12FE"; }

.mdi-molecule-co2::before {
  content: "\\F07E4"; }

.mdi-monitor::before {
  content: "\\F0379"; }

.mdi-monitor-cellphone::before {
  content: "\\F0989"; }

.mdi-monitor-cellphone-star::before {
  content: "\\F098A"; }

.mdi-monitor-clean::before {
  content: "\\F1104"; }

.mdi-monitor-dashboard::before {
  content: "\\F0A07"; }

.mdi-monitor-edit::before {
  content: "\\F12C6"; }

.mdi-monitor-eye::before {
  content: "\\F13B4"; }

.mdi-monitor-lock::before {
  content: "\\F0DDB"; }

.mdi-monitor-multiple::before {
  content: "\\F037A"; }

.mdi-monitor-off::before {
  content: "\\F0D90"; }

.mdi-monitor-screenshot::before {
  content: "\\F0E51"; }

.mdi-monitor-share::before {
  content: "\\F1483"; }

.mdi-monitor-speaker::before {
  content: "\\F0F5F"; }

.mdi-monitor-speaker-off::before {
  content: "\\F0F60"; }

.mdi-monitor-star::before {
  content: "\\F0DDC"; }

.mdi-moon-first-quarter::before {
  content: "\\F0F61"; }

.mdi-moon-full::before {
  content: "\\F0F62"; }

.mdi-moon-last-quarter::before {
  content: "\\F0F63"; }

.mdi-moon-new::before {
  content: "\\F0F64"; }

.mdi-moon-waning-crescent::before {
  content: "\\F0F65"; }

.mdi-moon-waning-gibbous::before {
  content: "\\F0F66"; }

.mdi-moon-waxing-crescent::before {
  content: "\\F0F67"; }

.mdi-moon-waxing-gibbous::before {
  content: "\\F0F68"; }

.mdi-moped::before {
  content: "\\F1086"; }

.mdi-moped-electric::before {
  content: "\\F15B7"; }

.mdi-moped-electric-outline::before {
  content: "\\F15B8"; }

.mdi-moped-outline::before {
  content: "\\F15B9"; }

.mdi-more::before {
  content: "\\F037B"; }

.mdi-mother-heart::before {
  content: "\\F1314"; }

.mdi-mother-nurse::before {
  content: "\\F0D21"; }

.mdi-motion::before {
  content: "\\F15B2"; }

.mdi-motion-outline::before {
  content: "\\F15B3"; }

.mdi-motion-pause::before {
  content: "\\F1590"; }

.mdi-motion-pause-outline::before {
  content: "\\F1592"; }

.mdi-motion-play::before {
  content: "\\F158F"; }

.mdi-motion-play-outline::before {
  content: "\\F1591"; }

.mdi-motion-sensor::before {
  content: "\\F0D91"; }

.mdi-motion-sensor-off::before {
  content: "\\F1435"; }

.mdi-motorbike::before {
  content: "\\F037C"; }

.mdi-motorbike-electric::before {
  content: "\\F15BA"; }

.mdi-mouse::before {
  content: "\\F037D"; }

.mdi-mouse-bluetooth::before {
  content: "\\F098B"; }

.mdi-mouse-move-down::before {
  content: "\\F1550"; }

.mdi-mouse-move-up::before {
  content: "\\F1551"; }

.mdi-mouse-move-vertical::before {
  content: "\\F1552"; }

.mdi-mouse-off::before {
  content: "\\F037E"; }

.mdi-mouse-variant::before {
  content: "\\F037F"; }

.mdi-mouse-variant-off::before {
  content: "\\F0380"; }

.mdi-move-resize::before {
  content: "\\F0655"; }

.mdi-move-resize-variant::before {
  content: "\\F0656"; }

.mdi-movie::before {
  content: "\\F0381"; }

.mdi-movie-edit::before {
  content: "\\F1122"; }

.mdi-movie-edit-outline::before {
  content: "\\F1123"; }

.mdi-movie-filter::before {
  content: "\\F1124"; }

.mdi-movie-filter-outline::before {
  content: "\\F1125"; }

.mdi-movie-open::before {
  content: "\\F0FCE"; }

.mdi-movie-open-outline::before {
  content: "\\F0FCF"; }

.mdi-movie-outline::before {
  content: "\\F0DDD"; }

.mdi-movie-roll::before {
  content: "\\F07DE"; }

.mdi-movie-search::before {
  content: "\\F11D2"; }

.mdi-movie-search-outline::before {
  content: "\\F11D3"; }

.mdi-mower::before {
  content: "\\F166F"; }

.mdi-mower-bag::before {
  content: "\\F1670"; }

.mdi-muffin::before {
  content: "\\F098C"; }

.mdi-multiplication::before {
  content: "\\F0382"; }

.mdi-multiplication-box::before {
  content: "\\F0383"; }

.mdi-mushroom::before {
  content: "\\F07DF"; }

.mdi-mushroom-off::before {
  content: "\\F13FA"; }

.mdi-mushroom-off-outline::before {
  content: "\\F13FB"; }

.mdi-mushroom-outline::before {
  content: "\\F07E0"; }

.mdi-music::before {
  content: "\\F075A"; }

.mdi-music-accidental-double-flat::before {
  content: "\\F0F69"; }

.mdi-music-accidental-double-sharp::before {
  content: "\\F0F6A"; }

.mdi-music-accidental-flat::before {
  content: "\\F0F6B"; }

.mdi-music-accidental-natural::before {
  content: "\\F0F6C"; }

.mdi-music-accidental-sharp::before {
  content: "\\F0F6D"; }

.mdi-music-box::before {
  content: "\\F0384"; }

.mdi-music-box-multiple::before {
  content: "\\F0333"; }

.mdi-music-box-multiple-outline::before {
  content: "\\F0F04"; }

.mdi-music-box-outline::before {
  content: "\\F0385"; }

.mdi-music-circle::before {
  content: "\\F0386"; }

.mdi-music-circle-outline::before {
  content: "\\F0AD4"; }

.mdi-music-clef-alto::before {
  content: "\\F0F6E"; }

.mdi-music-clef-bass::before {
  content: "\\F0F6F"; }

.mdi-music-clef-treble::before {
  content: "\\F0F70"; }

.mdi-music-note::before {
  content: "\\F0387"; }

.mdi-music-note-bluetooth::before {
  content: "\\F05FE"; }

.mdi-music-note-bluetooth-off::before {
  content: "\\F05FF"; }

.mdi-music-note-eighth::before {
  content: "\\F0388"; }

.mdi-music-note-eighth-dotted::before {
  content: "\\F0F71"; }

.mdi-music-note-half::before {
  content: "\\F0389"; }

.mdi-music-note-half-dotted::before {
  content: "\\F0F72"; }

.mdi-music-note-off::before {
  content: "\\F038A"; }

.mdi-music-note-off-outline::before {
  content: "\\F0F73"; }

.mdi-music-note-outline::before {
  content: "\\F0F74"; }

.mdi-music-note-plus::before {
  content: "\\F0DDE"; }

.mdi-music-note-quarter::before {
  content: "\\F038B"; }

.mdi-music-note-quarter-dotted::before {
  content: "\\F0F75"; }

.mdi-music-note-sixteenth::before {
  content: "\\F038C"; }

.mdi-music-note-sixteenth-dotted::before {
  content: "\\F0F76"; }

.mdi-music-note-whole::before {
  content: "\\F038D"; }

.mdi-music-note-whole-dotted::before {
  content: "\\F0F77"; }

.mdi-music-off::before {
  content: "\\F075B"; }

.mdi-music-rest-eighth::before {
  content: "\\F0F78"; }

.mdi-music-rest-half::before {
  content: "\\F0F79"; }

.mdi-music-rest-quarter::before {
  content: "\\F0F7A"; }

.mdi-music-rest-sixteenth::before {
  content: "\\F0F7B"; }

.mdi-music-rest-whole::before {
  content: "\\F0F7C"; }

.mdi-mustache::before {
  content: "\\F15DE"; }

.mdi-nail::before {
  content: "\\F0DDF"; }

.mdi-nas::before {
  content: "\\F08F3"; }

.mdi-nativescript::before {
  content: "\\F0880"; }

.mdi-nature::before {
  content: "\\F038E"; }

.mdi-nature-people::before {
  content: "\\F038F"; }

.mdi-navigation::before {
  content: "\\F0390"; }

.mdi-navigation-outline::before {
  content: "\\F1607"; }

.mdi-near-me::before {
  content: "\\F05CD"; }

.mdi-necklace::before {
  content: "\\F0F0B"; }

.mdi-needle::before {
  content: "\\F0391"; }

.mdi-netflix::before {
  content: "\\F0746"; }

.mdi-network::before {
  content: "\\F06F3"; }

.mdi-network-off::before {
  content: "\\F0C9B"; }

.mdi-network-off-outline::before {
  content: "\\F0C9C"; }

.mdi-network-outline::before {
  content: "\\F0C9D"; }

.mdi-network-strength-1::before {
  content: "\\F08F4"; }

.mdi-network-strength-1-alert::before {
  content: "\\F08F5"; }

.mdi-network-strength-2::before {
  content: "\\F08F6"; }

.mdi-network-strength-2-alert::before {
  content: "\\F08F7"; }

.mdi-network-strength-3::before {
  content: "\\F08F8"; }

.mdi-network-strength-3-alert::before {
  content: "\\F08F9"; }

.mdi-network-strength-4::before {
  content: "\\F08FA"; }

.mdi-network-strength-4-alert::before {
  content: "\\F08FB"; }

.mdi-network-strength-off::before {
  content: "\\F08FC"; }

.mdi-network-strength-off-outline::before {
  content: "\\F08FD"; }

.mdi-network-strength-outline::before {
  content: "\\F08FE"; }

.mdi-new-box::before {
  content: "\\F0394"; }

.mdi-newspaper::before {
  content: "\\F0395"; }

.mdi-newspaper-minus::before {
  content: "\\F0F0C"; }

.mdi-newspaper-plus::before {
  content: "\\F0F0D"; }

.mdi-newspaper-variant::before {
  content: "\\F1001"; }

.mdi-newspaper-variant-multiple::before {
  content: "\\F1002"; }

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F1003"; }

.mdi-newspaper-variant-outline::before {
  content: "\\F1004"; }

.mdi-nfc::before {
  content: "\\F0396"; }

.mdi-nfc-search-variant::before {
  content: "\\F0E53"; }

.mdi-nfc-tap::before {
  content: "\\F0397"; }

.mdi-nfc-variant::before {
  content: "\\F0398"; }

.mdi-nfc-variant-off::before {
  content: "\\F0E54"; }

.mdi-ninja::before {
  content: "\\F0774"; }

.mdi-nintendo-game-boy::before {
  content: "\\F1393"; }

.mdi-nintendo-switch::before {
  content: "\\F07E1"; }

.mdi-nintendo-wii::before {
  content: "\\F05AB"; }

.mdi-nintendo-wiiu::before {
  content: "\\F072D"; }

.mdi-nix::before {
  content: "\\F1105"; }

.mdi-nodejs::before {
  content: "\\F0399"; }

.mdi-noodles::before {
  content: "\\F117E"; }

.mdi-not-equal::before {
  content: "\\F098D"; }

.mdi-not-equal-variant::before {
  content: "\\F098E"; }

.mdi-note::before {
  content: "\\F039A"; }

.mdi-note-minus::before {
  content: "\\F164F"; }

.mdi-note-minus-outline::before {
  content: "\\F1650"; }

.mdi-note-multiple::before {
  content: "\\F06B8"; }

.mdi-note-multiple-outline::before {
  content: "\\F06B9"; }

.mdi-note-outline::before {
  content: "\\F039B"; }

.mdi-note-plus::before {
  content: "\\F039C"; }

.mdi-note-plus-outline::before {
  content: "\\F039D"; }

.mdi-note-remove::before {
  content: "\\F1651"; }

.mdi-note-remove-outline::before {
  content: "\\F1652"; }

.mdi-note-search::before {
  content: "\\F1653"; }

.mdi-note-search-outline::before {
  content: "\\F1654"; }

.mdi-note-text::before {
  content: "\\F039E"; }

.mdi-note-text-outline::before {
  content: "\\F11D7"; }

.mdi-notebook::before {
  content: "\\F082E"; }

.mdi-notebook-check::before {
  content: "\\F14F5"; }

.mdi-notebook-check-outline::before {
  content: "\\F14F6"; }

.mdi-notebook-edit::before {
  content: "\\F14E7"; }

.mdi-notebook-edit-outline::before {
  content: "\\F14E9"; }

.mdi-notebook-minus::before {
  content: "\\F1610"; }

.mdi-notebook-minus-outline::before {
  content: "\\F1611"; }

.mdi-notebook-multiple::before {
  content: "\\F0E55"; }

.mdi-notebook-outline::before {
  content: "\\F0EBF"; }

.mdi-notebook-plus::before {
  content: "\\F1612"; }

.mdi-notebook-plus-outline::before {
  content: "\\F1613"; }

.mdi-notebook-remove::before {
  content: "\\F1614"; }

.mdi-notebook-remove-outline::before {
  content: "\\F1615"; }

.mdi-notification-clear-all::before {
  content: "\\F039F"; }

.mdi-npm::before {
  content: "\\F06F7"; }

.mdi-nuke::before {
  content: "\\F06A4"; }

.mdi-null::before {
  content: "\\F07E2"; }

.mdi-numeric::before {
  content: "\\F03A0"; }

.mdi-numeric-0::before {
  content: "\\F0B39"; }

.mdi-numeric-0-box::before {
  content: "\\F03A1"; }

.mdi-numeric-0-box-multiple::before {
  content: "\\F0F0E"; }

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F03A2"; }

.mdi-numeric-0-box-outline::before {
  content: "\\F03A3"; }

.mdi-numeric-0-circle::before {
  content: "\\F0C9E"; }

.mdi-numeric-0-circle-outline::before {
  content: "\\F0C9F"; }

.mdi-numeric-1::before {
  content: "\\F0B3A"; }

.mdi-numeric-1-box::before {
  content: "\\F03A4"; }

.mdi-numeric-1-box-multiple::before {
  content: "\\F0F0F"; }

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F03A5"; }

.mdi-numeric-1-box-outline::before {
  content: "\\F03A6"; }

.mdi-numeric-1-circle::before {
  content: "\\F0CA0"; }

.mdi-numeric-1-circle-outline::before {
  content: "\\F0CA1"; }

.mdi-numeric-10::before {
  content: "\\F0FE9"; }

.mdi-numeric-10-box::before {
  content: "\\F0F7D"; }

.mdi-numeric-10-box-multiple::before {
  content: "\\F0FEA"; }

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F0FEB"; }

.mdi-numeric-10-box-outline::before {
  content: "\\F0F7E"; }

.mdi-numeric-10-circle::before {
  content: "\\F0FEC"; }

.mdi-numeric-10-circle-outline::before {
  content: "\\F0FED"; }

.mdi-numeric-2::before {
  content: "\\F0B3B"; }

.mdi-numeric-2-box::before {
  content: "\\F03A7"; }

.mdi-numeric-2-box-multiple::before {
  content: "\\F0F10"; }

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F03A8"; }

.mdi-numeric-2-box-outline::before {
  content: "\\F03A9"; }

.mdi-numeric-2-circle::before {
  content: "\\F0CA2"; }

.mdi-numeric-2-circle-outline::before {
  content: "\\F0CA3"; }

.mdi-numeric-3::before {
  content: "\\F0B3C"; }

.mdi-numeric-3-box::before {
  content: "\\F03AA"; }

.mdi-numeric-3-box-multiple::before {
  content: "\\F0F11"; }

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F03AB"; }

.mdi-numeric-3-box-outline::before {
  content: "\\F03AC"; }

.mdi-numeric-3-circle::before {
  content: "\\F0CA4"; }

.mdi-numeric-3-circle-outline::before {
  content: "\\F0CA5"; }

.mdi-numeric-4::before {
  content: "\\F0B3D"; }

.mdi-numeric-4-box::before {
  content: "\\F03AD"; }

.mdi-numeric-4-box-multiple::before {
  content: "\\F0F12"; }

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F03B2"; }

.mdi-numeric-4-box-outline::before {
  content: "\\F03AE"; }

.mdi-numeric-4-circle::before {
  content: "\\F0CA6"; }

.mdi-numeric-4-circle-outline::before {
  content: "\\F0CA7"; }

.mdi-numeric-5::before {
  content: "\\F0B3E"; }

.mdi-numeric-5-box::before {
  content: "\\F03B1"; }

.mdi-numeric-5-box-multiple::before {
  content: "\\F0F13"; }

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F03AF"; }

.mdi-numeric-5-box-outline::before {
  content: "\\F03B0"; }

.mdi-numeric-5-circle::before {
  content: "\\F0CA8"; }

.mdi-numeric-5-circle-outline::before {
  content: "\\F0CA9"; }

.mdi-numeric-6::before {
  content: "\\F0B3F"; }

.mdi-numeric-6-box::before {
  content: "\\F03B3"; }

.mdi-numeric-6-box-multiple::before {
  content: "\\F0F14"; }

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F03B4"; }

.mdi-numeric-6-box-outline::before {
  content: "\\F03B5"; }

.mdi-numeric-6-circle::before {
  content: "\\F0CAA"; }

.mdi-numeric-6-circle-outline::before {
  content: "\\F0CAB"; }

.mdi-numeric-7::before {
  content: "\\F0B40"; }

.mdi-numeric-7-box::before {
  content: "\\F03B6"; }

.mdi-numeric-7-box-multiple::before {
  content: "\\F0F15"; }

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F03B7"; }

.mdi-numeric-7-box-outline::before {
  content: "\\F03B8"; }

.mdi-numeric-7-circle::before {
  content: "\\F0CAC"; }

.mdi-numeric-7-circle-outline::before {
  content: "\\F0CAD"; }

.mdi-numeric-8::before {
  content: "\\F0B41"; }

.mdi-numeric-8-box::before {
  content: "\\F03B9"; }

.mdi-numeric-8-box-multiple::before {
  content: "\\F0F16"; }

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F03BA"; }

.mdi-numeric-8-box-outline::before {
  content: "\\F03BB"; }

.mdi-numeric-8-circle::before {
  content: "\\F0CAE"; }

.mdi-numeric-8-circle-outline::before {
  content: "\\F0CAF"; }

.mdi-numeric-9::before {
  content: "\\F0B42"; }

.mdi-numeric-9-box::before {
  content: "\\F03BC"; }

.mdi-numeric-9-box-multiple::before {
  content: "\\F0F17"; }

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F03BD"; }

.mdi-numeric-9-box-outline::before {
  content: "\\F03BE"; }

.mdi-numeric-9-circle::before {
  content: "\\F0CB0"; }

.mdi-numeric-9-circle-outline::before {
  content: "\\F0CB1"; }

.mdi-numeric-9-plus::before {
  content: "\\F0FEE"; }

.mdi-numeric-9-plus-box::before {
  content: "\\F03BF"; }

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\F0F18"; }

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F03C0"; }

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F03C1"; }

.mdi-numeric-9-plus-circle::before {
  content: "\\F0CB2"; }

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\F0CB3"; }

.mdi-numeric-negative-1::before {
  content: "\\F1052"; }

.mdi-numeric-positive-1::before {
  content: "\\F15CB"; }

.mdi-nut::before {
  content: "\\F06F8"; }

.mdi-nutrition::before {
  content: "\\F03C2"; }

.mdi-nuxt::before {
  content: "\\F1106"; }

.mdi-oar::before {
  content: "\\F067C"; }

.mdi-ocarina::before {
  content: "\\F0DE0"; }

.mdi-oci::before {
  content: "\\F12E9"; }

.mdi-ocr::before {
  content: "\\F113A"; }

.mdi-octagon::before {
  content: "\\F03C3"; }

.mdi-octagon-outline::before {
  content: "\\F03C4"; }

.mdi-octagram::before {
  content: "\\F06F9"; }

.mdi-octagram-outline::before {
  content: "\\F0775"; }

.mdi-odnoklassniki::before {
  content: "\\F03C5"; }

.mdi-offer::before {
  content: "\\F121B"; }

.mdi-office-building::before {
  content: "\\F0991"; }

.mdi-office-building-marker::before {
  content: "\\F1520"; }

.mdi-office-building-marker-outline::before {
  content: "\\F1521"; }

.mdi-office-building-outline::before {
  content: "\\F151F"; }

.mdi-oil::before {
  content: "\\F03C7"; }

.mdi-oil-lamp::before {
  content: "\\F0F19"; }

.mdi-oil-level::before {
  content: "\\F1053"; }

.mdi-oil-temperature::before {
  content: "\\F0FF8"; }

.mdi-omega::before {
  content: "\\F03C9"; }

.mdi-one-up::before {
  content: "\\F0BAD"; }

.mdi-onepassword::before {
  content: "\\F0881"; }

.mdi-opacity::before {
  content: "\\F05CC"; }

.mdi-open-in-app::before {
  content: "\\F03CB"; }

.mdi-open-in-new::before {
  content: "\\F03CC"; }

.mdi-open-source-initiative::before {
  content: "\\F0BAE"; }

.mdi-openid::before {
  content: "\\F03CD"; }

.mdi-opera::before {
  content: "\\F03CE"; }

.mdi-orbit::before {
  content: "\\F0018"; }

.mdi-orbit-variant::before {
  content: "\\F15DB"; }

.mdi-order-alphabetical-ascending::before {
  content: "\\F020D"; }

.mdi-order-alphabetical-descending::before {
  content: "\\F0D07"; }

.mdi-order-bool-ascending::before {
  content: "\\F02BE"; }

.mdi-order-bool-ascending-variant::before {
  content: "\\F098F"; }

.mdi-order-bool-descending::before {
  content: "\\F1384"; }

.mdi-order-bool-descending-variant::before {
  content: "\\F0990"; }

.mdi-order-numeric-ascending::before {
  content: "\\F0545"; }

.mdi-order-numeric-descending::before {
  content: "\\F0546"; }

.mdi-origin::before {
  content: "\\F0B43"; }

.mdi-ornament::before {
  content: "\\F03CF"; }

.mdi-ornament-variant::before {
  content: "\\F03D0"; }

.mdi-outdoor-lamp::before {
  content: "\\F1054"; }

.mdi-overscan::before {
  content: "\\F1005"; }

.mdi-owl::before {
  content: "\\F03D2"; }

.mdi-pac-man::before {
  content: "\\F0BAF"; }

.mdi-package::before {
  content: "\\F03D3"; }

.mdi-package-down::before {
  content: "\\F03D4"; }

.mdi-package-up::before {
  content: "\\F03D5"; }

.mdi-package-variant::before {
  content: "\\F03D6"; }

.mdi-package-variant-closed::before {
  content: "\\F03D7"; }

.mdi-page-first::before {
  content: "\\F0600"; }

.mdi-page-last::before {
  content: "\\F0601"; }

.mdi-page-layout-body::before {
  content: "\\F06FA"; }

.mdi-page-layout-footer::before {
  content: "\\F06FB"; }

.mdi-page-layout-header::before {
  content: "\\F06FC"; }

.mdi-page-layout-header-footer::before {
  content: "\\F0F7F"; }

.mdi-page-layout-sidebar-left::before {
  content: "\\F06FD"; }

.mdi-page-layout-sidebar-right::before {
  content: "\\F06FE"; }

.mdi-page-next::before {
  content: "\\F0BB0"; }

.mdi-page-next-outline::before {
  content: "\\F0BB1"; }

.mdi-page-previous::before {
  content: "\\F0BB2"; }

.mdi-page-previous-outline::before {
  content: "\\F0BB3"; }

.mdi-pail::before {
  content: "\\F1417"; }

.mdi-pail-minus::before {
  content: "\\F1437"; }

.mdi-pail-minus-outline::before {
  content: "\\F143C"; }

.mdi-pail-off::before {
  content: "\\F1439"; }

.mdi-pail-off-outline::before {
  content: "\\F143E"; }

.mdi-pail-outline::before {
  content: "\\F143A"; }

.mdi-pail-plus::before {
  content: "\\F1436"; }

.mdi-pail-plus-outline::before {
  content: "\\F143B"; }

.mdi-pail-remove::before {
  content: "\\F1438"; }

.mdi-pail-remove-outline::before {
  content: "\\F143D"; }

.mdi-palette::before {
  content: "\\F03D8"; }

.mdi-palette-advanced::before {
  content: "\\F03D9"; }

.mdi-palette-outline::before {
  content: "\\F0E0C"; }

.mdi-palette-swatch::before {
  content: "\\F08B5"; }

.mdi-palette-swatch-outline::before {
  content: "\\F135C"; }

.mdi-palm-tree::before {
  content: "\\F1055"; }

.mdi-pan::before {
  content: "\\F0BB4"; }

.mdi-pan-bottom-left::before {
  content: "\\F0BB5"; }

.mdi-pan-bottom-right::before {
  content: "\\F0BB6"; }

.mdi-pan-down::before {
  content: "\\F0BB7"; }

.mdi-pan-horizontal::before {
  content: "\\F0BB8"; }

.mdi-pan-left::before {
  content: "\\F0BB9"; }

.mdi-pan-right::before {
  content: "\\F0BBA"; }

.mdi-pan-top-left::before {
  content: "\\F0BBB"; }

.mdi-pan-top-right::before {
  content: "\\F0BBC"; }

.mdi-pan-up::before {
  content: "\\F0BBD"; }

.mdi-pan-vertical::before {
  content: "\\F0BBE"; }

.mdi-panda::before {
  content: "\\F03DA"; }

.mdi-pandora::before {
  content: "\\F03DB"; }

.mdi-panorama::before {
  content: "\\F03DC"; }

.mdi-panorama-fisheye::before {
  content: "\\F03DD"; }

.mdi-panorama-horizontal::before {
  content: "\\F03DE"; }

.mdi-panorama-vertical::before {
  content: "\\F03DF"; }

.mdi-panorama-wide-angle::before {
  content: "\\F03E0"; }

.mdi-paper-cut-vertical::before {
  content: "\\F03E1"; }

.mdi-paper-roll::before {
  content: "\\F1157"; }

.mdi-paper-roll-outline::before {
  content: "\\F1158"; }

.mdi-paperclip::before {
  content: "\\F03E2"; }

.mdi-parachute::before {
  content: "\\F0CB4"; }

.mdi-parachute-outline::before {
  content: "\\F0CB5"; }

.mdi-parking::before {
  content: "\\F03E3"; }

.mdi-party-popper::before {
  content: "\\F1056"; }

.mdi-passport::before {
  content: "\\F07E3"; }

.mdi-passport-biometric::before {
  content: "\\F0DE1"; }

.mdi-pasta::before {
  content: "\\F1160"; }

.mdi-patio-heater::before {
  content: "\\F0F80"; }

.mdi-patreon::before {
  content: "\\F0882"; }

.mdi-pause::before {
  content: "\\F03E4"; }

.mdi-pause-circle::before {
  content: "\\F03E5"; }

.mdi-pause-circle-outline::before {
  content: "\\F03E6"; }

.mdi-pause-octagon::before {
  content: "\\F03E7"; }

.mdi-pause-octagon-outline::before {
  content: "\\F03E8"; }

.mdi-paw::before {
  content: "\\F03E9"; }

.mdi-paw-off::before {
  content: "\\F0657"; }

.mdi-paw-off-outline::before {
  content: "\\F1676"; }

.mdi-paw-outline::before {
  content: "\\F1675"; }

.mdi-pdf-box::before {
  content: "\\F0E56"; }

.mdi-peace::before {
  content: "\\F0884"; }

.mdi-peanut::before {
  content: "\\F0FFC"; }

.mdi-peanut-off::before {
  content: "\\F0FFD"; }

.mdi-peanut-off-outline::before {
  content: "\\F0FFF"; }

.mdi-peanut-outline::before {
  content: "\\F0FFE"; }

.mdi-pen::before {
  content: "\\F03EA"; }

.mdi-pen-lock::before {
  content: "\\F0DE2"; }

.mdi-pen-minus::before {
  content: "\\F0DE3"; }

.mdi-pen-off::before {
  content: "\\F0DE4"; }

.mdi-pen-plus::before {
  content: "\\F0DE5"; }

.mdi-pen-remove::before {
  content: "\\F0DE6"; }

.mdi-pencil::before {
  content: "\\F03EB"; }

.mdi-pencil-box::before {
  content: "\\F03EC"; }

.mdi-pencil-box-multiple::before {
  content: "\\F1144"; }

.mdi-pencil-box-multiple-outline::before {
  content: "\\F1145"; }

.mdi-pencil-box-outline::before {
  content: "\\F03ED"; }

.mdi-pencil-circle::before {
  content: "\\F06FF"; }

.mdi-pencil-circle-outline::before {
  content: "\\F0776"; }

.mdi-pencil-lock::before {
  content: "\\F03EE"; }

.mdi-pencil-lock-outline::before {
  content: "\\F0DE7"; }

.mdi-pencil-minus::before {
  content: "\\F0DE8"; }

.mdi-pencil-minus-outline::before {
  content: "\\F0DE9"; }

.mdi-pencil-off::before {
  content: "\\F03EF"; }

.mdi-pencil-off-outline::before {
  content: "\\F0DEA"; }

.mdi-pencil-outline::before {
  content: "\\F0CB6"; }

.mdi-pencil-plus::before {
  content: "\\F0DEB"; }

.mdi-pencil-plus-outline::before {
  content: "\\F0DEC"; }

.mdi-pencil-remove::before {
  content: "\\F0DED"; }

.mdi-pencil-remove-outline::before {
  content: "\\F0DEE"; }

.mdi-pencil-ruler::before {
  content: "\\F1353"; }

.mdi-penguin::before {
  content: "\\F0EC0"; }

.mdi-pentagon::before {
  content: "\\F0701"; }

.mdi-pentagon-outline::before {
  content: "\\F0700"; }

.mdi-pentagram::before {
  content: "\\F1667"; }

.mdi-percent::before {
  content: "\\F03F0"; }

.mdi-percent-outline::before {
  content: "\\F1278"; }

.mdi-periodic-table::before {
  content: "\\F08B6"; }

.mdi-perspective-less::before {
  content: "\\F0D23"; }

.mdi-perspective-more::before {
  content: "\\F0D24"; }

.mdi-pharmacy::before {
  content: "\\F03F1"; }

.mdi-phone::before {
  content: "\\F03F2"; }

.mdi-phone-alert::before {
  content: "\\F0F1A"; }

.mdi-phone-alert-outline::before {
  content: "\\F118E"; }

.mdi-phone-bluetooth::before {
  content: "\\F03F3"; }

.mdi-phone-bluetooth-outline::before {
  content: "\\F118F"; }

.mdi-phone-cancel::before {
  content: "\\F10BC"; }

.mdi-phone-cancel-outline::before {
  content: "\\F1190"; }

.mdi-phone-check::before {
  content: "\\F11A9"; }

.mdi-phone-check-outline::before {
  content: "\\F11AA"; }

.mdi-phone-classic::before {
  content: "\\F0602"; }

.mdi-phone-classic-off::before {
  content: "\\F1279"; }

.mdi-phone-dial::before {
  content: "\\F1559"; }

.mdi-phone-dial-outline::before {
  content: "\\F155A"; }

.mdi-phone-forward::before {
  content: "\\F03F4"; }

.mdi-phone-forward-outline::before {
  content: "\\F1191"; }

.mdi-phone-hangup::before {
  content: "\\F03F5"; }

.mdi-phone-hangup-outline::before {
  content: "\\F1192"; }

.mdi-phone-in-talk::before {
  content: "\\F03F6"; }

.mdi-phone-in-talk-outline::before {
  content: "\\F1182"; }

.mdi-phone-incoming::before {
  content: "\\F03F7"; }

.mdi-phone-incoming-outline::before {
  content: "\\F1193"; }

.mdi-phone-lock::before {
  content: "\\F03F8"; }

.mdi-phone-lock-outline::before {
  content: "\\F1194"; }

.mdi-phone-log::before {
  content: "\\F03F9"; }

.mdi-phone-log-outline::before {
  content: "\\F1195"; }

.mdi-phone-message::before {
  content: "\\F1196"; }

.mdi-phone-message-outline::before {
  content: "\\F1197"; }

.mdi-phone-minus::before {
  content: "\\F0658"; }

.mdi-phone-minus-outline::before {
  content: "\\F1198"; }

.mdi-phone-missed::before {
  content: "\\F03FA"; }

.mdi-phone-missed-outline::before {
  content: "\\F11A5"; }

.mdi-phone-off::before {
  content: "\\F0DEF"; }

.mdi-phone-off-outline::before {
  content: "\\F11A6"; }

.mdi-phone-outgoing::before {
  content: "\\F03FB"; }

.mdi-phone-outgoing-outline::before {
  content: "\\F1199"; }

.mdi-phone-outline::before {
  content: "\\F0DF0"; }

.mdi-phone-paused::before {
  content: "\\F03FC"; }

.mdi-phone-paused-outline::before {
  content: "\\F119A"; }

.mdi-phone-plus::before {
  content: "\\F0659"; }

.mdi-phone-plus-outline::before {
  content: "\\F119B"; }

.mdi-phone-remove::before {
  content: "\\F152F"; }

.mdi-phone-remove-outline::before {
  content: "\\F1530"; }

.mdi-phone-return::before {
  content: "\\F082F"; }

.mdi-phone-return-outline::before {
  content: "\\F119C"; }

.mdi-phone-ring::before {
  content: "\\F11AB"; }

.mdi-phone-ring-outline::before {
  content: "\\F11AC"; }

.mdi-phone-rotate-landscape::before {
  content: "\\F0885"; }

.mdi-phone-rotate-portrait::before {
  content: "\\F0886"; }

.mdi-phone-settings::before {
  content: "\\F03FD"; }

.mdi-phone-settings-outline::before {
  content: "\\F119D"; }

.mdi-phone-voip::before {
  content: "\\F03FE"; }

.mdi-pi::before {
  content: "\\F03FF"; }

.mdi-pi-box::before {
  content: "\\F0400"; }

.mdi-pi-hole::before {
  content: "\\F0DF1"; }

.mdi-piano::before {
  content: "\\F067D"; }

.mdi-pickaxe::before {
  content: "\\F08B7"; }

.mdi-picture-in-picture-bottom-right::before {
  content: "\\F0E57"; }

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\F0E58"; }

.mdi-picture-in-picture-top-right::before {
  content: "\\F0E59"; }

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\F0E5A"; }

.mdi-pier::before {
  content: "\\F0887"; }

.mdi-pier-crane::before {
  content: "\\F0888"; }

.mdi-pig::before {
  content: "\\F0401"; }

.mdi-pig-variant::before {
  content: "\\F1006"; }

.mdi-pig-variant-outline::before {
  content: "\\F1678"; }

.mdi-piggy-bank::before {
  content: "\\F1007"; }

.mdi-piggy-bank-outline::before {
  content: "\\F1679"; }

.mdi-pill::before {
  content: "\\F0402"; }

.mdi-pillar::before {
  content: "\\F0702"; }

.mdi-pin::before {
  content: "\\F0403"; }

.mdi-pin-off::before {
  content: "\\F0404"; }

.mdi-pin-off-outline::before {
  content: "\\F0930"; }

.mdi-pin-outline::before {
  content: "\\F0931"; }

.mdi-pine-tree::before {
  content: "\\F0405"; }

.mdi-pine-tree-box::before {
  content: "\\F0406"; }

.mdi-pine-tree-fire::before {
  content: "\\F141A"; }

.mdi-pinterest::before {
  content: "\\F0407"; }

.mdi-pinwheel::before {
  content: "\\F0AD5"; }

.mdi-pinwheel-outline::before {
  content: "\\F0AD6"; }

.mdi-pipe::before {
  content: "\\F07E5"; }

.mdi-pipe-disconnected::before {
  content: "\\F07E6"; }

.mdi-pipe-leak::before {
  content: "\\F0889"; }

.mdi-pipe-wrench::before {
  content: "\\F1354"; }

.mdi-pirate::before {
  content: "\\F0A08"; }

.mdi-pistol::before {
  content: "\\F0703"; }

.mdi-piston::before {
  content: "\\F088A"; }

.mdi-pitchfork::before {
  content: "\\F1553"; }

.mdi-pizza::before {
  content: "\\F0409"; }

.mdi-play::before {
  content: "\\F040A"; }

.mdi-play-box::before {
  content: "\\F127A"; }

.mdi-play-box-multiple::before {
  content: "\\F0D19"; }

.mdi-play-box-multiple-outline::before {
  content: "\\F13E6"; }

.mdi-play-box-outline::before {
  content: "\\F040B"; }

.mdi-play-circle::before {
  content: "\\F040C"; }

.mdi-play-circle-outline::before {
  content: "\\F040D"; }

.mdi-play-network::before {
  content: "\\F088B"; }

.mdi-play-network-outline::before {
  content: "\\F0CB7"; }

.mdi-play-outline::before {
  content: "\\F0F1B"; }

.mdi-play-pause::before {
  content: "\\F040E"; }

.mdi-play-protected-content::before {
  content: "\\F040F"; }

.mdi-play-speed::before {
  content: "\\F08FF"; }

.mdi-playlist-check::before {
  content: "\\F05C7"; }

.mdi-playlist-edit::before {
  content: "\\F0900"; }

.mdi-playlist-minus::before {
  content: "\\F0410"; }

.mdi-playlist-music::before {
  content: "\\F0CB8"; }

.mdi-playlist-music-outline::before {
  content: "\\F0CB9"; }

.mdi-playlist-play::before {
  content: "\\F0411"; }

.mdi-playlist-plus::before {
  content: "\\F0412"; }

.mdi-playlist-remove::before {
  content: "\\F0413"; }

.mdi-playlist-star::before {
  content: "\\F0DF2"; }

.mdi-plex::before {
  content: "\\F06BA"; }

.mdi-plus::before {
  content: "\\F0415"; }

.mdi-plus-box::before {
  content: "\\F0416"; }

.mdi-plus-box-multiple::before {
  content: "\\F0334"; }

.mdi-plus-box-multiple-outline::before {
  content: "\\F1143"; }

.mdi-plus-box-outline::before {
  content: "\\F0704"; }

.mdi-plus-circle::before {
  content: "\\F0417"; }

.mdi-plus-circle-multiple::before {
  content: "\\F034C"; }

.mdi-plus-circle-multiple-outline::before {
  content: "\\F0418"; }

.mdi-plus-circle-outline::before {
  content: "\\F0419"; }

.mdi-plus-minus::before {
  content: "\\F0992"; }

.mdi-plus-minus-box::before {
  content: "\\F0993"; }

.mdi-plus-minus-variant::before {
  content: "\\F14C9"; }

.mdi-plus-network::before {
  content: "\\F041A"; }

.mdi-plus-network-outline::before {
  content: "\\F0CBA"; }

.mdi-plus-one::before {
  content: "\\F041B"; }

.mdi-plus-outline::before {
  content: "\\F0705"; }

.mdi-plus-thick::before {
  content: "\\F11EC"; }

.mdi-podcast::before {
  content: "\\F0994"; }

.mdi-podium::before {
  content: "\\F0D25"; }

.mdi-podium-bronze::before {
  content: "\\F0D26"; }

.mdi-podium-gold::before {
  content: "\\F0D27"; }

.mdi-podium-silver::before {
  content: "\\F0D28"; }

.mdi-point-of-sale::before {
  content: "\\F0D92"; }

.mdi-pokeball::before {
  content: "\\F041D"; }

.mdi-pokemon-go::before {
  content: "\\F0A09"; }

.mdi-poker-chip::before {
  content: "\\F0830"; }

.mdi-polaroid::before {
  content: "\\F041E"; }

.mdi-police-badge::before {
  content: "\\F1167"; }

.mdi-police-badge-outline::before {
  content: "\\F1168"; }

.mdi-poll::before {
  content: "\\F041F"; }

.mdi-poll-box::before {
  content: "\\F0420"; }

.mdi-poll-box-outline::before {
  content: "\\F127B"; }

.mdi-polo::before {
  content: "\\F14C3"; }

.mdi-polymer::before {
  content: "\\F0421"; }

.mdi-pool::before {
  content: "\\F0606"; }

.mdi-popcorn::before {
  content: "\\F0422"; }

.mdi-post::before {
  content: "\\F1008"; }

.mdi-post-outline::before {
  content: "\\F1009"; }

.mdi-postage-stamp::before {
  content: "\\F0CBB"; }

.mdi-pot::before {
  content: "\\F02E5"; }

.mdi-pot-mix::before {
  content: "\\F065B"; }

.mdi-pot-mix-outline::before {
  content: "\\F0677"; }

.mdi-pot-outline::before {
  content: "\\F02FF"; }

.mdi-pot-steam::before {
  content: "\\F065A"; }

.mdi-pot-steam-outline::before {
  content: "\\F0326"; }

.mdi-pound::before {
  content: "\\F0423"; }

.mdi-pound-box::before {
  content: "\\F0424"; }

.mdi-pound-box-outline::before {
  content: "\\F117F"; }

.mdi-power::before {
  content: "\\F0425"; }

.mdi-power-cycle::before {
  content: "\\F0901"; }

.mdi-power-off::before {
  content: "\\F0902"; }

.mdi-power-on::before {
  content: "\\F0903"; }

.mdi-power-plug::before {
  content: "\\F06A5"; }

.mdi-power-plug-off::before {
  content: "\\F06A6"; }

.mdi-power-plug-off-outline::before {
  content: "\\F1424"; }

.mdi-power-plug-outline::before {
  content: "\\F1425"; }

.mdi-power-settings::before {
  content: "\\F0426"; }

.mdi-power-sleep::before {
  content: "\\F0904"; }

.mdi-power-socket::before {
  content: "\\F0427"; }

.mdi-power-socket-au::before {
  content: "\\F0905"; }

.mdi-power-socket-de::before {
  content: "\\F1107"; }

.mdi-power-socket-eu::before {
  content: "\\F07E7"; }

.mdi-power-socket-fr::before {
  content: "\\F1108"; }

.mdi-power-socket-it::before {
  content: "\\F14FF"; }

.mdi-power-socket-jp::before {
  content: "\\F1109"; }

.mdi-power-socket-uk::before {
  content: "\\F07E8"; }

.mdi-power-socket-us::before {
  content: "\\F07E9"; }

.mdi-power-standby::before {
  content: "\\F0906"; }

.mdi-powershell::before {
  content: "\\F0A0A"; }

.mdi-prescription::before {
  content: "\\F0706"; }

.mdi-presentation::before {
  content: "\\F0428"; }

.mdi-presentation-play::before {
  content: "\\F0429"; }

.mdi-pretzel::before {
  content: "\\F1562"; }

.mdi-printer::before {
  content: "\\F042A"; }

.mdi-printer-3d::before {
  content: "\\F042B"; }

.mdi-printer-3d-nozzle::before {
  content: "\\F0E5B"; }

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F11C0"; }

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F11C1"; }

.mdi-printer-3d-nozzle-outline::before {
  content: "\\F0E5C"; }

.mdi-printer-alert::before {
  content: "\\F042C"; }

.mdi-printer-check::before {
  content: "\\F1146"; }

.mdi-printer-eye::before {
  content: "\\F1458"; }

.mdi-printer-off::before {
  content: "\\F0E5D"; }

.mdi-printer-pos::before {
  content: "\\F1057"; }

.mdi-printer-search::before {
  content: "\\F1457"; }

.mdi-printer-settings::before {
  content: "\\F0707"; }

.mdi-printer-wireless::before {
  content: "\\F0A0B"; }

.mdi-priority-high::before {
  content: "\\F0603"; }

.mdi-priority-low::before {
  content: "\\F0604"; }

.mdi-professional-hexagon::before {
  content: "\\F042D"; }

.mdi-progress-alert::before {
  content: "\\F0CBC"; }

.mdi-progress-check::before {
  content: "\\F0995"; }

.mdi-progress-clock::before {
  content: "\\F0996"; }

.mdi-progress-close::before {
  content: "\\F110A"; }

.mdi-progress-download::before {
  content: "\\F0997"; }

.mdi-progress-question::before {
  content: "\\F1522"; }

.mdi-progress-upload::before {
  content: "\\F0998"; }

.mdi-progress-wrench::before {
  content: "\\F0CBD"; }

.mdi-projector::before {
  content: "\\F042E"; }

.mdi-projector-screen::before {
  content: "\\F042F"; }

.mdi-propane-tank::before {
  content: "\\F1357"; }

.mdi-propane-tank-outline::before {
  content: "\\F1358"; }

.mdi-protocol::before {
  content: "\\F0FD8"; }

.mdi-publish::before {
  content: "\\F06A7"; }

.mdi-pulse::before {
  content: "\\F0430"; }

.mdi-pump::before {
  content: "\\F1402"; }

.mdi-pumpkin::before {
  content: "\\F0BBF"; }

.mdi-purse::before {
  content: "\\F0F1C"; }

.mdi-purse-outline::before {
  content: "\\F0F1D"; }

.mdi-puzzle::before {
  content: "\\F0431"; }

.mdi-puzzle-check::before {
  content: "\\F1426"; }

.mdi-puzzle-check-outline::before {
  content: "\\F1427"; }

.mdi-puzzle-edit::before {
  content: "\\F14D3"; }

.mdi-puzzle-edit-outline::before {
  content: "\\F14D9"; }

.mdi-puzzle-heart::before {
  content: "\\F14D4"; }

.mdi-puzzle-heart-outline::before {
  content: "\\F14DA"; }

.mdi-puzzle-minus::before {
  content: "\\F14D1"; }

.mdi-puzzle-minus-outline::before {
  content: "\\F14D7"; }

.mdi-puzzle-outline::before {
  content: "\\F0A66"; }

.mdi-puzzle-plus::before {
  content: "\\F14D0"; }

.mdi-puzzle-plus-outline::before {
  content: "\\F14D6"; }

.mdi-puzzle-remove::before {
  content: "\\F14D2"; }

.mdi-puzzle-remove-outline::before {
  content: "\\F14D8"; }

.mdi-puzzle-star::before {
  content: "\\F14D5"; }

.mdi-puzzle-star-outline::before {
  content: "\\F14DB"; }

.mdi-qi::before {
  content: "\\F0999"; }

.mdi-qqchat::before {
  content: "\\F0605"; }

.mdi-qrcode::before {
  content: "\\F0432"; }

.mdi-qrcode-edit::before {
  content: "\\F08B8"; }

.mdi-qrcode-minus::before {
  content: "\\F118C"; }

.mdi-qrcode-plus::before {
  content: "\\F118B"; }

.mdi-qrcode-remove::before {
  content: "\\F118D"; }

.mdi-qrcode-scan::before {
  content: "\\F0433"; }

.mdi-quadcopter::before {
  content: "\\F0434"; }

.mdi-quality-high::before {
  content: "\\F0435"; }

.mdi-quality-low::before {
  content: "\\F0A0C"; }

.mdi-quality-medium::before {
  content: "\\F0A0D"; }

.mdi-quora::before {
  content: "\\F0D29"; }

.mdi-rabbit::before {
  content: "\\F0907"; }

.mdi-racing-helmet::before {
  content: "\\F0D93"; }

.mdi-racquetball::before {
  content: "\\F0D94"; }

.mdi-radar::before {
  content: "\\F0437"; }

.mdi-radiator::before {
  content: "\\F0438"; }

.mdi-radiator-disabled::before {
  content: "\\F0AD7"; }

.mdi-radiator-off::before {
  content: "\\F0AD8"; }

.mdi-radio::before {
  content: "\\F0439"; }

.mdi-radio-am::before {
  content: "\\F0CBE"; }

.mdi-radio-fm::before {
  content: "\\F0CBF"; }

.mdi-radio-handheld::before {
  content: "\\F043A"; }

.mdi-radio-off::before {
  content: "\\F121C"; }

.mdi-radio-tower::before {
  content: "\\F043B"; }

.mdi-radioactive::before {
  content: "\\F043C"; }

.mdi-radioactive-off::before {
  content: "\\F0EC1"; }

.mdi-radiobox-blank::before {
  content: "\\F043D"; }

.mdi-radiobox-marked::before {
  content: "\\F043E"; }

.mdi-radiology-box::before {
  content: "\\F14C5"; }

.mdi-radiology-box-outline::before {
  content: "\\F14C6"; }

.mdi-radius::before {
  content: "\\F0CC0"; }

.mdi-radius-outline::before {
  content: "\\F0CC1"; }

.mdi-railroad-light::before {
  content: "\\F0F1E"; }

.mdi-rake::before {
  content: "\\F1544"; }

.mdi-raspberry-pi::before {
  content: "\\F043F"; }

.mdi-ray-end::before {
  content: "\\F0440"; }

.mdi-ray-end-arrow::before {
  content: "\\F0441"; }

.mdi-ray-start::before {
  content: "\\F0442"; }

.mdi-ray-start-arrow::before {
  content: "\\F0443"; }

.mdi-ray-start-end::before {
  content: "\\F0444"; }

.mdi-ray-start-vertex-end::before {
  content: "\\F15D8"; }

.mdi-ray-vertex::before {
  content: "\\F0445"; }

.mdi-react::before {
  content: "\\F0708"; }

.mdi-read::before {
  content: "\\F0447"; }

.mdi-receipt::before {
  content: "\\F0449"; }

.mdi-record::before {
  content: "\\F044A"; }

.mdi-record-circle::before {
  content: "\\F0EC2"; }

.mdi-record-circle-outline::before {
  content: "\\F0EC3"; }

.mdi-record-player::before {
  content: "\\F099A"; }

.mdi-record-rec::before {
  content: "\\F044B"; }

.mdi-rectangle::before {
  content: "\\F0E5E"; }

.mdi-rectangle-outline::before {
  content: "\\F0E5F"; }

.mdi-recycle::before {
  content: "\\F044C"; }

.mdi-recycle-variant::before {
  content: "\\F139D"; }

.mdi-reddit::before {
  content: "\\F044D"; }

.mdi-redhat::before {
  content: "\\F111B"; }

.mdi-redo::before {
  content: "\\F044E"; }

.mdi-redo-variant::before {
  content: "\\F044F"; }

.mdi-reflect-horizontal::before {
  content: "\\F0A0E"; }

.mdi-reflect-vertical::before {
  content: "\\F0A0F"; }

.mdi-refresh::before {
  content: "\\F0450"; }

.mdi-refresh-circle::before {
  content: "\\F1377"; }

.mdi-regex::before {
  content: "\\F0451"; }

.mdi-registered-trademark::before {
  content: "\\F0A67"; }

.mdi-reiterate::before {
  content: "\\F1588"; }

.mdi-relation-many-to-many::before {
  content: "\\F1496"; }

.mdi-relation-many-to-one::before {
  content: "\\F1497"; }

.mdi-relation-many-to-one-or-many::before {
  content: "\\F1498"; }

.mdi-relation-many-to-only-one::before {
  content: "\\F1499"; }

.mdi-relation-many-to-zero-or-many::before {
  content: "\\F149A"; }

.mdi-relation-many-to-zero-or-one::before {
  content: "\\F149B"; }

.mdi-relation-one-or-many-to-many::before {
  content: "\\F149C"; }

.mdi-relation-one-or-many-to-one::before {
  content: "\\F149D"; }

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\F149E"; }

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\F149F"; }

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\F14A0"; }

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\F14A1"; }

.mdi-relation-one-to-many::before {
  content: "\\F14A2"; }

.mdi-relation-one-to-one::before {
  content: "\\F14A3"; }

.mdi-relation-one-to-one-or-many::before {
  content: "\\F14A4"; }

.mdi-relation-one-to-only-one::before {
  content: "\\F14A5"; }

.mdi-relation-one-to-zero-or-many::before {
  content: "\\F14A6"; }

.mdi-relation-one-to-zero-or-one::before {
  content: "\\F14A7"; }

.mdi-relation-only-one-to-many::before {
  content: "\\F14A8"; }

.mdi-relation-only-one-to-one::before {
  content: "\\F14A9"; }

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\F14AA"; }

.mdi-relation-only-one-to-only-one::before {
  content: "\\F14AB"; }

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\F14AC"; }

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\F14AD"; }

.mdi-relation-zero-or-many-to-many::before {
  content: "\\F14AE"; }

.mdi-relation-zero-or-many-to-one::before {
  content: "\\F14AF"; }

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\F14B0"; }

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\F14B1"; }

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\F14B2"; }

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\F14B3"; }

.mdi-relation-zero-or-one-to-many::before {
  content: "\\F14B4"; }

.mdi-relation-zero-or-one-to-one::before {
  content: "\\F14B5"; }

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\F14B6"; }

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\F14B7"; }

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\F14B8"; }

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\F14B9"; }

.mdi-relative-scale::before {
  content: "\\F0452"; }

.mdi-reload::before {
  content: "\\F0453"; }

.mdi-reload-alert::before {
  content: "\\F110B"; }

.mdi-reminder::before {
  content: "\\F088C"; }

.mdi-remote::before {
  content: "\\F0454"; }

.mdi-remote-desktop::before {
  content: "\\F08B9"; }

.mdi-remote-off::before {
  content: "\\F0EC4"; }

.mdi-remote-tv::before {
  content: "\\F0EC5"; }

.mdi-remote-tv-off::before {
  content: "\\F0EC6"; }

.mdi-rename-box::before {
  content: "\\F0455"; }

.mdi-reorder-horizontal::before {
  content: "\\F0688"; }

.mdi-reorder-vertical::before {
  content: "\\F0689"; }

.mdi-repeat::before {
  content: "\\F0456"; }

.mdi-repeat-off::before {
  content: "\\F0457"; }

.mdi-repeat-once::before {
  content: "\\F0458"; }

.mdi-replay::before {
  content: "\\F0459"; }

.mdi-reply::before {
  content: "\\F045A"; }

.mdi-reply-all::before {
  content: "\\F045B"; }

.mdi-reply-all-outline::before {
  content: "\\F0F1F"; }

.mdi-reply-circle::before {
  content: "\\F11AE"; }

.mdi-reply-outline::before {
  content: "\\F0F20"; }

.mdi-reproduction::before {
  content: "\\F045C"; }

.mdi-resistor::before {
  content: "\\F0B44"; }

.mdi-resistor-nodes::before {
  content: "\\F0B45"; }

.mdi-resize::before {
  content: "\\F0A68"; }

.mdi-resize-bottom-right::before {
  content: "\\F045D"; }

.mdi-responsive::before {
  content: "\\F045E"; }

.mdi-restart::before {
  content: "\\F0709"; }

.mdi-restart-alert::before {
  content: "\\F110C"; }

.mdi-restart-off::before {
  content: "\\F0D95"; }

.mdi-restore::before {
  content: "\\F099B"; }

.mdi-restore-alert::before {
  content: "\\F110D"; }

.mdi-rewind::before {
  content: "\\F045F"; }

.mdi-rewind-10::before {
  content: "\\F0D2A"; }

.mdi-rewind-30::before {
  content: "\\F0D96"; }

.mdi-rewind-5::before {
  content: "\\F11F9"; }

.mdi-rewind-60::before {
  content: "\\F160C"; }

.mdi-rewind-outline::before {
  content: "\\F070A"; }

.mdi-rhombus::before {
  content: "\\F070B"; }

.mdi-rhombus-medium::before {
  content: "\\F0A10"; }

.mdi-rhombus-medium-outline::before {
  content: "\\F14DC"; }

.mdi-rhombus-outline::before {
  content: "\\F070C"; }

.mdi-rhombus-split::before {
  content: "\\F0A11"; }

.mdi-rhombus-split-outline::before {
  content: "\\F14DD"; }

.mdi-ribbon::before {
  content: "\\F0460"; }

.mdi-rice::before {
  content: "\\F07EA"; }

.mdi-rickshaw::before {
  content: "\\F15BB"; }

.mdi-rickshaw-electric::before {
  content: "\\F15BC"; }

.mdi-ring::before {
  content: "\\F07EB"; }

.mdi-rivet::before {
  content: "\\F0E60"; }

.mdi-road::before {
  content: "\\F0461"; }

.mdi-road-variant::before {
  content: "\\F0462"; }

.mdi-robber::before {
  content: "\\F1058"; }

.mdi-robot::before {
  content: "\\F06A9"; }

.mdi-robot-angry::before {
  content: "\\F169D"; }

.mdi-robot-angry-outline::before {
  content: "\\F169E"; }

.mdi-robot-confused::before {
  content: "\\F169F"; }

.mdi-robot-confused-outline::before {
  content: "\\F16A0"; }

.mdi-robot-dead::before {
  content: "\\F16A1"; }

.mdi-robot-dead-outline::before {
  content: "\\F16A2"; }

.mdi-robot-excited::before {
  content: "\\F16A3"; }

.mdi-robot-excited-outline::before {
  content: "\\F16A4"; }

.mdi-robot-industrial::before {
  content: "\\F0B46"; }

.mdi-robot-love::before {
  content: "\\F16A5"; }

.mdi-robot-love-outline::before {
  content: "\\F16A6"; }

.mdi-robot-mower::before {
  content: "\\F11F7"; }

.mdi-robot-mower-outline::before {
  content: "\\F11F3"; }

.mdi-robot-off::before {
  content: "\\F16A7"; }

.mdi-robot-off-outline::before {
  content: "\\F167B"; }

.mdi-robot-outline::before {
  content: "\\F167A"; }

.mdi-robot-vacuum::before {
  content: "\\F070D"; }

.mdi-robot-vacuum-variant::before {
  content: "\\F0908"; }

.mdi-rocket::before {
  content: "\\F0463"; }

.mdi-rocket-launch::before {
  content: "\\F14DE"; }

.mdi-rocket-launch-outline::before {
  content: "\\F14DF"; }

.mdi-rocket-outline::before {
  content: "\\F13AF"; }

.mdi-rodent::before {
  content: "\\F1327"; }

.mdi-roller-skate::before {
  content: "\\F0D2B"; }

.mdi-roller-skate-off::before {
  content: "\\F0145"; }

.mdi-rollerblade::before {
  content: "\\F0D2C"; }

.mdi-rollerblade-off::before {
  content: "\\F002E"; }

.mdi-rollupjs::before {
  content: "\\F0BC0"; }

.mdi-roman-numeral-1::before {
  content: "\\F1088"; }

.mdi-roman-numeral-10::before {
  content: "\\F1091"; }

.mdi-roman-numeral-2::before {
  content: "\\F1089"; }

.mdi-roman-numeral-3::before {
  content: "\\F108A"; }

.mdi-roman-numeral-4::before {
  content: "\\F108B"; }

.mdi-roman-numeral-5::before {
  content: "\\F108C"; }

.mdi-roman-numeral-6::before {
  content: "\\F108D"; }

.mdi-roman-numeral-7::before {
  content: "\\F108E"; }

.mdi-roman-numeral-8::before {
  content: "\\F108F"; }

.mdi-roman-numeral-9::before {
  content: "\\F1090"; }

.mdi-room-service::before {
  content: "\\F088D"; }

.mdi-room-service-outline::before {
  content: "\\F0D97"; }

.mdi-rotate-3d::before {
  content: "\\F0EC7"; }

.mdi-rotate-3d-variant::before {
  content: "\\F0464"; }

.mdi-rotate-left::before {
  content: "\\F0465"; }

.mdi-rotate-left-variant::before {
  content: "\\F0466"; }

.mdi-rotate-orbit::before {
  content: "\\F0D98"; }

.mdi-rotate-right::before {
  content: "\\F0467"; }

.mdi-rotate-right-variant::before {
  content: "\\F0468"; }

.mdi-rounded-corner::before {
  content: "\\F0607"; }

.mdi-router::before {
  content: "\\F11E2"; }

.mdi-router-network::before {
  content: "\\F1087"; }

.mdi-router-wireless::before {
  content: "\\F0469"; }

.mdi-router-wireless-off::before {
  content: "\\F15A3"; }

.mdi-router-wireless-settings::before {
  content: "\\F0A69"; }

.mdi-routes::before {
  content: "\\F046A"; }

.mdi-routes-clock::before {
  content: "\\F1059"; }

.mdi-rowing::before {
  content: "\\F0608"; }

.mdi-rss::before {
  content: "\\F046B"; }

.mdi-rss-box::before {
  content: "\\F046C"; }

.mdi-rss-off::before {
  content: "\\F0F21"; }

.mdi-rug::before {
  content: "\\F1475"; }

.mdi-rugby::before {
  content: "\\F0D99"; }

.mdi-ruler::before {
  content: "\\F046D"; }

.mdi-ruler-square::before {
  content: "\\F0CC2"; }

.mdi-ruler-square-compass::before {
  content: "\\F0EBE"; }

.mdi-run::before {
  content: "\\F070E"; }

.mdi-run-fast::before {
  content: "\\F046E"; }

.mdi-rv-truck::before {
  content: "\\F11D4"; }

.mdi-sack::before {
  content: "\\F0D2E"; }

.mdi-sack-percent::before {
  content: "\\F0D2F"; }

.mdi-safe::before {
  content: "\\F0A6A"; }

.mdi-safe-square::before {
  content: "\\F127C"; }

.mdi-safe-square-outline::before {
  content: "\\F127D"; }

.mdi-safety-goggles::before {
  content: "\\F0D30"; }

.mdi-sail-boat::before {
  content: "\\F0EC8"; }

.mdi-sale::before {
  content: "\\F046F"; }

.mdi-salesforce::before {
  content: "\\F088E"; }

.mdi-sass::before {
  content: "\\F07EC"; }

.mdi-satellite::before {
  content: "\\F0470"; }

.mdi-satellite-uplink::before {
  content: "\\F0909"; }

.mdi-satellite-variant::before {
  content: "\\F0471"; }

.mdi-sausage::before {
  content: "\\F08BA"; }

.mdi-saw-blade::before {
  content: "\\F0E61"; }

.mdi-sawtooth-wave::before {
  content: "\\F147A"; }

.mdi-saxophone::before {
  content: "\\F0609"; }

.mdi-scale::before {
  content: "\\F0472"; }

.mdi-scale-balance::before {
  content: "\\F05D1"; }

.mdi-scale-bathroom::before {
  content: "\\F0473"; }

.mdi-scale-off::before {
  content: "\\F105A"; }

.mdi-scan-helper::before {
  content: "\\F13D8"; }

.mdi-scanner::before {
  content: "\\F06AB"; }

.mdi-scanner-off::before {
  content: "\\F090A"; }

.mdi-scatter-plot::before {
  content: "\\F0EC9"; }

.mdi-scatter-plot-outline::before {
  content: "\\F0ECA"; }

.mdi-school::before {
  content: "\\F0474"; }

.mdi-school-outline::before {
  content: "\\F1180"; }

.mdi-scissors-cutting::before {
  content: "\\F0A6B"; }

.mdi-scooter::before {
  content: "\\F15BD"; }

.mdi-scooter-electric::before {
  content: "\\F15BE"; }

.mdi-scoreboard::before {
  content: "\\F127E"; }

.mdi-scoreboard-outline::before {
  content: "\\F127F"; }

.mdi-screen-rotation::before {
  content: "\\F0475"; }

.mdi-screen-rotation-lock::before {
  content: "\\F0478"; }

.mdi-screw-flat-top::before {
  content: "\\F0DF3"; }

.mdi-screw-lag::before {
  content: "\\F0DF4"; }

.mdi-screw-machine-flat-top::before {
  content: "\\F0DF5"; }

.mdi-screw-machine-round-top::before {
  content: "\\F0DF6"; }

.mdi-screw-round-top::before {
  content: "\\F0DF7"; }

.mdi-screwdriver::before {
  content: "\\F0476"; }

.mdi-script::before {
  content: "\\F0BC1"; }

.mdi-script-outline::before {
  content: "\\F0477"; }

.mdi-script-text::before {
  content: "\\F0BC2"; }

.mdi-script-text-outline::before {
  content: "\\F0BC3"; }

.mdi-sd::before {
  content: "\\F0479"; }

.mdi-seal::before {
  content: "\\F047A"; }

.mdi-seal-variant::before {
  content: "\\F0FD9"; }

.mdi-search-web::before {
  content: "\\F070F"; }

.mdi-seat::before {
  content: "\\F0CC3"; }

.mdi-seat-flat::before {
  content: "\\F047B"; }

.mdi-seat-flat-angled::before {
  content: "\\F047C"; }

.mdi-seat-individual-suite::before {
  content: "\\F047D"; }

.mdi-seat-legroom-extra::before {
  content: "\\F047E"; }

.mdi-seat-legroom-normal::before {
  content: "\\F047F"; }

.mdi-seat-legroom-reduced::before {
  content: "\\F0480"; }

.mdi-seat-outline::before {
  content: "\\F0CC4"; }

.mdi-seat-passenger::before {
  content: "\\F1249"; }

.mdi-seat-recline-extra::before {
  content: "\\F0481"; }

.mdi-seat-recline-normal::before {
  content: "\\F0482"; }

.mdi-seatbelt::before {
  content: "\\F0CC5"; }

.mdi-security::before {
  content: "\\F0483"; }

.mdi-security-network::before {
  content: "\\F0484"; }

.mdi-seed::before {
  content: "\\F0E62"; }

.mdi-seed-off::before {
  content: "\\F13FD"; }

.mdi-seed-off-outline::before {
  content: "\\F13FE"; }

.mdi-seed-outline::before {
  content: "\\F0E63"; }

.mdi-seesaw::before {
  content: "\\F15A4"; }

.mdi-segment::before {
  content: "\\F0ECB"; }

.mdi-select::before {
  content: "\\F0485"; }

.mdi-select-all::before {
  content: "\\F0486"; }

.mdi-select-color::before {
  content: "\\F0D31"; }

.mdi-select-compare::before {
  content: "\\F0AD9"; }

.mdi-select-drag::before {
  content: "\\F0A6C"; }

.mdi-select-group::before {
  content: "\\F0F82"; }

.mdi-select-inverse::before {
  content: "\\F0487"; }

.mdi-select-marker::before {
  content: "\\F1280"; }

.mdi-select-multiple::before {
  content: "\\F1281"; }

.mdi-select-multiple-marker::before {
  content: "\\F1282"; }

.mdi-select-off::before {
  content: "\\F0488"; }

.mdi-select-place::before {
  content: "\\F0FDA"; }

.mdi-select-search::before {
  content: "\\F1204"; }

.mdi-selection::before {
  content: "\\F0489"; }

.mdi-selection-drag::before {
  content: "\\F0A6D"; }

.mdi-selection-ellipse::before {
  content: "\\F0D32"; }

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\F0F22"; }

.mdi-selection-marker::before {
  content: "\\F1283"; }

.mdi-selection-multiple::before {
  content: "\\F1285"; }

.mdi-selection-multiple-marker::before {
  content: "\\F1284"; }

.mdi-selection-off::before {
  content: "\\F0777"; }

.mdi-selection-search::before {
  content: "\\F1205"; }

.mdi-semantic-web::before {
  content: "\\F1316"; }

.mdi-send::before {
  content: "\\F048A"; }

.mdi-send-check::before {
  content: "\\F1161"; }

.mdi-send-check-outline::before {
  content: "\\F1162"; }

.mdi-send-circle::before {
  content: "\\F0DF8"; }

.mdi-send-circle-outline::before {
  content: "\\F0DF9"; }

.mdi-send-clock::before {
  content: "\\F1163"; }

.mdi-send-clock-outline::before {
  content: "\\F1164"; }

.mdi-send-lock::before {
  content: "\\F07ED"; }

.mdi-send-lock-outline::before {
  content: "\\F1166"; }

.mdi-send-outline::before {
  content: "\\F1165"; }

.mdi-serial-port::before {
  content: "\\F065C"; }

.mdi-server::before {
  content: "\\F048B"; }

.mdi-server-minus::before {
  content: "\\F048C"; }

.mdi-server-network::before {
  content: "\\F048D"; }

.mdi-server-network-off::before {
  content: "\\F048E"; }

.mdi-server-off::before {
  content: "\\F048F"; }

.mdi-server-plus::before {
  content: "\\F0490"; }

.mdi-server-remove::before {
  content: "\\F0491"; }

.mdi-server-security::before {
  content: "\\F0492"; }

.mdi-set-all::before {
  content: "\\F0778"; }

.mdi-set-center::before {
  content: "\\F0779"; }

.mdi-set-center-right::before {
  content: "\\F077A"; }

.mdi-set-left::before {
  content: "\\F077B"; }

.mdi-set-left-center::before {
  content: "\\F077C"; }

.mdi-set-left-right::before {
  content: "\\F077D"; }

.mdi-set-merge::before {
  content: "\\F14E0"; }

.mdi-set-none::before {
  content: "\\F077E"; }

.mdi-set-right::before {
  content: "\\F077F"; }

.mdi-set-split::before {
  content: "\\F14E1"; }

.mdi-set-square::before {
  content: "\\F145D"; }

.mdi-set-top-box::before {
  content: "\\F099F"; }

.mdi-settings-helper::before {
  content: "\\F0A6E"; }

.mdi-shaker::before {
  content: "\\F110E"; }

.mdi-shaker-outline::before {
  content: "\\F110F"; }

.mdi-shape::before {
  content: "\\F0831"; }

.mdi-shape-circle-plus::before {
  content: "\\F065D"; }

.mdi-shape-outline::before {
  content: "\\F0832"; }

.mdi-shape-oval-plus::before {
  content: "\\F11FA"; }

.mdi-shape-plus::before {
  content: "\\F0495"; }

.mdi-shape-polygon-plus::before {
  content: "\\F065E"; }

.mdi-shape-rectangle-plus::before {
  content: "\\F065F"; }

.mdi-shape-square-plus::before {
  content: "\\F0660"; }

.mdi-shape-square-rounded-plus::before {
  content: "\\F14FA"; }

.mdi-share::before {
  content: "\\F0496"; }

.mdi-share-all::before {
  content: "\\F11F4"; }

.mdi-share-all-outline::before {
  content: "\\F11F5"; }

.mdi-share-circle::before {
  content: "\\F11AD"; }

.mdi-share-off::before {
  content: "\\F0F23"; }

.mdi-share-off-outline::before {
  content: "\\F0F24"; }

.mdi-share-outline::before {
  content: "\\F0932"; }

.mdi-share-variant::before {
  content: "\\F0497"; }

.mdi-share-variant-outline::before {
  content: "\\F1514"; }

.mdi-shark-fin::before {
  content: "\\F1673"; }

.mdi-shark-fin-outline::before {
  content: "\\F1674"; }

.mdi-sheep::before {
  content: "\\F0CC6"; }

.mdi-shield::before {
  content: "\\F0498"; }

.mdi-shield-account::before {
  content: "\\F088F"; }

.mdi-shield-account-outline::before {
  content: "\\F0A12"; }

.mdi-shield-account-variant::before {
  content: "\\F15A7"; }

.mdi-shield-account-variant-outline::before {
  content: "\\F15A8"; }

.mdi-shield-airplane::before {
  content: "\\F06BB"; }

.mdi-shield-airplane-outline::before {
  content: "\\F0CC7"; }

.mdi-shield-alert::before {
  content: "\\F0ECC"; }

.mdi-shield-alert-outline::before {
  content: "\\F0ECD"; }

.mdi-shield-bug::before {
  content: "\\F13DA"; }

.mdi-shield-bug-outline::before {
  content: "\\F13DB"; }

.mdi-shield-car::before {
  content: "\\F0F83"; }

.mdi-shield-check::before {
  content: "\\F0565"; }

.mdi-shield-check-outline::before {
  content: "\\F0CC8"; }

.mdi-shield-cross::before {
  content: "\\F0CC9"; }

.mdi-shield-cross-outline::before {
  content: "\\F0CCA"; }

.mdi-shield-edit::before {
  content: "\\F11A0"; }

.mdi-shield-edit-outline::before {
  content: "\\F11A1"; }

.mdi-shield-half::before {
  content: "\\F1360"; }

.mdi-shield-half-full::before {
  content: "\\F0780"; }

.mdi-shield-home::before {
  content: "\\F068A"; }

.mdi-shield-home-outline::before {
  content: "\\F0CCB"; }

.mdi-shield-key::before {
  content: "\\F0BC4"; }

.mdi-shield-key-outline::before {
  content: "\\F0BC5"; }

.mdi-shield-link-variant::before {
  content: "\\F0D33"; }

.mdi-shield-link-variant-outline::before {
  content: "\\F0D34"; }

.mdi-shield-lock::before {
  content: "\\F099D"; }

.mdi-shield-lock-outline::before {
  content: "\\F0CCC"; }

.mdi-shield-off::before {
  content: "\\F099E"; }

.mdi-shield-off-outline::before {
  content: "\\F099C"; }

.mdi-shield-outline::before {
  content: "\\F0499"; }

.mdi-shield-plus::before {
  content: "\\F0ADA"; }

.mdi-shield-plus-outline::before {
  content: "\\F0ADB"; }

.mdi-shield-refresh::before {
  content: "\\F00AA"; }

.mdi-shield-refresh-outline::before {
  content: "\\F01E0"; }

.mdi-shield-remove::before {
  content: "\\F0ADC"; }

.mdi-shield-remove-outline::before {
  content: "\\F0ADD"; }

.mdi-shield-search::before {
  content: "\\F0D9A"; }

.mdi-shield-star::before {
  content: "\\F113B"; }

.mdi-shield-star-outline::before {
  content: "\\F113C"; }

.mdi-shield-sun::before {
  content: "\\F105D"; }

.mdi-shield-sun-outline::before {
  content: "\\F105E"; }

.mdi-shield-sync::before {
  content: "\\F11A2"; }

.mdi-shield-sync-outline::before {
  content: "\\F11A3"; }

.mdi-ship-wheel::before {
  content: "\\F0833"; }

.mdi-shoe-ballet::before {
  content: "\\F15CA"; }

.mdi-shoe-cleat::before {
  content: "\\F15C7"; }

.mdi-shoe-formal::before {
  content: "\\F0B47"; }

.mdi-shoe-heel::before {
  content: "\\F0B48"; }

.mdi-shoe-print::before {
  content: "\\F0DFA"; }

.mdi-shoe-sneaker::before {
  content: "\\F15C8"; }

.mdi-shopping::before {
  content: "\\F049A"; }

.mdi-shopping-music::before {
  content: "\\F049B"; }

.mdi-shopping-outline::before {
  content: "\\F11D5"; }

.mdi-shopping-search::before {
  content: "\\F0F84"; }

.mdi-shore::before {
  content: "\\F14F9"; }

.mdi-shovel::before {
  content: "\\F0710"; }

.mdi-shovel-off::before {
  content: "\\F0711"; }

.mdi-shower::before {
  content: "\\F09A0"; }

.mdi-shower-head::before {
  content: "\\F09A1"; }

.mdi-shredder::before {
  content: "\\F049C"; }

.mdi-shuffle::before {
  content: "\\F049D"; }

.mdi-shuffle-disabled::before {
  content: "\\F049E"; }

.mdi-shuffle-variant::before {
  content: "\\F049F"; }

.mdi-shuriken::before {
  content: "\\F137F"; }

.mdi-sigma::before {
  content: "\\F04A0"; }

.mdi-sigma-lower::before {
  content: "\\F062B"; }

.mdi-sign-caution::before {
  content: "\\F04A1"; }

.mdi-sign-direction::before {
  content: "\\F0781"; }

.mdi-sign-direction-minus::before {
  content: "\\F1000"; }

.mdi-sign-direction-plus::before {
  content: "\\F0FDC"; }

.mdi-sign-direction-remove::before {
  content: "\\F0FDD"; }

.mdi-sign-pole::before {
  content: "\\F14F8"; }

.mdi-sign-real-estate::before {
  content: "\\F1118"; }

.mdi-sign-text::before {
  content: "\\F0782"; }

.mdi-signal::before {
  content: "\\F04A2"; }

.mdi-signal-2g::before {
  content: "\\F0712"; }

.mdi-signal-3g::before {
  content: "\\F0713"; }

.mdi-signal-4g::before {
  content: "\\F0714"; }

.mdi-signal-5g::before {
  content: "\\F0A6F"; }

.mdi-signal-cellular-1::before {
  content: "\\F08BC"; }

.mdi-signal-cellular-2::before {
  content: "\\F08BD"; }

.mdi-signal-cellular-3::before {
  content: "\\F08BE"; }

.mdi-signal-cellular-outline::before {
  content: "\\F08BF"; }

.mdi-signal-distance-variant::before {
  content: "\\F0E64"; }

.mdi-signal-hspa::before {
  content: "\\F0715"; }

.mdi-signal-hspa-plus::before {
  content: "\\F0716"; }

.mdi-signal-off::before {
  content: "\\F0783"; }

.mdi-signal-variant::before {
  content: "\\F060A"; }

.mdi-signature::before {
  content: "\\F0DFB"; }

.mdi-signature-freehand::before {
  content: "\\F0DFC"; }

.mdi-signature-image::before {
  content: "\\F0DFD"; }

.mdi-signature-text::before {
  content: "\\F0DFE"; }

.mdi-silo::before {
  content: "\\F0B49"; }

.mdi-silverware::before {
  content: "\\F04A3"; }

.mdi-silverware-clean::before {
  content: "\\F0FDE"; }

.mdi-silverware-fork::before {
  content: "\\F04A4"; }

.mdi-silverware-fork-knife::before {
  content: "\\F0A70"; }

.mdi-silverware-spoon::before {
  content: "\\F04A5"; }

.mdi-silverware-variant::before {
  content: "\\F04A6"; }

.mdi-sim::before {
  content: "\\F04A7"; }

.mdi-sim-alert::before {
  content: "\\F04A8"; }

.mdi-sim-alert-outline::before {
  content: "\\F15D3"; }

.mdi-sim-off::before {
  content: "\\F04A9"; }

.mdi-sim-off-outline::before {
  content: "\\F15D4"; }

.mdi-sim-outline::before {
  content: "\\F15D5"; }

.mdi-simple-icons::before {
  content: "\\F131D"; }

.mdi-sina-weibo::before {
  content: "\\F0ADF"; }

.mdi-sine-wave::before {
  content: "\\F095B"; }

.mdi-sitemap::before {
  content: "\\F04AA"; }

.mdi-size-l::before {
  content: "\\F13A6"; }

.mdi-size-m::before {
  content: "\\F13A5"; }

.mdi-size-s::before {
  content: "\\F13A4"; }

.mdi-size-xl::before {
  content: "\\F13A7"; }

.mdi-size-xs::before {
  content: "\\F13A3"; }

.mdi-size-xxl::before {
  content: "\\F13A8"; }

.mdi-size-xxs::before {
  content: "\\F13A2"; }

.mdi-size-xxxl::before {
  content: "\\F13A9"; }

.mdi-skate::before {
  content: "\\F0D35"; }

.mdi-skateboard::before {
  content: "\\F14C2"; }

.mdi-skew-less::before {
  content: "\\F0D36"; }

.mdi-skew-more::before {
  content: "\\F0D37"; }

.mdi-ski::before {
  content: "\\F1304"; }

.mdi-ski-cross-country::before {
  content: "\\F1305"; }

.mdi-ski-water::before {
  content: "\\F1306"; }

.mdi-skip-backward::before {
  content: "\\F04AB"; }

.mdi-skip-backward-outline::before {
  content: "\\F0F25"; }

.mdi-skip-forward::before {
  content: "\\F04AC"; }

.mdi-skip-forward-outline::before {
  content: "\\F0F26"; }

.mdi-skip-next::before {
  content: "\\F04AD"; }

.mdi-skip-next-circle::before {
  content: "\\F0661"; }

.mdi-skip-next-circle-outline::before {
  content: "\\F0662"; }

.mdi-skip-next-outline::before {
  content: "\\F0F27"; }

.mdi-skip-previous::before {
  content: "\\F04AE"; }

.mdi-skip-previous-circle::before {
  content: "\\F0663"; }

.mdi-skip-previous-circle-outline::before {
  content: "\\F0664"; }

.mdi-skip-previous-outline::before {
  content: "\\F0F28"; }

.mdi-skull::before {
  content: "\\F068C"; }

.mdi-skull-crossbones::before {
  content: "\\F0BC6"; }

.mdi-skull-crossbones-outline::before {
  content: "\\F0BC7"; }

.mdi-skull-outline::before {
  content: "\\F0BC8"; }

.mdi-skull-scan::before {
  content: "\\F14C7"; }

.mdi-skull-scan-outline::before {
  content: "\\F14C8"; }

.mdi-skype::before {
  content: "\\F04AF"; }

.mdi-skype-business::before {
  content: "\\F04B0"; }

.mdi-slack::before {
  content: "\\F04B1"; }

.mdi-slash-forward::before {
  content: "\\F0FDF"; }

.mdi-slash-forward-box::before {
  content: "\\F0FE0"; }

.mdi-sleep::before {
  content: "\\F04B2"; }

.mdi-sleep-off::before {
  content: "\\F04B3"; }

.mdi-slide::before {
  content: "\\F15A5"; }

.mdi-slope-downhill::before {
  content: "\\F0DFF"; }

.mdi-slope-uphill::before {
  content: "\\F0E00"; }

.mdi-slot-machine::before {
  content: "\\F1114"; }

.mdi-slot-machine-outline::before {
  content: "\\F1115"; }

.mdi-smart-card::before {
  content: "\\F10BD"; }

.mdi-smart-card-outline::before {
  content: "\\F10BE"; }

.mdi-smart-card-reader::before {
  content: "\\F10BF"; }

.mdi-smart-card-reader-outline::before {
  content: "\\F10C0"; }

.mdi-smog::before {
  content: "\\F0A71"; }

.mdi-smoke-detector::before {
  content: "\\F0392"; }

.mdi-smoking::before {
  content: "\\F04B4"; }

.mdi-smoking-off::before {
  content: "\\F04B5"; }

.mdi-smoking-pipe::before {
  content: "\\F140D"; }

.mdi-smoking-pipe-off::before {
  content: "\\F1428"; }

.mdi-snail::before {
  content: "\\F1677"; }

.mdi-snake::before {
  content: "\\F150E"; }

.mdi-snapchat::before {
  content: "\\F04B6"; }

.mdi-snowboard::before {
  content: "\\F1307"; }

.mdi-snowflake::before {
  content: "\\F0717"; }

.mdi-snowflake-alert::before {
  content: "\\F0F29"; }

.mdi-snowflake-melt::before {
  content: "\\F12CB"; }

.mdi-snowflake-off::before {
  content: "\\F14E3"; }

.mdi-snowflake-variant::before {
  content: "\\F0F2A"; }

.mdi-snowman::before {
  content: "\\F04B7"; }

.mdi-soccer::before {
  content: "\\F04B8"; }

.mdi-soccer-field::before {
  content: "\\F0834"; }

.mdi-social-distance-2-meters::before {
  content: "\\F1579"; }

.mdi-social-distance-6-feet::before {
  content: "\\F157A"; }

.mdi-sofa::before {
  content: "\\F04B9"; }

.mdi-sofa-outline::before {
  content: "\\F156D"; }

.mdi-sofa-single::before {
  content: "\\F156E"; }

.mdi-sofa-single-outline::before {
  content: "\\F156F"; }

.mdi-solar-panel::before {
  content: "\\F0D9B"; }

.mdi-solar-panel-large::before {
  content: "\\F0D9C"; }

.mdi-solar-power::before {
  content: "\\F0A72"; }

.mdi-soldering-iron::before {
  content: "\\F1092"; }

.mdi-solid::before {
  content: "\\F068D"; }

.mdi-sony-playstation::before {
  content: "\\F0414"; }

.mdi-sort::before {
  content: "\\F04BA"; }

.mdi-sort-alphabetical-ascending::before {
  content: "\\F05BD"; }

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\F1148"; }

.mdi-sort-alphabetical-descending::before {
  content: "\\F05BF"; }

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\F1149"; }

.mdi-sort-alphabetical-variant::before {
  content: "\\F04BB"; }

.mdi-sort-ascending::before {
  content: "\\F04BC"; }

.mdi-sort-bool-ascending::before {
  content: "\\F1385"; }

.mdi-sort-bool-ascending-variant::before {
  content: "\\F1386"; }

.mdi-sort-bool-descending::before {
  content: "\\F1387"; }

.mdi-sort-bool-descending-variant::before {
  content: "\\F1388"; }

.mdi-sort-calendar-ascending::before {
  content: "\\F1547"; }

.mdi-sort-calendar-descending::before {
  content: "\\F1548"; }

.mdi-sort-clock-ascending::before {
  content: "\\F1549"; }

.mdi-sort-clock-ascending-outline::before {
  content: "\\F154A"; }

.mdi-sort-clock-descending::before {
  content: "\\F154B"; }

.mdi-sort-clock-descending-outline::before {
  content: "\\F154C"; }

.mdi-sort-descending::before {
  content: "\\F04BD"; }

.mdi-sort-numeric-ascending::before {
  content: "\\F1389"; }

.mdi-sort-numeric-ascending-variant::before {
  content: "\\F090D"; }

.mdi-sort-numeric-descending::before {
  content: "\\F138A"; }

.mdi-sort-numeric-descending-variant::before {
  content: "\\F0AD2"; }

.mdi-sort-numeric-variant::before {
  content: "\\F04BE"; }

.mdi-sort-reverse-variant::before {
  content: "\\F033C"; }

.mdi-sort-variant::before {
  content: "\\F04BF"; }

.mdi-sort-variant-lock::before {
  content: "\\F0CCD"; }

.mdi-sort-variant-lock-open::before {
  content: "\\F0CCE"; }

.mdi-sort-variant-remove::before {
  content: "\\F1147"; }

.mdi-soundcloud::before {
  content: "\\F04C0"; }

.mdi-source-branch::before {
  content: "\\F062C"; }

.mdi-source-branch-check::before {
  content: "\\F14CF"; }

.mdi-source-branch-minus::before {
  content: "\\F14CB"; }

.mdi-source-branch-plus::before {
  content: "\\F14CA"; }

.mdi-source-branch-refresh::before {
  content: "\\F14CD"; }

.mdi-source-branch-remove::before {
  content: "\\F14CC"; }

.mdi-source-branch-sync::before {
  content: "\\F14CE"; }

.mdi-source-commit::before {
  content: "\\F0718"; }

.mdi-source-commit-end::before {
  content: "\\F0719"; }

.mdi-source-commit-end-local::before {
  content: "\\F071A"; }

.mdi-source-commit-local::before {
  content: "\\F071B"; }

.mdi-source-commit-next-local::before {
  content: "\\F071C"; }

.mdi-source-commit-start::before {
  content: "\\F071D"; }

.mdi-source-commit-start-next-local::before {
  content: "\\F071E"; }

.mdi-source-fork::before {
  content: "\\F04C1"; }

.mdi-source-merge::before {
  content: "\\F062D"; }

.mdi-source-pull::before {
  content: "\\F04C2"; }

.mdi-source-repository::before {
  content: "\\F0CCF"; }

.mdi-source-repository-multiple::before {
  content: "\\F0CD0"; }

.mdi-soy-sauce::before {
  content: "\\F07EE"; }

.mdi-soy-sauce-off::before {
  content: "\\F13FC"; }

.mdi-spa::before {
  content: "\\F0CD1"; }

.mdi-spa-outline::before {
  content: "\\F0CD2"; }

.mdi-space-invaders::before {
  content: "\\F0BC9"; }

.mdi-space-station::before {
  content: "\\F1383"; }

.mdi-spade::before {
  content: "\\F0E65"; }

.mdi-sparkles::before {
  content: "\\F1545"; }

.mdi-speaker::before {
  content: "\\F04C3"; }

.mdi-speaker-bluetooth::before {
  content: "\\F09A2"; }

.mdi-speaker-multiple::before {
  content: "\\F0D38"; }

.mdi-speaker-off::before {
  content: "\\F04C4"; }

.mdi-speaker-wireless::before {
  content: "\\F071F"; }

.mdi-speedometer::before {
  content: "\\F04C5"; }

.mdi-speedometer-medium::before {
  content: "\\F0F85"; }

.mdi-speedometer-slow::before {
  content: "\\F0F86"; }

.mdi-spellcheck::before {
  content: "\\F04C6"; }

.mdi-spider::before {
  content: "\\F11EA"; }

.mdi-spider-thread::before {
  content: "\\F11EB"; }

.mdi-spider-web::before {
  content: "\\F0BCA"; }

.mdi-spirit-level::before {
  content: "\\F14F1"; }

.mdi-spoon-sugar::before {
  content: "\\F1429"; }

.mdi-spotify::before {
  content: "\\F04C7"; }

.mdi-spotlight::before {
  content: "\\F04C8"; }

.mdi-spotlight-beam::before {
  content: "\\F04C9"; }

.mdi-spray::before {
  content: "\\F0665"; }

.mdi-spray-bottle::before {
  content: "\\F0AE0"; }

.mdi-sprinkler::before {
  content: "\\F105F"; }

.mdi-sprinkler-variant::before {
  content: "\\F1060"; }

.mdi-sprout::before {
  content: "\\F0E66"; }

.mdi-sprout-outline::before {
  content: "\\F0E67"; }

.mdi-square::before {
  content: "\\F0764"; }

.mdi-square-circle::before {
  content: "\\F1500"; }

.mdi-square-edit-outline::before {
  content: "\\F090C"; }

.mdi-square-medium::before {
  content: "\\F0A13"; }

.mdi-square-medium-outline::before {
  content: "\\F0A14"; }

.mdi-square-off::before {
  content: "\\F12EE"; }

.mdi-square-off-outline::before {
  content: "\\F12EF"; }

.mdi-square-outline::before {
  content: "\\F0763"; }

.mdi-square-root::before {
  content: "\\F0784"; }

.mdi-square-root-box::before {
  content: "\\F09A3"; }

.mdi-square-rounded::before {
  content: "\\F14FB"; }

.mdi-square-rounded-outline::before {
  content: "\\F14FC"; }

.mdi-square-small::before {
  content: "\\F0A15"; }

.mdi-square-wave::before {
  content: "\\F147B"; }

.mdi-squeegee::before {
  content: "\\F0AE1"; }

.mdi-ssh::before {
  content: "\\F08C0"; }

.mdi-stack-exchange::before {
  content: "\\F060B"; }

.mdi-stack-overflow::before {
  content: "\\F04CC"; }

.mdi-stackpath::before {
  content: "\\F0359"; }

.mdi-stadium::before {
  content: "\\F0FF9"; }

.mdi-stadium-variant::before {
  content: "\\F0720"; }

.mdi-stairs::before {
  content: "\\F04CD"; }

.mdi-stairs-box::before {
  content: "\\F139E"; }

.mdi-stairs-down::before {
  content: "\\F12BE"; }

.mdi-stairs-up::before {
  content: "\\F12BD"; }

.mdi-stamper::before {
  content: "\\F0D39"; }

.mdi-standard-definition::before {
  content: "\\F07EF"; }

.mdi-star::before {
  content: "\\F04CE"; }

.mdi-star-box::before {
  content: "\\F0A73"; }

.mdi-star-box-multiple::before {
  content: "\\F1286"; }

.mdi-star-box-multiple-outline::before {
  content: "\\F1287"; }

.mdi-star-box-outline::before {
  content: "\\F0A74"; }

.mdi-star-check::before {
  content: "\\F1566"; }

.mdi-star-check-outline::before {
  content: "\\F156A"; }

.mdi-star-circle::before {
  content: "\\F04CF"; }

.mdi-star-circle-outline::before {
  content: "\\F09A4"; }

.mdi-star-cog::before {
  content: "\\F1668"; }

.mdi-star-cog-outline::before {
  content: "\\F1669"; }

.mdi-star-face::before {
  content: "\\F09A5"; }

.mdi-star-four-points::before {
  content: "\\F0AE2"; }

.mdi-star-four-points-outline::before {
  content: "\\F0AE3"; }

.mdi-star-half::before {
  content: "\\F0246"; }

.mdi-star-half-full::before {
  content: "\\F04D0"; }

.mdi-star-minus::before {
  content: "\\F1564"; }

.mdi-star-minus-outline::before {
  content: "\\F1568"; }

.mdi-star-off::before {
  content: "\\F04D1"; }

.mdi-star-off-outline::before {
  content: "\\F155B"; }

.mdi-star-outline::before {
  content: "\\F04D2"; }

.mdi-star-plus::before {
  content: "\\F1563"; }

.mdi-star-plus-outline::before {
  content: "\\F1567"; }

.mdi-star-remove::before {
  content: "\\F1565"; }

.mdi-star-remove-outline::before {
  content: "\\F1569"; }

.mdi-star-settings::before {
  content: "\\F166A"; }

.mdi-star-settings-outline::before {
  content: "\\F166B"; }

.mdi-star-three-points::before {
  content: "\\F0AE4"; }

.mdi-star-three-points-outline::before {
  content: "\\F0AE5"; }

.mdi-state-machine::before {
  content: "\\F11EF"; }

.mdi-steam::before {
  content: "\\F04D3"; }

.mdi-steering::before {
  content: "\\F04D4"; }

.mdi-steering-off::before {
  content: "\\F090E"; }

.mdi-step-backward::before {
  content: "\\F04D5"; }

.mdi-step-backward-2::before {
  content: "\\F04D6"; }

.mdi-step-forward::before {
  content: "\\F04D7"; }

.mdi-step-forward-2::before {
  content: "\\F04D8"; }

.mdi-stethoscope::before {
  content: "\\F04D9"; }

.mdi-sticker::before {
  content: "\\F1364"; }

.mdi-sticker-alert::before {
  content: "\\F1365"; }

.mdi-sticker-alert-outline::before {
  content: "\\F1366"; }

.mdi-sticker-check::before {
  content: "\\F1367"; }

.mdi-sticker-check-outline::before {
  content: "\\F1368"; }

.mdi-sticker-circle-outline::before {
  content: "\\F05D0"; }

.mdi-sticker-emoji::before {
  content: "\\F0785"; }

.mdi-sticker-minus::before {
  content: "\\F1369"; }

.mdi-sticker-minus-outline::before {
  content: "\\F136A"; }

.mdi-sticker-outline::before {
  content: "\\F136B"; }

.mdi-sticker-plus::before {
  content: "\\F136C"; }

.mdi-sticker-plus-outline::before {
  content: "\\F136D"; }

.mdi-sticker-remove::before {
  content: "\\F136E"; }

.mdi-sticker-remove-outline::before {
  content: "\\F136F"; }

.mdi-stocking::before {
  content: "\\F04DA"; }

.mdi-stomach::before {
  content: "\\F1093"; }

.mdi-stop::before {
  content: "\\F04DB"; }

.mdi-stop-circle::before {
  content: "\\F0666"; }

.mdi-stop-circle-outline::before {
  content: "\\F0667"; }

.mdi-store::before {
  content: "\\F04DC"; }

.mdi-store-24-hour::before {
  content: "\\F04DD"; }

.mdi-store-minus::before {
  content: "\\F165E"; }

.mdi-store-outline::before {
  content: "\\F1361"; }

.mdi-store-plus::before {
  content: "\\F165F"; }

.mdi-store-remove::before {
  content: "\\F1660"; }

.mdi-storefront::before {
  content: "\\F07C7"; }

.mdi-storefront-outline::before {
  content: "\\F10C1"; }

.mdi-stove::before {
  content: "\\F04DE"; }

.mdi-strategy::before {
  content: "\\F11D6"; }

.mdi-stretch-to-page::before {
  content: "\\F0F2B"; }

.mdi-stretch-to-page-outline::before {
  content: "\\F0F2C"; }

.mdi-string-lights::before {
  content: "\\F12BA"; }

.mdi-string-lights-off::before {
  content: "\\F12BB"; }

.mdi-subdirectory-arrow-left::before {
  content: "\\F060C"; }

.mdi-subdirectory-arrow-right::before {
  content: "\\F060D"; }

.mdi-submarine::before {
  content: "\\F156C"; }

.mdi-subtitles::before {
  content: "\\F0A16"; }

.mdi-subtitles-outline::before {
  content: "\\F0A17"; }

.mdi-subway::before {
  content: "\\F06AC"; }

.mdi-subway-alert-variant::before {
  content: "\\F0D9D"; }

.mdi-subway-variant::before {
  content: "\\F04DF"; }

.mdi-summit::before {
  content: "\\F0786"; }

.mdi-sunglasses::before {
  content: "\\F04E0"; }

.mdi-surround-sound::before {
  content: "\\F05C5"; }

.mdi-surround-sound-2-0::before {
  content: "\\F07F0"; }

.mdi-surround-sound-3-1::before {
  content: "\\F07F1"; }

.mdi-surround-sound-5-1::before {
  content: "\\F07F2"; }

.mdi-surround-sound-7-1::before {
  content: "\\F07F3"; }

.mdi-svg::before {
  content: "\\F0721"; }

.mdi-swap-horizontal::before {
  content: "\\F04E1"; }

.mdi-swap-horizontal-bold::before {
  content: "\\F0BCD"; }

.mdi-swap-horizontal-circle::before {
  content: "\\F0FE1"; }

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0FE2"; }

.mdi-swap-horizontal-variant::before {
  content: "\\F08C1"; }

.mdi-swap-vertical::before {
  content: "\\F04E2"; }

.mdi-swap-vertical-bold::before {
  content: "\\F0BCE"; }

.mdi-swap-vertical-circle::before {
  content: "\\F0FE3"; }

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0FE4"; }

.mdi-swap-vertical-variant::before {
  content: "\\F08C2"; }

.mdi-swim::before {
  content: "\\F04E3"; }

.mdi-switch::before {
  content: "\\F04E4"; }

.mdi-sword::before {
  content: "\\F04E5"; }

.mdi-sword-cross::before {
  content: "\\F0787"; }

.mdi-syllabary-hangul::before {
  content: "\\F1333"; }

.mdi-syllabary-hiragana::before {
  content: "\\F1334"; }

.mdi-syllabary-katakana::before {
  content: "\\F1335"; }

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\F1336"; }

.mdi-symbol::before {
  content: "\\F1501"; }

.mdi-symfony::before {
  content: "\\F0AE6"; }

.mdi-sync::before {
  content: "\\F04E6"; }

.mdi-sync-alert::before {
  content: "\\F04E7"; }

.mdi-sync-circle::before {
  content: "\\F1378"; }

.mdi-sync-off::before {
  content: "\\F04E8"; }

.mdi-tab::before {
  content: "\\F04E9"; }

.mdi-tab-minus::before {
  content: "\\F0B4B"; }

.mdi-tab-plus::before {
  content: "\\F075C"; }

.mdi-tab-remove::before {
  content: "\\F0B4C"; }

.mdi-tab-unselected::before {
  content: "\\F04EA"; }

.mdi-table::before {
  content: "\\F04EB"; }

.mdi-table-account::before {
  content: "\\F13B9"; }

.mdi-table-alert::before {
  content: "\\F13BA"; }

.mdi-table-arrow-down::before {
  content: "\\F13BB"; }

.mdi-table-arrow-left::before {
  content: "\\F13BC"; }

.mdi-table-arrow-right::before {
  content: "\\F13BD"; }

.mdi-table-arrow-up::before {
  content: "\\F13BE"; }

.mdi-table-border::before {
  content: "\\F0A18"; }

.mdi-table-cancel::before {
  content: "\\F13BF"; }

.mdi-table-chair::before {
  content: "\\F1061"; }

.mdi-table-check::before {
  content: "\\F13C0"; }

.mdi-table-clock::before {
  content: "\\F13C1"; }

.mdi-table-cog::before {
  content: "\\F13C2"; }

.mdi-table-column::before {
  content: "\\F0835"; }

.mdi-table-column-plus-after::before {
  content: "\\F04EC"; }

.mdi-table-column-plus-before::before {
  content: "\\F04ED"; }

.mdi-table-column-remove::before {
  content: "\\F04EE"; }

.mdi-table-column-width::before {
  content: "\\F04EF"; }

.mdi-table-edit::before {
  content: "\\F04F0"; }

.mdi-table-eye::before {
  content: "\\F1094"; }

.mdi-table-eye-off::before {
  content: "\\F13C3"; }

.mdi-table-furniture::before {
  content: "\\F05BC"; }

.mdi-table-headers-eye::before {
  content: "\\F121D"; }

.mdi-table-headers-eye-off::before {
  content: "\\F121E"; }

.mdi-table-heart::before {
  content: "\\F13C4"; }

.mdi-table-key::before {
  content: "\\F13C5"; }

.mdi-table-large::before {
  content: "\\F04F1"; }

.mdi-table-large-plus::before {
  content: "\\F0F87"; }

.mdi-table-large-remove::before {
  content: "\\F0F88"; }

.mdi-table-lock::before {
  content: "\\F13C6"; }

.mdi-table-merge-cells::before {
  content: "\\F09A6"; }

.mdi-table-minus::before {
  content: "\\F13C7"; }

.mdi-table-multiple::before {
  content: "\\F13C8"; }

.mdi-table-network::before {
  content: "\\F13C9"; }

.mdi-table-of-contents::before {
  content: "\\F0836"; }

.mdi-table-off::before {
  content: "\\F13CA"; }

.mdi-table-plus::before {
  content: "\\F0A75"; }

.mdi-table-refresh::before {
  content: "\\F13A0"; }

.mdi-table-remove::before {
  content: "\\F0A76"; }

.mdi-table-row::before {
  content: "\\F0837"; }

.mdi-table-row-height::before {
  content: "\\F04F2"; }

.mdi-table-row-plus-after::before {
  content: "\\F04F3"; }

.mdi-table-row-plus-before::before {
  content: "\\F04F4"; }

.mdi-table-row-remove::before {
  content: "\\F04F5"; }

.mdi-table-search::before {
  content: "\\F090F"; }

.mdi-table-settings::before {
  content: "\\F0838"; }

.mdi-table-split-cell::before {
  content: "\\F142A"; }

.mdi-table-star::before {
  content: "\\F13CB"; }

.mdi-table-sync::before {
  content: "\\F13A1"; }

.mdi-table-tennis::before {
  content: "\\F0E68"; }

.mdi-tablet::before {
  content: "\\F04F6"; }

.mdi-tablet-android::before {
  content: "\\F04F7"; }

.mdi-tablet-cellphone::before {
  content: "\\F09A7"; }

.mdi-tablet-dashboard::before {
  content: "\\F0ECE"; }

.mdi-tablet-ipad::before {
  content: "\\F04F8"; }

.mdi-taco::before {
  content: "\\F0762"; }

.mdi-tag::before {
  content: "\\F04F9"; }

.mdi-tag-faces::before {
  content: "\\F04FA"; }

.mdi-tag-heart::before {
  content: "\\F068B"; }

.mdi-tag-heart-outline::before {
  content: "\\F0BCF"; }

.mdi-tag-minus::before {
  content: "\\F0910"; }

.mdi-tag-minus-outline::before {
  content: "\\F121F"; }

.mdi-tag-multiple::before {
  content: "\\F04FB"; }

.mdi-tag-multiple-outline::before {
  content: "\\F12F7"; }

.mdi-tag-off::before {
  content: "\\F1220"; }

.mdi-tag-off-outline::before {
  content: "\\F1221"; }

.mdi-tag-outline::before {
  content: "\\F04FC"; }

.mdi-tag-plus::before {
  content: "\\F0722"; }

.mdi-tag-plus-outline::before {
  content: "\\F1222"; }

.mdi-tag-remove::before {
  content: "\\F0723"; }

.mdi-tag-remove-outline::before {
  content: "\\F1223"; }

.mdi-tag-text::before {
  content: "\\F1224"; }

.mdi-tag-text-outline::before {
  content: "\\F04FD"; }

.mdi-tailwind::before {
  content: "\\F13FF"; }

.mdi-tank::before {
  content: "\\F0D3A"; }

.mdi-tanker-truck::before {
  content: "\\F0FE5"; }

.mdi-tape-drive::before {
  content: "\\F16DF"; }

.mdi-tape-measure::before {
  content: "\\F0B4D"; }

.mdi-target::before {
  content: "\\F04FE"; }

.mdi-target-account::before {
  content: "\\F0BD0"; }

.mdi-target-variant::before {
  content: "\\F0A77"; }

.mdi-taxi::before {
  content: "\\F04FF"; }

.mdi-tea::before {
  content: "\\F0D9E"; }

.mdi-tea-outline::before {
  content: "\\F0D9F"; }

.mdi-teach::before {
  content: "\\F0890"; }

.mdi-teamviewer::before {
  content: "\\F0500"; }

.mdi-telegram::before {
  content: "\\F0501"; }

.mdi-telescope::before {
  content: "\\F0B4E"; }

.mdi-television::before {
  content: "\\F0502"; }

.mdi-television-ambient-light::before {
  content: "\\F1356"; }

.mdi-television-box::before {
  content: "\\F0839"; }

.mdi-television-classic::before {
  content: "\\F07F4"; }

.mdi-television-classic-off::before {
  content: "\\F083A"; }

.mdi-television-clean::before {
  content: "\\F1110"; }

.mdi-television-guide::before {
  content: "\\F0503"; }

.mdi-television-off::before {
  content: "\\F083B"; }

.mdi-television-pause::before {
  content: "\\F0F89"; }

.mdi-television-play::before {
  content: "\\F0ECF"; }

.mdi-television-stop::before {
  content: "\\F0F8A"; }

.mdi-temperature-celsius::before {
  content: "\\F0504"; }

.mdi-temperature-fahrenheit::before {
  content: "\\F0505"; }

.mdi-temperature-kelvin::before {
  content: "\\F0506"; }

.mdi-tennis::before {
  content: "\\F0DA0"; }

.mdi-tennis-ball::before {
  content: "\\F0507"; }

.mdi-tent::before {
  content: "\\F0508"; }

.mdi-terraform::before {
  content: "\\F1062"; }

.mdi-terrain::before {
  content: "\\F0509"; }

.mdi-test-tube::before {
  content: "\\F0668"; }

.mdi-test-tube-empty::before {
  content: "\\F0911"; }

.mdi-test-tube-off::before {
  content: "\\F0912"; }

.mdi-text::before {
  content: "\\F09A8"; }

.mdi-text-account::before {
  content: "\\F1570"; }

.mdi-text-box::before {
  content: "\\F021A"; }

.mdi-text-box-check::before {
  content: "\\F0EA6"; }

.mdi-text-box-check-outline::before {
  content: "\\F0EA7"; }

.mdi-text-box-minus::before {
  content: "\\F0EA8"; }

.mdi-text-box-minus-outline::before {
  content: "\\F0EA9"; }

.mdi-text-box-multiple::before {
  content: "\\F0AB7"; }

.mdi-text-box-multiple-outline::before {
  content: "\\F0AB8"; }

.mdi-text-box-outline::before {
  content: "\\F09ED"; }

.mdi-text-box-plus::before {
  content: "\\F0EAA"; }

.mdi-text-box-plus-outline::before {
  content: "\\F0EAB"; }

.mdi-text-box-remove::before {
  content: "\\F0EAC"; }

.mdi-text-box-remove-outline::before {
  content: "\\F0EAD"; }

.mdi-text-box-search::before {
  content: "\\F0EAE"; }

.mdi-text-box-search-outline::before {
  content: "\\F0EAF"; }

.mdi-text-recognition::before {
  content: "\\F113D"; }

.mdi-text-search::before {
  content: "\\F13B8"; }

.mdi-text-shadow::before {
  content: "\\F0669"; }

.mdi-text-short::before {
  content: "\\F09A9"; }

.mdi-text-subject::before {
  content: "\\F09AA"; }

.mdi-text-to-speech::before {
  content: "\\F050A"; }

.mdi-text-to-speech-off::before {
  content: "\\F050B"; }

.mdi-texture::before {
  content: "\\F050C"; }

.mdi-texture-box::before {
  content: "\\F0FE6"; }

.mdi-theater::before {
  content: "\\F050D"; }

.mdi-theme-light-dark::before {
  content: "\\F050E"; }

.mdi-thermometer::before {
  content: "\\F050F"; }

.mdi-thermometer-alert::before {
  content: "\\F0E01"; }

.mdi-thermometer-chevron-down::before {
  content: "\\F0E02"; }

.mdi-thermometer-chevron-up::before {
  content: "\\F0E03"; }

.mdi-thermometer-high::before {
  content: "\\F10C2"; }

.mdi-thermometer-lines::before {
  content: "\\F0510"; }

.mdi-thermometer-low::before {
  content: "\\F10C3"; }

.mdi-thermometer-minus::before {
  content: "\\F0E04"; }

.mdi-thermometer-off::before {
  content: "\\F1531"; }

.mdi-thermometer-plus::before {
  content: "\\F0E05"; }

.mdi-thermostat::before {
  content: "\\F0393"; }

.mdi-thermostat-box::before {
  content: "\\F0891"; }

.mdi-thought-bubble::before {
  content: "\\F07F6"; }

.mdi-thought-bubble-outline::before {
  content: "\\F07F7"; }

.mdi-thumb-down::before {
  content: "\\F0511"; }

.mdi-thumb-down-outline::before {
  content: "\\F0512"; }

.mdi-thumb-up::before {
  content: "\\F0513"; }

.mdi-thumb-up-outline::before {
  content: "\\F0514"; }

.mdi-thumbs-up-down::before {
  content: "\\F0515"; }

.mdi-ticket::before {
  content: "\\F0516"; }

.mdi-ticket-account::before {
  content: "\\F0517"; }

.mdi-ticket-confirmation::before {
  content: "\\F0518"; }

.mdi-ticket-confirmation-outline::before {
  content: "\\F13AA"; }

.mdi-ticket-outline::before {
  content: "\\F0913"; }

.mdi-ticket-percent::before {
  content: "\\F0724"; }

.mdi-ticket-percent-outline::before {
  content: "\\F142B"; }

.mdi-tie::before {
  content: "\\F0519"; }

.mdi-tilde::before {
  content: "\\F0725"; }

.mdi-timelapse::before {
  content: "\\F051A"; }

.mdi-timeline::before {
  content: "\\F0BD1"; }

.mdi-timeline-alert::before {
  content: "\\F0F95"; }

.mdi-timeline-alert-outline::before {
  content: "\\F0F98"; }

.mdi-timeline-check::before {
  content: "\\F1532"; }

.mdi-timeline-check-outline::before {
  content: "\\F1533"; }

.mdi-timeline-clock::before {
  content: "\\F11FB"; }

.mdi-timeline-clock-outline::before {
  content: "\\F11FC"; }

.mdi-timeline-help::before {
  content: "\\F0F99"; }

.mdi-timeline-help-outline::before {
  content: "\\F0F9A"; }

.mdi-timeline-minus::before {
  content: "\\F1534"; }

.mdi-timeline-minus-outline::before {
  content: "\\F1535"; }

.mdi-timeline-outline::before {
  content: "\\F0BD2"; }

.mdi-timeline-plus::before {
  content: "\\F0F96"; }

.mdi-timeline-plus-outline::before {
  content: "\\F0F97"; }

.mdi-timeline-remove::before {
  content: "\\F1536"; }

.mdi-timeline-remove-outline::before {
  content: "\\F1537"; }

.mdi-timeline-text::before {
  content: "\\F0BD3"; }

.mdi-timeline-text-outline::before {
  content: "\\F0BD4"; }

.mdi-timer::before {
  content: "\\F13AB"; }

.mdi-timer-10::before {
  content: "\\F051C"; }

.mdi-timer-3::before {
  content: "\\F051D"; }

.mdi-timer-off::before {
  content: "\\F13AC"; }

.mdi-timer-off-outline::before {
  content: "\\F051E"; }

.mdi-timer-outline::before {
  content: "\\F051B"; }

.mdi-timer-sand::before {
  content: "\\F051F"; }

.mdi-timer-sand-empty::before {
  content: "\\F06AD"; }

.mdi-timer-sand-full::before {
  content: "\\F078C"; }

.mdi-timetable::before {
  content: "\\F0520"; }

.mdi-toaster::before {
  content: "\\F1063"; }

.mdi-toaster-off::before {
  content: "\\F11B7"; }

.mdi-toaster-oven::before {
  content: "\\F0CD3"; }

.mdi-toggle-switch::before {
  content: "\\F0521"; }

.mdi-toggle-switch-off::before {
  content: "\\F0522"; }

.mdi-toggle-switch-off-outline::before {
  content: "\\F0A19"; }

.mdi-toggle-switch-outline::before {
  content: "\\F0A1A"; }

.mdi-toilet::before {
  content: "\\F09AB"; }

.mdi-toolbox::before {
  content: "\\F09AC"; }

.mdi-toolbox-outline::before {
  content: "\\F09AD"; }

.mdi-tools::before {
  content: "\\F1064"; }

.mdi-tooltip::before {
  content: "\\F0523"; }

.mdi-tooltip-account::before {
  content: "\\F000C"; }

.mdi-tooltip-check::before {
  content: "\\F155C"; }

.mdi-tooltip-check-outline::before {
  content: "\\F155D"; }

.mdi-tooltip-edit::before {
  content: "\\F0524"; }

.mdi-tooltip-edit-outline::before {
  content: "\\F12C5"; }

.mdi-tooltip-image::before {
  content: "\\F0525"; }

.mdi-tooltip-image-outline::before {
  content: "\\F0BD5"; }

.mdi-tooltip-minus::before {
  content: "\\F155E"; }

.mdi-tooltip-minus-outline::before {
  content: "\\F155F"; }

.mdi-tooltip-outline::before {
  content: "\\F0526"; }

.mdi-tooltip-plus::before {
  content: "\\F0BD6"; }

.mdi-tooltip-plus-outline::before {
  content: "\\F0527"; }

.mdi-tooltip-remove::before {
  content: "\\F1560"; }

.mdi-tooltip-remove-outline::before {
  content: "\\F1561"; }

.mdi-tooltip-text::before {
  content: "\\F0528"; }

.mdi-tooltip-text-outline::before {
  content: "\\F0BD7"; }

.mdi-tooth::before {
  content: "\\F08C3"; }

.mdi-tooth-outline::before {
  content: "\\F0529"; }

.mdi-toothbrush::before {
  content: "\\F1129"; }

.mdi-toothbrush-electric::before {
  content: "\\F112C"; }

.mdi-toothbrush-paste::before {
  content: "\\F112A"; }

.mdi-torch::before {
  content: "\\F1606"; }

.mdi-tortoise::before {
  content: "\\F0D3B"; }

.mdi-toslink::before {
  content: "\\F12B8"; }

.mdi-tournament::before {
  content: "\\F09AE"; }

.mdi-tow-truck::before {
  content: "\\F083C"; }

.mdi-tower-beach::before {
  content: "\\F0681"; }

.mdi-tower-fire::before {
  content: "\\F0682"; }

.mdi-toy-brick::before {
  content: "\\F1288"; }

.mdi-toy-brick-marker::before {
  content: "\\F1289"; }

.mdi-toy-brick-marker-outline::before {
  content: "\\F128A"; }

.mdi-toy-brick-minus::before {
  content: "\\F128B"; }

.mdi-toy-brick-minus-outline::before {
  content: "\\F128C"; }

.mdi-toy-brick-outline::before {
  content: "\\F128D"; }

.mdi-toy-brick-plus::before {
  content: "\\F128E"; }

.mdi-toy-brick-plus-outline::before {
  content: "\\F128F"; }

.mdi-toy-brick-remove::before {
  content: "\\F1290"; }

.mdi-toy-brick-remove-outline::before {
  content: "\\F1291"; }

.mdi-toy-brick-search::before {
  content: "\\F1292"; }

.mdi-toy-brick-search-outline::before {
  content: "\\F1293"; }

.mdi-track-light::before {
  content: "\\F0914"; }

.mdi-trackpad::before {
  content: "\\F07F8"; }

.mdi-trackpad-lock::before {
  content: "\\F0933"; }

.mdi-tractor::before {
  content: "\\F0892"; }

.mdi-tractor-variant::before {
  content: "\\F14C4"; }

.mdi-trademark::before {
  content: "\\F0A78"; }

.mdi-traffic-cone::before {
  content: "\\F137C"; }

.mdi-traffic-light::before {
  content: "\\F052B"; }

.mdi-train::before {
  content: "\\F052C"; }

.mdi-train-car::before {
  content: "\\F0BD8"; }

.mdi-train-variant::before {
  content: "\\F08C4"; }

.mdi-tram::before {
  content: "\\F052D"; }

.mdi-tram-side::before {
  content: "\\F0FE7"; }

.mdi-transcribe::before {
  content: "\\F052E"; }

.mdi-transcribe-close::before {
  content: "\\F052F"; }

.mdi-transfer::before {
  content: "\\F1065"; }

.mdi-transfer-down::before {
  content: "\\F0DA1"; }

.mdi-transfer-left::before {
  content: "\\F0DA2"; }

.mdi-transfer-right::before {
  content: "\\F0530"; }

.mdi-transfer-up::before {
  content: "\\F0DA3"; }

.mdi-transit-connection::before {
  content: "\\F0D3C"; }

.mdi-transit-connection-horizontal::before {
  content: "\\F1546"; }

.mdi-transit-connection-variant::before {
  content: "\\F0D3D"; }

.mdi-transit-detour::before {
  content: "\\F0F8B"; }

.mdi-transit-skip::before {
  content: "\\F1515"; }

.mdi-transit-transfer::before {
  content: "\\F06AE"; }

.mdi-transition::before {
  content: "\\F0915"; }

.mdi-transition-masked::before {
  content: "\\F0916"; }

.mdi-translate::before {
  content: "\\F05CA"; }

.mdi-translate-off::before {
  content: "\\F0E06"; }

.mdi-transmission-tower::before {
  content: "\\F0D3E"; }

.mdi-trash-can::before {
  content: "\\F0A79"; }

.mdi-trash-can-outline::before {
  content: "\\F0A7A"; }

.mdi-tray::before {
  content: "\\F1294"; }

.mdi-tray-alert::before {
  content: "\\F1295"; }

.mdi-tray-full::before {
  content: "\\F1296"; }

.mdi-tray-minus::before {
  content: "\\F1297"; }

.mdi-tray-plus::before {
  content: "\\F1298"; }

.mdi-tray-remove::before {
  content: "\\F1299"; }

.mdi-treasure-chest::before {
  content: "\\F0726"; }

.mdi-tree::before {
  content: "\\F0531"; }

.mdi-tree-outline::before {
  content: "\\F0E69"; }

.mdi-trello::before {
  content: "\\F0532"; }

.mdi-trending-down::before {
  content: "\\F0533"; }

.mdi-trending-neutral::before {
  content: "\\F0534"; }

.mdi-trending-up::before {
  content: "\\F0535"; }

.mdi-triangle::before {
  content: "\\F0536"; }

.mdi-triangle-outline::before {
  content: "\\F0537"; }

.mdi-triangle-wave::before {
  content: "\\F147C"; }

.mdi-triforce::before {
  content: "\\F0BD9"; }

.mdi-trophy::before {
  content: "\\F0538"; }

.mdi-trophy-award::before {
  content: "\\F0539"; }

.mdi-trophy-broken::before {
  content: "\\F0DA4"; }

.mdi-trophy-outline::before {
  content: "\\F053A"; }

.mdi-trophy-variant::before {
  content: "\\F053B"; }

.mdi-trophy-variant-outline::before {
  content: "\\F053C"; }

.mdi-truck::before {
  content: "\\F053D"; }

.mdi-truck-check::before {
  content: "\\F0CD4"; }

.mdi-truck-check-outline::before {
  content: "\\F129A"; }

.mdi-truck-delivery::before {
  content: "\\F053E"; }

.mdi-truck-delivery-outline::before {
  content: "\\F129B"; }

.mdi-truck-fast::before {
  content: "\\F0788"; }

.mdi-truck-fast-outline::before {
  content: "\\F129C"; }

.mdi-truck-outline::before {
  content: "\\F129D"; }

.mdi-truck-trailer::before {
  content: "\\F0727"; }

.mdi-trumpet::before {
  content: "\\F1096"; }

.mdi-tshirt-crew::before {
  content: "\\F0A7B"; }

.mdi-tshirt-crew-outline::before {
  content: "\\F053F"; }

.mdi-tshirt-v::before {
  content: "\\F0A7C"; }

.mdi-tshirt-v-outline::before {
  content: "\\F0540"; }

.mdi-tumble-dryer::before {
  content: "\\F0917"; }

.mdi-tumble-dryer-alert::before {
  content: "\\F11BA"; }

.mdi-tumble-dryer-off::before {
  content: "\\F11BB"; }

.mdi-tune::before {
  content: "\\F062E"; }

.mdi-tune-variant::before {
  content: "\\F1542"; }

.mdi-tune-vertical::before {
  content: "\\F066A"; }

.mdi-tune-vertical-variant::before {
  content: "\\F1543"; }

.mdi-turnstile::before {
  content: "\\F0CD5"; }

.mdi-turnstile-outline::before {
  content: "\\F0CD6"; }

.mdi-turtle::before {
  content: "\\F0CD7"; }

.mdi-twitch::before {
  content: "\\F0543"; }

.mdi-twitter::before {
  content: "\\F0544"; }

.mdi-twitter-retweet::before {
  content: "\\F0547"; }

.mdi-two-factor-authentication::before {
  content: "\\F09AF"; }

.mdi-typewriter::before {
  content: "\\F0F2D"; }

.mdi-ubisoft::before {
  content: "\\F0BDA"; }

.mdi-ubuntu::before {
  content: "\\F0548"; }

.mdi-ufo::before {
  content: "\\F10C4"; }

.mdi-ufo-outline::before {
  content: "\\F10C5"; }

.mdi-ultra-high-definition::before {
  content: "\\F07F9"; }

.mdi-umbraco::before {
  content: "\\F0549"; }

.mdi-umbrella::before {
  content: "\\F054A"; }

.mdi-umbrella-closed::before {
  content: "\\F09B0"; }

.mdi-umbrella-closed-outline::before {
  content: "\\F13E2"; }

.mdi-umbrella-closed-variant::before {
  content: "\\F13E1"; }

.mdi-umbrella-outline::before {
  content: "\\F054B"; }

.mdi-undo::before {
  content: "\\F054C"; }

.mdi-undo-variant::before {
  content: "\\F054D"; }

.mdi-unfold-less-horizontal::before {
  content: "\\F054E"; }

.mdi-unfold-less-vertical::before {
  content: "\\F0760"; }

.mdi-unfold-more-horizontal::before {
  content: "\\F054F"; }

.mdi-unfold-more-vertical::before {
  content: "\\F0761"; }

.mdi-ungroup::before {
  content: "\\F0550"; }

.mdi-unicode::before {
  content: "\\F0ED0"; }

.mdi-unicorn::before {
  content: "\\F15C2"; }

.mdi-unicorn-variant::before {
  content: "\\F15C3"; }

.mdi-unicycle::before {
  content: "\\F15E5"; }

.mdi-unity::before {
  content: "\\F06AF"; }

.mdi-unreal::before {
  content: "\\F09B1"; }

.mdi-untappd::before {
  content: "\\F0551"; }

.mdi-update::before {
  content: "\\F06B0"; }

.mdi-upload::before {
  content: "\\F0552"; }

.mdi-upload-lock::before {
  content: "\\F1373"; }

.mdi-upload-lock-outline::before {
  content: "\\F1374"; }

.mdi-upload-multiple::before {
  content: "\\F083D"; }

.mdi-upload-network::before {
  content: "\\F06F6"; }

.mdi-upload-network-outline::before {
  content: "\\F0CD8"; }

.mdi-upload-off::before {
  content: "\\F10C6"; }

.mdi-upload-off-outline::before {
  content: "\\F10C7"; }

.mdi-upload-outline::before {
  content: "\\F0E07"; }

.mdi-usb::before {
  content: "\\F0553"; }

.mdi-usb-flash-drive::before {
  content: "\\F129E"; }

.mdi-usb-flash-drive-outline::before {
  content: "\\F129F"; }

.mdi-usb-port::before {
  content: "\\F11F0"; }

.mdi-valve::before {
  content: "\\F1066"; }

.mdi-valve-closed::before {
  content: "\\F1067"; }

.mdi-valve-open::before {
  content: "\\F1068"; }

.mdi-van-passenger::before {
  content: "\\F07FA"; }

.mdi-van-utility::before {
  content: "\\F07FB"; }

.mdi-vanish::before {
  content: "\\F07FC"; }

.mdi-vanish-quarter::before {
  content: "\\F1554"; }

.mdi-vanity-light::before {
  content: "\\F11E1"; }

.mdi-variable::before {
  content: "\\F0AE7"; }

.mdi-variable-box::before {
  content: "\\F1111"; }

.mdi-vector-arrange-above::before {
  content: "\\F0554"; }

.mdi-vector-arrange-below::before {
  content: "\\F0555"; }

.mdi-vector-bezier::before {
  content: "\\F0AE8"; }

.mdi-vector-circle::before {
  content: "\\F0556"; }

.mdi-vector-circle-variant::before {
  content: "\\F0557"; }

.mdi-vector-combine::before {
  content: "\\F0558"; }

.mdi-vector-curve::before {
  content: "\\F0559"; }

.mdi-vector-difference::before {
  content: "\\F055A"; }

.mdi-vector-difference-ab::before {
  content: "\\F055B"; }

.mdi-vector-difference-ba::before {
  content: "\\F055C"; }

.mdi-vector-ellipse::before {
  content: "\\F0893"; }

.mdi-vector-intersection::before {
  content: "\\F055D"; }

.mdi-vector-line::before {
  content: "\\F055E"; }

.mdi-vector-link::before {
  content: "\\F0FE8"; }

.mdi-vector-point::before {
  content: "\\F055F"; }

.mdi-vector-polygon::before {
  content: "\\F0560"; }

.mdi-vector-polyline::before {
  content: "\\F0561"; }

.mdi-vector-polyline-edit::before {
  content: "\\F1225"; }

.mdi-vector-polyline-minus::before {
  content: "\\F1226"; }

.mdi-vector-polyline-plus::before {
  content: "\\F1227"; }

.mdi-vector-polyline-remove::before {
  content: "\\F1228"; }

.mdi-vector-radius::before {
  content: "\\F074A"; }

.mdi-vector-rectangle::before {
  content: "\\F05C6"; }

.mdi-vector-selection::before {
  content: "\\F0562"; }

.mdi-vector-square::before {
  content: "\\F0001"; }

.mdi-vector-triangle::before {
  content: "\\F0563"; }

.mdi-vector-union::before {
  content: "\\F0564"; }

.mdi-vhs::before {
  content: "\\F0A1B"; }

.mdi-vibrate::before {
  content: "\\F0566"; }

.mdi-vibrate-off::before {
  content: "\\F0CD9"; }

.mdi-video::before {
  content: "\\F0567"; }

.mdi-video-3d::before {
  content: "\\F07FD"; }

.mdi-video-3d-off::before {
  content: "\\F13D9"; }

.mdi-video-3d-variant::before {
  content: "\\F0ED1"; }

.mdi-video-4k-box::before {
  content: "\\F083E"; }

.mdi-video-account::before {
  content: "\\F0919"; }

.mdi-video-box::before {
  content: "\\F00FD"; }

.mdi-video-box-off::before {
  content: "\\F00FE"; }

.mdi-video-check::before {
  content: "\\F1069"; }

.mdi-video-check-outline::before {
  content: "\\F106A"; }

.mdi-video-high-definition::before {
  content: "\\F152E"; }

.mdi-video-image::before {
  content: "\\F091A"; }

.mdi-video-input-antenna::before {
  content: "\\F083F"; }

.mdi-video-input-component::before {
  content: "\\F0840"; }

.mdi-video-input-hdmi::before {
  content: "\\F0841"; }

.mdi-video-input-scart::before {
  content: "\\F0F8C"; }

.mdi-video-input-svideo::before {
  content: "\\F0842"; }

.mdi-video-minus::before {
  content: "\\F09B2"; }

.mdi-video-minus-outline::before {
  content: "\\F02BA"; }

.mdi-video-off::before {
  content: "\\F0568"; }

.mdi-video-off-outline::before {
  content: "\\F0BDB"; }

.mdi-video-outline::before {
  content: "\\F0BDC"; }

.mdi-video-plus::before {
  content: "\\F09B3"; }

.mdi-video-plus-outline::before {
  content: "\\F01D3"; }

.mdi-video-stabilization::before {
  content: "\\F091B"; }

.mdi-video-switch::before {
  content: "\\F0569"; }

.mdi-video-switch-outline::before {
  content: "\\F0790"; }

.mdi-video-vintage::before {
  content: "\\F0A1C"; }

.mdi-video-wireless::before {
  content: "\\F0ED2"; }

.mdi-video-wireless-outline::before {
  content: "\\F0ED3"; }

.mdi-view-agenda::before {
  content: "\\F056A"; }

.mdi-view-agenda-outline::before {
  content: "\\F11D8"; }

.mdi-view-array::before {
  content: "\\F056B"; }

.mdi-view-array-outline::before {
  content: "\\F1485"; }

.mdi-view-carousel::before {
  content: "\\F056C"; }

.mdi-view-carousel-outline::before {
  content: "\\F1486"; }

.mdi-view-column::before {
  content: "\\F056D"; }

.mdi-view-column-outline::before {
  content: "\\F1487"; }

.mdi-view-comfy::before {
  content: "\\F0E6A"; }

.mdi-view-comfy-outline::before {
  content: "\\F1488"; }

.mdi-view-compact::before {
  content: "\\F0E6B"; }

.mdi-view-compact-outline::before {
  content: "\\F0E6C"; }

.mdi-view-dashboard::before {
  content: "\\F056E"; }

.mdi-view-dashboard-outline::before {
  content: "\\F0A1D"; }

.mdi-view-dashboard-variant::before {
  content: "\\F0843"; }

.mdi-view-dashboard-variant-outline::before {
  content: "\\F1489"; }

.mdi-view-day::before {
  content: "\\F056F"; }

.mdi-view-day-outline::before {
  content: "\\F148A"; }

.mdi-view-grid::before {
  content: "\\F0570"; }

.mdi-view-grid-outline::before {
  content: "\\F11D9"; }

.mdi-view-grid-plus::before {
  content: "\\F0F8D"; }

.mdi-view-grid-plus-outline::before {
  content: "\\F11DA"; }

.mdi-view-headline::before {
  content: "\\F0571"; }

.mdi-view-list::before {
  content: "\\F0572"; }

.mdi-view-list-outline::before {
  content: "\\F148B"; }

.mdi-view-module::before {
  content: "\\F0573"; }

.mdi-view-module-outline::before {
  content: "\\F148C"; }

.mdi-view-parallel::before {
  content: "\\F0728"; }

.mdi-view-parallel-outline::before {
  content: "\\F148D"; }

.mdi-view-quilt::before {
  content: "\\F0574"; }

.mdi-view-quilt-outline::before {
  content: "\\F148E"; }

.mdi-view-sequential::before {
  content: "\\F0729"; }

.mdi-view-sequential-outline::before {
  content: "\\F148F"; }

.mdi-view-split-horizontal::before {
  content: "\\F0BCB"; }

.mdi-view-split-vertical::before {
  content: "\\F0BCC"; }

.mdi-view-stream::before {
  content: "\\F0575"; }

.mdi-view-stream-outline::before {
  content: "\\F1490"; }

.mdi-view-week::before {
  content: "\\F0576"; }

.mdi-view-week-outline::before {
  content: "\\F1491"; }

.mdi-vimeo::before {
  content: "\\F0577"; }

.mdi-violin::before {
  content: "\\F060F"; }

.mdi-virtual-reality::before {
  content: "\\F0894"; }

.mdi-virus::before {
  content: "\\F13B6"; }

.mdi-virus-outline::before {
  content: "\\F13B7"; }

.mdi-vk::before {
  content: "\\F0579"; }

.mdi-vlc::before {
  content: "\\F057C"; }

.mdi-voice-off::before {
  content: "\\F0ED4"; }

.mdi-voicemail::before {
  content: "\\F057D"; }

.mdi-volleyball::before {
  content: "\\F09B4"; }

.mdi-volume-high::before {
  content: "\\F057E"; }

.mdi-volume-low::before {
  content: "\\F057F"; }

.mdi-volume-medium::before {
  content: "\\F0580"; }

.mdi-volume-minus::before {
  content: "\\F075E"; }

.mdi-volume-mute::before {
  content: "\\F075F"; }

.mdi-volume-off::before {
  content: "\\F0581"; }

.mdi-volume-plus::before {
  content: "\\F075D"; }

.mdi-volume-source::before {
  content: "\\F1120"; }

.mdi-volume-variant-off::before {
  content: "\\F0E08"; }

.mdi-volume-vibrate::before {
  content: "\\F1121"; }

.mdi-vote::before {
  content: "\\F0A1F"; }

.mdi-vote-outline::before {
  content: "\\F0A20"; }

.mdi-vpn::before {
  content: "\\F0582"; }

.mdi-vuejs::before {
  content: "\\F0844"; }

.mdi-vuetify::before {
  content: "\\F0E6D"; }

.mdi-walk::before {
  content: "\\F0583"; }

.mdi-wall::before {
  content: "\\F07FE"; }

.mdi-wall-sconce::before {
  content: "\\F091C"; }

.mdi-wall-sconce-flat::before {
  content: "\\F091D"; }

.mdi-wall-sconce-flat-variant::before {
  content: "\\F041C"; }

.mdi-wall-sconce-round::before {
  content: "\\F0748"; }

.mdi-wall-sconce-round-variant::before {
  content: "\\F091E"; }

.mdi-wallet::before {
  content: "\\F0584"; }

.mdi-wallet-giftcard::before {
  content: "\\F0585"; }

.mdi-wallet-membership::before {
  content: "\\F0586"; }

.mdi-wallet-outline::before {
  content: "\\F0BDD"; }

.mdi-wallet-plus::before {
  content: "\\F0F8E"; }

.mdi-wallet-plus-outline::before {
  content: "\\F0F8F"; }

.mdi-wallet-travel::before {
  content: "\\F0587"; }

.mdi-wallpaper::before {
  content: "\\F0E09"; }

.mdi-wan::before {
  content: "\\F0588"; }

.mdi-wardrobe::before {
  content: "\\F0F90"; }

.mdi-wardrobe-outline::before {
  content: "\\F0F91"; }

.mdi-warehouse::before {
  content: "\\F0F81"; }

.mdi-washing-machine::before {
  content: "\\F072A"; }

.mdi-washing-machine-alert::before {
  content: "\\F11BC"; }

.mdi-washing-machine-off::before {
  content: "\\F11BD"; }

.mdi-watch::before {
  content: "\\F0589"; }

.mdi-watch-export::before {
  content: "\\F058A"; }

.mdi-watch-export-variant::before {
  content: "\\F0895"; }

.mdi-watch-import::before {
  content: "\\F058B"; }

.mdi-watch-import-variant::before {
  content: "\\F0896"; }

.mdi-watch-variant::before {
  content: "\\F0897"; }

.mdi-watch-vibrate::before {
  content: "\\F06B1"; }

.mdi-watch-vibrate-off::before {
  content: "\\F0CDA"; }

.mdi-water::before {
  content: "\\F058C"; }

.mdi-water-alert::before {
  content: "\\F1502"; }

.mdi-water-alert-outline::before {
  content: "\\F1503"; }

.mdi-water-boiler::before {
  content: "\\F0F92"; }

.mdi-water-boiler-alert::before {
  content: "\\F11B3"; }

.mdi-water-boiler-off::before {
  content: "\\F11B4"; }

.mdi-water-check::before {
  content: "\\F1504"; }

.mdi-water-check-outline::before {
  content: "\\F1505"; }

.mdi-water-minus::before {
  content: "\\F1506"; }

.mdi-water-minus-outline::before {
  content: "\\F1507"; }

.mdi-water-off::before {
  content: "\\F058D"; }

.mdi-water-off-outline::before {
  content: "\\F1508"; }

.mdi-water-outline::before {
  content: "\\F0E0A"; }

.mdi-water-percent::before {
  content: "\\F058E"; }

.mdi-water-percent-alert::before {
  content: "\\F1509"; }

.mdi-water-plus::before {
  content: "\\F150A"; }

.mdi-water-plus-outline::before {
  content: "\\F150B"; }

.mdi-water-polo::before {
  content: "\\F12A0"; }

.mdi-water-pump::before {
  content: "\\F058F"; }

.mdi-water-pump-off::before {
  content: "\\F0F93"; }

.mdi-water-remove::before {
  content: "\\F150C"; }

.mdi-water-remove-outline::before {
  content: "\\F150D"; }

.mdi-water-well::before {
  content: "\\F106B"; }

.mdi-water-well-outline::before {
  content: "\\F106C"; }

.mdi-watering-can::before {
  content: "\\F1481"; }

.mdi-watering-can-outline::before {
  content: "\\F1482"; }

.mdi-watermark::before {
  content: "\\F0612"; }

.mdi-wave::before {
  content: "\\F0F2E"; }

.mdi-waveform::before {
  content: "\\F147D"; }

.mdi-waves::before {
  content: "\\F078D"; }

.mdi-waze::before {
  content: "\\F0BDE"; }

.mdi-weather-cloudy::before {
  content: "\\F0590"; }

.mdi-weather-cloudy-alert::before {
  content: "\\F0F2F"; }

.mdi-weather-cloudy-arrow-right::before {
  content: "\\F0E6E"; }

.mdi-weather-fog::before {
  content: "\\F0591"; }

.mdi-weather-hail::before {
  content: "\\F0592"; }

.mdi-weather-hazy::before {
  content: "\\F0F30"; }

.mdi-weather-hurricane::before {
  content: "\\F0898"; }

.mdi-weather-lightning::before {
  content: "\\F0593"; }

.mdi-weather-lightning-rainy::before {
  content: "\\F067E"; }

.mdi-weather-night::before {
  content: "\\F0594"; }

.mdi-weather-night-partly-cloudy::before {
  content: "\\F0F31"; }

.mdi-weather-partly-cloudy::before {
  content: "\\F0595"; }

.mdi-weather-partly-lightning::before {
  content: "\\F0F32"; }

.mdi-weather-partly-rainy::before {
  content: "\\F0F33"; }

.mdi-weather-partly-snowy::before {
  content: "\\F0F34"; }

.mdi-weather-partly-snowy-rainy::before {
  content: "\\F0F35"; }

.mdi-weather-pouring::before {
  content: "\\F0596"; }

.mdi-weather-rainy::before {
  content: "\\F0597"; }

.mdi-weather-snowy::before {
  content: "\\F0598"; }

.mdi-weather-snowy-heavy::before {
  content: "\\F0F36"; }

.mdi-weather-snowy-rainy::before {
  content: "\\F067F"; }

.mdi-weather-sunny::before {
  content: "\\F0599"; }

.mdi-weather-sunny-alert::before {
  content: "\\F0F37"; }

.mdi-weather-sunny-off::before {
  content: "\\F14E4"; }

.mdi-weather-sunset::before {
  content: "\\F059A"; }

.mdi-weather-sunset-down::before {
  content: "\\F059B"; }

.mdi-weather-sunset-up::before {
  content: "\\F059C"; }

.mdi-weather-tornado::before {
  content: "\\F0F38"; }

.mdi-weather-windy::before {
  content: "\\F059D"; }

.mdi-weather-windy-variant::before {
  content: "\\F059E"; }

.mdi-web::before {
  content: "\\F059F"; }

.mdi-web-box::before {
  content: "\\F0F94"; }

.mdi-web-clock::before {
  content: "\\F124A"; }

.mdi-webcam::before {
  content: "\\F05A0"; }

.mdi-webhook::before {
  content: "\\F062F"; }

.mdi-webpack::before {
  content: "\\F072B"; }

.mdi-webrtc::before {
  content: "\\F1248"; }

.mdi-wechat::before {
  content: "\\F0611"; }

.mdi-weight::before {
  content: "\\F05A1"; }

.mdi-weight-gram::before {
  content: "\\F0D3F"; }

.mdi-weight-kilogram::before {
  content: "\\F05A2"; }

.mdi-weight-lifter::before {
  content: "\\F115D"; }

.mdi-weight-pound::before {
  content: "\\F09B5"; }

.mdi-whatsapp::before {
  content: "\\F05A3"; }

.mdi-wheel-barrow::before {
  content: "\\F14F2"; }

.mdi-wheelchair-accessibility::before {
  content: "\\F05A4"; }

.mdi-whistle::before {
  content: "\\F09B6"; }

.mdi-whistle-outline::before {
  content: "\\F12BC"; }

.mdi-white-balance-auto::before {
  content: "\\F05A5"; }

.mdi-white-balance-incandescent::before {
  content: "\\F05A6"; }

.mdi-white-balance-iridescent::before {
  content: "\\F05A7"; }

.mdi-white-balance-sunny::before {
  content: "\\F05A8"; }

.mdi-widgets::before {
  content: "\\F072C"; }

.mdi-widgets-outline::before {
  content: "\\F1355"; }

.mdi-wifi::before {
  content: "\\F05A9"; }

.mdi-wifi-alert::before {
  content: "\\F16B5"; }

.mdi-wifi-arrow-down::before {
  content: "\\F16B6"; }

.mdi-wifi-arrow-left::before {
  content: "\\F16B7"; }

.mdi-wifi-arrow-left-right::before {
  content: "\\F16B8"; }

.mdi-wifi-arrow-right::before {
  content: "\\F16B9"; }

.mdi-wifi-arrow-up::before {
  content: "\\F16BA"; }

.mdi-wifi-arrow-up-down::before {
  content: "\\F16BB"; }

.mdi-wifi-cancel::before {
  content: "\\F16BC"; }

.mdi-wifi-check::before {
  content: "\\F16BD"; }

.mdi-wifi-cog::before {
  content: "\\F16BE"; }

.mdi-wifi-lock::before {
  content: "\\F16BF"; }

.mdi-wifi-lock-open::before {
  content: "\\F16C0"; }

.mdi-wifi-marker::before {
  content: "\\F16C1"; }

.mdi-wifi-minus::before {
  content: "\\F16C2"; }

.mdi-wifi-off::before {
  content: "\\F05AA"; }

.mdi-wifi-plus::before {
  content: "\\F16C3"; }

.mdi-wifi-refresh::before {
  content: "\\F16C4"; }

.mdi-wifi-remove::before {
  content: "\\F16C5"; }

.mdi-wifi-settings::before {
  content: "\\F16C6"; }

.mdi-wifi-star::before {
  content: "\\F0E0B"; }

.mdi-wifi-strength-1::before {
  content: "\\F091F"; }

.mdi-wifi-strength-1-alert::before {
  content: "\\F0920"; }

.mdi-wifi-strength-1-lock::before {
  content: "\\F0921"; }

.mdi-wifi-strength-1-lock-open::before {
  content: "\\F16CB"; }

.mdi-wifi-strength-2::before {
  content: "\\F0922"; }

.mdi-wifi-strength-2-alert::before {
  content: "\\F0923"; }

.mdi-wifi-strength-2-lock::before {
  content: "\\F0924"; }

.mdi-wifi-strength-2-lock-open::before {
  content: "\\F16CC"; }

.mdi-wifi-strength-3::before {
  content: "\\F0925"; }

.mdi-wifi-strength-3-alert::before {
  content: "\\F0926"; }

.mdi-wifi-strength-3-lock::before {
  content: "\\F0927"; }

.mdi-wifi-strength-3-lock-open::before {
  content: "\\F16CD"; }

.mdi-wifi-strength-4::before {
  content: "\\F0928"; }

.mdi-wifi-strength-4-alert::before {
  content: "\\F0929"; }

.mdi-wifi-strength-4-lock::before {
  content: "\\F092A"; }

.mdi-wifi-strength-4-lock-open::before {
  content: "\\F16CE"; }

.mdi-wifi-strength-alert-outline::before {
  content: "\\F092B"; }

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\F16CF"; }

.mdi-wifi-strength-lock-outline::before {
  content: "\\F092C"; }

.mdi-wifi-strength-off::before {
  content: "\\F092D"; }

.mdi-wifi-strength-off-outline::before {
  content: "\\F092E"; }

.mdi-wifi-strength-outline::before {
  content: "\\F092F"; }

.mdi-wifi-sync::before {
  content: "\\F16C7"; }

.mdi-wikipedia::before {
  content: "\\F05AC"; }

.mdi-wind-turbine::before {
  content: "\\F0DA5"; }

.mdi-window-close::before {
  content: "\\F05AD"; }

.mdi-window-closed::before {
  content: "\\F05AE"; }

.mdi-window-closed-variant::before {
  content: "\\F11DB"; }

.mdi-window-maximize::before {
  content: "\\F05AF"; }

.mdi-window-minimize::before {
  content: "\\F05B0"; }

.mdi-window-open::before {
  content: "\\F05B1"; }

.mdi-window-open-variant::before {
  content: "\\F11DC"; }

.mdi-window-restore::before {
  content: "\\F05B2"; }

.mdi-window-shutter::before {
  content: "\\F111C"; }

.mdi-window-shutter-alert::before {
  content: "\\F111D"; }

.mdi-window-shutter-open::before {
  content: "\\F111E"; }

.mdi-windsock::before {
  content: "\\F15FA"; }

.mdi-wiper::before {
  content: "\\F0AE9"; }

.mdi-wiper-wash::before {
  content: "\\F0DA6"; }

.mdi-wizard-hat::before {
  content: "\\F1477"; }

.mdi-wordpress::before {
  content: "\\F05B4"; }

.mdi-wrap::before {
  content: "\\F05B6"; }

.mdi-wrap-disabled::before {
  content: "\\F0BDF"; }

.mdi-wrench::before {
  content: "\\F05B7"; }

.mdi-wrench-outline::before {
  content: "\\F0BE0"; }

.mdi-xamarin::before {
  content: "\\F0845"; }

.mdi-xamarin-outline::before {
  content: "\\F0846"; }

.mdi-xing::before {
  content: "\\F05BE"; }

.mdi-xml::before {
  content: "\\F05C0"; }

.mdi-xmpp::before {
  content: "\\F07FF"; }

.mdi-y-combinator::before {
  content: "\\F0624"; }

.mdi-yahoo::before {
  content: "\\F0B4F"; }

.mdi-yeast::before {
  content: "\\F05C1"; }

.mdi-yin-yang::before {
  content: "\\F0680"; }

.mdi-yoga::before {
  content: "\\F117C"; }

.mdi-youtube::before {
  content: "\\F05C3"; }

.mdi-youtube-gaming::before {
  content: "\\F0848"; }

.mdi-youtube-studio::before {
  content: "\\F0847"; }

.mdi-youtube-subscription::before {
  content: "\\F0D40"; }

.mdi-youtube-tv::before {
  content: "\\F0448"; }

.mdi-yurt::before {
  content: "\\F1516"; }

.mdi-z-wave::before {
  content: "\\F0AEA"; }

.mdi-zend::before {
  content: "\\F0AEB"; }

.mdi-zigbee::before {
  content: "\\F0D41"; }

.mdi-zip-box::before {
  content: "\\F05C4"; }

.mdi-zip-box-outline::before {
  content: "\\F0FFA"; }

.mdi-zip-disk::before {
  content: "\\F0A23"; }

.mdi-zodiac-aquarius::before {
  content: "\\F0A7D"; }

.mdi-zodiac-aries::before {
  content: "\\F0A7E"; }

.mdi-zodiac-cancer::before {
  content: "\\F0A7F"; }

.mdi-zodiac-capricorn::before {
  content: "\\F0A80"; }

.mdi-zodiac-gemini::before {
  content: "\\F0A81"; }

.mdi-zodiac-leo::before {
  content: "\\F0A82"; }

.mdi-zodiac-libra::before {
  content: "\\F0A83"; }

.mdi-zodiac-pisces::before {
  content: "\\F0A84"; }

.mdi-zodiac-sagittarius::before {
  content: "\\F0A85"; }

.mdi-zodiac-scorpio::before {
  content: "\\F0A86"; }

.mdi-zodiac-taurus::before {
  content: "\\F0A87"; }

.mdi-zodiac-virgo::before {
  content: "\\F0A88"; }

.mdi-blank::before {
  content: "\\F68C";
  visibility: hidden; }

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px; }

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px; }

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px; }

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px; }

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54); }

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26); }

.mdi-light:before {
  color: white; }

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3); }

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-45:before {
  transform: rotate(45deg); }

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-90:before {
  transform: rotate(90deg); }

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-135:before {
  transform: rotate(135deg); }

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-180:before {
  transform: rotate(180deg); }

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-225:before {
  transform: rotate(225deg); }

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-270:before {
  transform: rotate(270deg); }

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-315:before {
  transform: rotate(315deg); }

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH"; }

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV"; }

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear; }

@keyframes mdi-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(359deg); } }

/*# sourceMappingURL=materialdesignicons.css.map */
@font-face {
  font-family: 'boxicons';
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg"); }

.bx {
  font-family: 'boxicons' !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none; }

.bx-ul > li {
  position: relative; }

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center; }

@keyframes spin {
  0% {
    transform: rotate(0); }
  100% {
    transform: rotate(359deg); } }

@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1; }
  90% {
    transform: scale(1.5);
    opacity: 0; } }

@keyframes flashing {
  0% {
    opacity: 1; }
  45% {
    opacity: 0; }
  90% {
    opacity: 1; } }

@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(-20px);
    opacity: 0; } }

@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(20px);
    opacity: 0; } }

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(-20px);
    opacity: 0; } }

@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(20px);
    opacity: 0; } }

@keyframes tada {
  from {
    transform: scale3d(1, 1, 1); }
  10%,
  20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg); }
  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg); }
  40%,
  60%,
  80% {
    transform: rotate3d(0, 0, 1, -10deg); }
  to {
    transform: scale3d(1, 1, 1); } }

.bx-spin {
  animation: spin 2s linear infinite; }

.bx-spin-hover:hover {
  animation: spin 2s linear infinite; }

.bx-tada {
  animation: tada 1.5s ease infinite; }

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite; }

.bx-flashing {
  animation: flashing 1.5s infinite linear; }

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear; }

.bx-burst {
  animation: burst 1.5s infinite linear; }

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear; }

.bx-fade-up {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-down {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-left {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-right {
  animation: fade-right 1.5s infinite linear; }

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear; }

.bx-xs {
  font-size: 1rem !important; }

.bx-sm {
  font-size: 1.55rem !important; }

.bx-md {
  font-size: 2.25rem !important; }

.bx-fw {
  font-size: 1.2857142857em;
  line-height: .8em;
  width: 1.2857142857em;
  height: .8em;
  margin-top: -0.2em !important;
  vertical-align: middle; }

.bx-lg {
  font-size: 3rem !important; }

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important; }

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important; }

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)'; }

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)'; }

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)'; }

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)'; }

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)'; }

.bx-border {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: .25em; }

.bx-border-circle {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%; }

.bxl-adobe:before {
  content: "\\e900"; }

.bxl-algolia:before {
  content: "\\e901"; }

.bxl-audible:before {
  content: "\\e902"; }

.bxl-figma:before {
  content: "\\e903"; }

.bxl-redbubble:before {
  content: "\\e904"; }

.bxl-etsy:before {
  content: "\\e905"; }

.bxl-gitlab:before {
  content: "\\e906"; }

.bxl-patreon:before {
  content: "\\e907"; }

.bxl-facebook-circle:before {
  content: "\\e908"; }

.bxl-imdb:before {
  content: "\\e909"; }

.bxl-jquery:before {
  content: "\\e90a"; }

.bxl-pinterest-alt:before {
  content: "\\e90b"; }

.bxl-500px:before {
  content: "\\e90c"; }

.bxl-airbnb:before {
  content: "\\e90d"; }

.bxl-amazon:before {
  content: "\\e90e"; }

.bxl-android:before {
  content: "\\e90f"; }

.bxl-angular:before {
  content: "\\e910"; }

.bxl-apple:before {
  content: "\\e911"; }

.bxl-baidu:before {
  content: "\\e912"; }

.bxl-behance:before {
  content: "\\e913"; }

.bxl-bing:before {
  content: "\\e914"; }

.bxl-bitcoin:before {
  content: "\\e915"; }

.bxl-blogger:before {
  content: "\\e916"; }

.bxl-bootstrap:before {
  content: "\\e917"; }

.bxl-chrome:before {
  content: "\\e918"; }

.bxl-codepen:before {
  content: "\\e919"; }

.bxl-creative-commons:before {
  content: "\\e91a"; }

.bxl-css3:before {
  content: "\\e91b"; }

.bxl-dailymotion:before {
  content: "\\e91c"; }

.bxl-deviantart:before {
  content: "\\e91d"; }

.bxl-digg:before {
  content: "\\e91e"; }

.bxl-digitalocean:before {
  content: "\\e91f"; }

.bxl-discord:before {
  content: "\\e920"; }

.bxl-discourse:before {
  content: "\\e921"; }

.bxl-dribbble:before {
  content: "\\e922"; }

.bxl-dropbox:before {
  content: "\\e923"; }

.bxl-drupal:before {
  content: "\\e924"; }

.bxl-ebay:before {
  content: "\\e925"; }

.bxl-edge:before {
  content: "\\e926"; }

.bxl-facebook:before {
  content: "\\e927"; }

.bxl-facebook-square:before {
  content: "\\e928"; }

.bxl-firefox:before {
  content: "\\e929"; }

.bxl-flickr:before {
  content: "\\e92a"; }

.bxl-flickr-square:before {
  content: "\\e92b"; }

.bxl-foursquare:before {
  content: "\\e92c"; }

.bxl-git:before {
  content: "\\e92d"; }

.bxl-github:before {
  content: "\\e92e"; }

.bxl-google:before {
  content: "\\e92f"; }

.bxl-google-plus:before {
  content: "\\e930"; }

.bxl-google-plus-circle:before {
  content: "\\e931"; }

.bxl-html5:before {
  content: "\\e932"; }

.bxl-instagram:before {
  content: "\\e933"; }

.bxl-instagram-alt:before {
  content: "\\e934"; }

.bxl-internet-explorer:before {
  content: "\\e935"; }

.bxl-invision:before {
  content: "\\e936"; }

.bxl-javascript:before {
  content: "\\e937"; }

.bxl-joomla:before {
  content: "\\e938"; }

.bxl-jsfiddle:before {
  content: "\\e939"; }

.bxl-kickstarter:before {
  content: "\\e93a"; }

.bxl-less:before {
  content: "\\e93b"; }

.bxl-linkedin:before {
  content: "\\e93c"; }

.bxl-linkedin-square:before {
  content: "\\e93d"; }

.bxl-magento:before {
  content: "\\e93e"; }

.bxl-mailchimp:before {
  content: "\\e93f"; }

.bxl-mastercard:before {
  content: "\\e940"; }

.bxl-medium:before {
  content: "\\e941"; }

.bxl-medium-old:before {
  content: "\\e942"; }

.bxl-medium-square:before {
  content: "\\e943"; }

.bxl-messenger:before {
  content: "\\e944"; }

.bxl-microsoft:before {
  content: "\\e945"; }

.bxl-nodejs:before {
  content: "\\e946"; }

.bxl-opera:before {
  content: "\\e947"; }

.bxl-paypal:before {
  content: "\\e948"; }

.bxl-periscope:before {
  content: "\\e949"; }

.bxl-pinterest:before {
  content: "\\e94a"; }

.bxl-play-store:before {
  content: "\\e94b"; }

.bxl-pocket:before {
  content: "\\e94c"; }

.bxl-product-hunt:before {
  content: "\\e94d"; }

.bxl-quora:before {
  content: "\\e94e"; }

.bxl-react:before {
  content: "\\e94f"; }

.bxl-reddit:before {
  content: "\\e950"; }

.bxl-redux:before {
  content: "\\e951"; }

.bxl-sass:before {
  content: "\\e952"; }

.bxl-shopify:before {
  content: "\\e953"; }

.bxl-skype:before {
  content: "\\e954"; }

.bxl-slack:before {
  content: "\\e955"; }

.bxl-slack-old:before {
  content: "\\e956"; }

.bxl-snapchat:before {
  content: "\\e957"; }

.bxl-soundcloud:before {
  content: "\\e958"; }

.bxl-spotify:before {
  content: "\\e959"; }

.bxl-squarespace:before {
  content: "\\e95a"; }

.bxl-stack-overflow:before {
  content: "\\e95b"; }

.bxl-stripe:before {
  content: "\\e95c"; }

.bxl-telegram:before {
  content: "\\e95d"; }

.bxl-trello:before {
  content: "\\e95e"; }

.bxl-tumblr:before {
  content: "\\e95f"; }

.bxl-twitch:before {
  content: "\\e960"; }

.bxl-twitter:before {
  content: "\\e961"; }

.bxl-unsplash:before {
  content: "\\e962"; }

.bxl-vimeo:before {
  content: "\\e963"; }

.bxl-visa:before {
  content: "\\e964"; }

.bxl-vk:before {
  content: "\\e965"; }

.bxl-vuejs:before {
  content: "\\e966"; }

.bxl-whatsapp:before {
  content: "\\e967"; }

.bxl-whatsapp-square:before {
  content: "\\e968"; }

.bxl-wikipedia:before {
  content: "\\e969"; }

.bxl-windows:before {
  content: "\\e96a"; }

.bxl-wix:before {
  content: "\\e96b"; }

.bxl-wordpress:before {
  content: "\\e96c"; }

.bxl-yahoo:before {
  content: "\\e96d"; }

.bxl-yelp:before {
  content: "\\e96e"; }

.bxl-youtube:before {
  content: "\\e96f"; }

.bx-accessibility:before {
  content: "\\e970"; }

.bx-add-to-queue:before {
  content: "\\e971"; }

.bx-adjust:before {
  content: "\\e972"; }

.bx-alarm:before {
  content: "\\e973"; }

.bx-alarm-add:before {
  content: "\\e974"; }

.bx-alarm-off:before {
  content: "\\e975"; }

.bx-album:before {
  content: "\\e976"; }

.bx-align-justify:before {
  content: "\\e977"; }

.bx-align-left:before {
  content: "\\e978"; }

.bx-align-middle:before {
  content: "\\e979"; }

.bx-align-right:before {
  content: "\\e97a"; }

.bx-analyse:before {
  content: "\\e97b"; }

.bx-anchor:before {
  content: "\\e97c"; }

.bx-angry:before {
  content: "\\e97d"; }

.bx-aperture:before {
  content: "\\e97e"; }

.bx-archive:before {
  content: "\\e97f"; }

.bx-archive-in:before {
  content: "\\e980"; }

.bx-archive-out:before {
  content: "\\e981"; }

.bx-area:before {
  content: "\\e982"; }

.bx-arrow-back:before {
  content: "\\e983"; }

.bx-at:before {
  content: "\\e984"; }

.bx-award:before {
  content: "\\e985"; }

.bx-badge:before {
  content: "\\e986"; }

.bx-badge-check:before {
  content: "\\e987"; }

.bx-ball:before {
  content: "\\e988"; }

.bx-band-aid:before {
  content: "\\e989"; }

.bx-bar-chart:before {
  content: "\\e98a"; }

.bx-bar-chart-alt:before {
  content: "\\e98b"; }

.bx-bar-chart-alt-2:before {
  content: "\\e98c"; }

.bx-bar-chart-square:before {
  content: "\\e98d"; }

.bx-barcode:before {
  content: "\\e98e"; }

.bx-basket:before {
  content: "\\e98f"; }

.bx-basketball:before {
  content: "\\e990"; }

.bx-bath:before {
  content: "\\e991"; }

.bx-battery:before {
  content: "\\e992"; }

.bx-bed:before {
  content: "\\e993"; }

.bx-bell:before {
  content: "\\e994"; }

.bx-bell-minus:before {
  content: "\\e995"; }

.bx-bell-off:before {
  content: "\\e996"; }

.bx-bell-plus:before {
  content: "\\e997"; }

.bx-bitcoin:before {
  content: "\\e998"; }

.bx-block:before {
  content: "\\e999"; }

.bx-bluetooth:before {
  content: "\\e99a"; }

.bx-body:before {
  content: "\\e99b"; }

.bx-bold:before {
  content: "\\e99c"; }

.bx-bolt-circle:before {
  content: "\\e99d"; }

.bx-book:before {
  content: "\\e99e"; }

.bx-book-bookmark:before {
  content: "\\e99f"; }

.bx-book-content:before {
  content: "\\e9a0"; }

.bx-bookmark:before {
  content: "\\e9a1"; }

.bx-bookmark-minus:before {
  content: "\\e9a2"; }

.bx-bookmark-plus:before {
  content: "\\e9a3"; }

.bx-bookmarks:before {
  content: "\\e9a4"; }

.bx-book-open:before {
  content: "\\e9a5"; }

.bx-border-all:before {
  content: "\\e9a6"; }

.bx-border-bottom:before {
  content: "\\e9a7"; }

.bx-border-left:before {
  content: "\\e9a8"; }

.bx-border-radius:before {
  content: "\\e9a9"; }

.bx-border-right:before {
  content: "\\e9aa"; }

.bx-border-top:before {
  content: "\\e9ab"; }

.bx-bot:before {
  content: "\\e9ac"; }

.bx-bowling-ball:before {
  content: "\\e9ad"; }

.bx-box:before {
  content: "\\e9ae"; }

.bx-briefcase:before {
  content: "\\e9af"; }

.bx-briefcase-alt:before {
  content: "\\e9b0"; }

.bx-briefcase-alt-2:before {
  content: "\\e9b1"; }

.bx-brightness:before {
  content: "\\e9b2"; }

.bx-brightness-half:before {
  content: "\\e9b3"; }

.bx-broadcast:before {
  content: "\\e9b4"; }

.bx-brush:before {
  content: "\\e9b5"; }

.bx-brush-alt:before {
  content: "\\e9b6"; }

.bx-bug:before {
  content: "\\e9b7"; }

.bx-bug-alt:before {
  content: "\\e9b8"; }

.bx-building:before {
  content: "\\e9b9"; }

.bx-building-house:before {
  content: "\\e9ba"; }

.bx-buildings:before {
  content: "\\e9bb"; }

.bx-bulb:before {
  content: "\\e9bc"; }

.bx-bullseye:before {
  content: "\\e9bd"; }

.bx-buoy:before {
  content: "\\e9be"; }

.bx-bus:before {
  content: "\\e9bf"; }

.bx-cake:before {
  content: "\\e9c0"; }

.bx-calculator:before {
  content: "\\e9c1"; }

.bx-calendar:before {
  content: "\\e9c2"; }

.bx-calendar-alt:before {
  content: "\\e9c3"; }

.bx-calendar-check:before {
  content: "\\e9c4"; }

.bx-calendar-event:before {
  content: "\\e9c5"; }

.bx-calendar-minus:before {
  content: "\\e9c6"; }

.bx-calendar-plus:before {
  content: "\\e9c7"; }

.bx-calendar-x:before {
  content: "\\e9c8"; }

.bx-camera:before {
  content: "\\e9c9"; }

.bx-camera-off:before {
  content: "\\e9ca"; }

.bx-captions:before {
  content: "\\e9cb"; }

.bx-car:before {
  content: "\\e9cc"; }

.bx-card:before {
  content: "\\e9cd"; }

.bx-caret-down:before {
  content: "\\e9ce"; }

.bx-caret-left:before {
  content: "\\e9cf"; }

.bx-caret-right:before {
  content: "\\e9d0"; }

.bx-caret-up:before {
  content: "\\e9d1"; }

.bx-carousel:before {
  content: "\\e9d2"; }

.bx-cart:before {
  content: "\\e9d3"; }

.bx-cart-alt:before {
  content: "\\e9d4"; }

.bx-cast:before {
  content: "\\e9d5"; }

.bx-certification:before {
  content: "\\e9d6"; }

.bx-chalkboard:before {
  content: "\\e9d7"; }

.bx-chart:before {
  content: "\\e9d8"; }

.bx-chat:before {
  content: "\\e9d9"; }

.bx-check:before {
  content: "\\e9da"; }

.bx-checkbox:before {
  content: "\\e9db"; }

.bx-checkbox-checked:before {
  content: "\\e9dc"; }

.bx-checkbox-square:before {
  content: "\\e9dd"; }

.bx-check-circle:before {
  content: "\\e9de"; }

.bx-check-double:before {
  content: "\\e9df"; }

.bx-check-shield:before {
  content: "\\e9e0"; }

.bx-check-square:before {
  content: "\\e9e1"; }

.bx-chevron-down:before {
  content: "\\e9e2"; }

.bx-chevron-left:before {
  content: "\\e9e3"; }

.bx-chevron-right:before {
  content: "\\e9e4"; }

.bx-chevrons-down:before {
  content: "\\e9e5"; }

.bx-chevrons-left:before {
  content: "\\e9e6"; }

.bx-chevrons-right:before {
  content: "\\e9e7"; }

.bx-chevrons-up:before {
  content: "\\e9e8"; }

.bx-chevron-up:before {
  content: "\\e9e9"; }

.bx-chip:before {
  content: "\\e9ea"; }

.bx-circle:before {
  content: "\\e9eb"; }

.bx-clinic:before {
  content: "\\e9ec"; }

.bx-clipboard:before {
  content: "\\e9ed"; }

.bx-closet:before {
  content: "\\e9ee"; }

.bx-cloud:before {
  content: "\\e9ef"; }

.bx-cloud-download:before {
  content: "\\e9f0"; }

.bx-cloud-drizzle:before {
  content: "\\e9f1"; }

.bx-cloud-lightning:before {
  content: "\\e9f2"; }

.bx-cloud-light-rain:before {
  content: "\\e9f3"; }

.bx-cloud-rain:before {
  content: "\\e9f4"; }

.bx-cloud-snow:before {
  content: "\\e9f5"; }

.bx-cloud-upload:before {
  content: "\\e9f6"; }

.bx-code:before {
  content: "\\e9f7"; }

.bx-code-alt:before {
  content: "\\e9f8"; }

.bx-code-block:before {
  content: "\\e9f9"; }

.bx-code-curly:before {
  content: "\\e9fa"; }

.bx-coffee:before {
  content: "\\e9fb"; }

.bx-cog:before {
  content: "\\e9fc"; }

.bx-collapse:before {
  content: "\\e9fd"; }

.bx-collection:before {
  content: "\\e9fe"; }

.bx-columns:before {
  content: "\\e9ff"; }

.bx-command:before {
  content: "\\ea00"; }

.bx-comment:before {
  content: "\\ea01"; }

.bx-comment-dots:before {
  content: "\\ea02"; }

.bx-compass:before {
  content: "\\ea03"; }

.bx-confused:before {
  content: "\\ea04"; }

.bx-conversation:before {
  content: "\\ea05"; }

.bx-cool:before {
  content: "\\ea06"; }

.bx-copy:before {
  content: "\\ea07"; }

.bx-copy-alt:before {
  content: "\\ea08"; }

.bx-copyright:before {
  content: "\\ea09"; }

.bx-credit-card:before {
  content: "\\ea0a"; }

.bx-credit-card-alt:before {
  content: "\\ea0b"; }

.bx-crop:before {
  content: "\\ea0c"; }

.bx-crosshair:before {
  content: "\\ea0d"; }

.bx-crown:before {
  content: "\\ea0e"; }

.bx-cube:before {
  content: "\\ea0f"; }

.bx-cube-alt:before {
  content: "\\ea10"; }

.bx-cuboid:before {
  content: "\\ea11"; }

.bx-customize:before {
  content: "\\ea12"; }

.bx-cut:before {
  content: "\\ea13"; }

.bx-cycling:before {
  content: "\\ea14"; }

.bx-cylinder:before {
  content: "\\ea15"; }

.bx-data:before {
  content: "\\ea16"; }

.bx-desktop:before {
  content: "\\ea17"; }

.bx-detail:before {
  content: "\\ea18"; }

.bx-devices:before {
  content: "\\ea19"; }

.bx-dialpad:before {
  content: "\\ea1a"; }

.bx-dialpad-alt:before {
  content: "\\ea1b"; }

.bx-diamond:before {
  content: "\\ea1c"; }

.bx-directions:before {
  content: "\\ea1d"; }

.bx-disc:before {
  content: "\\ea1e"; }

.bx-dish:before {
  content: "\\ea1f"; }

.bx-dislike:before {
  content: "\\ea20"; }

.bx-dizzy:before {
  content: "\\ea21"; }

.bx-dna:before {
  content: "\\ea22"; }

.bx-dock-bottom:before {
  content: "\\ea23"; }

.bx-dock-left:before {
  content: "\\ea24"; }

.bx-dock-right:before {
  content: "\\ea25"; }

.bx-dock-top:before {
  content: "\\ea26"; }

.bx-dollar:before {
  content: "\\ea27"; }

.bx-dollar-circle:before {
  content: "\\ea28"; }

.bx-dots-horizontal:before {
  content: "\\ea29"; }

.bx-dots-horizontal-rounded:before {
  content: "\\ea2a"; }

.bx-dots-vertical:before {
  content: "\\ea2b"; }

.bx-dots-vertical-rounded:before {
  content: "\\ea2c"; }

.bx-doughnut-chart:before {
  content: "\\ea2d"; }

.bx-down-arrow:before {
  content: "\\ea2e"; }

.bx-down-arrow-alt:before {
  content: "\\ea2f"; }

.bx-down-arrow-circle:before {
  content: "\\ea30"; }

.bx-download:before {
  content: "\\ea31"; }

.bx-downvote:before {
  content: "\\ea32"; }

.bx-droplet:before {
  content: "\\ea33"; }

.bx-dumbbell:before {
  content: "\\ea34"; }

.bx-duplicate:before {
  content: "\\ea35"; }

.bx-edit:before {
  content: "\\ea36"; }

.bx-edit-alt:before {
  content: "\\ea37"; }

.bx-envelope:before {
  content: "\\ea38"; }

.bx-equalizer:before {
  content: "\\ea39"; }

.bx-error:before {
  content: "\\ea3a"; }

.bx-error-alt:before {
  content: "\\ea3b"; }

.bx-error-circle:before {
  content: "\\ea3c"; }

.bx-euro:before {
  content: "\\ea3d"; }

.bx-exit:before {
  content: "\\ea3e"; }

.bx-exit-fullscreen:before {
  content: "\\ea3f"; }

.bx-expand:before {
  content: "\\ea40"; }

.bx-export:before {
  content: "\\ea41"; }

.bx-extension:before {
  content: "\\ea42"; }

.bx-face:before {
  content: "\\ea43"; }

.bx-fast-forward:before {
  content: "\\ea44"; }

.bx-fast-forward-circle:before {
  content: "\\ea45"; }

.bx-female:before {
  content: "\\ea46"; }

.bx-female-sign:before {
  content: "\\ea47"; }

.bx-file:before {
  content: "\\ea48"; }

.bx-file-blank:before {
  content: "\\ea49"; }

.bx-file-find:before {
  content: "\\ea4a"; }

.bx-film:before {
  content: "\\ea4b"; }

.bx-filter:before {
  content: "\\ea4c"; }

.bx-filter-alt:before {
  content: "\\ea4d"; }

.bx-fingerprint:before {
  content: "\\ea4e"; }

.bx-first-aid:before {
  content: "\\ea4f"; }

.bx-first-page:before {
  content: "\\ea50"; }

.bx-flag:before {
  content: "\\ea51"; }

.bx-folder:before {
  content: "\\ea52"; }

.bx-folder-minus:before {
  content: "\\ea53"; }

.bx-folder-open:before {
  content: "\\ea54"; }

.bx-folder-plus:before {
  content: "\\ea55"; }

.bx-font:before {
  content: "\\ea56"; }

.bx-font-color:before {
  content: "\\ea57"; }

.bx-font-family:before {
  content: "\\ea58"; }

.bx-font-size:before {
  content: "\\ea59"; }

.bx-food-menu:before {
  content: "\\ea5a"; }

.bx-food-tag:before {
  content: "\\ea5b"; }

.bx-football:before {
  content: "\\ea5c"; }

.bx-fridge:before {
  content: "\\ea5d"; }

.bx-fullscreen:before {
  content: "\\ea5e"; }

.bx-gas-pump:before {
  content: "\\ea5f"; }

.bx-ghost:before {
  content: "\\ea60"; }

.bx-gift:before {
  content: "\\ea61"; }

.bx-git-branch:before {
  content: "\\ea62"; }

.bx-git-commit:before {
  content: "\\ea63"; }

.bx-git-compare:before {
  content: "\\ea64"; }

.bx-git-merge:before {
  content: "\\ea65"; }

.bx-git-pull-request:before {
  content: "\\ea66"; }

.bx-git-repo-forked:before {
  content: "\\ea67"; }

.bx-globe:before {
  content: "\\ea68"; }

.bx-globe-alt:before {
  content: "\\ea69"; }

.bx-grid:before {
  content: "\\ea6a"; }

.bx-grid-alt:before {
  content: "\\ea6b"; }

.bx-grid-horizontal:before {
  content: "\\ea6c"; }

.bx-grid-small:before {
  content: "\\ea6d"; }

.bx-grid-vertical:before {
  content: "\\ea6e"; }

.bx-group:before {
  content: "\\ea6f"; }

.bx-handicap:before {
  content: "\\ea70"; }

.bx-happy:before {
  content: "\\ea71"; }

.bx-happy-alt:before {
  content: "\\ea72"; }

.bx-happy-beaming:before {
  content: "\\ea73"; }

.bx-happy-heart-eyes:before {
  content: "\\ea74"; }

.bx-hash:before {
  content: "\\ea75"; }

.bx-hdd:before {
  content: "\\ea76"; }

.bx-heading:before {
  content: "\\ea77"; }

.bx-headphone:before {
  content: "\\ea78"; }

.bx-health:before {
  content: "\\ea79"; }

.bx-heart:before {
  content: "\\ea7a"; }

.bx-help-circle:before {
  content: "\\ea7b"; }

.bx-hide:before {
  content: "\\ea7c"; }

.bx-highlight:before {
  content: "\\ea7d"; }

.bx-history:before {
  content: "\\ea7e"; }

.bx-hive:before {
  content: "\\ea7f"; }

.bx-home:before {
  content: "\\ea80"; }

.bx-home-alt:before {
  content: "\\ea81"; }

.bx-home-circle:before {
  content: "\\ea82"; }

.bx-horizontal-center:before {
  content: "\\ea83"; }

.bx-hotel:before {
  content: "\\ea84"; }

.bx-hourglass:before {
  content: "\\ea85"; }

.bx-id-card:before {
  content: "\\ea86"; }

.bx-image:before {
  content: "\\ea87"; }

.bx-image-add:before {
  content: "\\ea88"; }

.bx-image-alt:before {
  content: "\\ea89"; }

.bx-images:before {
  content: "\\ea8a"; }

.bx-import:before {
  content: "\\ea8b"; }

.bx-infinite:before {
  content: "\\ea8c"; }

.bx-info-circle:before {
  content: "\\ea8d"; }

.bx-italic:before {
  content: "\\ea8e"; }

.bx-joystick:before {
  content: "\\ea8f"; }

.bx-joystick-alt:before {
  content: "\\ea90"; }

.bx-joystick-button:before {
  content: "\\ea91"; }

.bx-key:before {
  content: "\\ea92"; }

.bx-label:before {
  content: "\\ea93"; }

.bx-landscape:before {
  content: "\\ea94"; }

.bx-laptop:before {
  content: "\\ea95"; }

.bx-last-page:before {
  content: "\\ea96"; }

.bx-laugh:before {
  content: "\\ea97"; }

.bx-layer:before {
  content: "\\ea98"; }

.bx-layout:before {
  content: "\\ea99"; }

.bx-left-arrow:before {
  content: "\\ea9a"; }

.bx-left-arrow-alt:before {
  content: "\\ea9b"; }

.bx-left-arrow-circle:before {
  content: "\\ea9c"; }

.bx-left-down-arrow-circle:before {
  content: "\\ea9d"; }

.bx-left-indent:before {
  content: "\\ea9e"; }

.bx-left-top-arrow-circle:before {
  content: "\\ea9f"; }

.bx-like:before {
  content: "\\eaa0"; }

.bx-line-chart:before {
  content: "\\eaa1"; }

.bx-link:before {
  content: "\\eaa2"; }

.bx-link-alt:before {
  content: "\\eaa3"; }

.bx-link-external:before {
  content: "\\eaa4"; }

.bx-lira:before {
  content: "\\eaa5"; }

.bx-list-check:before {
  content: "\\eaa6"; }

.bx-list-minus:before {
  content: "\\eaa7"; }

.bx-list-ol:before {
  content: "\\eaa8"; }

.bx-list-plus:before {
  content: "\\eaa9"; }

.bx-list-ul:before {
  content: "\\eaaa"; }

.bx-loader:before {
  content: "\\eaab"; }

.bx-loader-alt:before {
  content: "\\eaac"; }

.bx-loader-circle:before {
  content: "\\eaad"; }

.bx-lock:before {
  content: "\\eaae"; }

.bx-lock-alt:before {
  content: "\\eaaf"; }

.bx-lock-open:before {
  content: "\\eab0"; }

.bx-lock-open-alt:before {
  content: "\\eab1"; }

.bx-log-in:before {
  content: "\\eab2"; }

.bx-log-in-circle:before {
  content: "\\eab3"; }

.bx-log-out:before {
  content: "\\eab4"; }

.bx-log-out-circle:before {
  content: "\\eab5"; }

.bx-magnet:before {
  content: "\\eab6"; }

.bx-mail-send:before {
  content: "\\eab7"; }

.bx-male:before {
  content: "\\eab8"; }

.bx-male-sign:before {
  content: "\\eab9"; }

.bx-map:before {
  content: "\\eaba"; }

.bx-map-alt:before {
  content: "\\eabb"; }

.bx-map-pin:before {
  content: "\\eabc"; }

.bx-meh:before {
  content: "\\eabd"; }

.bx-meh-alt:before {
  content: "\\eabe"; }

.bx-meh-blank:before {
  content: "\\eabf"; }

.bx-memory-card:before {
  content: "\\eac0"; }

.bx-menu:before {
  content: "\\eac1"; }

.bx-menu-alt-left:before {
  content: "\\eac2"; }

.bx-menu-alt-right:before {
  content: "\\eac3"; }

.bx-message:before {
  content: "\\eac4"; }

.bx-message-alt:before {
  content: "\\eac5"; }

.bx-message-alt-dots:before {
  content: "\\eac6"; }

.bx-message-dots:before {
  content: "\\eac7"; }

.bx-message-rounded:before {
  content: "\\eac8"; }

.bx-message-rounded-dots:before {
  content: "\\eac9"; }

.bx-message-square:before {
  content: "\\eaca"; }

.bx-message-square-dots:before {
  content: "\\eacb"; }

.bx-microphone:before {
  content: "\\eacc"; }

.bx-microphone-off:before {
  content: "\\eacd"; }

.bx-minus:before {
  content: "\\eace"; }

.bx-minus-circle:before {
  content: "\\eacf"; }

.bx-mobile:before {
  content: "\\ead0"; }

.bx-mobile-alt:before {
  content: "\\ead1"; }

.bx-mobile-landscape:before {
  content: "\\ead2"; }

.bx-mobile-vibration:before {
  content: "\\ead3"; }

.bx-money:before {
  content: "\\ead4"; }

.bx-moon:before {
  content: "\\ead5"; }

.bx-mouse:before {
  content: "\\ead6"; }

.bx-mouse-alt:before {
  content: "\\ead7"; }

.bx-move:before {
  content: "\\ead8"; }

.bx-move-horizontal:before {
  content: "\\ead9"; }

.bx-move-vertical:before {
  content: "\\eada"; }

.bx-movie:before {
  content: "\\eadb"; }

.bx-music:before {
  content: "\\eadc"; }

.bx-navigation:before {
  content: "\\eadd"; }

.bx-news:before {
  content: "\\eade"; }

.bx-no-entry:before {
  content: "\\eadf"; }

.bx-note:before {
  content: "\\eae0"; }

.bx-notepad:before {
  content: "\\eae1"; }

.bx-notification:before {
  content: "\\eae2"; }

.bx-notification-off:before {
  content: "\\eae3"; }

.bx-package:before {
  content: "\\eae4"; }

.bx-paint:before {
  content: "\\eae5"; }

.bx-paint-roll:before {
  content: "\\eae6"; }

.bx-palette:before {
  content: "\\eae7"; }

.bx-paperclip:before {
  content: "\\eae8"; }

.bx-paper-plane:before {
  content: "\\eae9"; }

.bx-paragraph:before {
  content: "\\eaea"; }

.bx-paste:before {
  content: "\\eaeb"; }

.bx-pause:before {
  content: "\\eaec"; }

.bx-pause-circle:before {
  content: "\\eaed"; }

.bx-pen:before {
  content: "\\eaee"; }

.bx-pencil:before {
  content: "\\eaef"; }

.bx-phone:before {
  content: "\\eaf0"; }

.bx-phone-call:before {
  content: "\\eaf1"; }

.bx-phone-incoming:before {
  content: "\\eaf2"; }

.bx-phone-outgoing:before {
  content: "\\eaf3"; }

.bx-photo-album:before {
  content: "\\eaf4"; }

.bx-pie-chart:before {
  content: "\\eaf5"; }

.bx-pie-chart-alt:before {
  content: "\\eaf6"; }

.bx-pie-chart-alt-2:before {
  content: "\\eaf7"; }

.bx-pin:before {
  content: "\\eaf8"; }

.bx-planet:before {
  content: "\\eaf9"; }

.bx-play:before {
  content: "\\eafa"; }

.bx-play-circle:before {
  content: "\\eafb"; }

.bx-plug:before {
  content: "\\eafc"; }

.bx-plus:before {
  content: "\\eafd"; }

.bx-plus-circle:before {
  content: "\\eafe"; }

.bx-plus-medical:before {
  content: "\\eaff"; }

.bx-poll:before {
  content: "\\eb00"; }

.bx-polygon:before {
  content: "\\eb01"; }

.bx-pound:before {
  content: "\\eb02"; }

.bx-power-off:before {
  content: "\\eb03"; }

.bx-printer:before {
  content: "\\eb04"; }

.bx-pulse:before {
  content: "\\eb05"; }

.bx-purchase-tag:before {
  content: "\\eb06"; }

.bx-purchase-tag-alt:before {
  content: "\\eb07"; }

.bx-pyramid:before {
  content: "\\eb08"; }

.bx-question-mark:before {
  content: "\\eb09"; }

.bx-radar:before {
  content: "\\eb0a"; }

.bx-radio:before {
  content: "\\eb0b"; }

.bx-radio-circle:before {
  content: "\\eb0c"; }

.bx-radio-circle-marked:before {
  content: "\\eb0d"; }

.bx-receipt:before {
  content: "\\eb0e"; }

.bx-rectangle:before {
  content: "\\eb0f"; }

.bx-redo:before {
  content: "\\eb10"; }

.bx-rename:before {
  content: "\\eb11"; }

.bx-repeat:before {
  content: "\\eb12"; }

.bx-reply:before {
  content: "\\eb13"; }

.bx-reply-all:before {
  content: "\\eb14"; }

.bx-repost:before {
  content: "\\eb15"; }

.bx-reset:before {
  content: "\\eb16"; }

.bx-restaurant:before {
  content: "\\eb17"; }

.bx-revision:before {
  content: "\\eb18"; }

.bx-rewind:before {
  content: "\\eb19"; }

.bx-rewind-circle:before {
  content: "\\eb1a"; }

.bx-right-arrow:before {
  content: "\\eb1b"; }

.bx-right-arrow-alt:before {
  content: "\\eb1c"; }

.bx-right-arrow-circle:before {
  content: "\\eb1d"; }

.bx-right-down-arrow-circle:before {
  content: "\\eb1e"; }

.bx-right-indent:before {
  content: "\\eb1f"; }

.bx-right-top-arrow-circle:before {
  content: "\\eb20"; }

.bx-rocket:before {
  content: "\\eb21"; }

.bx-rotate-left:before {
  content: "\\eb22"; }

.bx-rotate-right:before {
  content: "\\eb23"; }

.bx-rss:before {
  content: "\\eb24"; }

.bx-ruble:before {
  content: "\\eb25"; }

.bx-ruler:before {
  content: "\\eb26"; }

.bx-run:before {
  content: "\\eb27"; }

.bx-rupee:before {
  content: "\\eb28"; }

.bx-sad:before {
  content: "\\eb29"; }

.bx-save:before {
  content: "\\eb2a"; }

.bx-screenshot:before {
  content: "\\eb2b"; }

.bx-search:before {
  content: "\\eb2c"; }

.bx-search-alt:before {
  content: "\\eb2d"; }

.bx-search-alt-2:before {
  content: "\\eb2e"; }

.bx-selection:before {
  content: "\\eb2f"; }

.bx-select-multiple:before {
  content: "\\eb30"; }

.bx-send:before {
  content: "\\eb31"; }

.bx-server:before {
  content: "\\eb32"; }

.bx-shape-circle:before {
  content: "\\eb33"; }

.bx-shape-square:before {
  content: "\\eb34"; }

.bx-shape-triangle:before {
  content: "\\eb35"; }

.bx-share:before {
  content: "\\eb36"; }

.bx-share-alt:before {
  content: "\\eb37"; }

.bx-shekel:before {
  content: "\\eb38"; }

.bx-shield:before {
  content: "\\eb39"; }

.bx-shield-alt:before {
  content: "\\eb3a"; }

.bx-shield-alt-2:before {
  content: "\\eb3b"; }

.bx-shield-quarter:before {
  content: "\\eb3c"; }

.bx-shocked:before {
  content: "\\eb3d"; }

.bx-shopping-bag:before {
  content: "\\eb3e"; }

.bx-show:before {
  content: "\\eb3f"; }

.bx-show-alt:before {
  content: "\\eb40"; }

.bx-shuffle:before {
  content: "\\eb41"; }

.bx-sidebar:before {
  content: "\\eb42"; }

.bx-sitemap:before {
  content: "\\eb43"; }

.bx-skip-next:before {
  content: "\\eb44"; }

.bx-skip-next-circle:before {
  content: "\\eb45"; }

.bx-skip-previous:before {
  content: "\\eb46"; }

.bx-skip-previous-circle:before {
  content: "\\eb47"; }

.bx-sleepy:before {
  content: "\\eb48"; }

.bx-slider:before {
  content: "\\eb49"; }

.bx-slider-alt:before {
  content: "\\eb4a"; }

.bx-slideshow:before {
  content: "\\eb4b"; }

.bx-smile:before {
  content: "\\eb4c"; }

.bx-sort:before {
  content: "\\eb4d"; }

.bx-sort-a-z:before {
  content: "\\eb4e"; }

.bx-sort-down:before {
  content: "\\eb4f"; }

.bx-sort-up:before {
  content: "\\eb50"; }

.bx-sort-z-a:before {
  content: "\\eb51"; }

.bx-spa:before {
  content: "\\eb52"; }

.bx-space-bar:before {
  content: "\\eb53"; }

.bx-spreadsheet:before {
  content: "\\eb54"; }

.bx-square:before {
  content: "\\eb55"; }

.bx-square-rounded:before {
  content: "\\eb56"; }

.bx-star:before {
  content: "\\eb57"; }

.bx-station:before {
  content: "\\eb58"; }

.bx-stats:before {
  content: "\\eb59"; }

.bx-sticker:before {
  content: "\\eb5a"; }

.bx-stop:before {
  content: "\\eb5b"; }

.bx-stop-circle:before {
  content: "\\eb5c"; }

.bx-stopwatch:before {
  content: "\\eb5d"; }

.bx-store:before {
  content: "\\eb5e"; }

.bx-store-alt:before {
  content: "\\eb5f"; }

.bx-street-view:before {
  content: "\\eb60"; }

.bx-strikethrough:before {
  content: "\\eb61"; }

.bx-subdirectory-left:before {
  content: "\\eb62"; }

.bx-subdirectory-right:before {
  content: "\\eb63"; }

.bx-sun:before {
  content: "\\eb64"; }

.bx-support:before {
  content: "\\eb65"; }

.bx-swim:before {
  content: "\\eb66"; }

.bx-sync:before {
  content: "\\eb67"; }

.bx-tab:before {
  content: "\\eb68"; }

.bx-table:before {
  content: "\\eb69"; }

.bx-tag:before {
  content: "\\eb6a"; }

.bx-target-lock:before {
  content: "\\eb6b"; }

.bx-task:before {
  content: "\\eb6c"; }

.bx-taxi:before {
  content: "\\eb6d"; }

.bx-tennis-ball:before {
  content: "\\eb6e"; }

.bx-terminal:before {
  content: "\\eb6f"; }

.bx-test-tube:before {
  content: "\\eb70"; }

.bx-text:before {
  content: "\\eb71"; }

.bx-time:before {
  content: "\\eb72"; }

.bx-time-five:before {
  content: "\\eb73"; }

.bx-timer:before {
  content: "\\eb74"; }

.bx-tired:before {
  content: "\\eb75"; }

.bx-toggle-left:before {
  content: "\\eb76"; }

.bx-toggle-right:before {
  content: "\\eb77"; }

.bx-tone:before {
  content: "\\eb78"; }

.bx-train:before {
  content: "\\eb79"; }

.bx-transfer:before {
  content: "\\eb7a"; }

.bx-transfer-alt:before {
  content: "\\eb7b"; }

.bx-trash:before {
  content: "\\eb7c"; }

.bx-trash-alt:before {
  content: "\\eb7d"; }

.bx-trending-down:before {
  content: "\\eb7e"; }

.bx-trending-up:before {
  content: "\\eb7f"; }

.bx-trophy:before {
  content: "\\eb80"; }

.bx-tv:before {
  content: "\\eb81"; }

.bx-underline:before {
  content: "\\eb82"; }

.bx-undo:before {
  content: "\\eb83"; }

.bx-unlink:before {
  content: "\\eb84"; }

.bx-up-arrow:before {
  content: "\\eb85"; }

.bx-up-arrow-alt:before {
  content: "\\eb86"; }

.bx-up-arrow-circle:before {
  content: "\\eb87"; }

.bx-upload:before {
  content: "\\eb88"; }

.bx-upside-down:before {
  content: "\\eb89"; }

.bx-upvote:before {
  content: "\\eb8a"; }

.bx-usb:before {
  content: "\\eb8b"; }

.bx-user:before {
  content: "\\eb8c"; }

.bx-user-check:before {
  content: "\\eb8d"; }

.bx-user-circle:before {
  content: "\\eb8e"; }

.bx-user-minus:before {
  content: "\\eb8f"; }

.bx-user-pin:before {
  content: "\\eb90"; }

.bx-user-plus:before {
  content: "\\eb91"; }

.bx-user-voice:before {
  content: "\\eb92"; }

.bx-user-x:before {
  content: "\\eb93"; }

.bx-vertical-center:before {
  content: "\\eb94"; }

.bx-video:before {
  content: "\\eb95"; }

.bx-video-off:before {
  content: "\\eb96"; }

.bx-video-plus:before {
  content: "\\eb97"; }

.bx-video-recording:before {
  content: "\\eb98"; }

.bx-voicemail:before {
  content: "\\eb99"; }

.bx-volume:before {
  content: "\\eb9a"; }

.bx-volume-full:before {
  content: "\\eb9b"; }

.bx-volume-low:before {
  content: "\\eb9c"; }

.bx-volume-mute:before {
  content: "\\eb9d"; }

.bx-walk:before {
  content: "\\eb9e"; }

.bx-wallet:before {
  content: "\\eb9f"; }

.bx-wallet-alt:before {
  content: "\\eba0"; }

.bx-water:before {
  content: "\\eba1"; }

.bx-wifi:before {
  content: "\\eba2"; }

.bx-wifi-off:before {
  content: "\\eba3"; }

.bx-wind:before {
  content: "\\eba4"; }

.bx-window:before {
  content: "\\eba5"; }

.bx-window-close:before {
  content: "\\eba6"; }

.bx-window-open:before {
  content: "\\eba7"; }

.bx-windows:before {
  content: "\\eba8"; }

.bx-wink-smile:before {
  content: "\\eba9"; }

.bx-wink-tongue:before {
  content: "\\ebaa"; }

.bx-won:before {
  content: "\\ebab"; }

.bx-world:before {
  content: "\\ebac"; }

.bx-wrench:before {
  content: "\\ebad"; }

.bx-x:before {
  content: "\\ebae"; }

.bx-x-circle:before {
  content: "\\ebaf"; }

.bx-yen:before {
  content: "\\ebb0"; }

.bx-zoom-in:before {
  content: "\\ebb1"; }

.bx-zoom-out:before {
  content: "\\ebb2"; }

.bxs-add-to-queue:before {
  content: "\\ebb3"; }

.bxs-adjust:before {
  content: "\\ebb4"; }

.bxs-adjust-alt:before {
  content: "\\ebb5"; }

.bxs-alarm:before {
  content: "\\ebb6"; }

.bxs-alarm-add:before {
  content: "\\ebb7"; }

.bxs-alarm-off:before {
  content: "\\ebb8"; }

.bxs-album:before {
  content: "\\ebb9"; }

.bxs-ambulance:before {
  content: "\\ebba"; }

.bxs-analyse:before {
  content: "\\ebbb"; }

.bxs-angry:before {
  content: "\\ebbc"; }

.bxs-archive:before {
  content: "\\ebbd"; }

.bxs-archive-in:before {
  content: "\\ebbe"; }

.bxs-archive-out:before {
  content: "\\ebbf"; }

.bxs-area:before {
  content: "\\ebc0"; }

.bxs-award:before {
  content: "\\ebc1"; }

.bxs-baby-carriage:before {
  content: "\\ebc2"; }

.bxs-badge:before {
  content: "\\ebc3"; }

.bxs-badge-check:before {
  content: "\\ebc4"; }

.bxs-ball:before {
  content: "\\ebc5"; }

.bxs-band-aid:before {
  content: "\\ebc6"; }

.bxs-bank:before {
  content: "\\ebc7"; }

.bxs-bar-chart-alt-2:before {
  content: "\\ebc8"; }

.bxs-bar-chart-square:before {
  content: "\\ebc9"; }

.bxs-barcode:before {
  content: "\\ebca"; }

.bxs-basket:before {
  content: "\\ebcb"; }

.bxs-bath:before {
  content: "\\ebcc"; }

.bxs-battery:before {
  content: "\\ebcd"; }

.bxs-battery-charging:before {
  content: "\\ebce"; }

.bxs-battery-full:before {
  content: "\\ebcf"; }

.bxs-battery-low:before {
  content: "\\ebd0"; }

.bxs-bed:before {
  content: "\\ebd1"; }

.bxs-bell:before {
  content: "\\ebd2"; }

.bxs-bell-minus:before {
  content: "\\ebd3"; }

.bxs-bell-off:before {
  content: "\\ebd4"; }

.bxs-bell-plus:before {
  content: "\\ebd5"; }

.bxs-bell-ring:before {
  content: "\\ebd6"; }

.bxs-bolt:before {
  content: "\\ebd7"; }

.bxs-bolt-circle:before {
  content: "\\ebd8"; }

.bxs-book:before {
  content: "\\ebd9"; }

.bxs-book-bookmark:before {
  content: "\\ebda"; }

.bxs-book-content:before {
  content: "\\ebdb"; }

.bxs-bookmark:before {
  content: "\\ebdc"; }

.bxs-bookmark-minus:before {
  content: "\\ebdd"; }

.bxs-bookmark-plus:before {
  content: "\\ebde"; }

.bxs-bookmarks:before {
  content: "\\ebdf"; }

.bxs-bookmark-star:before {
  content: "\\ebe0"; }

.bxs-book-open:before {
  content: "\\ebe1"; }

.bxs-bot:before {
  content: "\\ebe2"; }

.bxs-bowling-ball:before {
  content: "\\ebe3"; }

.bxs-box:before {
  content: "\\ebe4"; }

.bxs-briefcase:before {
  content: "\\ebe5"; }

.bxs-briefcase-alt:before {
  content: "\\ebe6"; }

.bxs-briefcase-alt-2:before {
  content: "\\ebe7"; }

.bxs-brightness:before {
  content: "\\ebe8"; }

.bxs-brightness-half:before {
  content: "\\ebe9"; }

.bxs-brush:before {
  content: "\\ebea"; }

.bxs-brush-alt:before {
  content: "\\ebeb"; }

.bxs-bug:before {
  content: "\\ebec"; }

.bxs-bug-alt:before {
  content: "\\ebed"; }

.bxs-building:before {
  content: "\\ebee"; }

.bxs-building-house:before {
  content: "\\ebef"; }

.bxs-buildings:before {
  content: "\\ebf0"; }

.bxs-bulb:before {
  content: "\\ebf1"; }

.bxs-buoy:before {
  content: "\\ebf2"; }

.bxs-bus:before {
  content: "\\ebf3"; }

.bxs-business:before {
  content: "\\ebf4"; }

.bxs-cake:before {
  content: "\\ebf5"; }

.bxs-calculator:before {
  content: "\\ebf6"; }

.bxs-calendar:before {
  content: "\\ebf7"; }

.bxs-calendar-alt:before {
  content: "\\ebf8"; }

.bxs-calendar-check:before {
  content: "\\ebf9"; }

.bxs-calendar-event:before {
  content: "\\ebfa"; }

.bxs-calendar-minus:before {
  content: "\\ebfb"; }

.bxs-calendar-plus:before {
  content: "\\ebfc"; }

.bxs-calendar-x:before {
  content: "\\ebfd"; }

.bxs-camera:before {
  content: "\\ebfe"; }

.bxs-camera-off:before {
  content: "\\ebff"; }

.bxs-camera-plus:before {
  content: "\\ec00"; }

.bxs-capsule:before {
  content: "\\ec01"; }

.bxs-captions:before {
  content: "\\ec02"; }

.bxs-car:before {
  content: "\\ec03"; }

.bxs-card:before {
  content: "\\ec04"; }

.bxs-caret-down-circle:before {
  content: "\\ec05"; }

.bxs-caret-left-circle:before {
  content: "\\ec06"; }

.bxs-caret-right-circle:before {
  content: "\\ec07"; }

.bxs-caret-up-circle:before {
  content: "\\ec08"; }

.bxs-carousel:before {
  content: "\\ec09"; }

.bxs-cart:before {
  content: "\\ec0a"; }

.bxs-cart-alt:before {
  content: "\\ec0b"; }

.bxs-certification:before {
  content: "\\ec0c"; }

.bxs-chalkboard:before {
  content: "\\ec0d"; }

.bxs-chart:before {
  content: "\\ec0e"; }

.bxs-chat:before {
  content: "\\ec0f"; }

.bxs-checkbox:before {
  content: "\\ec10"; }

.bxs-checkbox-checked:before {
  content: "\\ec11"; }

.bxs-check-circle:before {
  content: "\\ec12"; }

.bxs-check-shield:before {
  content: "\\ec13"; }

.bxs-check-square:before {
  content: "\\ec14"; }

.bxs-chip:before {
  content: "\\ec15"; }

.bxs-circle:before {
  content: "\\ec16"; }

.bxs-city:before {
  content: "\\ec17"; }

.bxs-clinic:before {
  content: "\\ec18"; }

.bxs-cloud:before {
  content: "\\ec19"; }

.bxs-cloud-download:before {
  content: "\\ec1a"; }

.bxs-cloud-lightning:before {
  content: "\\ec1b"; }

.bxs-cloud-rain:before {
  content: "\\ec1c"; }

.bxs-cloud-upload:before {
  content: "\\ec1d"; }

.bxs-coffee:before {
  content: "\\ec1e"; }

.bxs-coffee-alt:before {
  content: "\\ec1f"; }

.bxs-cog:before {
  content: "\\ec20"; }

.bxs-collection:before {
  content: "\\ec21"; }

.bxs-color-fill:before {
  content: "\\ec22"; }

.bxs-comment:before {
  content: "\\ec23"; }

.bxs-comment-add:before {
  content: "\\ec24"; }

.bxs-comment-detail:before {
  content: "\\ec25"; }

.bxs-comment-dots:before {
  content: "\\ec26"; }

.bxs-comment-error:before {
  content: "\\ec27"; }

.bxs-compass:before {
  content: "\\ec28"; }

.bxs-component:before {
  content: "\\ec29"; }

.bxs-confused:before {
  content: "\\ec2a"; }

.bxs-contact:before {
  content: "\\ec2b"; }

.bxs-conversation:before {
  content: "\\ec2c"; }

.bxs-cool:before {
  content: "\\ec2d"; }

.bxs-copy:before {
  content: "\\ec2e"; }

.bxs-copy-alt:before {
  content: "\\ec2f"; }

.bxs-coupon:before {
  content: "\\ec30"; }

.bxs-credit-card:before {
  content: "\\ec31"; }

.bxs-credit-card-alt:before {
  content: "\\ec32"; }

.bxs-crown:before {
  content: "\\ec33"; }

.bxs-cube:before {
  content: "\\ec34"; }

.bxs-cube-alt:before {
  content: "\\ec35"; }

.bxs-cuboid:before {
  content: "\\ec36"; }

.bxs-customize:before {
  content: "\\ec37"; }

.bxs-cylinder:before {
  content: "\\ec38"; }

.bxs-dashboard:before {
  content: "\\ec39"; }

.bxs-data:before {
  content: "\\ec3a"; }

.bxs-detail:before {
  content: "\\ec3b"; }

.bxs-devices:before {
  content: "\\ec3c"; }

.bxs-direction-left:before {
  content: "\\ec3d"; }

.bxs-direction-right:before {
  content: "\\ec3e"; }

.bxs-directions:before {
  content: "\\ec3f"; }

.bxs-disc:before {
  content: "\\ec40"; }

.bxs-discount:before {
  content: "\\ec41"; }

.bxs-dish:before {
  content: "\\ec42"; }

.bxs-dislike:before {
  content: "\\ec43"; }

.bxs-dizzy:before {
  content: "\\ec44"; }

.bxs-dock-bottom:before {
  content: "\\ec45"; }

.bxs-dock-left:before {
  content: "\\ec46"; }

.bxs-dock-right:before {
  content: "\\ec47"; }

.bxs-dock-top:before {
  content: "\\ec48"; }

.bxs-dollar-circle:before {
  content: "\\ec49"; }

.bxs-doughnut-chart:before {
  content: "\\ec4a"; }

.bxs-down-arrow:before {
  content: "\\ec4b"; }

.bxs-down-arrow-circle:before {
  content: "\\ec4c"; }

.bxs-down-arrow-square:before {
  content: "\\ec4d"; }

.bxs-download:before {
  content: "\\ec4e"; }

.bxs-downvote:before {
  content: "\\ec4f"; }

.bxs-drink:before {
  content: "\\ec50"; }

.bxs-droplet:before {
  content: "\\ec51"; }

.bxs-droplet-half:before {
  content: "\\ec52"; }

.bxs-duplicate:before {
  content: "\\ec53"; }

.bxs-edit:before {
  content: "\\ec54"; }

.bxs-edit-alt:before {
  content: "\\ec55"; }

.bxs-eject:before {
  content: "\\ec56"; }

.bxs-envelope:before {
  content: "\\ec57"; }

.bxs-eraser:before {
  content: "\\ec58"; }

.bxs-error:before {
  content: "\\ec59"; }

.bxs-error-alt:before {
  content: "\\ec5a"; }

.bxs-error-circle:before {
  content: "\\ec5b"; }

.bxs-exit:before {
  content: "\\ec5c"; }

.bxs-extension:before {
  content: "\\ec5d"; }

.bxs-eyedropper:before {
  content: "\\ec5e"; }

.bxs-face:before {
  content: "\\ec5f"; }

.bxs-factory:before {
  content: "\\ec60"; }

.bxs-fast-forward-circle:before {
  content: "\\ec61"; }

.bxs-file:before {
  content: "\\ec62"; }

.bxs-file-blank:before {
  content: "\\ec63"; }

.bxs-file-css:before {
  content: "\\ec64"; }

.bxs-file-doc:before {
  content: "\\ec65"; }

.bxs-file-find:before {
  content: "\\ec66"; }

.bxs-file-gif:before {
  content: "\\ec67"; }

.bxs-file-html:before {
  content: "\\ec68"; }

.bxs-file-image:before {
  content: "\\ec69"; }

.bxs-file-jpg:before {
  content: "\\ec6a"; }

.bxs-file-js:before {
  content: "\\ec6b"; }

.bxs-file-json:before {
  content: "\\ec6c"; }

.bxs-file-md:before {
  content: "\\ec6d"; }

.bxs-file-pdf:before {
  content: "\\ec6e"; }

.bxs-file-plus:before {
  content: "\\ec6f"; }

.bxs-file-png:before {
  content: "\\ec70"; }

.bxs-file-txt:before {
  content: "\\ec71"; }

.bxs-film:before {
  content: "\\ec72"; }

.bxs-filter-alt:before {
  content: "\\ec73"; }

.bxs-first-aid:before {
  content: "\\ec74"; }

.bxs-flag:before {
  content: "\\ec75"; }

.bxs-flag-alt:before {
  content: "\\ec76"; }

.bxs-flame:before {
  content: "\\ec77"; }

.bxs-flask:before {
  content: "\\ec78"; }

.bxs-folder:before {
  content: "\\ec79"; }

.bxs-folder-minus:before {
  content: "\\ec7a"; }

.bxs-folder-open:before {
  content: "\\ec7b"; }

.bxs-folder-plus:before {
  content: "\\ec7c"; }

.bxs-food-menu:before {
  content: "\\ec7d"; }

.bxs-fridge:before {
  content: "\\ec7e"; }

.bxs-gas-pump:before {
  content: "\\ec7f"; }

.bxs-ghost:before {
  content: "\\ec80"; }

.bxs-gift:before {
  content: "\\ec81"; }

.bxs-graduation:before {
  content: "\\ec82"; }

.bxs-grid:before {
  content: "\\ec83"; }

.bxs-grid-alt:before {
  content: "\\ec84"; }

.bxs-group:before {
  content: "\\ec85"; }

.bxs-hand-down:before {
  content: "\\ec86"; }

.bxs-hand-left:before {
  content: "\\ec87"; }

.bxs-hand-right:before {
  content: "\\ec88"; }

.bxs-hand-up:before {
  content: "\\ec89"; }

.bxs-happy:before {
  content: "\\ec8a"; }

.bxs-happy-alt:before {
  content: "\\ec8b"; }

.bxs-happy-beaming:before {
  content: "\\ec8c"; }

.bxs-happy-heart-eyes:before {
  content: "\\ec8d"; }

.bxs-hdd:before {
  content: "\\ec8e"; }

.bxs-heart:before {
  content: "\\ec8f"; }

.bxs-help-circle:before {
  content: "\\ec90"; }

.bxs-hide:before {
  content: "\\ec91"; }

.bxs-home:before {
  content: "\\ec92"; }

.bxs-home-circle:before {
  content: "\\ec93"; }

.bxs-hot:before {
  content: "\\ec94"; }

.bxs-hotel:before {
  content: "\\ec95"; }

.bxs-hourglass:before {
  content: "\\ec96"; }

.bxs-hourglass-bottom:before {
  content: "\\ec97"; }

.bxs-hourglass-top:before {
  content: "\\ec98"; }

.bxs-id-card:before {
  content: "\\ec99"; }

.bxs-image:before {
  content: "\\ec9a"; }

.bxs-image-add:before {
  content: "\\ec9b"; }

.bxs-image-alt:before {
  content: "\\ec9c"; }

.bxs-inbox:before {
  content: "\\ec9d"; }

.bxs-info-circle:before {
  content: "\\ec9e"; }

.bxs-institution:before {
  content: "\\ec9f"; }

.bxs-joystick:before {
  content: "\\eca0"; }

.bxs-joystick-alt:before {
  content: "\\eca1"; }

.bxs-joystick-button:before {
  content: "\\eca2"; }

.bxs-key:before {
  content: "\\eca3"; }

.bxs-keyboard:before {
  content: "\\eca4"; }

.bxs-label:before {
  content: "\\eca5"; }

.bxs-landmark:before {
  content: "\\eca6"; }

.bxs-landscape:before {
  content: "\\eca7"; }

.bxs-laugh:before {
  content: "\\eca8"; }

.bxs-layer:before {
  content: "\\eca9"; }

.bxs-layout:before {
  content: "\\ecaa"; }

.bxs-left-arrow:before {
  content: "\\ecab"; }

.bxs-left-arrow-circle:before {
  content: "\\ecac"; }

.bxs-left-arrow-square:before {
  content: "\\ecad"; }

.bxs-left-down-arrow-circle:before {
  content: "\\ecae"; }

.bxs-left-top-arrow-circle:before {
  content: "\\ecaf"; }

.bxs-like:before {
  content: "\\ecb0"; }

.bxs-lock:before {
  content: "\\ecb1"; }

.bxs-lock-alt:before {
  content: "\\ecb2"; }

.bxs-lock-open:before {
  content: "\\ecb3"; }

.bxs-lock-open-alt:before {
  content: "\\ecb4"; }

.bxs-log-in:before {
  content: "\\ecb5"; }

.bxs-log-in-circle:before {
  content: "\\ecb6"; }

.bxs-log-out:before {
  content: "\\ecb7"; }

.bxs-log-out-circle:before {
  content: "\\ecb8"; }

.bxs-magic-wand:before {
  content: "\\ecb9"; }

.bxs-magnet:before {
  content: "\\ecba"; }

.bxs-map:before {
  content: "\\ecbb"; }

.bxs-map-alt:before {
  content: "\\ecbc"; }

.bxs-map-pin:before {
  content: "\\ecbd"; }

.bxs-megaphone:before {
  content: "\\ecbe"; }

.bxs-meh:before {
  content: "\\ecbf"; }

.bxs-meh-alt:before {
  content: "\\ecc0"; }

.bxs-meh-blank:before {
  content: "\\ecc1"; }

.bxs-memory-card:before {
  content: "\\ecc2"; }

.bxs-message:before {
  content: "\\ecc3"; }

.bxs-message-alt:before {
  content: "\\ecc4"; }

.bxs-message-alt-dots:before {
  content: "\\ecc5"; }

.bxs-message-dots:before {
  content: "\\ecc6"; }

.bxs-message-rounded:before {
  content: "\\ecc7"; }

.bxs-message-rounded-dots:before {
  content: "\\ecc8"; }

.bxs-message-square:before {
  content: "\\ecc9"; }

.bxs-message-square-dots:before {
  content: "\\ecca"; }

.bxs-microphone:before {
  content: "\\eccb"; }

.bxs-microphone-alt:before {
  content: "\\eccc"; }

.bxs-microphone-off:before {
  content: "\\eccd"; }

.bxs-minus-circle:before {
  content: "\\ecce"; }

.bxs-minus-square:before {
  content: "\\eccf"; }

.bxs-mobile:before {
  content: "\\ecd0"; }

.bxs-mobile-vibration:before {
  content: "\\ecd1"; }

.bxs-moon:before {
  content: "\\ecd2"; }

.bxs-mouse:before {
  content: "\\ecd3"; }

.bxs-mouse-alt:before {
  content: "\\ecd4"; }

.bxs-movie:before {
  content: "\\ecd5"; }

.bxs-music:before {
  content: "\\ecd6"; }

.bxs-navigation:before {
  content: "\\ecd7"; }

.bxs-news:before {
  content: "\\ecd8"; }

.bxs-no-entry:before {
  content: "\\ecd9"; }

.bxs-note:before {
  content: "\\ecda"; }

.bxs-notepad:before {
  content: "\\ecdb"; }

.bxs-notification:before {
  content: "\\ecdc"; }

.bxs-notification-off:before {
  content: "\\ecdd"; }

.bxs-offer:before {
  content: "\\ecde"; }

.bxs-package:before {
  content: "\\ecdf"; }

.bxs-paint:before {
  content: "\\ece0"; }

.bxs-paint-roll:before {
  content: "\\ece1"; }

.bxs-palette:before {
  content: "\\ece2"; }

.bxs-paper-plane:before {
  content: "\\ece3"; }

.bxs-parking:before {
  content: "\\ece4"; }

.bxs-paste:before {
  content: "\\ece5"; }

.bxs-pen:before {
  content: "\\ece6"; }

.bxs-pencil:before {
  content: "\\ece7"; }

.bxs-phone:before {
  content: "\\ece8"; }

.bxs-phone-call:before {
  content: "\\ece9"; }

.bxs-phone-incoming:before {
  content: "\\ecea"; }

.bxs-phone-outgoing:before {
  content: "\\eceb"; }

.bxs-photo-album:before {
  content: "\\ecec"; }

.bxs-pie-chart:before {
  content: "\\eced"; }

.bxs-pie-chart-alt:before {
  content: "\\ecee"; }

.bxs-pie-chart-alt-2:before {
  content: "\\ecef"; }

.bxs-pin:before {
  content: "\\ecf0"; }

.bxs-plane:before {
  content: "\\ecf1"; }

.bxs-plane-alt:before {
  content: "\\ecf2"; }

.bxs-plane-land:before {
  content: "\\ecf3"; }

.bxs-planet:before {
  content: "\\ecf4"; }

.bxs-plane-take-off:before {
  content: "\\ecf5"; }

.bxs-playlist:before {
  content: "\\ecf6"; }

.bxs-plug:before {
  content: "\\ecf7"; }

.bxs-plus-circle:before {
  content: "\\ecf8"; }

.bxs-plus-square:before {
  content: "\\ecf9"; }

.bxs-polygon:before {
  content: "\\ecfa"; }

.bxs-printer:before {
  content: "\\ecfb"; }

.bxs-purchase-tag:before {
  content: "\\ecfc"; }

.bxs-purchase-tag-alt:before {
  content: "\\ecfd"; }

.bxs-pyramid:before {
  content: "\\ecfe"; }

.bxs-quote-alt-left:before {
  content: "\\ecff"; }

.bxs-quote-alt-right:before {
  content: "\\ed00"; }

.bxs-quote-left:before {
  content: "\\ed01"; }

.bxs-quote-right:before {
  content: "\\ed02"; }

.bxs-quote-single-left:before {
  content: "\\ed03"; }

.bxs-quote-single-right:before {
  content: "\\ed04"; }

.bxs-radio:before {
  content: "\\ed05"; }

.bxs-receipt:before {
  content: "\\ed06"; }

.bxs-rectangle:before {
  content: "\\ed07"; }

.bxs-rename:before {
  content: "\\ed08"; }

.bxs-report:before {
  content: "\\ed09"; }

.bxs-rewind-circle:before {
  content: "\\ed0a"; }

.bxs-right-arrow:before {
  content: "\\ed0b"; }

.bxs-right-arrow-circle:before {
  content: "\\ed0c"; }

.bxs-right-arrow-square:before {
  content: "\\ed0d"; }

.bxs-right-down-arrow-circle:before {
  content: "\\ed0e"; }

.bxs-right-top-arrow-circle:before {
  content: "\\ed0f"; }

.bxs-rocket:before {
  content: "\\ed10"; }

.bxs-ruler:before {
  content: "\\ed11"; }

.bxs-sad:before {
  content: "\\ed12"; }

.bxs-save:before {
  content: "\\ed13"; }

.bxs-school:before {
  content: "\\ed14"; }

.bxs-search:before {
  content: "\\ed15"; }

.bxs-search-alt-2:before {
  content: "\\ed16"; }

.bxs-select-multiple:before {
  content: "\\ed17"; }

.bxs-send:before {
  content: "\\ed18"; }

.bxs-server:before {
  content: "\\ed19"; }

.bxs-share:before {
  content: "\\ed1a"; }

.bxs-share-alt:before {
  content: "\\ed1b"; }

.bxs-shield:before {
  content: "\\ed1c"; }

.bxs-shield-alt-2:before {
  content: "\\ed1d"; }

.bxs-ship:before {
  content: "\\ed1e"; }

.bxs-shocked:before {
  content: "\\ed1f"; }

.bxs-shopping-bag:before {
  content: "\\ed20"; }

.bxs-shopping-bag-alt:before {
  content: "\\ed21"; }

.bxs-show:before {
  content: "\\ed22"; }

.bxs-skip-next-circle:before {
  content: "\\ed23"; }

.bxs-skip-previous-circle:before {
  content: "\\ed24"; }

.bxs-skull:before {
  content: "\\ed25"; }

.bxs-sleepy:before {
  content: "\\ed26"; }

.bxs-slideshow:before {
  content: "\\ed27"; }

.bxs-smile:before {
  content: "\\ed28"; }

.bxs-sort-alt:before {
  content: "\\ed29"; }

.bxs-spa:before {
  content: "\\ed2a"; }

.bxs-spreadsheet:before {
  content: "\\ed2b"; }

.bxs-square:before {
  content: "\\ed2c"; }

.bxs-square-rounded:before {
  content: "\\ed2d"; }

.bxs-star:before {
  content: "\\ed2e"; }

.bxs-star-half:before {
  content: "\\ed2f"; }

.bxs-stopwatch:before {
  content: "\\ed30"; }

.bxs-store:before {
  content: "\\ed31"; }

.bxs-store-alt:before {
  content: "\\ed32"; }

.bxs-sun:before {
  content: "\\ed33"; }

.bxs-tag:before {
  content: "\\ed34"; }

.bxs-tag-x:before {
  content: "\\ed35"; }

.bxs-taxi:before {
  content: "\\ed36"; }

.bxs-tennis-ball:before {
  content: "\\ed37"; }

.bxs-terminal:before {
  content: "\\ed38"; }

.bxs-time:before {
  content: "\\ed39"; }

.bxs-time-five:before {
  content: "\\ed3a"; }

.bxs-timer:before {
  content: "\\ed3b"; }

.bxs-tired:before {
  content: "\\ed3c"; }

.bxs-toggle-left:before {
  content: "\\ed3d"; }

.bxs-toggle-right:before {
  content: "\\ed3e"; }

.bxs-tone:before {
  content: "\\ed3f"; }

.bxs-torch:before {
  content: "\\ed40"; }

.bxs-to-top:before {
  content: "\\ed41"; }

.bxs-traffic:before {
  content: "\\ed42"; }

.bxs-traffic-barrier:before {
  content: "\\ed43"; }

.bxs-train:before {
  content: "\\ed44"; }

.bxs-trash:before {
  content: "\\ed45"; }

.bxs-trash-alt:before {
  content: "\\ed46"; }

.bxs-tree:before {
  content: "\\ed47"; }

.bxs-trophy:before {
  content: "\\ed48"; }

.bxs-truck:before {
  content: "\\ed49"; }

.bxs-t-shirt:before {
  content: "\\ed4a"; }

.bxs-up-arrow:before {
  content: "\\ed4b"; }

.bxs-up-arrow-circle:before {
  content: "\\ed4c"; }

.bxs-up-arrow-square:before {
  content: "\\ed4d"; }

.bxs-upside-down:before {
  content: "\\ed4e"; }

.bxs-upvote:before {
  content: "\\ed4f"; }

.bxs-user:before {
  content: "\\ed50"; }

.bxs-user-badge:before {
  content: "\\ed51"; }

.bxs-user-check:before {
  content: "\\ed52"; }

.bxs-user-circle:before {
  content: "\\ed53"; }

.bxs-user-detail:before {
  content: "\\ed54"; }

.bxs-user-minus:before {
  content: "\\ed55"; }

.bxs-user-pin:before {
  content: "\\ed56"; }

.bxs-user-plus:before {
  content: "\\ed57"; }

.bxs-user-rectangle:before {
  content: "\\ed58"; }

.bxs-user-voice:before {
  content: "\\ed59"; }

.bxs-user-x:before {
  content: "\\ed5a"; }

.bxs-vial:before {
  content: "\\ed5b"; }

.bxs-video:before {
  content: "\\ed5c"; }

.bxs-video-off:before {
  content: "\\ed5d"; }

.bxs-video-plus:before {
  content: "\\ed5e"; }

.bxs-video-recording:before {
  content: "\\ed5f"; }

.bxs-videos:before {
  content: "\\ed60"; }

.bxs-volume:before {
  content: "\\ed61"; }

.bxs-volume-full:before {
  content: "\\ed62"; }

.bxs-volume-low:before {
  content: "\\ed63"; }

.bxs-volume-mute:before {
  content: "\\ed64"; }

.bxs-wallet:before {
  content: "\\ed65"; }

.bxs-wallet-alt:before {
  content: "\\ed66"; }

.bxs-watch:before {
  content: "\\ed67"; }

.bxs-watch-alt:before {
  content: "\\ed68"; }

.bxs-widget:before {
  content: "\\ed69"; }

.bxs-wine:before {
  content: "\\ed6a"; }

.bxs-wink-smile:before {
  content: "\\ed6b"; }

.bxs-wink-tongue:before {
  content: "\\ed6c"; }

.bxs-wrench:before {
  content: "\\ed6d"; }

.bxs-x-circle:before {
  content: "\\ed6e"; }

.bxs-x-square:before {
  content: "\\ed6f"; }

.bxs-yin-yang:before {
  content: "\\ed70"; }

.bxs-zap:before {
  content: "\\ed71"; }

.bxs-zoom-in:before {
  content: "\\ed72"; }

.bxs-zoom-out:before {
  content: "\\ed73"; }

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fas,
.far,
.fal,
.fad,
.fab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1; }

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.fa-xs {
  font-size: .75em; }

.fa-sm {
  font-size: .875em; }

.fa-1x {
  font-size: 1em; }

.fa-2x {
  font-size: 2em; }

.fa-3x {
  font-size: 3em; }

.fa-4x {
  font-size: 4em; }

.fa-5x {
  font-size: 5em; }

.fa-6x {
  font-size: 6em; }

.fa-7x {
  font-size: 7em; }

.fa-8x {
  font-size: 8em; }

.fa-9x {
  font-size: 9em; }

.fa-10x {
  font-size: 10em; }

.fa-fw {
  text-align: center;
  width: 1.25em; }

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0; }

.fa-ul > li {
  position: relative; }

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit; }

.fa-border {
  border: solid 0.08em #eee;
  border-radius: .1em;
  padding: .2em .25em .15em; }

.fa-pull-left {
  float: left; }

.fa-pull-right {
  float: right; }

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: .3em; }

.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: .3em; }

.fa-spin {
  animation: fa-spin 2s infinite linear; }

.fa-pulse {
  animation: fa-spin 1s infinite steps(8); }

@keyframes fa-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg); }

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg); }

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg); }

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1); }

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1); }

.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1); }

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  filter: none; }

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em; }

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%; }

.fa-stack-1x {
  line-height: inherit; }

.fa-stack-2x {
  font-size: 2em; }

.fa-inverse {
  color: #fff; }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-500px:before {
  content: "\\f26e"; }

.fa-accessible-icon:before {
  content: "\\f368"; }

.fa-accusoft:before {
  content: "\\f369"; }

.fa-acquisitions-incorporated:before {
  content: "\\f6af"; }

.fa-ad:before {
  content: "\\f641"; }

.fa-address-book:before {
  content: "\\f2b9"; }

.fa-address-card:before {
  content: "\\f2bb"; }

.fa-adjust:before {
  content: "\\f042"; }

.fa-adn:before {
  content: "\\f170"; }

.fa-adobe:before {
  content: "\\f778"; }

.fa-adversal:before {
  content: "\\f36a"; }

.fa-affiliatetheme:before {
  content: "\\f36b"; }

.fa-air-freshener:before {
  content: "\\f5d0"; }

.fa-airbnb:before {
  content: "\\f834"; }

.fa-algolia:before {
  content: "\\f36c"; }

.fa-align-center:before {
  content: "\\f037"; }

.fa-align-justify:before {
  content: "\\f039"; }

.fa-align-left:before {
  content: "\\f036"; }

.fa-align-right:before {
  content: "\\f038"; }

.fa-alipay:before {
  content: "\\f642"; }

.fa-allergies:before {
  content: "\\f461"; }

.fa-amazon:before {
  content: "\\f270"; }

.fa-amazon-pay:before {
  content: "\\f42c"; }

.fa-ambulance:before {
  content: "\\f0f9"; }

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3"; }

.fa-amilia:before {
  content: "\\f36d"; }

.fa-anchor:before {
  content: "\\f13d"; }

.fa-android:before {
  content: "\\f17b"; }

.fa-angellist:before {
  content: "\\f209"; }

.fa-angle-double-down:before {
  content: "\\f103"; }

.fa-angle-double-left:before {
  content: "\\f100"; }

.fa-angle-double-right:before {
  content: "\\f101"; }

.fa-angle-double-up:before {
  content: "\\f102"; }

.fa-angle-down:before {
  content: "\\f107"; }

.fa-angle-left:before {
  content: "\\f104"; }

.fa-angle-right:before {
  content: "\\f105"; }

.fa-angle-up:before {
  content: "\\f106"; }

.fa-angry:before {
  content: "\\f556"; }

.fa-angrycreative:before {
  content: "\\f36e"; }

.fa-angular:before {
  content: "\\f420"; }

.fa-ankh:before {
  content: "\\f644"; }

.fa-app-store:before {
  content: "\\f36f"; }

.fa-app-store-ios:before {
  content: "\\f370"; }

.fa-apper:before {
  content: "\\f371"; }

.fa-apple:before {
  content: "\\f179"; }

.fa-apple-alt:before {
  content: "\\f5d1"; }

.fa-apple-pay:before {
  content: "\\f415"; }

.fa-archive:before {
  content: "\\f187"; }

.fa-archway:before {
  content: "\\f557"; }

.fa-arrow-alt-circle-down:before {
  content: "\\f358"; }

.fa-arrow-alt-circle-left:before {
  content: "\\f359"; }

.fa-arrow-alt-circle-right:before {
  content: "\\f35a"; }

.fa-arrow-alt-circle-up:before {
  content: "\\f35b"; }

.fa-arrow-circle-down:before {
  content: "\\f0ab"; }

.fa-arrow-circle-left:before {
  content: "\\f0a8"; }

.fa-arrow-circle-right:before {
  content: "\\f0a9"; }

.fa-arrow-circle-up:before {
  content: "\\f0aa"; }

.fa-arrow-down:before {
  content: "\\f063"; }

.fa-arrow-left:before {
  content: "\\f060"; }

.fa-arrow-right:before {
  content: "\\f061"; }

.fa-arrow-up:before {
  content: "\\f062"; }

.fa-arrows-alt:before {
  content: "\\f0b2"; }

.fa-arrows-alt-h:before {
  content: "\\f337"; }

.fa-arrows-alt-v:before {
  content: "\\f338"; }

.fa-artstation:before {
  content: "\\f77a"; }

.fa-assistive-listening-systems:before {
  content: "\\f2a2"; }

.fa-asterisk:before {
  content: "\\f069"; }

.fa-asymmetrik:before {
  content: "\\f372"; }

.fa-at:before {
  content: "\\f1fa"; }

.fa-atlas:before {
  content: "\\f558"; }

.fa-atlassian:before {
  content: "\\f77b"; }

.fa-atom:before {
  content: "\\f5d2"; }

.fa-audible:before {
  content: "\\f373"; }

.fa-audio-description:before {
  content: "\\f29e"; }

.fa-autoprefixer:before {
  content: "\\f41c"; }

.fa-avianex:before {
  content: "\\f374"; }

.fa-aviato:before {
  content: "\\f421"; }

.fa-award:before {
  content: "\\f559"; }

.fa-aws:before {
  content: "\\f375"; }

.fa-baby:before {
  content: "\\f77c"; }

.fa-baby-carriage:before {
  content: "\\f77d"; }

.fa-backspace:before {
  content: "\\f55a"; }

.fa-backward:before {
  content: "\\f04a"; }

.fa-bacon:before {
  content: "\\f7e5"; }

.fa-bahai:before {
  content: "\\f666"; }

.fa-balance-scale:before {
  content: "\\f24e"; }

.fa-balance-scale-left:before {
  content: "\\f515"; }

.fa-balance-scale-right:before {
  content: "\\f516"; }

.fa-ban:before {
  content: "\\f05e"; }

.fa-band-aid:before {
  content: "\\f462"; }

.fa-bandcamp:before {
  content: "\\f2d5"; }

.fa-barcode:before {
  content: "\\f02a"; }

.fa-bars:before {
  content: "\\f0c9"; }

.fa-baseball-ball:before {
  content: "\\f433"; }

.fa-basketball-ball:before {
  content: "\\f434"; }

.fa-bath:before {
  content: "\\f2cd"; }

.fa-battery-empty:before {
  content: "\\f244"; }

.fa-battery-full:before {
  content: "\\f240"; }

.fa-battery-half:before {
  content: "\\f242"; }

.fa-battery-quarter:before {
  content: "\\f243"; }

.fa-battery-three-quarters:before {
  content: "\\f241"; }

.fa-battle-net:before {
  content: "\\f835"; }

.fa-bed:before {
  content: "\\f236"; }

.fa-beer:before {
  content: "\\f0fc"; }

.fa-behance:before {
  content: "\\f1b4"; }

.fa-behance-square:before {
  content: "\\f1b5"; }

.fa-bell:before {
  content: "\\f0f3"; }

.fa-bell-slash:before {
  content: "\\f1f6"; }

.fa-bezier-curve:before {
  content: "\\f55b"; }

.fa-bible:before {
  content: "\\f647"; }

.fa-bicycle:before {
  content: "\\f206"; }

.fa-biking:before {
  content: "\\f84a"; }

.fa-bimobject:before {
  content: "\\f378"; }

.fa-binoculars:before {
  content: "\\f1e5"; }

.fa-biohazard:before {
  content: "\\f780"; }

.fa-birthday-cake:before {
  content: "\\f1fd"; }

.fa-bitbucket:before {
  content: "\\f171"; }

.fa-bitcoin:before {
  content: "\\f379"; }

.fa-bity:before {
  content: "\\f37a"; }

.fa-black-tie:before {
  content: "\\f27e"; }

.fa-blackberry:before {
  content: "\\f37b"; }

.fa-blender:before {
  content: "\\f517"; }

.fa-blender-phone:before {
  content: "\\f6b6"; }

.fa-blind:before {
  content: "\\f29d"; }

.fa-blog:before {
  content: "\\f781"; }

.fa-blogger:before {
  content: "\\f37c"; }

.fa-blogger-b:before {
  content: "\\f37d"; }

.fa-bluetooth:before {
  content: "\\f293"; }

.fa-bluetooth-b:before {
  content: "\\f294"; }

.fa-bold:before {
  content: "\\f032"; }

.fa-bolt:before {
  content: "\\f0e7"; }

.fa-bomb:before {
  content: "\\f1e2"; }

.fa-bone:before {
  content: "\\f5d7"; }

.fa-bong:before {
  content: "\\f55c"; }

.fa-book:before {
  content: "\\f02d"; }

.fa-book-dead:before {
  content: "\\f6b7"; }

.fa-book-medical:before {
  content: "\\f7e6"; }

.fa-book-open:before {
  content: "\\f518"; }

.fa-book-reader:before {
  content: "\\f5da"; }

.fa-bookmark:before {
  content: "\\f02e"; }

.fa-bootstrap:before {
  content: "\\f836"; }

.fa-border-all:before {
  content: "\\f84c"; }

.fa-border-none:before {
  content: "\\f850"; }

.fa-border-style:before {
  content: "\\f853"; }

.fa-bowling-ball:before {
  content: "\\f436"; }

.fa-box:before {
  content: "\\f466"; }

.fa-box-open:before {
  content: "\\f49e"; }

.fa-box-tissue:before {
  content: "\\f95b"; }

.fa-boxes:before {
  content: "\\f468"; }

.fa-braille:before {
  content: "\\f2a1"; }

.fa-brain:before {
  content: "\\f5dc"; }

.fa-bread-slice:before {
  content: "\\f7ec"; }

.fa-briefcase:before {
  content: "\\f0b1"; }

.fa-briefcase-medical:before {
  content: "\\f469"; }

.fa-broadcast-tower:before {
  content: "\\f519"; }

.fa-broom:before {
  content: "\\f51a"; }

.fa-brush:before {
  content: "\\f55d"; }

.fa-btc:before {
  content: "\\f15a"; }

.fa-buffer:before {
  content: "\\f837"; }

.fa-bug:before {
  content: "\\f188"; }

.fa-building:before {
  content: "\\f1ad"; }

.fa-bullhorn:before {
  content: "\\f0a1"; }

.fa-bullseye:before {
  content: "\\f140"; }

.fa-burn:before {
  content: "\\f46a"; }

.fa-buromobelexperte:before {
  content: "\\f37f"; }

.fa-bus:before {
  content: "\\f207"; }

.fa-bus-alt:before {
  content: "\\f55e"; }

.fa-business-time:before {
  content: "\\f64a"; }

.fa-buy-n-large:before {
  content: "\\f8a6"; }

.fa-buysellads:before {
  content: "\\f20d"; }

.fa-calculator:before {
  content: "\\f1ec"; }

.fa-calendar:before {
  content: "\\f133"; }

.fa-calendar-alt:before {
  content: "\\f073"; }

.fa-calendar-check:before {
  content: "\\f274"; }

.fa-calendar-day:before {
  content: "\\f783"; }

.fa-calendar-minus:before {
  content: "\\f272"; }

.fa-calendar-plus:before {
  content: "\\f271"; }

.fa-calendar-times:before {
  content: "\\f273"; }

.fa-calendar-week:before {
  content: "\\f784"; }

.fa-camera:before {
  content: "\\f030"; }

.fa-camera-retro:before {
  content: "\\f083"; }

.fa-campground:before {
  content: "\\f6bb"; }

.fa-canadian-maple-leaf:before {
  content: "\\f785"; }

.fa-candy-cane:before {
  content: "\\f786"; }

.fa-cannabis:before {
  content: "\\f55f"; }

.fa-capsules:before {
  content: "\\f46b"; }

.fa-car:before {
  content: "\\f1b9"; }

.fa-car-alt:before {
  content: "\\f5de"; }

.fa-car-battery:before {
  content: "\\f5df"; }

.fa-car-crash:before {
  content: "\\f5e1"; }

.fa-car-side:before {
  content: "\\f5e4"; }

.fa-caravan:before {
  content: "\\f8ff"; }

.fa-caret-down:before {
  content: "\\f0d7"; }

.fa-caret-left:before {
  content: "\\f0d9"; }

.fa-caret-right:before {
  content: "\\f0da"; }

.fa-caret-square-down:before {
  content: "\\f150"; }

.fa-caret-square-left:before {
  content: "\\f191"; }

.fa-caret-square-right:before {
  content: "\\f152"; }

.fa-caret-square-up:before {
  content: "\\f151"; }

.fa-caret-up:before {
  content: "\\f0d8"; }

.fa-carrot:before {
  content: "\\f787"; }

.fa-cart-arrow-down:before {
  content: "\\f218"; }

.fa-cart-plus:before {
  content: "\\f217"; }

.fa-cash-register:before {
  content: "\\f788"; }

.fa-cat:before {
  content: "\\f6be"; }

.fa-cc-amazon-pay:before {
  content: "\\f42d"; }

.fa-cc-amex:before {
  content: "\\f1f3"; }

.fa-cc-apple-pay:before {
  content: "\\f416"; }

.fa-cc-diners-club:before {
  content: "\\f24c"; }

.fa-cc-discover:before {
  content: "\\f1f2"; }

.fa-cc-jcb:before {
  content: "\\f24b"; }

.fa-cc-mastercard:before {
  content: "\\f1f1"; }

.fa-cc-paypal:before {
  content: "\\f1f4"; }

.fa-cc-stripe:before {
  content: "\\f1f5"; }

.fa-cc-visa:before {
  content: "\\f1f0"; }

.fa-centercode:before {
  content: "\\f380"; }

.fa-centos:before {
  content: "\\f789"; }

.fa-certificate:before {
  content: "\\f0a3"; }

.fa-chair:before {
  content: "\\f6c0"; }

.fa-chalkboard:before {
  content: "\\f51b"; }

.fa-chalkboard-teacher:before {
  content: "\\f51c"; }

.fa-charging-station:before {
  content: "\\f5e7"; }

.fa-chart-area:before {
  content: "\\f1fe"; }

.fa-chart-bar:before {
  content: "\\f080"; }

.fa-chart-line:before {
  content: "\\f201"; }

.fa-chart-pie:before {
  content: "\\f200"; }

.fa-check:before {
  content: "\\f00c"; }

.fa-check-circle:before {
  content: "\\f058"; }

.fa-check-double:before {
  content: "\\f560"; }

.fa-check-square:before {
  content: "\\f14a"; }

.fa-cheese:before {
  content: "\\f7ef"; }

.fa-chess:before {
  content: "\\f439"; }

.fa-chess-bishop:before {
  content: "\\f43a"; }

.fa-chess-board:before {
  content: "\\f43c"; }

.fa-chess-king:before {
  content: "\\f43f"; }

.fa-chess-knight:before {
  content: "\\f441"; }

.fa-chess-pawn:before {
  content: "\\f443"; }

.fa-chess-queen:before {
  content: "\\f445"; }

.fa-chess-rook:before {
  content: "\\f447"; }

.fa-chevron-circle-down:before {
  content: "\\f13a"; }

.fa-chevron-circle-left:before {
  content: "\\f137"; }

.fa-chevron-circle-right:before {
  content: "\\f138"; }

.fa-chevron-circle-up:before {
  content: "\\f139"; }

.fa-chevron-down:before {
  content: "\\f078"; }

.fa-chevron-left:before {
  content: "\\f053"; }

.fa-chevron-right:before {
  content: "\\f054"; }

.fa-chevron-up:before {
  content: "\\f077"; }

.fa-child:before {
  content: "\\f1ae"; }

.fa-chrome:before {
  content: "\\f268"; }

.fa-chromecast:before {
  content: "\\f838"; }

.fa-church:before {
  content: "\\f51d"; }

.fa-circle:before {
  content: "\\f111"; }

.fa-circle-notch:before {
  content: "\\f1ce"; }

.fa-city:before {
  content: "\\f64f"; }

.fa-clinic-medical:before {
  content: "\\f7f2"; }

.fa-clipboard:before {
  content: "\\f328"; }

.fa-clipboard-check:before {
  content: "\\f46c"; }

.fa-clipboard-list:before {
  content: "\\f46d"; }

.fa-clock:before {
  content: "\\f017"; }

.fa-clone:before {
  content: "\\f24d"; }

.fa-closed-captioning:before {
  content: "\\f20a"; }

.fa-cloud:before {
  content: "\\f0c2"; }

.fa-cloud-download-alt:before {
  content: "\\f381"; }

.fa-cloud-meatball:before {
  content: "\\f73b"; }

.fa-cloud-moon:before {
  content: "\\f6c3"; }

.fa-cloud-moon-rain:before {
  content: "\\f73c"; }

.fa-cloud-rain:before {
  content: "\\f73d"; }

.fa-cloud-showers-heavy:before {
  content: "\\f740"; }

.fa-cloud-sun:before {
  content: "\\f6c4"; }

.fa-cloud-sun-rain:before {
  content: "\\f743"; }

.fa-cloud-upload-alt:before {
  content: "\\f382"; }

.fa-cloudscale:before {
  content: "\\f383"; }

.fa-cloudsmith:before {
  content: "\\f384"; }

.fa-cloudversify:before {
  content: "\\f385"; }

.fa-cocktail:before {
  content: "\\f561"; }

.fa-code:before {
  content: "\\f121"; }

.fa-code-branch:before {
  content: "\\f126"; }

.fa-codepen:before {
  content: "\\f1cb"; }

.fa-codiepie:before {
  content: "\\f284"; }

.fa-coffee:before {
  content: "\\f0f4"; }

.fa-cog:before {
  content: "\\f013"; }

.fa-cogs:before {
  content: "\\f085"; }

.fa-coins:before {
  content: "\\f51e"; }

.fa-columns:before {
  content: "\\f0db"; }

.fa-comment:before {
  content: "\\f075"; }

.fa-comment-alt:before {
  content: "\\f27a"; }

.fa-comment-dollar:before {
  content: "\\f651"; }

.fa-comment-dots:before {
  content: "\\f4ad"; }

.fa-comment-medical:before {
  content: "\\f7f5"; }

.fa-comment-slash:before {
  content: "\\f4b3"; }

.fa-comments:before {
  content: "\\f086"; }

.fa-comments-dollar:before {
  content: "\\f653"; }

.fa-compact-disc:before {
  content: "\\f51f"; }

.fa-compass:before {
  content: "\\f14e"; }

.fa-compress:before {
  content: "\\f066"; }

.fa-compress-alt:before {
  content: "\\f422"; }

.fa-compress-arrows-alt:before {
  content: "\\f78c"; }

.fa-concierge-bell:before {
  content: "\\f562"; }

.fa-confluence:before {
  content: "\\f78d"; }

.fa-connectdevelop:before {
  content: "\\f20e"; }

.fa-contao:before {
  content: "\\f26d"; }

.fa-cookie:before {
  content: "\\f563"; }

.fa-cookie-bite:before {
  content: "\\f564"; }

.fa-copy:before {
  content: "\\f0c5"; }

.fa-copyright:before {
  content: "\\f1f9"; }

.fa-cotton-bureau:before {
  content: "\\f89e"; }

.fa-couch:before {
  content: "\\f4b8"; }

.fa-cpanel:before {
  content: "\\f388"; }

.fa-creative-commons:before {
  content: "\\f25e"; }

.fa-creative-commons-by:before {
  content: "\\f4e7"; }

.fa-creative-commons-nc:before {
  content: "\\f4e8"; }

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9"; }

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea"; }

.fa-creative-commons-nd:before {
  content: "\\f4eb"; }

.fa-creative-commons-pd:before {
  content: "\\f4ec"; }

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed"; }

.fa-creative-commons-remix:before {
  content: "\\f4ee"; }

.fa-creative-commons-sa:before {
  content: "\\f4ef"; }

.fa-creative-commons-sampling:before {
  content: "\\f4f0"; }

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1"; }

.fa-creative-commons-share:before {
  content: "\\f4f2"; }

.fa-creative-commons-zero:before {
  content: "\\f4f3"; }

.fa-credit-card:before {
  content: "\\f09d"; }

.fa-critical-role:before {
  content: "\\f6c9"; }

.fa-crop:before {
  content: "\\f125"; }

.fa-crop-alt:before {
  content: "\\f565"; }

.fa-cross:before {
  content: "\\f654"; }

.fa-crosshairs:before {
  content: "\\f05b"; }

.fa-crow:before {
  content: "\\f520"; }

.fa-crown:before {
  content: "\\f521"; }

.fa-crutch:before {
  content: "\\f7f7"; }

.fa-css3:before {
  content: "\\f13c"; }

.fa-css3-alt:before {
  content: "\\f38b"; }

.fa-cube:before {
  content: "\\f1b2"; }

.fa-cubes:before {
  content: "\\f1b3"; }

.fa-cut:before {
  content: "\\f0c4"; }

.fa-cuttlefish:before {
  content: "\\f38c"; }

.fa-d-and-d:before {
  content: "\\f38d"; }

.fa-d-and-d-beyond:before {
  content: "\\f6ca"; }

.fa-dailymotion:before {
  content: "\\f952"; }

.fa-dashcube:before {
  content: "\\f210"; }

.fa-database:before {
  content: "\\f1c0"; }

.fa-deaf:before {
  content: "\\f2a4"; }

.fa-delicious:before {
  content: "\\f1a5"; }

.fa-democrat:before {
  content: "\\f747"; }

.fa-deploydog:before {
  content: "\\f38e"; }

.fa-deskpro:before {
  content: "\\f38f"; }

.fa-desktop:before {
  content: "\\f108"; }

.fa-dev:before {
  content: "\\f6cc"; }

.fa-deviantart:before {
  content: "\\f1bd"; }

.fa-dharmachakra:before {
  content: "\\f655"; }

.fa-dhl:before {
  content: "\\f790"; }

.fa-diagnoses:before {
  content: "\\f470"; }

.fa-diaspora:before {
  content: "\\f791"; }

.fa-dice:before {
  content: "\\f522"; }

.fa-dice-d20:before {
  content: "\\f6cf"; }

.fa-dice-d6:before {
  content: "\\f6d1"; }

.fa-dice-five:before {
  content: "\\f523"; }

.fa-dice-four:before {
  content: "\\f524"; }

.fa-dice-one:before {
  content: "\\f525"; }

.fa-dice-six:before {
  content: "\\f526"; }

.fa-dice-three:before {
  content: "\\f527"; }

.fa-dice-two:before {
  content: "\\f528"; }

.fa-digg:before {
  content: "\\f1a6"; }

.fa-digital-ocean:before {
  content: "\\f391"; }

.fa-digital-tachograph:before {
  content: "\\f566"; }

.fa-directions:before {
  content: "\\f5eb"; }

.fa-discord:before {
  content: "\\f392"; }

.fa-discourse:before {
  content: "\\f393"; }

.fa-disease:before {
  content: "\\f7fa"; }

.fa-divide:before {
  content: "\\f529"; }

.fa-dizzy:before {
  content: "\\f567"; }

.fa-dna:before {
  content: "\\f471"; }

.fa-dochub:before {
  content: "\\f394"; }

.fa-docker:before {
  content: "\\f395"; }

.fa-dog:before {
  content: "\\f6d3"; }

.fa-dollar-sign:before {
  content: "\\f155"; }

.fa-dolly:before {
  content: "\\f472"; }

.fa-dolly-flatbed:before {
  content: "\\f474"; }

.fa-donate:before {
  content: "\\f4b9"; }

.fa-door-closed:before {
  content: "\\f52a"; }

.fa-door-open:before {
  content: "\\f52b"; }

.fa-dot-circle:before {
  content: "\\f192"; }

.fa-dove:before {
  content: "\\f4ba"; }

.fa-download:before {
  content: "\\f019"; }

.fa-draft2digital:before {
  content: "\\f396"; }

.fa-drafting-compass:before {
  content: "\\f568"; }

.fa-dragon:before {
  content: "\\f6d5"; }

.fa-draw-polygon:before {
  content: "\\f5ee"; }

.fa-dribbble:before {
  content: "\\f17d"; }

.fa-dribbble-square:before {
  content: "\\f397"; }

.fa-dropbox:before {
  content: "\\f16b"; }

.fa-drum:before {
  content: "\\f569"; }

.fa-drum-steelpan:before {
  content: "\\f56a"; }

.fa-drumstick-bite:before {
  content: "\\f6d7"; }

.fa-drupal:before {
  content: "\\f1a9"; }

.fa-dumbbell:before {
  content: "\\f44b"; }

.fa-dumpster:before {
  content: "\\f793"; }

.fa-dumpster-fire:before {
  content: "\\f794"; }

.fa-dungeon:before {
  content: "\\f6d9"; }

.fa-dyalog:before {
  content: "\\f399"; }

.fa-earlybirds:before {
  content: "\\f39a"; }

.fa-ebay:before {
  content: "\\f4f4"; }

.fa-edge:before {
  content: "\\f282"; }

.fa-edit:before {
  content: "\\f044"; }

.fa-egg:before {
  content: "\\f7fb"; }

.fa-eject:before {
  content: "\\f052"; }

.fa-elementor:before {
  content: "\\f430"; }

.fa-ellipsis-h:before {
  content: "\\f141"; }

.fa-ellipsis-v:before {
  content: "\\f142"; }

.fa-ello:before {
  content: "\\f5f1"; }

.fa-ember:before {
  content: "\\f423"; }

.fa-empire:before {
  content: "\\f1d1"; }

.fa-envelope:before {
  content: "\\f0e0"; }

.fa-envelope-open:before {
  content: "\\f2b6"; }

.fa-envelope-open-text:before {
  content: "\\f658"; }

.fa-envelope-square:before {
  content: "\\f199"; }

.fa-envira:before {
  content: "\\f299"; }

.fa-equals:before {
  content: "\\f52c"; }

.fa-eraser:before {
  content: "\\f12d"; }

.fa-erlang:before {
  content: "\\f39d"; }

.fa-ethereum:before {
  content: "\\f42e"; }

.fa-ethernet:before {
  content: "\\f796"; }

.fa-etsy:before {
  content: "\\f2d7"; }

.fa-euro-sign:before {
  content: "\\f153"; }

.fa-evernote:before {
  content: "\\f839"; }

.fa-exchange-alt:before {
  content: "\\f362"; }

.fa-exclamation:before {
  content: "\\f12a"; }

.fa-exclamation-circle:before {
  content: "\\f06a"; }

.fa-exclamation-triangle:before {
  content: "\\f071"; }

.fa-expand:before {
  content: "\\f065"; }

.fa-expand-alt:before {
  content: "\\f424"; }

.fa-expand-arrows-alt:before {
  content: "\\f31e"; }

.fa-expeditedssl:before {
  content: "\\f23e"; }

.fa-external-link-alt:before {
  content: "\\f35d"; }

.fa-external-link-square-alt:before {
  content: "\\f360"; }

.fa-eye:before {
  content: "\\f06e"; }

.fa-eye-dropper:before {
  content: "\\f1fb"; }

.fa-eye-slash:before {
  content: "\\f070"; }

.fa-facebook:before {
  content: "\\f09a"; }

.fa-facebook-f:before {
  content: "\\f39e"; }

.fa-facebook-messenger:before {
  content: "\\f39f"; }

.fa-facebook-square:before {
  content: "\\f082"; }

.fa-fan:before {
  content: "\\f863"; }

.fa-fantasy-flight-games:before {
  content: "\\f6dc"; }

.fa-fast-backward:before {
  content: "\\f049"; }

.fa-fast-forward:before {
  content: "\\f050"; }

.fa-faucet:before {
  content: "\\f905"; }

.fa-fax:before {
  content: "\\f1ac"; }

.fa-feather:before {
  content: "\\f52d"; }

.fa-feather-alt:before {
  content: "\\f56b"; }

.fa-fedex:before {
  content: "\\f797"; }

.fa-fedora:before {
  content: "\\f798"; }

.fa-female:before {
  content: "\\f182"; }

.fa-fighter-jet:before {
  content: "\\f0fb"; }

.fa-figma:before {
  content: "\\f799"; }

.fa-file:before {
  content: "\\f15b"; }

.fa-file-alt:before {
  content: "\\f15c"; }

.fa-file-archive:before {
  content: "\\f1c6"; }

.fa-file-audio:before {
  content: "\\f1c7"; }

.fa-file-code:before {
  content: "\\f1c9"; }

.fa-file-contract:before {
  content: "\\f56c"; }

.fa-file-csv:before {
  content: "\\f6dd"; }

.fa-file-download:before {
  content: "\\f56d"; }

.fa-file-excel:before {
  content: "\\f1c3"; }

.fa-file-export:before {
  content: "\\f56e"; }

.fa-file-image:before {
  content: "\\f1c5"; }

.fa-file-import:before {
  content: "\\f56f"; }

.fa-file-invoice:before {
  content: "\\f570"; }

.fa-file-invoice-dollar:before {
  content: "\\f571"; }

.fa-file-medical:before {
  content: "\\f477"; }

.fa-file-medical-alt:before {
  content: "\\f478"; }

.fa-file-pdf:before {
  content: "\\f1c1"; }

.fa-file-powerpoint:before {
  content: "\\f1c4"; }

.fa-file-prescription:before {
  content: "\\f572"; }

.fa-file-signature:before {
  content: "\\f573"; }

.fa-file-upload:before {
  content: "\\f574"; }

.fa-file-video:before {
  content: "\\f1c8"; }

.fa-file-word:before {
  content: "\\f1c2"; }

.fa-fill:before {
  content: "\\f575"; }

.fa-fill-drip:before {
  content: "\\f576"; }

.fa-film:before {
  content: "\\f008"; }

.fa-filter:before {
  content: "\\f0b0"; }

.fa-fingerprint:before {
  content: "\\f577"; }

.fa-fire:before {
  content: "\\f06d"; }

.fa-fire-alt:before {
  content: "\\f7e4"; }

.fa-fire-extinguisher:before {
  content: "\\f134"; }

.fa-firefox:before {
  content: "\\f269"; }

.fa-firefox-browser:before {
  content: "\\f907"; }

.fa-first-aid:before {
  content: "\\f479"; }

.fa-first-order:before {
  content: "\\f2b0"; }

.fa-first-order-alt:before {
  content: "\\f50a"; }

.fa-firstdraft:before {
  content: "\\f3a1"; }

.fa-fish:before {
  content: "\\f578"; }

.fa-fist-raised:before {
  content: "\\f6de"; }

.fa-flag:before {
  content: "\\f024"; }

.fa-flag-checkered:before {
  content: "\\f11e"; }

.fa-flag-usa:before {
  content: "\\f74d"; }

.fa-flask:before {
  content: "\\f0c3"; }

.fa-flickr:before {
  content: "\\f16e"; }

.fa-flipboard:before {
  content: "\\f44d"; }

.fa-flushed:before {
  content: "\\f579"; }

.fa-fly:before {
  content: "\\f417"; }

.fa-folder:before {
  content: "\\f07b"; }

.fa-folder-minus:before {
  content: "\\f65d"; }

.fa-folder-open:before {
  content: "\\f07c"; }

.fa-folder-plus:before {
  content: "\\f65e"; }

.fa-font:before {
  content: "\\f031"; }

.fa-font-awesome:before {
  content: "\\f2b4"; }

.fa-font-awesome-alt:before {
  content: "\\f35c"; }

.fa-font-awesome-flag:before {
  content: "\\f425"; }

.fa-font-awesome-logo-full:before {
  content: "\\f4e6"; }

.fa-fonticons:before {
  content: "\\f280"; }

.fa-fonticons-fi:before {
  content: "\\f3a2"; }

.fa-football-ball:before {
  content: "\\f44e"; }

.fa-fort-awesome:before {
  content: "\\f286"; }

.fa-fort-awesome-alt:before {
  content: "\\f3a3"; }

.fa-forumbee:before {
  content: "\\f211"; }

.fa-forward:before {
  content: "\\f04e"; }

.fa-foursquare:before {
  content: "\\f180"; }

.fa-free-code-camp:before {
  content: "\\f2c5"; }

.fa-freebsd:before {
  content: "\\f3a4"; }

.fa-frog:before {
  content: "\\f52e"; }

.fa-frown:before {
  content: "\\f119"; }

.fa-frown-open:before {
  content: "\\f57a"; }

.fa-fulcrum:before {
  content: "\\f50b"; }

.fa-funnel-dollar:before {
  content: "\\f662"; }

.fa-futbol:before {
  content: "\\f1e3"; }

.fa-galactic-republic:before {
  content: "\\f50c"; }

.fa-galactic-senate:before {
  content: "\\f50d"; }

.fa-gamepad:before {
  content: "\\f11b"; }

.fa-gas-pump:before {
  content: "\\f52f"; }

.fa-gavel:before {
  content: "\\f0e3"; }

.fa-gem:before {
  content: "\\f3a5"; }

.fa-genderless:before {
  content: "\\f22d"; }

.fa-get-pocket:before {
  content: "\\f265"; }

.fa-gg:before {
  content: "\\f260"; }

.fa-gg-circle:before {
  content: "\\f261"; }

.fa-ghost:before {
  content: "\\f6e2"; }

.fa-gift:before {
  content: "\\f06b"; }

.fa-gifts:before {
  content: "\\f79c"; }

.fa-git:before {
  content: "\\f1d3"; }

.fa-git-alt:before {
  content: "\\f841"; }

.fa-git-square:before {
  content: "\\f1d2"; }

.fa-github:before {
  content: "\\f09b"; }

.fa-github-alt:before {
  content: "\\f113"; }

.fa-github-square:before {
  content: "\\f092"; }

.fa-gitkraken:before {
  content: "\\f3a6"; }

.fa-gitlab:before {
  content: "\\f296"; }

.fa-gitter:before {
  content: "\\f426"; }

.fa-glass-cheers:before {
  content: "\\f79f"; }

.fa-glass-martini:before {
  content: "\\f000"; }

.fa-glass-martini-alt:before {
  content: "\\f57b"; }

.fa-glass-whiskey:before {
  content: "\\f7a0"; }

.fa-glasses:before {
  content: "\\f530"; }

.fa-glide:before {
  content: "\\f2a5"; }

.fa-glide-g:before {
  content: "\\f2a6"; }

.fa-globe:before {
  content: "\\f0ac"; }

.fa-globe-africa:before {
  content: "\\f57c"; }

.fa-globe-americas:before {
  content: "\\f57d"; }

.fa-globe-asia:before {
  content: "\\f57e"; }

.fa-globe-europe:before {
  content: "\\f7a2"; }

.fa-gofore:before {
  content: "\\f3a7"; }

.fa-golf-ball:before {
  content: "\\f450"; }

.fa-goodreads:before {
  content: "\\f3a8"; }

.fa-goodreads-g:before {
  content: "\\f3a9"; }

.fa-google:before {
  content: "\\f1a0"; }

.fa-google-drive:before {
  content: "\\f3aa"; }

.fa-google-play:before {
  content: "\\f3ab"; }

.fa-google-plus:before {
  content: "\\f2b3"; }

.fa-google-plus-g:before {
  content: "\\f0d5"; }

.fa-google-plus-square:before {
  content: "\\f0d4"; }

.fa-google-wallet:before {
  content: "\\f1ee"; }

.fa-gopuram:before {
  content: "\\f664"; }

.fa-graduation-cap:before {
  content: "\\f19d"; }

.fa-gratipay:before {
  content: "\\f184"; }

.fa-grav:before {
  content: "\\f2d6"; }

.fa-greater-than:before {
  content: "\\f531"; }

.fa-greater-than-equal:before {
  content: "\\f532"; }

.fa-grimace:before {
  content: "\\f57f"; }

.fa-grin:before {
  content: "\\f580"; }

.fa-grin-alt:before {
  content: "\\f581"; }

.fa-grin-beam:before {
  content: "\\f582"; }

.fa-grin-beam-sweat:before {
  content: "\\f583"; }

.fa-grin-hearts:before {
  content: "\\f584"; }

.fa-grin-squint:before {
  content: "\\f585"; }

.fa-grin-squint-tears:before {
  content: "\\f586"; }

.fa-grin-stars:before {
  content: "\\f587"; }

.fa-grin-tears:before {
  content: "\\f588"; }

.fa-grin-tongue:before {
  content: "\\f589"; }

.fa-grin-tongue-squint:before {
  content: "\\f58a"; }

.fa-grin-tongue-wink:before {
  content: "\\f58b"; }

.fa-grin-wink:before {
  content: "\\f58c"; }

.fa-grip-horizontal:before {
  content: "\\f58d"; }

.fa-grip-lines:before {
  content: "\\f7a4"; }

.fa-grip-lines-vertical:before {
  content: "\\f7a5"; }

.fa-grip-vertical:before {
  content: "\\f58e"; }

.fa-gripfire:before {
  content: "\\f3ac"; }

.fa-grunt:before {
  content: "\\f3ad"; }

.fa-guitar:before {
  content: "\\f7a6"; }

.fa-gulp:before {
  content: "\\f3ae"; }

.fa-h-square:before {
  content: "\\f0fd"; }

.fa-hacker-news:before {
  content: "\\f1d4"; }

.fa-hacker-news-square:before {
  content: "\\f3af"; }

.fa-hackerrank:before {
  content: "\\f5f7"; }

.fa-hamburger:before {
  content: "\\f805"; }

.fa-hammer:before {
  content: "\\f6e3"; }

.fa-hamsa:before {
  content: "\\f665"; }

.fa-hand-holding:before {
  content: "\\f4bd"; }

.fa-hand-holding-heart:before {
  content: "\\f4be"; }

.fa-hand-holding-medical:before {
  content: "\\f95c"; }

.fa-hand-holding-usd:before {
  content: "\\f4c0"; }

.fa-hand-holding-water:before {
  content: "\\f4c1"; }

.fa-hand-lizard:before {
  content: "\\f258"; }

.fa-hand-middle-finger:before {
  content: "\\f806"; }

.fa-hand-paper:before {
  content: "\\f256"; }

.fa-hand-peace:before {
  content: "\\f25b"; }

.fa-hand-point-down:before {
  content: "\\f0a7"; }

.fa-hand-point-left:before {
  content: "\\f0a5"; }

.fa-hand-point-right:before {
  content: "\\f0a4"; }

.fa-hand-point-up:before {
  content: "\\f0a6"; }

.fa-hand-pointer:before {
  content: "\\f25a"; }

.fa-hand-rock:before {
  content: "\\f255"; }

.fa-hand-scissors:before {
  content: "\\f257"; }

.fa-hand-sparkles:before {
  content: "\\f95d"; }

.fa-hand-spock:before {
  content: "\\f259"; }

.fa-hands:before {
  content: "\\f4c2"; }

.fa-hands-helping:before {
  content: "\\f4c4"; }

.fa-hands-wash:before {
  content: "\\f95e"; }

.fa-handshake:before {
  content: "\\f2b5"; }

.fa-handshake-alt-slash:before {
  content: "\\f95f"; }

.fa-handshake-slash:before {
  content: "\\f960"; }

.fa-hanukiah:before {
  content: "\\f6e6"; }

.fa-hard-hat:before {
  content: "\\f807"; }

.fa-hashtag:before {
  content: "\\f292"; }

.fa-hat-cowboy:before {
  content: "\\f8c0"; }

.fa-hat-cowboy-side:before {
  content: "\\f8c1"; }

.fa-hat-wizard:before {
  content: "\\f6e8"; }

.fa-hdd:before {
  content: "\\f0a0"; }

.fa-head-side-cough:before {
  content: "\\f961"; }

.fa-head-side-cough-slash:before {
  content: "\\f962"; }

.fa-head-side-mask:before {
  content: "\\f963"; }

.fa-head-side-virus:before {
  content: "\\f964"; }

.fa-heading:before {
  content: "\\f1dc"; }

.fa-headphones:before {
  content: "\\f025"; }

.fa-headphones-alt:before {
  content: "\\f58f"; }

.fa-headset:before {
  content: "\\f590"; }

.fa-heart:before {
  content: "\\f004"; }

.fa-heart-broken:before {
  content: "\\f7a9"; }

.fa-heartbeat:before {
  content: "\\f21e"; }

.fa-helicopter:before {
  content: "\\f533"; }

.fa-highlighter:before {
  content: "\\f591"; }

.fa-hiking:before {
  content: "\\f6ec"; }

.fa-hippo:before {
  content: "\\f6ed"; }

.fa-hips:before {
  content: "\\f452"; }

.fa-hire-a-helper:before {
  content: "\\f3b0"; }

.fa-history:before {
  content: "\\f1da"; }

.fa-hockey-puck:before {
  content: "\\f453"; }

.fa-holly-berry:before {
  content: "\\f7aa"; }

.fa-home:before {
  content: "\\f015"; }

.fa-hooli:before {
  content: "\\f427"; }

.fa-hornbill:before {
  content: "\\f592"; }

.fa-horse:before {
  content: "\\f6f0"; }

.fa-horse-head:before {
  content: "\\f7ab"; }

.fa-hospital:before {
  content: "\\f0f8"; }

.fa-hospital-alt:before {
  content: "\\f47d"; }

.fa-hospital-symbol:before {
  content: "\\f47e"; }

.fa-hospital-user:before {
  content: "\\f80d"; }

.fa-hot-tub:before {
  content: "\\f593"; }

.fa-hotdog:before {
  content: "\\f80f"; }

.fa-hotel:before {
  content: "\\f594"; }

.fa-hotjar:before {
  content: "\\f3b1"; }

.fa-hourglass:before {
  content: "\\f254"; }

.fa-hourglass-end:before {
  content: "\\f253"; }

.fa-hourglass-half:before {
  content: "\\f252"; }

.fa-hourglass-start:before {
  content: "\\f251"; }

.fa-house-damage:before {
  content: "\\f6f1"; }

.fa-house-user:before {
  content: "\\f965"; }

.fa-houzz:before {
  content: "\\f27c"; }

.fa-hryvnia:before {
  content: "\\f6f2"; }

.fa-html5:before {
  content: "\\f13b"; }

.fa-hubspot:before {
  content: "\\f3b2"; }

.fa-i-cursor:before {
  content: "\\f246"; }

.fa-ice-cream:before {
  content: "\\f810"; }

.fa-icicles:before {
  content: "\\f7ad"; }

.fa-icons:before {
  content: "\\f86d"; }

.fa-id-badge:before {
  content: "\\f2c1"; }

.fa-id-card:before {
  content: "\\f2c2"; }

.fa-id-card-alt:before {
  content: "\\f47f"; }

.fa-ideal:before {
  content: "\\f913"; }

.fa-igloo:before {
  content: "\\f7ae"; }

.fa-image:before {
  content: "\\f03e"; }

.fa-images:before {
  content: "\\f302"; }

.fa-imdb:before {
  content: "\\f2d8"; }

.fa-inbox:before {
  content: "\\f01c"; }

.fa-indent:before {
  content: "\\f03c"; }

.fa-industry:before {
  content: "\\f275"; }

.fa-infinity:before {
  content: "\\f534"; }

.fa-info:before {
  content: "\\f129"; }

.fa-info-circle:before {
  content: "\\f05a"; }

.fa-instagram:before {
  content: "\\f16d"; }

.fa-instagram-square:before {
  content: "\\f955"; }

.fa-intercom:before {
  content: "\\f7af"; }

.fa-internet-explorer:before {
  content: "\\f26b"; }

.fa-invision:before {
  content: "\\f7b0"; }

.fa-ioxhost:before {
  content: "\\f208"; }

.fa-italic:before {
  content: "\\f033"; }

.fa-itch-io:before {
  content: "\\f83a"; }

.fa-itunes:before {
  content: "\\f3b4"; }

.fa-itunes-note:before {
  content: "\\f3b5"; }

.fa-java:before {
  content: "\\f4e4"; }

.fa-jedi:before {
  content: "\\f669"; }

.fa-jedi-order:before {
  content: "\\f50e"; }

.fa-jenkins:before {
  content: "\\f3b6"; }

.fa-jira:before {
  content: "\\f7b1"; }

.fa-joget:before {
  content: "\\f3b7"; }

.fa-joint:before {
  content: "\\f595"; }

.fa-joomla:before {
  content: "\\f1aa"; }

.fa-journal-whills:before {
  content: "\\f66a"; }

.fa-js:before {
  content: "\\f3b8"; }

.fa-js-square:before {
  content: "\\f3b9"; }

.fa-jsfiddle:before {
  content: "\\f1cc"; }

.fa-kaaba:before {
  content: "\\f66b"; }

.fa-kaggle:before {
  content: "\\f5fa"; }

.fa-key:before {
  content: "\\f084"; }

.fa-keybase:before {
  content: "\\f4f5"; }

.fa-keyboard:before {
  content: "\\f11c"; }

.fa-keycdn:before {
  content: "\\f3ba"; }

.fa-khanda:before {
  content: "\\f66d"; }

.fa-kickstarter:before {
  content: "\\f3bb"; }

.fa-kickstarter-k:before {
  content: "\\f3bc"; }

.fa-kiss:before {
  content: "\\f596"; }

.fa-kiss-beam:before {
  content: "\\f597"; }

.fa-kiss-wink-heart:before {
  content: "\\f598"; }

.fa-kiwi-bird:before {
  content: "\\f535"; }

.fa-korvue:before {
  content: "\\f42f"; }

.fa-landmark:before {
  content: "\\f66f"; }

.fa-language:before {
  content: "\\f1ab"; }

.fa-laptop:before {
  content: "\\f109"; }

.fa-laptop-code:before {
  content: "\\f5fc"; }

.fa-laptop-house:before {
  content: "\\f966"; }

.fa-laptop-medical:before {
  content: "\\f812"; }

.fa-laravel:before {
  content: "\\f3bd"; }

.fa-lastfm:before {
  content: "\\f202"; }

.fa-lastfm-square:before {
  content: "\\f203"; }

.fa-laugh:before {
  content: "\\f599"; }

.fa-laugh-beam:before {
  content: "\\f59a"; }

.fa-laugh-squint:before {
  content: "\\f59b"; }

.fa-laugh-wink:before {
  content: "\\f59c"; }

.fa-layer-group:before {
  content: "\\f5fd"; }

.fa-leaf:before {
  content: "\\f06c"; }

.fa-leanpub:before {
  content: "\\f212"; }

.fa-lemon:before {
  content: "\\f094"; }

.fa-less:before {
  content: "\\f41d"; }

.fa-less-than:before {
  content: "\\f536"; }

.fa-less-than-equal:before {
  content: "\\f537"; }

.fa-level-down-alt:before {
  content: "\\f3be"; }

.fa-level-up-alt:before {
  content: "\\f3bf"; }

.fa-life-ring:before {
  content: "\\f1cd"; }

.fa-lightbulb:before {
  content: "\\f0eb"; }

.fa-line:before {
  content: "\\f3c0"; }

.fa-link:before {
  content: "\\f0c1"; }

.fa-linkedin:before {
  content: "\\f08c"; }

.fa-linkedin-in:before {
  content: "\\f0e1"; }

.fa-linode:before {
  content: "\\f2b8"; }

.fa-linux:before {
  content: "\\f17c"; }

.fa-lira-sign:before {
  content: "\\f195"; }

.fa-list:before {
  content: "\\f03a"; }

.fa-list-alt:before {
  content: "\\f022"; }

.fa-list-ol:before {
  content: "\\f0cb"; }

.fa-list-ul:before {
  content: "\\f0ca"; }

.fa-location-arrow:before {
  content: "\\f124"; }

.fa-lock:before {
  content: "\\f023"; }

.fa-lock-open:before {
  content: "\\f3c1"; }

.fa-long-arrow-alt-down:before {
  content: "\\f309"; }

.fa-long-arrow-alt-left:before {
  content: "\\f30a"; }

.fa-long-arrow-alt-right:before {
  content: "\\f30b"; }

.fa-long-arrow-alt-up:before {
  content: "\\f30c"; }

.fa-low-vision:before {
  content: "\\f2a8"; }

.fa-luggage-cart:before {
  content: "\\f59d"; }

.fa-lungs:before {
  content: "\\f604"; }

.fa-lungs-virus:before {
  content: "\\f967"; }

.fa-lyft:before {
  content: "\\f3c3"; }

.fa-magento:before {
  content: "\\f3c4"; }

.fa-magic:before {
  content: "\\f0d0"; }

.fa-magnet:before {
  content: "\\f076"; }

.fa-mail-bulk:before {
  content: "\\f674"; }

.fa-mailchimp:before {
  content: "\\f59e"; }

.fa-male:before {
  content: "\\f183"; }

.fa-mandalorian:before {
  content: "\\f50f"; }

.fa-map:before {
  content: "\\f279"; }

.fa-map-marked:before {
  content: "\\f59f"; }

.fa-map-marked-alt:before {
  content: "\\f5a0"; }

.fa-map-marker:before {
  content: "\\f041"; }

.fa-map-marker-alt:before {
  content: "\\f3c5"; }

.fa-map-pin:before {
  content: "\\f276"; }

.fa-map-signs:before {
  content: "\\f277"; }

.fa-markdown:before {
  content: "\\f60f"; }

.fa-marker:before {
  content: "\\f5a1"; }

.fa-mars:before {
  content: "\\f222"; }

.fa-mars-double:before {
  content: "\\f227"; }

.fa-mars-stroke:before {
  content: "\\f229"; }

.fa-mars-stroke-h:before {
  content: "\\f22b"; }

.fa-mars-stroke-v:before {
  content: "\\f22a"; }

.fa-mask:before {
  content: "\\f6fa"; }

.fa-mastodon:before {
  content: "\\f4f6"; }

.fa-maxcdn:before {
  content: "\\f136"; }

.fa-mdb:before {
  content: "\\f8ca"; }

.fa-medal:before {
  content: "\\f5a2"; }

.fa-medapps:before {
  content: "\\f3c6"; }

.fa-medium:before {
  content: "\\f23a"; }

.fa-medium-m:before {
  content: "\\f3c7"; }

.fa-medkit:before {
  content: "\\f0fa"; }

.fa-medrt:before {
  content: "\\f3c8"; }

.fa-meetup:before {
  content: "\\f2e0"; }

.fa-megaport:before {
  content: "\\f5a3"; }

.fa-meh:before {
  content: "\\f11a"; }

.fa-meh-blank:before {
  content: "\\f5a4"; }

.fa-meh-rolling-eyes:before {
  content: "\\f5a5"; }

.fa-memory:before {
  content: "\\f538"; }

.fa-mendeley:before {
  content: "\\f7b3"; }

.fa-menorah:before {
  content: "\\f676"; }

.fa-mercury:before {
  content: "\\f223"; }

.fa-meteor:before {
  content: "\\f753"; }

.fa-microblog:before {
  content: "\\f91a"; }

.fa-microchip:before {
  content: "\\f2db"; }

.fa-microphone:before {
  content: "\\f130"; }

.fa-microphone-alt:before {
  content: "\\f3c9"; }

.fa-microphone-alt-slash:before {
  content: "\\f539"; }

.fa-microphone-slash:before {
  content: "\\f131"; }

.fa-microscope:before {
  content: "\\f610"; }

.fa-microsoft:before {
  content: "\\f3ca"; }

.fa-minus:before {
  content: "\\f068"; }

.fa-minus-circle:before {
  content: "\\f056"; }

.fa-minus-square:before {
  content: "\\f146"; }

.fa-mitten:before {
  content: "\\f7b5"; }

.fa-mix:before {
  content: "\\f3cb"; }

.fa-mixcloud:before {
  content: "\\f289"; }

.fa-mixer:before {
  content: "\\f956"; }

.fa-mizuni:before {
  content: "\\f3cc"; }

.fa-mobile:before {
  content: "\\f10b"; }

.fa-mobile-alt:before {
  content: "\\f3cd"; }

.fa-modx:before {
  content: "\\f285"; }

.fa-monero:before {
  content: "\\f3d0"; }

.fa-money-bill:before {
  content: "\\f0d6"; }

.fa-money-bill-alt:before {
  content: "\\f3d1"; }

.fa-money-bill-wave:before {
  content: "\\f53a"; }

.fa-money-bill-wave-alt:before {
  content: "\\f53b"; }

.fa-money-check:before {
  content: "\\f53c"; }

.fa-money-check-alt:before {
  content: "\\f53d"; }

.fa-monument:before {
  content: "\\f5a6"; }

.fa-moon:before {
  content: "\\f186"; }

.fa-mortar-pestle:before {
  content: "\\f5a7"; }

.fa-mosque:before {
  content: "\\f678"; }

.fa-motorcycle:before {
  content: "\\f21c"; }

.fa-mountain:before {
  content: "\\f6fc"; }

.fa-mouse:before {
  content: "\\f8cc"; }

.fa-mouse-pointer:before {
  content: "\\f245"; }

.fa-mug-hot:before {
  content: "\\f7b6"; }

.fa-music:before {
  content: "\\f001"; }

.fa-napster:before {
  content: "\\f3d2"; }

.fa-neos:before {
  content: "\\f612"; }

.fa-network-wired:before {
  content: "\\f6ff"; }

.fa-neuter:before {
  content: "\\f22c"; }

.fa-newspaper:before {
  content: "\\f1ea"; }

.fa-nimblr:before {
  content: "\\f5a8"; }

.fa-node:before {
  content: "\\f419"; }

.fa-node-js:before {
  content: "\\f3d3"; }

.fa-not-equal:before {
  content: "\\f53e"; }

.fa-notes-medical:before {
  content: "\\f481"; }

.fa-npm:before {
  content: "\\f3d4"; }

.fa-ns8:before {
  content: "\\f3d5"; }

.fa-nutritionix:before {
  content: "\\f3d6"; }

.fa-object-group:before {
  content: "\\f247"; }

.fa-object-ungroup:before {
  content: "\\f248"; }

.fa-odnoklassniki:before {
  content: "\\f263"; }

.fa-odnoklassniki-square:before {
  content: "\\f264"; }

.fa-oil-can:before {
  content: "\\f613"; }

.fa-old-republic:before {
  content: "\\f510"; }

.fa-om:before {
  content: "\\f679"; }

.fa-opencart:before {
  content: "\\f23d"; }

.fa-openid:before {
  content: "\\f19b"; }

.fa-opera:before {
  content: "\\f26a"; }

.fa-optin-monster:before {
  content: "\\f23c"; }

.fa-orcid:before {
  content: "\\f8d2"; }

.fa-osi:before {
  content: "\\f41a"; }

.fa-otter:before {
  content: "\\f700"; }

.fa-outdent:before {
  content: "\\f03b"; }

.fa-page4:before {
  content: "\\f3d7"; }

.fa-pagelines:before {
  content: "\\f18c"; }

.fa-pager:before {
  content: "\\f815"; }

.fa-paint-brush:before {
  content: "\\f1fc"; }

.fa-paint-roller:before {
  content: "\\f5aa"; }

.fa-palette:before {
  content: "\\f53f"; }

.fa-palfed:before {
  content: "\\f3d8"; }

.fa-pallet:before {
  content: "\\f482"; }

.fa-paper-plane:before {
  content: "\\f1d8"; }

.fa-paperclip:before {
  content: "\\f0c6"; }

.fa-parachute-box:before {
  content: "\\f4cd"; }

.fa-paragraph:before {
  content: "\\f1dd"; }

.fa-parking:before {
  content: "\\f540"; }

.fa-passport:before {
  content: "\\f5ab"; }

.fa-pastafarianism:before {
  content: "\\f67b"; }

.fa-paste:before {
  content: "\\f0ea"; }

.fa-patreon:before {
  content: "\\f3d9"; }

.fa-pause:before {
  content: "\\f04c"; }

.fa-pause-circle:before {
  content: "\\f28b"; }

.fa-paw:before {
  content: "\\f1b0"; }

.fa-paypal:before {
  content: "\\f1ed"; }

.fa-peace:before {
  content: "\\f67c"; }

.fa-pen:before {
  content: "\\f304"; }

.fa-pen-alt:before {
  content: "\\f305"; }

.fa-pen-fancy:before {
  content: "\\f5ac"; }

.fa-pen-nib:before {
  content: "\\f5ad"; }

.fa-pen-square:before {
  content: "\\f14b"; }

.fa-pencil-alt:before {
  content: "\\f303"; }

.fa-pencil-ruler:before {
  content: "\\f5ae"; }

.fa-penny-arcade:before {
  content: "\\f704"; }

.fa-people-arrows:before {
  content: "\\f968"; }

.fa-people-carry:before {
  content: "\\f4ce"; }

.fa-pepper-hot:before {
  content: "\\f816"; }

.fa-percent:before {
  content: "\\f295"; }

.fa-percentage:before {
  content: "\\f541"; }

.fa-periscope:before {
  content: "\\f3da"; }

.fa-person-booth:before {
  content: "\\f756"; }

.fa-phabricator:before {
  content: "\\f3db"; }

.fa-phoenix-framework:before {
  content: "\\f3dc"; }

.fa-phoenix-squadron:before {
  content: "\\f511"; }

.fa-phone:before {
  content: "\\f095"; }

.fa-phone-alt:before {
  content: "\\f879"; }

.fa-phone-slash:before {
  content: "\\f3dd"; }

.fa-phone-square:before {
  content: "\\f098"; }

.fa-phone-square-alt:before {
  content: "\\f87b"; }

.fa-phone-volume:before {
  content: "\\f2a0"; }

.fa-photo-video:before {
  content: "\\f87c"; }

.fa-php:before {
  content: "\\f457"; }

.fa-pied-piper:before {
  content: "\\f2ae"; }

.fa-pied-piper-alt:before {
  content: "\\f1a8"; }

.fa-pied-piper-hat:before {
  content: "\\f4e5"; }

.fa-pied-piper-pp:before {
  content: "\\f1a7"; }

.fa-pied-piper-square:before {
  content: "\\f91e"; }

.fa-piggy-bank:before {
  content: "\\f4d3"; }

.fa-pills:before {
  content: "\\f484"; }

.fa-pinterest:before {
  content: "\\f0d2"; }

.fa-pinterest-p:before {
  content: "\\f231"; }

.fa-pinterest-square:before {
  content: "\\f0d3"; }

.fa-pizza-slice:before {
  content: "\\f818"; }

.fa-place-of-worship:before {
  content: "\\f67f"; }

.fa-plane:before {
  content: "\\f072"; }

.fa-plane-arrival:before {
  content: "\\f5af"; }

.fa-plane-departure:before {
  content: "\\f5b0"; }

.fa-plane-slash:before {
  content: "\\f969"; }

.fa-play:before {
  content: "\\f04b"; }

.fa-play-circle:before {
  content: "\\f144"; }

.fa-playstation:before {
  content: "\\f3df"; }

.fa-plug:before {
  content: "\\f1e6"; }

.fa-plus:before {
  content: "\\f067"; }

.fa-plus-circle:before {
  content: "\\f055"; }

.fa-plus-square:before {
  content: "\\f0fe"; }

.fa-podcast:before {
  content: "\\f2ce"; }

.fa-poll:before {
  content: "\\f681"; }

.fa-poll-h:before {
  content: "\\f682"; }

.fa-poo:before {
  content: "\\f2fe"; }

.fa-poo-storm:before {
  content: "\\f75a"; }

.fa-poop:before {
  content: "\\f619"; }

.fa-portrait:before {
  content: "\\f3e0"; }

.fa-pound-sign:before {
  content: "\\f154"; }

.fa-power-off:before {
  content: "\\f011"; }

.fa-pray:before {
  content: "\\f683"; }

.fa-praying-hands:before {
  content: "\\f684"; }

.fa-prescription:before {
  content: "\\f5b1"; }

.fa-prescription-bottle:before {
  content: "\\f485"; }

.fa-prescription-bottle-alt:before {
  content: "\\f486"; }

.fa-print:before {
  content: "\\f02f"; }

.fa-procedures:before {
  content: "\\f487"; }

.fa-product-hunt:before {
  content: "\\f288"; }

.fa-project-diagram:before {
  content: "\\f542"; }

.fa-pump-medical:before {
  content: "\\f96a"; }

.fa-pump-soap:before {
  content: "\\f96b"; }

.fa-pushed:before {
  content: "\\f3e1"; }

.fa-puzzle-piece:before {
  content: "\\f12e"; }

.fa-python:before {
  content: "\\f3e2"; }

.fa-qq:before {
  content: "\\f1d6"; }

.fa-qrcode:before {
  content: "\\f029"; }

.fa-question:before {
  content: "\\f128"; }

.fa-question-circle:before {
  content: "\\f059"; }

.fa-quidditch:before {
  content: "\\f458"; }

.fa-quinscape:before {
  content: "\\f459"; }

.fa-quora:before {
  content: "\\f2c4"; }

.fa-quote-left:before {
  content: "\\f10d"; }

.fa-quote-right:before {
  content: "\\f10e"; }

.fa-quran:before {
  content: "\\f687"; }

.fa-r-project:before {
  content: "\\f4f7"; }

.fa-radiation:before {
  content: "\\f7b9"; }

.fa-radiation-alt:before {
  content: "\\f7ba"; }

.fa-rainbow:before {
  content: "\\f75b"; }

.fa-random:before {
  content: "\\f074"; }

.fa-raspberry-pi:before {
  content: "\\f7bb"; }

.fa-ravelry:before {
  content: "\\f2d9"; }

.fa-react:before {
  content: "\\f41b"; }

.fa-reacteurope:before {
  content: "\\f75d"; }

.fa-readme:before {
  content: "\\f4d5"; }

.fa-rebel:before {
  content: "\\f1d0"; }

.fa-receipt:before {
  content: "\\f543"; }

.fa-record-vinyl:before {
  content: "\\f8d9"; }

.fa-recycle:before {
  content: "\\f1b8"; }

.fa-red-river:before {
  content: "\\f3e3"; }

.fa-reddit:before {
  content: "\\f1a1"; }

.fa-reddit-alien:before {
  content: "\\f281"; }

.fa-reddit-square:before {
  content: "\\f1a2"; }

.fa-redhat:before {
  content: "\\f7bc"; }

.fa-redo:before {
  content: "\\f01e"; }

.fa-redo-alt:before {
  content: "\\f2f9"; }

.fa-registered:before {
  content: "\\f25d"; }

.fa-remove-format:before {
  content: "\\f87d"; }

.fa-renren:before {
  content: "\\f18b"; }

.fa-reply:before {
  content: "\\f3e5"; }

.fa-reply-all:before {
  content: "\\f122"; }

.fa-replyd:before {
  content: "\\f3e6"; }

.fa-republican:before {
  content: "\\f75e"; }

.fa-researchgate:before {
  content: "\\f4f8"; }

.fa-resolving:before {
  content: "\\f3e7"; }

.fa-restroom:before {
  content: "\\f7bd"; }

.fa-retweet:before {
  content: "\\f079"; }

.fa-rev:before {
  content: "\\f5b2"; }

.fa-ribbon:before {
  content: "\\f4d6"; }

.fa-ring:before {
  content: "\\f70b"; }

.fa-road:before {
  content: "\\f018"; }

.fa-robot:before {
  content: "\\f544"; }

.fa-rocket:before {
  content: "\\f135"; }

.fa-rocketchat:before {
  content: "\\f3e8"; }

.fa-rockrms:before {
  content: "\\f3e9"; }

.fa-route:before {
  content: "\\f4d7"; }

.fa-rss:before {
  content: "\\f09e"; }

.fa-rss-square:before {
  content: "\\f143"; }

.fa-ruble-sign:before {
  content: "\\f158"; }

.fa-ruler:before {
  content: "\\f545"; }

.fa-ruler-combined:before {
  content: "\\f546"; }

.fa-ruler-horizontal:before {
  content: "\\f547"; }

.fa-ruler-vertical:before {
  content: "\\f548"; }

.fa-running:before {
  content: "\\f70c"; }

.fa-rupee-sign:before {
  content: "\\f156"; }

.fa-sad-cry:before {
  content: "\\f5b3"; }

.fa-sad-tear:before {
  content: "\\f5b4"; }

.fa-safari:before {
  content: "\\f267"; }

.fa-salesforce:before {
  content: "\\f83b"; }

.fa-sass:before {
  content: "\\f41e"; }

.fa-satellite:before {
  content: "\\f7bf"; }

.fa-satellite-dish:before {
  content: "\\f7c0"; }

.fa-save:before {
  content: "\\f0c7"; }

.fa-schlix:before {
  content: "\\f3ea"; }

.fa-school:before {
  content: "\\f549"; }

.fa-screwdriver:before {
  content: "\\f54a"; }

.fa-scribd:before {
  content: "\\f28a"; }

.fa-scroll:before {
  content: "\\f70e"; }

.fa-sd-card:before {
  content: "\\f7c2"; }

.fa-search:before {
  content: "\\f002"; }

.fa-search-dollar:before {
  content: "\\f688"; }

.fa-search-location:before {
  content: "\\f689"; }

.fa-search-minus:before {
  content: "\\f010"; }

.fa-search-plus:before {
  content: "\\f00e"; }

.fa-searchengin:before {
  content: "\\f3eb"; }

.fa-seedling:before {
  content: "\\f4d8"; }

.fa-sellcast:before {
  content: "\\f2da"; }

.fa-sellsy:before {
  content: "\\f213"; }

.fa-server:before {
  content: "\\f233"; }

.fa-servicestack:before {
  content: "\\f3ec"; }

.fa-shapes:before {
  content: "\\f61f"; }

.fa-share:before {
  content: "\\f064"; }

.fa-share-alt:before {
  content: "\\f1e0"; }

.fa-share-alt-square:before {
  content: "\\f1e1"; }

.fa-share-square:before {
  content: "\\f14d"; }

.fa-shekel-sign:before {
  content: "\\f20b"; }

.fa-shield-alt:before {
  content: "\\f3ed"; }

.fa-shield-virus:before {
  content: "\\f96c"; }

.fa-ship:before {
  content: "\\f21a"; }

.fa-shipping-fast:before {
  content: "\\f48b"; }

.fa-shirtsinbulk:before {
  content: "\\f214"; }

.fa-shoe-prints:before {
  content: "\\f54b"; }

.fa-shopify:before {
  content: "\\f957"; }

.fa-shopping-bag:before {
  content: "\\f290"; }

.fa-shopping-basket:before {
  content: "\\f291"; }

.fa-shopping-cart:before {
  content: "\\f07a"; }

.fa-shopware:before {
  content: "\\f5b5"; }

.fa-shower:before {
  content: "\\f2cc"; }

.fa-shuttle-van:before {
  content: "\\f5b6"; }

.fa-sign:before {
  content: "\\f4d9"; }

.fa-sign-in-alt:before {
  content: "\\f2f6"; }

.fa-sign-language:before {
  content: "\\f2a7"; }

.fa-sign-out-alt:before {
  content: "\\f2f5"; }

.fa-signal:before {
  content: "\\f012"; }

.fa-signature:before {
  content: "\\f5b7"; }

.fa-sim-card:before {
  content: "\\f7c4"; }

.fa-simplybuilt:before {
  content: "\\f215"; }

.fa-sistrix:before {
  content: "\\f3ee"; }

.fa-sitemap:before {
  content: "\\f0e8"; }

.fa-sith:before {
  content: "\\f512"; }

.fa-skating:before {
  content: "\\f7c5"; }

.fa-sketch:before {
  content: "\\f7c6"; }

.fa-skiing:before {
  content: "\\f7c9"; }

.fa-skiing-nordic:before {
  content: "\\f7ca"; }

.fa-skull:before {
  content: "\\f54c"; }

.fa-skull-crossbones:before {
  content: "\\f714"; }

.fa-skyatlas:before {
  content: "\\f216"; }

.fa-skype:before {
  content: "\\f17e"; }

.fa-slack:before {
  content: "\\f198"; }

.fa-slack-hash:before {
  content: "\\f3ef"; }

.fa-slash:before {
  content: "\\f715"; }

.fa-sleigh:before {
  content: "\\f7cc"; }

.fa-sliders-h:before {
  content: "\\f1de"; }

.fa-slideshare:before {
  content: "\\f1e7"; }

.fa-smile:before {
  content: "\\f118"; }

.fa-smile-beam:before {
  content: "\\f5b8"; }

.fa-smile-wink:before {
  content: "\\f4da"; }

.fa-smog:before {
  content: "\\f75f"; }

.fa-smoking:before {
  content: "\\f48d"; }

.fa-smoking-ban:before {
  content: "\\f54d"; }

.fa-sms:before {
  content: "\\f7cd"; }

.fa-snapchat:before {
  content: "\\f2ab"; }

.fa-snapchat-ghost:before {
  content: "\\f2ac"; }

.fa-snapchat-square:before {
  content: "\\f2ad"; }

.fa-snowboarding:before {
  content: "\\f7ce"; }

.fa-snowflake:before {
  content: "\\f2dc"; }

.fa-snowman:before {
  content: "\\f7d0"; }

.fa-snowplow:before {
  content: "\\f7d2"; }

.fa-soap:before {
  content: "\\f96e"; }

.fa-socks:before {
  content: "\\f696"; }

.fa-solar-panel:before {
  content: "\\f5ba"; }

.fa-sort:before {
  content: "\\f0dc"; }

.fa-sort-alpha-down:before {
  content: "\\f15d"; }

.fa-sort-alpha-down-alt:before {
  content: "\\f881"; }

.fa-sort-alpha-up:before {
  content: "\\f15e"; }

.fa-sort-alpha-up-alt:before {
  content: "\\f882"; }

.fa-sort-amount-down:before {
  content: "\\f160"; }

.fa-sort-amount-down-alt:before {
  content: "\\f884"; }

.fa-sort-amount-up:before {
  content: "\\f161"; }

.fa-sort-amount-up-alt:before {
  content: "\\f885"; }

.fa-sort-down:before {
  content: "\\f0dd"; }

.fa-sort-numeric-down:before {
  content: "\\f162"; }

.fa-sort-numeric-down-alt:before {
  content: "\\f886"; }

.fa-sort-numeric-up:before {
  content: "\\f163"; }

.fa-sort-numeric-up-alt:before {
  content: "\\f887"; }

.fa-sort-up:before {
  content: "\\f0de"; }

.fa-soundcloud:before {
  content: "\\f1be"; }

.fa-sourcetree:before {
  content: "\\f7d3"; }

.fa-spa:before {
  content: "\\f5bb"; }

.fa-space-shuttle:before {
  content: "\\f197"; }

.fa-speakap:before {
  content: "\\f3f3"; }

.fa-speaker-deck:before {
  content: "\\f83c"; }

.fa-spell-check:before {
  content: "\\f891"; }

.fa-spider:before {
  content: "\\f717"; }

.fa-spinner:before {
  content: "\\f110"; }

.fa-splotch:before {
  content: "\\f5bc"; }

.fa-spotify:before {
  content: "\\f1bc"; }

.fa-spray-can:before {
  content: "\\f5bd"; }

.fa-square:before {
  content: "\\f0c8"; }

.fa-square-full:before {
  content: "\\f45c"; }

.fa-square-root-alt:before {
  content: "\\f698"; }

.fa-squarespace:before {
  content: "\\f5be"; }

.fa-stack-exchange:before {
  content: "\\f18d"; }

.fa-stack-overflow:before {
  content: "\\f16c"; }

.fa-stackpath:before {
  content: "\\f842"; }

.fa-stamp:before {
  content: "\\f5bf"; }

.fa-star:before {
  content: "\\f005"; }

.fa-star-and-crescent:before {
  content: "\\f699"; }

.fa-star-half:before {
  content: "\\f089"; }

.fa-star-half-alt:before {
  content: "\\f5c0"; }

.fa-star-of-david:before {
  content: "\\f69a"; }

.fa-star-of-life:before {
  content: "\\f621"; }

.fa-staylinked:before {
  content: "\\f3f5"; }

.fa-steam:before {
  content: "\\f1b6"; }

.fa-steam-square:before {
  content: "\\f1b7"; }

.fa-steam-symbol:before {
  content: "\\f3f6"; }

.fa-step-backward:before {
  content: "\\f048"; }

.fa-step-forward:before {
  content: "\\f051"; }

.fa-stethoscope:before {
  content: "\\f0f1"; }

.fa-sticker-mule:before {
  content: "\\f3f7"; }

.fa-sticky-note:before {
  content: "\\f249"; }

.fa-stop:before {
  content: "\\f04d"; }

.fa-stop-circle:before {
  content: "\\f28d"; }

.fa-stopwatch:before {
  content: "\\f2f2"; }

.fa-stopwatch-20:before {
  content: "\\f96f"; }

.fa-store:before {
  content: "\\f54e"; }

.fa-store-alt:before {
  content: "\\f54f"; }

.fa-store-alt-slash:before {
  content: "\\f970"; }

.fa-store-slash:before {
  content: "\\f971"; }

.fa-strava:before {
  content: "\\f428"; }

.fa-stream:before {
  content: "\\f550"; }

.fa-street-view:before {
  content: "\\f21d"; }

.fa-strikethrough:before {
  content: "\\f0cc"; }

.fa-stripe:before {
  content: "\\f429"; }

.fa-stripe-s:before {
  content: "\\f42a"; }

.fa-stroopwafel:before {
  content: "\\f551"; }

.fa-studiovinari:before {
  content: "\\f3f8"; }

.fa-stumbleupon:before {
  content: "\\f1a4"; }

.fa-stumbleupon-circle:before {
  content: "\\f1a3"; }

.fa-subscript:before {
  content: "\\f12c"; }

.fa-subway:before {
  content: "\\f239"; }

.fa-suitcase:before {
  content: "\\f0f2"; }

.fa-suitcase-rolling:before {
  content: "\\f5c1"; }

.fa-sun:before {
  content: "\\f185"; }

.fa-superpowers:before {
  content: "\\f2dd"; }

.fa-superscript:before {
  content: "\\f12b"; }

.fa-supple:before {
  content: "\\f3f9"; }

.fa-surprise:before {
  content: "\\f5c2"; }

.fa-suse:before {
  content: "\\f7d6"; }

.fa-swatchbook:before {
  content: "\\f5c3"; }

.fa-swift:before {
  content: "\\f8e1"; }

.fa-swimmer:before {
  content: "\\f5c4"; }

.fa-swimming-pool:before {
  content: "\\f5c5"; }

.fa-symfony:before {
  content: "\\f83d"; }

.fa-synagogue:before {
  content: "\\f69b"; }

.fa-sync:before {
  content: "\\f021"; }

.fa-sync-alt:before {
  content: "\\f2f1"; }

.fa-syringe:before {
  content: "\\f48e"; }

.fa-table:before {
  content: "\\f0ce"; }

.fa-table-tennis:before {
  content: "\\f45d"; }

.fa-tablet:before {
  content: "\\f10a"; }

.fa-tablet-alt:before {
  content: "\\f3fa"; }

.fa-tablets:before {
  content: "\\f490"; }

.fa-tachometer-alt:before {
  content: "\\f3fd"; }

.fa-tag:before {
  content: "\\f02b"; }

.fa-tags:before {
  content: "\\f02c"; }

.fa-tape:before {
  content: "\\f4db"; }

.fa-tasks:before {
  content: "\\f0ae"; }

.fa-taxi:before {
  content: "\\f1ba"; }

.fa-teamspeak:before {
  content: "\\f4f9"; }

.fa-teeth:before {
  content: "\\f62e"; }

.fa-teeth-open:before {
  content: "\\f62f"; }

.fa-telegram:before {
  content: "\\f2c6"; }

.fa-telegram-plane:before {
  content: "\\f3fe"; }

.fa-temperature-high:before {
  content: "\\f769"; }

.fa-temperature-low:before {
  content: "\\f76b"; }

.fa-tencent-weibo:before {
  content: "\\f1d5"; }

.fa-tenge:before {
  content: "\\f7d7"; }

.fa-terminal:before {
  content: "\\f120"; }

.fa-text-height:before {
  content: "\\f034"; }

.fa-text-width:before {
  content: "\\f035"; }

.fa-th:before {
  content: "\\f00a"; }

.fa-th-large:before {
  content: "\\f009"; }

.fa-th-list:before {
  content: "\\f00b"; }

.fa-the-red-yeti:before {
  content: "\\f69d"; }

.fa-theater-masks:before {
  content: "\\f630"; }

.fa-themeco:before {
  content: "\\f5c6"; }

.fa-themeisle:before {
  content: "\\f2b2"; }

.fa-thermometer:before {
  content: "\\f491"; }

.fa-thermometer-empty:before {
  content: "\\f2cb"; }

.fa-thermometer-full:before {
  content: "\\f2c7"; }

.fa-thermometer-half:before {
  content: "\\f2c9"; }

.fa-thermometer-quarter:before {
  content: "\\f2ca"; }

.fa-thermometer-three-quarters:before {
  content: "\\f2c8"; }

.fa-think-peaks:before {
  content: "\\f731"; }

.fa-thumbs-down:before {
  content: "\\f165"; }

.fa-thumbs-up:before {
  content: "\\f164"; }

.fa-thumbtack:before {
  content: "\\f08d"; }

.fa-ticket-alt:before {
  content: "\\f3ff"; }

.fa-times:before {
  content: "\\f00d"; }

.fa-times-circle:before {
  content: "\\f057"; }

.fa-tint:before {
  content: "\\f043"; }

.fa-tint-slash:before {
  content: "\\f5c7"; }

.fa-tired:before {
  content: "\\f5c8"; }

.fa-toggle-off:before {
  content: "\\f204"; }

.fa-toggle-on:before {
  content: "\\f205"; }

.fa-toilet:before {
  content: "\\f7d8"; }

.fa-toilet-paper:before {
  content: "\\f71e"; }

.fa-toilet-paper-slash:before {
  content: "\\f972"; }

.fa-toolbox:before {
  content: "\\f552"; }

.fa-tools:before {
  content: "\\f7d9"; }

.fa-tooth:before {
  content: "\\f5c9"; }

.fa-torah:before {
  content: "\\f6a0"; }

.fa-torii-gate:before {
  content: "\\f6a1"; }

.fa-tractor:before {
  content: "\\f722"; }

.fa-trade-federation:before {
  content: "\\f513"; }

.fa-trademark:before {
  content: "\\f25c"; }

.fa-traffic-light:before {
  content: "\\f637"; }

.fa-trailer:before {
  content: "\\f941"; }

.fa-train:before {
  content: "\\f238"; }

.fa-tram:before {
  content: "\\f7da"; }

.fa-transgender:before {
  content: "\\f224"; }

.fa-transgender-alt:before {
  content: "\\f225"; }

.fa-trash:before {
  content: "\\f1f8"; }

.fa-trash-alt:before {
  content: "\\f2ed"; }

.fa-trash-restore:before {
  content: "\\f829"; }

.fa-trash-restore-alt:before {
  content: "\\f82a"; }

.fa-tree:before {
  content: "\\f1bb"; }

.fa-trello:before {
  content: "\\f181"; }

.fa-tripadvisor:before {
  content: "\\f262"; }

.fa-trophy:before {
  content: "\\f091"; }

.fa-truck:before {
  content: "\\f0d1"; }

.fa-truck-loading:before {
  content: "\\f4de"; }

.fa-truck-monster:before {
  content: "\\f63b"; }

.fa-truck-moving:before {
  content: "\\f4df"; }

.fa-truck-pickup:before {
  content: "\\f63c"; }

.fa-tshirt:before {
  content: "\\f553"; }

.fa-tty:before {
  content: "\\f1e4"; }

.fa-tumblr:before {
  content: "\\f173"; }

.fa-tumblr-square:before {
  content: "\\f174"; }

.fa-tv:before {
  content: "\\f26c"; }

.fa-twitch:before {
  content: "\\f1e8"; }

.fa-twitter:before {
  content: "\\f099"; }

.fa-twitter-square:before {
  content: "\\f081"; }

.fa-typo3:before {
  content: "\\f42b"; }

.fa-uber:before {
  content: "\\f402"; }

.fa-ubuntu:before {
  content: "\\f7df"; }

.fa-uikit:before {
  content: "\\f403"; }

.fa-umbraco:before {
  content: "\\f8e8"; }

.fa-umbrella:before {
  content: "\\f0e9"; }

.fa-umbrella-beach:before {
  content: "\\f5ca"; }

.fa-underline:before {
  content: "\\f0cd"; }

.fa-undo:before {
  content: "\\f0e2"; }

.fa-undo-alt:before {
  content: "\\f2ea"; }

.fa-uniregistry:before {
  content: "\\f404"; }

.fa-unity:before {
  content: "\\f949"; }

.fa-universal-access:before {
  content: "\\f29a"; }

.fa-university:before {
  content: "\\f19c"; }

.fa-unlink:before {
  content: "\\f127"; }

.fa-unlock:before {
  content: "\\f09c"; }

.fa-unlock-alt:before {
  content: "\\f13e"; }

.fa-untappd:before {
  content: "\\f405"; }

.fa-upload:before {
  content: "\\f093"; }

.fa-ups:before {
  content: "\\f7e0"; }

.fa-usb:before {
  content: "\\f287"; }

.fa-user:before {
  content: "\\f007"; }

.fa-user-alt:before {
  content: "\\f406"; }

.fa-user-alt-slash:before {
  content: "\\f4fa"; }

.fa-user-astronaut:before {
  content: "\\f4fb"; }

.fa-user-check:before {
  content: "\\f4fc"; }

.fa-user-circle:before {
  content: "\\f2bd"; }

.fa-user-clock:before {
  content: "\\f4fd"; }

.fa-user-cog:before {
  content: "\\f4fe"; }

.fa-user-edit:before {
  content: "\\f4ff"; }

.fa-user-friends:before {
  content: "\\f500"; }

.fa-user-graduate:before {
  content: "\\f501"; }

.fa-user-injured:before {
  content: "\\f728"; }

.fa-user-lock:before {
  content: "\\f502"; }

.fa-user-md:before {
  content: "\\f0f0"; }

.fa-user-minus:before {
  content: "\\f503"; }

.fa-user-ninja:before {
  content: "\\f504"; }

.fa-user-nurse:before {
  content: "\\f82f"; }

.fa-user-plus:before {
  content: "\\f234"; }

.fa-user-secret:before {
  content: "\\f21b"; }

.fa-user-shield:before {
  content: "\\f505"; }

.fa-user-slash:before {
  content: "\\f506"; }

.fa-user-tag:before {
  content: "\\f507"; }

.fa-user-tie:before {
  content: "\\f508"; }

.fa-user-times:before {
  content: "\\f235"; }

.fa-users:before {
  content: "\\f0c0"; }

.fa-users-cog:before {
  content: "\\f509"; }

.fa-usps:before {
  content: "\\f7e1"; }

.fa-ussunnah:before {
  content: "\\f407"; }

.fa-utensil-spoon:before {
  content: "\\f2e5"; }

.fa-utensils:before {
  content: "\\f2e7"; }

.fa-vaadin:before {
  content: "\\f408"; }

.fa-vector-square:before {
  content: "\\f5cb"; }

.fa-venus:before {
  content: "\\f221"; }

.fa-venus-double:before {
  content: "\\f226"; }

.fa-venus-mars:before {
  content: "\\f228"; }

.fa-viacoin:before {
  content: "\\f237"; }

.fa-viadeo:before {
  content: "\\f2a9"; }

.fa-viadeo-square:before {
  content: "\\f2aa"; }

.fa-vial:before {
  content: "\\f492"; }

.fa-vials:before {
  content: "\\f493"; }

.fa-viber:before {
  content: "\\f409"; }

.fa-video:before {
  content: "\\f03d"; }

.fa-video-slash:before {
  content: "\\f4e2"; }

.fa-vihara:before {
  content: "\\f6a7"; }

.fa-vimeo:before {
  content: "\\f40a"; }

.fa-vimeo-square:before {
  content: "\\f194"; }

.fa-vimeo-v:before {
  content: "\\f27d"; }

.fa-vine:before {
  content: "\\f1ca"; }

.fa-virus:before {
  content: "\\f974"; }

.fa-virus-slash:before {
  content: "\\f975"; }

.fa-viruses:before {
  content: "\\f976"; }

.fa-vk:before {
  content: "\\f189"; }

.fa-vnv:before {
  content: "\\f40b"; }

.fa-voicemail:before {
  content: "\\f897"; }

.fa-volleyball-ball:before {
  content: "\\f45f"; }

.fa-volume-down:before {
  content: "\\f027"; }

.fa-volume-mute:before {
  content: "\\f6a9"; }

.fa-volume-off:before {
  content: "\\f026"; }

.fa-volume-up:before {
  content: "\\f028"; }

.fa-vote-yea:before {
  content: "\\f772"; }

.fa-vr-cardboard:before {
  content: "\\f729"; }

.fa-vuejs:before {
  content: "\\f41f"; }

.fa-walking:before {
  content: "\\f554"; }

.fa-wallet:before {
  content: "\\f555"; }

.fa-warehouse:before {
  content: "\\f494"; }

.fa-water:before {
  content: "\\f773"; }

.fa-wave-square:before {
  content: "\\f83e"; }

.fa-waze:before {
  content: "\\f83f"; }

.fa-weebly:before {
  content: "\\f5cc"; }

.fa-weibo:before {
  content: "\\f18a"; }

.fa-weight:before {
  content: "\\f496"; }

.fa-weight-hanging:before {
  content: "\\f5cd"; }

.fa-weixin:before {
  content: "\\f1d7"; }

.fa-whatsapp:before {
  content: "\\f232"; }

.fa-whatsapp-square:before {
  content: "\\f40c"; }

.fa-wheelchair:before {
  content: "\\f193"; }

.fa-whmcs:before {
  content: "\\f40d"; }

.fa-wifi:before {
  content: "\\f1eb"; }

.fa-wikipedia-w:before {
  content: "\\f266"; }

.fa-wind:before {
  content: "\\f72e"; }

.fa-window-close:before {
  content: "\\f410"; }

.fa-window-maximize:before {
  content: "\\f2d0"; }

.fa-window-minimize:before {
  content: "\\f2d1"; }

.fa-window-restore:before {
  content: "\\f2d2"; }

.fa-windows:before {
  content: "\\f17a"; }

.fa-wine-bottle:before {
  content: "\\f72f"; }

.fa-wine-glass:before {
  content: "\\f4e3"; }

.fa-wine-glass-alt:before {
  content: "\\f5ce"; }

.fa-wix:before {
  content: "\\f5cf"; }

.fa-wizards-of-the-coast:before {
  content: "\\f730"; }

.fa-wolf-pack-battalion:before {
  content: "\\f514"; }

.fa-won-sign:before {
  content: "\\f159"; }

.fa-wordpress:before {
  content: "\\f19a"; }

.fa-wordpress-simple:before {
  content: "\\f411"; }

.fa-wpbeginner:before {
  content: "\\f297"; }

.fa-wpexplorer:before {
  content: "\\f2de"; }

.fa-wpforms:before {
  content: "\\f298"; }

.fa-wpressr:before {
  content: "\\f3e4"; }

.fa-wrench:before {
  content: "\\f0ad"; }

.fa-x-ray:before {
  content: "\\f497"; }

.fa-xbox:before {
  content: "\\f412"; }

.fa-xing:before {
  content: "\\f168"; }

.fa-xing-square:before {
  content: "\\f169"; }

.fa-y-combinator:before {
  content: "\\f23b"; }

.fa-yahoo:before {
  content: "\\f19e"; }

.fa-yammer:before {
  content: "\\f840"; }

.fa-yandex:before {
  content: "\\f413"; }

.fa-yandex-international:before {
  content: "\\f414"; }

.fa-yarn:before {
  content: "\\f7e3"; }

.fa-yelp:before {
  content: "\\f1e9"; }

.fa-yen-sign:before {
  content: "\\f157"; }

.fa-yin-yang:before {
  content: "\\f6ad"; }

.fa-yoast:before {
  content: "\\f2b1"; }

.fa-youtube:before {
  content: "\\f167"; }

.fa-youtube-square:before {
  content: "\\f431"; }

.fa-zhihu:before {
  content: "\\f63f"; }

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto; }

@font-face {
  font-family: 'Font Awesome 5 Brands';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg"); }

.fab {
  font-family: 'Font Awesome 5 Brands';
  font-weight: 400; }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg"); }

.far {
  font-family: 'Font Awesome 5 Free';
  font-weight: 400; }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg"); }

.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900; }

@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("svg");
  font-weight: normal;
  font-style: normal; }

[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

[class^="dripicons-"]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.dripicons-alarm:before {
  content: "\\61"; }

.dripicons-align-center:before {
  content: "\\62"; }

.dripicons-align-justify:before {
  content: "\\63"; }

.dripicons-align-left:before {
  content: "\\64"; }

.dripicons-align-right:before {
  content: "\\65"; }

.dripicons-anchor:before {
  content: "\\66"; }

.dripicons-archive:before {
  content: "\\67"; }

.dripicons-arrow-down:before {
  content: "\\68"; }

.dripicons-arrow-left:before {
  content: "\\69"; }

.dripicons-arrow-right:before {
  content: "\\6a"; }

.dripicons-arrow-thin-down:before {
  content: "\\6b"; }

.dripicons-arrow-thin-left:before {
  content: "\\6c"; }

.dripicons-arrow-thin-right:before {
  content: "\\6d"; }

.dripicons-arrow-thin-up:before {
  content: "\\6e"; }

.dripicons-arrow-up:before {
  content: "\\6f"; }

.dripicons-article:before {
  content: "\\70"; }

.dripicons-backspace:before {
  content: "\\71"; }

.dripicons-basket:before {
  content: "\\72"; }

.dripicons-basketball:before {
  content: "\\73"; }

.dripicons-battery-empty:before {
  content: "\\74"; }

.dripicons-battery-full:before {
  content: "\\75"; }

.dripicons-battery-low:before {
  content: "\\76"; }

.dripicons-battery-medium:before {
  content: "\\77"; }

.dripicons-bell:before {
  content: "\\78"; }

.dripicons-blog:before {
  content: "\\79"; }

.dripicons-bluetooth:before {
  content: "\\7a"; }

.dripicons-bold:before {
  content: "\\41"; }

.dripicons-bookmark:before {
  content: "\\42"; }

.dripicons-bookmarks:before {
  content: "\\43"; }

.dripicons-box:before {
  content: "\\44"; }

.dripicons-briefcase:before {
  content: "\\45"; }

.dripicons-brightness-low:before {
  content: "\\46"; }

.dripicons-brightness-max:before {
  content: "\\47"; }

.dripicons-brightness-medium:before {
  content: "\\48"; }

.dripicons-broadcast:before {
  content: "\\49"; }

.dripicons-browser:before {
  content: "\\4a"; }

.dripicons-browser-upload:before {
  content: "\\4b"; }

.dripicons-brush:before {
  content: "\\4c"; }

.dripicons-calendar:before {
  content: "\\4d"; }

.dripicons-camcorder:before {
  content: "\\4e"; }

.dripicons-camera:before {
  content: "\\4f"; }

.dripicons-card:before {
  content: "\\50"; }

.dripicons-cart:before {
  content: "\\51"; }

.dripicons-checklist:before {
  content: "\\52"; }

.dripicons-checkmark:before {
  content: "\\53"; }

.dripicons-chevron-down:before {
  content: "\\54"; }

.dripicons-chevron-left:before {
  content: "\\55"; }

.dripicons-chevron-right:before {
  content: "\\56"; }

.dripicons-chevron-up:before {
  content: "\\57"; }

.dripicons-clipboard:before {
  content: "\\58"; }

.dripicons-clock:before {
  content: "\\59"; }

.dripicons-clockwise:before {
  content: "\\5a"; }

.dripicons-cloud:before {
  content: "\\30"; }

.dripicons-cloud-download:before {
  content: "\\31"; }

.dripicons-cloud-upload:before {
  content: "\\32"; }

.dripicons-code:before {
  content: "\\33"; }

.dripicons-contract:before {
  content: "\\34"; }

.dripicons-contract-2:before {
  content: "\\35"; }

.dripicons-conversation:before {
  content: "\\36"; }

.dripicons-copy:before {
  content: "\\37"; }

.dripicons-crop:before {
  content: "\\38"; }

.dripicons-cross:before {
  content: "\\39"; }

.dripicons-crosshair:before {
  content: "\\21"; }

.dripicons-cutlery:before {
  content: "\\22"; }

.dripicons-device-desktop:before {
  content: "\\23"; }

.dripicons-device-mobile:before {
  content: "\\24"; }

.dripicons-device-tablet:before {
  content: "\\25"; }

.dripicons-direction:before {
  content: "\\26"; }

.dripicons-disc:before {
  content: "\\27"; }

.dripicons-document:before {
  content: "\\28"; }

.dripicons-document-delete:before {
  content: "\\29"; }

.dripicons-document-edit:before {
  content: "\\2a"; }

.dripicons-document-new:before {
  content: "\\2b"; }

.dripicons-document-remove:before {
  content: "\\2c"; }

.dripicons-dot:before {
  content: "\\2d"; }

.dripicons-dots-2:before {
  content: "\\2e"; }

.dripicons-dots-3:before {
  content: "\\2f"; }

.dripicons-download:before {
  content: "\\3a"; }

.dripicons-duplicate:before {
  content: "\\3b"; }

.dripicons-enter:before {
  content: "\\3c"; }

.dripicons-exit:before {
  content: "\\3d"; }

.dripicons-expand:before {
  content: "\\3e"; }

.dripicons-expand-2:before {
  content: "\\3f"; }

.dripicons-experiment:before {
  content: "\\40"; }

.dripicons-export:before {
  content: "\\5b"; }

.dripicons-feed:before {
  content: "\\5d"; }

.dripicons-flag:before {
  content: "\\5e"; }

.dripicons-flashlight:before {
  content: "\\5f"; }

.dripicons-folder:before {
  content: "\\60"; }

.dripicons-folder-open:before {
  content: "\\7b"; }

.dripicons-forward:before {
  content: "\\7c"; }

.dripicons-gaming:before {
  content: "\\7d"; }

.dripicons-gear:before {
  content: "\\7e"; }

.dripicons-graduation:before {
  content: "\\5c"; }

.dripicons-graph-bar:before {
  content: "\\e000"; }

.dripicons-graph-line:before {
  content: "\\e001"; }

.dripicons-graph-pie:before {
  content: "\\e002"; }

.dripicons-headset:before {
  content: "\\e003"; }

.dripicons-heart:before {
  content: "\\e004"; }

.dripicons-help:before {
  content: "\\e005"; }

.dripicons-home:before {
  content: "\\e006"; }

.dripicons-hourglass:before {
  content: "\\e007"; }

.dripicons-inbox:before {
  content: "\\e008"; }

.dripicons-information:before {
  content: "\\e009"; }

.dripicons-italic:before {
  content: "\\e00a"; }

.dripicons-jewel:before {
  content: "\\e00b"; }

.dripicons-lifting:before {
  content: "\\e00c"; }

.dripicons-lightbulb:before {
  content: "\\e00d"; }

.dripicons-link:before {
  content: "\\e00e"; }

.dripicons-link-broken:before {
  content: "\\e00f"; }

.dripicons-list:before {
  content: "\\e010"; }

.dripicons-loading:before {
  content: "\\e011"; }

.dripicons-location:before {
  content: "\\e012"; }

.dripicons-lock:before {
  content: "\\e013"; }

.dripicons-lock-open:before {
  content: "\\e014"; }

.dripicons-mail:before {
  content: "\\e015"; }

.dripicons-map:before {
  content: "\\e016"; }

.dripicons-media-loop:before {
  content: "\\e017"; }

.dripicons-media-next:before {
  content: "\\e018"; }

.dripicons-media-pause:before {
  content: "\\e019"; }

.dripicons-media-play:before {
  content: "\\e01a"; }

.dripicons-media-previous:before {
  content: "\\e01b"; }

.dripicons-media-record:before {
  content: "\\e01c"; }

.dripicons-media-shuffle:before {
  content: "\\e01d"; }

.dripicons-media-stop:before {
  content: "\\e01e"; }

.dripicons-medical:before {
  content: "\\e01f"; }

.dripicons-menu:before {
  content: "\\e020"; }

.dripicons-message:before {
  content: "\\e021"; }

.dripicons-meter:before {
  content: "\\e022"; }

.dripicons-microphone:before {
  content: "\\e023"; }

.dripicons-minus:before {
  content: "\\e024"; }

.dripicons-monitor:before {
  content: "\\e025"; }

.dripicons-move:before {
  content: "\\e026"; }

.dripicons-music:before {
  content: "\\e027"; }

.dripicons-network-1:before {
  content: "\\e028"; }

.dripicons-network-2:before {
  content: "\\e029"; }

.dripicons-network-3:before {
  content: "\\e02a"; }

.dripicons-network-4:before {
  content: "\\e02b"; }

.dripicons-network-5:before {
  content: "\\e02c"; }

.dripicons-pamphlet:before {
  content: "\\e02d"; }

.dripicons-paperclip:before {
  content: "\\e02e"; }

.dripicons-pencil:before {
  content: "\\e02f"; }

.dripicons-phone:before {
  content: "\\e030"; }

.dripicons-photo:before {
  content: "\\e031"; }

.dripicons-photo-group:before {
  content: "\\e032"; }

.dripicons-pill:before {
  content: "\\e033"; }

.dripicons-pin:before {
  content: "\\e034"; }

.dripicons-plus:before {
  content: "\\e035"; }

.dripicons-power:before {
  content: "\\e036"; }

.dripicons-preview:before {
  content: "\\e037"; }

.dripicons-print:before {
  content: "\\e038"; }

.dripicons-pulse:before {
  content: "\\e039"; }

.dripicons-question:before {
  content: "\\e03a"; }

.dripicons-reply:before {
  content: "\\e03b"; }

.dripicons-reply-all:before {
  content: "\\e03c"; }

.dripicons-return:before {
  content: "\\e03d"; }

.dripicons-retweet:before {
  content: "\\e03e"; }

.dripicons-rocket:before {
  content: "\\e03f"; }

.dripicons-scale:before {
  content: "\\e040"; }

.dripicons-search:before {
  content: "\\e041"; }

.dripicons-shopping-bag:before {
  content: "\\e042"; }

.dripicons-skip:before {
  content: "\\e043"; }

.dripicons-stack:before {
  content: "\\e044"; }

.dripicons-star:before {
  content: "\\e045"; }

.dripicons-stopwatch:before {
  content: "\\e046"; }

.dripicons-store:before {
  content: "\\e047"; }

.dripicons-suitcase:before {
  content: "\\e048"; }

.dripicons-swap:before {
  content: "\\e049"; }

.dripicons-tag:before {
  content: "\\e04a"; }

.dripicons-tag-delete:before {
  content: "\\e04b"; }

.dripicons-tags:before {
  content: "\\e04c"; }

.dripicons-thumbs-down:before {
  content: "\\e04d"; }

.dripicons-thumbs-up:before {
  content: "\\e04e"; }

.dripicons-ticket:before {
  content: "\\e04f"; }

.dripicons-time-reverse:before {
  content: "\\e050"; }

.dripicons-to-do:before {
  content: "\\e051"; }

.dripicons-toggles:before {
  content: "\\e052"; }

.dripicons-trash:before {
  content: "\\e053"; }

.dripicons-trophy:before {
  content: "\\e054"; }

.dripicons-upload:before {
  content: "\\e055"; }

.dripicons-user:before {
  content: "\\e056"; }

.dripicons-user-group:before {
  content: "\\e057"; }

.dripicons-user-id:before {
  content: "\\e058"; }

.dripicons-vibrate:before {
  content: "\\e059"; }

.dripicons-view-apps:before {
  content: "\\e05a"; }

.dripicons-view-list:before {
  content: "\\e05b"; }

.dripicons-view-list-large:before {
  content: "\\e05c"; }

.dripicons-view-thumb:before {
  content: "\\e05d"; }

.dripicons-volume-full:before {
  content: "\\e05e"; }

.dripicons-volume-low:before {
  content: "\\e05f"; }

.dripicons-volume-medium:before {
  content: "\\e060"; }

.dripicons-volume-off:before {
  content: "\\e061"; }

.dripicons-wallet:before {
  content: "\\e062"; }

.dripicons-warning:before {
  content: "\\e063"; }

.dripicons-web:before {
  content: "\\e064"; }

.dripicons-weight:before {
  content: "\\e065"; }

.dripicons-wifi:before {
  content: "\\e066"; }

.dripicons-wrong:before {
  content: "\\e067"; }

.dripicons-zoom-in:before {
  content: "\\e068"; }

.dripicons-zoom-out:before {
  content: "\\e069"; }

/*
Template Name: Skote - Admin & Dashboard Template
Author: Themesbrand
Version: 4.0.0.
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/* =============================Custom Variables========================== */
/*!
   * Bootstrap  v5.3.0 (https://getbootstrap.com/)
   * Copyright 2011-2023 The Bootstrap Authors
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
:root,
[data-bs-theme="light"] {
  --bs-blue: #556ee6;
  --bs-indigo: #564ab1;
  --bs-purple: #6f42c1;
  --bs-pink: #e83e8c;
  --bs-red: #f46a6a;
  --bs-orange: #f1734f;
  --bs-yellow: #f1b44c;
  --bs-green: #34c38f;
  --bs-teal: #050505;
  --bs-cyan: #50a5f1;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #74788d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #eff2f7;
  --bs-gray-300: #f6f6f6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #74788d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #556ee6;
  --bs-secondary: #74788d;
  --bs-success: #34c38f;
  --bs-info: #50a5f1;
  --bs-warning: #f1b44c;
  --bs-danger: #f46a6a;
  --bs-pink: #e83e8c;
  --bs-light: #eff2f7;
  --bs-dark: #343a40;
  --bs-primary-rgb: 85, 110, 230;
  --bs-secondary-rgb: 116, 120, 141;
  --bs-success-rgb: 52, 195, 143;
  --bs-info-rgb: 80, 165, 241;
  --bs-warning-rgb: 241, 180, 76;
  --bs-danger-rgb: 244, 106, 106;
  --bs-pink-rgb: 232, 62, 140;
  --bs-light-rgb: 239, 242, 247;
  --bs-dark-rgb: 52, 58, 64;
  --bs-primary-text-emphasis: #222c5c;
  --bs-secondary-text-emphasis: #2e3038;
  --bs-success-text-emphasis: #154e39;
  --bs-info-text-emphasis: #204260;
  --bs-warning-text-emphasis: #60481e;
  --bs-danger-text-emphasis: #622a2a;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgba(85, 110, 230, 0.25);
  --bs-secondary-bg-subtle: rgba(116, 120, 141, 0.25);
  --bs-success-bg-subtle: rgba(52, 195, 143, 0.25);
  --bs-info-bg-subtle: rgba(80, 165, 241, 0.25);
  --bs-warning-bg-subtle: rgba(241, 180, 76, 0.25);
  --bs-danger-bg-subtle: rgba(244, 106, 106, 0.25);
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: rgba(52, 58, 64, 0.25);
  --bs-primary-border-subtle: #bbc5f5;
  --bs-secondary-border-subtle: #c7c9d1;
  --bs-success-border-subtle: #aee7d2;
  --bs-info-border-subtle: #b9dbf9;
  --bs-warning-border-subtle: #f9e1b7;
  --bs-danger-border-subtle: #fbc3c3;
  --bs-light-border-subtle: #eff2f7;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Poppins", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.8125rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #f8f8fb;
  --bs-body-bg-rgb: 248, 248, 251;
  --bs-emphasis-color: #343a40;
  --bs-emphasis-color-rgb: 52, 58, 64;
  --bs-secondary-color: #74788d;
  --bs-secondary-color-rgb: 116, 120, 141;
  --bs-secondary-bg: #fff;
  --bs-secondary-bg-rgb: 255, 255, 255;
  --bs-tertiary-color: rgba(73, 80, 87, 0.5);
  --bs-tertiary-color-rgb: 73, 80, 87;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #556ee6;
  --bs-link-color-rgb: 85, 110, 230;
  --bs-link-decoration: none;
  --bs-link-hover-color: #4458b8;
  --bs-link-hover-color-rgb: 68, 88, 184;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #e83e8c;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #eff2f7;
  --bs-border-color-translucent: #ced4da;
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.4rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.15rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(85, 110, 230, 0.25);
  --bs-form-valid-color: #34c38f;
  --bs-form-valid-border-color: #34c38f;
  --bs-form-invalid-color: #f46a6a;
  --bs-form-invalid-border-color: #f46a6a; }

[data-bs-theme="dark"] {
  color-scheme: dark;
  --bs-body-color: #a6b0cf;
  --bs-body-color-rgb: 166, 176, 207;
  --bs-body-bg: #222736;
  --bs-body-bg-rgb: 34, 39, 54;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: #c3cbe4;
  --bs-secondary-color-rgb: 195, 203, 228;
  --bs-secondary-bg: #2a3042;
  --bs-secondary-bg-rgb: 42, 48, 66;
  --bs-tertiary-color: #f6f6f6;
  --bs-tertiary-color-rgb: 246, 246, 246;
  --bs-tertiary-bg: #32394e;
  --bs-tertiary-bg-rgb: 50, 57, 78;
  --bs-primary-text-emphasis: #99a8f0;
  --bs-secondary-text-emphasis: #acaebb;
  --bs-success-text-emphasis: #85dbbc;
  --bs-info-text-emphasis: #96c9f7;
  --bs-warning-text-emphasis: #f7d294;
  --bs-danger-text-emphasis: #f8a6a6;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #f6f6f6;
  --bs-primary-bg-subtle: rgba(85, 110, 230, 0.25);
  --bs-secondary-bg-subtle: rgba(116, 120, 141, 0.25);
  --bs-success-bg-subtle: rgba(52, 195, 143, 0.25);
  --bs-info-bg-subtle: rgba(80, 165, 241, 0.25);
  --bs-warning-bg-subtle: rgba(241, 180, 76, 0.25);
  --bs-danger-bg-subtle: rgba(244, 106, 106, 0.25);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: rgba(52, 58, 64, 0.25);
  --bs-primary-border-subtle: #33428a;
  --bs-secondary-border-subtle: #464855;
  --bs-success-border-subtle: #1f7556;
  --bs-info-border-subtle: #306391;
  --bs-warning-border-subtle: #916c2e;
  --bs-danger-border-subtle: #924040;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: #f6f6f6;
  --bs-link-color: #556ee6;
  --bs-link-hover-color: #778beb;
  --bs-link-color-rgb: 85, 110, 230;
  --bs-link-hover-color-rgb: 119, 139, 235;
  --bs-code-color: #e83e8c;
  --bs-border-color: #32394e;
  --bs-border-color-translucent: #353d55;
  --bs-form-valid-color: #85dbbc;
  --bs-form-valid-border-color: #85dbbc;
  --bs-form-invalid-color: #f8a6a6;
  --bs-form-invalid-border-color: #f8a6a6; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid var(--bs-border-color);
  opacity: 0.8; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color); }

h1, .h1 {
  font-size: calc(1.32813rem + 0.9375vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.03125rem; } }

h2, .h2 {
  font-size: calc(1.2875rem + 0.45vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 1.625rem; } }

h3, .h3 {
  font-size: calc(1.26719rem + 0.20625vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.42188rem; } }

h4, .h4 {
  font-size: 1.21875rem; }

h5, .h5 {
  font-size: 1.01563rem; }
  @media (min-width: 1200px) {
    h5, .h5 {
      font-size: 1.01562rem; } }

h6, .h6 {
  font-size: 0.8125rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul {
  padding-left: 2rem; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 600; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 80%; }

mark, .mark {
  padding: 0.2em;
  background-color: var(--bs-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none; }
  a:hover {
    --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
    text-decoration: underline; }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: var(--bs-secondary-color);
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit; }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield; }

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.01563rem;
  font-weight: 300; }
  @media (min-width: 1200px) {
    .lead {
      font-size: 1.01562rem; } }

.display-1 {
  font-size: calc(1.725rem + 5.7vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 6rem; } }

.display-2 {
  font-size: calc(1.675rem + 5.1vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 5.5rem; } }

.display-3 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4.5rem; } }

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 80%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.01563rem; }
  @media (min-width: 1200px) {
    .blockquote {
      font-size: 1.01562rem; } }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 80%;
  color: var(--bs-secondary-color); }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 80%;
  color: var(--bs-secondary-color); }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --bs-gutter-x: 12px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px; }

.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * .5);
    padding-left: calc(var(--bs-gutter-x) * .5);
    margin-top: var(--bs-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

.g-0,
.gx-0 {
  --bs-gutter-x: 0; }

.g-0,
.gy-0 {
  --bs-gutter-y: 0; }

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem; } }

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: var(--bs-secondary-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(var(--bs-tertiary-bg-rgb), 1);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(var(--bs-tertiary-bg-rgb), 1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(var(--bs-tertiary-bg-rgb), 1);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.75rem 0.75rem;
    color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
    background-color: var(--bs-table-bg);
    border-bottom-width: var(--bs-border-width);
    box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg))); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor; }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.3rem; }

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 var(--bs-border-width); }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg); }

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg); }

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #dde2fa;
  --bs-table-border-color: #c7cbe1;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e3e4e8;
  --bs-table-border-color: #cccdd1;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d6f3e9;
  --bs-table-border-color: #c1dbd2;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #dcedfc;
  --bs-table-border-color: #c6d5e3;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fcf0db;
  --bs-table-border-color: #e3d8c5;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #fde1e1;
  --bs-table-border-color: #e4cbcb;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #eff2f7;
  --bs-table-border-color: #d7dade;
  --bs-table-striped-bg: black;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: #484e53;
  --bs-table-striped-bg: white;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: white;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: white;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem; }

.col-form-label {
  padding-top: calc(0.47rem + var(--bs-border-width));
  padding-bottom: calc(0.47rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.01563rem; }
  @media (min-width: 1200px) {
    .col-form-label-lg {
      font-size: 1.01562rem; } }

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.71094rem; }

.form-text {
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-secondary-color); }

.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-emphasis-color);
  background-color: var(--bs-secondary-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  appearance: none;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: var(--bs-emphasis-color);
    background-color: var(--bs-secondary-bg);
    border-color: rgba(var(--bs-body-color-rgb), 0.2);
    outline: 0;
    box-shadow: none; }
  .form-control::-webkit-date-and-time-value {
    min-width: 85px;
    height: 1.5em;
    margin: 0; }
  .form-control::-webkit-datetime-edit {
    display: block;
    padding: 0; }
  .form-control::placeholder {
    color: var(--bs-secondary-color);
    opacity: 1; }
  .form-control:disabled {
    background-color: var(--bs-body-bg);
    opacity: 1; }
  .form-control::file-selector-button {
    padding: 0.47rem 0.75rem;
    margin: -0.47rem -0.75rem;
    margin-inline-end: 0.75rem;
    color: var(--bs-emphasis-color);
    background-color: var(--bs-tertiary-bg);
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: var(--bs-border-width);
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: var(--bs-secondary-bg); }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: var(--bs-border-radius-sm); }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.01563rem;
  border-radius: var(--bs-border-radius-lg); }
  @media (min-width: 1200px) {
    .form-control-lg {
      font-size: 1.01562rem; } }
  .form-control-lg::file-selector-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    margin-inline-end: 1rem; }

textarea.form-control {
  min-height: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2)); }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2)); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2)); }

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2));
  padding: 0.47rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius); }
  .form-control-color::-webkit-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius); }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2)); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2)); }

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  display: block;
  width: 100%;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-emphasis-color);
  background-color: var(--bs-secondary-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: rgba(var(--bs-body-color-rgb), 0.2);
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    padding-right: 0.75rem;
    background-image: none; }
  .form-select:disabled {
    background-color: var(--bs-body-bg); }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 var(--bs-emphasis-color); }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.71094rem;
  border-radius: var(--bs-border-radius-sm); }

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.01563rem;
  border-radius: var(--bs-border-radius-lg); }
  @media (min-width: 1200px) {
    .form-select-lg {
      font-size: 1.01562rem; } }

[data-bs-theme="dark"] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_34___}); }

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem; }
  .form-check .form-check-input {
    float: left;
    margin-left: -1.5em; }

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right; }
  .form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.5em;
    margin-left: 0; }

.form-check-input {
  --bs-form-check-bg: var(--bs-secondary-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-check-input {
      transition: none; } }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: rgba(var(--bs-body-color-rgb), 0.2);
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25); }
  .form-check-input:checked {
    background-color: #556ee6;
    border-color: #556ee6; }
    .form-check-input:checked[type="checkbox"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}); }
    .form-check-input:checked[type="radio"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #556ee6;
    border-color: #556ee6;
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-switch {
  padding-left: 2.5em; }
  .form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    width: 2em;
    margin-left: -2.5em;
    background-image: var(--bs-form-switch-bg);
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch .form-check-input {
        transition: none; } }
    .form-switch .form-check-input:focus {
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_38___}); }
    .form-switch .form-check-input:checked {
      background-position: right center;
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___}); }
  .form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0; }
    .form-switch.form-check-reverse .form-check-input {
      margin-right: -2.5em;
      margin-left: 0; }

.form-check-inline {
  display: inline-block;
  margin-right: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

[data-bs-theme="dark"] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_40___}); }

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  background-color: transparent;
  appearance: none; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f8f8fb, none; }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f8f8fb, none; }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #556ee6;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #ccd4f8; }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--bs-tertiary-bg);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #556ee6;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #ccd4f8; }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--bs-tertiary-bg);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: var(--bs-secondary-color); }
    .form-range:disabled::-moz-range-thumb {
      background-color: var(--bs-secondary-color); }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    height: 100%;
    padding: 1rem 0.75rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: var(--bs-border-width) solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.75rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
    .form-floating > .form-control:focus ~ label::after,
    .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
    .form-floating > .form-control-plaintext ~ label::after,
    .form-floating > .form-select ~ label::after {
      position: absolute;
      inset: 1rem 0.375rem;
      z-index: -1;
      height: 1.5em;
      content: "";
      background-color: var(--bs-secondary-bg);
      border-radius: var(--bs-border-radius); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control-plaintext ~ label {
    border-width: var(--bs-border-width) 0; }
  .form-floating > :disabled ~ label {
    color: #74788d; }
    .form-floating > :disabled ~ label::after {
      background-color: var(--bs-body-bg); }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-emphasis-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: var(--bs-border-radius); }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.01563rem;
  border-radius: var(--bs-border-radius-lg); }
  @media (min-width: 1200px) {
    .input-group-lg > .form-control,
    .input-group-lg > .form-select,
    .input-group-lg > .input-group-text,
    .input-group-lg > .btn {
      font-size: 1.01562rem; } }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: var(--bs-border-radius-sm); }

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.5rem; }

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-form-valid-color); }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.71094rem;
  line-height: 1.5;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius); }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-success-rgb), 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color); }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
    padding-right: 3.625rem;
    background-position: right 0.75rem center, center right 1.75rem;
    background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-success-rgb), 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.94rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color); }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: var(--bs-form-valid-color); }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-success-rgb), 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: var(--bs-form-valid-color); }

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-form-invalid-color); }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.71094rem;
  line-height: 1.5;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius); }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-danger-rgb), 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color); }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
    padding-right: 3.625rem;
    background-position: right 0.75rem center, center right 1.75rem;
    background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-danger-rgb), 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.94rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color); }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: var(--bs-form-invalid-color); }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0.15rem rgba(var(--bs-danger-rgb), 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: var(--bs-form-invalid-color); }

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--bs-btn-hover-color);
    text-decoration: none;
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color); }
  .btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity); }

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #556ee6;
  --bs-btn-border-color: #556ee6;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #485ec4;
  --bs-btn-hover-border-color: #4458b8;
  --bs-btn-focus-shadow-rgb: 111, 132, 234;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4458b8;
  --bs-btn-active-border-color: #4053ad;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #556ee6;
  --bs-btn-disabled-border-color: #556ee6; }

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #636678;
  --bs-btn-hover-border-color: #5d6071;
  --bs-btn-focus-shadow-rgb: 137, 140, 158;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5d6071;
  --bs-btn-active-border-color: #575a6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #74788d;
  --bs-btn-disabled-border-color: #74788d; }

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2ca67a;
  --bs-btn-hover-border-color: #2a9c72;
  --bs-btn-focus-shadow-rgb: 82, 204, 160;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2a9c72;
  --bs-btn-active-border-color: #27926b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #34c38f;
  --bs-btn-disabled-border-color: #34c38f; }

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #448ccd;
  --bs-btn-hover-border-color: #4084c1;
  --bs-btn-focus-shadow-rgb: 106, 179, 243;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4084c1;
  --bs-btn-active-border-color: #3c7cb5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #50a5f1;
  --bs-btn-disabled-border-color: #50a5f1; }

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #cd9941;
  --bs-btn-hover-border-color: #c1903d;
  --bs-btn-focus-shadow-rgb: 243, 191, 103;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c1903d;
  --bs-btn-active-border-color: #b58739;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f1b44c;
  --bs-btn-disabled-border-color: #f1b44c; }

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #cf5a5a;
  --bs-btn-hover-border-color: #c35555;
  --bs-btn-focus-shadow-rgb: 246, 128, 128;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c35555;
  --bs-btn-active-border-color: #b75050;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f46a6a;
  --bs-btn-disabled-border-color: #f46a6a; }

.btn-pink {
  --bs-btn-color: #fff;
  --bs-btn-bg: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c53577;
  --bs-btn-hover-border-color: #ba3270;
  --bs-btn-focus-shadow-rgb: 235, 91, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ba3270;
  --bs-btn-active-border-color: #ae2f69;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #e83e8c;
  --bs-btn-disabled-border-color: #e83e8c; }

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #cbced2;
  --bs-btn-hover-border-color: #bfc2c6;
  --bs-btn-focus-shadow-rgb: 203, 206, 210;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #bfc2c6;
  --bs-btn-active-border-color: #b3b6b9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eff2f7;
  --bs-btn-disabled-border-color: #eff2f7; }

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #52585d;
  --bs-btn-hover-border-color: #484e53;
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5d6166;
  --bs-btn-active-border-color: #484e53;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40; }

.btn-outline-primary {
  --bs-btn-color: #556ee6;
  --bs-btn-border-color: #556ee6;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #556ee6;
  --bs-btn-hover-border-color: #556ee6;
  --bs-btn-focus-shadow-rgb: 85, 110, 230;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #556ee6;
  --bs-btn-active-border-color: #556ee6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #556ee6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #556ee6;
  --bs-gradient: none; }

.btn-outline-secondary {
  --bs-btn-color: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #74788d;
  --bs-btn-hover-border-color: #74788d;
  --bs-btn-focus-shadow-rgb: 116, 120, 141;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #74788d;
  --bs-btn-active-border-color: #74788d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #74788d;
  --bs-gradient: none; }

.btn-outline-success {
  --bs-btn-color: #34c38f;
  --bs-btn-border-color: #34c38f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #34c38f;
  --bs-btn-hover-border-color: #34c38f;
  --bs-btn-focus-shadow-rgb: 52, 195, 143;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #34c38f;
  --bs-btn-active-border-color: #34c38f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #34c38f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #34c38f;
  --bs-gradient: none; }

.btn-outline-info {
  --bs-btn-color: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #50a5f1;
  --bs-btn-hover-border-color: #50a5f1;
  --bs-btn-focus-shadow-rgb: 80, 165, 241;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #50a5f1;
  --bs-btn-active-border-color: #50a5f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50a5f1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50a5f1;
  --bs-gradient: none; }

.btn-outline-warning {
  --bs-btn-color: #f1b44c;
  --bs-btn-border-color: #f1b44c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f1b44c;
  --bs-btn-hover-border-color: #f1b44c;
  --bs-btn-focus-shadow-rgb: 241, 180, 76;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f1b44c;
  --bs-btn-active-border-color: #f1b44c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f1b44c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f1b44c;
  --bs-gradient: none; }

.btn-outline-danger {
  --bs-btn-color: #f46a6a;
  --bs-btn-border-color: #f46a6a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f46a6a;
  --bs-btn-hover-border-color: #f46a6a;
  --bs-btn-focus-shadow-rgb: 244, 106, 106;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f46a6a;
  --bs-btn-active-border-color: #f46a6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f46a6a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f46a6a;
  --bs-gradient: none; }

.btn-outline-pink {
  --bs-btn-color: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #e83e8c;
  --bs-btn-hover-border-color: #e83e8c;
  --bs-btn-focus-shadow-rgb: 232, 62, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #e83e8c;
  --bs-btn-active-border-color: #e83e8c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e83e8c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e83e8c;
  --bs-gradient: none; }

.btn-outline-light {
  --bs-btn-color: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eff2f7;
  --bs-btn-hover-border-color: #eff2f7;
  --bs-btn-focus-shadow-rgb: 239, 242, 247;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eff2f7;
  --bs-btn-active-border-color: #eff2f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eff2f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eff2f7;
  --bs-gradient: none; }

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none; }

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 111, 132, 234;
  text-decoration: none; }
  .btn-link:hover, .btn-link:focus-visible {
    text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--bs-btn-color); }
  .btn-link:hover {
    color: var(--bs-btn-hover-color); }

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.01563rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg); }
  @media (min-width: 1200px) {
    .btn-lg, .btn-group-lg > .btn {
      --bs-btn-font-size: 1.01562rem; } }

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.71094rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm); }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.8125rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-secondary-bg);
  --bs-dropdown-border-color: var(--bs-border-color);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - 0);
  --bs-dropdown-divider-bg: var(--bs-border-color);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-emphasis-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: var(--bs-emphasis-color);
  --bs-dropdown-link-active-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #74788d;
  --bs-dropdown-header-padding-x: 1.5rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius); }
  .dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer); }

.dropdown-menu-start {
  --bs-position: start; }
  .dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0; }

.dropdown-menu-end {
  --bs-position: end; }
  .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start; }
    .dropdown-menu-sm-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-sm-end {
    --bs-position: end; }
    .dropdown-menu-sm-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start; }
    .dropdown-menu-md-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-md-end {
    --bs-position: end; }
    .dropdown-menu-md-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start; }
    .dropdown-menu-lg-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-lg-end {
    --bs-position: end; }
    .dropdown-menu-lg-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start; }
    .dropdown-menu-xl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xl-end {
    --bs-position: end; }
    .dropdown-menu-xl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start; }
    .dropdown-menu-xxl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xxl-end {
    --bs-position: end; }
    .dropdown-menu-xxl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer); }

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer); }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0); }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.71094rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color); }

.dropdown-menu-dark {
  --bs-dropdown-color: #f6f6f6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #f6f6f6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: var(--bs-emphasis-color);
  --bs-dropdown-link-active-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: var(--bs-border-radius); }
  .btn-group > :not(.btn-check:first-child) + .btn,
  .btn-group > .btn-group:not(:first-child) {
    margin-left: calc(var(--bs-border-width) * -1); }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group > .btn.dropdown-toggle-split:first-child,
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .btn-group > .btn:nth-child(n + 3),
  .btn-group > :not(.btn-check) + .btn,
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: calc(var(--bs-border-width) * -1); }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn ~ .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--bs-nav-link-hover-color);
    text-decoration: none; }
  .nav-link:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25); }
  .nav-link.disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-secondary-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-secondary-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
    border: var(--bs-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--bs-nav-tabs-link-hover-border-color); }
    .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
      color: var(--bs-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #556ee6; }
  .nav-pills .nav-link {
    border-radius: var(--bs-nav-pills-border-radius); }
    .nav-pills .nav-link:disabled {
      color: var(--bs-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg); }

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap); }
  .nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    border-bottom: var(--bs-nav-underline-border-width) solid transparent; }
    .nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
      border-bottom-color: currentcolor; }
  .nav-underline .nav-link.active,
  .nav-underline .show > .nav-link {
    font-weight: 600;
    color: var(--bs-nav-underline-link-active-color);
    border-bottom-color: currentcolor; }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.34766rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.01562rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.01562rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color);
    text-decoration: none; }

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
    color: var(--bs-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--bs-navbar-active-color); }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--bs-navbar-nav-link-padding-x);
      padding-left: var(--bs-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark,
.navbar[data-bs-theme="dark"] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___}); }

[data-bs-theme="dark"] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___}); }

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: var(--bs-emphasis-color);
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: var(--bs-border-color);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - 0);
  --bs-card-cap-padding-y: 0.625rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: var(--bs-tertiary-bg);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-secondary-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--bs-card-inner-border-radius);
      border-top-right-radius: var(--bs-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--bs-card-inner-border-radius);
      border-bottom-left-radius: var(--bs-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color); }

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color); }

.card-subtitle {
  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color); }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x); }

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-secondary-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --bs-accordion-btn-icon-width: 16px;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --bs-accordion-btn-focus-border-color: rgba(var(--bs-body-color-rgb), 0.2);
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), 0.5);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle); }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.8125rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--bs-accordion-btn-active-icon);
      transform: var(--bs-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    border-color: var(--bs-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius); }
    .accordion-item:first-of-type .accordion-button {
      border-top-left-radius: var(--bs-accordion-inner-border-radius);
      border-top-right-radius: var(--bs-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius); }
    .accordion-item:last-of-type .accordion-button.collapsed {
      border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
      border-bottom-left-radius: var(--bs-accordion-inner-border-radius); }
    .accordion-item:last-of-type .accordion-collapse {
      border-bottom-right-radius: var(--bs-accordion-border-radius);
      border-bottom-left-radius: var(--bs-accordion-border-radius); }

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x); }

.accordion-flush .accordion-collapse {
  border-width: 0; }

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0; }

[data-bs-theme="dark"] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___}); }

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius); }

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x); }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */; }

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color); }

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 0.8125rem;
  --bs-pagination-color: var(--bs-secondary-color);
  --bs-pagination-bg: var(--bs-secondary-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #556ee6;
  --bs-pagination-active-border-color: #556ee6;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none; }

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    text-decoration: none;
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color); }

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1); }

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius); }

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius); }

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.01563rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg); }
  @media (min-width: 1200px) {
    .pagination-lg {
      --bs-pagination-font-size: 1.01562rem; } }

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.71094rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm); }

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 75%;
  --bs-badge-font-weight: 500;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color); }

.alert-dismissible {
  padding-right: 3.75rem; }
  .alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 0.9375rem 1.25rem; }

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis); }

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis); }

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis); }

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis); }

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis); }

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis); }

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis); }

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis); }

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis); }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem; } }

.progress,
.progress-stacked {
  --bs-progress-height: 0.625rem;
  --bs-progress-font-size: 0.60938rem;
  --bs-progress-bg: var(--bs-tertiary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #556ee6;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height); }

.progress-stacked > .progress {
  overflow: visible; }

.progress-stacked > .progress > .progress-bar {
  width: 100%; }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.list-group {
  --bs-list-group-color: var(--bs-emphasis-color);
  --bs-list-group-bg: var(--bs-secondary-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-tertiary-color);
  --bs-list-group-disabled-bg: var(--bs-secondary-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #556ee6;
  --bs-list-group-active-border-color: #556ee6;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius); }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg); }
  .list-group-item-action:active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg); }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--bs-list-group-border-width));
      border-top-width: var(--bs-list-group-border-width); }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--bs-list-group-border-width));
      border-left-width: var(--bs-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis); }

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis); }

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis); }

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis); }

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis); }

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis); }

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis); }

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis); }

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis); }

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity); }
  .btn-close:hover {
    color: var(--bs-btn-close-color);
    text-decoration: none;
    opacity: var(--bs-btn-close-hover-opacity); }
  .btn-close:focus {
    outline: 0;
    box-shadow: var(--bs-btn-close-focus-shadow);
    opacity: var(--bs-btn-close-focus-opacity); }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: var(--bs-btn-close-disabled-opacity); }

.btn-close-white {
  filter: var(--bs-btn-close-white-filter); }

[data-bs-theme="dark"] .btn-close {
  filter: var(--bs-btn-close-white-filter); }

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.25rem;
  --bs-toast-spacing: 12px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: var(--bs-secondary-bg);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: var(--bs-box-shadow-lg);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: var(--bs-secondary-bg);
  --bs-toast-header-border-color: var(--bs-border-color);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--bs-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width)); }
  .toast-header .btn-close {
    margin-right: calc(-.5 * var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x); }

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-secondary-bg);
  --bs-modal-border-color: var(--bs-border-color);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);
    margin: calc(-.5 * var(--bs-modal-header-padding-y)) calc(-.5 * var(--bs-modal-header-padding-x)) calc(-.5 * var(--bs-modal-header-padding-y)) auto; }

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--bs-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --bs-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.7rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.71094rem;
  --bs-tooltip-color: var(--bs-secondary-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: var(--bs-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius); }

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.71094rem;
  --bs-popover-bg: var(--bs-secondary-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.8125rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%; }
  .carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-bs-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center; }

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100); }

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000; }

.carousel-dark .carousel-caption {
  color: #000; }

[data-bs-theme="dark"] .carousel .carousel-control-prev-icon,
[data-bs-theme="dark"] .carousel .carousel-control-next-icon, [data-bs-theme="dark"].carousel .carousel-control-prev-icon,
[data-bs-theme="dark"].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100); }

[data-bs-theme="dark"] .carousel .carousel-indicators [data-bs-target], [data-bs-theme="dark"].carousel .carousel-indicators [data-bs-target] {
  background-color: #000; }

[data-bs-theme="dark"] .carousel .carousel-caption, [data-bs-theme="dark"].carousel .carousel-caption {
  color: #000; }

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-secondary-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5; }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition); }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--bs-offcanvas-padding-y)); }

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height); }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%; } }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(85, 110, 230, var(--bs-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(116, 120, 141, var(--bs-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(52, 195, 143, var(--bs-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(80, 165, 241, var(--bs-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(241, 180, 76, var(--bs-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(244, 106, 106, var(--bs-bg-opacity, 1)) !important; }

.text-bg-pink {
  color: #fff !important;
  background-color: RGBA(232, 62, 140, var(--bs-bg-opacity, 1)) !important; }

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(239, 242, 247, var(--bs-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(52, 58, 64, var(--bs-bg-opacity, 1)) !important; }

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-primary:hover, .link-primary:focus {
    color: RGBA(68, 88, 184, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(68, 88, 184, var(--bs-link-underline-opacity, 1)) !important; }

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: RGBA(93, 96, 113, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(93, 96, 113, var(--bs-link-underline-opacity, 1)) !important; }

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-success:hover, .link-success:focus {
    color: RGBA(42, 156, 114, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(42, 156, 114, var(--bs-link-underline-opacity, 1)) !important; }

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-info:hover, .link-info:focus {
    color: RGBA(64, 132, 193, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(64, 132, 193, var(--bs-link-underline-opacity, 1)) !important; }

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-warning:hover, .link-warning:focus {
    color: RGBA(193, 144, 61, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(193, 144, 61, var(--bs-link-underline-opacity, 1)) !important; }

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-danger:hover, .link-danger:focus {
    color: RGBA(195, 85, 85, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(195, 85, 85, var(--bs-link-underline-opacity, 1)) !important; }

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-pink:hover, .link-pink:focus {
    color: RGBA(186, 50, 112, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(186, 50, 112, var(--bs-link-underline-opacity, 1)) !important; }

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light:hover, .link-light:focus {
    color: RGBA(242, 245, 249, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(242, 245, 249, var(--bs-link-underline-opacity, 1)) !important; }

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-dark:hover, .link-dark:focus {
    color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important; }

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-body-emphasis:hover, .link-body-emphasis:focus {
    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important; }

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color); }

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden; }
  .icon-link > .bi {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentcolor;
    transition: 0.2s ease-in-out transform; }
    @media (prefers-reduced-motion: reduce) {
      .icon-link > .bi {
        transition: none; } }

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0)); }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; }

.ratio-1x1 {
  --bs-aspect-ratio: 100%; }

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }
  .visually-hidden:not(caption),
  .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
    position: absolute !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.8; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.float-start {
  float: left !important; }

.float-end {
  float: right !important; }

.float-none {
  float: none !important; }

.object-fit-contain {
  object-fit: contain !important; }

.object-fit-cover {
  object-fit: cover !important; }

.object-fit-fill {
  object-fit: fill !important; }

.object-fit-scale {
  object-fit: scale-down !important; }

.object-fit-none {
  object-fit: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.overflow-x-auto {
  overflow-x: auto !important; }

.overflow-x-hidden {
  overflow-x: hidden !important; }

.overflow-x-visible {
  overflow-x: visible !important; }

.overflow-x-scroll {
  overflow-x: scroll !important; }

.overflow-y-auto {
  overflow-y: auto !important; }

.overflow-y-hidden {
  overflow-y: hidden !important; }

.overflow-y-visible {
  overflow-y: visible !important; }

.overflow-y-scroll {
  overflow-y: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-inline-grid {
  display: inline-grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03) !important; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }

.shadow-none {
  box-shadow: none !important; }

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity)); }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-end-0 {
  border-right: 0 !important; }

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-start-0 {
  border-left: 0 !important; }

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important; }

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important; }

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important; }

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important; }

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important; }

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important; }

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important; }

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important; }

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important; }

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important; }

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important; }

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important; }

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important; }

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important; }

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important; }

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important; }

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important; }

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important; }

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important; }

.border-0 {
  border-width: 0 !important; }

.border-1 {
  border-width: 1px !important; }

.border-2 {
  border-width: 2px !important; }

.border-3 {
  border-width: 3px !important; }

.border-4 {
  border-width: 4px !important; }

.border-5 {
  border-width: 5px !important; }

.border-opacity-10 {
  --bs-border-opacity: 0.1; }

.border-opacity-25 {
  --bs-border-opacity: 0.25; }

.border-opacity-50 {
  --bs-border-opacity: 0.5; }

.border-opacity-75 {
  --bs-border-opacity: 0.75; }

.border-opacity-100 {
  --bs-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

.me-0 {
  margin-right: 0 !important; }

.me-1 {
  margin-right: 0.25rem !important; }

.me-2 {
  margin-right: 0.5rem !important; }

.me-3 {
  margin-right: 1rem !important; }

.me-4 {
  margin-right: 1.5rem !important; }

.me-5 {
  margin-right: 3rem !important; }

.me-auto {
  margin-right: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

.ms-0 {
  margin-left: 0 !important; }

.ms-1 {
  margin-left: 0.25rem !important; }

.ms-2 {
  margin-left: 0.5rem !important; }

.ms-3 {
  margin-left: 1rem !important; }

.ms-4 {
  margin-left: 1.5rem !important; }

.ms-5 {
  margin-left: 3rem !important; }

.ms-auto {
  margin-left: auto !important; }

.m-n1 {
  margin: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important; }

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important; }

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important; }

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important; }

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important; }

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important; }

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important; }

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important; }

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important; }

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important; }

.mt-n1 {
  margin-top: -0.25rem !important; }

.mt-n2 {
  margin-top: -0.5rem !important; }

.mt-n3 {
  margin-top: -1rem !important; }

.mt-n4 {
  margin-top: -1.5rem !important; }

.mt-n5 {
  margin-top: -3rem !important; }

.me-n1 {
  margin-right: -0.25rem !important; }

.me-n2 {
  margin-right: -0.5rem !important; }

.me-n3 {
  margin-right: -1rem !important; }

.me-n4 {
  margin-right: -1.5rem !important; }

.me-n5 {
  margin-right: -3rem !important; }

.mb-n1 {
  margin-bottom: -0.25rem !important; }

.mb-n2 {
  margin-bottom: -0.5rem !important; }

.mb-n3 {
  margin-bottom: -1rem !important; }

.mb-n4 {
  margin-bottom: -1.5rem !important; }

.mb-n5 {
  margin-bottom: -3rem !important; }

.ms-n1 {
  margin-left: -0.25rem !important; }

.ms-n2 {
  margin-left: -0.5rem !important; }

.ms-n3 {
  margin-left: -1rem !important; }

.ms-n4 {
  margin-left: -1.5rem !important; }

.ms-n5 {
  margin-left: -3rem !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

.pe-0 {
  padding-right: 0 !important; }

.pe-1 {
  padding-right: 0.25rem !important; }

.pe-2 {
  padding-right: 0.5rem !important; }

.pe-3 {
  padding-right: 1rem !important; }

.pe-4 {
  padding-right: 1.5rem !important; }

.pe-5 {
  padding-right: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

.ps-0 {
  padding-left: 0 !important; }

.ps-1 {
  padding-left: 0.25rem !important; }

.ps-2 {
  padding-left: 0.5rem !important; }

.ps-3 {
  padding-left: 1rem !important; }

.ps-4 {
  padding-left: 1.5rem !important; }

.ps-5 {
  padding-left: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.row-gap-0 {
  row-gap: 0 !important; }

.row-gap-1 {
  row-gap: 0.25rem !important; }

.row-gap-2 {
  row-gap: 0.5rem !important; }

.row-gap-3 {
  row-gap: 1rem !important; }

.row-gap-4 {
  row-gap: 1.5rem !important; }

.row-gap-5 {
  row-gap: 3rem !important; }

.column-gap-0 {
  column-gap: 0 !important; }

.column-gap-1 {
  column-gap: 0.25rem !important; }

.column-gap-2 {
  column-gap: 0.5rem !important; }

.column-gap-3 {
  column-gap: 1rem !important; }

.column-gap-4 {
  column-gap: 1.5rem !important; }

.column-gap-5 {
  column-gap: 3rem !important; }

.font-monospace {
  font-family: var(--bs-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.32813rem + 0.9375vw) !important; }

.fs-2 {
  font-size: calc(1.2875rem + 0.45vw) !important; }

.fs-3 {
  font-size: calc(1.26719rem + 0.20625vw) !important; }

.fs-4 {
  font-size: 1.21875rem !important; }

.fs-5 {
  font-size: 1.01563rem !important; }

.fs-6 {
  font-size: 0.8125rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-medium {
  font-weight: 500 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bold {
  font-weight: 600 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

.text-start {
  text-align: left !important; }

.text-end {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important; }

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important; }

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important; }

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important; }

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important; }

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important; }

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important; }

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important; }

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important; }

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important; }

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important; }

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important; }

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important; }

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important; }

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important; }

.text-opacity-25 {
  --bs-text-opacity: 0.25; }

.text-opacity-50 {
  --bs-text-opacity: 0.5; }

.text-opacity-75 {
  --bs-text-opacity: 0.75; }

.text-opacity-100 {
  --bs-text-opacity: 1; }

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important; }

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important; }

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important; }

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important; }

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important; }

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important; }

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important; }

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important; }

.link-opacity-10 {
  --bs-link-opacity: 0.1; }

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1; }

.link-opacity-25 {
  --bs-link-opacity: 0.25; }

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25; }

.link-opacity-50 {
  --bs-link-opacity: 0.5; }

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5; }

.link-opacity-75 {
  --bs-link-opacity: 0.75; }

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75; }

.link-opacity-100 {
  --bs-link-opacity: 1; }

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1; }

.link-offset-1 {
  text-underline-offset: 0.125em !important; }

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important; }

.link-offset-2 {
  text-underline-offset: 0.25em !important; }

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important; }

.link-offset-3 {
  text-underline-offset: 0.375em !important; }

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important; }

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1; }

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1; }

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important; }

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important; }

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important; }

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important; }

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important; }

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important; }

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important; }

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important; }

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important; }

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important; }

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important; }

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important; }

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-opacity-10 {
  --bs-bg-opacity: 0.1; }

.bg-opacity-25 {
  --bs-bg-opacity: 0.25; }

.bg-opacity-50 {
  --bs-bg-opacity: 0.5; }

.bg-opacity-75 {
  --bs-bg-opacity: 0.75; }

.bg-opacity-100 {
  --bs-bg-opacity: 1; }

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important; }

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important; }

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important; }

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important; }

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important; }

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important; }

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important; }

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important; }

.bg-gradient {
  background-image: var(--bs-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: var(--bs-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important; }

.rounded-2 {
  border-radius: var(--bs-border-radius) !important; }

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important; }

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important; }

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important; }

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important; }

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; }

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important; }

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important; }

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important; }

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important; }

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

.z-n1 {
  z-index: -1 !important; }

.z-0 {
  z-index: 0 !important; }

.z-1 {
  z-index: 1 !important; }

.z-2 {
  z-index: 2 !important; }

.z-3 {
  z-index: 3 !important; }

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important; }
  .float-sm-end {
    float: right !important; }
  .float-sm-none {
    float: none !important; }
  .object-fit-sm-contain {
    object-fit: contain !important; }
  .object-fit-sm-cover {
    object-fit: cover !important; }
  .object-fit-sm-fill {
    object-fit: fill !important; }
  .object-fit-sm-scale {
    object-fit: scale-down !important; }
  .object-fit-sm-none {
    object-fit: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-inline-grid {
    display: inline-grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  .me-sm-0 {
    margin-right: 0 !important; }
  .me-sm-1 {
    margin-right: 0.25rem !important; }
  .me-sm-2 {
    margin-right: 0.5rem !important; }
  .me-sm-3 {
    margin-right: 1rem !important; }
  .me-sm-4 {
    margin-right: 1.5rem !important; }
  .me-sm-5 {
    margin-right: 3rem !important; }
  .me-sm-auto {
    margin-right: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  .ms-sm-0 {
    margin-left: 0 !important; }
  .ms-sm-1 {
    margin-left: 0.25rem !important; }
  .ms-sm-2 {
    margin-left: 0.5rem !important; }
  .ms-sm-3 {
    margin-left: 1rem !important; }
  .ms-sm-4 {
    margin-left: 1.5rem !important; }
  .ms-sm-5 {
    margin-left: 3rem !important; }
  .ms-sm-auto {
    margin-left: auto !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-sm-n1 {
    margin-top: -0.25rem !important; }
  .mt-sm-n2 {
    margin-top: -0.5rem !important; }
  .mt-sm-n3 {
    margin-top: -1rem !important; }
  .mt-sm-n4 {
    margin-top: -1.5rem !important; }
  .mt-sm-n5 {
    margin-top: -3rem !important; }
  .me-sm-n1 {
    margin-right: -0.25rem !important; }
  .me-sm-n2 {
    margin-right: -0.5rem !important; }
  .me-sm-n3 {
    margin-right: -1rem !important; }
  .me-sm-n4 {
    margin-right: -1.5rem !important; }
  .me-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-sm-n3 {
    margin-bottom: -1rem !important; }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-sm-n5 {
    margin-bottom: -3rem !important; }
  .ms-sm-n1 {
    margin-left: -0.25rem !important; }
  .ms-sm-n2 {
    margin-left: -0.5rem !important; }
  .ms-sm-n3 {
    margin-left: -1rem !important; }
  .ms-sm-n4 {
    margin-left: -1.5rem !important; }
  .ms-sm-n5 {
    margin-left: -3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  .pe-sm-0 {
    padding-right: 0 !important; }
  .pe-sm-1 {
    padding-right: 0.25rem !important; }
  .pe-sm-2 {
    padding-right: 0.5rem !important; }
  .pe-sm-3 {
    padding-right: 1rem !important; }
  .pe-sm-4 {
    padding-right: 1.5rem !important; }
  .pe-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  .ps-sm-0 {
    padding-left: 0 !important; }
  .ps-sm-1 {
    padding-left: 0.25rem !important; }
  .ps-sm-2 {
    padding-left: 0.5rem !important; }
  .ps-sm-3 {
    padding-left: 1rem !important; }
  .ps-sm-4 {
    padding-left: 1.5rem !important; }
  .ps-sm-5 {
    padding-left: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .row-gap-sm-0 {
    row-gap: 0 !important; }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important; }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important; }
  .row-gap-sm-3 {
    row-gap: 1rem !important; }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important; }
  .row-gap-sm-5 {
    row-gap: 3rem !important; }
  .column-gap-sm-0 {
    column-gap: 0 !important; }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important; }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important; }
  .column-gap-sm-3 {
    column-gap: 1rem !important; }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important; }
  .column-gap-sm-5 {
    column-gap: 3rem !important; }
  .text-sm-start {
    text-align: left !important; }
  .text-sm-end {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .float-md-start {
    float: left !important; }
  .float-md-end {
    float: right !important; }
  .float-md-none {
    float: none !important; }
  .object-fit-md-contain {
    object-fit: contain !important; }
  .object-fit-md-cover {
    object-fit: cover !important; }
  .object-fit-md-fill {
    object-fit: fill !important; }
  .object-fit-md-scale {
    object-fit: scale-down !important; }
  .object-fit-md-none {
    object-fit: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-inline-grid {
    display: inline-grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  .me-md-0 {
    margin-right: 0 !important; }
  .me-md-1 {
    margin-right: 0.25rem !important; }
  .me-md-2 {
    margin-right: 0.5rem !important; }
  .me-md-3 {
    margin-right: 1rem !important; }
  .me-md-4 {
    margin-right: 1.5rem !important; }
  .me-md-5 {
    margin-right: 3rem !important; }
  .me-md-auto {
    margin-right: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  .ms-md-0 {
    margin-left: 0 !important; }
  .ms-md-1 {
    margin-left: 0.25rem !important; }
  .ms-md-2 {
    margin-left: 0.5rem !important; }
  .ms-md-3 {
    margin-left: 1rem !important; }
  .ms-md-4 {
    margin-left: 1.5rem !important; }
  .ms-md-5 {
    margin-left: 3rem !important; }
  .ms-md-auto {
    margin-left: auto !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-md-n1 {
    margin-top: -0.25rem !important; }
  .mt-md-n2 {
    margin-top: -0.5rem !important; }
  .mt-md-n3 {
    margin-top: -1rem !important; }
  .mt-md-n4 {
    margin-top: -1.5rem !important; }
  .mt-md-n5 {
    margin-top: -3rem !important; }
  .me-md-n1 {
    margin-right: -0.25rem !important; }
  .me-md-n2 {
    margin-right: -0.5rem !important; }
  .me-md-n3 {
    margin-right: -1rem !important; }
  .me-md-n4 {
    margin-right: -1.5rem !important; }
  .me-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-md-n3 {
    margin-bottom: -1rem !important; }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-md-n5 {
    margin-bottom: -3rem !important; }
  .ms-md-n1 {
    margin-left: -0.25rem !important; }
  .ms-md-n2 {
    margin-left: -0.5rem !important; }
  .ms-md-n3 {
    margin-left: -1rem !important; }
  .ms-md-n4 {
    margin-left: -1.5rem !important; }
  .ms-md-n5 {
    margin-left: -3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  .pe-md-0 {
    padding-right: 0 !important; }
  .pe-md-1 {
    padding-right: 0.25rem !important; }
  .pe-md-2 {
    padding-right: 0.5rem !important; }
  .pe-md-3 {
    padding-right: 1rem !important; }
  .pe-md-4 {
    padding-right: 1.5rem !important; }
  .pe-md-5 {
    padding-right: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  .ps-md-0 {
    padding-left: 0 !important; }
  .ps-md-1 {
    padding-left: 0.25rem !important; }
  .ps-md-2 {
    padding-left: 0.5rem !important; }
  .ps-md-3 {
    padding-left: 1rem !important; }
  .ps-md-4 {
    padding-left: 1.5rem !important; }
  .ps-md-5 {
    padding-left: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .row-gap-md-0 {
    row-gap: 0 !important; }
  .row-gap-md-1 {
    row-gap: 0.25rem !important; }
  .row-gap-md-2 {
    row-gap: 0.5rem !important; }
  .row-gap-md-3 {
    row-gap: 1rem !important; }
  .row-gap-md-4 {
    row-gap: 1.5rem !important; }
  .row-gap-md-5 {
    row-gap: 3rem !important; }
  .column-gap-md-0 {
    column-gap: 0 !important; }
  .column-gap-md-1 {
    column-gap: 0.25rem !important; }
  .column-gap-md-2 {
    column-gap: 0.5rem !important; }
  .column-gap-md-3 {
    column-gap: 1rem !important; }
  .column-gap-md-4 {
    column-gap: 1.5rem !important; }
  .column-gap-md-5 {
    column-gap: 3rem !important; }
  .text-md-start {
    text-align: left !important; }
  .text-md-end {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important; }
  .float-lg-end {
    float: right !important; }
  .float-lg-none {
    float: none !important; }
  .object-fit-lg-contain {
    object-fit: contain !important; }
  .object-fit-lg-cover {
    object-fit: cover !important; }
  .object-fit-lg-fill {
    object-fit: fill !important; }
  .object-fit-lg-scale {
    object-fit: scale-down !important; }
  .object-fit-lg-none {
    object-fit: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-inline-grid {
    display: inline-grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  .me-lg-0 {
    margin-right: 0 !important; }
  .me-lg-1 {
    margin-right: 0.25rem !important; }
  .me-lg-2 {
    margin-right: 0.5rem !important; }
  .me-lg-3 {
    margin-right: 1rem !important; }
  .me-lg-4 {
    margin-right: 1.5rem !important; }
  .me-lg-5 {
    margin-right: 3rem !important; }
  .me-lg-auto {
    margin-right: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  .ms-lg-0 {
    margin-left: 0 !important; }
  .ms-lg-1 {
    margin-left: 0.25rem !important; }
  .ms-lg-2 {
    margin-left: 0.5rem !important; }
  .ms-lg-3 {
    margin-left: 1rem !important; }
  .ms-lg-4 {
    margin-left: 1.5rem !important; }
  .ms-lg-5 {
    margin-left: 3rem !important; }
  .ms-lg-auto {
    margin-left: auto !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-lg-n1 {
    margin-top: -0.25rem !important; }
  .mt-lg-n2 {
    margin-top: -0.5rem !important; }
  .mt-lg-n3 {
    margin-top: -1rem !important; }
  .mt-lg-n4 {
    margin-top: -1.5rem !important; }
  .mt-lg-n5 {
    margin-top: -3rem !important; }
  .me-lg-n1 {
    margin-right: -0.25rem !important; }
  .me-lg-n2 {
    margin-right: -0.5rem !important; }
  .me-lg-n3 {
    margin-right: -1rem !important; }
  .me-lg-n4 {
    margin-right: -1.5rem !important; }
  .me-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-lg-n3 {
    margin-bottom: -1rem !important; }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-lg-n5 {
    margin-bottom: -3rem !important; }
  .ms-lg-n1 {
    margin-left: -0.25rem !important; }
  .ms-lg-n2 {
    margin-left: -0.5rem !important; }
  .ms-lg-n3 {
    margin-left: -1rem !important; }
  .ms-lg-n4 {
    margin-left: -1.5rem !important; }
  .ms-lg-n5 {
    margin-left: -3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  .pe-lg-0 {
    padding-right: 0 !important; }
  .pe-lg-1 {
    padding-right: 0.25rem !important; }
  .pe-lg-2 {
    padding-right: 0.5rem !important; }
  .pe-lg-3 {
    padding-right: 1rem !important; }
  .pe-lg-4 {
    padding-right: 1.5rem !important; }
  .pe-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  .ps-lg-0 {
    padding-left: 0 !important; }
  .ps-lg-1 {
    padding-left: 0.25rem !important; }
  .ps-lg-2 {
    padding-left: 0.5rem !important; }
  .ps-lg-3 {
    padding-left: 1rem !important; }
  .ps-lg-4 {
    padding-left: 1.5rem !important; }
  .ps-lg-5 {
    padding-left: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .row-gap-lg-0 {
    row-gap: 0 !important; }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important; }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important; }
  .row-gap-lg-3 {
    row-gap: 1rem !important; }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important; }
  .row-gap-lg-5 {
    row-gap: 3rem !important; }
  .column-gap-lg-0 {
    column-gap: 0 !important; }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important; }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important; }
  .column-gap-lg-3 {
    column-gap: 1rem !important; }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important; }
  .column-gap-lg-5 {
    column-gap: 3rem !important; }
  .text-lg-start {
    text-align: left !important; }
  .text-lg-end {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important; }
  .float-xl-end {
    float: right !important; }
  .float-xl-none {
    float: none !important; }
  .object-fit-xl-contain {
    object-fit: contain !important; }
  .object-fit-xl-cover {
    object-fit: cover !important; }
  .object-fit-xl-fill {
    object-fit: fill !important; }
  .object-fit-xl-scale {
    object-fit: scale-down !important; }
  .object-fit-xl-none {
    object-fit: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-inline-grid {
    display: inline-grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  .me-xl-0 {
    margin-right: 0 !important; }
  .me-xl-1 {
    margin-right: 0.25rem !important; }
  .me-xl-2 {
    margin-right: 0.5rem !important; }
  .me-xl-3 {
    margin-right: 1rem !important; }
  .me-xl-4 {
    margin-right: 1.5rem !important; }
  .me-xl-5 {
    margin-right: 3rem !important; }
  .me-xl-auto {
    margin-right: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  .ms-xl-0 {
    margin-left: 0 !important; }
  .ms-xl-1 {
    margin-left: 0.25rem !important; }
  .ms-xl-2 {
    margin-left: 0.5rem !important; }
  .ms-xl-3 {
    margin-left: 1rem !important; }
  .ms-xl-4 {
    margin-left: 1.5rem !important; }
  .ms-xl-5 {
    margin-left: 3rem !important; }
  .ms-xl-auto {
    margin-left: auto !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xl-n3 {
    margin-top: -1rem !important; }
  .mt-xl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xl-n5 {
    margin-top: -3rem !important; }
  .me-xl-n1 {
    margin-right: -0.25rem !important; }
  .me-xl-n2 {
    margin-right: -0.5rem !important; }
  .me-xl-n3 {
    margin-right: -1rem !important; }
  .me-xl-n4 {
    margin-right: -1.5rem !important; }
  .me-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xl-n3 {
    margin-left: -1rem !important; }
  .ms-xl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xl-n5 {
    margin-left: -3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  .pe-xl-0 {
    padding-right: 0 !important; }
  .pe-xl-1 {
    padding-right: 0.25rem !important; }
  .pe-xl-2 {
    padding-right: 0.5rem !important; }
  .pe-xl-3 {
    padding-right: 1rem !important; }
  .pe-xl-4 {
    padding-right: 1.5rem !important; }
  .pe-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  .ps-xl-0 {
    padding-left: 0 !important; }
  .ps-xl-1 {
    padding-left: 0.25rem !important; }
  .ps-xl-2 {
    padding-left: 0.5rem !important; }
  .ps-xl-3 {
    padding-left: 1rem !important; }
  .ps-xl-4 {
    padding-left: 1.5rem !important; }
  .ps-xl-5 {
    padding-left: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .row-gap-xl-0 {
    row-gap: 0 !important; }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xl-3 {
    row-gap: 1rem !important; }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xl-5 {
    row-gap: 3rem !important; }
  .column-gap-xl-0 {
    column-gap: 0 !important; }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xl-3 {
    column-gap: 1rem !important; }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xl-5 {
    column-gap: 3rem !important; }
  .text-xl-start {
    text-align: left !important; }
  .text-xl-end {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important; }
  .float-xxl-end {
    float: right !important; }
  .float-xxl-none {
    float: none !important; }
  .object-fit-xxl-contain {
    object-fit: contain !important; }
  .object-fit-xxl-cover {
    object-fit: cover !important; }
  .object-fit-xxl-fill {
    object-fit: fill !important; }
  .object-fit-xxl-scale {
    object-fit: scale-down !important; }
  .object-fit-xxl-none {
    object-fit: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-inline-grid {
    display: inline-grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  .me-xxl-0 {
    margin-right: 0 !important; }
  .me-xxl-1 {
    margin-right: 0.25rem !important; }
  .me-xxl-2 {
    margin-right: 0.5rem !important; }
  .me-xxl-3 {
    margin-right: 1rem !important; }
  .me-xxl-4 {
    margin-right: 1.5rem !important; }
  .me-xxl-5 {
    margin-right: 3rem !important; }
  .me-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  .ms-xxl-0 {
    margin-left: 0 !important; }
  .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  .ms-xxl-3 {
    margin-left: 1rem !important; }
  .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  .ms-xxl-5 {
    margin-left: 3rem !important; }
  .ms-xxl-auto {
    margin-left: auto !important; }
  .m-xxl-n1 {
    margin: -0.25rem !important; }
  .m-xxl-n2 {
    margin: -0.5rem !important; }
  .m-xxl-n3 {
    margin: -1rem !important; }
  .m-xxl-n4 {
    margin: -1.5rem !important; }
  .m-xxl-n5 {
    margin: -3rem !important; }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xxl-n3 {
    margin-top: -1rem !important; }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xxl-n5 {
    margin-top: -3rem !important; }
  .me-xxl-n1 {
    margin-right: -0.25rem !important; }
  .me-xxl-n2 {
    margin-right: -0.5rem !important; }
  .me-xxl-n3 {
    margin-right: -1rem !important; }
  .me-xxl-n4 {
    margin-right: -1.5rem !important; }
  .me-xxl-n5 {
    margin-right: -3rem !important; }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xxl-n3 {
    margin-left: -1rem !important; }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xxl-n5 {
    margin-left: -3rem !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  .pe-xxl-0 {
    padding-right: 0 !important; }
  .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  .pe-xxl-3 {
    padding-right: 1rem !important; }
  .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  .pe-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  .ps-xxl-0 {
    padding-left: 0 !important; }
  .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  .ps-xxl-3 {
    padding-left: 1rem !important; }
  .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  .ps-xxl-5 {
    padding-left: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .row-gap-xxl-0 {
    row-gap: 0 !important; }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xxl-3 {
    row-gap: 1rem !important; }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xxl-5 {
    row-gap: 3rem !important; }
  .column-gap-xxl-0 {
    column-gap: 0 !important; }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xxl-3 {
    column-gap: 1rem !important; }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xxl-5 {
    column-gap: 3rem !important; }
  .text-xxl-start {
    text-align: left !important; }
  .text-xxl-end {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.03125rem !important; }
  .fs-2 {
    font-size: 1.625rem !important; }
  .fs-3 {
    font-size: 1.42188rem !important; }
  .fs-5 {
    font-size: 1.01562rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-inline-grid {
    display: inline-grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

:root {
  --bs-header-bg:                              #fff;
  --bs-header-item-color:                      #555b6d;
  --bs-header-dark-bg:                         #2a3042;
  --bs-header-dark-item-color:                 #e9ecef;
  --bs-topbar-search-bg:                       #f3f3f9;
  --bs-footer-bg:                              #f2f2f5;
  --bs-footer-color:                           #74788d;
  --bs-topnav-bg:                              #fff;
  --bs-menu-item-color:                        #545a6d;
  --bs-menu-item-active-color:                 #556ee6;
  --bs-boxed-body-bg:                          #ebebf4;
  --bs-display-none:                           none;
  --bs-display-block:                          block; }

[data-bs-theme="dark"] {
  --bs-header-bg:                              #262b3c;
  --bs-header-item-color:                      #a6b0cf;
  --bs-header-dark-bg:                         #556ee6;
  --bs-header-dark-item-color:                 #e9ecef;
  --bs-topbar-search-bg:                       #2a3042;
  --bs-footer-bg:                              #262b3c;
  --bs-footer-color:                           #a6b0cf;
  --bs-topnav-bg:                              #282e3f;
  --bs-menu-item-color:                        #a6b0cf;
  --bs-menu-item-active-color:                 #556ee6;
  --bs-boxed-body-bg:                          #32394f;
  --bs-light:                                      #32394e;
  --bs-light-rgb:                                  50, 57, 78;
  --bs-dark:                                       #f6f6f6;
  --bs-dark-rgb:                                   246, 246, 246;
  --bs-display-none:                           block;
  --bs-display-block:                          none; }
  [data-bs-theme="dark"] .btn-light {
    --bs-btn-color:                                         #c3cbe4;
    --bs-btn-bg:                                            #32394e;
    --bs-btn-border-color:                                  #32394e; }
  [data-bs-theme="dark"] .btn-outline-light {
    --bs-btn-color:                                         #c3cbe4;
    --bs-btn-border-color:                                  #32394e; }
  [data-bs-theme="dark"] .btn-light,
  [data-bs-theme="dark"] .btn-outline-light {
    --bs-btn-hover-color:                        #c3cbe4;
    --bs-btn-hover-bg:                           #32394e;
    --bs-btn-hover-border-color:                 #32394e;
    --bs-btn-active-color:                       #c3cbe4;
    --bs-btn-active-bg:                          #32394e;
    --bs-btn-active-border-color:                #32394e;
    --bs-btn-focus-shadow-rgb:                   50, 57, 78; }
  [data-bs-theme="dark"] .btn-dark {
    --bs-btn-bg:                                 #a6b0cf;
    --bs-btn-border-color:                       #a6b0cf;
    --bs-btn-hover-bg:                           #a6b0cf; }
  [data-bs-theme="dark"] .btn-outline-dark {
    --bs-btn-color:                              #a6b0cf;
    --bs-btn-border-color:                       #a6b0cf; }
  [data-bs-theme="dark"] .dropdown-menu {
    --bs-dropdown-border-width:                  1px; }
  [data-bs-theme="dark"] .table-light {
    --bs-table-color:                                   #a6b0cf;
    --bs-table-bg:                                      #32394e;
    --bs-table-border-color:                            #32394e; }
  [data-bs-theme="dark"] .table-dark {
    --bs-table-color:                                   #a6b0cf;
    --bs-table-bg:                                      #32394e;
    --bs-table-border-color:                            #3a425a; }

/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%; }

a {
  text-decoration: none !important; }

label {
  font-weight: 500;
  margin-bottom: 0.5rem; }

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--bs-border-color); }

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--bs-border-color);
  text-align: right; }

@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1140px; } }

.row > * {
  position: relative; }

.badge[href]:hover, .badge[href]:focus {
  color: var(--bs-secondary-bg); }

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: #435fe3 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18) !important; }
  .badge-soft-primary[href]:hover, .badge-soft-primary[href]:focus {
    color: #556ee6;
    text-decoration: none;
    background-color: rgba(85, 110, 230, 0.4); }

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: #6b6e82 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18) !important; }
  .badge-soft-secondary[href]:hover, .badge-soft-secondary[href]:focus {
    color: #74788d;
    text-decoration: none;
    background-color: rgba(116, 120, 141, 0.4); }

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: #30b383 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18) !important; }
  .badge-soft-success[href]:hover, .badge-soft-success[href]:focus {
    color: #34c38f;
    text-decoration: none;
    background-color: rgba(52, 195, 143, 0.4); }

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: #3d9bef !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18) !important; }
  .badge-soft-info[href]:hover, .badge-soft-info[href]:focus {
    color: #50a5f1;
    text-decoration: none;
    background-color: rgba(80, 165, 241, 0.4); }

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: #f0ac39 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18) !important; }
  .badge-soft-warning[href]:hover, .badge-soft-warning[href]:focus {
    color: #f1b44c;
    text-decoration: none;
    background-color: rgba(241, 180, 76, 0.4); }

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: #f35757 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18) !important; }
  .badge-soft-danger[href]:hover, .badge-soft-danger[href]:focus {
    color: #f46a6a;
    text-decoration: none;
    background-color: rgba(244, 106, 106, 0.4); }

.badge.bg-pink[href]:hover, .badge.bg-pink[href]:focus {
  background-color: #e62c81 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.18) !important; }
  .badge-soft-pink[href]:hover, .badge-soft-pink[href]:focus {
    color: #e83e8c;
    text-decoration: none;
    background-color: rgba(232, 62, 140, 0.4); }

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: #e1e7f0 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.18) !important; }
  .badge-soft-light[href]:hover, .badge-soft-light[href]:focus {
    color: #eff2f7;
    text-decoration: none;
    background-color: rgba(239, 242, 247, 0.4); }

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: #2b3035 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18) !important; }
  .badge-soft-dark[href]:hover, .badge-soft-dark[href]:focus {
    color: #343a40;
    text-decoration: none;
    background-color: rgba(52, 58, 64, 0.4); }

.rounded-pill {
  padding-right: .6em;
  padding-left: .6em; }

.badge.bg-dark {
  color: var(--bs-light); }

button,
a {
  outline: none !important; }

.btn-primary {
  background-color: #18293F; }
  .btn-primary:hover {
    background-color: #31537e; }

.btn-rounded {
  border-radius: 30px; }

.btn:focus {
  box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), 0.5); }

.btn-group-example .btn {
  position: relative; }
  .btn-group-example .btn:first-child::before {
    display: none; }
  .btn-group-example .btn:before {
    content: "OR";
    position: absolute;
    font-size: 10px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    background-color: var(--bs-secondary-color);
    color: var(--bs-secondary-bg);
    border: 1px solid var(--bs-secondary-bg);
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1; }

.btn-label {
  position: relative;
  padding-left: 44px; }
  .btn-label .label-icon {
    position: absolute;
    width: 32px;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.1);
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .btn-label.btn-light .label-icon {
    background-color: rgba(52, 58, 64, 0.1);
    border-right: 1px solid rgba(52, 58, 64, 0.2); }

.btn-group-vertical label {
  margin-bottom: 0px; }

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active {
    color: #fff;
    background-color: #556ee6;
    border-color: transparent; }

.btn-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active {
    color: #fff;
    background-color: #74788d;
    border-color: transparent; }

.btn-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active {
    color: #fff;
    background-color: #34c38f;
    border-color: transparent; }

.btn-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active {
    color: #fff;
    background-color: #50a5f1;
    border-color: transparent; }

.btn-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active {
    color: #fff;
    background-color: #f1b44c;
    border-color: transparent; }

.btn-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active {
    color: #fff;
    background-color: #f46a6a;
    border-color: transparent; }

.btn-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-pink:hover, .btn-soft-pink:focus, .btn-soft-pink:active {
    color: #fff;
    background-color: #e83e8c;
    border-color: transparent; }

.btn-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active {
    color: #fff;
    background-color: #eff2f7;
    border-color: transparent; }

.btn-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.1);
  border-color: transparent;
  transition: all 0.5s ease; }
  .btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active {
    color: #fff;
    background-color: #343a40;
    border-color: transparent; }

.like-btn.active .bx-heart {
  color: #f46a6a; }
  .like-btn.active .bx-heart:before {
    content: "\\ec8f"; }

.breadcrumb-item > a {
  color: var(--bs-emphasis-color); }

.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons"; }

.card {
  margin-bottom: 24px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }

.card-drop {
  color: var(--bs-body-color); }

.card-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 600;
  color: var(--bs-emphasis-color); }

.card-title-desc {
  color: var(--bs-secondary-color);
  margin-bottom: 24px; }

.dropdown-menu {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  z-index: 1000; }
  .dropdown-menu.show {
    top: 100% !important; }

.dropdown-menu-end[style] {
  left: auto !important;
  right: 0 !important; }

.dropdown-menu[data-popper-placement^="right"],
.dropdown-menu[data-popper-placement^="top"],
.dropdown-menu[data-popper-placement^="left"] {
  top: auto !important;
  animation: none !important; }

@keyframes DropDownSlide {
  100% {
    transform: translateY(0); }
  0% {
    transform: translateY(10px); } }

@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px; }
  .dropdown-menu-md {
    width: 240px; } }

.dropdown-mega {
  position: static !important; }

.dropdown-megamenu[style] {
  padding: 20px;
  left: 20px !important;
  right: 20px !important; }

.dropdown-mega-menu-xl {
  width: 40rem; }

.dropdown-mega-menu-lg {
  width: 26rem; }

.dropdown-toggle:after {
  display: none !important; }

.dropstart .dropdown-toggle:before {
  display: none !important; }

.nav-tabs > li > a, .nav-pills > li > a {
  color: var(--bs-emphasis-color);
  font-weight: 500; }

.nav-pills > a {
  color: var(--bs-emphasis-color);
  font-weight: 500; }

.nav-tabs-custom {
  border-bottom: 2px solid var(--bs-border-color); }
  .nav-tabs-custom .nav-item {
    position: relative;
    color: var(--bs-body-color); }
    .nav-tabs-custom .nav-item .nav-link {
      border: none; }
      .nav-tabs-custom .nav-item .nav-link::after {
        content: "";
        background: #556ee6;
        height: 2px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -1px;
        transition: all 250ms ease 0s;
        transform: scale(0); }
      .nav-tabs-custom .nav-item .nav-link.active {
        color: #556ee6; }
        .nav-tabs-custom .nav-item .nav-link.active:after {
          transform: scale(1); }

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px; }
  .vertical-nav .nav .nav-link .nav-icon {
    font-size: 24px; }

.table th {
  font-weight: 600; }

.table-dark > :not(:last-child) > :last-child > * {
  border-bottom-color: #43494e; }

.table-bordered {
  border: var(--bs-border-width) solid var(--bs-border-color); }

.table-nowrap th, .table-nowrap td {
  white-space: nowrap; }

.table > :not(:first-child) {
  border-top: 0; }

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px; }

.progress-sm {
  height: 5px; }

.progress-md {
  height: 8px; }

.progress-lg {
  height: 12px; }

.progress-xl {
  height: 16px; }

.custom-progess {
  position: relative; }
  .custom-progess .progress-icon {
    position: absolute;
    top: -12px; }
    .custom-progess .progress-icon .avatar-title {
      background: var(--bs-secondary-bg); }

.animated-progess {
  position: relative; }
  .animated-progess .progress-bar {
    position: relative;
    border-radius: 6px;
    animation: animate-positive 2s; }

@keyframes animate-positive {
  0% {
    width: 0; } }

/*
Template Name: Skote - Admin & Dashboard Template
Author: Themesbrand
Version: 4.1.0.
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Main Css File
*/
/* =============================Custom Variables========================== */
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 250px;
  z-index: 1002;
  background-color: var(--bs-header-bg);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  @media (max-width: 992.98px) {
    #page-topbar {
      left: 0; } }

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 calc(24px * 0.5) 0 0; }
  .navbar-header .dropdown .show.header-item {
    background-color: var(--bs-tertiary-bg); }

.navbar-brand-box {
  padding: 0 1.5rem;
  text-align: center;
  width: 250px; }

.logo {
  line-height: 70px; }
  .logo .logo-sm {
    display: none; }

.logo-light {
  display: none; }

/* Search */
.app-search {
  padding: calc(32px * 0.5) 0; }
  .app-search .form-control {
    border: none;
    height: 38px;
    padding-left: 40px;
    padding-right: 20px;
    background-color: var(--bs-topbar-search-bg);
    box-shadow: none;
    border-radius: 30px; }
  .app-search span {
    position: absolute;
    z-index: 10;
    font-size: 16px;
    line-height: 38px;
    left: 13px;
    top: 0;
    color: var(--bs-secondary-color); }

.megamenu-list li {
  position: relative;
  padding: 5px 0px; }
  .megamenu-list li a {
    color: var(--bs-body-color); }

@media (max-width: 992px) {
  .navbar-brand-box {
    width: auto; }
  .logo span.logo-lg {
    display: none; }
  .logo span.logo-sm {
    display: inline-block; } }

.page-content {
  padding: calc(70px + 24px) calc(24px * 0.75) 60px calc(24px * 0.75); }

.header-item {
  height: 70px;
  box-shadow: none !important;
  color: var(--bs-header-item-color);
  border: 0;
  border-radius: 0px; }
  .header-item:hover {
    color: var(--bs-header-item-color); }

.header-profile-user {
  height: 36px;
  width: 36px;
  background-color: var(--bs-tertiary-bg);
  padding: 3px; }

.noti-icon i {
  font-size: 22px;
  color: var(--bs-header-item-color); }

.noti-icon .badge {
  position: absolute;
  top: 12px;
  right: 4px; }

.notification-item .d-flex {
  padding: 0.75rem 1rem; }
  .notification-item .d-flex:hover {
    background-color: var(--bs-tertiary-bg); }

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: var(--bs-secondary-color); }
  .dropdown-icon-item img {
    height: 24px; }
  .dropdown-icon-item span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .dropdown-icon-item:hover {
    border-color: var(--bs-border-color); }

.fullscreen-enable [data-bs-toggle="fullscreen"] .bx-fullscreen::before {
  content: "\\ea3f"; }

body[data-topbar="dark"] #page-topbar {
  background-color: #2a3042; }

body[data-topbar="dark"] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.05); }

body[data-topbar="dark"] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

body[data-topbar="dark"] .header-item {
  color: var(--bs-header-dark-item-color); }
  body[data-topbar="dark"] .header-item:hover {
    color: var(--bs-header-dark-item-color); }

body[data-topbar="dark"] .header-profile-user {
  background-color: rgba(255, 255, 255, 0.25); }

body[data-topbar="dark"] .noti-icon i {
  color: var(--bs-header-dark-item-color); }

body[data-topbar="dark"] .logo-dark {
  display: none; }

body[data-topbar="dark"] .logo-light {
  display: block; }

body[data-topbar="dark"] .app-search .form-control {
  background-color: rgba(var(--bs-topbar-search-bg), 0.07);
  color: #fff; }

body[data-topbar="dark"] .app-search span,
body[data-topbar="dark"] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5); }

body[data-sidebar="dark"] .navbar-brand-box {
  background: #2a3042; }

body[data-sidebar="dark"] .logo-dark {
  display: none; }

body[data-sidebar="dark"] .logo-light {
  display: block; }

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static; }
    .navbar-header .dropdown .dropdown-menu {
      left: 10px !important;
      right: 10px !important; } }

@media (max-width: 380px) {
  .navbar-brand-box {
    display: none; } }

body[data-layout="horizontal"] .navbar-brand-box {
  width: auto; }

body[data-layout="horizontal"] .page-content {
  margin-top: 70px;
  padding: calc(55px + 24px) calc(24px * 0.5) 60px calc(24px * 0.5); }

@media (max-width: 992px) {
  body[data-layout="horizontal"] .page-content {
    margin-top: 15px; } }

.page-title-box {
  padding-bottom: 24px; }
  .page-title-box .breadcrumb {
    background-color: transparent;
    padding: 0; }
  .page-title-box h4, .page-title-box .h4 {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px !important; }

.footer {
  bottom: 0;
  padding: 20px calc(24px * 0.75);
  position: absolute;
  right: 0;
  color: var(--bs-footer-color);
  left: 250px;
  height: 60px;
  background-color: var(--bs-footer-bg); }
  @media (max-width: 991.98px) {
    .footer {
      left: 0; } }

.vertical-collpsed .footer {
  left: 70px; }
  @media (max-width: 991.98px) {
    .vertical-collpsed .footer {
      left: 0; } }

body[data-layout="horizontal"] .footer {
  left: 0 !important; }

.right-bar {
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0; }
  .right-bar .right-bar-toggle {
    background-color: var(--bs-dark);
    height: 24px;
    width: 24px;
    line-height: 24px;
    display: block;
    color: var(--bs-gray-200);
    text-align: center;
    border-radius: 50%; }
    .right-bar .right-bar-toggle:hover {
      background-color: var(--bs-dark); }

.rightbar-overlay {
  background-color: rgba(52, 58, 64, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all .2s ease-out; }

.right-bar-enabled .right-bar {
  right: 0; }

.right-bar-enabled .rightbar-overlay {
  display: block; }

@media (max-width: 767.98px) {
  .right-bar {
    overflow: auto; }
    .right-bar .slimscroll-menu {
      height: auto !important; } }

.metismenu {
  margin: 0; }
  .metismenu li {
    display: block;
    width: 100%; }
  .metismenu .mm-collapse {
    display: none; }
    .metismenu .mm-collapse:not(.mm-show) {
      display: none; }
    .metismenu .mm-collapse.mm-show {
      display: block; }
  .metismenu .mm-collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition-timing-function: ease;
    transition-duration: .35s;
    transition-property: height, visibility; }

.vertical-menu {
  width: 250px;
  z-index: 1001;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  padding-top: 70px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  @media (max-width: 991.98px) {
    .vertical-menu {
      top: 70px;
      padding-top: 0px; } }
  .vertical-menu .navbar-brand-box {
    position: fixed;
    top: 0px;
    z-index: 99; }
    @media (max-width: 991.98px) {
      .vertical-menu .navbar-brand-box {
        display: none; } }

.main-content {
  margin-left: 250px;
  overflow: hidden; }
  .main-content .content {
    padding: 0 15px 10px 15px;
    margin-top: 70px; }

#sidebar-menu {
  padding: 10px 0 30px 0; }
  #sidebar-menu .mm-active > .has-arrow:after {
    transform: rotate(-180deg); }
  #sidebar-menu .has-arrow:after {
    content: "\\F0140";
    font-family: 'Material Design Icons';
    display: block;
    float: right;
    transition: transform .2s;
    font-size: 1rem; }
  #sidebar-menu ul li a {
    display: block;
    padding: .625rem 1.5rem;
    color: #545a6d;
    position: relative;
    font-size: 13px;
    transition: all .4s; }
    #sidebar-menu ul li a i {
      display: inline-block;
      min-width: 1.75rem;
      padding-bottom: .125em;
      font-size: 1.25rem;
      line-height: 1.40625rem;
      vertical-align: middle;
      color: #7f8387;
      transition: all .4s; }
    #sidebar-menu ul li a:hover {
      color: #383c40; }
      #sidebar-menu ul li a:hover i {
        color: #383c40; }
  #sidebar-menu ul li .badge {
    margin-top: 4px; }
  #sidebar-menu ul li ul.sub-menu {
    padding: 0; }
    #sidebar-menu ul li ul.sub-menu li a {
      padding: .4rem 1.5rem .4rem 3.5rem;
      font-size: 13px;
      color: #545a6d; }
      #sidebar-menu ul li ul.sub-menu li a:hover {
        color: #383c40; }
    #sidebar-menu ul li ul.sub-menu li ul.sub-menu {
      padding: 0; }
      #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
        padding: .4rem 1.5rem .4rem 4.5rem;
        font-size: 13px; }

.menu-title {
  padding: 12px 20px !important;
  letter-spacing: .05em;
  pointer-events: none;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: #7f8387;
  font-weight: 600; }

.mm-active {
  color: #556ee6 !important; }
  .mm-active > a {
    color: #556ee6 !important; }
    .mm-active > a i {
      color: #556ee6 !important; }
  .mm-active .active {
    color: #556ee6 !important; }
    .mm-active .active i {
      color: #556ee6 !important; }
  .mm-active > i {
    color: #556ee6 !important; }

@media (max-width: 992px) {
  .vertical-menu {
    display: none; }
  .main-content {
    margin-left: 0 !important; }
  body.sidebar-enable .vertical-menu {
    display: block; } }

.vertical-collpsed .main-content {
  margin-left: 70px; }

.vertical-collpsed .navbar-brand-box {
  width: 70px !important; }

.vertical-collpsed #page-topbar {
  left: 70px; }
  @media (max-width: 991.98px) {
    .vertical-collpsed #page-topbar {
      left: 0; } }

.vertical-collpsed .logo span.logo-lg {
  display: none; }

.vertical-collpsed .logo span.logo-sm {
  display: block; }

.vertical-collpsed .vertical-menu {
  position: absolute;
  width: 70px !important;
  z-index: 5; }
  .vertical-collpsed .vertical-menu .simplebar-mask,
  .vertical-collpsed .vertical-menu .simplebar-content-wrapper {
    overflow: visible !important; }
  .vertical-collpsed .vertical-menu .simplebar-scrollbar {
    display: none !important; }
  .vertical-collpsed .vertical-menu .simplebar-offset {
    bottom: 0 !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .menu-title,
  .vertical-collpsed .vertical-menu #sidebar-menu .badge,
  .vertical-collpsed .vertical-menu #sidebar-menu .collapse.in {
    display: none !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .nav.collapse {
    height: inherit !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .has-arrow:after {
    display: none; }
  .vertical-collpsed .vertical-menu #sidebar-menu > ul > li {
    position: relative;
    white-space: nowrap; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a {
      padding: 15px 20px;
      min-height: 55px;
      transition: none; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:active, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:focus {
        color: #383c40; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
        font-size: 1.45rem;
        margin-left: 4px; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a span {
        display: none;
        padding-left: 25px; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
      position: relative;
      width: calc(190px + 70px);
      color: #556ee6;
      background-color: whitesmoke;
      transition: none; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
        color: #556ee6; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a span {
        display: inline; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul {
      display: block;
      left: 70px;
      position: absolute;
      width: 190px;
      height: auto !important;
      box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1); }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul ul {
        box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1); }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
        box-shadow: none;
        padding: 8px 20px;
        position: relative;
        width: 190px;
        z-index: 6;
        color: #545a6d; }
        .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
          color: #383c40; }
  .vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
    padding: 5px 0;
    z-index: 9999;
    display: none;
    background-color: #ffffff; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li:hover > ul {
      display: block;
      left: 190px;
      height: auto !important;
      margin-top: -36px;
      position: absolute;
      width: 190px; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li > a span.pull-right {
      position: absolute;
      right: 20px;
      top: 12px;
      transform: rotate(270deg); }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li.active a {
      color: #f8f9fa; }

body[data-sidebar="dark"] .vertical-menu {
  background: #2a3042; }

body[data-sidebar="dark"] #sidebar-menu ul li a {
  color: #a6b0cf; }
  body[data-sidebar="dark"] #sidebar-menu ul li a i {
    color: #6a7187; }
  body[data-sidebar="dark"] #sidebar-menu ul li a:hover {
    color: #ffffff; }
    body[data-sidebar="dark"] #sidebar-menu ul li a:hover i {
      color: #ffffff; }

body[data-sidebar="dark"] #sidebar-menu ul li ul.sub-menu li a {
  color: #79829c; }
  body[data-sidebar="dark"] #sidebar-menu ul li ul.sub-menu li a:hover {
    color: #ffffff; }

body[data-sidebar="dark"].vertical-collpsed {
  min-height: 1760px; }
  body[data-sidebar="dark"].vertical-collpsed .vertical-menu .navbar-brand-box {
    background: #2a3042; }
  body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
    background: #2e3548;
    color: #ffffff; }
    body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
      color: #ffffff; }
  body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
    color: #79829c; }
    body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
      color: #ffffff; }
  body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
    background-color: #2a3042; }
  body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
    color: #ffffff !important; }
    body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {
      color: #ffffff !important; }

body[data-sidebar="dark"] .mm-active {
  color: #ffffff !important; }
  body[data-sidebar="dark"] .mm-active > a {
    color: #ffffff !important; }
    body[data-sidebar="dark"] .mm-active > a i {
      color: #ffffff !important; }
  body[data-sidebar="dark"] .mm-active > i {
    color: #ffffff !important; }
  body[data-sidebar="dark"] .mm-active .active {
    color: #ffffff !important; }
    body[data-sidebar="dark"] .mm-active .active i {
      color: #ffffff !important; }

body[data-sidebar="dark"] .menu-title {
  color: #6a7187; }

body[data-layout="horizontal"] .main-content {
  margin-left: 0 !important; }

body[data-sidebar-size="small"] .navbar-brand-box {
  width: 160px; }

body[data-sidebar-size="small"] .vertical-menu {
  width: 160px;
  text-align: center; }
  body[data-sidebar-size="small"] .vertical-menu .has-arrow:after,
  body[data-sidebar-size="small"] .vertical-menu .badge {
    display: none !important; }

body[data-sidebar-size="small"] .main-content {
  margin-left: 160px; }

body[data-sidebar-size="small"] .footer {
  left: 160px; }
  @media (max-width: 991.98px) {
    body[data-sidebar-size="small"] .footer {
      left: 0; } }

body[data-sidebar-size="small"] #page-topbar {
  left: 160px; }
  @media (max-width: 991.98px) {
    body[data-sidebar-size="small"] #page-topbar {
      left: 0; }
      body[data-sidebar-size="small"] #page-topbar .navbar-header .navbar-brand-box {
        width: auto; } }

body[data-sidebar-size="small"] #sidebar-menu ul li a i {
  display: block; }

body[data-sidebar-size="small"] #sidebar-menu ul li ul.sub-menu li a {
  padding-left: 1.5rem; }

body[data-sidebar-size="small"] #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding-left: 1.5rem; }

body[data-sidebar-size="small"].vertical-collpsed .main-content {
  margin-left: 70px; }

body[data-sidebar-size="small"].vertical-collpsed .vertical-menu #sidebar-menu {
  text-align: left; }
  body[data-sidebar-size="small"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
    display: inline-block; }

body[data-sidebar-size="small"].vertical-collpsed .footer {
  left: 70px; }

body[data-sidebar="colored"] .navbar-brand-box .logo-dark,
body[data-sidebar="winter"] .navbar-brand-box .logo-dark,
body[data-sidebar="ladylip"] .navbar-brand-box .logo-dark,
body[data-sidebar="plumplate"] .navbar-brand-box .logo-dark,
body[data-sidebar="strongbliss"] .navbar-brand-box .logo-dark,
body[data-sidebar="greatwhale"] .navbar-brand-box .logo-dark {
  display: none; }

body[data-sidebar="colored"] .navbar-brand-box .logo-light,
body[data-sidebar="winter"] .navbar-brand-box .logo-light,
body[data-sidebar="ladylip"] .navbar-brand-box .logo-light,
body[data-sidebar="plumplate"] .navbar-brand-box .logo-light,
body[data-sidebar="strongbliss"] .navbar-brand-box .logo-light,
body[data-sidebar="greatwhale"] .navbar-brand-box .logo-light {
  display: block; }

body[data-sidebar="colored"] .mm-active,
body[data-sidebar="winter"] .mm-active,
body[data-sidebar="ladylip"] .mm-active,
body[data-sidebar="plumplate"] .mm-active,
body[data-sidebar="strongbliss"] .mm-active,
body[data-sidebar="greatwhale"] .mm-active {
  color: #fff !important; }
  body[data-sidebar="colored"] .mm-active > a,
  body[data-sidebar="winter"] .mm-active > a,
  body[data-sidebar="ladylip"] .mm-active > a,
  body[data-sidebar="plumplate"] .mm-active > a,
  body[data-sidebar="strongbliss"] .mm-active > a,
  body[data-sidebar="greatwhale"] .mm-active > a {
    color: #fff !important; }
    body[data-sidebar="colored"] .mm-active > a i,
    body[data-sidebar="winter"] .mm-active > a i,
    body[data-sidebar="ladylip"] .mm-active > a i,
    body[data-sidebar="plumplate"] .mm-active > a i,
    body[data-sidebar="strongbliss"] .mm-active > a i,
    body[data-sidebar="greatwhale"] .mm-active > a i {
      color: #fff !important; }
  body[data-sidebar="colored"] .mm-active > i,
  body[data-sidebar="colored"] .mm-active .active,
  body[data-sidebar="winter"] .mm-active > i,
  body[data-sidebar="winter"] .mm-active .active,
  body[data-sidebar="ladylip"] .mm-active > i,
  body[data-sidebar="ladylip"] .mm-active .active,
  body[data-sidebar="plumplate"] .mm-active > i,
  body[data-sidebar="plumplate"] .mm-active .active,
  body[data-sidebar="strongbliss"] .mm-active > i,
  body[data-sidebar="strongbliss"] .mm-active .active,
  body[data-sidebar="greatwhale"] .mm-active > i,
  body[data-sidebar="greatwhale"] .mm-active .active {
    color: #fff !important; }

body[data-sidebar="colored"] #sidebar-menu ul li.menu-title,
body[data-sidebar="winter"] #sidebar-menu ul li.menu-title,
body[data-sidebar="ladylip"] #sidebar-menu ul li.menu-title,
body[data-sidebar="plumplate"] #sidebar-menu ul li.menu-title,
body[data-sidebar="strongbliss"] #sidebar-menu ul li.menu-title,
body[data-sidebar="greatwhale"] #sidebar-menu ul li.menu-title {
  color: rgba(255, 255, 255, 0.6); }

body[data-sidebar="colored"] #sidebar-menu ul li a,
body[data-sidebar="winter"] #sidebar-menu ul li a,
body[data-sidebar="ladylip"] #sidebar-menu ul li a,
body[data-sidebar="plumplate"] #sidebar-menu ul li a,
body[data-sidebar="strongbliss"] #sidebar-menu ul li a,
body[data-sidebar="greatwhale"] #sidebar-menu ul li a {
  color: rgba(255, 255, 255, 0.6); }
  body[data-sidebar="colored"] #sidebar-menu ul li a i,
  body[data-sidebar="winter"] #sidebar-menu ul li a i,
  body[data-sidebar="ladylip"] #sidebar-menu ul li a i,
  body[data-sidebar="plumplate"] #sidebar-menu ul li a i,
  body[data-sidebar="strongbliss"] #sidebar-menu ul li a i,
  body[data-sidebar="greatwhale"] #sidebar-menu ul li a i {
    color: rgba(255, 255, 255, 0.6); }
  body[data-sidebar="colored"] #sidebar-menu ul li a.waves-effect .waves-ripple,
  body[data-sidebar="winter"] #sidebar-menu ul li a.waves-effect .waves-ripple,
  body[data-sidebar="ladylip"] #sidebar-menu ul li a.waves-effect .waves-ripple,
  body[data-sidebar="plumplate"] #sidebar-menu ul li a.waves-effect .waves-ripple,
  body[data-sidebar="strongbliss"] #sidebar-menu ul li a.waves-effect .waves-ripple,
  body[data-sidebar="greatwhale"] #sidebar-menu ul li a.waves-effect .waves-ripple {
    background: rgba(255, 255, 255, 0.1); }
  body[data-sidebar="colored"] #sidebar-menu ul li a:hover,
  body[data-sidebar="winter"] #sidebar-menu ul li a:hover,
  body[data-sidebar="ladylip"] #sidebar-menu ul li a:hover,
  body[data-sidebar="plumplate"] #sidebar-menu ul li a:hover,
  body[data-sidebar="strongbliss"] #sidebar-menu ul li a:hover,
  body[data-sidebar="greatwhale"] #sidebar-menu ul li a:hover {
    color: #fff; }
    body[data-sidebar="colored"] #sidebar-menu ul li a:hover i,
    body[data-sidebar="winter"] #sidebar-menu ul li a:hover i,
    body[data-sidebar="ladylip"] #sidebar-menu ul li a:hover i,
    body[data-sidebar="plumplate"] #sidebar-menu ul li a:hover i,
    body[data-sidebar="strongbliss"] #sidebar-menu ul li a:hover i,
    body[data-sidebar="greatwhale"] #sidebar-menu ul li a:hover i {
      color: #fff; }

body[data-sidebar="colored"] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar="winter"] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar="ladylip"] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar="plumplate"] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar="strongbliss"] #sidebar-menu ul li ul.sub-menu li a,
body[data-sidebar="greatwhale"] #sidebar-menu ul li ul.sub-menu li a {
  color: rgba(255, 255, 255, 0.5); }
  body[data-sidebar="colored"] #sidebar-menu ul li ul.sub-menu li a:hover,
  body[data-sidebar="winter"] #sidebar-menu ul li ul.sub-menu li a:hover,
  body[data-sidebar="ladylip"] #sidebar-menu ul li ul.sub-menu li a:hover,
  body[data-sidebar="plumplate"] #sidebar-menu ul li ul.sub-menu li a:hover,
  body[data-sidebar="strongbliss"] #sidebar-menu ul li ul.sub-menu li a:hover,
  body[data-sidebar="greatwhale"] #sidebar-menu ul li ul.sub-menu li a:hover {
    color: #fff; }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a,
body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: #5e76e7;
  color: #fff; }
  body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
  body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
  body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
  body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
  body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i,
  body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
    color: #fff; }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active,
body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active {
  color: #556ee6 !important; }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover,
body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover {
  color: #556ee6; }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active,
body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active {
  color: #556ee6 !important; }
  body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
  body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
  body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
  body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
  body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
  body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a {
    color: #556ee6 !important; }
    body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
    body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
    body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
    body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
    body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i,
    body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a i {
      color: #556ee6 !important; }

.bg-colored {
  background-color: #556ee6 !important; }

body[data-sidebar="colored"] .vertical-menu {
  background-color: #556ee6; }

@media (max-width: 991.98px) {
  body[data-sidebar="colored"] .navbar-brand-box {
    background-color: #5e76e7;
    background-repeat: repeat-x; } }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-color: #556ee6; }

body[data-sidebar="colored"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: #5e76e7; }

body[data-sidebar="colored"][data-sidebar-size="small"] .menu-title {
  background: transparent; }

.vertical-menu [data-simplebar] {
  z-index: 9; }

body[data-sidebar="winter"] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x; }

@media (max-width: 991.98px) {
  body[data-sidebar="winter"] .navbar-brand-box {
    background-image: linear-gradient(to right, #556ee6, #34c38f);
    background-repeat: repeat-x; } }

body[data-sidebar="winter"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x; }

body[data-sidebar="winter"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x; }

body[data-sidebar="winter"][data-sidebar-size="small"] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #34c38f); }

body[data-sidebar="ladylip"] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x; }

@media (max-width: 991.98px) {
  body[data-sidebar="ladylip"] .navbar-brand-box {
    background-image: linear-gradient(to right, #556ee6, #f46a6a);
    background-repeat: repeat-x; } }

body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x; }

body[data-sidebar="ladylip"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x; }

body[data-sidebar="ladylip"][data-sidebar-size="small"] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #f46a6a); }

body[data-sidebar="plumplate"] .vertical-menu {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x; }

@media (max-width: 991.98px) {
  body[data-sidebar="plumplate"] .navbar-brand-box {
    background-image: linear-gradient(to right, #556ee6, #f1b44c);
    background-repeat: repeat-x; } }

body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x; }

body[data-sidebar="plumplate"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #556ee6, #f1b44c);
  background-repeat: repeat-x; }

body[data-sidebar="plumplate"][data-sidebar-size="small"] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #f1b44c); }

body[data-sidebar="strongbliss"] .vertical-menu {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x; }

@media (max-width: 991.98px) {
  body[data-sidebar="strongbliss"] .navbar-brand-box {
    background-image: linear-gradient(to right, #f46a6a, #f1b44c);
    background-repeat: repeat-x; } }

body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x; }

body[data-sidebar="strongbliss"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c);
  background-repeat: repeat-x; }

body[data-sidebar="strongbliss"][data-sidebar-size="small"] .menu-title {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c); }

body[data-sidebar="greatwhale"] .vertical-menu {
  background-image: linear-gradient(to right, #1f3dd0, #50a5f1);
  background-repeat: repeat-x; }

@media (max-width: 991.98px) {
  body[data-sidebar="greatwhale"] .navbar-brand-box {
    background-image: linear-gradient(to right, #556ee6, #50a5f1);
    background-repeat: repeat-x; } }

body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu .navbar-brand-box {
  background-image: linear-gradient(to right, #1f3dd0, #50a5f1);
  background-repeat: repeat-x; }

body[data-sidebar="greatwhale"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-image: linear-gradient(to right, #1f3dd0, #50a5f1);
  background-repeat: repeat-x; }

body[data-sidebar="greatwhale"][data-sidebar-size="small"] .menu-title {
  background-image: linear-gradient(to right, #556ee6, #50a5f1); }

.themesideimage {
  height: 80px;
  width: 40px; }

body[data-sidebar-image] .vertical-menu:before {
  opacity: 0.33;
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2; }

body[data-sidebar-image] .vertical-menu:after {
  opacity: 0.77;
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2; }

body[data-sidebar-image] .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07; }

body[data-sidebar-image="img1"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___}); }

body[data-sidebar-image="img2"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___}); }

body[data-sidebar-image="img3"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___}); }

body[data-sidebar-image="img4"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___}); }

.verticalcontent {
  writing-mode: vertical-rl;
  text-orientation: upright;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #343a40 !important; }

.wh-30 {
  width: 30px;
  height: 30px; }

.gradient-colored {
  background-color: #556ee6; }

.gradient-winter {
  background-image: linear-gradient(to right, #556ee6, #34c38f);
  background-repeat: repeat-x; }

.gradient-lady-lip {
  background-image: linear-gradient(to right, #556ee6, #f46a6a);
  background-repeat: repeat-x; }

.gradient-plum-plate {
  background-image: linear-gradient(to right, #556ee6, #f1b44c); }

.gradient-strong-bliss {
  background-image: linear-gradient(to right, #f46a6a, #f1b44c); }

.gradient-strong-great-whale {
  background-image: linear-gradient(to right, #2948df, #50a5f1); }

.topnav {
  background: var(--bs-topnav-bg);
  padding: 0 calc(24px * 0.5);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100; }
  .topnav .topnav-menu {
    margin: 0;
    padding: 0; }
  .topnav .navbar-nav .nav-link {
    font-size: 14px;
    position: relative;
    padding: 1rem 1.3rem;
    color: var(--bs-menu-item-color); }
    .topnav .navbar-nav .nav-link i {
      font-size: 15px; }
    .topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
      color: var(--bs-menu-item-active-color);
      background-color: transparent; }
  .topnav .navbar-nav .dropdown-item {
    color: var(--bs-menu-item-color); }
    .topnav .navbar-nav .dropdown-item.active, .topnav .navbar-nav .dropdown-item:hover {
      color: var(--bs-menu-item-active-color); }
  .topnav .navbar-nav .nav-item .nav-link.active {
    color: var(--bs-menu-item-active-color); }
  .topnav .navbar-nav .dropdown.active > a {
    color: var(--bs-menu-item-active-color);
    background-color: transparent; }

body[data-layout="horizontal"] #page-topbar {
  left: 0; }

@media (min-width: 1200px) {
  body[data-layout="horizontal"] .container-fluid, body[data-layout="horizontal"] .container-sm, body[data-layout="horizontal"] .container-md, body[data-layout="horizontal"] .container-lg, body[data-layout="horizontal"] .container-xl, body[data-layout="horizontal"] .container-xxl,
  body[data-layout="horizontal"] .navbar-header {
    max-width: 85%; } }

@media (min-width: 992px) {
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0; }
  .topnav .dropdown-item {
    padding: .5rem 1.5rem;
    min-width: 180px; }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto; }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 var(--bs-border-radius) var(--bs-border-radius); }
    .topnav .dropdown .dropdown-menu .arrow-down::after {
      right: 15px;
      transform: rotate(-135deg) translateY(-50%);
      position: absolute; }
    .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
      position: absolute;
      top: 0 !important;
      left: 100%;
      display: none; }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block; }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block; }
  .navbar-toggle {
    display: none; } }

.arrow-down {
  display: inline-block; }
  .arrow-down:after {
    border-color: initial;
    border-style: solid;
    border-width: 0 0 1px 1px;
    content: "";
    height: .4em;
    display: inline-block;
    right: 5px;
    top: 50%;
    margin-left: 10px;
    transform: rotate(-45deg) translateY(-50%);
    transform-origin: top;
    transition: all .3s ease-out;
    width: .4em; }

@media (max-width: 1199.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto; } }

@media (max-width: 991.98px) {
  .navbar-brand-box .logo-dark {
    display: var(--bs-display-block); }
    .navbar-brand-box .logo-dark span.logo-sm {
      display: var(--bs-display-block); }
  .navbar-brand-box .logo-light {
    display: var(--bs-display-none); }
  .topnav {
    max-height: 360px;
    overflow-y: auto;
    padding: 0; }
    .topnav .navbar-nav .nav-link {
      padding: 0.75rem 1.1rem; }
    .topnav .dropdown .dropdown-menu {
      background-color: transparent;
      border: none;
      box-shadow: none;
      padding-left: 15px; }
      .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl {
        width: auto; }
        .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl .row {
          margin: 0px; }
    .topnav .dropdown .dropdown-item {
      position: relative;
      background-color: transparent; }
      .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
        color: #556ee6; }
    .topnav .arrow-down::after {
      right: 15px;
      position: absolute; } }

@media (min-width: 992px) {
  body[data-layout="horizontal"][data-topbar="light"] .navbar-brand-box .logo-dark {
    display: var(--bs-display-block); }
  body[data-layout="horizontal"][data-topbar="light"] .navbar-brand-box .logo-light {
    display: var(--bs-display-none); }
  body[data-layout="horizontal"][data-topbar="light"] .topnav {
    background-color: #556ee6; }
    body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link {
      color: rgba(255, 255, 255, 0.6); }
      body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link:focus, body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link:hover {
        color: rgba(255, 255, 255, 0.9); }
    body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav > .dropdown.active > a {
      color: rgba(255, 255, 255, 0.9) !important; } }

body[data-layout="horizontal"][data-topbar="colored"] #page-topbar {
  background-color: #556ee6;
  box-shadow: none; }

body[data-layout="horizontal"][data-topbar="colored"] .logo-dark {
  display: none; }

body[data-layout="horizontal"][data-topbar="colored"] .logo-light {
  display: block; }

body[data-layout="horizontal"][data-topbar="colored"] .app-search .form-control {
  background-color: rgba(var(--bs-topbar-search-bg), 0.07);
  color: #fff; }

body[data-layout="horizontal"][data-topbar="colored"] .app-search span,
body[data-layout="horizontal"][data-topbar="colored"] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5); }

body[data-layout="horizontal"][data-topbar="colored"] .header-item {
  color: var(--bs-header-dark-item-color); }
  body[data-layout="horizontal"][data-topbar="colored"] .header-item:hover {
    color: var(--bs-header-dark-item-color); }

body[data-layout="horizontal"][data-topbar="colored"] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.1); }

body[data-layout="horizontal"][data-topbar="colored"] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

body[data-layout="horizontal"][data-topbar="colored"] .noti-icon i {
  color: var(--bs-header-dark-item-color); }

@media (min-width: 992px) {
  body[data-layout="horizontal"][data-topbar="colored"] .topnav {
    background-color: #556ee6; }
    body[data-layout="horizontal"][data-topbar="colored"] .topnav .navbar-nav .nav-link {
      color: rgba(255, 255, 255, 0.6); }
      body[data-layout="horizontal"][data-topbar="colored"] .topnav .navbar-nav .nav-link:focus, body[data-layout="horizontal"][data-topbar="colored"] .topnav .navbar-nav .nav-link:hover {
        color: rgba(255, 255, 255, 0.9); }
    body[data-layout="horizontal"][data-topbar="colored"] .topnav .navbar-nav > .dropdown.active > a {
      color: rgba(255, 255, 255, 0.9) !important; } }

body[data-layout-size="boxed"] {
  background-color: var(--bs-boxed-body-bg); }
  body[data-layout-size="boxed"] #layout-wrapper {
    background-color: var(--bs-body-bg);
    max-width: 1300px;
    margin: 0 auto;
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  body[data-layout-size="boxed"] #page-topbar {
    max-width: calc(1300px - 250px);
    margin: 0 auto; }
  body[data-layout-size="boxed"] .footer {
    margin: 0 auto;
    max-width: calc(1300px - 250px); }
  body[data-layout-size="boxed"].vertical-collpsed .footer {
    max-width: calc(1300px - 70px); }
  body[data-layout-size="boxed"][data-sidebar-size="small"] #page-topbar {
    max-width: calc(1300px - 160px); }
    @media (max-width: 991.98px) {
      body[data-layout-size="boxed"][data-sidebar-size="small"] #page-topbar {
        left: 0; } }
  body[data-layout-size="boxed"] .footer {
    margin: 0 auto;
    max-width: calc(1300px - 250px); }
  body[data-layout-size="boxed"].vertical-collpsed .footer {
    max-width: calc(1300px - 70px); }

body[data-layout="horizontal"][data-layout-size="boxed"] #page-topbar,
body[data-layout="horizontal"][data-layout-size="boxed"] #layout-wrapper,
body[data-layout="horizontal"][data-layout-size="boxed"] .footer {
  max-width: 100%; }

body[data-layout="horizontal"][data-layout-size="boxed"] .container-fluid, body[data-layout="horizontal"][data-layout-size="boxed"] .container-sm, body[data-layout="horizontal"][data-layout-size="boxed"] .container-md, body[data-layout="horizontal"][data-layout-size="boxed"] .container-lg, body[data-layout="horizontal"][data-layout-size="boxed"] .container-xl, body[data-layout="horizontal"][data-layout-size="boxed"] .container-xxl,
body[data-layout="horizontal"][data-layout-size="boxed"] .navbar-header {
  max-width: 1300px; }

body[data-layout="horizontal"][data-layout-size="boxed"].vertical-collpsed .main-content {
  min-height: auto; }

@media (min-width: 992px) {
  body[data-layout-scrollable="true"] #page-topbar,
  body[data-layout-scrollable="true"] .vertical-menu,
  body[data-layout-scrollable="true"] .navbar-brand-box {
    position: absolute; } }

@media (min-width: 992px) {
  body[data-layout-scrollable="true"][data-layout="horizontal"] #page-topbar,
  body[data-layout-scrollable="true"][data-layout="horizontal"] .topnav {
    position: absolute; }
  body[data-layout-scrollable="true"][data-layout="horizontal"] .navbar-brand-box {
    position: relative; } }

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent; }

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none; }

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%); }

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2); }

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

.waves-notransition {
  transition: none !important; }

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%); }

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1; }

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em; }

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em; }

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom; }

.waves-input-wrapper.waves-button {
  padding: 0; }

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1; }

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%; }

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms; }

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3); }

.waves-block {
  display: block; }

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4); }

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(85, 110, 230, 0.4); }

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(52, 195, 143, 0.4); }

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(80, 165, 241, 0.4); }

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(241, 180, 76, 0.4); }

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(244, 106, 106, 0.4); }

.avatar-xs {
  height: 2rem;
  width: 2rem; }

.avatar-sm {
  height: 3rem;
  width: 3rem !important; }

.avatar-md {
  height: 4.5rem;
  width: 4.5rem; }

.avatar-lg {
  height: 6rem;
  width: 6rem; }

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem; }

.avatar-title {
  align-items: center;
  background-color: #556ee6;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%; }

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap; }
  .avatar-group .avatar-group-item {
    margin-left: -12px;
    border: 2px solid var(--bs-secondary-bg);
    border-radius: 50%;
    transition: all 0.2s; }
    .avatar-group .avatar-group-item:hover {
      position: relative;
      transform: translateY(-2px); }

.custom-accordion .accordion-list {
  display: flex;
  border-radius: 7px;
  background-color: var(--bs-tertiary-bg);
  padding: 12px 20px;
  color: var(--bs-body-color);
  font-weight: 600;
  align-items: center;
  justify-content: space-between; }
  .custom-accordion .accordion-list.collapsed i.accor-plus-icon:before {
    content: "\\F0415"; }
  .custom-accordion .accordion-list .accor-plus-icon {
    display: inline-block;
    font-size: 16px;
    height: 24px;
    width: 24px;
    line-height: 22px;
    background-color: var(--bs-secondary-bg);
    text-align: center;
    border-radius: 50%; }

.custom-accordion a.collapsed i.accor-down-icon:before {
  content: "\\F0140"; }

.custom-accordion .card-body {
  color: var(--prefixsecondary-color); }

.font-size-10 {
  font-size: 10px !important; }

.font-size-11 {
  font-size: 11px !important; }

.font-size-12 {
  font-size: 12px !important; }

.font-size-13 {
  font-size: 13px !important; }

.font-size-14 {
  font-size: 14px !important; }

.font-size-15 {
  font-size: 15px !important; }

.font-size-16 {
  font-size: 16px !important; }

.font-size-17 {
  font-size: 17px !important; }

.font-size-18 {
  font-size: 18px !important; }

.font-size-20 {
  font-size: 20px !important; }

.font-size-22 {
  font-size: 22px !important; }

.font-size-24 {
  font-size: 24px !important; }

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s; }
  .social-list-item:hover {
    color: var(--bs-secondary-color);
    background-color: #eff2f7; }

.w-xs {
  min-width: 80px; }

.w-sm {
  min-width: 95px; }

.w-md {
  min-width: 110px; }

.w-lg {
  min-width: 140px; }

.w-xl {
  min-width: 160px; }

.alert-dismissible .btn-close {
  font-size: 10px;
  padding: 1.05rem 1.25rem; }

.chartjs-chart {
  max-height: 300px; }

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-secondary-bg);
  z-index: 9999; }

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px; }

.spinner-chase {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
  animation: spinner-chase 2.5s infinite linear both; }

.chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: chase-dot 2.0s infinite ease-in-out both; }
  .chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #556ee6;
    border-radius: 100%;
    animation: chase-dot-before 2.0s infinite ease-in-out both; }
  .chase-dot:nth-child(1) {
    animation-delay: -1.1s; }
    .chase-dot:nth-child(1):before {
      animation-delay: -1.1s; }
  .chase-dot:nth-child(2) {
    animation-delay: -1.0s; }
    .chase-dot:nth-child(2):before {
      animation-delay: -1.0s; }
  .chase-dot:nth-child(3) {
    animation-delay: -0.9s; }
    .chase-dot:nth-child(3):before {
      animation-delay: -0.9s; }
  .chase-dot:nth-child(4) {
    animation-delay: -0.8s; }
    .chase-dot:nth-child(4):before {
      animation-delay: -0.8s; }
  .chase-dot:nth-child(5) {
    animation-delay: -0.7s; }
    .chase-dot:nth-child(5):before {
      animation-delay: -0.7s; }
  .chase-dot:nth-child(6) {
    animation-delay: -0.6s; }
    .chase-dot:nth-child(6):before {
      animation-delay: -0.6s; }

@keyframes spinner-chase {
  100% {
    transform: rotate(360deg); } }

@keyframes chase-dot {
  80%, 100% {
    transform: rotate(360deg); } }

@keyframes chase-dot-before {
  50% {
    transform: scale(0.4); }
  100%, 0% {
    transform: scale(1); } }

[type="tel"]::placeholder,
[type="url"]::placeholder,
[type="email"]::placeholder,
[type="number"]::placeholder {
  text-align: left; }

.form-check {
  position: relative;
  text-align: left; }

.form-check-right {
  padding-left: 0;
  display: inline-block;
  padding-right: 1.5em; }
  .form-check-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.5em; }
  .form-check-right .form-check-label {
    display: block; }

.form-checkbox-outline .form-check-input {
  border-width: 2px;
  background-color: var(--bs-secondary-bg); }
  .form-checkbox-outline .form-check-input:active {
    filter: none; }
  .form-checkbox-outline .form-check-input:checked {
    background-color: var(--bs-secondary-bg) !important; }
    .form-checkbox-outline .form-check-input:checked[type=checkbox] {
      background-image: none; }
    .form-checkbox-outline .form-check-input:checked:after {
      position: absolute;
      content: '\\F012C';
      font-family: "Material Design Icons";
      top: -4px !important;
      left: 1px;
      /*rtl: -4px */
      font-size: 16px;
      color: var(--bs-body-color); }

.form-radio-outline .form-check-input {
  background-color: var(--bs-secondary-bg);
  position: relative; }
  .form-radio-outline .form-check-input:active {
    filter: none; }
  .form-radio-outline .form-check-input:checked {
    background-color: var(--bs-secondary-bg) !important; }
    .form-radio-outline .form-check-input:checked[type=checkbox] {
      background-image: none; }
    .form-radio-outline .form-check-input:checked:after {
      position: absolute;
      content: '';
      top: 3px !important;
      left: 3px;
      width: 5px;
      height: 5px;
      border-radius: 50%; }

.form-check-primary .form-check-input:checked {
  background-color: #556ee6;
  border-color: #556ee6; }

.form-radio-primary .form-check-input:checked {
  border-color: #556ee6;
  background-color: #556ee6; }
  .form-radio-primary .form-check-input:checked:after {
    background-color: #556ee6; }

.form-check-secondary .form-check-input:checked {
  background-color: #74788d;
  border-color: #74788d; }

.form-radio-secondary .form-check-input:checked {
  border-color: #74788d;
  background-color: #74788d; }
  .form-radio-secondary .form-check-input:checked:after {
    background-color: #74788d; }

.form-check-success .form-check-input:checked {
  background-color: #34c38f;
  border-color: #34c38f; }

.form-radio-success .form-check-input:checked {
  border-color: #34c38f;
  background-color: #34c38f; }
  .form-radio-success .form-check-input:checked:after {
    background-color: #34c38f; }

.form-check-info .form-check-input:checked {
  background-color: #50a5f1;
  border-color: #50a5f1; }

.form-radio-info .form-check-input:checked {
  border-color: #50a5f1;
  background-color: #50a5f1; }
  .form-radio-info .form-check-input:checked:after {
    background-color: #50a5f1; }

.form-check-warning .form-check-input:checked {
  background-color: #f1b44c;
  border-color: #f1b44c; }

.form-radio-warning .form-check-input:checked {
  border-color: #f1b44c;
  background-color: #f1b44c; }
  .form-radio-warning .form-check-input:checked:after {
    background-color: #f1b44c; }

.form-check-danger .form-check-input:checked {
  background-color: #f46a6a;
  border-color: #f46a6a; }

.form-radio-danger .form-check-input:checked {
  border-color: #f46a6a;
  background-color: #f46a6a; }
  .form-radio-danger .form-check-input:checked:after {
    background-color: #f46a6a; }

.form-check-pink .form-check-input:checked {
  background-color: #e83e8c;
  border-color: #e83e8c; }

.form-radio-pink .form-check-input:checked {
  border-color: #e83e8c;
  background-color: #e83e8c; }
  .form-radio-pink .form-check-input:checked:after {
    background-color: #e83e8c; }

.form-check-light .form-check-input:checked {
  background-color: #eff2f7;
  border-color: #eff2f7; }

.form-radio-light .form-check-input:checked {
  border-color: #eff2f7;
  background-color: #eff2f7; }
  .form-radio-light .form-check-input:checked:after {
    background-color: #eff2f7; }

.form-check-dark .form-check-input:checked {
  background-color: #343a40;
  border-color: #343a40; }

.form-radio-dark .form-check-input:checked {
  border-color: #343a40;
  background-color: #343a40; }
  .form-radio-dark .form-check-input:checked:after {
    background-color: #343a40; }

.form-check,
.form-check-input,
.form-check-label {
  cursor: pointer;
  margin-bottom: 0; }

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 24px;
  line-height: 24px; }
  .form-switch-md .form-check-input {
    width: 40px;
    height: 20px;
    left: -0.5rem;
    position: relative; }
  .form-switch-md .form-check-label {
    vertical-align: middle; }

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px; }
  .form-switch-lg .form-check-input {
    width: 48px;
    height: 24px;
    left: -0.75rem;
    position: relative; }

.input-group-text {
  margin-bottom: 0px; }

.rdl-filter,
.rdl-control {
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color-translucent);
  color: var(--bs-emphasis-color); }

.react-dual-listbox button {
  color: #343a40;
  border-color: #eff2f7;
  background-color: #eff2f7; }

.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background-color: var(--bs-body-bg); }

.rdl-move .form-check-input,
.rdl-move .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___}); }

.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative; }
  .mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
    content: "";
    position: absolute;
    width: 8px;
    height: 54px;
    background-color: rgba(255, 255, 255, 0.1);
    left: 16px;
    transform: rotate(32deg);
    top: -5px;
    transition: all 0.4s; }
  .mini-stats-wid .mini-stat-icon::after {
    left: -12px;
    width: 12px;
    transition: all 0.2s; }

.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px; }

.mfp-popup-form {
  max-width: 1140px; }

.mfp-close {
  color: var(--bs-body-color) !important; }

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block; }

[dir="rtl"] .modal-open {
  padding-left: 0px !important; }

.icon-demo-content {
  text-align: center;
  color: #adb5bd; }
  .icon-demo-content i {
    display: block;
    font-size: 24px;
    margin-bottom: 16px;
    color: var(--prefixsecondary-color);
    transition: all 0.4s; }
  .icon-demo-content .col-lg-4 {
    margin-top: 24px; }
    .icon-demo-content .col-lg-4:hover i {
      color: #556ee6;
      transform: scale(1.5); }

.grid-structure .grid-container {
  background-color: var(--bs-gray-100);
  margin-top: 10px;
  font-size: .8rem;
  font-weight: 500;
  padding: 10px 20px; }

.card-radio {
  background-color: var(--bs-secondary-bg);
  border: 2px solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }
  .card-radio:hover {
    cursor: pointer; }

.card-radio-label {
  display: block; }

.card-radio-input {
  display: none; }
  .card-radio-input:checked + .card-radio {
    border-color: #556ee6 !important; }

.navs-carousel .owl-nav {
  margin-top: 16px; }
  .navs-carousel .owl-nav button {
    width: 30px;
    height: 30px;
    line-height: 28px !important;
    font-size: 20px !important;
    border-radius: 50% !important;
    background-color: rgba(85, 110, 230, 0.25) !important;
    color: #556ee6 !important;
    margin: 4px 8px !important; }

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer {
    display: none !important; }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0; }
  .card {
    border: 0; } }

.badge[href]:hover, .badge[href]:focus {
  color: var(--bs-secondary-bg); }

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: #435fe3 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18) !important; }
  .badge-soft-primary[href]:hover, .badge-soft-primary[href]:focus {
    color: #556ee6;
    text-decoration: none;
    background-color: rgba(85, 110, 230, 0.4); }

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: #6b6e82 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18) !important; }
  .badge-soft-secondary[href]:hover, .badge-soft-secondary[href]:focus {
    color: #74788d;
    text-decoration: none;
    background-color: rgba(116, 120, 141, 0.4); }

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: #30b383 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18) !important; }
  .badge-soft-success[href]:hover, .badge-soft-success[href]:focus {
    color: #34c38f;
    text-decoration: none;
    background-color: rgba(52, 195, 143, 0.4); }

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: #3d9bef !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18) !important; }
  .badge-soft-info[href]:hover, .badge-soft-info[href]:focus {
    color: #50a5f1;
    text-decoration: none;
    background-color: rgba(80, 165, 241, 0.4); }

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: #f0ac39 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18) !important; }
  .badge-soft-warning[href]:hover, .badge-soft-warning[href]:focus {
    color: #f1b44c;
    text-decoration: none;
    background-color: rgba(241, 180, 76, 0.4); }

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: #f35757 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18) !important; }
  .badge-soft-danger[href]:hover, .badge-soft-danger[href]:focus {
    color: #f46a6a;
    text-decoration: none;
    background-color: rgba(244, 106, 106, 0.4); }

.badge.bg-pink[href]:hover, .badge.bg-pink[href]:focus {
  background-color: #e62c81 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.18) !important; }
  .badge-soft-pink[href]:hover, .badge-soft-pink[href]:focus {
    color: #e83e8c;
    text-decoration: none;
    background-color: rgba(232, 62, 140, 0.4); }

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: #e1e7f0 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.18) !important; }
  .badge-soft-light[href]:hover, .badge-soft-light[href]:focus {
    color: #eff2f7;
    text-decoration: none;
    background-color: rgba(239, 242, 247, 0.4); }

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: #2b3035 !important; }

.badge.bg-light {
  color: var(--bs-body-color); }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: var(--bs-body-color); }

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18) !important; }
  .badge-soft-dark[href]:hover, .badge-soft-dark[href]:focus {
    color: #343a40;
    text-decoration: none;
    background-color: rgba(52, 58, 64, 0.4); }

.rounded-pill {
  padding-right: .6em;
  padding-left: .6em; }

.badge.bg-dark {
  color: var(--bs-light); }

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start; }

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit; }

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0; }

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch; }

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important; }

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none; }

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table; }

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none; }

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0; }

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1; }

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden; }

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none; }

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all; }

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 4px;
  min-height: 10px; }

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear; }

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear; }

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px; }

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px; }

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto; }

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0; }

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll; }

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none; }

.custom-scroll {
  height: 100%; }

/* ==============
  Calendar
===================*/
.lnb-calendars-item {
  display: inline-block;
  margin-right: 7px; }

input[type="checkbox"].tui-full-calendar-checkbox-round + span {
  margin-right: 4px;
  margin-left: 0; }

.tui-full-calendar-layout,
.tui-full-calendar-timegrid-timezone {
  background-color: var(--bs-secondary-bg) !important; }

.tui-full-calendar-dayname-container,
.tui-full-calendar-left,
.tui-full-calendar-splitter,
.tui-full-calendar-time-date,
.tui-full-calendar-weekday-grid-line,
.tui-full-calendar-timegrid-timezone,
.tui-full-calendar-timegrid-gridline {
  border-color: var(--bs-border-color) !important; }

.tui-full-calendar-weekday-exceed-in-week {
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 28px;
  border-radius: 4px;
  background-color: var(--bs-custom-white);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color); }

.tui-full-calendar-timegrid-hour {
  color: var(--bs-body-color) !important; }

.tui-full-calendar-weekday-schedule-title {
  color: var(--bs-emphasis-color) !important; }
  .tui-full-calendar-weekday-schedule-title .tui-full-calendar-time-schedule {
    font-weight: 600; }

.tui-full-calendar-popup-container {
  background-color: var(--bs-custom-white) !important;
  border-color: var(--bs-border-color) !important; }

.tui-full-calendar-dropdown:hover .tui-full-calendar-dropdown-button {
  border-color: var(--bs-border-color); }

.tui-full-calendar-popup-section-item:hover, .tui-full-calendar-popup-section-item:focus {
  border-color: var(--bs-border-color); }

.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-fill {
  border-top-color: var(--bs-border-color) !important; }

.tui-full-calendar-arrow-top .tui-full-calendar-popup-arrow-fill {
  border-bottom-color: var(--bs-border-color) !important; }

.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-borde {
  border-bottom-color: var(--bs-border-color) !important; }

.tui-full-calendar-button {
  color: var(--bs-emphasis-color);
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color); }

.tui-full-calendar-popup-section-item {
  border-color: var(--bs-border-color); }

.tui-full-calendar-month-dayname,
.tui-full-calendar-weekday-border {
  border-top-color: var(--bs-border-color) !important; }

.tui-full-calendar-arrow-top .tui-full-calendar-popup-arrow-border {
  border-bottom-color: var(--bs-border-color) !important; }

.tui-full-calendar-dropdown-menu {
  border-color: var(--bs-border-color) !important; }

.tui-full-calendar-dropdown-menu-item,
.tui-full-calendar-dropdown-menu {
  background-color: var(--bs-secondary-bg) !important; }

.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-border {
  border-top-color: var(--bs-border-color); }

.tui-full-calendar-content {
  background-color: var(--bs-secondary-bg) !important;
  color: var(--bs-emphasis-color) !important; }

.tui-full-calendar-confirm {
  background-color: #f46a6a !important;
  color: #fff !important; }
  .tui-full-calendar-confirm:hover {
    background-color: #c35555 !important;
    color: #fff !important; }

.tui-full-calendar-month-dayname-item span {
  color: var(--bs-emphasis-color) !important; }

.tui-full-calendar-weekday-grid-line.tui-full-calendar-near-month-day.tui-full-calendar-extra-date .tui-full-calendar-weekday-grid-header .tui-full-calendar-weekday-grid-date {
  color: var(--bs-secondary-color) !important; }

.tui-full-calendar-weekday-grid-line.tui-full-calendar-near-month-day .tui-full-calendar-weekday-grid-header .tui-full-calendar-weekday-grid-date {
  color: var(--bs-emphasis-color) !important; }

/* ==============
  Calendar
===================*/
.fc td,
.fc th {
  border: var(--bs-border-width) solid var(--bs-border-color); }

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase; }

@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc .fc-toolbar .fc-today-button {
    display: none; } }

.fc .fc-toolbar .btn {
  text-transform: capitalize; }

.fc .fc-col-header-cell-cushion {
  color: var(--bs-body-color); }

.fc .fc-daygrid-day-number {
  color: var(--bs-body-color); }

.fc-daygrid-event-dot {
  display: none; }

.fc-prev-button,
.fc-next-button {
  position: relative;
  padding: 6px 8px !important; }

.fc-toolbar-chunk .fc-button-group .fc-button {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
  box-shadow: none; }
  .fc-toolbar-chunk .fc-button-group .fc-button:hover, .fc-toolbar-chunk .fc-button-group .fc-button.active {
    color: #fff;
    background-color: var(--bs-primary);
    border-color: var(--bs-primary); }

.fc-toolbar-chunk .fc-today-button {
  background-color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important; }

.fc .fc-button-primary:not(:disabled).fc-button-active,
.fc .fc-button-primary:not(:disabled):active {
  background-color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important;
  color: #fff !important; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px; } }

.fc th.fc-widget-header {
  background: #f6f6f6;
  color: #495057;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 600; }

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #f6f6f6; }

.fc-unthemed td.fc-today {
  background: #f6f8fa; }

.fc-button {
  background: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important; }

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #556ee6;
  color: #fff;
  text-shadow: none; }

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
  color: #fff; }
  .fc-event.bg-dark {
    background-color: var(--bs-secondary-color) !important; }
    .fc-event.bg-dark .fc-event-time {
      color: var(--bs-secondary-bg) !important; }
    .fc-event.bg-dark .fc-event-title {
      color: var(--bs-secondary-bg) !important; }

.fc-event,
.fc-event-dot {
  background-color: #556ee6; }

.fc-event .fc-content {
  color: #fff; }

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin-left: 0;
  margin-right: 0; }

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #eff2f7; }

[dir="rtl"] .fc-header-toolbar {
  direction: ltr !important; }

[dir="rtl"] .fc-toolbar > * > :not(:first-child) {
  margin-left: .75em; }

.fc-theme-standard .fc-scrollgrid {
  border-color: var(--bs-border-color); }

.fc .fc-daygrid-week-number {
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color); }

.fc .fc-daygrid-more-link {
  padding: 5px;
  font-size: 11px;
  font-weight: 600; }

.fc .fc-daygrid-more-link:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.1); }

.fc .fc-popover-header {
  padding: 6px 12px; }

.fc-theme-standard .fc-popover-header {
  background: var(--bs-body-bg); }

.fc-theme-standard .fc-popover {
  background: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color); }

/* ==============
  Druafula
===================*/
.task-box {
  border: 1px solid var(--bs-border-color); }

[data-bs-theme=dark] .card .task-box {
  border: 1px solid var(--bs-gray-dark) !important; }

.gu-transit {
  border: 1px dashed var(--bs-border-color) !important;
  background-color: var(--bs-gray-200) !important; }

#session-timeout-dialog .close {
  display: none; }

#session-timeout-dialog .countdown-holder {
  color: #f46a6a;
  font-weight: 500; }

#session-timeout-dialog .btn-default {
  background-color: #fff;
  color: #f46a6a;
  box-shadow: none; }

.irs {
  font-family: var(--bs-font-sans-serif); }

.irs--square {
  cursor: pointer; }
  .irs--square .irs-bar,
  .irs--square .irs-to,
  .irs--square .irs-from,
  .irs--square .irs-single {
    background: #556ee6 !important;
    font-size: 11px; }
  .irs--square .irs-to:before,
  .irs--square .irs-from:before,
  .irs--square .irs-single:before {
    border-top-color: #556ee6; }
  .irs--square .irs-line {
    background: var(--bs-tertiary-bg);
    border-color: var(--bs-tertiary-bg); }
  .irs--square .irs-grid-text {
    font-size: 11px;
    color: var(--bs-secondary-color); }
  .irs--square .irs-min,
  .irs--square .irs-max {
    color: var(--bs-secondary-color);
    background: var(--bs-tertiary-bg);
    font-size: 11px; }
  .irs--square .irs-handle {
    border: 2px solid #556ee6;
    width: 12px;
    height: 12px;
    top: 26px;
    background-color: var(--bs-secondary-bg) !important;
    cursor: pointer; }
    .irs--square .irs-handle:active {
      cursor: pointer; }
  .irs--square .irs-grid-pol {
    background-color: var(--bs-secondary-color); }

.swal2-container .swal2-title {
  font-size: 20px;
  font-weight: 500; }

.swal2-modal {
  font-size: 14px; }

.swal2-icon.swal2-question {
  border-color: #50a5f1;
  color: #50a5f1; }

.swal2-icon.swal2-success [class^="swal2-success-line"] {
  background-color: #34c38f; }

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(52, 195, 143, 0.3); }

.swal2-icon.swal2-warning {
  border-color: #f1b44c;
  color: #f1b44c; }

.swal2-styled:focus {
  box-shadow: none; }

.swal2-progress-steps .swal2-progress-step {
  background: #556ee6; }
  .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
    background: #556ee6; }
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step,
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
      background: rgba(85, 110, 230, 0.3); }

.swal2-progress-steps .swal2-progress-step-line {
  background: #556ee6; }

.swal2-loader {
  border-color: #556ee6 transparent #556ee6 transparent; }

.swal2-popup {
  background: var(--bs-secondary-bg); }

.swal2-title, .swal2-html-container {
  color: var(--bs-emphasis-color); }

.swal2-file,
.swal2-input,
.swal2-textarea {
  border-color: var(--bs-border-color);
  color: var(--bs-body-color); }
  .swal2-file:focus,
  .swal2-input:focus,
  .swal2-textarea:focus {
    box-shadow: none;
    border-color: var(--bs-border-color); }

div:where(.swal2-container) div:where(.swal2-popup) {
  color: var(--bs-secondary-color); }

.symbol {
  border-color: var(--bs-secondary-bg); }

.rating-symbol-background, .rating-symbol-foreground {
  font-size: 24px; }

.symbol-empty {
  background-color: var(--bs-gray-400); }

.rating-symbol-foreground {
  top: 0px; }

.rating-star > span {
  display: inline-block;
  vertical-align: middle; }
  .rating-star > span.badge {
    margin-left: 4px; }

/* =============
   Notification
============= */
#toast-container > div {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  opacity: 1; }
  #toast-container > div:hover {
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
    opacity: 0.9; }

#toast-container.toast-top-full-width > div, #toast-container.toast-bottom-full-width > div {
  min-width: 96%;
  margin: 4px auto; }

.toast-primary {
  border: 2px solid #556ee6 !important;
  background-color: rgba(85, 110, 230, 0.8) !important; }

.toast-secondary {
  border: 2px solid #74788d !important;
  background-color: rgba(116, 120, 141, 0.8) !important; }

.toast-success {
  border: 2px solid #34c38f !important;
  background-color: rgba(52, 195, 143, 0.8) !important; }

.toast-info {
  border: 2px solid #50a5f1 !important;
  background-color: rgba(80, 165, 241, 0.8) !important; }

.toast-warning {
  border: 2px solid #f1b44c !important;
  background-color: rgba(241, 180, 76, 0.8) !important; }

.toast-danger {
  border: 2px solid #f46a6a !important;
  background-color: rgba(244, 106, 106, 0.8) !important; }

.toast-pink {
  border: 2px solid #e83e8c !important;
  background-color: rgba(232, 62, 140, 0.8) !important; }

.toast-light {
  border: 2px solid #eff2f7 !important;
  background-color: rgba(239, 242, 247, 0.8) !important; }

.toast-dark {
  border: 2px solid #343a40 !important;
  background-color: rgba(52, 58, 64, 0.8) !important; }

.toast-error {
  background-color: rgba(244, 106, 106, 0.8);
  border: 2px solid #f46a6a; }

.toastr-options {
  padding: 24px;
  background-color: var(--bs-tertiary-bg);
  margin-bottom: 0;
  border: 1px solid var(--bs-border-color); }

.error {
  color: #f46a6a; }

.parsley-error {
  border-color: #f46a6a; }

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0; }
  .parsley-errors-list.filled {
    display: block; }
  .parsley-errors-list > li {
    font-size: 12px;
    list-style: none;
    color: #f46a6a;
    margin-top: 5px; }

.select2-container .select2-selection--single {
  background-color: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color-translucent);
  height: 38px; }
  .select2-container .select2-selection--single:focus {
    outline: none; }
  .select2-container .select2-selection--single .select2-selection__rendered {
    line-height: 36px;
    padding-left: 0.75rem;
    color: var(--bs-secondary-color); }
  .select2-container .select2-selection--single .select2-selection__arrow {
    height: 34px;
    width: 34px;
    right: 3px; }
    .select2-container .select2-selection--single .select2-selection__arrow b {
      border-color: var(--bs-gray-500) transparent transparent transparent;
      border-width: 6px 6px 0 6px; }
  .select2-container .select2-selection--single .select2-selection__placeholder {
    color: var(--bs-body-color); }

[dir="rtl"] .select2-selection__rendered {
  text-align: end; }

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent var(--bs-gray-500) transparent !important;
  border-width: 0 6px 6px 6px !important; }

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--bs-secondary-bg); }
  .select2-container--default .select2-search--dropdown .select2-search__field {
    border: 1px solid var(--bs-border-color-translucent);
    background-color: var(--bs-secondary-bg);
    color: var(--bs-secondary-color);
    outline: none; }

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #556ee6; }

.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: var(--bs-light);
  color: var(--bs-emphasis-color);
  margin: 0;
  margin-top: 7px; }
  .select2-container--default .select2-results__option[aria-selected="true"]:hover {
    background-color: #556ee6;
    color: #fff; }

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  border-right: none;
  color: var(--bs-emphasis-color); }

.select2-results__option {
  padding: 6px 12px; }

.select2-container[dir="rtl"] .select2-selection--single .select2-selection__rendered {
  padding-left: 0.75rem; }

.select2-dropdown {
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }

.select2-search input {
  border: 1px solid var(--bs-border-color); }

.select2-container .select2-selection--multiple {
  min-height: 38px;
  background-color: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color-translucent) !important; }
  .select2-container .select2-selection--multiple .select2-selection__rendered {
    padding: 2px 0.75rem; }
  .select2-container .select2-selection--multiple .select2-search__field {
    border: 0;
    color: var(--bs-input-color); }
    .select2-container .select2-selection--multiple .select2-search__field::placeholder {
      color: var(--bs-secondary-color); }
  .select2-container .select2-selection--multiple .select2-selection__choice {
    background-color: var(--bs-tertiary-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 1px;
    padding: 0 7px; }
  .select2-container .select2-selection--multiple .select2-selection__rendered {
    padding: 0; }

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: var(--bs-border-color-translucent); }

.select2-container--default .select2-results__group {
  font-weight: 600; }

.select2-container--default .select2-selection--multiple .select2-selection__choice__display {
  padding-left: 16px; }

.select2-result-repository__avatar {
  float: left;
  width: 60px;
  margin-right: 10px; }
  .select2-result-repository__avatar img {
    width: 100%;
    height: auto;
    border-radius: 2px; }

.select2-result-repository__statistics {
  margin-top: 7px; }

.select2-result-repository__forks,
.select2-result-repository__stargazers,
.select2-result-repository__watchers {
  display: inline-block;
  font-size: 11px;
  margin-right: 1em;
  color: var(--bs-gray-500); }
  .select2-result-repository__forks .fa,
  .select2-result-repository__stargazers .fa,
  .select2-result-repository__watchers .fa {
    margin-right: 4px; }
    .select2-result-repository__forks .fa.fa-flash::before,
    .select2-result-repository__stargazers .fa.fa-flash::before,
    .select2-result-repository__watchers .fa.fa-flash::before {
      content: "\\f0e7";
      font-family: "Font Awesome 5 Free"; }

.select2-results__option--highlighted .select2-result-repository__forks,
.select2-results__option--highlighted .select2-result-repository__stargazers,
.select2-results__option--highlighted .select2-result-repository__watchers {
  color: rgba(255, 255, 255, 0.8); }

.select2-result-repository__meta {
  overflow: hidden; }

.img-flag {
  margin-right: 7px;
  height: 15px;
  width: 18px; }

.select2-container--default .select2-results__option--selected {
  background-color: var(--bs-tertiary-bg); }

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fas,
.far,
.fal,
.fad,
.fab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1; }

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.fa-xs {
  font-size: .75em; }

.fa-sm {
  font-size: .875em; }

.fa-1x {
  font-size: 1em; }

.fa-2x {
  font-size: 2em; }

.fa-3x {
  font-size: 3em; }

.fa-4x {
  font-size: 4em; }

.fa-5x {
  font-size: 5em; }

.fa-6x {
  font-size: 6em; }

.fa-7x {
  font-size: 7em; }

.fa-8x {
  font-size: 8em; }

.fa-9x {
  font-size: 9em; }

.fa-10x {
  font-size: 10em; }

.fa-fw {
  text-align: center;
  width: 1.25em; }

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0; }

.fa-ul > li {
  position: relative; }

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit; }

.fa-border {
  border: solid 0.08em #eee;
  border-radius: .1em;
  padding: .2em .25em .15em; }

.fa-pull-left {
  float: left; }

.fa-pull-right {
  float: right; }

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: .3em; }

.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: .3em; }

.fa-spin {
  animation: fa-spin 2s infinite linear; }

.fa-pulse {
  animation: fa-spin 1s infinite steps(8); }

@keyframes fa-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg); }

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg); }

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg); }

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1); }

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1); }

.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1); }

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  filter: none; }

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em; }

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%; }

.fa-stack-1x {
  line-height: inherit; }

.fa-stack-2x {
  font-size: 2em; }

.fa-inverse {
  color: #fff; }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-500px:before {
  content: "\\f26e"; }

.fa-accessible-icon:before {
  content: "\\f368"; }

.fa-accusoft:before {
  content: "\\f369"; }

.fa-acquisitions-incorporated:before {
  content: "\\f6af"; }

.fa-ad:before {
  content: "\\f641"; }

.fa-address-book:before {
  content: "\\f2b9"; }

.fa-address-card:before {
  content: "\\f2bb"; }

.fa-adjust:before {
  content: "\\f042"; }

.fa-adn:before {
  content: "\\f170"; }

.fa-adobe:before {
  content: "\\f778"; }

.fa-adversal:before {
  content: "\\f36a"; }

.fa-affiliatetheme:before {
  content: "\\f36b"; }

.fa-air-freshener:before {
  content: "\\f5d0"; }

.fa-airbnb:before {
  content: "\\f834"; }

.fa-algolia:before {
  content: "\\f36c"; }

.fa-align-center:before {
  content: "\\f037"; }

.fa-align-justify:before {
  content: "\\f039"; }

.fa-align-left:before {
  content: "\\f036"; }

.fa-align-right:before {
  content: "\\f038"; }

.fa-alipay:before {
  content: "\\f642"; }

.fa-allergies:before {
  content: "\\f461"; }

.fa-amazon:before {
  content: "\\f270"; }

.fa-amazon-pay:before {
  content: "\\f42c"; }

.fa-ambulance:before {
  content: "\\f0f9"; }

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3"; }

.fa-amilia:before {
  content: "\\f36d"; }

.fa-anchor:before {
  content: "\\f13d"; }

.fa-android:before {
  content: "\\f17b"; }

.fa-angellist:before {
  content: "\\f209"; }

.fa-angle-double-down:before {
  content: "\\f103"; }

.fa-angle-double-left:before {
  content: "\\f100"; }

.fa-angle-double-right:before {
  content: "\\f101"; }

.fa-angle-double-up:before {
  content: "\\f102"; }

.fa-angle-down:before {
  content: "\\f107"; }

.fa-angle-left:before {
  content: "\\f104"; }

.fa-angle-right:before {
  content: "\\f105"; }

.fa-angle-up:before {
  content: "\\f106"; }

.fa-angry:before {
  content: "\\f556"; }

.fa-angrycreative:before {
  content: "\\f36e"; }

.fa-angular:before {
  content: "\\f420"; }

.fa-ankh:before {
  content: "\\f644"; }

.fa-app-store:before {
  content: "\\f36f"; }

.fa-app-store-ios:before {
  content: "\\f370"; }

.fa-apper:before {
  content: "\\f371"; }

.fa-apple:before {
  content: "\\f179"; }

.fa-apple-alt:before {
  content: "\\f5d1"; }

.fa-apple-pay:before {
  content: "\\f415"; }

.fa-archive:before {
  content: "\\f187"; }

.fa-archway:before {
  content: "\\f557"; }

.fa-arrow-alt-circle-down:before {
  content: "\\f358"; }

.fa-arrow-alt-circle-left:before {
  content: "\\f359"; }

.fa-arrow-alt-circle-right:before {
  content: "\\f35a"; }

.fa-arrow-alt-circle-up:before {
  content: "\\f35b"; }

.fa-arrow-circle-down:before {
  content: "\\f0ab"; }

.fa-arrow-circle-left:before {
  content: "\\f0a8"; }

.fa-arrow-circle-right:before {
  content: "\\f0a9"; }

.fa-arrow-circle-up:before {
  content: "\\f0aa"; }

.fa-arrow-down:before {
  content: "\\f063"; }

.fa-arrow-left:before {
  content: "\\f060"; }

.fa-arrow-right:before {
  content: "\\f061"; }

.fa-arrow-up:before {
  content: "\\f062"; }

.fa-arrows-alt:before {
  content: "\\f0b2"; }

.fa-arrows-alt-h:before {
  content: "\\f337"; }

.fa-arrows-alt-v:before {
  content: "\\f338"; }

.fa-artstation:before {
  content: "\\f77a"; }

.fa-assistive-listening-systems:before {
  content: "\\f2a2"; }

.fa-asterisk:before {
  content: "\\f069"; }

.fa-asymmetrik:before {
  content: "\\f372"; }

.fa-at:before {
  content: "\\f1fa"; }

.fa-atlas:before {
  content: "\\f558"; }

.fa-atlassian:before {
  content: "\\f77b"; }

.fa-atom:before {
  content: "\\f5d2"; }

.fa-audible:before {
  content: "\\f373"; }

.fa-audio-description:before {
  content: "\\f29e"; }

.fa-autoprefixer:before {
  content: "\\f41c"; }

.fa-avianex:before {
  content: "\\f374"; }

.fa-aviato:before {
  content: "\\f421"; }

.fa-award:before {
  content: "\\f559"; }

.fa-aws:before {
  content: "\\f375"; }

.fa-baby:before {
  content: "\\f77c"; }

.fa-baby-carriage:before {
  content: "\\f77d"; }

.fa-backspace:before {
  content: "\\f55a"; }

.fa-backward:before {
  content: "\\f04a"; }

.fa-bacon:before {
  content: "\\f7e5"; }

.fa-bahai:before {
  content: "\\f666"; }

.fa-balance-scale:before {
  content: "\\f24e"; }

.fa-balance-scale-left:before {
  content: "\\f515"; }

.fa-balance-scale-right:before {
  content: "\\f516"; }

.fa-ban:before {
  content: "\\f05e"; }

.fa-band-aid:before {
  content: "\\f462"; }

.fa-bandcamp:before {
  content: "\\f2d5"; }

.fa-barcode:before {
  content: "\\f02a"; }

.fa-bars:before {
  content: "\\f0c9"; }

.fa-baseball-ball:before {
  content: "\\f433"; }

.fa-basketball-ball:before {
  content: "\\f434"; }

.fa-bath:before {
  content: "\\f2cd"; }

.fa-battery-empty:before {
  content: "\\f244"; }

.fa-battery-full:before {
  content: "\\f240"; }

.fa-battery-half:before {
  content: "\\f242"; }

.fa-battery-quarter:before {
  content: "\\f243"; }

.fa-battery-three-quarters:before {
  content: "\\f241"; }

.fa-battle-net:before {
  content: "\\f835"; }

.fa-bed:before {
  content: "\\f236"; }

.fa-beer:before {
  content: "\\f0fc"; }

.fa-behance:before {
  content: "\\f1b4"; }

.fa-behance-square:before {
  content: "\\f1b5"; }

.fa-bell:before {
  content: "\\f0f3"; }

.fa-bell-slash:before {
  content: "\\f1f6"; }

.fa-bezier-curve:before {
  content: "\\f55b"; }

.fa-bible:before {
  content: "\\f647"; }

.fa-bicycle:before {
  content: "\\f206"; }

.fa-biking:before {
  content: "\\f84a"; }

.fa-bimobject:before {
  content: "\\f378"; }

.fa-binoculars:before {
  content: "\\f1e5"; }

.fa-biohazard:before {
  content: "\\f780"; }

.fa-birthday-cake:before {
  content: "\\f1fd"; }

.fa-bitbucket:before {
  content: "\\f171"; }

.fa-bitcoin:before {
  content: "\\f379"; }

.fa-bity:before {
  content: "\\f37a"; }

.fa-black-tie:before {
  content: "\\f27e"; }

.fa-blackberry:before {
  content: "\\f37b"; }

.fa-blender:before {
  content: "\\f517"; }

.fa-blender-phone:before {
  content: "\\f6b6"; }

.fa-blind:before {
  content: "\\f29d"; }

.fa-blog:before {
  content: "\\f781"; }

.fa-blogger:before {
  content: "\\f37c"; }

.fa-blogger-b:before {
  content: "\\f37d"; }

.fa-bluetooth:before {
  content: "\\f293"; }

.fa-bluetooth-b:before {
  content: "\\f294"; }

.fa-bold:before {
  content: "\\f032"; }

.fa-bolt:before {
  content: "\\f0e7"; }

.fa-bomb:before {
  content: "\\f1e2"; }

.fa-bone:before {
  content: "\\f5d7"; }

.fa-bong:before {
  content: "\\f55c"; }

.fa-book:before {
  content: "\\f02d"; }

.fa-book-dead:before {
  content: "\\f6b7"; }

.fa-book-medical:before {
  content: "\\f7e6"; }

.fa-book-open:before {
  content: "\\f518"; }

.fa-book-reader:before {
  content: "\\f5da"; }

.fa-bookmark:before {
  content: "\\f02e"; }

.fa-bootstrap:before {
  content: "\\f836"; }

.fa-border-all:before {
  content: "\\f84c"; }

.fa-border-none:before {
  content: "\\f850"; }

.fa-border-style:before {
  content: "\\f853"; }

.fa-bowling-ball:before {
  content: "\\f436"; }

.fa-box:before {
  content: "\\f466"; }

.fa-box-open:before {
  content: "\\f49e"; }

.fa-box-tissue:before {
  content: "\\f95b"; }

.fa-boxes:before {
  content: "\\f468"; }

.fa-braille:before {
  content: "\\f2a1"; }

.fa-brain:before {
  content: "\\f5dc"; }

.fa-bread-slice:before {
  content: "\\f7ec"; }

.fa-briefcase:before {
  content: "\\f0b1"; }

.fa-briefcase-medical:before {
  content: "\\f469"; }

.fa-broadcast-tower:before {
  content: "\\f519"; }

.fa-broom:before {
  content: "\\f51a"; }

.fa-brush:before {
  content: "\\f55d"; }

.fa-btc:before {
  content: "\\f15a"; }

.fa-buffer:before {
  content: "\\f837"; }

.fa-bug:before {
  content: "\\f188"; }

.fa-building:before {
  content: "\\f1ad"; }

.fa-bullhorn:before {
  content: "\\f0a1"; }

.fa-bullseye:before {
  content: "\\f140"; }

.fa-burn:before {
  content: "\\f46a"; }

.fa-buromobelexperte:before {
  content: "\\f37f"; }

.fa-bus:before {
  content: "\\f207"; }

.fa-bus-alt:before {
  content: "\\f55e"; }

.fa-business-time:before {
  content: "\\f64a"; }

.fa-buy-n-large:before {
  content: "\\f8a6"; }

.fa-buysellads:before {
  content: "\\f20d"; }

.fa-calculator:before {
  content: "\\f1ec"; }

.fa-calendar:before {
  content: "\\f133"; }

.fa-calendar-alt:before {
  content: "\\f073"; }

.fa-calendar-check:before {
  content: "\\f274"; }

.fa-calendar-day:before {
  content: "\\f783"; }

.fa-calendar-minus:before {
  content: "\\f272"; }

.fa-calendar-plus:before {
  content: "\\f271"; }

.fa-calendar-times:before {
  content: "\\f273"; }

.fa-calendar-week:before {
  content: "\\f784"; }

.fa-camera:before {
  content: "\\f030"; }

.fa-camera-retro:before {
  content: "\\f083"; }

.fa-campground:before {
  content: "\\f6bb"; }

.fa-canadian-maple-leaf:before {
  content: "\\f785"; }

.fa-candy-cane:before {
  content: "\\f786"; }

.fa-cannabis:before {
  content: "\\f55f"; }

.fa-capsules:before {
  content: "\\f46b"; }

.fa-car:before {
  content: "\\f1b9"; }

.fa-car-alt:before {
  content: "\\f5de"; }

.fa-car-battery:before {
  content: "\\f5df"; }

.fa-car-crash:before {
  content: "\\f5e1"; }

.fa-car-side:before {
  content: "\\f5e4"; }

.fa-caravan:before {
  content: "\\f8ff"; }

.fa-caret-down:before {
  content: "\\f0d7"; }

.fa-caret-left:before {
  content: "\\f0d9"; }

.fa-caret-right:before {
  content: "\\f0da"; }

.fa-caret-square-down:before {
  content: "\\f150"; }

.fa-caret-square-left:before {
  content: "\\f191"; }

.fa-caret-square-right:before {
  content: "\\f152"; }

.fa-caret-square-up:before {
  content: "\\f151"; }

.fa-caret-up:before {
  content: "\\f0d8"; }

.fa-carrot:before {
  content: "\\f787"; }

.fa-cart-arrow-down:before {
  content: "\\f218"; }

.fa-cart-plus:before {
  content: "\\f217"; }

.fa-cash-register:before {
  content: "\\f788"; }

.fa-cat:before {
  content: "\\f6be"; }

.fa-cc-amazon-pay:before {
  content: "\\f42d"; }

.fa-cc-amex:before {
  content: "\\f1f3"; }

.fa-cc-apple-pay:before {
  content: "\\f416"; }

.fa-cc-diners-club:before {
  content: "\\f24c"; }

.fa-cc-discover:before {
  content: "\\f1f2"; }

.fa-cc-jcb:before {
  content: "\\f24b"; }

.fa-cc-mastercard:before {
  content: "\\f1f1"; }

.fa-cc-paypal:before {
  content: "\\f1f4"; }

.fa-cc-stripe:before {
  content: "\\f1f5"; }

.fa-cc-visa:before {
  content: "\\f1f0"; }

.fa-centercode:before {
  content: "\\f380"; }

.fa-centos:before {
  content: "\\f789"; }

.fa-certificate:before {
  content: "\\f0a3"; }

.fa-chair:before {
  content: "\\f6c0"; }

.fa-chalkboard:before {
  content: "\\f51b"; }

.fa-chalkboard-teacher:before {
  content: "\\f51c"; }

.fa-charging-station:before {
  content: "\\f5e7"; }

.fa-chart-area:before {
  content: "\\f1fe"; }

.fa-chart-bar:before {
  content: "\\f080"; }

.fa-chart-line:before {
  content: "\\f201"; }

.fa-chart-pie:before {
  content: "\\f200"; }

.fa-check:before {
  content: "\\f00c"; }

.fa-check-circle:before {
  content: "\\f058"; }

.fa-check-double:before {
  content: "\\f560"; }

.fa-check-square:before {
  content: "\\f14a"; }

.fa-cheese:before {
  content: "\\f7ef"; }

.fa-chess:before {
  content: "\\f439"; }

.fa-chess-bishop:before {
  content: "\\f43a"; }

.fa-chess-board:before {
  content: "\\f43c"; }

.fa-chess-king:before {
  content: "\\f43f"; }

.fa-chess-knight:before {
  content: "\\f441"; }

.fa-chess-pawn:before {
  content: "\\f443"; }

.fa-chess-queen:before {
  content: "\\f445"; }

.fa-chess-rook:before {
  content: "\\f447"; }

.fa-chevron-circle-down:before {
  content: "\\f13a"; }

.fa-chevron-circle-left:before {
  content: "\\f137"; }

.fa-chevron-circle-right:before {
  content: "\\f138"; }

.fa-chevron-circle-up:before {
  content: "\\f139"; }

.fa-chevron-down:before {
  content: "\\f078"; }

.fa-chevron-left:before {
  content: "\\f053"; }

.fa-chevron-right:before {
  content: "\\f054"; }

.fa-chevron-up:before {
  content: "\\f077"; }

.fa-child:before {
  content: "\\f1ae"; }

.fa-chrome:before {
  content: "\\f268"; }

.fa-chromecast:before {
  content: "\\f838"; }

.fa-church:before {
  content: "\\f51d"; }

.fa-circle:before {
  content: "\\f111"; }

.fa-circle-notch:before {
  content: "\\f1ce"; }

.fa-city:before {
  content: "\\f64f"; }

.fa-clinic-medical:before {
  content: "\\f7f2"; }

.fa-clipboard:before {
  content: "\\f328"; }

.fa-clipboard-check:before {
  content: "\\f46c"; }

.fa-clipboard-list:before {
  content: "\\f46d"; }

.fa-clock:before {
  content: "\\f017"; }

.fa-clone:before {
  content: "\\f24d"; }

.fa-closed-captioning:before {
  content: "\\f20a"; }

.fa-cloud:before {
  content: "\\f0c2"; }

.fa-cloud-download-alt:before {
  content: "\\f381"; }

.fa-cloud-meatball:before {
  content: "\\f73b"; }

.fa-cloud-moon:before {
  content: "\\f6c3"; }

.fa-cloud-moon-rain:before {
  content: "\\f73c"; }

.fa-cloud-rain:before {
  content: "\\f73d"; }

.fa-cloud-showers-heavy:before {
  content: "\\f740"; }

.fa-cloud-sun:before {
  content: "\\f6c4"; }

.fa-cloud-sun-rain:before {
  content: "\\f743"; }

.fa-cloud-upload-alt:before {
  content: "\\f382"; }

.fa-cloudscale:before {
  content: "\\f383"; }

.fa-cloudsmith:before {
  content: "\\f384"; }

.fa-cloudversify:before {
  content: "\\f385"; }

.fa-cocktail:before {
  content: "\\f561"; }

.fa-code:before {
  content: "\\f121"; }

.fa-code-branch:before {
  content: "\\f126"; }

.fa-codepen:before {
  content: "\\f1cb"; }

.fa-codiepie:before {
  content: "\\f284"; }

.fa-coffee:before {
  content: "\\f0f4"; }

.fa-cog:before {
  content: "\\f013"; }

.fa-cogs:before {
  content: "\\f085"; }

.fa-coins:before {
  content: "\\f51e"; }

.fa-columns:before {
  content: "\\f0db"; }

.fa-comment:before {
  content: "\\f075"; }

.fa-comment-alt:before {
  content: "\\f27a"; }

.fa-comment-dollar:before {
  content: "\\f651"; }

.fa-comment-dots:before {
  content: "\\f4ad"; }

.fa-comment-medical:before {
  content: "\\f7f5"; }

.fa-comment-slash:before {
  content: "\\f4b3"; }

.fa-comments:before {
  content: "\\f086"; }

.fa-comments-dollar:before {
  content: "\\f653"; }

.fa-compact-disc:before {
  content: "\\f51f"; }

.fa-compass:before {
  content: "\\f14e"; }

.fa-compress:before {
  content: "\\f066"; }

.fa-compress-alt:before {
  content: "\\f422"; }

.fa-compress-arrows-alt:before {
  content: "\\f78c"; }

.fa-concierge-bell:before {
  content: "\\f562"; }

.fa-confluence:before {
  content: "\\f78d"; }

.fa-connectdevelop:before {
  content: "\\f20e"; }

.fa-contao:before {
  content: "\\f26d"; }

.fa-cookie:before {
  content: "\\f563"; }

.fa-cookie-bite:before {
  content: "\\f564"; }

.fa-copy:before {
  content: "\\f0c5"; }

.fa-copyright:before {
  content: "\\f1f9"; }

.fa-cotton-bureau:before {
  content: "\\f89e"; }

.fa-couch:before {
  content: "\\f4b8"; }

.fa-cpanel:before {
  content: "\\f388"; }

.fa-creative-commons:before {
  content: "\\f25e"; }

.fa-creative-commons-by:before {
  content: "\\f4e7"; }

.fa-creative-commons-nc:before {
  content: "\\f4e8"; }

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9"; }

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea"; }

.fa-creative-commons-nd:before {
  content: "\\f4eb"; }

.fa-creative-commons-pd:before {
  content: "\\f4ec"; }

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed"; }

.fa-creative-commons-remix:before {
  content: "\\f4ee"; }

.fa-creative-commons-sa:before {
  content: "\\f4ef"; }

.fa-creative-commons-sampling:before {
  content: "\\f4f0"; }

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1"; }

.fa-creative-commons-share:before {
  content: "\\f4f2"; }

.fa-creative-commons-zero:before {
  content: "\\f4f3"; }

.fa-credit-card:before {
  content: "\\f09d"; }

.fa-critical-role:before {
  content: "\\f6c9"; }

.fa-crop:before {
  content: "\\f125"; }

.fa-crop-alt:before {
  content: "\\f565"; }

.fa-cross:before {
  content: "\\f654"; }

.fa-crosshairs:before {
  content: "\\f05b"; }

.fa-crow:before {
  content: "\\f520"; }

.fa-crown:before {
  content: "\\f521"; }

.fa-crutch:before {
  content: "\\f7f7"; }

.fa-css3:before {
  content: "\\f13c"; }

.fa-css3-alt:before {
  content: "\\f38b"; }

.fa-cube:before {
  content: "\\f1b2"; }

.fa-cubes:before {
  content: "\\f1b3"; }

.fa-cut:before {
  content: "\\f0c4"; }

.fa-cuttlefish:before {
  content: "\\f38c"; }

.fa-d-and-d:before {
  content: "\\f38d"; }

.fa-d-and-d-beyond:before {
  content: "\\f6ca"; }

.fa-dailymotion:before {
  content: "\\f952"; }

.fa-dashcube:before {
  content: "\\f210"; }

.fa-database:before {
  content: "\\f1c0"; }

.fa-deaf:before {
  content: "\\f2a4"; }

.fa-delicious:before {
  content: "\\f1a5"; }

.fa-democrat:before {
  content: "\\f747"; }

.fa-deploydog:before {
  content: "\\f38e"; }

.fa-deskpro:before {
  content: "\\f38f"; }

.fa-desktop:before {
  content: "\\f108"; }

.fa-dev:before {
  content: "\\f6cc"; }

.fa-deviantart:before {
  content: "\\f1bd"; }

.fa-dharmachakra:before {
  content: "\\f655"; }

.fa-dhl:before {
  content: "\\f790"; }

.fa-diagnoses:before {
  content: "\\f470"; }

.fa-diaspora:before {
  content: "\\f791"; }

.fa-dice:before {
  content: "\\f522"; }

.fa-dice-d20:before {
  content: "\\f6cf"; }

.fa-dice-d6:before {
  content: "\\f6d1"; }

.fa-dice-five:before {
  content: "\\f523"; }

.fa-dice-four:before {
  content: "\\f524"; }

.fa-dice-one:before {
  content: "\\f525"; }

.fa-dice-six:before {
  content: "\\f526"; }

.fa-dice-three:before {
  content: "\\f527"; }

.fa-dice-two:before {
  content: "\\f528"; }

.fa-digg:before {
  content: "\\f1a6"; }

.fa-digital-ocean:before {
  content: "\\f391"; }

.fa-digital-tachograph:before {
  content: "\\f566"; }

.fa-directions:before {
  content: "\\f5eb"; }

.fa-discord:before {
  content: "\\f392"; }

.fa-discourse:before {
  content: "\\f393"; }

.fa-disease:before {
  content: "\\f7fa"; }

.fa-divide:before {
  content: "\\f529"; }

.fa-dizzy:before {
  content: "\\f567"; }

.fa-dna:before {
  content: "\\f471"; }

.fa-dochub:before {
  content: "\\f394"; }

.fa-docker:before {
  content: "\\f395"; }

.fa-dog:before {
  content: "\\f6d3"; }

.fa-dollar-sign:before {
  content: "\\f155"; }

.fa-dolly:before {
  content: "\\f472"; }

.fa-dolly-flatbed:before {
  content: "\\f474"; }

.fa-donate:before {
  content: "\\f4b9"; }

.fa-door-closed:before {
  content: "\\f52a"; }

.fa-door-open:before {
  content: "\\f52b"; }

.fa-dot-circle:before {
  content: "\\f192"; }

.fa-dove:before {
  content: "\\f4ba"; }

.fa-download:before {
  content: "\\f019"; }

.fa-draft2digital:before {
  content: "\\f396"; }

.fa-drafting-compass:before {
  content: "\\f568"; }

.fa-dragon:before {
  content: "\\f6d5"; }

.fa-draw-polygon:before {
  content: "\\f5ee"; }

.fa-dribbble:before {
  content: "\\f17d"; }

.fa-dribbble-square:before {
  content: "\\f397"; }

.fa-dropbox:before {
  content: "\\f16b"; }

.fa-drum:before {
  content: "\\f569"; }

.fa-drum-steelpan:before {
  content: "\\f56a"; }

.fa-drumstick-bite:before {
  content: "\\f6d7"; }

.fa-drupal:before {
  content: "\\f1a9"; }

.fa-dumbbell:before {
  content: "\\f44b"; }

.fa-dumpster:before {
  content: "\\f793"; }

.fa-dumpster-fire:before {
  content: "\\f794"; }

.fa-dungeon:before {
  content: "\\f6d9"; }

.fa-dyalog:before {
  content: "\\f399"; }

.fa-earlybirds:before {
  content: "\\f39a"; }

.fa-ebay:before {
  content: "\\f4f4"; }

.fa-edge:before {
  content: "\\f282"; }

.fa-edit:before {
  content: "\\f044"; }

.fa-egg:before {
  content: "\\f7fb"; }

.fa-eject:before {
  content: "\\f052"; }

.fa-elementor:before {
  content: "\\f430"; }

.fa-ellipsis-h:before {
  content: "\\f141"; }

.fa-ellipsis-v:before {
  content: "\\f142"; }

.fa-ello:before {
  content: "\\f5f1"; }

.fa-ember:before {
  content: "\\f423"; }

.fa-empire:before {
  content: "\\f1d1"; }

.fa-envelope:before {
  content: "\\f0e0"; }

.fa-envelope-open:before {
  content: "\\f2b6"; }

.fa-envelope-open-text:before {
  content: "\\f658"; }

.fa-envelope-square:before {
  content: "\\f199"; }

.fa-envira:before {
  content: "\\f299"; }

.fa-equals:before {
  content: "\\f52c"; }

.fa-eraser:before {
  content: "\\f12d"; }

.fa-erlang:before {
  content: "\\f39d"; }

.fa-ethereum:before {
  content: "\\f42e"; }

.fa-ethernet:before {
  content: "\\f796"; }

.fa-etsy:before {
  content: "\\f2d7"; }

.fa-euro-sign:before {
  content: "\\f153"; }

.fa-evernote:before {
  content: "\\f839"; }

.fa-exchange-alt:before {
  content: "\\f362"; }

.fa-exclamation:before {
  content: "\\f12a"; }

.fa-exclamation-circle:before {
  content: "\\f06a"; }

.fa-exclamation-triangle:before {
  content: "\\f071"; }

.fa-expand:before {
  content: "\\f065"; }

.fa-expand-alt:before {
  content: "\\f424"; }

.fa-expand-arrows-alt:before {
  content: "\\f31e"; }

.fa-expeditedssl:before {
  content: "\\f23e"; }

.fa-external-link-alt:before {
  content: "\\f35d"; }

.fa-external-link-square-alt:before {
  content: "\\f360"; }

.fa-eye:before {
  content: "\\f06e"; }

.fa-eye-dropper:before {
  content: "\\f1fb"; }

.fa-eye-slash:before {
  content: "\\f070"; }

.fa-facebook:before {
  content: "\\f09a"; }

.fa-facebook-f:before {
  content: "\\f39e"; }

.fa-facebook-messenger:before {
  content: "\\f39f"; }

.fa-facebook-square:before {
  content: "\\f082"; }

.fa-fan:before {
  content: "\\f863"; }

.fa-fantasy-flight-games:before {
  content: "\\f6dc"; }

.fa-fast-backward:before {
  content: "\\f049"; }

.fa-fast-forward:before {
  content: "\\f050"; }

.fa-faucet:before {
  content: "\\f905"; }

.fa-fax:before {
  content: "\\f1ac"; }

.fa-feather:before {
  content: "\\f52d"; }

.fa-feather-alt:before {
  content: "\\f56b"; }

.fa-fedex:before {
  content: "\\f797"; }

.fa-fedora:before {
  content: "\\f798"; }

.fa-female:before {
  content: "\\f182"; }

.fa-fighter-jet:before {
  content: "\\f0fb"; }

.fa-figma:before {
  content: "\\f799"; }

.fa-file:before {
  content: "\\f15b"; }

.fa-file-alt:before {
  content: "\\f15c"; }

.fa-file-archive:before {
  content: "\\f1c6"; }

.fa-file-audio:before {
  content: "\\f1c7"; }

.fa-file-code:before {
  content: "\\f1c9"; }

.fa-file-contract:before {
  content: "\\f56c"; }

.fa-file-csv:before {
  content: "\\f6dd"; }

.fa-file-download:before {
  content: "\\f56d"; }

.fa-file-excel:before {
  content: "\\f1c3"; }

.fa-file-export:before {
  content: "\\f56e"; }

.fa-file-image:before {
  content: "\\f1c5"; }

.fa-file-import:before {
  content: "\\f56f"; }

.fa-file-invoice:before {
  content: "\\f570"; }

.fa-file-invoice-dollar:before {
  content: "\\f571"; }

.fa-file-medical:before {
  content: "\\f477"; }

.fa-file-medical-alt:before {
  content: "\\f478"; }

.fa-file-pdf:before {
  content: "\\f1c1"; }

.fa-file-powerpoint:before {
  content: "\\f1c4"; }

.fa-file-prescription:before {
  content: "\\f572"; }

.fa-file-signature:before {
  content: "\\f573"; }

.fa-file-upload:before {
  content: "\\f574"; }

.fa-file-video:before {
  content: "\\f1c8"; }

.fa-file-word:before {
  content: "\\f1c2"; }

.fa-fill:before {
  content: "\\f575"; }

.fa-fill-drip:before {
  content: "\\f576"; }

.fa-film:before {
  content: "\\f008"; }

.fa-filter:before {
  content: "\\f0b0"; }

.fa-fingerprint:before {
  content: "\\f577"; }

.fa-fire:before {
  content: "\\f06d"; }

.fa-fire-alt:before {
  content: "\\f7e4"; }

.fa-fire-extinguisher:before {
  content: "\\f134"; }

.fa-firefox:before {
  content: "\\f269"; }

.fa-firefox-browser:before {
  content: "\\f907"; }

.fa-first-aid:before {
  content: "\\f479"; }

.fa-first-order:before {
  content: "\\f2b0"; }

.fa-first-order-alt:before {
  content: "\\f50a"; }

.fa-firstdraft:before {
  content: "\\f3a1"; }

.fa-fish:before {
  content: "\\f578"; }

.fa-fist-raised:before {
  content: "\\f6de"; }

.fa-flag:before {
  content: "\\f024"; }

.fa-flag-checkered:before {
  content: "\\f11e"; }

.fa-flag-usa:before {
  content: "\\f74d"; }

.fa-flask:before {
  content: "\\f0c3"; }

.fa-flickr:before {
  content: "\\f16e"; }

.fa-flipboard:before {
  content: "\\f44d"; }

.fa-flushed:before {
  content: "\\f579"; }

.fa-fly:before {
  content: "\\f417"; }

.fa-folder:before {
  content: "\\f07b"; }

.fa-folder-minus:before {
  content: "\\f65d"; }

.fa-folder-open:before {
  content: "\\f07c"; }

.fa-folder-plus:before {
  content: "\\f65e"; }

.fa-font:before {
  content: "\\f031"; }

.fa-font-awesome:before {
  content: "\\f2b4"; }

.fa-font-awesome-alt:before {
  content: "\\f35c"; }

.fa-font-awesome-flag:before {
  content: "\\f425"; }

.fa-font-awesome-logo-full:before {
  content: "\\f4e6"; }

.fa-fonticons:before {
  content: "\\f280"; }

.fa-fonticons-fi:before {
  content: "\\f3a2"; }

.fa-football-ball:before {
  content: "\\f44e"; }

.fa-fort-awesome:before {
  content: "\\f286"; }

.fa-fort-awesome-alt:before {
  content: "\\f3a3"; }

.fa-forumbee:before {
  content: "\\f211"; }

.fa-forward:before {
  content: "\\f04e"; }

.fa-foursquare:before {
  content: "\\f180"; }

.fa-free-code-camp:before {
  content: "\\f2c5"; }

.fa-freebsd:before {
  content: "\\f3a4"; }

.fa-frog:before {
  content: "\\f52e"; }

.fa-frown:before {
  content: "\\f119"; }

.fa-frown-open:before {
  content: "\\f57a"; }

.fa-fulcrum:before {
  content: "\\f50b"; }

.fa-funnel-dollar:before {
  content: "\\f662"; }

.fa-futbol:before {
  content: "\\f1e3"; }

.fa-galactic-republic:before {
  content: "\\f50c"; }

.fa-galactic-senate:before {
  content: "\\f50d"; }

.fa-gamepad:before {
  content: "\\f11b"; }

.fa-gas-pump:before {
  content: "\\f52f"; }

.fa-gavel:before {
  content: "\\f0e3"; }

.fa-gem:before {
  content: "\\f3a5"; }

.fa-genderless:before {
  content: "\\f22d"; }

.fa-get-pocket:before {
  content: "\\f265"; }

.fa-gg:before {
  content: "\\f260"; }

.fa-gg-circle:before {
  content: "\\f261"; }

.fa-ghost:before {
  content: "\\f6e2"; }

.fa-gift:before {
  content: "\\f06b"; }

.fa-gifts:before {
  content: "\\f79c"; }

.fa-git:before {
  content: "\\f1d3"; }

.fa-git-alt:before {
  content: "\\f841"; }

.fa-git-square:before {
  content: "\\f1d2"; }

.fa-github:before {
  content: "\\f09b"; }

.fa-github-alt:before {
  content: "\\f113"; }

.fa-github-square:before {
  content: "\\f092"; }

.fa-gitkraken:before {
  content: "\\f3a6"; }

.fa-gitlab:before {
  content: "\\f296"; }

.fa-gitter:before {
  content: "\\f426"; }

.fa-glass-cheers:before {
  content: "\\f79f"; }

.fa-glass-martini:before {
  content: "\\f000"; }

.fa-glass-martini-alt:before {
  content: "\\f57b"; }

.fa-glass-whiskey:before {
  content: "\\f7a0"; }

.fa-glasses:before {
  content: "\\f530"; }

.fa-glide:before {
  content: "\\f2a5"; }

.fa-glide-g:before {
  content: "\\f2a6"; }

.fa-globe:before {
  content: "\\f0ac"; }

.fa-globe-africa:before {
  content: "\\f57c"; }

.fa-globe-americas:before {
  content: "\\f57d"; }

.fa-globe-asia:before {
  content: "\\f57e"; }

.fa-globe-europe:before {
  content: "\\f7a2"; }

.fa-gofore:before {
  content: "\\f3a7"; }

.fa-golf-ball:before {
  content: "\\f450"; }

.fa-goodreads:before {
  content: "\\f3a8"; }

.fa-goodreads-g:before {
  content: "\\f3a9"; }

.fa-google:before {
  content: "\\f1a0"; }

.fa-google-drive:before {
  content: "\\f3aa"; }

.fa-google-play:before {
  content: "\\f3ab"; }

.fa-google-plus:before {
  content: "\\f2b3"; }

.fa-google-plus-g:before {
  content: "\\f0d5"; }

.fa-google-plus-square:before {
  content: "\\f0d4"; }

.fa-google-wallet:before {
  content: "\\f1ee"; }

.fa-gopuram:before {
  content: "\\f664"; }

.fa-graduation-cap:before {
  content: "\\f19d"; }

.fa-gratipay:before {
  content: "\\f184"; }

.fa-grav:before {
  content: "\\f2d6"; }

.fa-greater-than:before {
  content: "\\f531"; }

.fa-greater-than-equal:before {
  content: "\\f532"; }

.fa-grimace:before {
  content: "\\f57f"; }

.fa-grin:before {
  content: "\\f580"; }

.fa-grin-alt:before {
  content: "\\f581"; }

.fa-grin-beam:before {
  content: "\\f582"; }

.fa-grin-beam-sweat:before {
  content: "\\f583"; }

.fa-grin-hearts:before {
  content: "\\f584"; }

.fa-grin-squint:before {
  content: "\\f585"; }

.fa-grin-squint-tears:before {
  content: "\\f586"; }

.fa-grin-stars:before {
  content: "\\f587"; }

.fa-grin-tears:before {
  content: "\\f588"; }

.fa-grin-tongue:before {
  content: "\\f589"; }

.fa-grin-tongue-squint:before {
  content: "\\f58a"; }

.fa-grin-tongue-wink:before {
  content: "\\f58b"; }

.fa-grin-wink:before {
  content: "\\f58c"; }

.fa-grip-horizontal:before {
  content: "\\f58d"; }

.fa-grip-lines:before {
  content: "\\f7a4"; }

.fa-grip-lines-vertical:before {
  content: "\\f7a5"; }

.fa-grip-vertical:before {
  content: "\\f58e"; }

.fa-gripfire:before {
  content: "\\f3ac"; }

.fa-grunt:before {
  content: "\\f3ad"; }

.fa-guitar:before {
  content: "\\f7a6"; }

.fa-gulp:before {
  content: "\\f3ae"; }

.fa-h-square:before {
  content: "\\f0fd"; }

.fa-hacker-news:before {
  content: "\\f1d4"; }

.fa-hacker-news-square:before {
  content: "\\f3af"; }

.fa-hackerrank:before {
  content: "\\f5f7"; }

.fa-hamburger:before {
  content: "\\f805"; }

.fa-hammer:before {
  content: "\\f6e3"; }

.fa-hamsa:before {
  content: "\\f665"; }

.fa-hand-holding:before {
  content: "\\f4bd"; }

.fa-hand-holding-heart:before {
  content: "\\f4be"; }

.fa-hand-holding-medical:before {
  content: "\\f95c"; }

.fa-hand-holding-usd:before {
  content: "\\f4c0"; }

.fa-hand-holding-water:before {
  content: "\\f4c1"; }

.fa-hand-lizard:before {
  content: "\\f258"; }

.fa-hand-middle-finger:before {
  content: "\\f806"; }

.fa-hand-paper:before {
  content: "\\f256"; }

.fa-hand-peace:before {
  content: "\\f25b"; }

.fa-hand-point-down:before {
  content: "\\f0a7"; }

.fa-hand-point-left:before {
  content: "\\f0a5"; }

.fa-hand-point-right:before {
  content: "\\f0a4"; }

.fa-hand-point-up:before {
  content: "\\f0a6"; }

.fa-hand-pointer:before {
  content: "\\f25a"; }

.fa-hand-rock:before {
  content: "\\f255"; }

.fa-hand-scissors:before {
  content: "\\f257"; }

.fa-hand-sparkles:before {
  content: "\\f95d"; }

.fa-hand-spock:before {
  content: "\\f259"; }

.fa-hands:before {
  content: "\\f4c2"; }

.fa-hands-helping:before {
  content: "\\f4c4"; }

.fa-hands-wash:before {
  content: "\\f95e"; }

.fa-handshake:before {
  content: "\\f2b5"; }

.fa-handshake-alt-slash:before {
  content: "\\f95f"; }

.fa-handshake-slash:before {
  content: "\\f960"; }

.fa-hanukiah:before {
  content: "\\f6e6"; }

.fa-hard-hat:before {
  content: "\\f807"; }

.fa-hashtag:before {
  content: "\\f292"; }

.fa-hat-cowboy:before {
  content: "\\f8c0"; }

.fa-hat-cowboy-side:before {
  content: "\\f8c1"; }

.fa-hat-wizard:before {
  content: "\\f6e8"; }

.fa-hdd:before {
  content: "\\f0a0"; }

.fa-head-side-cough:before {
  content: "\\f961"; }

.fa-head-side-cough-slash:before {
  content: "\\f962"; }

.fa-head-side-mask:before {
  content: "\\f963"; }

.fa-head-side-virus:before {
  content: "\\f964"; }

.fa-heading:before {
  content: "\\f1dc"; }

.fa-headphones:before {
  content: "\\f025"; }

.fa-headphones-alt:before {
  content: "\\f58f"; }

.fa-headset:before {
  content: "\\f590"; }

.fa-heart:before {
  content: "\\f004"; }

.fa-heart-broken:before {
  content: "\\f7a9"; }

.fa-heartbeat:before {
  content: "\\f21e"; }

.fa-helicopter:before {
  content: "\\f533"; }

.fa-highlighter:before {
  content: "\\f591"; }

.fa-hiking:before {
  content: "\\f6ec"; }

.fa-hippo:before {
  content: "\\f6ed"; }

.fa-hips:before {
  content: "\\f452"; }

.fa-hire-a-helper:before {
  content: "\\f3b0"; }

.fa-history:before {
  content: "\\f1da"; }

.fa-hockey-puck:before {
  content: "\\f453"; }

.fa-holly-berry:before {
  content: "\\f7aa"; }

.fa-home:before {
  content: "\\f015"; }

.fa-hooli:before {
  content: "\\f427"; }

.fa-hornbill:before {
  content: "\\f592"; }

.fa-horse:before {
  content: "\\f6f0"; }

.fa-horse-head:before {
  content: "\\f7ab"; }

.fa-hospital:before {
  content: "\\f0f8"; }

.fa-hospital-alt:before {
  content: "\\f47d"; }

.fa-hospital-symbol:before {
  content: "\\f47e"; }

.fa-hospital-user:before {
  content: "\\f80d"; }

.fa-hot-tub:before {
  content: "\\f593"; }

.fa-hotdog:before {
  content: "\\f80f"; }

.fa-hotel:before {
  content: "\\f594"; }

.fa-hotjar:before {
  content: "\\f3b1"; }

.fa-hourglass:before {
  content: "\\f254"; }

.fa-hourglass-end:before {
  content: "\\f253"; }

.fa-hourglass-half:before {
  content: "\\f252"; }

.fa-hourglass-start:before {
  content: "\\f251"; }

.fa-house-damage:before {
  content: "\\f6f1"; }

.fa-house-user:before {
  content: "\\f965"; }

.fa-houzz:before {
  content: "\\f27c"; }

.fa-hryvnia:before {
  content: "\\f6f2"; }

.fa-html5:before {
  content: "\\f13b"; }

.fa-hubspot:before {
  content: "\\f3b2"; }

.fa-i-cursor:before {
  content: "\\f246"; }

.fa-ice-cream:before {
  content: "\\f810"; }

.fa-icicles:before {
  content: "\\f7ad"; }

.fa-icons:before {
  content: "\\f86d"; }

.fa-id-badge:before {
  content: "\\f2c1"; }

.fa-id-card:before {
  content: "\\f2c2"; }

.fa-id-card-alt:before {
  content: "\\f47f"; }

.fa-ideal:before {
  content: "\\f913"; }

.fa-igloo:before {
  content: "\\f7ae"; }

.fa-image:before {
  content: "\\f03e"; }

.fa-images:before {
  content: "\\f302"; }

.fa-imdb:before {
  content: "\\f2d8"; }

.fa-inbox:before {
  content: "\\f01c"; }

.fa-indent:before {
  content: "\\f03c"; }

.fa-industry:before {
  content: "\\f275"; }

.fa-infinity:before {
  content: "\\f534"; }

.fa-info:before {
  content: "\\f129"; }

.fa-info-circle:before {
  content: "\\f05a"; }

.fa-instagram:before {
  content: "\\f16d"; }

.fa-instagram-square:before {
  content: "\\f955"; }

.fa-intercom:before {
  content: "\\f7af"; }

.fa-internet-explorer:before {
  content: "\\f26b"; }

.fa-invision:before {
  content: "\\f7b0"; }

.fa-ioxhost:before {
  content: "\\f208"; }

.fa-italic:before {
  content: "\\f033"; }

.fa-itch-io:before {
  content: "\\f83a"; }

.fa-itunes:before {
  content: "\\f3b4"; }

.fa-itunes-note:before {
  content: "\\f3b5"; }

.fa-java:before {
  content: "\\f4e4"; }

.fa-jedi:before {
  content: "\\f669"; }

.fa-jedi-order:before {
  content: "\\f50e"; }

.fa-jenkins:before {
  content: "\\f3b6"; }

.fa-jira:before {
  content: "\\f7b1"; }

.fa-joget:before {
  content: "\\f3b7"; }

.fa-joint:before {
  content: "\\f595"; }

.fa-joomla:before {
  content: "\\f1aa"; }

.fa-journal-whills:before {
  content: "\\f66a"; }

.fa-js:before {
  content: "\\f3b8"; }

.fa-js-square:before {
  content: "\\f3b9"; }

.fa-jsfiddle:before {
  content: "\\f1cc"; }

.fa-kaaba:before {
  content: "\\f66b"; }

.fa-kaggle:before {
  content: "\\f5fa"; }

.fa-key:before {
  content: "\\f084"; }

.fa-keybase:before {
  content: "\\f4f5"; }

.fa-keyboard:before {
  content: "\\f11c"; }

.fa-keycdn:before {
  content: "\\f3ba"; }

.fa-khanda:before {
  content: "\\f66d"; }

.fa-kickstarter:before {
  content: "\\f3bb"; }

.fa-kickstarter-k:before {
  content: "\\f3bc"; }

.fa-kiss:before {
  content: "\\f596"; }

.fa-kiss-beam:before {
  content: "\\f597"; }

.fa-kiss-wink-heart:before {
  content: "\\f598"; }

.fa-kiwi-bird:before {
  content: "\\f535"; }

.fa-korvue:before {
  content: "\\f42f"; }

.fa-landmark:before {
  content: "\\f66f"; }

.fa-language:before {
  content: "\\f1ab"; }

.fa-laptop:before {
  content: "\\f109"; }

.fa-laptop-code:before {
  content: "\\f5fc"; }

.fa-laptop-house:before {
  content: "\\f966"; }

.fa-laptop-medical:before {
  content: "\\f812"; }

.fa-laravel:before {
  content: "\\f3bd"; }

.fa-lastfm:before {
  content: "\\f202"; }

.fa-lastfm-square:before {
  content: "\\f203"; }

.fa-laugh:before {
  content: "\\f599"; }

.fa-laugh-beam:before {
  content: "\\f59a"; }

.fa-laugh-squint:before {
  content: "\\f59b"; }

.fa-laugh-wink:before {
  content: "\\f59c"; }

.fa-layer-group:before {
  content: "\\f5fd"; }

.fa-leaf:before {
  content: "\\f06c"; }

.fa-leanpub:before {
  content: "\\f212"; }

.fa-lemon:before {
  content: "\\f094"; }

.fa-less:before {
  content: "\\f41d"; }

.fa-less-than:before {
  content: "\\f536"; }

.fa-less-than-equal:before {
  content: "\\f537"; }

.fa-level-down-alt:before {
  content: "\\f3be"; }

.fa-level-up-alt:before {
  content: "\\f3bf"; }

.fa-life-ring:before {
  content: "\\f1cd"; }

.fa-lightbulb:before {
  content: "\\f0eb"; }

.fa-line:before {
  content: "\\f3c0"; }

.fa-link:before {
  content: "\\f0c1"; }

.fa-linkedin:before {
  content: "\\f08c"; }

.fa-linkedin-in:before {
  content: "\\f0e1"; }

.fa-linode:before {
  content: "\\f2b8"; }

.fa-linux:before {
  content: "\\f17c"; }

.fa-lira-sign:before {
  content: "\\f195"; }

.fa-list:before {
  content: "\\f03a"; }

.fa-list-alt:before {
  content: "\\f022"; }

.fa-list-ol:before {
  content: "\\f0cb"; }

.fa-list-ul:before {
  content: "\\f0ca"; }

.fa-location-arrow:before {
  content: "\\f124"; }

.fa-lock:before {
  content: "\\f023"; }

.fa-lock-open:before {
  content: "\\f3c1"; }

.fa-long-arrow-alt-down:before {
  content: "\\f309"; }

.fa-long-arrow-alt-left:before {
  content: "\\f30a"; }

.fa-long-arrow-alt-right:before {
  content: "\\f30b"; }

.fa-long-arrow-alt-up:before {
  content: "\\f30c"; }

.fa-low-vision:before {
  content: "\\f2a8"; }

.fa-luggage-cart:before {
  content: "\\f59d"; }

.fa-lungs:before {
  content: "\\f604"; }

.fa-lungs-virus:before {
  content: "\\f967"; }

.fa-lyft:before {
  content: "\\f3c3"; }

.fa-magento:before {
  content: "\\f3c4"; }

.fa-magic:before {
  content: "\\f0d0"; }

.fa-magnet:before {
  content: "\\f076"; }

.fa-mail-bulk:before {
  content: "\\f674"; }

.fa-mailchimp:before {
  content: "\\f59e"; }

.fa-male:before {
  content: "\\f183"; }

.fa-mandalorian:before {
  content: "\\f50f"; }

.fa-map:before {
  content: "\\f279"; }

.fa-map-marked:before {
  content: "\\f59f"; }

.fa-map-marked-alt:before {
  content: "\\f5a0"; }

.fa-map-marker:before {
  content: "\\f041"; }

.fa-map-marker-alt:before {
  content: "\\f3c5"; }

.fa-map-pin:before {
  content: "\\f276"; }

.fa-map-signs:before {
  content: "\\f277"; }

.fa-markdown:before {
  content: "\\f60f"; }

.fa-marker:before {
  content: "\\f5a1"; }

.fa-mars:before {
  content: "\\f222"; }

.fa-mars-double:before {
  content: "\\f227"; }

.fa-mars-stroke:before {
  content: "\\f229"; }

.fa-mars-stroke-h:before {
  content: "\\f22b"; }

.fa-mars-stroke-v:before {
  content: "\\f22a"; }

.fa-mask:before {
  content: "\\f6fa"; }

.fa-mastodon:before {
  content: "\\f4f6"; }

.fa-maxcdn:before {
  content: "\\f136"; }

.fa-mdb:before {
  content: "\\f8ca"; }

.fa-medal:before {
  content: "\\f5a2"; }

.fa-medapps:before {
  content: "\\f3c6"; }

.fa-medium:before {
  content: "\\f23a"; }

.fa-medium-m:before {
  content: "\\f3c7"; }

.fa-medkit:before {
  content: "\\f0fa"; }

.fa-medrt:before {
  content: "\\f3c8"; }

.fa-meetup:before {
  content: "\\f2e0"; }

.fa-megaport:before {
  content: "\\f5a3"; }

.fa-meh:before {
  content: "\\f11a"; }

.fa-meh-blank:before {
  content: "\\f5a4"; }

.fa-meh-rolling-eyes:before {
  content: "\\f5a5"; }

.fa-memory:before {
  content: "\\f538"; }

.fa-mendeley:before {
  content: "\\f7b3"; }

.fa-menorah:before {
  content: "\\f676"; }

.fa-mercury:before {
  content: "\\f223"; }

.fa-meteor:before {
  content: "\\f753"; }

.fa-microblog:before {
  content: "\\f91a"; }

.fa-microchip:before {
  content: "\\f2db"; }

.fa-microphone:before {
  content: "\\f130"; }

.fa-microphone-alt:before {
  content: "\\f3c9"; }

.fa-microphone-alt-slash:before {
  content: "\\f539"; }

.fa-microphone-slash:before {
  content: "\\f131"; }

.fa-microscope:before {
  content: "\\f610"; }

.fa-microsoft:before {
  content: "\\f3ca"; }

.fa-minus:before {
  content: "\\f068"; }

.fa-minus-circle:before {
  content: "\\f056"; }

.fa-minus-square:before {
  content: "\\f146"; }

.fa-mitten:before {
  content: "\\f7b5"; }

.fa-mix:before {
  content: "\\f3cb"; }

.fa-mixcloud:before {
  content: "\\f289"; }

.fa-mixer:before {
  content: "\\f956"; }

.fa-mizuni:before {
  content: "\\f3cc"; }

.fa-mobile:before {
  content: "\\f10b"; }

.fa-mobile-alt:before {
  content: "\\f3cd"; }

.fa-modx:before {
  content: "\\f285"; }

.fa-monero:before {
  content: "\\f3d0"; }

.fa-money-bill:before {
  content: "\\f0d6"; }

.fa-money-bill-alt:before {
  content: "\\f3d1"; }

.fa-money-bill-wave:before {
  content: "\\f53a"; }

.fa-money-bill-wave-alt:before {
  content: "\\f53b"; }

.fa-money-check:before {
  content: "\\f53c"; }

.fa-money-check-alt:before {
  content: "\\f53d"; }

.fa-monument:before {
  content: "\\f5a6"; }

.fa-moon:before {
  content: "\\f186"; }

.fa-mortar-pestle:before {
  content: "\\f5a7"; }

.fa-mosque:before {
  content: "\\f678"; }

.fa-motorcycle:before {
  content: "\\f21c"; }

.fa-mountain:before {
  content: "\\f6fc"; }

.fa-mouse:before {
  content: "\\f8cc"; }

.fa-mouse-pointer:before {
  content: "\\f245"; }

.fa-mug-hot:before {
  content: "\\f7b6"; }

.fa-music:before {
  content: "\\f001"; }

.fa-napster:before {
  content: "\\f3d2"; }

.fa-neos:before {
  content: "\\f612"; }

.fa-network-wired:before {
  content: "\\f6ff"; }

.fa-neuter:before {
  content: "\\f22c"; }

.fa-newspaper:before {
  content: "\\f1ea"; }

.fa-nimblr:before {
  content: "\\f5a8"; }

.fa-node:before {
  content: "\\f419"; }

.fa-node-js:before {
  content: "\\f3d3"; }

.fa-not-equal:before {
  content: "\\f53e"; }

.fa-notes-medical:before {
  content: "\\f481"; }

.fa-npm:before {
  content: "\\f3d4"; }

.fa-ns8:before {
  content: "\\f3d5"; }

.fa-nutritionix:before {
  content: "\\f3d6"; }

.fa-object-group:before {
  content: "\\f247"; }

.fa-object-ungroup:before {
  content: "\\f248"; }

.fa-odnoklassniki:before {
  content: "\\f263"; }

.fa-odnoklassniki-square:before {
  content: "\\f264"; }

.fa-oil-can:before {
  content: "\\f613"; }

.fa-old-republic:before {
  content: "\\f510"; }

.fa-om:before {
  content: "\\f679"; }

.fa-opencart:before {
  content: "\\f23d"; }

.fa-openid:before {
  content: "\\f19b"; }

.fa-opera:before {
  content: "\\f26a"; }

.fa-optin-monster:before {
  content: "\\f23c"; }

.fa-orcid:before {
  content: "\\f8d2"; }

.fa-osi:before {
  content: "\\f41a"; }

.fa-otter:before {
  content: "\\f700"; }

.fa-outdent:before {
  content: "\\f03b"; }

.fa-page4:before {
  content: "\\f3d7"; }

.fa-pagelines:before {
  content: "\\f18c"; }

.fa-pager:before {
  content: "\\f815"; }

.fa-paint-brush:before {
  content: "\\f1fc"; }

.fa-paint-roller:before {
  content: "\\f5aa"; }

.fa-palette:before {
  content: "\\f53f"; }

.fa-palfed:before {
  content: "\\f3d8"; }

.fa-pallet:before {
  content: "\\f482"; }

.fa-paper-plane:before {
  content: "\\f1d8"; }

.fa-paperclip:before {
  content: "\\f0c6"; }

.fa-parachute-box:before {
  content: "\\f4cd"; }

.fa-paragraph:before {
  content: "\\f1dd"; }

.fa-parking:before {
  content: "\\f540"; }

.fa-passport:before {
  content: "\\f5ab"; }

.fa-pastafarianism:before {
  content: "\\f67b"; }

.fa-paste:before {
  content: "\\f0ea"; }

.fa-patreon:before {
  content: "\\f3d9"; }

.fa-pause:before {
  content: "\\f04c"; }

.fa-pause-circle:before {
  content: "\\f28b"; }

.fa-paw:before {
  content: "\\f1b0"; }

.fa-paypal:before {
  content: "\\f1ed"; }

.fa-peace:before {
  content: "\\f67c"; }

.fa-pen:before {
  content: "\\f304"; }

.fa-pen-alt:before {
  content: "\\f305"; }

.fa-pen-fancy:before {
  content: "\\f5ac"; }

.fa-pen-nib:before {
  content: "\\f5ad"; }

.fa-pen-square:before {
  content: "\\f14b"; }

.fa-pencil-alt:before {
  content: "\\f303"; }

.fa-pencil-ruler:before {
  content: "\\f5ae"; }

.fa-penny-arcade:before {
  content: "\\f704"; }

.fa-people-arrows:before {
  content: "\\f968"; }

.fa-people-carry:before {
  content: "\\f4ce"; }

.fa-pepper-hot:before {
  content: "\\f816"; }

.fa-percent:before {
  content: "\\f295"; }

.fa-percentage:before {
  content: "\\f541"; }

.fa-periscope:before {
  content: "\\f3da"; }

.fa-person-booth:before {
  content: "\\f756"; }

.fa-phabricator:before {
  content: "\\f3db"; }

.fa-phoenix-framework:before {
  content: "\\f3dc"; }

.fa-phoenix-squadron:before {
  content: "\\f511"; }

.fa-phone:before {
  content: "\\f095"; }

.fa-phone-alt:before {
  content: "\\f879"; }

.fa-phone-slash:before {
  content: "\\f3dd"; }

.fa-phone-square:before {
  content: "\\f098"; }

.fa-phone-square-alt:before {
  content: "\\f87b"; }

.fa-phone-volume:before {
  content: "\\f2a0"; }

.fa-photo-video:before {
  content: "\\f87c"; }

.fa-php:before {
  content: "\\f457"; }

.fa-pied-piper:before {
  content: "\\f2ae"; }

.fa-pied-piper-alt:before {
  content: "\\f1a8"; }

.fa-pied-piper-hat:before {
  content: "\\f4e5"; }

.fa-pied-piper-pp:before {
  content: "\\f1a7"; }

.fa-pied-piper-square:before {
  content: "\\f91e"; }

.fa-piggy-bank:before {
  content: "\\f4d3"; }

.fa-pills:before {
  content: "\\f484"; }

.fa-pinterest:before {
  content: "\\f0d2"; }

.fa-pinterest-p:before {
  content: "\\f231"; }

.fa-pinterest-square:before {
  content: "\\f0d3"; }

.fa-pizza-slice:before {
  content: "\\f818"; }

.fa-place-of-worship:before {
  content: "\\f67f"; }

.fa-plane:before {
  content: "\\f072"; }

.fa-plane-arrival:before {
  content: "\\f5af"; }

.fa-plane-departure:before {
  content: "\\f5b0"; }

.fa-plane-slash:before {
  content: "\\f969"; }

.fa-play:before {
  content: "\\f04b"; }

.fa-play-circle:before {
  content: "\\f144"; }

.fa-playstation:before {
  content: "\\f3df"; }

.fa-plug:before {
  content: "\\f1e6"; }

.fa-plus:before {
  content: "\\f067"; }

.fa-plus-circle:before {
  content: "\\f055"; }

.fa-plus-square:before {
  content: "\\f0fe"; }

.fa-podcast:before {
  content: "\\f2ce"; }

.fa-poll:before {
  content: "\\f681"; }

.fa-poll-h:before {
  content: "\\f682"; }

.fa-poo:before {
  content: "\\f2fe"; }

.fa-poo-storm:before {
  content: "\\f75a"; }

.fa-poop:before {
  content: "\\f619"; }

.fa-portrait:before {
  content: "\\f3e0"; }

.fa-pound-sign:before {
  content: "\\f154"; }

.fa-power-off:before {
  content: "\\f011"; }

.fa-pray:before {
  content: "\\f683"; }

.fa-praying-hands:before {
  content: "\\f684"; }

.fa-prescription:before {
  content: "\\f5b1"; }

.fa-prescription-bottle:before {
  content: "\\f485"; }

.fa-prescription-bottle-alt:before {
  content: "\\f486"; }

.fa-print:before {
  content: "\\f02f"; }

.fa-procedures:before {
  content: "\\f487"; }

.fa-product-hunt:before {
  content: "\\f288"; }

.fa-project-diagram:before {
  content: "\\f542"; }

.fa-pump-medical:before {
  content: "\\f96a"; }

.fa-pump-soap:before {
  content: "\\f96b"; }

.fa-pushed:before {
  content: "\\f3e1"; }

.fa-puzzle-piece:before {
  content: "\\f12e"; }

.fa-python:before {
  content: "\\f3e2"; }

.fa-qq:before {
  content: "\\f1d6"; }

.fa-qrcode:before {
  content: "\\f029"; }

.fa-question:before {
  content: "\\f128"; }

.fa-question-circle:before {
  content: "\\f059"; }

.fa-quidditch:before {
  content: "\\f458"; }

.fa-quinscape:before {
  content: "\\f459"; }

.fa-quora:before {
  content: "\\f2c4"; }

.fa-quote-left:before {
  content: "\\f10d"; }

.fa-quote-right:before {
  content: "\\f10e"; }

.fa-quran:before {
  content: "\\f687"; }

.fa-r-project:before {
  content: "\\f4f7"; }

.fa-radiation:before {
  content: "\\f7b9"; }

.fa-radiation-alt:before {
  content: "\\f7ba"; }

.fa-rainbow:before {
  content: "\\f75b"; }

.fa-random:before {
  content: "\\f074"; }

.fa-raspberry-pi:before {
  content: "\\f7bb"; }

.fa-ravelry:before {
  content: "\\f2d9"; }

.fa-react:before {
  content: "\\f41b"; }

.fa-reacteurope:before {
  content: "\\f75d"; }

.fa-readme:before {
  content: "\\f4d5"; }

.fa-rebel:before {
  content: "\\f1d0"; }

.fa-receipt:before {
  content: "\\f543"; }

.fa-record-vinyl:before {
  content: "\\f8d9"; }

.fa-recycle:before {
  content: "\\f1b8"; }

.fa-red-river:before {
  content: "\\f3e3"; }

.fa-reddit:before {
  content: "\\f1a1"; }

.fa-reddit-alien:before {
  content: "\\f281"; }

.fa-reddit-square:before {
  content: "\\f1a2"; }

.fa-redhat:before {
  content: "\\f7bc"; }

.fa-redo:before {
  content: "\\f01e"; }

.fa-redo-alt:before {
  content: "\\f2f9"; }

.fa-registered:before {
  content: "\\f25d"; }

.fa-remove-format:before {
  content: "\\f87d"; }

.fa-renren:before {
  content: "\\f18b"; }

.fa-reply:before {
  content: "\\f3e5"; }

.fa-reply-all:before {
  content: "\\f122"; }

.fa-replyd:before {
  content: "\\f3e6"; }

.fa-republican:before {
  content: "\\f75e"; }

.fa-researchgate:before {
  content: "\\f4f8"; }

.fa-resolving:before {
  content: "\\f3e7"; }

.fa-restroom:before {
  content: "\\f7bd"; }

.fa-retweet:before {
  content: "\\f079"; }

.fa-rev:before {
  content: "\\f5b2"; }

.fa-ribbon:before {
  content: "\\f4d6"; }

.fa-ring:before {
  content: "\\f70b"; }

.fa-road:before {
  content: "\\f018"; }

.fa-robot:before {
  content: "\\f544"; }

.fa-rocket:before {
  content: "\\f135"; }

.fa-rocketchat:before {
  content: "\\f3e8"; }

.fa-rockrms:before {
  content: "\\f3e9"; }

.fa-route:before {
  content: "\\f4d7"; }

.fa-rss:before {
  content: "\\f09e"; }

.fa-rss-square:before {
  content: "\\f143"; }

.fa-ruble-sign:before {
  content: "\\f158"; }

.fa-ruler:before {
  content: "\\f545"; }

.fa-ruler-combined:before {
  content: "\\f546"; }

.fa-ruler-horizontal:before {
  content: "\\f547"; }

.fa-ruler-vertical:before {
  content: "\\f548"; }

.fa-running:before {
  content: "\\f70c"; }

.fa-rupee-sign:before {
  content: "\\f156"; }

.fa-sad-cry:before {
  content: "\\f5b3"; }

.fa-sad-tear:before {
  content: "\\f5b4"; }

.fa-safari:before {
  content: "\\f267"; }

.fa-salesforce:before {
  content: "\\f83b"; }

.fa-sass:before {
  content: "\\f41e"; }

.fa-satellite:before {
  content: "\\f7bf"; }

.fa-satellite-dish:before {
  content: "\\f7c0"; }

.fa-save:before {
  content: "\\f0c7"; }

.fa-schlix:before {
  content: "\\f3ea"; }

.fa-school:before {
  content: "\\f549"; }

.fa-screwdriver:before {
  content: "\\f54a"; }

.fa-scribd:before {
  content: "\\f28a"; }

.fa-scroll:before {
  content: "\\f70e"; }

.fa-sd-card:before {
  content: "\\f7c2"; }

.fa-search:before {
  content: "\\f002"; }

.fa-search-dollar:before {
  content: "\\f688"; }

.fa-search-location:before {
  content: "\\f689"; }

.fa-search-minus:before {
  content: "\\f010"; }

.fa-search-plus:before {
  content: "\\f00e"; }

.fa-searchengin:before {
  content: "\\f3eb"; }

.fa-seedling:before {
  content: "\\f4d8"; }

.fa-sellcast:before {
  content: "\\f2da"; }

.fa-sellsy:before {
  content: "\\f213"; }

.fa-server:before {
  content: "\\f233"; }

.fa-servicestack:before {
  content: "\\f3ec"; }

.fa-shapes:before {
  content: "\\f61f"; }

.fa-share:before {
  content: "\\f064"; }

.fa-share-alt:before {
  content: "\\f1e0"; }

.fa-share-alt-square:before {
  content: "\\f1e1"; }

.fa-share-square:before {
  content: "\\f14d"; }

.fa-shekel-sign:before {
  content: "\\f20b"; }

.fa-shield-alt:before {
  content: "\\f3ed"; }

.fa-shield-virus:before {
  content: "\\f96c"; }

.fa-ship:before {
  content: "\\f21a"; }

.fa-shipping-fast:before {
  content: "\\f48b"; }

.fa-shirtsinbulk:before {
  content: "\\f214"; }

.fa-shoe-prints:before {
  content: "\\f54b"; }

.fa-shopify:before {
  content: "\\f957"; }

.fa-shopping-bag:before {
  content: "\\f290"; }

.fa-shopping-basket:before {
  content: "\\f291"; }

.fa-shopping-cart:before {
  content: "\\f07a"; }

.fa-shopware:before {
  content: "\\f5b5"; }

.fa-shower:before {
  content: "\\f2cc"; }

.fa-shuttle-van:before {
  content: "\\f5b6"; }

.fa-sign:before {
  content: "\\f4d9"; }

.fa-sign-in-alt:before {
  content: "\\f2f6"; }

.fa-sign-language:before {
  content: "\\f2a7"; }

.fa-sign-out-alt:before {
  content: "\\f2f5"; }

.fa-signal:before {
  content: "\\f012"; }

.fa-signature:before {
  content: "\\f5b7"; }

.fa-sim-card:before {
  content: "\\f7c4"; }

.fa-simplybuilt:before {
  content: "\\f215"; }

.fa-sistrix:before {
  content: "\\f3ee"; }

.fa-sitemap:before {
  content: "\\f0e8"; }

.fa-sith:before {
  content: "\\f512"; }

.fa-skating:before {
  content: "\\f7c5"; }

.fa-sketch:before {
  content: "\\f7c6"; }

.fa-skiing:before {
  content: "\\f7c9"; }

.fa-skiing-nordic:before {
  content: "\\f7ca"; }

.fa-skull:before {
  content: "\\f54c"; }

.fa-skull-crossbones:before {
  content: "\\f714"; }

.fa-skyatlas:before {
  content: "\\f216"; }

.fa-skype:before {
  content: "\\f17e"; }

.fa-slack:before {
  content: "\\f198"; }

.fa-slack-hash:before {
  content: "\\f3ef"; }

.fa-slash:before {
  content: "\\f715"; }

.fa-sleigh:before {
  content: "\\f7cc"; }

.fa-sliders-h:before {
  content: "\\f1de"; }

.fa-slideshare:before {
  content: "\\f1e7"; }

.fa-smile:before {
  content: "\\f118"; }

.fa-smile-beam:before {
  content: "\\f5b8"; }

.fa-smile-wink:before {
  content: "\\f4da"; }

.fa-smog:before {
  content: "\\f75f"; }

.fa-smoking:before {
  content: "\\f48d"; }

.fa-smoking-ban:before {
  content: "\\f54d"; }

.fa-sms:before {
  content: "\\f7cd"; }

.fa-snapchat:before {
  content: "\\f2ab"; }

.fa-snapchat-ghost:before {
  content: "\\f2ac"; }

.fa-snapchat-square:before {
  content: "\\f2ad"; }

.fa-snowboarding:before {
  content: "\\f7ce"; }

.fa-snowflake:before {
  content: "\\f2dc"; }

.fa-snowman:before {
  content: "\\f7d0"; }

.fa-snowplow:before {
  content: "\\f7d2"; }

.fa-soap:before {
  content: "\\f96e"; }

.fa-socks:before {
  content: "\\f696"; }

.fa-solar-panel:before {
  content: "\\f5ba"; }

.fa-sort:before {
  content: "\\f0dc"; }

.fa-sort-alpha-down:before {
  content: "\\f15d"; }

.fa-sort-alpha-down-alt:before {
  content: "\\f881"; }

.fa-sort-alpha-up:before {
  content: "\\f15e"; }

.fa-sort-alpha-up-alt:before {
  content: "\\f882"; }

.fa-sort-amount-down:before {
  content: "\\f160"; }

.fa-sort-amount-down-alt:before {
  content: "\\f884"; }

.fa-sort-amount-up:before {
  content: "\\f161"; }

.fa-sort-amount-up-alt:before {
  content: "\\f885"; }

.fa-sort-down:before {
  content: "\\f0dd"; }

.fa-sort-numeric-down:before {
  content: "\\f162"; }

.fa-sort-numeric-down-alt:before {
  content: "\\f886"; }

.fa-sort-numeric-up:before {
  content: "\\f163"; }

.fa-sort-numeric-up-alt:before {
  content: "\\f887"; }

.fa-sort-up:before {
  content: "\\f0de"; }

.fa-soundcloud:before {
  content: "\\f1be"; }

.fa-sourcetree:before {
  content: "\\f7d3"; }

.fa-spa:before {
  content: "\\f5bb"; }

.fa-space-shuttle:before {
  content: "\\f197"; }

.fa-speakap:before {
  content: "\\f3f3"; }

.fa-speaker-deck:before {
  content: "\\f83c"; }

.fa-spell-check:before {
  content: "\\f891"; }

.fa-spider:before {
  content: "\\f717"; }

.fa-spinner:before {
  content: "\\f110"; }

.fa-splotch:before {
  content: "\\f5bc"; }

.fa-spotify:before {
  content: "\\f1bc"; }

.fa-spray-can:before {
  content: "\\f5bd"; }

.fa-square:before {
  content: "\\f0c8"; }

.fa-square-full:before {
  content: "\\f45c"; }

.fa-square-root-alt:before {
  content: "\\f698"; }

.fa-squarespace:before {
  content: "\\f5be"; }

.fa-stack-exchange:before {
  content: "\\f18d"; }

.fa-stack-overflow:before {
  content: "\\f16c"; }

.fa-stackpath:before {
  content: "\\f842"; }

.fa-stamp:before {
  content: "\\f5bf"; }

.fa-star:before {
  content: "\\f005"; }

.fa-star-and-crescent:before {
  content: "\\f699"; }

.fa-star-half:before {
  content: "\\f089"; }

.fa-star-half-alt:before {
  content: "\\f5c0"; }

.fa-star-of-david:before {
  content: "\\f69a"; }

.fa-star-of-life:before {
  content: "\\f621"; }

.fa-staylinked:before {
  content: "\\f3f5"; }

.fa-steam:before {
  content: "\\f1b6"; }

.fa-steam-square:before {
  content: "\\f1b7"; }

.fa-steam-symbol:before {
  content: "\\f3f6"; }

.fa-step-backward:before {
  content: "\\f048"; }

.fa-step-forward:before {
  content: "\\f051"; }

.fa-stethoscope:before {
  content: "\\f0f1"; }

.fa-sticker-mule:before {
  content: "\\f3f7"; }

.fa-sticky-note:before {
  content: "\\f249"; }

.fa-stop:before {
  content: "\\f04d"; }

.fa-stop-circle:before {
  content: "\\f28d"; }

.fa-stopwatch:before {
  content: "\\f2f2"; }

.fa-stopwatch-20:before {
  content: "\\f96f"; }

.fa-store:before {
  content: "\\f54e"; }

.fa-store-alt:before {
  content: "\\f54f"; }

.fa-store-alt-slash:before {
  content: "\\f970"; }

.fa-store-slash:before {
  content: "\\f971"; }

.fa-strava:before {
  content: "\\f428"; }

.fa-stream:before {
  content: "\\f550"; }

.fa-street-view:before {
  content: "\\f21d"; }

.fa-strikethrough:before {
  content: "\\f0cc"; }

.fa-stripe:before {
  content: "\\f429"; }

.fa-stripe-s:before {
  content: "\\f42a"; }

.fa-stroopwafel:before {
  content: "\\f551"; }

.fa-studiovinari:before {
  content: "\\f3f8"; }

.fa-stumbleupon:before {
  content: "\\f1a4"; }

.fa-stumbleupon-circle:before {
  content: "\\f1a3"; }

.fa-subscript:before {
  content: "\\f12c"; }

.fa-subway:before {
  content: "\\f239"; }

.fa-suitcase:before {
  content: "\\f0f2"; }

.fa-suitcase-rolling:before {
  content: "\\f5c1"; }

.fa-sun:before {
  content: "\\f185"; }

.fa-superpowers:before {
  content: "\\f2dd"; }

.fa-superscript:before {
  content: "\\f12b"; }

.fa-supple:before {
  content: "\\f3f9"; }

.fa-surprise:before {
  content: "\\f5c2"; }

.fa-suse:before {
  content: "\\f7d6"; }

.fa-swatchbook:before {
  content: "\\f5c3"; }

.fa-swift:before {
  content: "\\f8e1"; }

.fa-swimmer:before {
  content: "\\f5c4"; }

.fa-swimming-pool:before {
  content: "\\f5c5"; }

.fa-symfony:before {
  content: "\\f83d"; }

.fa-synagogue:before {
  content: "\\f69b"; }

.fa-sync:before {
  content: "\\f021"; }

.fa-sync-alt:before {
  content: "\\f2f1"; }

.fa-syringe:before {
  content: "\\f48e"; }

.fa-table:before {
  content: "\\f0ce"; }

.fa-table-tennis:before {
  content: "\\f45d"; }

.fa-tablet:before {
  content: "\\f10a"; }

.fa-tablet-alt:before {
  content: "\\f3fa"; }

.fa-tablets:before {
  content: "\\f490"; }

.fa-tachometer-alt:before {
  content: "\\f3fd"; }

.fa-tag:before {
  content: "\\f02b"; }

.fa-tags:before {
  content: "\\f02c"; }

.fa-tape:before {
  content: "\\f4db"; }

.fa-tasks:before {
  content: "\\f0ae"; }

.fa-taxi:before {
  content: "\\f1ba"; }

.fa-teamspeak:before {
  content: "\\f4f9"; }

.fa-teeth:before {
  content: "\\f62e"; }

.fa-teeth-open:before {
  content: "\\f62f"; }

.fa-telegram:before {
  content: "\\f2c6"; }

.fa-telegram-plane:before {
  content: "\\f3fe"; }

.fa-temperature-high:before {
  content: "\\f769"; }

.fa-temperature-low:before {
  content: "\\f76b"; }

.fa-tencent-weibo:before {
  content: "\\f1d5"; }

.fa-tenge:before {
  content: "\\f7d7"; }

.fa-terminal:before {
  content: "\\f120"; }

.fa-text-height:before {
  content: "\\f034"; }

.fa-text-width:before {
  content: "\\f035"; }

.fa-th:before {
  content: "\\f00a"; }

.fa-th-large:before {
  content: "\\f009"; }

.fa-th-list:before {
  content: "\\f00b"; }

.fa-the-red-yeti:before {
  content: "\\f69d"; }

.fa-theater-masks:before {
  content: "\\f630"; }

.fa-themeco:before {
  content: "\\f5c6"; }

.fa-themeisle:before {
  content: "\\f2b2"; }

.fa-thermometer:before {
  content: "\\f491"; }

.fa-thermometer-empty:before {
  content: "\\f2cb"; }

.fa-thermometer-full:before {
  content: "\\f2c7"; }

.fa-thermometer-half:before {
  content: "\\f2c9"; }

.fa-thermometer-quarter:before {
  content: "\\f2ca"; }

.fa-thermometer-three-quarters:before {
  content: "\\f2c8"; }

.fa-think-peaks:before {
  content: "\\f731"; }

.fa-thumbs-down:before {
  content: "\\f165"; }

.fa-thumbs-up:before {
  content: "\\f164"; }

.fa-thumbtack:before {
  content: "\\f08d"; }

.fa-ticket-alt:before {
  content: "\\f3ff"; }

.fa-times:before {
  content: "\\f00d"; }

.fa-times-circle:before {
  content: "\\f057"; }

.fa-tint:before {
  content: "\\f043"; }

.fa-tint-slash:before {
  content: "\\f5c7"; }

.fa-tired:before {
  content: "\\f5c8"; }

.fa-toggle-off:before {
  content: "\\f204"; }

.fa-toggle-on:before {
  content: "\\f205"; }

.fa-toilet:before {
  content: "\\f7d8"; }

.fa-toilet-paper:before {
  content: "\\f71e"; }

.fa-toilet-paper-slash:before {
  content: "\\f972"; }

.fa-toolbox:before {
  content: "\\f552"; }

.fa-tools:before {
  content: "\\f7d9"; }

.fa-tooth:before {
  content: "\\f5c9"; }

.fa-torah:before {
  content: "\\f6a0"; }

.fa-torii-gate:before {
  content: "\\f6a1"; }

.fa-tractor:before {
  content: "\\f722"; }

.fa-trade-federation:before {
  content: "\\f513"; }

.fa-trademark:before {
  content: "\\f25c"; }

.fa-traffic-light:before {
  content: "\\f637"; }

.fa-trailer:before {
  content: "\\f941"; }

.fa-train:before {
  content: "\\f238"; }

.fa-tram:before {
  content: "\\f7da"; }

.fa-transgender:before {
  content: "\\f224"; }

.fa-transgender-alt:before {
  content: "\\f225"; }

.fa-trash:before {
  content: "\\f1f8"; }

.fa-trash-alt:before {
  content: "\\f2ed"; }

.fa-trash-restore:before {
  content: "\\f829"; }

.fa-trash-restore-alt:before {
  content: "\\f82a"; }

.fa-tree:before {
  content: "\\f1bb"; }

.fa-trello:before {
  content: "\\f181"; }

.fa-tripadvisor:before {
  content: "\\f262"; }

.fa-trophy:before {
  content: "\\f091"; }

.fa-truck:before {
  content: "\\f0d1"; }

.fa-truck-loading:before {
  content: "\\f4de"; }

.fa-truck-monster:before {
  content: "\\f63b"; }

.fa-truck-moving:before {
  content: "\\f4df"; }

.fa-truck-pickup:before {
  content: "\\f63c"; }

.fa-tshirt:before {
  content: "\\f553"; }

.fa-tty:before {
  content: "\\f1e4"; }

.fa-tumblr:before {
  content: "\\f173"; }

.fa-tumblr-square:before {
  content: "\\f174"; }

.fa-tv:before {
  content: "\\f26c"; }

.fa-twitch:before {
  content: "\\f1e8"; }

.fa-twitter:before {
  content: "\\f099"; }

.fa-twitter-square:before {
  content: "\\f081"; }

.fa-typo3:before {
  content: "\\f42b"; }

.fa-uber:before {
  content: "\\f402"; }

.fa-ubuntu:before {
  content: "\\f7df"; }

.fa-uikit:before {
  content: "\\f403"; }

.fa-umbraco:before {
  content: "\\f8e8"; }

.fa-umbrella:before {
  content: "\\f0e9"; }

.fa-umbrella-beach:before {
  content: "\\f5ca"; }

.fa-underline:before {
  content: "\\f0cd"; }

.fa-undo:before {
  content: "\\f0e2"; }

.fa-undo-alt:before {
  content: "\\f2ea"; }

.fa-uniregistry:before {
  content: "\\f404"; }

.fa-unity:before {
  content: "\\f949"; }

.fa-universal-access:before {
  content: "\\f29a"; }

.fa-university:before {
  content: "\\f19c"; }

.fa-unlink:before {
  content: "\\f127"; }

.fa-unlock:before {
  content: "\\f09c"; }

.fa-unlock-alt:before {
  content: "\\f13e"; }

.fa-untappd:before {
  content: "\\f405"; }

.fa-upload:before {
  content: "\\f093"; }

.fa-ups:before {
  content: "\\f7e0"; }

.fa-usb:before {
  content: "\\f287"; }

.fa-user:before {
  content: "\\f007"; }

.fa-user-alt:before {
  content: "\\f406"; }

.fa-user-alt-slash:before {
  content: "\\f4fa"; }

.fa-user-astronaut:before {
  content: "\\f4fb"; }

.fa-user-check:before {
  content: "\\f4fc"; }

.fa-user-circle:before {
  content: "\\f2bd"; }

.fa-user-clock:before {
  content: "\\f4fd"; }

.fa-user-cog:before {
  content: "\\f4fe"; }

.fa-user-edit:before {
  content: "\\f4ff"; }

.fa-user-friends:before {
  content: "\\f500"; }

.fa-user-graduate:before {
  content: "\\f501"; }

.fa-user-injured:before {
  content: "\\f728"; }

.fa-user-lock:before {
  content: "\\f502"; }

.fa-user-md:before {
  content: "\\f0f0"; }

.fa-user-minus:before {
  content: "\\f503"; }

.fa-user-ninja:before {
  content: "\\f504"; }

.fa-user-nurse:before {
  content: "\\f82f"; }

.fa-user-plus:before {
  content: "\\f234"; }

.fa-user-secret:before {
  content: "\\f21b"; }

.fa-user-shield:before {
  content: "\\f505"; }

.fa-user-slash:before {
  content: "\\f506"; }

.fa-user-tag:before {
  content: "\\f507"; }

.fa-user-tie:before {
  content: "\\f508"; }

.fa-user-times:before {
  content: "\\f235"; }

.fa-users:before {
  content: "\\f0c0"; }

.fa-users-cog:before {
  content: "\\f509"; }

.fa-usps:before {
  content: "\\f7e1"; }

.fa-ussunnah:before {
  content: "\\f407"; }

.fa-utensil-spoon:before {
  content: "\\f2e5"; }

.fa-utensils:before {
  content: "\\f2e7"; }

.fa-vaadin:before {
  content: "\\f408"; }

.fa-vector-square:before {
  content: "\\f5cb"; }

.fa-venus:before {
  content: "\\f221"; }

.fa-venus-double:before {
  content: "\\f226"; }

.fa-venus-mars:before {
  content: "\\f228"; }

.fa-viacoin:before {
  content: "\\f237"; }

.fa-viadeo:before {
  content: "\\f2a9"; }

.fa-viadeo-square:before {
  content: "\\f2aa"; }

.fa-vial:before {
  content: "\\f492"; }

.fa-vials:before {
  content: "\\f493"; }

.fa-viber:before {
  content: "\\f409"; }

.fa-video:before {
  content: "\\f03d"; }

.fa-video-slash:before {
  content: "\\f4e2"; }

.fa-vihara:before {
  content: "\\f6a7"; }

.fa-vimeo:before {
  content: "\\f40a"; }

.fa-vimeo-square:before {
  content: "\\f194"; }

.fa-vimeo-v:before {
  content: "\\f27d"; }

.fa-vine:before {
  content: "\\f1ca"; }

.fa-virus:before {
  content: "\\f974"; }

.fa-virus-slash:before {
  content: "\\f975"; }

.fa-viruses:before {
  content: "\\f976"; }

.fa-vk:before {
  content: "\\f189"; }

.fa-vnv:before {
  content: "\\f40b"; }

.fa-voicemail:before {
  content: "\\f897"; }

.fa-volleyball-ball:before {
  content: "\\f45f"; }

.fa-volume-down:before {
  content: "\\f027"; }

.fa-volume-mute:before {
  content: "\\f6a9"; }

.fa-volume-off:before {
  content: "\\f026"; }

.fa-volume-up:before {
  content: "\\f028"; }

.fa-vote-yea:before {
  content: "\\f772"; }

.fa-vr-cardboard:before {
  content: "\\f729"; }

.fa-vuejs:before {
  content: "\\f41f"; }

.fa-walking:before {
  content: "\\f554"; }

.fa-wallet:before {
  content: "\\f555"; }

.fa-warehouse:before {
  content: "\\f494"; }

.fa-water:before {
  content: "\\f773"; }

.fa-wave-square:before {
  content: "\\f83e"; }

.fa-waze:before {
  content: "\\f83f"; }

.fa-weebly:before {
  content: "\\f5cc"; }

.fa-weibo:before {
  content: "\\f18a"; }

.fa-weight:before {
  content: "\\f496"; }

.fa-weight-hanging:before {
  content: "\\f5cd"; }

.fa-weixin:before {
  content: "\\f1d7"; }

.fa-whatsapp:before {
  content: "\\f232"; }

.fa-whatsapp-square:before {
  content: "\\f40c"; }

.fa-wheelchair:before {
  content: "\\f193"; }

.fa-whmcs:before {
  content: "\\f40d"; }

.fa-wifi:before {
  content: "\\f1eb"; }

.fa-wikipedia-w:before {
  content: "\\f266"; }

.fa-wind:before {
  content: "\\f72e"; }

.fa-window-close:before {
  content: "\\f410"; }

.fa-window-maximize:before {
  content: "\\f2d0"; }

.fa-window-minimize:before {
  content: "\\f2d1"; }

.fa-window-restore:before {
  content: "\\f2d2"; }

.fa-windows:before {
  content: "\\f17a"; }

.fa-wine-bottle:before {
  content: "\\f72f"; }

.fa-wine-glass:before {
  content: "\\f4e3"; }

.fa-wine-glass-alt:before {
  content: "\\f5ce"; }

.fa-wix:before {
  content: "\\f5cf"; }

.fa-wizards-of-the-coast:before {
  content: "\\f730"; }

.fa-wolf-pack-battalion:before {
  content: "\\f514"; }

.fa-won-sign:before {
  content: "\\f159"; }

.fa-wordpress:before {
  content: "\\f19a"; }

.fa-wordpress-simple:before {
  content: "\\f411"; }

.fa-wpbeginner:before {
  content: "\\f297"; }

.fa-wpexplorer:before {
  content: "\\f2de"; }

.fa-wpforms:before {
  content: "\\f298"; }

.fa-wpressr:before {
  content: "\\f3e4"; }

.fa-wrench:before {
  content: "\\f0ad"; }

.fa-x-ray:before {
  content: "\\f497"; }

.fa-xbox:before {
  content: "\\f412"; }

.fa-xing:before {
  content: "\\f168"; }

.fa-xing-square:before {
  content: "\\f169"; }

.fa-y-combinator:before {
  content: "\\f23b"; }

.fa-yahoo:before {
  content: "\\f19e"; }

.fa-yammer:before {
  content: "\\f840"; }

.fa-yandex:before {
  content: "\\f413"; }

.fa-yandex-international:before {
  content: "\\f414"; }

.fa-yarn:before {
  content: "\\f7e3"; }

.fa-yelp:before {
  content: "\\f1e9"; }

.fa-yen-sign:before {
  content: "\\f157"; }

.fa-yin-yang:before {
  content: "\\f6ad"; }

.fa-yoast:before {
  content: "\\f2b1"; }

.fa-youtube:before {
  content: "\\f167"; }

.fa-youtube-square:before {
  content: "\\f431"; }

.fa-zhihu:before {
  content: "\\f63f"; }

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto; }

@font-face {
  font-family: 'Font Awesome 5 Brands';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg"); }

.fab {
  font-family: 'Font Awesome 5 Brands';
  font-weight: 400; }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg"); }

.far {
  font-family: 'Font Awesome 5 Free';
  font-weight: 400; }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg"); }

.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900; }

/* CSS Switch */
input.switch {
  display: none; }
  input.switch + label {
    font-size: 1em;
    line-height: 1;
    width: 56px;
    height: 24px;
    background-color: #ced4da;
    background-image: none;
    border-radius: 2rem;
    padding: 0.16667rem;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    position: relative;
    font-weight: 500;
    transition: all 0.1s ease-in-out; }
    input.switch + label:before {
      color: #343a40;
      content: attr(data-off-label);
      display: block;
      font-family: inherit;
      font-weight: 500;
      font-size: 12px;
      line-height: 21px;
      position: absolute;
      right: 1px;
      margin: 3px;
      top: -2px;
      text-align: center;
      min-width: 1.66667rem;
      overflow: hidden;
      transition: all 0.1s ease-in-out; }
    input.switch + label:after {
      content: '';
      position: absolute;
      left: 3px;
      background-color: #eff2f7;
      box-shadow: none;
      border-radius: 2rem;
      height: 20px;
      width: 20px;
      top: 2px;
      transition: all 0.1s ease-in-out; }
  input.switch:checked + label {
    background-color: #556ee6; }

input.switch:checked + label {
  background-color: #556ee6; }
  input.switch:checked + label:before {
    color: #fff;
    content: attr(data-on-label);
    right: auto;
    left: 3px; }
  input.switch:checked + label:after {
    left: 33px;
    background-color: #eff2f7; }

input.switch-bool + label {
  background-color: #f46a6a; }

input.switch-bool + label:before, input.switch-bool:checked + label:before,
input[switch="default"]:checked + label:before {
  color: #fff; }

input.switch-bool:checked + label {
  background-color: #34c38f; }

input.switch-default:checked + label {
  background-color: #a2a2a2; }

input.switch-primary:checked + label {
  background-color: #556ee6; }

input.switch-success:checked + label {
  background-color: #34c38f; }

input.switch-info:checked + label {
  background-color: #50a5f1; }

input.switch-warning:checked + label {
  background-color: #f1b44c; }

input.switch-danger:checked + label {
  background-color: #f46a6a; }

input.switch-dark:checked + label {
  background-color: #343a40; }
  input.switch-dark:checked + label:before {
    color: #eff2f7; }

.square-switch {
  margin-right: 7px; }
  .square-switch input.switch + label, .square-switch input.switch + label:after {
    border-radius: 4px; }

.sp-container {
  background-color: var(--bs-secondary-bg); }
  .sp-container button {
    padding: .25rem .5rem;
    font-size: .71094rem;
    border-radius: .2rem;
    font-weight: 400;
    color: #343a40; }
    .sp-container button.sp-palette-toggle {
      background-color: #eff2f7; }
    .sp-container button.sp-choose {
      background-color: #34c38f;
      margin-left: 5px;
      margin-right: 0; }

.sp-palette-container {
  border-right: 1px solid #eff2f7; }

.sp-input {
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color-translucent) !important;
  color: var(--bs-emphasis-color); }
  .sp-input:focus {
    outline: none; }

[dir="rtl"] .sp-alpha {
  direction: ltr; }

[dir="rtl"] .sp-original-input-container .sp-add-on {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important; }

[dir="rtl"] input.spectrum.with-add-on {
  border: 1px solid var(--bs-border-color-translucent);
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: var(--bs-border-radius);
  border-bottom-right-radius: var(--bs-border-radius); }

/* Timepicker */
.bootstrap-timepicker-widget table td a {
  color: var(--bs-emphasis-color); }
  .bootstrap-timepicker-widget table td a:hover {
    background-color: transparent;
    border-color: transparent;
    border-radius: 4px;
    color: #556ee6;
    text-decoration: none; }

.bootstrap-timepicker-widget table td input {
  width: 32px;
  height: 32px;
  border: 0;
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-secondary-bg); }

.bootstrap-timepicker-widget.dropdown-menu:after {
  border-bottom-color: var(--bs-gray-200); }

.bootstrap-timepicker-widget.timepicker-orient-bottom:after {
  border-top-color: var(--bs-gray-200); }

.timepicker-orient-top {
  top: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2)) !important; }

.timepicker-orient-bottom {
  top: auto !important;
  bottom: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2)) !important; }

.bootstrap-timepicker-widget {
  left: 0 !important;
  right: auto !important; }

.bootstrap-timepicker-widget.timepicker-orient-left:before {
  left: 6px;
  right: auto; }

.bootstrap-timepicker-widget.timepicker-orient-left::after {
  left: 7px;
  right: auto; }

.datepicker {
  border: 1px solid var(--bs-border-color);
  padding: 8px;
  z-index: 999 !important; }
  .datepicker table tr th {
    font-weight: 500; }
  .datepicker table tr td.active, .datepicker table tr td.active:hover, .datepicker table tr td .active.disabled, .datepicker table tr td.active.disabled:hover, .datepicker table tr td.today, .datepicker table tr td.today:hover, .datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:hover, .datepicker table tr td.selected, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.disabled, .datepicker table tr td.selected.disabled:hover,
  .datepicker table tr td span.active.active, .datepicker table tr td span.active:hover.active {
    background-color: #556ee6 !important;
    background-image: none;
    box-shadow: none;
    color: #fff !important; }
  .datepicker table tr td.day.focused, .datepicker table tr td.day:hover,
  .datepicker table tr td span.focused,
  .datepicker table tr td span:hover {
    background: var(--bs-light); }
  .datepicker table tr td.new, .datepicker table tr td.old,
  .datepicker table tr td span.new,
  .datepicker table tr td span.old {
    color: var(--bs-gray-500);
    opacity: 0.6; }
  .datepicker table tr td.range, .datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:hover, .datepicker table tr td.range:hover {
    background-color: var(--bs-tertiary-bg); }

.table-condensed > thead > tr > th, .table-condensed > tbody > tr > td {
  padding: 7px; }

.bootstrap-datepicker-inline .datepicker-inline {
  width: auto !important;
  display: inline-block; }

.datepicker-container {
  border: 1px solid var(--bs-border-color);
  box-shadow: none;
  background-color: var(--bs-secondary-bg); }
  .datepicker-container.datepicker-inline {
    width: 212px; }

.datepicker {
  color: var(--bs-secondary-color); }
  .datepicker .datepicker-switch:hover, .datepicker .next:hover, .datepicker .prev:hover, .datepicker tfoot tr th:hover {
    background: var(--bs-light); }

.datepicker-panel > ul > li {
  background-color: var(--bs-secondary-bg);
  border-radius: 4px; }
  .datepicker-panel > ul > li.picked, .datepicker-panel > ul > li.picked:hover {
    background-color: rgba(85, 110, 230, 0.25);
    color: #556ee6; }
  .datepicker-panel > ul > li.highlighted, .datepicker-panel > ul > li.highlighted:hover, .datepicker-panel > ul > li:hover {
    background-color: #556ee6;
    color: #fff; }
  .datepicker-panel > ul > li.muted, .datepicker-panel > ul > li.muted:hover {
    color: var(--bs-gray-500);
    opacity: 0.6; }

.datepicker-panel > ul[data-view=week] > li {
  font-weight: 500; }

.datepicker-panel > ul[data-view=week] > li, .datepicker-panel > ul[data-view=week] > li:hover {
  background-color: var(--bs-secondary-bg); }

.bootstrap-touchspin.input-group > .input-group-prepend > .btn,
.bootstrap-touchspin.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.bootstrap-touchspin.input-group > .input-group-append > .btn,
.bootstrap-touchspin.input-group > .input-group-append > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.tox-tinymce {
  border: 1px solid var(--bs-border-color-translucent) !important; }

.tox :not(svg):not(rect) {
  color: var(--bs-body-color); }

.tox {
  color: var(--bs-body-color); }
  .tox .tox-collection__item {
    color: var(--bs-body-color) !important; }
  .tox .tox-menu.tox-collection.tox-collection--list.tox-selected-menu,
  .tox .tox-collection--toolbar.tox-collection--toolbar-lg.tox-selected-menu,
  .tox .tox-swatches-menu.tox-selected-menu {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    animation-name: DropDownSlide !important;
    animation-duration: 0.3s !important;
    animation-fill-mode: both !important;
    margin: 0 !important;
    position: absolute !important;
    z-index: 1000 !important;
    padding: 0.5rem 0 !important;
    background-color: var(--bs-custom-white) !important;
    border: 0 solid var(--bs-border-color) !important;
    border-radius: 0.25rem !important; }
  .tox .tox-collection--list .tox-collection__group {
    border-color: var(--bs-border-color) !important; }
  .tox .tox-collection--list .tox-collection__item--active {
    color: var(--bs-emphasis-color) !important;
    background-color: var(--bs-tertiary-bg) !important; }
  .tox .tox-collection__group-heading {
    color: var(--bs-emphasis-color) !important;
    background-color: var(--bs-tertiary-bg) !important; }
  .tox .tox-statusbar {
    border-top: 1px solid var(--bs-border-top) !important; }
  .tox .tox-menubar,
  .tox .tox-edit-area__iframe,
  .tox .tox-statusbar {
    background-color: var(--bs-custom-white) !important;
    background: none !important; }
  .tox .tox-mbtn {
    color: var(--bs-gray-600) !important; }
    .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
      background-color: var(--bs-light) !important; }
  .tox .tox-tbtn:hover {
    background-color: transparent !important; }
  .tox .tox-toolbar,
  .tox .tox-toolbar__overflow,
  .tox .tox-toolbar__primary {
    background: var(--bs-light) !important; }
  .tox .tox-toolbar__primary {
    border-top-color: var(--bs-light) !important; }
  .tox .tox-tbtn--enabled {
    background: transparent !important; }
  .tox tox-split-button:focus {
    background: transparent !important; }
  .tox .tox-tbtn {
    color: transparent !important; }
    .tox .tox-tbtn svg {
      fill: var(--bs-gray-700) !important; }
  .tox .tox-edit-area__iframe {
    background-color: var(--bs-custom-white) !important; }
  .tox .tox-statusbar a,
  .tox .tox-statusbar__path-item,
  .tox .tox-statusbar__wordcount {
    color: var(--bs-gray-700) !important; }
  .tox:not([dir="rtl"]) .tox-toolbar__group:not(:last-of-type) {
    border-right: 1px solid var(--bs-border-color) !important; }
  .tox .tox-dialog {
    background-color: var(--bs-custom-white) !important; }
  .tox .tox-button:hover {
    background-color: #556ee6 !important;
    background-image: none !important;
    border-color: #556ee6 !important;
    box-shadow: none !important; }
  .tox .tox-collection--toolbar .tox-collection__item--active {
    background-color: var(--bs-gray-300) !important; }
  .tox .tox-dialog__header {
    background-color: var(--bs-custom-white) !important; }
  .tox .tox-dialog__footer {
    background-color: var(--bs-custom-white) !important; }
  .tox .tox-icon {
    color: var(--bs-dark) !important; }
  .tox .tox-textfield {
    background-color: var(--bs-secondary-bg) !important;
    color: var(--bs-emphasis-color) !important; }

.tox .tox-collection__item-checkmark svg,
.tox .tox-collection__item-icon svg {
  color: var(--bs-gray-800); }

.editable-input .form-control {
  display: inline-block; }

.editable-buttons {
  margin-left: 7px; }
  .editable-buttons .editable-cancel {
    margin-left: 7px; }

/* Dropzone */
.dropzone {
  min-height: 230px;
  border: 2px dashed var(--bs-border-color);
  background: var(--bs-secondary-bg);
  border-radius: 6px; }
  .dropzone .dz-message {
    font-size: 24px;
    width: 100%;
    margin: 3rem 0; }

.dropzone .dz-message {
  margin: 0; }

.form-wizard-wrapper label {
  font-size: 14px;
  text-align: right; }

.wizard .steps > ul {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  @media (max-width: 1199.98px) {
    .wizard .steps > ul {
      flex-direction: column; } }
  .wizard .steps > ul > a, .wizard .steps > ul > li {
    flex-basis: 0;
    flex-grow: 1; }
  .wizard .steps > ul > li {
    width: 100%; }
    .wizard .steps > ul > li a {
      display: block;
      padding: .5rem 1rem;
      color: var(--bs-secondary-color);
      font-weight: 500;
      background-color: rgba(85, 110, 230, 0.1); }
  .wizard .steps > ul .current-info {
    position: absolute;
    left: -999em; }

.wizard .steps .number {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 34px;
  border: 2px solid #556ee6;
  color: #556ee6;
  text-align: center;
  border-radius: 50%;
  margin-right: .5rem; }

.wizard .steps .current a, .wizard .steps .current a:active, .wizard .steps .current a:hover {
  background-color: rgba(85, 110, 230, 0.2);
  color: var(--bs-emphasis-color); }
  .wizard .steps .current a .number, .wizard .steps .current a:active .number, .wizard .steps .current a:hover .number {
    background-color: #556ee6;
    color: #fff; }

.wizard > .content {
  background-color: transparent;
  padding: 14px;
  margin-top: 0;
  border-radius: 0;
  min-height: 150px; }
  .wizard > .content > .title {
    position: absolute;
    left: -999em; }
  .wizard > .content > .body {
    width: 100%;
    height: 100%;
    padding: 14px 0 0;
    position: static; }

.wizard > .actions {
  position: relative;
  display: block;
  text-align: right;
  width: 100%; }
  .wizard > .actions > ul {
    display: block;
    text-align: right;
    padding-left: 0; }
    .wizard > .actions > ul > li {
      display: inline-block;
      margin: 0 0.5em; }
  .wizard > .actions a, .wizard > .actions a:active, .wizard > .actions a:hover {
    background-color: #556ee6;
    border-radius: 4px;
    padding: 8px 15px;
    color: #fff; }
  .wizard > .actions .disabled a, .wizard > .actions .disabled a:active, .wizard > .actions .disabled a:hover {
    opacity: .65;
    background-color: #556ee6;
    color: #fff;
    cursor: not-allowed; }

.wizard.vertical-wizard {
  display: flex;
  flex-wrap: wrap; }
  .wizard.vertical-wizard .steps > ul {
    flex-direction: column; }
    .wizard.vertical-wizard .steps > ul > li {
      width: 100% !important; }
  .wizard.vertical-wizard .steps, .wizard.vertical-wizard .content, .wizard.vertical-wizard .actions {
    width: 100%; }
  @media (min-width: 1200px) {
    .wizard.vertical-wizard .steps {
      width: 25%; } }
  .wizard.vertical-wizard .content {
    padding: 24px; }
    @media (min-width: 1200px) {
      .wizard.vertical-wizard .content {
        width: 75%;
        padding: 12px 24px; } }
    .wizard.vertical-wizard .content > .body {
      padding: 0; }

/* 
Datatable
*/
div.dataTables_wrapper div.dataTables_filter {
  text-align: right; }
  @media (max-width: 767px) {
    div.dataTables_wrapper div.dataTables_filter {
      text-align: center; } }
  div.dataTables_wrapper div.dataTables_filter input {
    margin-left: 0.5em;
    margin-right: 0; }

.table.dataTable,
table.dataTable {
  border-collapse: collapse !important; }
  .table.dataTable.dtr-inline.collapsed > tbody > tr > td,
  table.dataTable.dtr-inline.collapsed > tbody > tr > td {
    position: relative; }
    .table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control,
    table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control {
      padding-left: 30px; }
      .table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before,
      table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before {
        top: 50%;
        left: 5px;
        height: 14px;
        width: 14px;
        margin-top: -9px;
        display: block;
        position: absolute;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 14px;
        box-sizing: content-box;
        text-align: center;
        text-indent: 0 !important;
        line-height: 14px;
        content: '+';
        background-color: #556ee6; }

.table-rep-plugin .btn-toolbar {
  display: block; }

.table-rep-plugin .table-responsive {
  border: none !important; }

.table-rep-plugin .btn-group .btn-default {
  background-color: #74788d;
  color: #eff2f7;
  border: 1px solid #74788d; }
  .table-rep-plugin .btn-group .btn-default.btn-primary {
    background-color: #556ee6;
    border-color: #556ee6;
    color: #fff;
    box-shadow: 0 0 0 2px rgba(85, 110, 230, 0.5); }

.table-rep-plugin .btn-group.pull-right {
  float: right; }
  .table-rep-plugin .btn-group.pull-right .dropdown-menu {
    right: 0;
    transform: none !important;
    top: 100% !important; }

.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal; }

.table-rep-plugin .checkbox-row {
  padding-left: 40px;
  color: var(--bs-body-color) !important; }
  .table-rep-plugin .checkbox-row:hover {
    background-color: #f6f8fa !important; }
  .table-rep-plugin .checkbox-row label {
    display: inline-block;
    padding-left: 5px;
    position: relative; }
    .table-rep-plugin .checkbox-row label::before {
      -o-transition: 0.3s ease-in-out;
      -webkit-transition: 0.3s ease-in-out;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #f6f6f6;
      content: "";
      display: inline-block;
      height: 17px;
      left: 0;
      margin-left: -20px;
      position: absolute;
      transition: 0.3s ease-in-out;
      width: 17px;
      outline: none !important; }
    .table-rep-plugin .checkbox-row label::after {
      color: #eff2f7;
      display: inline-block;
      font-size: 11px;
      height: 16px;
      left: 0;
      margin-left: -20px;
      padding-left: 3px;
      padding-top: 1px;
      position: absolute;
      top: -1px;
      width: 16px; }
  .table-rep-plugin .checkbox-row input[type="checkbox"] {
    cursor: pointer;
    opacity: 0;
    z-index: 1;
    outline: none !important; }
    .table-rep-plugin .checkbox-row input[type="checkbox"]:disabled + label {
      opacity: 0.65; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:focus + label::before {
    outline-offset: -2px;
    outline: none; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::after {
    content: "\\f00c";
    font-family: 'Font Awesome 5 Free';
    font-weight: 900; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:disabled + label::before {
    background-color: #f8f9fa;
    cursor: not-allowed; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::before {
    background-color: #556ee6;
    border-color: #556ee6; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::after {
    color: #fff; }

.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 70px !important;
  background-color: #556ee6; }
  .table-rep-plugin .fixed-solution .sticky-table-header table {
    color: #fff; }

.table-rep-plugin table.focus-on tbody tr.focused th,
.table-rep-plugin table.focus-on tbody tr.focused td,
.table-rep-plugin .sticky-table-header {
  background: #556ee6;
  border-color: #556ee6;
  color: #fff; }
  .table-rep-plugin table.focus-on tbody tr.focused th table,
  .table-rep-plugin table.focus-on tbody tr.focused td table,
  .table-rep-plugin .sticky-table-header table {
    color: #fff; }

.table-rep-plugin table.focus-on tbody tr.unfocused th,
.table-rep-plugin table.focus-on tfoot tr.unfocused th,
.table-rep-plugin table.focus-on tbody tr.unfocused td,
.table-rep-plugin table.focus-on tfoot tr.unfocused td {
  color: var(--bs-body-color); }

@media (min-width: 992px) {
  body[data-layout="horizontal"] .fixed-solution .sticky-table-header {
    top: 120px !important; } }

.table-edits input, .table-edits select {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--bs-border-color-translucent);
  background-color: var(--bs-secondary-bg);
  color: var(--bs-emphasis-color);
  border-radius: var(--bs-border-radius); }
  .table-edits input:focus, .table-edits select:focus {
    outline: none;
    border-color: rgba(var(--bs-body-color-rgb), 0.2); }

.apex-charts {
  min-height: 10px !important; }
  .apex-charts text {
    font-family: var(--bs-font-sans-serif) !important;
    fill: var(--bs-gray-500); }
  .apex-charts .apexcharts-canvas {
    margin: 0 auto; }

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--bs-font-sans-serif) !important; }

.apexcharts-legend-series {
  font-weight: 500; }

.apexcharts-gridline {
  pointer-events: none;
  stroke: var(--bs-border-color); }

.apexcharts-legend-text {
  color: #74788d !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-size: 13px !important; }

.apexcharts-pie-label {
  fill: #fff !important; }

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: var(--bs-secondary-color); }

.apexcharts-gridline {
  stroke: var(--bs-border-color); }

.apexcharts-radialbar-track.apexcharts-track path {
  stroke: var(--bs-border-color); }

.apexcharts-tooltip {
  background-color: var(--bs-secondary-bg) !important;
  border: 1px solid var(--bs-border-color) !important; }
  .apexcharts-tooltip .apexcharts-tooltip-title {
    background-color: var(--bs-border-color) !important;
    border-bottom: 1px solid var(--bs-border-color) !important; }

.apexcharts-pie-label {
  fill: var(--bs-white) !important; }

.apexcharts-xaxis-tick {
  stroke: var(--bs-border-color); }

.e-charts {
  height: 350px; }

/* Flot chart */
.flot-charts-height {
  height: 320px; }

.flotTip {
  padding: 8px 12px;
  background-color: rgba(52, 58, 64, 0.9);
  z-index: 100;
  color: #f8f9fa;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border-radius: 4px; }

.legendLabel {
  color: #adb5bd; }

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #343a40 !important;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #212529 !important; }

.jqsfield {
  color: #eff2f7 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-weight: 500 !important; }

.gmaps, .gmaps-panaroma {
  height: 300px !important;
  background: #f8f9fa;
  border-radius: 3px; }

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #556ee6;
  border-radius: 4px;
  padding: 10px 20px; }

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute; }
  .gmaps-overlay_arrow.above {
    bottom: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #556ee6; }
  .gmaps-overlay_arrow.below {
    top: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 16px solid #556ee6; }

.jvectormap-label {
  border: none;
  background: #343a40;
  color: #f8f9fa;
  font-family: var(--bs-font-sans-serif);
  font-size: 0.8125rem;
  padding: 5px 8px; }

.leaflet-map {
  height: 300px; }
  .leaflet-map.leaflet-container {
    z-index: 99; }

.home-btn {
  position: absolute;
  top: 15px;
  right: 25px; }

.auth-logo .auth-logo-dark {
  display: var(--bs-display-block); }

.auth-logo .auth-logo-light {
  display: var(--bs-display-none); }

.auth-body-bg {
  background-color: var(--bs-secondary-bg); }

.auth-pass-inputgroup input[type="input"] + .btn .mdi-eye-outline:before {
  content: "\\F06D1"; }

.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex; }
  @media (min-width: 1200px) {
    .auth-full-bg {
      height: 100vh; } }
  .auth-full-bg::before {
    content: "";
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%; }
  .auth-full-bg .bg-overlay {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }

.auth-full-page-content {
  display: flex; }
  @media (min-width: 1200px) {
    .auth-full-page-content {
      min-height: 100vh; } }

.auth-review-carousel.owl-theme .owl-dots .owl-dot span {
  background-color: rgba(85, 110, 230, 0.25); }

.auth-review-carousel.owl-theme .owl-dots .owl-dot.active span, .auth-review-carousel.owl-theme .owl-dots .owl-dot:hover span {
  background-color: #556ee6; }

.search-box .form-control {
  border-radius: 0px;
  padding-left: 40px; }

.search-box .search-icon {
  font-size: 16px;
  position: absolute;
  left: 13px;
  top: 0;
  line-height: 38px; }

.product-list li a {
  display: block;
  padding: 4px 0px;
  color: var(--bs-body-color); }

.product-view-nav.nav-pills .nav-item {
  margin-left: 4px; }

.product-view-nav.nav-pills .nav-link {
  width: 36px;
  height: 36px;
  font-size: 16px;
  padding: 0;
  line-height: 36px;
  text-align: center;
  border-radius: 50%; }

.product-ribbon {
  position: absolute;
  right: 0px;
  top: 0px; }

.product-detai-imgs .nav .nav-link {
  margin: 7px 0px; }
  .product-detai-imgs .nav .nav-link.active {
    background-color: var(--bs-tertiary-bg); }

.product-color a {
  display: inline-block;
  text-align: center;
  color: var(--bs-body-color); }
  .product-color a .product-color-item {
    margin: 7px; }
  .product-color a.active, .product-color a:hover {
    color: #556ee6; }
    .product-color a.active .product-color-item, .product-color a:hover .product-color-item {
      border-color: #556ee6 !important; }

.visa-card .visa-logo {
  line-height: 0.5; }

.visa-card .visa-pattern {
  position: absolute;
  font-size: 385px;
  color: rgba(255, 255, 255, 0.05);
  line-height: 0.4;
  right: 0px;
  bottom: 0px; }

.checkout-tabs .nav-pills .nav-link {
  margin-bottom: 24px;
  text-align: center;
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  .checkout-tabs .nav-pills .nav-link.active {
    background-color: #556ee6; }
  .checkout-tabs .nav-pills .nav-link .check-nav-icon {
    font-size: 36px; }

/* ==============
  Email
===================*/
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px; }

.email-rightbar {
  margin-left: 260px; }

.chat-user-box p.user-title {
  color: var(--bs-emphasis-color);
  font-weight: 500; }

.chat-user-box p {
  font-size: 12px; }

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%; }
  .email-rightbar {
    margin: 0; } }

.mail-list a {
  display: block;
  color: var(--bs-secondary-color);
  line-height: 24px;
  padding: 8px 5px; }
  .mail-list a.active {
    color: #f46a6a;
    font-weight: 500; }

.message-list {
  display: block;
  padding-left: 0; }
  .message-list li {
    position: relative;
    display: block;
    height: 50px;
    line-height: 50px;
    cursor: default;
    transition-duration: .3s; }
    .message-list li a {
      color: var(--bs-secondary-color); }
    .message-list li:hover {
      background: var(--bs-tertiary-bg);
      transition-duration: .05s; }
    .message-list li .col-mail {
      float: left;
      position: relative; }
    .message-list li .col-mail-1 {
      width: 320px; }
      .message-list li .col-mail-1 .star-toggle,
      .message-list li .col-mail-1 .checkbox-wrapper-mail,
      .message-list li .col-mail-1 .dot {
        display: block;
        float: left; }
      .message-list li .col-mail-1 .dot {
        border: 4px solid transparent;
        border-radius: 100px;
        margin: 22px 26px 0;
        height: 0;
        width: 0;
        line-height: 0;
        font-size: 0; }
      .message-list li .col-mail-1 .checkbox-wrapper-mail {
        margin: 15px 10px 0 20px; }
      .message-list li .col-mail-1 .star-toggle {
        margin-top: 18px;
        margin-left: 5px; }
      .message-list li .col-mail-1 .title {
        position: absolute;
        top: 0;
        left: 110px;
        right: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 0; }
    .message-list li .col-mail-2 {
      position: absolute;
      top: 0;
      left: 320px;
      right: 0;
      bottom: 0; }
      .message-list li .col-mail-2 .subject,
      .message-list li .col-mail-2 .date {
        position: absolute;
        top: 0; }
      .message-list li .col-mail-2 .subject {
        left: 0;
        right: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap; }
      .message-list li .col-mail-2 .date {
        right: 0;
        width: 170px;
        padding-left: 80px; }
    .message-list li.active, .message-list li.active:hover {
      box-shadow: inset 3px 0 0 #556ee6; }
    .message-list li.unread {
      background-color: var(--bs-tertiary-bg);
      font-weight: 500;
      color: var(--bs-body-color); }
      .message-list li.unread a {
        color: var(--bs-body-color);
        font-weight: 500; }
  .message-list .checkbox-wrapper-mail {
    cursor: pointer;
    height: 20px;
    width: 20px;
    position: relative;
    display: inline-block;
    background-color: var(--bs-secondary-bg);
    box-shadow: inset 0 0 0 1px var(--bs-border-color-translucent);
    border-radius: 1px; }
    .message-list .checkbox-wrapper-mail input {
      opacity: 0;
      cursor: pointer; }
    .message-list .checkbox-wrapper-mail input:checked ~ label {
      opacity: 1; }
    .message-list .checkbox-wrapper-mail label {
      position: absolute;
      height: 20px;
      width: 20px;
      left: 0;
      cursor: pointer;
      opacity: 0;
      margin-bottom: 0;
      transition-duration: .05s;
      top: 0; }
      .message-list .checkbox-wrapper-mail label:before {
        content: "\\F012C";
        font-family: "Material Design Icons";
        top: 0;
        height: 20px;
        color: var(--bs-body-color);
        width: 20px;
        position: absolute;
        margin-top: -16px;
        left: 4px;
        font-size: 13px; }

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px; } }

@media (min-width: 1200px) {
  .filemanager-sidebar {
    min-width: 230px;
    max-width: 230px; } }

@media (min-width: 1366px) {
  .filemanager-sidebar {
    min-width: 280px;
    max-width: 280px; } }

.categories-list {
  padding: 4px 0; }
  .categories-list li a {
    display: block;
    padding: 8px 12px;
    color: var(--bs-body-color);
    font-weight: 500; }
  .categories-list li.active a {
    color: #556ee6; }
  .categories-list li ul {
    padding-left: 16px; }
    .categories-list li ul li a {
      padding: 4px 12px;
      color: var(--bs-secondary-color);
      font-size: 13px;
      font-weight: 400; }

@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 260px; } }

@media (min-width: 1200px) {
  .chat-leftsidebar {
    min-width: 380px; } }

.chat-leftsidebar .chat-leftsidebar-nav .nav {
  background-color: var(--bs-secondary-bg); }

.chat-leftsidebar .chat-leftsidebar-nav .tab-content {
  min-height: 488px; }

.chat-noti-dropdown.active:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #f46a6a;
  border-radius: 50%;
  right: 0; }

.chat-noti-dropdown .btn {
  padding: 6px;
  box-shadow: none;
  font-size: 20px; }

.chat-search-box .form-control {
  border: 0; }

.chat-list {
  margin: 0; }
  .chat-list li.active a {
    background-color: var(--bs-secondary-bg);
    border-color: transparent;
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
  .chat-list li a {
    display: block;
    padding: 14px 16px;
    color: var(--bs-secondary-color);
    transition: all 0.4s;
    border-top: 1px solid var(--bs-border-color);
    border-radius: 4px; }
    .chat-list li a:hover {
      background-color: var(--bs-secondary-bg);
      border-color: transparent;
      box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }

.user-chat-nav .dropdown .nav-btn {
  color: var(--bs-body-color);
  height: 40px;
  width: 40px;
  line-height: 42px;
  box-shadow: none;
  padding: 0;
  font-size: 16px;
  background-color: var(--bs-light);
  border-radius: 50%;
  border: none; }

.user-chat-nav .dropdown .dropdown-menu {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  border: 1px solid var(--bs-border-color); }

.chat-conversation li {
  clear: both; }

.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px; }
  .chat-conversation .chat-day-title .title {
    background-color: var(--bs-secondary-bg);
    position: relative;
    z-index: 1;
    padding: 6px 24px; }
  .chat-conversation .chat-day-title:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    right: 0;
    background-color: var(--bs-border-color);
    top: 10px; }
  .chat-conversation .chat-day-title .badge {
    font-size: 12px; }

.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative; }
  .chat-conversation .conversation-list .ctext-wrap {
    padding: 12px 24px;
    background-color: rgba(85, 110, 230, 0.1);
    border-radius: 8px 8px 8px 0px;
    overflow: hidden; }
    .chat-conversation .conversation-list .ctext-wrap .conversation-name {
      font-weight: 600;
      color: #556ee6;
      margin-bottom: 4px; }
  .chat-conversation .conversation-list .dropdown {
    float: right; }
    .chat-conversation .conversation-list .dropdown .dropdown-toggle {
      font-size: 18px;
      padding: 4px;
      color: var(--bs-secondary-color); }
      @media (max-width: 575.98px) {
        .chat-conversation .conversation-list .dropdown .dropdown-toggle {
          display: none; } }
    .chat-conversation .conversation-list .dropdown .dropdown-menu {
      box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
      border: 1px solid var(--bs-border-color); }
  .chat-conversation .conversation-list .chat-time {
    font-size: 12px; }

.chat-conversation .right .conversation-list {
  float: right; }
  .chat-conversation .right .conversation-list .ctext-wrap {
    background-color: var(--bs-light);
    text-align: right;
    border-radius: 8px 8px 0px 8px; }
  .chat-conversation .right .conversation-list .dropdown {
    float: left; }
  .chat-conversation .right .conversation-list.last-chat .conversation-list:before {
    right: 0;
    left: auto; }

.chat-conversation .last-chat .conversation-list:before {
  content: "\\F0009";
  font-family: "Material Design Icons";
  position: absolute;
  color: #556ee6;
  right: 0;
  bottom: 0;
  font-size: 16px; }
  @media (max-width: 575.98px) {
    .chat-conversation .last-chat .conversation-list:before {
      display: none; } }

.chat-input-section {
  border-top: 1px solid var(--bs-border-color); }

.chat-input {
  border-radius: 30px;
  background-color: var(--bs-light) !important;
  border-color: var(--bs-light) !important;
  padding-right: 120px; }

.chat-input-links {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%); }
  .chat-input-links li a {
    font-size: 16px;
    line-height: 36px;
    padding: 0px 4px;
    display: inline-block; }

@media (max-width: 575.98px) {
  .chat-send {
    min-width: auto; } }

.project-list-table {
  border-collapse: separate;
  border-spacing: 0 12px; }
  .project-list-table tr {
    background-color: var(--bs-secondary-bg); }

.contact-links a {
  color: var(--bs-body-color); }

.profile-user-wid {
  margin-top: -26px; }

@media (min-width: 576px) {
  .currency-value {
    position: relative; }
    .currency-value:after {
      content: "\\F04E1";
      font-family: "Material Design Icons";
      font-size: 24px;
      position: absolute;
      width: 45px;
      height: 45px;
      line-height: 45px;
      border-radius: 50%;
      text-align: center;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: #556ee6;
      color: #fff;
      z-index: 9;
      right: -34px; } }

.crypto-buy-sell-nav-content {
  border: 2px solid var(--bs-border-color);
  border-top: 0; }

.kyc-doc-verification .dropzone {
  min-height: 180px; }
  .kyc-doc-verification .dropzone .dz-message {
    margin: 24px 0px; }

/******************
    Ico Landing
*******************/
.section {
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px; }
  .section.bg-white {
    background-color: var(--bs-secondary-bg) !important; }

.small-title {
  color: var(--bs-secondary-color);
  margin-bottom: 8px; }

.navigation {
  padding: 0 16px;
  width: 100%;
  z-index: 999;
  margin-bottom: 0px;
  transition: all 0.5s ease-in-out;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1); }
  @media (max-width: 991.98px) {
    .navigation {
      background-color: var(--bs-topnav-bg); } }
  .navigation .navbar-logo {
    line-height: 70px;
    transition: all 0.4s; }
    .navigation .navbar-logo .logo-dark {
      display: none; }
      @media (max-width: 991.98px) {
        .navigation .navbar-logo .logo-dark {
          display: block; } }
    .navigation .navbar-logo .logo-light {
      display: block; }
      @media (max-width: 991.98px) {
        .navigation .navbar-logo .logo-light {
          display: none; } }
  .navigation .navbar-nav .nav-item .nav-link {
    color: rgba(255, 255, 255, 0.6);
    line-height: 58px;
    padding: 6px 16px;
    font-weight: 500;
    transition: all 0.4s; }
    @media (max-width: 991.98px) {
      .navigation .navbar-nav .nav-item .nav-link {
        color: var(--bs-header-item-color); } }
    .navigation .navbar-nav .nav-item .nav-link:hover, .navigation .navbar-nav .nav-item .nav-link.active {
      color: rgba(255, 255, 255, 0.9); }
      @media (max-width: 991.98px) {
        .navigation .navbar-nav .nav-item .nav-link:hover, .navigation .navbar-nav .nav-item .nav-link.active {
          color: #556ee6; } }
    @media (max-width: 991.98px) {
      .navigation .navbar-nav .nav-item .nav-link {
        line-height: 28px !important; } }
  .navigation.nav-sticky {
    background-color: var(--bs-topnav-bg);
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03); }
    .navigation.nav-sticky .navbar-logo {
      line-height: 60px; }
      .navigation.nav-sticky .navbar-logo .logo-dark {
        display: var(--bs-display-block); }
      .navigation.nav-sticky .navbar-logo .logo-light {
        display: var(--bs-display-none); }
    .navigation.nav-sticky .navbar-nav .nav-item .nav-link {
      line-height: 48px;
      color: var(--bs-header-item-color); }
      .navigation.nav-sticky .navbar-nav .nav-item .nav-link:hover, .navigation.nav-sticky .navbar-nav .nav-item .nav-link.active {
        color: #556ee6; }

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000; }

.hero-section {
  padding-top: 220px;
  padding-bottom: 190px; }
  .hero-section.bg-ico-hero {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
    background-size: cover;
    background-position: top; }
  @media (max-width: 575.98px) {
    .hero-section {
      padding-top: 140px;
      padding-bottom: 80px; } }
  .hero-section .hero-title {
    font-size: 42px; }
    @media (max-width: 575.98px) {
      .hero-section .hero-title {
        font-size: 26px; } }
  .hero-section .ico-countdown {
    font-size: 22px;
    margin-right: -12px;
    margin-left: -12px; }
    @media (max-width: 575.98px) {
      .hero-section .ico-countdown {
        display: block; } }
    .hero-section .ico-countdown .coming-box {
      margin-right: 12px;
      margin-left: 12px;
      border: 1px solid var(--bs-border-color);
      border-radius: 4px;
      padding: 8px;
      background-color: var(--bs-secondary-bg); }
      @media (max-width: 575.98px) {
        .hero-section .ico-countdown .coming-box {
          display: inline-block;
          width: 40%;
          margin-bottom: 24px; } }
      .hero-section .ico-countdown .coming-box span {
        background-color: var(--bs-light);
        font-size: 12px;
        padding: 4px;
        margin-top: 8px; }
  .hero-section .softcap-progress {
    overflow: visible; }
    .hero-section .softcap-progress .progress-bar {
      overflow: visible; }
    .hero-section .softcap-progress .progress-label {
      position: relative;
      text-align: right;
      color: var(--bs-body-color);
      bottom: 20px;
      font-size: 12px;
      font-weight: 500; }

.currency-price {
  position: relative;
  bottom: 40px; }

.client-images img {
  max-height: 34px;
  width: auto !important;
  margin: 12px auto;
  opacity: 0.7;
  transition: all 0.4s; }

.features-number {
  opacity: 0.1; }

.team-box .team-social-links a {
  color: var(--bs-body-color);
  font-size: 14px; }

.blog-box .blog-badge {
  position: absolute;
  top: 12px;
  right: 12px; }

.landing-footer {
  padding: 80px 0 40px;
  background-color: #2a3042;
  color: rgba(255, 255, 255, 0.5); }
  .landing-footer .footer-list-title {
    color: rgba(255, 255, 255, 0.9); }
  .landing-footer .footer-list-menu li a {
    display: block;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 14px;
    transition: all 0.4s; }
    .landing-footer .footer-list-menu li a:hover {
      color: rgba(255, 255, 255, 0.8); }
  .landing-footer .blog-post .post {
    display: block;
    color: rgba(255, 255, 255, 0.5);
    padding: 16px 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1); }
    .landing-footer .blog-post .post .post-title {
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px; }
    .landing-footer .blog-post .post:first-of-type {
      padding-top: 0; }
    .landing-footer .blog-post .post:last-of-type {
      padding-bottom: 0;
      border-bottom: 0; }
  .landing-footer .footer-border {
    border-color: rgba(255, 255, 255, 0.1); }

.counter-number {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  display: flex; }
  .counter-number span {
    font-size: 16px;
    font-weight: 400;
    display: block;
    padding-top: 5px; }

.coming-box {
  width: 25%; }

/************** Horizontal timeline **************/
.hori-timeline .events .event-list {
  text-align: center;
  display: block; }
  .hori-timeline .events .event-list .event-down-icon {
    position: relative; }
    .hori-timeline .events .event-list .event-down-icon::before {
      content: "";
      position: absolute;
      width: 100%;
      top: 16px;
      left: 0;
      right: 0;
      border-bottom: 3px dashed var(--bs-border-color); }
    .hori-timeline .events .event-list .event-down-icon .down-arrow-icon {
      position: relative;
      border-bottom: 3px dashed var(--bs-border-color);
      padding: 4px; }
  .hori-timeline .events .event-list:hover .down-arrow-icon {
    animation: fade-down 1.5s infinite linear; }
  .hori-timeline .events .event-list.active .down-arrow-icon {
    animation: fade-down 1.5s infinite linear; }
    .hori-timeline .events .event-list.active .down-arrow-icon:before {
      content: "\\ec4c"; }

/************** vertical timeline **************/
.verti-timeline {
  border-left: 3px dashed var(--bs-border-color);
  margin: 0 10px; }
  .verti-timeline .event-list {
    position: relative;
    padding: 0px 0px 40px 30px; }
    .verti-timeline .event-list .event-timeline-dot {
      position: absolute;
      left: -9px;
      top: 0px;
      z-index: 9;
      font-size: 16px; }
    .verti-timeline .event-list .event-content {
      position: relative;
      border: 2px solid var(--bs-border-color);
      border-radius: 7px; }
    .verti-timeline .event-list.active .event-timeline-dot {
      color: #556ee6; }
    .verti-timeline .event-list:last-child {
      padding-bottom: 0px; }

.plan-box .plan-btn {
  position: relative; }
  .plan-box .plan-btn::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: var(--bs-border-color);
    left: 0px;
    right: 0px;
    top: 12px; }

.blog-play-icon {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  margin: 0px auto; }

.logo-dark-element {
  display: block; }

.logo-light-element {
  display: none; }

[data-layout-mode="dark"] .logo-dark-element {
  display: none; }

[data-layout-mode="dark"] .logo-light-element {
  display: block; }

.jobs-categories a {
  color: var(--bs-body-color);
  transition: all 0.5s ease; }
  .jobs-categories a:hover {
    color: #556ee6; }

body * {
  outline: none; }

#sidebar-menu ul li a i {
  min-width: 2rem; }

.leaflet-pane {
  z-index: 1; }

svg > rect:first-child {
  fill-opacity: 0 !important; }

.dataTables_filter,
.dataTables_paginate {
  float: right; }

.rdw-editor-main {
  border: 1px solid #f6f6f6;
  height: 239px;
  padding-left: 15px; }

.dz-message {
  text-align: center;
  padding: 30px; }

.react-kanban-board {
  display: inherit !important; }
  .react-kanban-board .react-kanban-column {
    background-color: #fff;
    padding: 1.25rem; }
    .react-kanban-board .react-kanban-column [data-rbd-draggable-context-id] > div {
      display: block !important; }
  .react-kanban-board > div {
    display: flex;
    justify-content: center;
    gap: 25px; }
    @media (max-width: 991.98px) {
      .react-kanban-board > div {
        flex-direction: column; }
        .react-kanban-board > div .react-kanban-column {
          width: 100%; } }

.react-kanban-column {
  width: 33.33%; }

.react-kanban-column > div {
  display: block !important; }

.fcYNFc,
.sc-AxmLO.gmtmqV {
  background-color: var(--bs-secondary-bg) !important;
  margin: 0 20px 0 0 !important; }

.task-box {
  border: 1px solid #eff2f7; }

.react-datepicker-wrapper {
  width: 100% !important; }

.ReactModal__Overlay {
  z-index: 1001 !important; }

.external-event:hover {
  cursor: pointer; }

a:hover {
  cursor: pointer; }

.rating-container {
  background-color: transparent !important; }

.input-group-append {
  z-index: 0; }

.input-color {
  color: var(--bs-emphasis-color) !important; }

.sketch-picker {
  position: absolute;
  z-index: 1; }

.rangeslider__fill {
  background-color: #556ee6 !important; }

.dropdown-menu-end {
  left: auto !important;
  right: 0 !important; }

.flatpickr-months .flatpickr-month {
  background: #556ee6 !important; }

.flatpickr-weekdays {
  background: #556ee6 !important; }

span.flatpickr-weekday {
  background: #556ee6 !important; }

.flatpickr-current-month .flatpickr-monthDropdown-months {
  background: #556ee6 !important; }

span.flatpickr-weekday {
  color: #fff !important; }

.flatpickr-day.selected {
  background: #556ee6 !important; }

.bs-select select {
  width: auto !important; }

.file-manager .table td {
  padding: 0.35rem; }

.slider_css .slide {
  background: none !important; }

.slider_css .carousel-status,
.slider_css .control-next,
.slider_css .control-prev {
  display: none !important; }

.carousel .control-dots {
  margin: -5px 0px; }

.carousel .dot {
  background: #556ee6 !important;
  width: 9px !important;
  height: 9px !important; }

.verification input:focus {
  border: none;
  outline: none !important; }

@media (max-width: 768px) {
  .verification input {
    width: 40px !important; } }

@media (max-width: 320px) {
  .verification input {
    width: 30px !important;
    height: 30px !important;
    font-size: 15px !important; } }

.verification-2 input:focus {
  border: none;
  outline: none !important; }

@media (max-width: 768px) {
  .verification-2 input {
    width: 40px !important;
    font-size: 14px; } }

@media (max-width: 320px) {
  .verification-2 input {
    width: 30px !important;
    height: 35px !important;
    font-size: 15px !important; } }

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center; }
    .fc-toolbar .fc-left,
    .fc-toolbar .fc-right,
    .fc-toolbar .fc-center {
      float: none;
      display: block;
      clear: both;
      margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc-today-button {
    display: none; } }

.ps__rail-y {
  z-index: 999999 !important; }

.close {
  background: transparent;
  border: 0;
  font-size: 10px;
  padding: 1.35rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_48___}) center/1em auto no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2; }
  .close span {
    display: none; }

.card-columns .card {
  margin-bottom: 24px; }

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

/* drawer */
.react-drawer-drawer {
  z-index: 9999;
  background: #fff; }

.drawer-main-menu {
  padding-top: 8px;
  padding-bottom: 8px; }

.drawer-menu a i {
  min-width: 2rem;
  display: inline-block;
  min-width: 1.75rem;
  padding-bottom: 0.125em;
  font-size: 1.25rem;
  line-height: 1.40625rem;
  vertical-align: middle;
  color: #7f8387;
  transition: all 0.4s; }

.drawer-menu a {
  display: block;
  padding: 0.625rem 1.5rem;
  color: #545a6d;
  position: relative;
  font-size: 13px;
  transition: all 0.4s; }

.drawer-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto; }

.ReactModal__Overlay {
  z-index: 5000 !important; }

.rangeslider__handle:focus {
  outline: none; }

.react-bootstrap-table-page-btns-ul {
  float: right !important; }

.search-label {
  float: right; }

.react-drawer-overlay {
  z-index: 9999; }

.react-bs-table-sizePerPage-dropdown .dropdown-menu .dropdown-item a {
  display: block; }

.rightbar-title .right-bar-toggle {
  background-color: #444c54 !important;
  height: 24px !important;
  width: 24px !important;
  line-height: 24px !important;
  display: block !important;
  color: #eff2f7 !important;
  text-align: center !important;
  border-radius: 50% !important; }

.css-sourceMap-modules-importLoaders-1-localIdentName-animate__animated___2O131 {
  animation-duration: 0.6s !important; }

.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {
  background: rgba(0, 0, 0, 0.15) !important; }

.custom-header-css thead tr th div:last-child {
  min-height: 38px; }

.custom-header-css thead td:nth-last-child(2) {
  width: 150px !important; }

.editor_email .ck-content {
  height: 200px; }

.jobs-categories .card-body a:last-child {
  margin-bottom: 0 !important; }

@media (max-width: 991.98px) {
  .search-box {
    display: block !important; }
    .search-box .search-label {
      float: none;
      width: 100%; }
      .search-box .search-label .form-control {
        border-radius: 0.25rem !important; } }

.css-1s2u09g-control,
.css-1pahdxg-control {
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color-translucent) !important; }

.css-14el2xx-placeholder {
  color: var(--bs-secondary-color) !important; }

.css-26l3qy-menu {
  box-shadow: none !important;
  border: 1px solid var(--bs-border-color-translucent) !important; }

.css-4ljt47-MenuList {
  background-color: var(--bs-custom-white) !important;
  border-radius: 4px !important; }

.css-319lph-ValueContainer .css-qc6sy-singleValue {
  color: var(--bs-emphasis-color) !important; }

.select2-selection .css-b62m3t-container {
  color: var(--bs-emphasis-color) !important; }

.css-1n7v3ny-option,
.css-9gakcf-option {
  background-color: #556ee6 !important;
  color: #fff !important; }

.rdw-editor-toolbar,
.rdw-option-wrapper,
.rdw-editor-main {
  border-color: var(--bs-border-color-translucent) !important;
  background-color: var(--bs-custom-white) !important; }

.rdw-option-wrapper {
  border: none !important;
  box-shadow: none !important; }

.rdw-dropdown-wrapper {
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color-translucent) !important;
  box-shadow: none !important; }

.rdw-dropdown-selectedtext {
  color: var(--bs-body-color) !important; }

[data-layout-mode="dark"] .rdw-option-wrapper img,
[data-layout-mode="dark"] .rdw-dropdown-selectedtext img {
  filter: invert(1) !important; }

.ck.ck-toolbar {
  background-color: var(--bs-light) !important;
  border: 1px solid var(--bs-border-color-translucent) !important; }

.ck-reset_all :not(.ck-reset_all-excluded *),
.ck.ck-reset_all {
  color: var(--bs-body-color) !important; }

.ck.ck-editor__main > .ck-editor__editable {
  background-color: var(--bs-custom-white) !important;
  color: var(--bs-body-color) !important;
  height: 300px !important; }

.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: var(--bs-border-color-translucent) !important; }

.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover,
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background-color: var(--bs-light) !important; }

.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: var(--bs-border-color-translucent) !important; }

.selectall.checkbox-wrapper-mail label:before {
  margin-top: 0; }

.ps__rail-y,
.ps__rail-x {
  z-index: 999 !important; }

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px var(--bs-custom-white) inset !important;
  background-color: var(--bs-custom-white) !important;
  color: var(--bs-body-color) !important;
  -webkit-text-fill-color: var(--bs-body-color) !important; }

.select2-selection__control,
.select__control,
.select2-selection .css-13cymwt-control,
.css-t3ipsp-control {
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color-translucent) !important; }

.select2-selection__menu,
.select__menu,
.css-1nmdiq5-menu {
  background-color: var(--bs-card-bg) !important;
  box-shadow: 0 0 0 1px var(--bs-border-color), 0 4px 11px var(--bs-border-color) !important; }

.select2-selection__option--is-focused,
.select__option--is-focused,
.css-d7l1ni-option {
  background-color: #556ee6 !important;
  color: #fff !important; }

.select__multi-value .css-13cymwt-control,
.select2-selection__multi-value .css-13cymwt-control,
.css-b62m3t-container .css-13cymwt-control {
  background-color: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color); }
  .select__multi-value .css-13cymwt-control:hover, .select__multi-value .css-13cymwt-control:focus,
  .select2-selection__multi-value .css-13cymwt-control:hover,
  .select2-selection__multi-value .css-13cymwt-control:focus,
  .css-b62m3t-container .css-13cymwt-control:hover,
  .css-b62m3t-container .css-13cymwt-control:focus {
    border-color: var(--bs-primary); }
  .select__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue,
  .select2-selection__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue,
  .css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue {
    color: var(--bs-white);
    background-color: var(--bs-primary); }
    .select__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric,
    .select2-selection__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric,
    .css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric {
      color: var(--bs-white) !important; }
    .select__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-9jq23d,
    .select2-selection__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-9jq23d,
    .css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-9jq23d {
      color: var(--bs-white); }
    .select__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator,
    .select2-selection__multi-value .css-13cymwt-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator,
    .css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator {
      border-color: var(--bs-border-color); }

.select__multi-value .css-tr4s17-option,
.select2-selection__multi-value .css-tr4s17-option,
.css-b62m3t-container .css-tr4s17-option {
  background-color: var(--bs-gray-400);
  color: black; }

.css-13cymwt-control {
  border-color: #cccccc !important; }

.select__multi-value__label,
.select2-selection__multi-value__label,
.css-qbdosj-Input,
.css-1dimb5e-singleValue,
.css-wsp0cs-MultiValueGeneric {
  color: var(--bs-body-color) !important; }

.select__multi-value__remove,
.select2-selection__multi-value__remove {
  background-color: var(--bs-light) !important;
  color: var(--bs-body-color) !important; }

[data-layout-mode="dark"] .auth-logo .auth-logo-light {
  display: block; }

[data-layout-mode="dark"] .auth-logo .auth-logo-dark {
  display: none; }

.noUi-connect {
  height: 2px !important; }

.noUi-horizontal .noUi-handle {
  border-radius: 50% !important;
  height: 16px !important;
  right: -10px !important;
  top: -7px !important;
  width: 16px !important; }

.noUi-target {
  background: #fafafa !important;
  background-color: #f3f6f9 !important;
  background-color: #f3f6f9 !important;
  border: 1px solid #f3f6f9 !important;
  border-color: #f3f6f9 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  height: 4px !important; }

.noUi-handle {
  background: #0ab39c !important;
  border: 2px solid #fff !important;
  box-shadow: none !important; }

aside.EmojiPickerReact.epr-main {
  position: absolute !important;
  bottom: 69px;
  z-index: 2;
  right: 110px; }

[dir="rtl"] .EmojiPickerReact.epr-main {
  right: unset !important;
  left: 116px !important; }

.replymessage-block {
  padding: 12px 20px;
  text-align: left;
  border-left: 2px solid rgba(var(--tb-success-rgb), 1);
  border-radius: 4px;
  background-color: rgba(29, 207, 122, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/theme.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_fontawesome-all.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./src/assets/scss/_variables-dark.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_root.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_vertical.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_layouts.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_demos.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_calendar-full.scss","webpack://./src/assets/scss/custom/plugins/_dragula.scss","webpack://./src/assets/scss/custom/plugins/_session-timeout.scss","webpack://./src/assets/scss/custom/plugins/_range-slider.scss","webpack://./src/assets/scss/custom/plugins/_sweatalert2.scss","webpack://./src/assets/scss/custom/plugins/_rating.scss","webpack://./src/assets/scss/custom/plugins/_toastr.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_switch.scss","webpack://./src/assets/scss/custom/plugins/_colorpicker.scss","webpack://./src/assets/scss/custom/plugins/_timepicker.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_form-editors.scss","webpack://./src/assets/scss/custom/plugins/_form-upload.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_responsive-table.scss","webpack://./src/assets/scss/custom/plugins/_table-editable.scss","webpack://./src/assets/scss/custom/plugins/_apexcharts.scss","webpack://./src/assets/scss/custom/plugins/_echarts.scss","webpack://./src/assets/scss/custom/plugins/_flot.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_google-map.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/custom/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_ecommerce.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_file-manager.scss","webpack://./src/assets/scss/custom/pages/_chat.scss","webpack://./src/assets/scss/custom/pages/_projects.scss","webpack://./src/assets/scss/custom/pages/_contacts.scss","webpack://./src/assets/scss/custom/pages/_crypto.scss","webpack://./src/assets/scss/custom/pages/_coming-soon.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_extras-pages.scss","webpack://./src/assets/scss/custom/pages/_jobs.scss"],"names":[],"mappings":"AAAA;;;;;;;CCOC;ACPD,4BAAA;AACA;EACE,oCAAoC;EACpC,4CAAsE;EACtE,qPAAuW;EACvW,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;;EAEE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,YAAY,EAAA;;AAGd;EACE,+BAA+B,EAAA;;AAGjC;EACE;;;;;;;;;;;;;;;SDltLO,ECiuLC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SDptLO,ECmuLC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SDttLO,ECquLC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SDxtLO,ECuuLC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SD1tLO,ECyuLC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SD5tLO,EC2uLC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SD9tLO,EC6uLC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,sCAAsC,EAAA;;AAcxC;EACE;IAEE,uBAAuB,EAAA;EAEzB;IAEE,yBAAyB,EAAA,EAAA;;AAI7B,kDAAA;AC7ouBA;EAEI,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAElB,4CAA0C;EAC1C,4SAI6D,EAAA;;AAEjE;EAEI,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EAEd,qBAAqB;EAErB,oBAAoB;EAEpB,WAAW;EACX,mCAAmC;EACnC,kCAAkC,EAAA;;AAEtC;EAEI,gBAAgB;EAChB,eAAe;EAEf,gBAAgB,EAAA;;AAEpB;EAEI,kBAAkB,EAAA;;AAEtB;EAEI,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,UAAU;EAEV,UAAU;EAEV,kBAAkB,EAAA;;AAetB;EAEI;IAGY,oBAAoB,EAAA;EAEhC;IAGY,yBAAyB,EAAA,EAAA;;AAoBzC;EAEI;IAGY,mBAAmB;IAE3B,UAAU,EAAA;EAEd;IAGY,qBAAqB;IAE7B,UAAU,EAAA,EAAA;;AAkBlB;EAEI;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AA0ClB;EAEI;IAGY,2BAA2B,EAAA;EAGvC;;IAIY,8DAA2D,EAAA;EAGvE;;;;IAMY,oDAAoD,EAAA;EAGhE;;;IAKY,oCAAoC,EAAA;EAGhD;IAGY,2BAA2B,EAAA,EAAA;;AAG3C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,wCAAwC,EAAA;;AAEpD;EAGY,wCAAwC,EAAA;;AAGpD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,0CAA0C,EAAA;;AAEtD;EAGY,0CAA0C,EAAA;;AAEtD;EAEI,0BAAyB,EAAA;;AAE7B;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,yBAAyB;EACzB,iBAAiB;EAEjB,qBAAqB;EACrB,YAAY;EACZ,6BAA2B;EAE3B,sBAAsB,EAAA;;AAG1B;EAEI,0BAA2B,EAAA;;AAE/B;EAEI,WAAW;EAEX,8BAA4B,EAAA;;AAGhC;EAEI,YAAY;EAEZ,6BAA2B,EAAA;;AAE/B;EAEI,wBAAwB;EAExB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,cAAc;EAEd,uCAAkC;EAClC,oBAAoB,EAAA;;AAExB;EAEI,cAAc;EAEd,uCAAkC;EAClC,kBAAkB,EAAA;;AAGtB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;ACt2HlB;;;EHokqBE;AGhkqBF;;;;;;EAME,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc,EAAA;;AAEhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB,EAAA;;AAE1B;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,eAAe,EAAA;;AAEjB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe,EAAA;;AACf;EACE,kBAAkB,EAAA;;AAEtB;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAEtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB,EAAA;;AAE3B;EACE,WAAW,EAAA;;AAEb;EACE,YAAY,EAAA;;AAEd;;;;;EAKE,kBAAkB,EAAA;;AAEpB;;;;;EAKE,iBAAiB,EAAA;;AAEnB;EAEU,qCAAqC,EAAA;;AAE/C;EAEU,uCAAuC,EAAA;;AAUjD;EACE;IAEU,uBAAuB,EAAA;EACjC;IAEU,yBAAyB,EAAA,EAAA;;AAErC;EACE,sEAAsE;EAE9D,wBAAwB,EAAA;;AAElC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,wBAAwB,EAAA;;AAElC;;;;;;EAOU,YAAY,EAAA;;AAEtB;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAA;;AAEd;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,oBAAoB,EAAA;;AAEtB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;gEHmkqBgE;AGjkqBhE;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU,EAAA;;AAEZ;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAA;;AACb;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA+C;EAC/C,iTAAiV,EAAA;;AAEnV;EACE,oCAAoC;EACpC,gBAAgB,EAAA;;AAClB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAAgD;EAChD,iTAAsV,EAAA;;AAExV;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAClB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA8C;EAC9C,iTAA4U,EAAA;;AAE9U;;EAEE,kCAAkC;EAClC,gBAAgB,EAAA;;ACz8IlB;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,uPAGsE;EACtE,mBAAmB;EACnB,kBAAkB,EAAA;;AJ+gzBpB;EI1gzBE,sCAAsC;EACtC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAA;;AJ6gzBpC;;EIxgzBE,sCAAsC;EACtC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AC9nBlB;;;;;;;CLgp0BC;AM1j0BD,4EAAA;ACrFE;;;;IPqp0BE;AQtp0BJ;;EASI,kBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,kBAAwB;EAAxB,gBAAwB;EAAxB,gBAAwB;EAAxB,kBAAwB;EAAxB,uBAAwB;EAIxB,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIlC,qBAAwB;EAAxB,uBAAwB;EAAxB,qBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAIxB,8BAAgC;EAAhC,iCAAgC;EAAhC,8BAAgC;EAAhC,2BAAgC;EAAhC,8BAAgC;EAAhC,8BAAgC;EAAhC,2BAAgC;EAAhC,6BAAgC;EAAhC,yBAAgC;EAIhC,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,gDAA4C;EAA5C,mDAA4C;EAA5C,gDAA4C;EAA5C,6CAA4C;EAA5C,gDAA4C;EAA5C,gDAA4C;EAA5C,6BAA4C;EAA5C,2CAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,6BAAiC;EACjC,uBAAiC;EAMjC,2CAA6C;EAC7C,yGAA2C;EAC3C,yFAA+B;EAO/B,gDAA+C;EC2O3C,8BAnE+B;EDtKnC,0BAA+C;EAC/C,0BAA+C;EAK/C,wBAAmC;EACnC,+BAA2C;EAC3C,qBAA6B;EAC7B,+BAAqC;EAErC,4BAA2C;EAC3C,mCAAmD;EAEnD,6BAA6C;EAC7C,uCAAqD;EACrD,uBAAuC;EACvC,oCAA+C;EAE/C,0CAA2C;EAC3C,mCAAmD;EACnD,yBAAqC;EACrC,mCAA6C;EAG7C,2BAAyC;EAEzC,wBAAmC;EACnC,iCAA2C;EAC3C,0BAA6C;EAE7C,8BAA+C;EAC/C,sCAAuD;EAGrD,qCAAyD;EAG3D,wBAAmC;EACnC,0BAAuC;EAGvC,sBAAuC;EACvC,wBAAuC;EACvC,0BAAuC;EACvC,sCAA+D;EAE/D,2BAAyC;EACzC,6BAA+C;EAC/C,6BAA+C;EAC/C,2BAA+C;EAC/C,4BAAiD;EACjD,mDAAiD;EACjD,8BAAmD;EAGnD,wDAAmC;EACnC,2DAAyC;EACzC,oDAAyC;EACzC,2DAA+C;EAI/C,8BAA+C;EAC/C,6BAAmD;EACnD,+CAA+C;EAI/C,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;ARmp0BnE;EQ7o0BI,kBAAkB;EAGlB,wBAAmC;EACnC,kCAA2C;EAC3C,qBAA6B;EAC7B,4BAAqC;EAErC,yBAA2C;EAC3C,sCAAmD;EAEnD,6BAA6C;EAC7C,uCAAqD;EACrD,0BAAuC;EACvC,iCAA+C;EAE/C,4BAA2C;EAC3C,sCAAmD;EACnD,yBAAqC;EACrC,gCAA6C;EAG3C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,gDAA4C;EAA5C,mDAA4C;EAA5C,gDAA4C;EAA5C,6CAA4C;EAA5C,gDAA4C;EAA5C,gDAA4C;EAA5C,6BAA4C;EAA5C,2CAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,2BAAyC;EAEzC,wBAAmC;EACnC,8BAA+C;EAC/C,iCAA2C;EAC3C,wCAAuD;EAEvD,wBAAmC;EAEnC,0BAAuC;EACvC,sCAA+D;EAE/D,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;AErKrE;;;EAGE,sBAAsB,EAAA;;AAepB;EANJ;IAOM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,uCAAgE;ED6O5D,mCAnE+B;ECxKnC,uCAAgE;EAChE,uCAAgE;EAChE,2BAA8C;EAC9C,qCAA6D;EAC7D,mCAAmD;EACnD,8BAA8B;EAC9B,6CC8Ba,EAAA;;ADrBf;EACE,cAAsB;EACtB,cCyrBmC;EDxrBnC,SAAS;EACT,+DC6rBuE;ED5rBvE,YC8rB+B,EAAA;;ADprBjC;EACE,aAAa;EACb,qBC+nBwC;ED5nBxC,gBC+nB+B;ED9nB/B,gBC+nB+B;ED9nB/B,8BAAoD,EAAA;;AAGtD;EDuMQ,sCAf6B,EAAA;EA7IjC;IC3CJ;MD8MQ,qBA9E6B,EAAA,EC7HpC;;AAED;EDkMQ,mCAf6B,EAAA;EA7IjC;ICtCJ;MDyMQ,mBA9E6B,EAAA,ECxHpC;;AAED;ED6LQ,uCAf6B,EAAA;EA7IjC;ICjCJ;MDoMQ,qBA9E6B,EAAA,ECnHpC;;AAED;EDoLM,qBAnE+B,EAAA;;AC5GrC;EDmLQ,qBAf6B,EAAA;EA7IjC;ICvBJ;MD0LQ,qBA9E6B,EAAA,ECzGpC;;AAED;ED0KM,oBAnE+B,EAAA;;AC5FrC;EACE,aAAa;EACb,mBC+Z8B,EAAA;;ADrZhC;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAMtB;;EAEE,kBAAkB,EAAA;;AAGpB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBCqgB+B,EAAA;;ADhgBjC;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBC8ekC,EAAA;;ADtepC;ED6EM,cAnE+B,EAAA;;ACHrC;EACE,cCsjBgC;EDrjBhC,wCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;EDyDd,iBAnE+B;ECYnC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,gEAA4G;EAC5G,qBCwR4C,EAAA;ED1R9C;IAKI,mDAA2C;IAC3C,0BCuR+C,EAAA;;AD9QnD;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,qCCyZ2E;EF1YvE,cAnE+B,EAAA;;AC4DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDGV,gBAnE+B,EAAA;EC4DrC;IDOM,kBAnE+B;ICuEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDTM,gBAnE+B;EC8EnC,2BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,sBCs9CuC;EF3+CnC,gBAnE+B;EC0FnC,wBCs9CmE;EDr9CnE,sCCs9CyE;EC1vDvE,qBDulB+B,EAAA;EDvTnC;IAQI,UAAU;ID5BR,cAnE+B,EAAA;;AC0GrC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,oBC6bkC;ED5blC,uBC4bkC;ED3blC,gCC4d6E;ED3d7E,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;ED3HhB,kBAnE+B;ECgMnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;AVyo0BtB;EUno0BE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;AVio0Bd;EUzn0BE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBCqRiC;EFre3B,iCAf6B;ECkOnC,oBAAoB,EAAA;ED/WlB;ICwWJ;MDrMQ,iBA9E6B,EAAA,EC+RpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AV4l0Bd;EUll0BE,oBAAoB;EACpB,6BAA6B,EAAA;;AAQ/B;;;;;;;CVol0BC;AUzk0BD;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AVmj0B1B;EU1i0BE,wBAAwB,EAAA;;AGpkB1B;EJuQQ,qBAf6B;EItPnC,gBF+sB+B,EAAA;EFtmB7B;II3GJ;MJ8QQ,qBA9E6B,EAAA,EI7LpC;;AAIC;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,eA9E6B,EAAA,EInLlC;;AAND;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAND;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAND;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAND;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,eA9E6B,EAAA,EInLlC;;AAND;EJgQM,iCAf6B;EI7OjC,gBFgsBqB;EE/rBrB,gBF+qB6B,EAAA;EFhlB7B;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAkBH;ECvDE,eAAe;EACf,gBAAgB,EAAA;;AD2DlB;EC5DE,eAAe;EACf,gBAAgB,EAAA;;AD8DlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBFusB+B,EAAA;;AE7rBnC;EJ8MM,cAnE+B;EIzInC,yBAAyB,EAAA;;AAI3B;EACE,mBFqYW;EF1LL,qBAf6B,EAAA;EA7IjC;IIhDJ;MJmNQ,qBA9E6B,EAAA,EI9HpC;EAPD;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBF4XW;EE3XX,mBF2XW;EF9LP,cAnE+B;EIxHnC,gCFspB6E,EAAA;EE1pB/E;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBJ4nDwC;EI3nDxC,mCJ4nDmE;EI3nDnE,2DJ6nD6E;EC1nD3E,sCD2nD6E;EKnoD/E,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;ENyPM,cAnE+B;EMpLnC,gCJ+mDmF,EAAA;;AMjpDnF;;;;;;;ECHA,mBAA+B;EAC/B,gBAA+B;EAC/B,WAAW;EACX,4CAA6D;EAC7D,2CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBN0iBG,EAAA,EMziBJ;;AE0CH;EF5CE;IACE,gBN2iBG,EAAA,EM1iBJ;;AE0CH;EF5CE;IACE,gBN4iBG,EAAA,EM3iBJ;;AE0CH;EF5CE;IACE,iBN6iBI,EAAA,EM5iBL;;AE0CH;EF5CE;IACE,iBN8iBK,EAAA,EM7iBN;;APMP;EUrBI,qBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,0BAA6C;EAA7C,2BAA6C,EAAA;;AAK/C;ECNA,mBAA+B;EAC/B,gBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,yCAA0D;EAC1D,4CAA6D;EAC7D,2CAA4D,EAAA;EDD5D;ICUA,cAAc;IACd,WAAW;IACX,eAAe;IACf,4CAA6D;IAC7D,2CAA4D;IAC5D,8BAA+C,EAAA;;AA+C3C;EACE,SAAY,EAAA;;AAGd;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYFnD;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AAuElC;EAxDV,qBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAmExC;;EAEE,gBAA+B,EAAA;;AAGjC;;EAEE,gBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;ACtHT;EAEE,8BAA+C;EAC/C,2BAAyC;EACzC,+BAAiD;EACjD,4BAA2C;EAE3C,sCAAqC;EACrC,qCAA+B;EAC/B,+CAAmD;EACnD,iCAA6C;EAC7C,8CAAqD;EACrD,yDAA+C;EAC/C,6CAAmD;EACnD,wDAA6C;EAC7C,4CAAiD;EACjD,uDAA2C;EAE3C,WAAW;EACX,mBXscW;EWrcX,mBXuwB+B;EWtwB/B,0CAAqE,EAAA;EArBvE;IA6BI,wBX0vBgC;IWxvBhC,qFAA4J;IAC5J,oCAAqD;IACrD,2CX+wBqE;IW9wBrE,2GAAgL,EAAA;EAlCpL;IAsCI,uBAAuB,EAAA;EAtC3B;IA0CI,sBAAsB,EAAA;;AAI1B;EACE,+DXswBwC,EAAA;;AW/vB1C;EACE,iBAAiB,EAAA;;AAQnB;EAGI,sBXutB+B,EAAA;;AWzsBnC;EAEI,sCAAmC,EAAA;EAFvC;IAMM,sCX0tBmE,EAAA;;AWrtBzE;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAK7C;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAQ7C;EACE,oDAAiD;EACjD,8CAA2C,EAAA;;AAO7C;EAEI,mDAAiD;EACjD,6CAA2C,EAAA;;AC5I7C;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,4BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;ADiJrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AH3FnC;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AEpKL;EACE,qBbq6B2C,EAAA;;Aa55B7C;EACE,mDC2N8D;ED1N9D,sDC0N8D;EDzN9D,gBAAgB;Ef8QZ,kBAnE+B;EevMnC,gBbsqB+B,EAAA;;AalqBjC;EACE,kDCgN8D;ED/M9D,qDC+M8D;EhByDxD,qBAf6B,EAAA;EA7IjC;Ie9GJ;MfiRQ,qBA9E6B,EAAA,Ee/LpC;;AAED;EACE,mDC0M8D;EDzM9D,sDCyM8D;EhBqD1D,qBAnE+B,EAAA;;AiBxNrC;EACE,mBf65B4C;EFnoBxC,cAnE+B;EiBnNnC,gCf65BuF,EAAA;;AgBl6BzF;EACE,cAAc;EACd,WAAW;EACX,wBhB60BkC;EFrjB9B,oBAnE+B;EkBlNnC,gBhB0qB+B;EgBzqB/B,gBhBgrB+B;EgB/qB/B,+BhB07BqF;EgBz7BrF,wChBo7BiF;EgBn7BjF,4BAA4B;EAC5B,uEhBw7ByG;EgBv7BzG,gBAAgB;EfGd,sCDw7BiF;EiB37B/E,wEjBk9B4F,EAAA;EiB98B5F;IDhBN;MCiBQ,gBAAgB,EAAA,ED2FvB;EA5GD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,+BhBo6BmF;IgBn6BnF,wChB85B+E;IgB75B/E,iDhB46B8F;IgB36B9F,UAAU;IAKR,gBhBy6BsC,EAAA;EgB/8B5C;IAgDI,eAAe;IAMf,aAAmE;IAKnE,SAAS,EAAA;EA3Db;IAiEI,cAAc;IACd,UAAU,EAAA;EAlEd;IAuEI,gChB04BqF;IgBx4BrF,UAAU,EAAA;EAzEd;IAmFI,mChB42BqE;IgBz2BrE,UAAU,EAAA;EAtFd;IA2FI,wBhBqvBgC;IgBpvBhC,yBhBovBgC;IgBnvBhC,0BhBmvBgC;IgBlvBhC,+BhBo2BmF;IkBl8BrF,uClBkmCyE;IgBlgCvE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,+ChB+vBqE;IgB9vBrE,gBAAgB;ICzFd,qIjBk4B6I,EAAA;IiB93B7I;MDhBN;QCiBQ,gBAAgB,EAAA,EDsFrB;EAvGH;IA0GI,wChBy/ByE,EAAA;;AgBh/B7E;EACE,cAAc;EACd,WAAW;EACX,kBAA2B;EAC3B,gBAAgB;EAChB,gBhB+jB+B;EgB9jB/B,2BhBy1B6E;EgBx1B7E,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,mEFqF8D;EEpF9D,uBhB0sBiC;EFjkB7B,qBAnE+B;EGzMjC,yCDy7BuF,EAAA;EgBxzB3F;IAOI,uBhBqsB+B;IgBpsB/B,wBhBosB+B;IgBnsB/B,yBhBmsB+B,EAAA;;AgB/rBnC;EACE,iEFwE8D;EEvE9D,oBhBisBgC;EFjkB1B,qBAf6B;EGjQjC,yCD07BuF,EAAA;EFt0BvF;IkB0BJ;MlByIQ,qBA9E6B,EAAA,EkBhDpC;EAXD;IAOI,oBhB4rB8B;IgB3rB9B,qBhB2rB8B;IgB1rB9B,uBhB0rB8B,EAAA;;AgBnrBlC;EAEI,oEFuD4D,EAAA;;AEzDhE;EAMI,mEFmD4D,EAAA;;AEzDhE;EAUI,iEF+C4D,EAAA;;AE1ChE;EACE,WhBkyB0C;EgBjyB1C,gEFwC8D;EEvC9D,gBhBgpBkC,EAAA;EgBnpBpC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;IfvLpB,sCDw7BiF,EAAA;EgB3wBrF;IAeI,oBAAoB;If5LpB,sCDw7BiF,EAAA;EgB3wBrF;IAmBsB,+DFuB0C,EAAA;EE1ChE;IAoBsB,6DFsB0C,EAAA;;AKrOhE;EACE,iEAAmD;EAEnD,cAAc;EACd,WAAW;EACX,wCnB00BkC;EFrjB9B,oBAnE+B;EqB/MnC,gBnBuqB+B;EmBtqB/B,gBnB6qB+B;EmB5qB/B,+BnBu7BqF;EmBt7BrF,wCnBi7BiF;EmBh7BjF,mFAA0I;EAC1I,4BAA4B;EAC5B,yCnB6hCqE;EmB5hCrE,0BnB6hC2C;EmB5hC3C,uEnBk7ByG;ECp7BvG,sCDw7BiF;EiB37B/E,wEjBk9B4F;EmBz8BhG,gBAAgB,EAAA;EFLZ;IEfN;MFgBQ,gBAAgB,EAAA,EEkCvB;EAlDD;IAuBI,iDnBo7B8F;ImBn7B9F,UAAU;IAKR,kDnB0EW,EAAA;EmBvGjB;IAmCI,sBnB4yBgC;ImB3yBhC,sBAAsB,EAAA;EApC1B;IAyCI,mCnBq5BqE,EAAA;EmB97BzE;IA+CI,kBAAkB;IAClB,2CnBi5BmF,EAAA;;AmB74BvF;EACE,oBnBqyBkC;EmBpyBlC,uBnBoyBkC;EmBnyBlC,oBnBoyBiC;EFjkB7B,qBAnE+B;EGzMjC,yCDy7BuF,EAAA;;AmB34B3F;EACE,mBnBiyBiC;EmBhyBjC,sBnBgyBiC;EmB/xBjC,kBnBgyBgC;EFjkB1B,qBAf6B;EGjQjC,yCD07BuF,EAAA;EFt0BvF;IqBtEJ;MrByOQ,qBA9E6B,EAAA,EqBrJpC;;A9Bm53BD;E8B943BM,iEAAmD,EAAA;;ACxEzD;EACE,cAAc;EACd,sBpBk+B2E;EoBj+B3E,mBpBk+BsE;EoBj+BtE,uBpBk+B+C,EAAA;EoBt+BjD;IAOI,WAAW;IACX,mBAA2C,EAAA;;AAI/C;EACE,oBpBw9BsE;EoBv9BtE,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,YAAY;IACZ,oBAA4C;IAC5C,cAAc,EAAA;;AAIlB;EACE,0CAAyC;EAEzC,UpBw8B2C;EoBv8B3C,WpBu8B2C;EoBt8B3C,kBAA8D;EAC9D,mBAAmB;EACnB,yCAA+D;EAC/D,+CAA2E;EAC3E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,uEpB08B6J;EoBz8B7J,gBAAgB;EAChB,iCAAyB;UAAzB,yBAAyB;EH1BrB,mJjB69BuK,EAAA;EiBz9BvK;IGQN;MHPQ,gBAAgB,EAAA,EG0FvB;EAnFD;InBTI,qBDg+B2C,EAAA;EoBv9B/C;IAuBI,kBpBi8ByC,EAAA;EoBx9B7C;IA2BI,uBpBw7BqD,EAAA;EoBn9BzD;IA+BI,iDpBq5B8F;IoBp5B9F,UAAU;IACV,kDpB+Ca,EAAA;EoBhFjB;IAqCI,yBpB2Ca;IoB1Cb,qBpB0Ca,EAAA;IoBhFjB;MA4CQ,kEAAqD,EAAA;IA5C7D;MAoDQ,kEAAqD,EAAA;EApD7D;IA0DI,yBpBsBa;IoBrBb,qBpBqBa;IoBhBX,kEAAqD,EAAA;EAhE3D;IAqEI,oBAAoB;IACpB,YAAY;IACZ,YpBg6ByC,EAAA;EoBv+B7C;IA+EM,eAAe;IACf,YpBu5BuC,EAAA;;AoBz4B7C;EACE,mBpBk5ByD,EAAA;EoBn5B3D;IAII,6DAA2C;IAE3C,UpB44BiC;IoB34BjC,mBAA4C;IAC5C,0CAAiE;IACjE,gCAAgC;InBhHhC,kBDy/BiC;IiB5/B/B,iDjBggCgE,EAAA;IiB5/BhE;MGsGN;QHrGQ,gBAAgB,EAAA,EG+HrB;IA1BH;MAcM,6DAA2C,EAAA;IAdjD;MAkBM,iCpB24BwC;MoBt4BtC,6DAA2C,EAAA;EAvBnD;IA6BI,oBpBs3BuD;IoBr3BvD,eAAe,EAAA;IA9BnB;MAiCM,oBAA6C;MAC7C,cAAc,EAAA;;AAKpB;EACE,qBAAqB;EACrB,kBpBo2BoC,EAAA;;AoBj2BtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,apBstB2B,EAAA;;AX8r2BjC;E+B543BM,6DAA2C,EAAA;;AClLjD;EACE,WAAW;EACX,cP+N2B;EO9N3B,UAAU;EACV,6BAA6B;EAC7B,gBAAgB,EAAA;EALlB;IAQI,UAAU,EAAA;IARd;MAY8B,mCrBi8Bc,EAAA;IqB78B5C;MAa8B,mCrBg8Bc,EAAA;EqB78B5C;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WrB4jC2C;IqB3jC3C,YrB2jC2C;IqB1jC3C,oBAAsE;IHzBxE,yBlBwGe;IqB7Eb,SrB2jCwC;ICvkCxC,mBDwkC2C;IiB3kCzC,oHjBilCkI;IiBjlClI,4GjBilCkI;IqB9jCpI,gBAAgB,EAAA;IJfd;MIdN;QJeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EImBrB;IAlCH;MHFE,yBJ0MmC,EAAA;EOxMrC;IAqCI,WrBqiCkC;IqBpiClC,crBqiCmC;IqBpiCnC,kBAAkB;IAClB,erBoiCqC;IqBniCrC,uCrBoiCuE;IqBniCvE,yBAAyB;IpB7BzB,mBDikCkC,EAAA;EqB9kCtC;IAgDI,WrBiiC2C;IqBhiC3C,YrBgiC2C;IkBnlC7C,yBlBwGe;IqBnDb,SrBiiCwC;ICvkCxC,mBDwkC2C;IiB3kCzC,iHjBilCkI;IiBjlClI,4GjBilCkI;IqBpiCpI,gBAAgB,EAAA;IJzCd;MIdN;QJeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EI6CrB;IA5DH;MHFE,yBJ0MmC,EAAA;EOxMrC;IA+DI,WrB2gCkC;IqB1gClC,crB2gCmC;IqB1gCnC,kBAAkB;IAClB,erB0gCqC;IqBzgCrC,uCrB0gCuE;IqBzgCvE,yBAAyB;IpBvDzB,mBDikCkC,EAAA;EqB9kCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,2CrB6gCsF,EAAA;IqB1lC5F;MAiFM,2CrBygCsF,EAAA;;AsBhmC5F;EACE,kBAAkB,EAAA;EADpB;;;IAMI,uDRoO4D;IQnO5D,2DRmO4D;IQlO5D,iBtBomCkC,EAAA;EsB5mCtC;IAYI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,qBtBm0BgC;IsBl0BhC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gDAA6C;IAC7C,qBAAqB;ILRnB,gEjBqmC8E,EAAA;IiBjmC9E;MKpBN;QLqBQ,gBAAgB,EAAA,EKKrB;EA1BH;;IA8BI,qBtBszBgC,EAAA;IsBp1BpC;;MAiCM,kBAAkB,EAAA;IAjCxB;;;MAsCM,qBtBykCoC;MsBxkCpC,wBtBykCmC,EAAA;IsBhnCzC;;MA2CM,qBtBokCoC;MsBnkCpC,wBtBokCmC,EAAA;EsBhnCzC;IAiDI,qBtB8jCsC;IsB7jCtC,wBtB8jCqC,EAAA;EsBhnCzC;;;;IA0DM,2CAA6F;IAC7F,8DtBwjC4E,EAAA;IsBnnClF;;;;MA8DQ,kBAAkB;MAClB,oBAA+D;MAC/D,WAAW;MACX,atBgjCqC;MsB/iCrC,WAAW;MACX,wCtB83B2E;MC96B/E,sCDw7BiF,EAAA;EsB38BrF;IA2EM,2CAA6F;IAC7F,8DtBuiC4E,EAAA;EsBnnClF;IAkFM,sCAAmC,EAAA;EAlFzC;IAuFI,ctBHc,EAAA;IsBpFlB;MA0FM,mCtBy2BmE,EAAA;;AuB/7BzE;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,wBvBmyBkC;EFrjB9B,oBAnE+B;EyBzKnC,gBvBioB+B;EuBhoB/B,gBvBuoB+B;EuBtoB/B,+BvBi5BqF;EuBh5BrF,kBAAkB;EAClB,mBAAmB;EACnB,uCvBu+B+E;EuBt+B/E,uEvB84ByG;ECp7BvG,sCDw7BiF,EAAA;;AuBx4BrF;;;;EAIE,oBvB6xBgC;EFjkB1B,qBAf6B;EGjQjC,yCD07BuF,EAAA;EFt0BvF;IyBpEJ;;;;MzBuOQ,qBA9E6B,EAAA,EyBlJpC;;AAED;;;;EAIE,uBvBgxBiC;EFjkB7B,qBAnE+B;EGzMjC,yCDy7BuF,EAAA;;AuBv3B3F;;EAEE,qBAAsE,EAAA;;AAWxE;;;;EtB/DI,0BsBqE8B;EtBpE9B,6BsBoE8B,EAAA;;AANlC;;;;EtB/DI,0BsB8E8B;EtB7E9B,6BsB6E8B,EAAA;;AAflC;EAyBI,8CAA8C;EtB1E9C,yBsB2E8B;EtB1E9B,4BsB0E8B,EAAA;;AA1BlC;;EtBjDI,yBsBgF8B;EtB/E9B,4BsB+E8B,EAAA;;AAP4B;EC/F1D,aAAa;EACb,WAAW;EACX,mBxBq4B0C;EFnoBxC,cAnE+B;E0B5LjC,iCxBinC4D,EAAA;;AuBvhCtB;ECtFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBxBk5CqC;EwBj5CrC,iBAAiB;E1BqPf,qBAnE+B;E0BhLjC,gBxB+oB6B;EwB9oB7B,WxBsmCqB;EwBrmCrB,mCxBsmCqD;ECjoCrD,sCDq6C6E,EAAA;;AwBl7C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,+CxB2lC+E;EwBxlC7E,oCV4KwD;EU3KxD,0DVwE0E;EUvE1E,4BAA4B;EAC5B,0DAA6D;EAC7D,8DVwKwD,EAAA;EUpO5D;IAgEI,+CxBglC6E;IwB/kC7E,2DxB8kC4I,EAAA;;AwB/oChJ;EA0EI,oCV0JwD;EUzJxD,gFVyJwD,EAAA;;AUpO5D;EAkFE,+CxB8jC+E,EAAA;EwBhpCjF;IAuFM,kEAAqD;IACrD,uBxBu9B2F;IwBt9B3F,+DxBy8BiC;IwBx8BjC,yEV0IsD,EAAA;EUpO5D;IA+FI,+CxBijC6E;IwBhjC7E,2DxB+iC4I,EAAA;;AwB/oChJ;EAwGI,yCV4HwD,EAAA;;AUpO5D;EA+GE,+CxBiiC+E,EAAA;EwBhpCjF;IAkHI,4CxByhCwD,EAAA;EwB3oC5D;IAsHI,2DxByhC4I,EAAA;EwB/oChJ;IA0HI,iCxBihCwD,EAAA;;AwB7gC9D;EAEI,iBAAiB,EAAA;;AAhInB;;;;;EA0IM,UAAU,EAAA;;ADtBqF;EC/FrG,aAAa;EACb,WAAW;EACX,mBxBq4B0C;EFnoBxC,cAnE+B;E0B5LjC,mCxBynCgE,EAAA;;AuB/hCe;ECtF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBxBk5CqC;EwBj5CrC,iBAAiB;E1BqPf,qBAnE+B;E0BhLjC,gBxB+oB6B;EwB9oB7B,WxB8mCqB;EwB7mCrB,kCxB8mCmD;ECzoCnD,sCDq6C6E,EAAA;;AwBl7C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,iDxBmmCmF;EwBhmCjF,oCV4KwD;EU3KxD,0DVwE0E;EUvE1E,4BAA4B;EAC5B,0DAA6D;EAC7D,8DVwKwD,EAAA;EUpO5D;IAgEI,iDxBwlCiF;IwBvlCjF,0DxBslC0I,EAAA;;AwBvpC9I;EA0EI,oCV0JwD;EUzJxD,gFVyJwD,EAAA;;AUpO5D;EAkFE,iDxBskCmF,EAAA;EwBxpCrF;IAuFM,kEAAqD;IACrD,uBxBu9B2F;IwBt9B3F,+DxBy8BiC;IwBx8BjC,yEV0IsD,EAAA;EUpO5D;IA+FI,iDxByjCiF;IwBxjCjF,0DxBujC0I,EAAA;;AwBvpC9I;EAwGI,yCV4HwD,EAAA;;AUpO5D;EA+GE,iDxByiCmF,EAAA;EwBxpCrF;IAkHI,8CxBiiC4D,EAAA;EwBnpChE;IAsHI,0DxBiiC0I,EAAA;EwBvpC9I;IA0HI,mCxByhC4D,EAAA;;AwBrhClE;EAEI,iBAAiB,EAAA;;AAhInB;;;;;EA4IM,UAAU,EAAA;;AC9IpB;EAEE,2BAAyC;EACzC,2BAAyC;EACzC,sBAA6C;E3BuRzC,6BAnE+B;E2BlNnC,yBAA6C;EAC7C,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,6CAA+C;EAC/C,kCAA+C;EAC/C,+CAAiD;EACjD,wCAA2D;EAC3D,4FAA2C;EAC3C,+BAAuD;EACvD,iFAAuD;EAGvD,qBAAqB;EACrB,wDAAoG;EACpG,sCAA8D;E3BsQ1D,kCAnE+B;E2BjMnC,sCAA8D;EAC9D,sCAA8D;EAC9D,0BAA4C;EAC5C,kBAAkB;EAGlB,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAqH;ExBjBnH,0CwBkB0E;EPjC5E,kCOkCoD;ERtBhD,qIjBk4B6I,EAAA;EiB93B7I;IQhBN;MRiBQ,gBAAgB,EAAA,EQ4FvB;EA7GD;IAuCI,gCAAwD;IACxD,qBAA6D;IAC7D,wCAA6D;IAC7D,8CAA6E,EAAA;EAG/E;IAEE,0BAA4C;IAC5C,kCAAiD;IACjD,wCAAiE,EAAA;EAjDrE;IAqDI,gCAAwD;IPrD1D,wCOsDkE;IAChE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;IACE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;;IAKE,iCAA0D;IAC1D,yCAA+D;IAG/D,+CAA+E,EAAA;IATjF;;MAiBM,0CAAuE,EAAA;EA7F/E;;IAqGI,mCAA8D;IAC9D,oBAAoB;IACpB,2CAAmE;IAEnE,iDAAmF;IACnF,uCAAoE,EAAA;;AAYtE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADmHjE;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADsGjC;EACE,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,gDAA6C;EAC7C,wCAA2D;EAC3D,iDAA+C;EAC/C,yCAA6D;EAC7D,gCAAmD;EACnD,2CAAiE;EACjE,+BAA2C;EAC3C,wCAAuD;EAEvD,qBzB8V4C,EAAA;EyB5W9C;IAqBI,0BzB0V+C,EAAA;EyB/WnD;IAyBI,0BAA4C,EAAA;EAzBhD;IA6BI,gCAAwD,EAAA;;AAW5D;ECxIE,0BAAyC;EACzC,wBAAyC;E5BkOnC,8BAf6B;E4BjNnC,kDAAiD,EAAA;E5BoE/C;I2BiEJ;M3BkGQ,8BA9E6B,EAAA,E2BlBpC;;AAED;EC5IE,2BAAyC;EACzC,0BAAyC;E5B8NrC,8BAnE+B;E4BzJnC,kDAAiD,EAAA;;ACnEnD;EVgBM,gCjB6nB2C,EAAA;EiBznB3C;IUpBN;MVqBQ,gBAAgB,EAAA,EUfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EVDZ,6BjB+nBwC,EAAA;EiB3nBxC;IULN;MVMQ,gBAAgB,EAAA,EUIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IVNV,4BjBgoBuC,EAAA;IiB5nBvC;MULN;QVMQ,gBAAgB,EAAA,EUGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;;ALyFwB;EKhF3C,0BAA6C;EAC7C,8BAAmD;EACnD,0BAAmD;EACnD,+BAAmD;EACnD,8BAA6C;E9BuQzC,kCAnE+B;E8BlMnC,yCAA2C;EAC3C,wCAAqC;EACrC,kDAAyD;EACzD,oDAA2D;EAC3D,6BAAyD;EACzD,oEAAuE;EACvE,gDAAqD;EACrD,sCAAiE;EACjE,iEAAqD;EACrD,8CAAqD;EACrD,wDAAiE;EACjE,kDAA2D;EAC3D,yDAAmE;EACnE,mDAA6D;EAC7D,2DAAuE;EACvE,oCAA6D;EAC7D,qCAA6D;EAC7D,mCAAyD;EACzD,sCAAiE;EACjE,sCAAiE;EAGjE,kBAAkB;EAClB,kCAA0D;EAC1D,aAAa;EACb,uCAAkE;EAClE,kEAAwH;EACxH,SAAS;E9B0OL,uCAnE+B;E8BrKnC,+BAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,uCAA2D;EAC3D,4BAA4B;EAC5B,6EAAyI;E3BzCvI,+C2B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IACT,OAAO;IACP,qCAA6D,EAAA;;AAwB7D;EACE,oBAAc,EAAA;EADhB;IAII,WAAW;IACX,OAAO,EAAA;;AAIX;EACE,kBAAc,EAAA;EADhB;IAII,QAAQ;IACR,UAAU,EAAA;;ApB1Cd;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;AAQP;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAgE,EAAA;;AAQpE;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sCAA8D,EAAA;;AANlE;EAYM,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,uCAA+D,EAAA;;AANnE;EAYM,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,6CAA+E;EAC/E,gBAAgB;EAChB,mDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,4EAA4I;EAC5I,WAAW;EACX,gB5BigB+B;E4BhgB/B,oCAAgE;EAChE,mBAAmB;EAEnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;E3BtKP,uD2BuKiG,EAAA;EAZrG;IAgBI,0CAA4E;IAC5E,qBAA6D;IV3L/D,kDU4LsF,EAAA;EAlBxF;IAuBI,2CAA8E;IAC9E,qBAAqB;IVlMvB,mDUmMwF,EAAA;EAzB1F;IA8BI,6CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,gFAAoJ;EACpJ,gBAAgB;E9BmEZ,qBAnE+B;E8BEnC,sCAAoE;EACpE,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,4EAA4I;EAC5I,oCAAgE,EAAA;;AAIlE;EAEE,4BAA2C;EAC3C,yBAAqC;EACrC,kDAAyD;EACzD,0BAAqD;EACrD,iCAAqD;EACrD,oCAAiE;EACjE,gDAAqD;EACrD,sDAA2D;EAC3D,yDAAmE;EACnE,mDAA6D;EAC7D,0CAAuE;EACvE,mCAAyD,EAAA;;ACtP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E5BhBI,sCD23BuE,EAAA;E6B32B3E;;IAMI,8CAA4C,EAAA;EANhD;;;I5BAI,0B4Ba4B;I5BZ5B,6B4BY4B,EAAA;EAbhC;;;I5BcI,yB4BS8B;I5BR9B,4B4BQ8B,EAAA;;AAgBlC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,6CAA2C,EAAA;EAZ/C;;I5B1EI,6B4B4F+B;I5B3F/B,4B4B2F+B,EAAA;EAlBnC;;I5BxFI,yB4B+G4B;I5B9G5B,0B4B8G4B,EAAA;;ACtIhC;EAEE,6BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,yCAA2C;EAC3C,qDAAuD;EACvD,uDAA6D;EAG7D,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kEAAwH;EhCsQpH,uCAnE+B;EgCjMnC,2CAAwE;EACxE,+BAAsD;EAEtD,gBAAgB;EAChB,SAAS;EbfL,uGjBwrCsH,EAAA;EiBprCtH;IaGN;MbFQ,gBAAgB,EAAA,Ea8BvB;EA5BD;IAaI,qCAAkE;IAClE,qBAA6D,EAAA;EAdjE;IAkBI,UAAU;IACV,kD9BkEa,EAAA;E8BrFjB;IAwBI,wCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,kDAAyD;EACzD,kDAAyD;EACzD,oDAA2D;EAC3D,2GAA+E;EAC/E,yDAAmE;EACnE,oDAA6D;EAC7D,4GAAiF;EAGjF,oFAAgJ,EAAA;EAXlJ;IAcI,yDAAuF;IACvF,yDAAuF;I7B5CvF,wD6B6C0F;I7B5C1F,yD6B4C0F,EAAA;IAhB9F;MAqBM,kBAAkB;MAClB,wDAAiG,EAAA;IAtBvG;MA2BM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EA7B/B;;IAmCI,2CAA8E;IAC9E,mDAAmF;IACnF,yDAAmG,EAAA;EArCvG;IA0CI,sDAAoF;I7BvEpF,yB6ByE4B;I7BxE5B,0B6BwE4B,EAAA;;AAShC;EAEE,qDAA6D;EAC7D,sCAAqE;EACrE,sCAA+D,EAAA;EAJjE;I7B3FI,gD6BmGwF,EAAA;IAR5F;MAWM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EAb/B;;IAmBI,4CAAgF;IZ7HlF,oDY8H0F,EAAA;;AAS5F;EAEE,4BAAiD;EACjD,yCAAmE;EACnE,8DAA6E;EAG7E,gCAA0D,EAAA;EAP5D;IAUI,gBAAgB;IAChB,eAAe;IACf,qEAAwG,EAAA;IAZ5G;MAgBM,iCAAiC,EAAA;EAhBvC;;IAsBI,gB9BshB6B;I8BrhB7B,gDAAwF;IACxF,iCAAiC,EAAA;;AASrC;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;ACzMlB;EAEE,wBAA+C;EAC/C,6BAA+C;EAC/C,2DAAuC;EACvC,gEAAmD;EACnD,mEAAyD;EACzD,+DAAqD;EACrD,uCAA2D;EAC3D,kCAA6D;EAC7D,uCAA2D;EAC3D,8DAAmD;EACnD,oEAA+D;EAC/D,sCAAiE;EACjE,sCAA+D;EAC/D,sCAA+D;EAC/D,yCAA+D;EAC/D,qEAA2D;EAC3D,0EAAqE;EACrE,0DAAuE;EACvE,wCAAmE;EACnE,4DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8DAAgH,EAAA;EA7BlH;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,6CAA4E;EAC5E,gDAA+E;EAC/E,+CAA+E;EjC4N3E,2CAnE+B;EiCvJnC,mCAA8D;EAE9D,mBAAmB,EAAA;EAPrB;IAWI,yCAA0E;IAC1E,qBAA6D,EAAA;;AASjE;EAEE,0BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAG7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAflB;IAoBM,oCAAgE,EAAA;EApBtE;IAyBI,gBAAgB,EAAA;;AASpB;EACE,mB/B0kCuC;E+BzkCvC,sB/BykCuC;E+BxkCvC,6BAAkD,EAAA;EAHpD;;;IAQI,oCAAgE,EAAA;;AAapE;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,8EAAgJ;EjCyI5I,6CAnE+B;EiCpEnC,cAAc;EACd,6BAAkD;EAClD,6BAA6B;EAC7B,0EAAmI;E9BxIjI,qD8ByIgG;Ed5I9F,+Cc6IqF,EAAA;EdzIrF;IciIN;MdhIQ,gBAAgB,EAAA,EcmJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,sDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,yCAA+D;EAC/D,gBAAgB,EAAA;;AvB1Hd;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,kDAAoF;MACpF,iDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;Id9N9B,gBcgO4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;;EAGE,4CAAuC;EACvC,kDAAmD;EACnD,qDAAyD;EACzD,8BAAqD;EACrD,6BAAmD;EACnD,mCAA+D;EAC/D,0DAAqE;EACrE,qEAA2D,EAAA;;A1Ci06B7D;E0C1z6BM,qEAA2D,EAAA;;ACzRjE;EAEE,2BAAyC;EACzC,2BAAyC;EACzC,gCAAqD;EACrD,+CAA+C;EAC/C,0BAAqD;EACrD,yBAAiD;EACjD,8CAAiD;EACjD,gDAAmD;EACnD,sBAA6C;EAC7C,gEAA+D;EAC/D,iCAAmD;EACnD,gCAAmD;EACnD,uCAAqC;EACrC,qBAA2C;EAC3C,kBAAqC;EACrC,iBAAmC;EACnC,oCAA6B;EAC7B,mCAA+D;EAC/D,4BAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAAiD;EACjD,2BAA8C;EAC9C,qBAAqB;EACrB,mCAAmD;EACnD,2BAA2B;EAC3B,qEAAyH;E/BjBvH,2C+BkB4E,EAAA;EAjChF;IAqCI,eAAe;IACf,cAAc,EAAA;EAtClB;IA0CI,mBAAmB;IACnB,sBAAsB,EAAA;IA3C1B;MA8CM,mBAAmB;M/BtBrB,0D+BuBgG;M/BtBhG,2D+BsBgG,EAAA;IA/CpG;MAmDM,sBAAsB;M/BbxB,8D+BcmG;M/BbnG,6D+BamG,EAAA;EApDvG;;IA4DI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,wDAAoG;EACpG,2BAA8C,EAAA;;AAGhD;EACE,4CAAwE;EACxE,iCAA0D,EAAA;;AAG5D;EACE,qDAAiF;EACjF,gBAAgB;EAChB,oCAAgE,EAAA;;AAGlE;EACE,gBAAgB,EAAA;;AAGlB;EAEI,qBAA6D,EAAA;;AAFjE;EAMI,oCAA0D,EAAA;;AAQ9D;EACE,kEAAwH;EACxH,gBAAgB;EAChB,+BAAsD;EACtD,uCAA2D;EAC3D,4EAAgI,EAAA;EALlI;I/BtFI,wF+B8FkK,EAAA;;AAItK;EACE,kEAAwH;EACxH,+BAAsD;EACtD,uCAA2D;EAC3D,yEAA6H,EAAA;EAJ/H;I/BlGI,wF+ByGkK,EAAA;;AAStK;EACE,sDAAiF;EACjF,sDAAiF;EACjF,qDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,mCAAmD;IACnD,sCAAsD,EAAA;;AAI1D;EACE,sDAAiF;EACjF,qDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,2CAA4E;E/B1I1E,iD+B2IwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;E/B3II,0D+B6I4F;E/B5I5F,2D+B4I4F,EAAA;;AAGhG;;E/BlII,8D+BoI+F;E/BnI/F,6D+BmI+F,EAAA;;AAQnG;EAII,0CAAoE,EAAA;;AxB3HpE;EwBuHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MAftB;QAkBQ,cAAc;QACd,cAAc,EAAA;MAnBtB;Q/BnJI,0B+B4KkC;Q/B3KlC,6B+B2KkC,EAAA;QAzBtC;;UA8BY,0BAA0B,EAAA;QA9BtC;;UAmCY,6BAA6B,EAAA;MAnCzC;Q/BrII,yB+B6KoC;Q/B5KpC,4B+B4KoC,EAAA;QAxCxC;;UA6CY,yBAAyB,EAAA;QA7CrC;;UAkDY,4BAA4B,EAAA,EAC7B;;ACrOX;EAEE,0CAA6C;EAC7C,yCAAuC;EACvC,8KAAuD;EACvD,mDAA2D;EAC3D,mDAA2D;EAC3D,qDAA6D;EAC7D,4FAAyE;EACzE,qCAA6D;EAC7D,kCAA6D;EAC7D,8CAAqD;EACrD,6CAA+C;EAC/C,iEAAmD;EACnD,mCAA+D;EAC/D,kDAAuE;EACvE,8DAAyE;EACzE,wEAAiE;EACjE,0EAA+E;EAC/E,4FAA2E;EAC3E,sCAA+D;EAC/D,mCAA+D;EAC/D,4DAA2D;EAC3D,qDAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4EAA4I;EnC2PxI,oBAnE+B;EmCtLnC,oCAAgE;EAChE,gBAAgB;EAChB,4CAAqE;EACrE,SAAS;EhCtBP,gBgCuBsB;EACxB,qBAAqB;EhB3BjB,0CgB4B2E,EAAA;EhBxB3E;IgBWN;MhBVQ,gBAAgB,EAAA,EgB2DvB;EAjDD;IAgBI,uCAAsE;IACtE,+CAA2E;IAC3E,kGAAgK,EAAA;IAlBpK;MAqBM,qDAAuF;MACvF,iDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,yCAA0E;IAC1E,0CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,8CAAyE;IACzE,4BAA4B;IAC5B,mDAAoF;IhBlDlF,mDgBmD+F,EAAA;IhB/C/F;MgBWN;QhBVQ,gBAAgB,EAAA,EgB+CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,wDAAiG;IACjG,UAAU;IACV,oDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,gCAAwD;EACxD,wCAA6D;EAC7D,+EAA6I,EAAA;EAH/I;IhC1DI,yDgCgE4F;IhC/D5F,0DgC+D4F,EAAA;IANhG;MhC1DI,+DgCmE0G;MhClE1G,gEgCkE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IhC5CI,6DgC+D+F;IhC9D/F,4DgC8D+F,EAAA;IAnBnG;MhC5CI,mEgCmE+G;MhClE/G,kEgCkE+G,EAAA;IAvBnH;MhC5CI,6DgCwEiG;MhCvEjG,4DgCuEiG,EAAA;;AAKrG;EACE,8EAAgJ,EAAA;;AAQlJ;EAEI,eAAe,EAAA;;AAFnB;EAMI,eAAe;EACf,cAAc;EhCpHd,gBgCqHwB,EAAA;EAR5B;IAUoB,aAAa,EAAA;EAVjC;IAWmB,gBAAgB,EAAA;EAXnC;IhC7GI,gBgC6H4B,EAAA;;A5Cut7BhC;E4C9s7BM,iEAAmD;EACnD,wEAAiE,EAAA;;AC1JvE;EAEE,+BAAuD;EACvD,kCAAuD;EACvD,mCAA+D;EAE/D,oBAAyC;EACzC,+BAA+D;EAC/D,wDAA+D;EAC/D,sCAAiE;EACjE,4DAAuE;EAGvE,aAAa;EACb,eAAe;EACf,sEAAgI;EAChI,iDAAkF;EpC+Q9E,yCAnE+B;EoC1MnC,gBAAgB;EAChB,yCAA+D;EjCA7D,iDiCCwF,EAAA;;AAG5F;EAGI,iDAAmF,EAAA;EAHvF;IAMM,WAAW;IACX,kDAAoF;IACpF,yCAA0E;IAC1E,uFAAuN,EAAA;;AAT7N;EAcI,6CAAkF,EAAA;;ACrCtF;EAEE,kCAAuD;EACvD,iCAAuD;ErC4RnD,oCAnE+B;EqCvNnC,gDAA+C;EAC/C,0CAAyC;EACzC,oDAA6D;EAC7D,oDAA6D;EAC7D,sDAA+D;EAC/D,uDAA2D;EAC3D,+CAAqD;EACrD,0DAAyE;EACzE,uDAA2D;EAC3D,gDAAqD;EACrD,wEAAqE;EACrE,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAC3E,yDAAiE;EACjE,mDAA2D;EAC3D,6DAA+E;EAG/E,aAAa;EhCpBb,eAAe;EACf,gBAAgB,EAAA;;AgCuBlB;EACE,kBAAkB;EAClB,cAAc;EACd,sEAAgI;ErCgQ5H,yCAnE+B;EqC3LnC,iCAA0D;EAE1D,yCAA+D;EAC/D,iFAAiJ;ElBpB7I,qIjBu1CoJ,EAAA;EiBn1CpJ;IkBQN;MlBPQ,gBAAgB,EAAA,EkBiDvB;EA1CD;IAYI,UAAU;IACV,uCAAsE;IACtE,qBAA6D;IAC7D,+CAA2E;IAC3E,qDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,uCAAsE;IACtE,+CAA2E;IAC3E,UnCsyCiC;ImCryCjC,iDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,wCAAwE;IjBtD1E,gDiBuDkF;IAChF,sDAA6F,EAAA;EAhCjG;;IAqCI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF;IACjF,wDAAiG,EAAA;;AAIrG;EAEI,8CnCywCsE,EAAA;;AmC3wC1E;ElCvBI,0DkC+BoG;ElC9BpG,6DkC8BoG,EAAA;;AARxG;ElCrCI,2DkCmDkG;ElClDlG,8DkCkDkG,EAAA;;AAgBtG;EClGE,iCAAuD;EACvD,kCAAuD;EtC8RjD,qCAf6B;EsC7QnC,yDAA+D,EAAA;EtCgI7D;IqCjCJ;MrCoMQ,qCA9E6B,EAAA,EqCpHpC;;AAED;ECtGE,iCAAuD;EACvD,kCAAuD;EtC0RnD,qCAnE+B;EsCrNnC,yDAA+D,EAAA;;ACFjE;EAEE,2BAA6C;EAC7C,4BAA6C;EvCuRzC,yBAnE+B;EuClNnC,2BAAiD;EACjD,sBAAqC;EACrC,iDAAqD;EAGrD,qBAAqB;EACrB,4DAA4G;EvC+QxG,oCAnE+B;EuC1MnC,wCAAkE;EAClE,cAAc;EACd,4BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EpCJtB,4CoCK8E,EAAA;EAnBlF;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AChCX;EAEE,0BAA+B;EAC/B,6BAA6C;EAC7C,6BAA6C;EAC7C,8BAAqD;EACrD,yBAAqC;EACrC,oCAAmD;EACnD,4EAAuC;EACvC,iDAAqD;EACrD,8BAA+C;EAG/C,kBAAkB;EAClB,4DAA4G;EAC5G,4CAAwE;EACxE,4BAAgD;EAChD,oCAAqD;EACrD,8BAAmD;ErCHjD,4CqCI8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBtCqpB+B;EsCppB/B,iCAA0D,EAAA;;AAQ5D;EACE,sBtCmiDkD,EAAA;EsCpiDpD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UtC+duC;IsC9dvC,0BtCihDuC,EAAA;;AsCzgDzC;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,mDAAqC;EACrC,4CAA+B;EAC/B,0DAAmD;EACnD,wDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,gDAAqC;EACrC,yCAA+B;EAC/B,uDAAmD;EACnD,qDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,+CAAqC;EACrC,wCAA+B;EAC/B,sDAAmD;EACnD,oDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AC5DjD;EACE;IAAK,+BvCslDkC,EAAA,EAAA;;AuCjlD3C;;EAGE,8BAA6C;EzCkRzC,mCAnE+B;EyC7MnC,uCAAqC;EACrC,oDAA2D;EAC3D,oDAAqD;EACrD,6BAAmD;EACnD,6BAA6C;EAC7C,6CAA6D;EAG7D,aAAa;EACb,iCAAyD;EACzD,gBAAgB;EzCsQZ,uCAnE+B;EyCjMnC,uCAA2D;EtCRzD,+CsCSoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,2CAAmE;EtBxB/D,6CsByBiF,EAAA;EtBrBjF;IsBYN;MtBXQ,gBAAgB,EAAA,EsBqBvB;;AAED;ErBAE,qMAA6I;EqBE7I,oEAAoH,EAAA;;AAGtH;EACE,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAIX;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AC9DH;EAEE,+CAA+C;EAC/C,0CAAyC;EACzC,oDAA6D;EAC7D,oDAA6D;EAC7D,sDAA+D;EAC/D,uCAAiE;EACjE,uCAAiE;EACjE,uDAA6D;EAC7D,4DAAyE;EACzE,sDAAmE;EACnE,yDAA2E;EAC3E,wDAAqE;EACrE,wDAAiE;EACjE,mDAA2D;EAC3D,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;EvCXd,iDuCYwF,EAAA;;AAG5F;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAS9B;EACE,WAAW;EACX,wCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IAQI,UAAU;IACV,8CAAoF;IACpF,qBAAqB;IACrB,sDAAyF,EAAA;EAX7F;IAeI,+CAAsF;IACtF,uDAA2F,EAAA;;AAQ/F;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAoJ;EACpJ,iCAA0D;EAE1D,yCAA+D;EAC/D,iFAAiJ,EAAA;EAPnJ;IvC9CI,+BuCwDkC;IvCvDlC,gCuCuDkC,EAAA;EAVtC;IvChCI,mCuC8CqC;IvC7CrC,kCuC6CqC,EAAA;EAdzC;IAmBI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,wCAAwE;IACxE,gDAA6E;IAC7E,sDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,wDAAwF;MACxF,mDAAmF,EAAA;;AAarF;EACE,mBAAmB,EAAA;EADrB;IvCnDA,6DuCwD6G;IvCpE7G,0BuCqEsC,EAAA;EANtC;IvC/DA,2DuCyEwG;IvC7DxG,4BuC8D2C,EAAA;EAX3C;IAeM,aAAa,EAAA;EAfnB;IAmBM,mDAAmF;IACnF,oBAAoB,EAAA;IApB1B;MAuBQ,yDAAyF;MACzF,oDAAoF,EAAA;;AhCtF5F;EgC8DA;IACE,mBAAmB,EAAA;IADrB;MvCnDA,6DuCwD6G;MvCpE7G,0BuCqEsC,EAAA;IANtC;MvC/DA,2DuCyEwG;MvC7DxG,4BuC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCvFP;EgC8DA;IACE,mBAAmB,EAAA;IADrB;MvCnDA,6DuCwD6G;MvCpE7G,0BuCqEsC,EAAA;IANtC;MvC/DA,2DuCyEwG;MvC7DxG,4BuC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCvFP;EgC8DA;IACE,mBAAmB,EAAA;IADrB;MvCnDA,6DuCwD6G;MvCpE7G,0BuCqEsC,EAAA;IANtC;MvC/DA,2DuCyEwG;MvC7DxG,4BuC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCvFP;EgC8DA;IACE,mBAAmB,EAAA;IADrB;MvCnDA,6DuCwD6G;MvCpE7G,0BuCqEsC,EAAA;IANtC;MvC/DA,2DuCyEwG;MvC7DxG,4BuC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCvFP;EgC8DA;IACE,mBAAmB,EAAA;IADrB;MvCnDA,6DuCwD6G;MvCpE7G,0BuCqEsC,EAAA;IANtC;MvC/DA,2DuCyEwG;MvC7DxG,4BuC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AAaX;EvChJI,gBuCiJsB,EAAA;EAD1B;IAII,mDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;AAa1B;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,wDAA+C;EAC/C,iDAAyC;EACzC,+DAA6D;EAC7D,4DAAyE;EACzE,kEAAmE;EACnE,6DAA2E;EAC3E,mEAAqE;EACrE,2DAA6D;EAC7D,4DAAuD;EACvD,sEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,qDAA+C;EAC/C,8CAAyC;EACzC,4DAA6D;EAC7D,4DAAyE;EACzE,+DAAmE;EACnE,6DAA2E;EAC3E,gEAAqE;EACrE,wDAA6D;EAC7D,yDAAuD;EACvD,mEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,oDAA+C;EAC/C,6CAAyC;EACzC,2DAA6D;EAC7D,4DAAyE;EACzE,8DAAmE;EACnE,6DAA2E;EAC3E,+DAAqE;EACrE,uDAA6D;EAC7D,wDAAuD;EACvD,kEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AC5L/E;EAEE,0BAA6C;EAC7C,2DAAuC;EACvC,2BAAiD;EACjD,kCAA6D;EAC7D,iCAA2D;EAC3D,+BAA6D;EAC7D,qCAAmE;EACnE,uEAA2D;EAG3D,uBAAuB;EACvB,UzCitD8B;EyChtD9B,WzCgtD8B;EyC/sD9B,sBzCitDgC;EyChtDhC,gCAAwD;EACxD,wEAA4G;EAC5G,SAAS;ExCJP,sBDslBgC;EyChlBlC,oCAA8D,EAAA;EApBhE;IAwBI,gCAAwD;IACxD,qBAAqB;IACrB,0CAA0E,EAAA;EA1B9E;IA8BI,UAAU;IACV,4CAA2E;IAC3E,0CAA0E,EAAA;EAhC9E;IAqCI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,6CAAgF,EAAA;;AAQpF;EAHE,wCAAuE,EAAA;;ApD058BzE;EoD158BE,wCAAuE,EAAA;;ACjDzE;EAEE,uBAAuC;EACvC,6BAA6C;EAC7C,6BAA6C;EAC7C,wBAAyC;EACzC,2BAA6C;E5CyRzC,8BAnE+B;E4CpNnC,kBAAqC;EACrC,qCAA+B;EAC/B,+CAAmD;EACnD,+CAAmD;EACnD,iCAAqD;EACrD,8CAA+C;EAC/C,kDAAmD;EACnD,4CAA6C;EAC7C,sDAAiE;EAGjE,gCAAwD;EACxD,eAAe;E5C2QX,oCAnE+B;E4CtMnC,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;EAC7H,sCAA+D;EzCR7D,4CyCS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,uBAAuC;EAEvC,kBAAkB;EAClB,+BAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,sCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4G;EAC5G,mCAA8D;EAC9D,2CAAmE;EACnE,4BAA4B;EAC5B,qFAAkJ;EzChChJ,0FyCiCkJ;EzChClJ,2FyCgCkJ,EAAA;EARtJ;IAWI,mDAA2E;IAC3E,sCAA8D,EAAA;;AAIlE;EACE,kCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,uBAAuC;EACvC,uBAAqC;EACrC,wBAAyC;EACzC,yBAAuC;EACvC,kBAAqC;EACrC,qCAA+B;EAC/B,+CAAmD;EACnD,+CAAmD;EACnD,oDAAqD;EACrD,8DAA+C;EAC/C,2FAAiE;EACjE,iCAA2D;EAC3D,iCAA2D;EAC3D,oCAAuD;EACvD,sDAAiE;EACjE,sDAAiE;EACjE,iCAA6D;EAC7D,6BAA+C;EAC/C,sBAA6C;EAC7C,sDAAiE;EACjE,sDAAiE;EAGjE,eAAe;EACf,MAAM;EACN,OAAO;EACP,+BAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,8BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;I1B5CI,mCjB0iDoD;I2C5/CtD,8B3C0/CmD,EAAA;IiBpiDjD;M0BwCJ;Q1BvCM,gBAAgB,EAAA,E0B0CrB;EACD;IACE,e3Cw/CoC,EAAA;E2Cp/CtC;IACE,sB3Cq/C2C,EAAA;;A2Cj/C/C;EACE,+CAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;E1CrF3H,4C0CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,0BAA6C;EAC7C,sBAAqC;EACrC,0BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,uCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,mCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAoE;EACpE,4FAAgK;E1CtG9J,2D0CuG8F;E1CtG9F,4D0CsG8F,EAAA;EAPlG;IAUI,gGAA8J;IAC9J,mJAAgP,EAAA;;AAKpP;EACE,gBAAgB;EAChB,8CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,gCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAuH;EACvH,2CAAmE;EACnE,yFAA6J;E1C1H3J,+D0C2HiG;E1C1HjG,8D0C0HiG,EAAA;EATrG;IAeI,6CAAsE,EAAA;;AnC5GtE;EmCtDJ;IAyKI,0BAAuC;IACvC,8DAA+C,EAAA;EA/HnD;IAoII,gCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,uBAAqC,EAAA,EACtC;;AnChIC;EmCoIF;;IAEE,uBAAqC,EAAA,EACtC;;AnCvIC;EmC2IF;IACE,wBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I1C1Mb,gB0C2M4B,EAAA;EAT5B;;I1ClMA,gB0CgN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;AnC3JpB;EmCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C1Mb,gB0C2M4B,EAAA;IAT5B;;M1ClMA,gB0CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC5JH;EmCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C1Mb,gB0C2M4B,EAAA;IAT5B;;M1ClMA,gB0CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC5JH;EmCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C1Mb,gB0C2M4B,EAAA;IAT5B;;M1ClMA,gB0CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC5JH;EmCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C1Mb,gB0C2M4B,EAAA;IAT5B;;M1ClMA,gB0CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC5JH;EmCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C1Mb,gB0C2M4B,EAAA;IAT5B;;M1ClMA,gB0CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AEvOP;EAEE,yBAA2C;EAC3C,6BAAiD;EACjD,8BAAiD;EACjD,8BAAiD;EACjD,sBAA2C;E/CwRvC,kCAnE+B;E+CnNnC,0CAAyC;EACzC,yCAAmC;EACnC,mDAAyD;EACzD,yBAA6C;EAC7C,gCAAqD;EACrD,iCAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,gCAAuD;EClBvD,sC9CuqB6E;E8CrqB7E,kBAAkB;EAClB,gB9CgrB+B;E8C/qB/B,gB9CsrB+B;E8CrrB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EhDgRZ,sCAnE+B;E+ClMnC,qBAAqB;EACrB,UAAU,EAAA;EA1BZ;IA4BW,kCAA0D,EAAA;EA5BrE;IA+BI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IAjCvE;MAoCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,iDAA8E,EAAA;EADhF;IAII,SAAS;IACT,uFAAgJ;IAChJ,sCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,+CAA4E;EAC5E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,gIAAqN;IACrN,wCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,8CAA2E,EAAA;EAD7E;IAII,YAAY;IACZ,uFAAgJ;IAChJ,yCAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,gDAA6E;EAC7E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,gIAAqN;IACrN,uCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,sCAAgE;EAChE,gEAAoH;EACpH,8BAAoD;EACpD,kBAAkB;EAClB,sCAAyD;E5CjGvD,8C4CkGkF,EAAA;;AErHtF;EAEE,yBAA2C;EAC3C,6BAAiD;EjD4R7C,kCAnE+B;EiDvNnC,uCAAmC;EACnC,iDAAuD;EACvD,iDAAuD;EACvD,sDAAyD;EACzD,2FAAqE;EACrE,4DAAmD;EACnD,mCAA+D;EAC/D,qCAA+D;EjDmR3D,wCAnE+B;EiD9MnC,kCAAuD;EACvD,8CAAiD;EACjD,iCAA2D;EAC3D,iCAA2D;EAC3D,6CAAmD;EACnD,8BAAqD;EACrD,iCAAuD;EACvD,yDAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,sCAAgE;EDzBhE,sC9CuqB6E;E8CrqB7E,kBAAkB;EAClB,gB9CgrB+B;E8C/qB/B,gB9CsrB+B;E8CrrB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EhDgRZ,sCAnE+B;EiD5LnC,qBAAqB;EACrB,sCAAyD;EACzD,4BAA4B;EAC5B,2EAAqI;E9ChBnI,8C8CiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,oFAA8I,EAAA;EAFlJ;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,gDAA6E,EAAA;EAXnF;IAeM,sCAAmE;IACnE,sCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,kFAA4I;EAC5I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,kDAA+E,EAAA;EAbrF;IAiBM,oCAAiE;IACjE,wCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,iFAA2I,EAAA;EAF/I;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,mDAAgF,EAAA;EAXtF;IAeM,mCAAgE;IAChE,yCAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oCAAgE;EAChE,sDAAkF;EAClF,WAAW;EACX,+EAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,mFAA6I;EAC7I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,iDAA8E,EAAA;EAbpF;IAiBM,qCAAkE;IAClE,uCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,8EAAgJ;EAChJ,gBAAgB;EjD2GZ,6CAnE+B;EiDtCnC,qCAAkE;EAClE,6CAAuE;EACvE,kFAA4I;E9C5J1I,6D8C6JkG;E9C5JlG,8D8C4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,0EAAwI;EACxI,mCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;E/BlBvB,sCjBwrDkF,EAAA;EiBprDlF;I+BQN;M/BPQ,gBAAgB,EAAA,E+BevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;E/B5DR,2BjBurDkC,EAAA;EiBnrDlC;I+BuCN;;M/BtCQ,gBAAgB,EAAA,E+ByDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UhD+kDsC;EgD9kDtC,UAAU;EACV,WhDpBa;EgDqBb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YhD0kDqC;EiBhqDjC,8BjBkqDgD,EAAA;EiB9pDhD;I+BkEN;;M/BjEQ,gBAAgB,EAAA,E+B4FvB;EA3BD;;;IAsBI,WhD9BW;IgD+BX,qBAAqB;IACrB,UAAU;IACV,YhDkkDmC,EAAA;;AgD/jDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WhDmkDuC;EgDlkDvC,YhDkkDuC;EgDjkDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;;;;;;;G3Do89BG;A2D579BH;EACE,0DlCRgF,EAAA;;AkCUlF;EACE,0DlCXgF,EAAA;;AkCmBlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBhD2gDsC;EgD1gDtC,mBAAmB;EACnB,gBhDygDsC,EAAA;EgDrhDxC;IAeI,uBAAuB;IACvB,cAAc;IACd,WhDygDqC;IgDxgDrC,WhDygDoC;IgDxgDpC,UAAU;IACV,iBhDygDoC;IgDxgDpC,gBhDwgDoC;IgDvgDpC,mBAAmB;IACnB,eAAe;IACf,sBhDpGW;IgDqGX,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YhDggDmC;IiBxqDjC,6BjB2qD+C,EAAA;IiBvqD/C;M+BsIN;Q/BrIQ,gBAAgB,EAAA,E+BqKrB;EAhCH;IAmCI,UhD6/CkC,EAAA;;AgDp/CtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,ehDu/C0C;EgDt/C1C,SAA2C;EAC3C,oBhDo/C0C;EgDn/C1C,uBhDm/C0C;EgDl/C1C,WhD/Ha;EgDgIb,kBAAkB,EAAA;;AAMlB;;EAEE,gChDw/CyD,EAAA;;AgDr/C3D;EACE,sBhDlIW,EAAA;;AgDqIb;EACE,WhDtIW,EAAA;;AXgj+Bf;;;E2Dl79BI,gChDw/CyD,EAAA;;AX+76B7D;E2Dn79BI,sBhDlIW,EAAA;;AXwj+Bf;E2Dl79BI,WhDtIW,EAAA;;AkDpFf;;EAEE,qBAAqB;EACrB,8BAAoD;EACpD,gCAAuD;EACvD,gDAA+E;EAE/E,kBAAkB;EAClB,6FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,iCAAuD;EACvD,mCAA6D;EAC7D,2CAA2D;EAG3D,yDAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,gCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,mCAA6D;EAC7D,yCAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,wBAAyC;EACzC,yBAA2C,EAAA;;AAI3C;EACE;;IAEE,kCAA6D,EAAA,EAC9D;;AChFL;EAEE,2BAA+C;EAC/C,2BAA6C;EAC7C,2BAA+C;EAC/C,8BAAqD;EACrD,8BAAqD;EACrD,0CAA6C;EAC7C,yCAAuC;EACvC,mDAA2D;EAC3D,mDAA2D;EAC3D,kEAAuD;EACvD,qDAAuD;EACvD,qCAAqE,EAAA;;A3C6DnE;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,mCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAwD;EACxD,kBAAkB;EAClB,wCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;ElC5BV,0CkC8B+E,EAAA;ElC1B/E;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;EAnFD;IAiBM,MAAM;IACN,OAAO;IACP,gCAAwD;IACxD,qFAAmJ;IACnJ,4BAA4B,EAAA;EArBlC;IAyBM,MAAM;IACN,QAAQ;IACR,gCAAwD;IACxD,oFAAkJ;IAClJ,2BAA2B,EAAA;EA7BjC;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,sFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,mFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,eAAe,EAAA;EArDrB;IA2DM,mBAAmB,EAAA;;AA2B3B;EPpHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a5CuqCsC;E4CtqCtC,YAAY;EACZ,aAAa;EACb,sB5CgFa,EAAA;E4C7Eb;IAAS,UAAU,EAAA;EACnB;IAAS,Y5C4hD2B,EAAA;;AmD96CtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oEAA4H,EAAA;EAJ9H;IAOI,0FAAkJ;IAClJ,qDAAiF;IACjF,uDAAmF;IACnF,wDAAoF,EAAA;;AAIxF;EACE,gBAAgB;EAChB,kDAAsF,EAAA;;AAGxF;EACE,YAAY;EACZ,oEAA4H;EAC5H,gBAAgB,EAAA;;AChJlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YpD22CoC,EAAA;EoDj3CtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YpD80CkC,EAAA,EAAA;;AoD10CtC;EACE,+EAA8G;EAC9G,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,uBAAuB,EAAA,EAAA;;AH9CzB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AIFb;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,sEAAyH,EAAA;;ACH3H;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,0EAA4I;EAC5I,oGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,uEAA4I;EAC5I,iGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,sEAA4I;EAC5I,gGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AAOxK;EACE,+EAA+J;EAC/J,yGAAmM,EAAA;EAFrM;IAOM,kFAAiK;IACjK,4GAAqM,EAAA;;AC1B3M;EACE,UAAU;EAEV,kJAAsQ,EAAA;;ACHxQ;EACE,oBAAoB;EACpB,axDohBmC;EwDnhBnC,mBAAmB;EACnB,kFAA6H;EAC7H,6BxDkhBiC;EwDjhBjC,2BAA2B,EAAA;EAN7B;IASI,cAAc;IACd,UxD8gB6B;IwD7gB7B,WxD6gB6B;IwD5gB7B,kBAAkB;IvCIhB,sCjBygBiD,EAAA;IiBrgBjD;MuCpBN;QvCqBQ,gBAAgB,EAAA,EuCPrB;;AAGH;EAIM,mEAA+F,EAAA;;ACnBrG;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,mCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAA;;AAKd;EACE,uBAAuC,EAAA;;AADzC;EACE,qCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a1DoqCsC,EAAA;;A0DjqCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a1D4pCsC,EAAA;;A0DppCpC;EACE,gBAAgB;EAChB,MAAM;EACN,a1DgpCkC,EAAA;;A0D7oCpC;EACE,gBAAgB;EAChB,SAAS;EACT,a1D0oCkC,EAAA;;AQ3mCpC;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DgpCkC,EAAA;E0D7oCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1D0oCkC,EAAA,E0DzoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DgpCkC,EAAA;E0D7oCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1D0oCkC,EAAA,E0DzoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DgpCkC,EAAA;E0D7oCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1D0oCkC,EAAA,E0DzoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DgpCkC,EAAA;E0D7oCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1D0oCkC,EAAA,E0DzoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DgpCkC,EAAA;E0D7oCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1D0oCkC,EAAA,E0DzoCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;EAGpB;;IACE,6BAA6B,EAAA;;ACfjC;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U9DugBuC;E8DtgBvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,YjEgwB+B,EAAA;;AkEpsBzB;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAjBnE;EACE,gFAAoC,EAAA;;AADtC;EACE,kFAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,+EAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,8EAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AAStC;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,kBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,uFAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,2FAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,6FAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,8FAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4FAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAjBnE;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AAStC;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,uCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,0BAA+D;EAA/D,yBAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,wBAA+D;EAA/D,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,0BAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,yBAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,kDAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AArBnE,qBAAA;AAcA;EAOI,gCAA+D;EAA/D,iCAA+D,EAAA;;AAmBnE,mBAAA;AA1BA;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,uEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,wEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oCAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAjBnE;EACE,uBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AAStC;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,mDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAjBnE;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,oBAAoC,EAAA;;AAIpC;EACE,oBAAoC,EAAA;;AAIxC;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAOI,wCAA+D,EAAA;;AAKjE;EAOI,wCAA+D,EAAA;;AAnBrE;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,iGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,8FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,6FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAjBnE;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AAIxC;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wCAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAjBnE;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,kBAAoC,EAAA;;AAStC;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,mCAA+D;UAA/D,2BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,oCAA+D;EAA/D,qCAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,sCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,qCAA+D;EAA/D,wCAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,0CAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,mEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,wCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,0CAA+D;EAA/D,yCAA+D,EAAA;;AAPnE;EAOI,mEAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,oCAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,yCAA+D;EAA/D,sCAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;A1DVvE;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;ACxDT;ED+CQ;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA,EAElE;;ACrCT;ED4BQ;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA,EAElE;;AnEhDT;EqEpBI,iDAAiC;EACjC,oDAAiD;EAGjD,oDAA2C;EAC3C,oDAA2D;EAE3D,oDAA+C;EAG/C,oDAAiC;EACjC,oDAAuC;EAGvC,iDAAiC;EACjC,oDAA6C;EAC7C,oDAA2D;EAG3D,oDAAyC;EAEzC,iDAAuC;EACvC,kDAAyC,EAAA;;A/EoxnC7C;E+E7wnCQ,oDAAiC;EACjC,oDAAiD;EAGjD,oDAA2C;EAC3C,oDAA2D;EAC3D,oDAA+C;EAG/C,oDAAiC;EACjC,oDAAuC;EAGvC,oDAAiC;EACjC,oDAA6C;EAC7C,oDAA2D;EAG3D,oDAAyC;EAGzC,wDAAyB;EACzB,2DAAiC;EACjC,wDAAuB;EACvB,8DAA+B;EAE/B,kDAAuC;EACvC,iDAAyC,EAAA;E/EownC/C;I+EjwnCU,+DAAiC;IACjC,+DAA2B;IAC3B,+DAA+C,EAAA;E/EmwnCzD;I+E/vnCU,+DAAiC;IACjC,+DAA+C,EAAA;E/EiwnCzD;;I+E5vnCU,oDAA6C;IAC7C,oDAAuC;IACvC,oDAA2D;IAC3D,oDAA+C;IAC/C,oDAAyC;IACzC,oDAA6D;IAC7D,uDAAuD,EAAA;E/E+vnCjE;I+E3vnCU,oDAA2B;IAC3B,oDAA+C;IAC/C,oDAAuC,EAAA;E/E6vnCjD;I+EzvnCU,oDAAiC;IACjC,oDAA+C,EAAA;E/E2vnCzD;I+EvvnCU,gDAAyD,EAAA;E/EyvnCnE;I+ErvnCU,2DAAiB;IACjB,2DAAc;IACd,2DAAwB,EAAA;E/EuvnClC;I+EnvnCU,2DAAiB;IACjB,2DAAc;IACd,2DAAwB,EAAA;;AC/GpC;;ehFu2nCe;AgFn2nCf;EACE,kBAAkB;EAClB,gBAAgB,EAAA;;AtE4OlB;EsEnOE,gCAAgC,EAAA;;AtE8WlC;EsE1WE,gBAAgB;EAChB,qBrEs5B2C,EAAA;;AEn1B7C;EmE7DE,kBAAkB;EAClB,6CAA2E,EAAA;;AAG7E;EACE,cAAc;EACd,8CAA4E;EAC5E,iBAAiB,EAAA;;AAMjB;EADF;IAEM,iBAAiB,EAAA,EAEtB;;A5D/BC;E4DqCI,kBAAkB,EAAA;;AC3CxB;EAIM,6BAAkD,EAAA;;AAqBtD;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctE4Fe;EsE3Ff,qDAA4C,EAAA;EAG1C;IAEE,ctEsFW;IsErFX,qBAAqB;IACrB,yCtEoFW,EAAA;;AsE9Ef;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEoEgB;EsEnEhB,sDAA4C,EAAA;EAG1C;IAEE,ctE8DY;IsE7DZ,qBAAqB;IACrB,0CtE4DY,EAAA;;AsEtDhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEmGe;EsElGf,qDAA4C,EAAA;EAG1C;IAEE,ctE6FW;IsE5FX,qBAAqB;IACrB,yCtE2FW,EAAA;;AsErFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEqGe;EsEpGf,qDAA4C,EAAA;EAG1C;IAEE,ctE+FW;IsE9FX,qBAAqB;IACrB,yCtE6FW,EAAA;;AsEvFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEkGe;EsEjGf,qDAA4C,EAAA;EAG1C;IAEE,ctE4FW;IsE3FX,qBAAqB;IACrB,yCtE0FW,EAAA;;AsEpFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEgGe;EsE/Ff,sDAA4C,EAAA;EAG1C;IAEE,ctE0FW;IsEzFX,qBAAqB;IACrB,0CtEwFW,EAAA;;AsElFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctE+Fe;EsE9Ff,qDAA4C,EAAA;EAG1C;IAEE,ctEyFW;IsExFX,qBAAqB;IACrB,yCtEuFW,EAAA;;AsEtEjB;EANQ,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEgEgB;EsE/DhB,sDAA4C,EAAA;EAG1C;IAEE,ctE0DY;IsEzDZ,qBAAqB;IACrB,0CtEwDY,EAAA;;AsElDhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEsEgB;EsErEhB,mDAA4C,EAAA;EAG1C;IAEE,ctEgEY;IsE/DZ,qBAAqB;IACrB,uCtE8DY,EAAA;;AkEpBV;EILL,mBAAmB;EAClB,kBAAkB,EAAA;;AAKtB;EACE,sBAAoC,EAAA;;AChEtC;;EAEI,wBAAwB,EAAA;;A9CoH1B;E8ChHC,yBAAyB,EAAA;EAD5B;IAIQ,yBAAyB,EAAA;;AAKjC;EACI,mBAAmB,EAAA;;AAGvB;EAEQ,mEvE62ByG,EAAA;;AuEv2BjH;EAEQ,kBAAkB,EAAA;EAF1B;IAMgB,aAAa,EAAA;EAN7B;IAWY,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2CAAmE;IACnE,6BAAkD;IAClD,wCAA6D;IAC7D,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,UAAU,EAAA;;AAOtB;EACI,kBAAkB;EAClB,kBAAkB,EAAA;EAFtB;IAIQ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,0CvEQO;IuEPP,gDvEOO;IuENP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAd/B;IAkBY,uCvEOM;IuENN,6CvEMM,EAAA;;AuEAlB;EAEQ,kBAAkB,EAAA;;AAyBtB;EAfA,cvEUa;EuETb,yCvESa;EuERb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEES;IuEDT,yBAAyB,EAAA;;AAM7B;EAfA,cvEdc;EuEed,0CvEfc;EuEgBd,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEtBU;IuEuBV,yBAAyB,EAAA;;AAM7B;EAfA,cvEiBa;EuEhBb,yCvEgBa;EuEfb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvESS;IuERT,yBAAyB,EAAA;;AAM7B;EAfA,cvEmBa;EuElBb,yCvEkBa;EuEjBb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEWS;IuEVT,yBAAyB,EAAA;;AAM7B;EAfA,cvEgBa;EuEfb,yCvEea;EuEdb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEQS;IuEPT,yBAAyB,EAAA;;AAM7B;EAfA,cvEca;EuEbb,0CvEaa;EuEZb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEMS;IuELT,yBAAyB,EAAA;;AAM7B;EAfA,cvEaa;EuEZb,yCvEYa;EuEXb,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEKS;IuEJT,yBAAyB,EAAA;;AAM7B;EAfA,cvElBc;EuEmBd,0CvEnBc;EuEoBd,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvE1BU;IuE2BV,yBAAyB,EAAA;;AAM7B;EAfA,cvEZc;EuEad,uCvEbc;EuEcd,yBAAyB;EACzB,yBAAyB,EAAA;EACzB;IAGI,WvE3BO;IuE4BP,yBvEpBU;IuEqBV,yBAAyB,EAAA;;AAWjC;EAGY,cvETK,EAAA;EuEMjB;IAKgB,gBAAgB,EAAA;;ACpHhC;EAEQ,+BAAsD,EAAA;;AtCc9D;EsCVY,oCAAoC,EAAA;;AxCThD;EyCCE,mBzEykBgC;EyExkBhC,mDzEgnB+D,EAAA;;AyE7mBjE;EACE,2BAA8C,EAAA;;AzCkEhD;EyC9DE,eAAe;EACf,iBAAiB;EACjB,gBzEsqB+B;EyErqB/B,+BAAsD,EAAA;;AAGxD;EACE,gCAAwD;EACxD,mBAAmB,EAAA;;AlD8EwB;EmD/F3C,4C1EmFa;E0ElFb,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,aAAa,EAAA;E9CyMf;I8CtMI,oBAAoB,EAAA;;AAOxB;EACE,qBAAqB;EACrB,mBAAmB,EAAA;;AAGrB;;;EAGE,oBAAoB;EACpB,0BAA0B,EAAA;;AAG5B;EACE;IACE,wBAAwB,EAAA;EAE1B;IACE,2BAA2B,EAAA,EAAA;;AAI/B;EACE;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA,EACb;;AAMH;EACE,2BAA2B,EAAA;;AAG7B;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB,EAAA;;AAKxB;EACE,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;;AAGd;EAEI,wBAAwB,EAAA;;AAG5B;EAGM,wBAAwB,EAAA;;AC/E9B;EAGQ,+BAAsD;EACtD,gB3E6qByB,EAAA;;A2ExqBjC;EAEI,+BAAsD;EACtD,gB3EqqB6B,EAAA;;A2EhqBjC;EACE,+CAAoE,EAAA;EADtE;IAII,kBAAkB;IAClB,2BAA8C,EAAA;IALlD;MAOM,YAAY,EAAA;MAPlB;QAUQ,WAAW;QACX,mB3E4ES;Q2E3ET,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,OAAO;QACP,YAAY;QACZ,6BAA6B;QAC7B,mBAAmB,EAAA;MAlB3B;QAsBQ,c3EiES,EAAA;Q2EvFjB;UAwBU,mBAAmB,EAAA;;AAW7B;EAGU,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAA;EAL5B;IAOc,eAAe,EAAA;;AC3D7B;EAEM,gB5EirB2B,EAAA;;A4E7qBjC;EACE,4B9DmMmC,EAAA;;A8D/LrC;EACE,2D5EqyBuE,EAAA;;A4ElyBzE;EAEI,mBAAmB,EAAA;;AAIvB;EACI,aAAa,EAAA;;ACrBjB;EAEQ,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iBAAiB,EAAA;;ACTzB;EACE,WAAW,EAAA;;AAKb;EACE,WAAW,EAAA;;AAKb;EACE,YAAY,EAAA;;AAId;EACE,YAAY,EAAA;;AAGd;EACE,kBAAkB,EAAA;EADpB;IAGM,kBAAkB;IAClB,UAAU,EAAA;IAJhB;MAMQ,kCAAuD,EAAA;;AAO/D;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B,EAAA;;AAIlC;EACE;IACI,QAAQ,EAAA,EAAA;;AClDd;;;;;;;C1Fq2oCC;AM/woCD,4EAAA;AqFlFA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WhFKyD;EgFJzD,aAAa;EACb,qCAAuD;EACvD,mDhF2mB+D,EAAA;EgF1mB/D;IARF;MASI,OAAO,EAAA,EAEV;;AAED;EACI,aAAa;EAEb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YhFGsD;EgFFtD,+BAAgD,EAAA;EAPpD;IAWY,uCAA2D,EAAA;;AAKvE;EACI,iBAAiB;EACjB,kBAAkB;EAClB,YhFoBsD,EAAA;;AgFjB1D;EACI,iBAAiB,EAAA;EADrB;IAIQ,aAAa,EAAA;;AAIrB;EACI,aAAa,EAAA;;AAGjB,WAAA;AAEA;EACI,2BAA+C,EAAA;EADnD;IAIQ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,4CAAqE;IACrE,gBAAgB;IAChB,mBAAmB,EAAA;EAV3B;IAaQ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,MAAM;IACN,gCAAwD,EAAA;;AAMhE;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAKY,2BAA8C,EAAA;;AAK1D;EAvDA;IAyDQ,WAAW,EAAA;EAGf;IAGQ,aAAa,EAAA;EAHrB;IAOQ,qBAAqB,EAAA,EACxB;;AAIT;EACI,mEAA6I,EAAA;;AAGjJ;EACI,YhFpFsD;EgFqFtD,2BAA2B;EAC3B,kCAA4D;EAC5D,SAAS;EACT,kBAAkB,EAAA;EALtB;IAQQ,kCAA4D,EAAA;;AAIpE;EACI,YAAY;EACZ,WAAW;EACX,uCAA2D;EAC3D,YAAY,EAAA;;AAGhB;EAEQ,eAAe;EACf,kCAA4D,EAAA;;AAHpE;EAOQ,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAA;;AAIlB;EAEQ,qBAAqB,EAAA;EAF7B;IAKY,uCAA2D,EAAA;;AAMvE;EACI,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,gCAAwD,EAAA;EAR5D;IAWQ,YAAY,EAAA;EAXpB;IAeQ,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAlB3B;IAuBQ,oCAAyD,EAAA;;AAMjE;EAGY,gBAAgB,EAAA;;AAK5B;EAEQ,yBhFhKqD,EAAA;;AgF8J7D;EAOgB,2ChFtHD,EAAA;;AgF+Gf;EAYY,oChF3HG,EAAA;;AgF+Gf;EAiBQ,uCAAsE,EAAA;EAjB9E;IAoBY,uCAAsE,EAAA;;AApBlF;EAyBQ,2ChFxIO,EAAA;;AgF+Gf;EA8BY,uCAAsE,EAAA;;AA9BlF;EAmCQ,aAAa,EAAA;;AAnCrB;EAuCQ,cAAc,EAAA;;AAvCtB;EA6CY,wDAAgF;EAChF,WhF7JG,EAAA;;AgF+Gf;;EAkDY,+BhFjKG,EAAA;;AgFsKf;EAEQ,mBhFpOqD,EAAA;;AgFkO7D;EAMQ,aAAa,EAAA;;AANrB;EAUQ,cAAc,EAAA;;AAItB;EACI;IAEQ,gBAAgB,EAAA;IAFxB;MAKY,qBAAqB;MACrB,sBAAsB,EAAA,EACzB;;AAKb;EA9OA;IAgPQ,aAAa,EAAA,EAChB;;AAGL;EAEQ,WAAW,EAAA;;AAFnB;EAKQ,gBhFhQkD;EgFiQlD,iEAA8H,EAAA;;AAItI;EAVA;IAaY,gBAAgB,EAAA,EACnB;;AC/RT;EACI,oBjFykB8B,EAAA;EiF1kBlC;IAIQ,6BAA6B;IAC7B,UAAU,EAAA;EALlB;IASQ,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B,EAAA;;ACXlC;EACI,SAAS;EACT,+BAAgD;EAChD,kBAAkB;EAClB,QAAQ;EACR,6BAAkD;EAClD,WAAW;EACX,YlF2BsD;EkF1BtD,qCAAuD,EAAA;EAEvD;IAVJ;MAWQ,OAAO,EAAA,EAEd;;AAGD;EAEQ,UlFRkD,EAAA;EkFUlD;IAJR;MAKY,OAAO,EAAA,EAEd;;AAGL;EAEQ,kBAAkB,EAAA;;AC5B1B;EACI,wCAA6D;EAC7D,yEAAyE;EACzE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,YnFuCuD;EmFtCvD,aAAa;EACb,uBAAuB;EACvB,aAA+B;EAC/B,MAAM;EACN,SAAS,EAAA;EAXb;IAcQ,gCAA6C;IAC7C,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAA0C;IAC1C,kBAAkB;IAClB,kBAAkB,EAAA;IArB1B;MAwBY,gCAA6C,EAAA;;AAMzD;EACI,wCnFmDc;EmFlDd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,aAAa;EACb,4BAA4B,EAAA;;AAGhC;EAEQ,QAAQ,EAAA;;AAFhB;EAKQ,cAAc,EAAA;;A3EyBlB;E2ExEJ;IAqDQ,cAAc,EAAA;IADlB;MAGQ,uBAAuB,EAAA,EAC1B;;ACxDT;EACI,SAAS,EAAA;EADb;IAIQ,cAAc;IACd,WAAW,EAAA;EALnB;IASQ,aAAa,EAAA;IATrB;MAYY,aAAa,EAAA;IAZzB;MAgBY,cACJ,EAAA;EAjBR;IAqBQ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,uCAAuC,EAAA;;AAK/C;EACE,YpFvByD;EoFwBzD,aAAa;EACb,mBpF/B2D;EoFgC3D,SAAS;EACT,aAAa;EACb,eAAe;EACf,MAAM;EACN,iBpFjBwD;EoFkBxD,mDpF0kB+D,EAAA;EoFzkB/D;IAVF;MAWI,SpFpBsD;MoFqBtD,gBAAgB,EAAA,EAWnB;EAvBD;IAgBI,eAAe;IACf,QAAQ;IACR,WAAW,EAAA;IACX;MAnBJ;QAoBM,aAAa,EAAA,EAEhB;;AAGH;EACI,kBpFhDuD;EoFiDvD,gBAAgB,EAAA;EAFpB;IAKQ,yBAAyB;IACzB,gBpFxCkD,EAAA;;AoF6C1D;EACI,sBAAsB,EAAA;EAD1B;IAMgB,0BAA0B,EAAA;EAN1C;IAaY,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,eAAe,EAAA;EAlB3B;IAyBgB,cAAc;IACd,uBAAuB;IACvB,cpF1F6C;IoF2F7C,kBAAkB;IAClB,eAAe;IACf,mBAAmB,EAAA;IA9BnC;MAiCoB,qBAAqB;MACrB,kBAAkB;MAClB,sBAAsB;MACtB,kBAAkB;MAClB,uBAAuB;MACvB,sBAAsB;MACtB,cpFpGyC;MoFqGzC,mBAAmB,EAAA;IAxCvC;MA4CoB,cpFxGyC,EAAA;MoF4D7D;QA+CwB,cpF3GqC,EAAA;EoF4D7D;IAqDgB,eAAe,EAAA;EArD/B;IAyDgB,UAAU,EAAA;IAzD1B;MA8DwB,kCAAkC;MAClC,eAAe;MACf,cpF9HqC,EAAA;MoF8D7D;QAkE4B,cpF9HiC,EAAA;IoF4D7D;MAuEwB,UAAU,EAAA;MAvElC;QA2EgC,kCAAkC;QAClC,eAAe,EAAA;;AAa/C;EACI,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cpF7JyD;EoF8JzD,gBpF8gB6B,EAAA;;AoF3gBjC;EACI,yBAAiD,EAAA;EADrD;IAGQ,yBAAiD,EAAA;IAHzD;MAKY,yBAAiD,EAAA;EAL7D;IASQ,yBAAiD,EAAA;IATzD;MAYY,yBAAiD,EAAA;EAZ7D;IAgBQ,yBAAiD,EAAA;;AAIzD;EA5JA;IA8JQ,aAAa,EAAA;EArIrB;IAyIQ,yBAAyB,EAAA;EAG7B;IAEQ,cAAc,EAAA,EACjB;;AAKT;EAGQ,iBpFrMkD,EAAA;;AoFkM1D;EAOI,sBAA0C,EAAA;;AAP9C;EAWI,UpF7MsD,EAAA;EoF8MtD;IAZJ;MAaM,OAAO,EAAA,EAEV;;AAfH;EAmBY,aAAa,EAAA;;AAnBzB;EAuBY,cAAc,EAAA;;AAvB1B;EA6BQ,kBAAkB;EAClB,sBAA0C;EAC1C,UAAU,EAAA;EA/BlB;;IAmCY,4BAA4B,EAAA;EAnCxC;IAuCY,wBAAwB,EAAA;EAvCpC;IA2CY,oBAAoB,EAAA;EA3ChC;;;IAoDgB,wBAAwB,EAAA;EApDxC;IAwDgB,0BAA0B,EAAA;EAxD1C;IA6DoB,aAAa,EAAA;EA7DjC;IAmEoB,kBAAkB;IAClB,mBAAmB,EAAA;IApEvC;MAuEwB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB,EAAA;MAzExC;QA8E4B,cpFnRiC,EAAA;MoFqM7D;QAkF4B,kBAAkB;QAClB,gBAAgB,EAAA;MAnF5C;QAuF4B,aAAa;QACb,kBAAkB,EAAA;IAxF9C;MA8F4B,kBAAkB;MAClB,yBAAgD;MAChD,cpFpMX;MoFqMW,4BAAyC;MACzC,gBAAgB,EAAA;MAlG5C;QAqGgC,cpFzMf,EAAA;MoFoGjB;QAyGgC,eAAe,EAAA;IAzG/C;MA8Gc,cAAc;MACd,UpFjT4C;MoFkT5C,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,gDAAgD,EAAA;MAnH9D;QAsHgB,gDAAgD,EAAA;MAtHhE;QA0HgC,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,cpFtU6B,EAAA;QoFuM7D;UAkIoC,cpFvUyB,EAAA;EoFqM7D;IA0IoB,cAAc;IACd,aAAa;IACb,aAAa;IACb,yBpFtVyC,EAAA;IoFyM7D;MAkJgC,cAAc;MACd,WAAW;MACX,uBAAuB;MACvB,iBAAiB;MACjB,kBAAkB;MAClB,YAAY,EAAA;IAvJ5C;MA6JgC,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,yBAAyB,EAAA;IAhKzD;MAuK4B,cpFxSV,EAAA;;AoFmTlB;EAEQ,mBpFlXqD,EAAA;;AoFgX7D;EAUoB,cpFzXyC,EAAA;EoF+W7D;IAawB,cpF1XqC,EAAA;EoF6W7D;IAiBwB,cpF7XqC,EAAA;IoF4W7D;MAoB4B,cpFhYiC,EAAA;;AoF4W7D;EA6B4B,cpF3YiC,EAAA;EoF8W7D;IAgCgB,cpF5Y6C,EAAA;;AoF4W7D;EA0CI,kBAAkB,EAAA;EA1CtB;IA+CQ,mBpF/ZqD,EAAA;EoFgX7D;IAuDgB,mBAAyC;IACzC,cpFpa6C,EAAA;IoF4W7D;MA0DkB,cpFta2C,EAAA;EoF4W7D;IAgEoC,cpF9ayB,EAAA;IoF8W7D;MAkEwC,cpF9aqB,EAAA;EoF4W7D;IA0EwB,yBpF1bqC,EAAA;EoFgX7D;IAmF4B,yBAAsD,EAAA;IAnFlF;MAqFgC,yBAAsD,EAAA;;AArFtF;EAiGQ,yBAAsD,EAAA;EAjG9D;IAmGY,yBAAsD,EAAA;IAnGlE;MAqGgB,yBAAsD,EAAA;EArGtE;IAyGY,yBAAsD,EAAA;EAzGlE;IA4GY,yBAAsD,EAAA;IA5GlE;MA+GgB,yBAAsD,EAAA;;AA/GtE;EAqHQ,cpFleqD,EAAA;;AoFue7D;EAEQ,yBAAyB,EAAA;;AAMjC;EAEQ,YpFvfmD,EAAA;;AoFqf3D;EAKQ,YpF1fmD;EoF2fnD,kBAAkB,EAAA;EAN1B;;IAUY,wBAAwB,EAAA;;AAVpC;EAcQ,kBpFngBmD,EAAA;;AoFqf3D;EAiBQ,WpFtgBmD,EAAA;EoFugBnD;IAlBR;MAmBY,OAAO,EAAA,EAEd;;AArBL;EAwBI,WpF7gBuD,EAAA;EoF8gBvD;IAzBJ;MA0BM,OAAO,EAAA;MA1Bb;QA8BU,WAAW,EAAA,EACZ;;AA/BT;EAwCU,cAAc,EAAA;;AAxCxB;EA8CY,oBAAoB,EAAA;;AA9ChC;EAkDwB,oBAAoB,EAAA;;AAlD5C;EA0DY,iBpFhjB8C,EAAA;;AoFsf1D;EA8DgB,gBAAgB,EAAA;EA9DhC;IAmEgC,qBAAqB,EAAA;;AAnErD;EA2EY,UpFjkB8C,EAAA;;AoFwkB1D;;;;;;EAQM,aAAa,EAAA;;AARnB;;;;;;EAWM,cAAc,EAAA;;AAXpB;;;;;;EAgBI,sBAAwB,EAAA;EAhB5B;;;;;;IAkBM,sBAAwB,EAAA;IAlB9B;;;;;;MAoBQ,sBAAwB,EAAA;EApBhC;;;;;;;;;;;;IAyBM,sBAAwB,EAAA;;AAzB9B;;;;;;EAiCoB,+BpFziBL,EAAA;;AoFwgBf;;;;;;EAqCoB,+BpF7iBL,EAAA;EoFwgBf;;;;;;IAuCwB,+BpF/iBT,EAAA;EoFwgBf;;;;;;IA2C0B,oCpFnjBX,EAAA;EoFwgBf;;;;;;IAgDwB,WpFxjBT,EAAA;IoFwgBf;;;;;;MAmD4B,WpF3jBb,EAAA;;AoFwgBf;;;;;;EA2Dc,+BpFnkBC,EAAA;EoFwgBf;;;;;;IA6DgB,WpFrkBD,EAAA;;AoFwgBf;;;;;;EA4E4B,yBAAuC;EACvC,WpFrlBb,EAAA;EoFwgBf;;;;;;IA+EgC,WpFvlBjB,EAAA;;AoFwgBf;;;;;;EAyFgC,yBAAiD,EAAA;;AAzFjF;;;;;;EAiGwC,cpF3qBqB,EAAA;;AoF0kB7D;;;;;;EAqGoC,yBAAiD,EAAA;EArGrF;;;;;;IAuGwC,yBAAiD,EAAA;IAvGzF;;;;;;MAyG4C,yBAAiD,EAAA;;AAc7F;EACE,oCAAqC,EAAA;;AAEvC;EAEI,yBpFtmBa,EAAA;;AoFymBf;EALF;IAOM,yBAAuC;IACvC,2BAA2B,EAAA,EAC5B;;AATL;EAeQ,yBpFnnBS,EAAA;;AoFomBjB;EAqBc,yBAAuC,EAAA;;AArBrD;EA8BM,uBAAuB,EAAA;;AAK7B;EAEI,UAAU,EAAA;;AAMd;EAEI,6DAA6D;EAC7D,2BAA2B,EAAA;;AAG7B;EANF;IAQM,6DAA6D;IAC7D,2BAA2B,EAAA,EAC5B;;AAVL;EAgBQ,6DAA6D;EAC7D,2BAA2B,EAAA;;AAjBnC;EAuBc,6DAA6D;EAC7D,2BAA2B,EAAA;;AAxBzC;EAkCM,6DAA6D,EAAA;;AAOnE;EAEI,6DAA6D;EAC7D,2BAA2B,EAAA;;AAG7B;EANF;IAQM,6DAA6D;IAC7D,2BAA2B,EAAA,EAC5B;;AAVL;EAgBQ,6DAA6D;EAC7D,2BAA2B,EAAA;;AAjBnC;EAuBc,6DAA6D;EAC7D,2BAA2B,EAAA;;AAxBzC;EAiCM,6DAA6D,EAAA;;AAOnE;EAEI,6DAA6D;EAC7D,2BAA2B,EAAA;;AAE7B;EALF;IAOM,6DAA6D;IAC7D,2BAA2B,EAAA,EAC5B;;AATL;EAeQ,6DAA6D;EAC7D,2BAA2B,EAAA;;AAhBnC;EAsBc,6DAA6D;EAC7D,2BAA2B,EAAA;;AAvBzC;EAgCM,6DAA6D,EAAA;;AAOnE;EAEI,6DAA6D;EAC7D,2BAA2B,EAAA;;AAG7B;EANF;IAQM,6DAA6D;IAC7D,2BAA2B,EAAA,EAC5B;;AAVL;EAgBQ,6DAA6D;EAC7D,2BAA2B,EAAA;;AAjBnC;EAuBc,6DAA6D;EAC7D,2BAA2B,EAAA;;AAxBzC;EAiCM,6DAA6D,EAAA;;AAMnE;EAEI,6DAA2E;EAC3E,2BAA2B,EAAA;;AAG7B;EANF;IAQM,6DAA6D;IAC7D,2BAA2B,EAAA,EAC5B;;AAVL;EAgBQ,6DAIC;EACD,2BAA2B,EAAA;;AArBnC;EA2Bc,6DAIC;EACD,2BAA2B,EAAA;;AAhCzC;EAyCM,6DAA6D,EAAA;;AAKnE;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EAGM,aAAa;EACb,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAXhB;EAeM,aAAa;EACb,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAvBhB;EA4BI,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,wBAAwB;EACxB,aAAa,EAAA;;AAIjB;EAEI,0DAAyD,EAAA;;AAI7D;EAEI,0DAAyD,EAAA;;AAI7D;EAEI,0DAAyD,EAAA;;AAI7D;EAEI,0DAAyD,EAAA;;AAI7D;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,yBpFh7Be,EAAA;;AoFk7BjB;EACE,6DAA6D;EAC7D,2BAA2B,EAAA;;AAE7B;EACE,6DAA6D;EAC7D,2BAA2B,EAAA;;AAE7B;EACE,6DAA6D,EAAA;;AAE/D;EACE,6DAA6D,EAAA;;AAE/D;EACE,6DAA2E,EAAA;;ACziC7E;EACI,+BAAiD;EACjD,2BAA4C;EAC5C,mDrF+mB6D;EqF9mB7D,gBrFkBsD;EqFjBtD,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY,EAAA;EARhB;IAWQ,SAAS;IACT,UAAU,EAAA;EAZlB;IAkBY,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gCAAwD,EAAA;IArBpE;MAuBgB,eAAe,EAAA;IAvB/B;MA0BgB,uCAAsE;MACtE,6BAA6B,EAAA;EA3B7C;IAgCY,gCAAwD,EAAA;IAhCpE;MAkCgB,uCAAsE,EAAA;EAlCtF;IAwCgB,uCAAsE,EAAA;EAxCtF;IA+CoB,uCAAsE;IACtE,6BAA6B,EAAA;;AAOjD;EAEQ,OAAO,EAAA;;A7EEX;E6EIA;;IAGQ,cAAc,EAAA,EACjB;;A7ERL;E6EaA;IAKoB,eAAe,EAAA;EALnC;IAYQ,qBAAqB;IACrB,gBAAgB,EAAA;EAbxB;IAoBgB,SAAS;IACT,WAAW,EAAA;EArB3B;IAyBY,aAAa;IACb,kErFkrCiE,EAAA;IqF5sC7E;MA8BoB,WAAW;MACX,2CAA2C;MAC3C,kBAAkB,EAAA;IAhCtC;MAsCoB,kBAAkB;MAClB,iBAAiB;MACjB,UAAU;MACV,aACJ,EAAA;EA1ChB;IAgDgB,cAAc,EAAA;EAhD9B;IAsDQ,cACJ,EAAA;EAGJ;IACI,aAAa,EAAA,EAChB;;AAGL;EACI,qBAAqB,EAAA;EADzB;IAIQ,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW,EAAA;;A7E/Ef;E6EqFA;IAMwB,WAAW;IACX,UAAU,EAAA,EACb;;A7E7FrB;E6EuGA;IAEQ,gCAAsD,EAAA;IAF9D;MAIY,gCAAsD,EAAA;EAJlE;IASQ,+BAAoD,EAAA;EAxLhE;IA6LQ,iBAAiB;IACjB,gBAAgB;IAChB,UAAU,EAAA;IA/LlB;MAkMgB,uBAAuB,EAAA;IA1HnC;MAgIY,6BAA6B;MAC7B,YAAY;MACZ,gBAAgB;MAChB,kBAAkB,EAAA;MAf9B;QAiBgB,WAAW,EAAA;QAjB3B;UAoBoB,WAAW,EAAA;IApB/B;MA0BY,kBAAkB;MAClB,6BAA6B,EAAA;MA3BzC;QA+BgB,crFnHH,EAAA;IqFoFb;MAsCY,WAAW;MACX,kBAAkB,EAAA,EACrB;;A7EzKT;E6EiLA;IAGY,gCAAsD,EAAA;EAHlE;IAOY,+BAAoD,EAAA;EAPhE;IAYQ,yBrFhJK,EAAA;IqFoIb;MAgBgB,+BrFlLL,EAAA;MqFkKX;QAmBoB,+BrFrLT,EAAA;IqFkKX;MA0BwB,0CAAmC,EAAA,EACtC;;AAUzB;EAEQ,yBrF3KS;EqF4KT,gBAAgB,EAAA;;AAHxB;EAOQ,aAAa,EAAA;;AAPrB;EAWQ,cAAc,EAAA;;AAXtB;EAiBY,wDAAgF;EAChF,WrFzNG,EAAA;;AqFuMf;;EAsBY,+BrF7NG,EAAA;;AqFuMf;EA0BQ,uCAAsE,EAAA;EA1B9E;IA6BY,uCAAsE,EAAA;;AA7BlF;EAoCgB,0CrF3OD,EAAA;;AqFuMf;EAyCY,oCrFhPG,EAAA;;AqFuMf;EA+CY,uCAAsE,EAAA;;A7ErQ9E;E6EsNJ;IAqDY,yBrF9NK,EAAA;IqFyKjB;MAyDoB,+BrFhQL,EAAA;MqFuMf;QA4DwB,+BrFnQT,EAAA;IqFuMf;MAmE4B,0CAAmC,EAAA,EACtC;;ACrVzB;EACI,yCAA+D,EAAA;EADnE;IAGQ,mCAAmD;IACnD,iBtFmDmD;IsFlDnD,cAAc;IACd,mDtF4mByD,EAAA;EsFlnBjE;IAUI,+BAA2D;IAC3D,cAAc,EAAA;EAXlB;IAeI,cAAc;IACd,+BAA2D,EAAA;EAhB/D;IAqBQ,8BAAqE,EAAA;EArB7E;IA4BM,+BAA8D,EAAA;IAE9D;MA9BN;QA+BQ,OAAO,EAAA,EAEV;EAjCL;IAqCQ,cAAc;IACd,+BAA2D,EAAA;EAtCnE;IA2CY,8BAAqE,EAAA;;AAQjF;;;EAII,eAAe,EAAA;;AAJnB;;EAQI,iBtFJuD,EAAA;;AsFJ3D;EAaM,gBAAgB,EAAA;;AAQpB;EADF;;;IAKM,kBAAkB,EAAA,EACnB;;AAID;EAVJ;;IAaQ,kBAAkB,EAAA;EAb1B;IAgBQ,kBAAkB,EAAA,EACnB;;AC3FP;;;;;;uDlGshrCuD;AkG/grCtD;EACG,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,wCAAwC,EAAA;;AAE1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAI9B,qJAAqJ;EAIrJ,6BAA6B;EAI7B,uCAAuC;EAKvC,mCAAmC;EACnC,oBAAoB,EAAA;;AAEtB;EACE,oCAAoC;EAIpC,6KAA6K,EAAA;;AAE/K;EACE,8BAA8B,EAAA;;AAEhC;EACE,oCAAoC,EAAA;;AAEtC;EAIE,2BAA2B,EAAA;;AAE7B;;EAME,wBAAwB;EACxB,2EAA2E,EAAA;;AAE7E;;;;EAIE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU,EAAA;;AAEZ;EACE,qBAAqB;EACrB,oBAAoB,EAAA;;AAEtB;EACE,SAAS;EACT,qBAAqB,EAAA;;AAEvB;EACE,oBAAoB;EACpB,sBAAsB,EAAA;;AAExB;EACE,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAA;;AAEpB;EACE,wBAAwB;EAExB,iDAAiD;EAIjD,qBAAqB,EAAA;;AAEvB;EAEE,+CAA+C,EAAA;;AAEjD;EACE,cAAc,EAAA;;AAvFhB;EA4FM,0CvF7DO,EAAA;;AuFiEf;EAEQ,yCvFrCS,EAAA;;AuFwCjB;EAEQ,yCvFnCS,EAAA;;AuFsCjB;EAEQ,yCvFtCS,EAAA;;AuFyCjB;EAEQ,yCvF9CS,EAAA;;AuFiDjB;EAEQ,0CvFrDS,EAAA;;AwF5GjB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,yBxF6Ee;EwF5Ef,WxF8Ca;EwF7Cb,aAAa;EACb,gBxFmpB+B;EwFlpB/B,YAAY;EACZ,uBAAuB;EACvB,WAAW,EAAA;;AAIb;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAA;EAHjB;IAKI,kBAAkB;IAClB,wCAA6D;IAC7D,kBAAkB;IAClB,oBAAoB,EAAA;IARxB;MAUM,kBAAkB;MAClB,2BAA2B,EAAA;;AC/CjC;EAEQ,aAAa;EACb,kBAAkB;EAClB,uCAA2D;EAC3D,kBAAkB;EAClB,2BAA8C;EAC9C,gBzF0qByB;EyFzqBzB,mBAAmB;EACnB,8BAA8B,EAAA;EATtC;IAaoB,iBAAiB,EAAA;EAbrC;IAmBY,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,wCAA6D;IAC7D,kBAAkB;IAClB,kBAAkB,EAAA;;AA1B9B;EAoCoB,iBAAiB,EAAA;;AApCrC;EA4CQ,mCAAuD,EAAA;;AC7C/D;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAO9B;EACI,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,yB1FsBc;E0FrBd,kBAAkB;EAClB,c1FoBc;E0FnBd,kBAAkB;EAClB,oBAAoB,EAAA;EATxB;IAYQ,gCAAwD;IACxD,yB1FWU,EAAA;;A0FNlB;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;ApDhDpB;EoDwDQ,eAAe;EACf,wB1Fi+CmC,EAAA;;A0F79C3C;EACI,iBAAiB,EAAA;;ACrGrB;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAA6D;EAC7D,aAAa,EAAA;;AAGjB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB,EAAA;;AAG3B;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kDAAkD,EAAA;;AAGtD;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,mDAAmD,EAAA;EANvD;IAQQ,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,yB3FiES;I2FhET,mBAAmB;IACnB,0DAA0D,EAAA;EAdlE;IAkBQ,sBAAsB,EAAA;IAlB9B;MAoBY,sBAAsB,EAAA;EApBlC;IAwBQ,sBAAsB,EAAA;IAxB9B;MA0BY,sBAAsB,EAAA;EA1BlC;IA8BQ,sBAAsB,EAAA;IA9B9B;MAgCY,sBAAsB,EAAA;EAhClC;IAoCQ,sBAAsB,EAAA;IApC9B;MAsCY,sBAAsB,EAAA;EAtClC;IA0CQ,sBAAsB,EAAA;IA1C9B;MA4CY,sBAAsB,EAAA;EA5ClC;IAgDQ,sBAAsB,EAAA;IAhD9B;MAkDY,sBAAsB,EAAA;;AAKlC;EACI;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,qBAAqB,EAAA;EAEzB;IACI,mBAAqB,EAAA,EAAA;;AtG+xrC7B;;;;EuG13rCI,gBAAgB,EAAA;;AxERpB;EwEeE,kBAAkB;EAClB,gBAAgB,EAAA;;AAQlB;EACE,eAAe;EACf,qBAAqB;EACrB,oB5F08BsE,EAAA;E4F78BxE;IAMI,YAAY;IACZ,cAAc;IACd,oBAA4C,EAAA;EARhD;IAYI,cAAc,EAAA;;AAQlB;EAGI,iBAAiB;EACjB,wCAA6D,EAAA;EAJjE;IAOM,YAAY,EAAA;EAPlB;IAWM,mDAAyE,EAAA;IAX/E;MAcQ,sBAAsB,EAAA;IAd9B;MAmBQ,kBAAkB;MAClB,iBAAiB;MACjB,oCAAoC;MACpC,oBAAoB;MACpB,SAAS;MACT,aAAA;MACA,eAAe;MACf,2BAA8C,EAAA;;AAQtD;EAEI,wCAA6D;EAC7D,kBAAkB,EAAA;EAHtB;IAMM,YAAY,EAAA;EANlB;IAUM,mDAAyE,EAAA;IAV/E;MAaQ,sBAAsB,EAAA;IAb9B;MAkBQ,kBAAkB;MAClB,WAAW;MACX,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,WAAW;MACX,kBAAkB,EAAA;;AAYxB;EAGM,yB5FbS;E4FcT,qB5FdS,EAAA;;A4FmBf;EAGM,qB5FtBS;E4FuBT,yB5FvBS,EAAA;E4FmBf;IAOQ,yB5F1BO,EAAA;;A4FUf;EAGM,yB5FrCU;E4FsCV,qB5FtCU,EAAA;;A4F2ChB;EAGM,qB5F9CU;E4F+CV,yB5F/CU,EAAA;E4F2ChB;IAOQ,yB5FlDQ,EAAA;;A4FkChB;EAGM,yB5FNS;E4FOT,qB5FPS,EAAA;;A4FYf;EAGM,qB5FfS;E4FgBT,yB5FhBS,EAAA;E4FYf;IAOQ,yB5FnBO,EAAA;;A4FGf;EAGM,yB5FJS;E4FKT,qB5FLS,EAAA;;A4FUf;EAGM,qB5FbS;E4FcT,yB5FdS,EAAA;E4FUf;IAOQ,yB5FjBO,EAAA;;A4FCf;EAGM,yB5FPS;E4FQT,qB5FRS,EAAA;;A4Faf;EAGM,qB5FhBS;E4FiBT,yB5FjBS,EAAA;E4Faf;IAOQ,yB5FpBO,EAAA;;A4FIf;EAGM,yB5FTS;E4FUT,qB5FVS,EAAA;;A4Fef;EAGM,qB5FlBS;E4FmBT,yB5FnBS,EAAA;E4Fef;IAOQ,yB5FtBO,EAAA;;A4FMf;EAGM,yB5FVS;E4FWT,qB5FXS,EAAA;;A4FgBf;EAGM,qB5FnBS;E4FoBT,yB5FpBS,EAAA;E4FgBf;IAOQ,yB5FvBO,EAAA;;A4FOf;EAGM,yB5FzCU;E4F0CV,qB5F1CU,EAAA;;A4F+ChB;EAGM,qB5FlDU;E4FmDV,yB5FnDU,EAAA;E4F+ChB;IAOQ,yB5FtDQ,EAAA;;A4FsChB;EAGM,yB5FnCU;E4FoCV,qB5FpCU,EAAA;;A4FyChB;EAGM,qB5F5CU;E4F6CV,yB5F7CU,EAAA;E4FyChB;IAOQ,yB5FhDQ,EAAA;;A4FuDlB;;;EAGE,eAAe;EACf,gBAAgB,EAAA;;AAKlB;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB,EAAA;EAHnB;IAMI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB,EAAA;EATtB;IAaI,sBAAsB,EAAA;;AAK1B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB,EAAA;EAHnB;IAMI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;;ArEnItB;EqEwIE,kBAAkB,EAAA;;AAKpB;;EAEE,wC5FowBiF;E4FnwBjF,gD5FywByG;E4FxwBzG,+B5FuwBqF,EAAA;;A4FpwBvF;EAEI,c5F9Gc;E4F+Gd,qB5FrHc;E4FsHd,yB5FtHc,EAAA;;A4FkHlB;;EAUM,mC5FuvBmE,EAAA;;A4FlvBzE;;EAIM,0D9E9E4E,EAAA;;A+EnIlF;EAEQ,gBAAgB;EAChB,kBAAkB,EAAA;EAH1B;IAKY,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,0C7FiEG;I6FhEH,UAAU;IACV,wBAAwB;IACxB,SAAS;IACT,oBAAoB,EAAA;EAbhC;IAiBY,WAAW;IACX,WAAW;IACX,oBAAoB,EAAA;;AAnBhC;EA0BgB,UAAU,EAAA;;ACxB1B;EACI,iBAAiB,EAAA;;AAErB;EACE,sCAAyD,EAAA;;AAK3D;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc,EAAA;;AzG0lsClB;EyGrlsCI,4BAA4B,EAAA;;AAKhC;EACI,kBAAkB;EAClB,c9FiDc,EAAA;E8FnDlB;IAKM,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mCAAuD;IACvD,oBAAoB,EAAA;EAT1B;IAaM,gBAAgB,EAAA;IAbtB;MAiBU,c9F2DO;M8F1DP,qBAAqB,EAAA;;AAS/B;EAEQ,oCAAqD;EACrD,gBAAgB;EAChB,gBAAgB;EAChB,gB9FqnByB;E8FpnBzB,kBAAkB,EAAA;;AAO1B;EACE,wCAA6D;EAC7D,wCAA6D;EAC7D,sCAA4D;EAC5D,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;EAPrB;IAUI,eAAe,EAAA;;AAInB;EACE,cAAc,EAAA;;AAIhB;EACE,aAAa,EAAA;EADf;IAGI,gCAAiC,EAAA;;AAIrC;EAEM,gBAAgB,EAAA;EAFtB;IAIU,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,qDAAiD;IACjD,yBAA0B;IAC1B,0BAA0B,EAAA;;ACxGpC;EACI;;;;;IAKI,wBAAwB,EAAA;EAE5B;;;;;IAKI,UAAU;IACV,SAAS,EAAA;E/DfjB;I+DmBQ,SAAS,EAAA,EACZ;;AzBnBL;EAIM,6BAAkD,EAAA;;AAqBtD;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctE4Fe;EsE3Ff,qDAA4C,EAAA;EAG1C;IAEE,ctEsFW;IsErFX,qBAAqB;IACrB,yCtEoFW,EAAA;;AsE9Ef;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEoEgB;EsEnEhB,sDAA4C,EAAA;EAG1C;IAEE,ctE8DY;IsE7DZ,qBAAqB;IACrB,0CtE4DY,EAAA;;AsEtDhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEmGe;EsElGf,qDAA4C,EAAA;EAG1C;IAEE,ctE6FW;IsE5FX,qBAAqB;IACrB,yCtE2FW,EAAA;;AsErFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEqGe;EsEpGf,qDAA4C,EAAA;EAG1C;IAEE,ctE+FW;IsE9FX,qBAAqB;IACrB,yCtE6FW,EAAA;;AsEvFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEkGe;EsEjGf,qDAA4C,EAAA;EAG1C;IAEE,ctE4FW;IsE3FX,qBAAqB;IACrB,yCtE0FW,EAAA;;AsEpFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEgGe;EsE/Ff,sDAA4C,EAAA;EAG1C;IAEE,ctE0FW;IsEzFX,qBAAqB;IACrB,0CtEwFW,EAAA;;AsElFf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctE+Fe;EsE9Ff,qDAA4C,EAAA;EAG1C;IAEE,ctEyFW;IsExFX,qBAAqB;IACrB,yCtEuFW,EAAA;;AsEtEjB;EANQ,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEgEgB;EsE/DhB,sDAA4C,EAAA;EAG1C;IAEE,ctE0DY;IsEzDZ,qBAAqB;IACrB,0CtEwDY,EAAA;;AsElDhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,2BAA8C,EAAA;EAFlD;IAOQ,2BAA8C,EAAA;;AAMtD;EAtCE,ctEsEgB;EsErEhB,mDAA4C,EAAA;EAG1C;IAEE,ctEgEY;IsE/DZ,qBAAqB;IACrB,uCtE8DY,EAAA;;AkEpBV;EILL,mBAAmB;EAClB,kBAAkB,EAAA;;AAKtB;EACE,sBAAoC,EAAA;;AjF+wsCtC;E2Gl1sCE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU,EAAA;;AAGZ;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iCAAiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EAAE,mGAAA;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EAAE,mFAAA;EAChB,eAAe;EAAE,kDAAA;EACjB,gBAAgB;EAAE,0CAAA;EAClB,qBAAqB;EACrB,uBAAuB,EAAA;;AAGzB;;EAEE,aAAa,EAAA;;AAGf;;EAEE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB,EAAA;;A3G+0sClB;E2G30sCE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB,EAAA;;A3G80sC3B;E2G10sCE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,+BAA+B,EAAA;;AAGjC;EACE,0DAAA;EACA,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,MAAM;EACN,WAAW,EAAA;;AAGb;EACE,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb,gBAAA;A3Gm0sCA;E2Gj0sCE,WAAW;EACX,OAAO,EAAA;;AAGT;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,YAAY,EAAA;;ACrNd;;oB5GwhtCoB;A4GphtCpB;EACI,qBAAqB;EACrB,iBAAiB,EAAA;;AAKrB;EACI,iBAAiB;EAGjB,cAAc,EAAA;;AAKlB;;EAEI,mDAAwE,EAAA;;AAG5E;;;;;;;EAOI,+CAAoE,EAAA;;AAGxE;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAA6D;EAC7D,2BAA8C;EAC9C,oCAAyD,EAAA;;AAG7D;EACI,sCAAyD,EAAA;;AAG7D;EACI,0CAAiE,EAAA;EADrE;IAIQ,gBjGgoByB,EAAA;;AiG5nBjC;EACI,mDAAwE;EACxE,+CAAoE,EAAA;;AAGxE;EAGY,oCAAyD,EAAA;;AAKrE;EAEQ,oCAAyD,EAAA;;AAIjE;EACI,mDAAwE,EAAA;;AAG5E;EACI,sDAA2E,EAAA;;AAG/E;EACI,sDAA2E,EAAA;;AAG/E;EACI,+BjG42BmF;EiG32BnF,mDAAuC;EACvC,oCAAyD,EAAA;;AAG7D;EACI,oCAAyD,EAAA;;AAG7D;;EAEI,mDAAwE,EAAA;;AAG5E;EACI,sDAA2E,EAAA;;AAG/E;EACI,+CAAoE,EAAA;;AAGxE;;EAEI,mDAAuC,EAAA;;AAG3C;EACI,wCAA6D,EAAA;;AAGjE;EACI,mDAAuC;EACvC,0CAA+B,EAAA;;AAGnC;EACI,oCAAqC;EACrC,sBAAyB,EAAA;EAF7B;IAKQ,oCAAsC;IACtC,sBAAyB,EAAA;;AAIjC;EAEQ,0CAAiE,EAAA;;AAIzE;EAKoB,2CAAmE,EAAA;;AAQvF;EAIgB,0CAAiE,EAAA;;AC/JjF;;oB7GkotCoB;A6G7ntCpB;;EAEE,2DlG8yBuE,EAAA;;AkGxyBzE;EAGU,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAA;;AAG7B;EARN;;;IAac,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,cAAc,EAAA;EAjB5B;IAqBc,WAAW,EAAA;EArBzB;IAyBc,aAAa,EAAA,EAChB;;AA1BX;EA8BU,0BAA0B,EAAA;;AA9BpC;EAmCI,2BAA8C,EAAA;;AAnClD;EAuCI,2BAA8C,EAAA;;AAIlD;EACE,aAAa,EAAA;;AAGf;;EAEE,kBAAkB;EAClB,2BAA2B,EAAA;;AAI7B;EAGM,mCAAmD;EACnD,+BAA+C;EAE/C,gBAAgB,EAAA;EANtB;IAUQ,WlGCO;IkGAP,mCAAmD;IACnD,+BAA+C,EAAA;;AAZvD;EAkBI,8CAA8D;EAC9D,0CAA0D,EAAA;;AAI9D;;EAII,8CAA8D;EAC9D,0CAA0D;EAC1D,sBAAwB,EAAA;;AAK1B;EADF;IAEI,sBAAsB;IACtB,SAAS,EAAA,EAEZ;;AAED;EAEM,mBlG5BY;EkG6BZ,clGzBY;EkG0BZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBlGqkB2B,EAAA;;AkGjkBjC;;;;;;;;;;EAYM,qBlGjDY,EAAA;;AkGqClB;EAgBM,mBAAkC,EAAA;;AAIxC;EACE,kCAAuD;EACvD,oCAAyD;EACzD,clGxDgB;EkGyDhB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB,EAAA;;AAGzB;;;EAGE,yBlG3Ce;EkG4Cf,WlG1Ea;EkG2Eb,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WlGtFa,EAAA;EkG8Ef;IAcI,sDAA8E,EAAA;IAdlF;MAYM,wCAA6D,EAAA;IAZnE;MAgBM,wCAA6D,EAAA;;AAKnE;;EAEE,yBlGvEe,EAAA;;AkG0EjB;EACE,WlGzGa,EAAA;;AkG4Gf;EAEM,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;;AAKrB;EAEI,clGtHc,EAAA;;AX0rtClB;E6G5jtCM,yBAAyB,EAAA;;A7G+jtC/B;E6G3jtCM,kBAAkB,EAAA;;AAIxB;EACE,oCAAyD,EAAA;;AAG3D;EACE,mCAAmD;EACnD,2BAA8C,EAAA;;AAGhD;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,kDAAsE,EAAA;;AAGxE;EACE,iBAAiB,EAAA;;AAGnB;EACE,6BAA6C,EAAA;;AAG/C;EACI,kCAAuD;EACvD,wCAA6D,EAAA;;ACnPjE;;oB9G2ytCoB;A8GtytCpB;EAEE,wCAA6D,EAAA;;A9GwytC/D;E8GpytCE,gDAAgD,EAAA;;AAGlD;EACE,oDAAyE;EACzE,+CAAgE,EAAA;;ACZlE;EAEQ,aAAa,EAAA;;AAFrB;EAMQ,cpGsGS;EoGrGT,gBpG0qByB,EAAA;;AoGjrBjC;EAWQ,sBpG+DO;EoG9DP,cpGgGS;EoG/FT,gBAAgB,EAAA;;ACbxB;EACE,sCrGmqB6E,EAAA;;AqGhqB/E;EACE,eAAe,EAAA;EADjB;;;;IAOI,8BAAgC;IAChC,eAAe,EAAA;EARnB;;;IAeM,yBrGqFW,EAAA;EqGpGjB;IAoBI,iCAAqD;IACrD,mCAAuD,EAAA;EArB3D;IAyBI,eAAe;IACf,gCAAwD,EAAA;EA1B5D;;IA+BI,gCAAwD;IACxD,iCAAqD;IACrD,eAAe,EAAA;EAjCnB;IAqCI,yBrG+Da;IqG9Db,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mDAAwE;IACxE,eAAe,EAAA;IA1CnB;MA6CM,eAAe,EAAA;EA7CrB;IAkDI,2CAAmE,EAAA;;ACtDvE;EAEQ,eAAe;EACf,gBtG8qByB,EAAA;;AsG1qBjC;EACI,eAAe,EAAA;;AAGnB;EAEQ,qBtGoGS;EsGnGT,ctGmGS,EAAA;;AsGtGjB;EAOY,yBtG6FK,EAAA;;AsGpGjB;EAWY,qCtGyFK,EAAA;;AsGpGjB;EAeQ,qBtGoFS;EsGnFT,ctGmFS,EAAA;;AsG/EjB;EAEQ,gBAAgB,EAAA;;AAIxB;EAEQ,mBtGiES,EAAA;EsGnEjB;IAIY,mBtG+DK,EAAA;IsGnEjB;;MAOgB,mCtG4DC,EAAA;;AsGnEjB;EAaQ,mBtGsDS,EAAA;;AsGlDjB;EACI,qDAAuD,EAAA;;AAE3D;EACI,kCAAuD,EAAA;;AAG3D;EACI,+BAAsD,EAAA;;AAG1D;;;EAGI,oCAAyD;EACzD,2BAA8C,EAAA;EAJlD;;;IAMQ,gBAAgB;IAChB,oCAAyD,EAAA;;AAIjE;EACI,gCAAwD,EAAA;;AC5E5D;EACE,oCAAyD,EAAA;;AAG3D;EACE,eAAe,EAAA;;AAGjB;EACE,oCAAqD,EAAA;;AAGvD;EACE,QAAQ,EAAA;;AAGV;EAEI,qBAAqB;EACrB,sBAAsB,EAAA;EAH1B;IAMM,gBAAgB,EAAA;;ACrBtB;;enHg7tCe;AmH76tCf;EAEQ,mDxG2mByD;EwG1mBzD,UAAU,EAAA;EAHlB;IAKY,mDxGwmBqD;IwGvmBrD,YAAY,EAAA;;AANxB;EAYU,cAAc;EACd,gBAAgB,EAAA;;AAQtB;EACI,oCAAmC;EACnC,oDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,qDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,oDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,oDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,oDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,qDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,oDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,qDAAgD,EAAA;;AAFpD;EACI,oCAAmC;EACnC,kDAAgD,EAAA;;AAOxD;EACI,0CxGwEa;EwGvEb,yBxGuEa,EAAA;;AwGpEjB;EACI,aAAa;EACb,uCAA2D;EAC3D,gBAAgB;EAChB,wCAA6D,EAAA;;AC3CjE;EACE,czG0Ge,EAAA;;AyGvGjB;EACE,qBzGsGe,EAAA;;AyGnGjB;EACE,aAAa;EACb,SAAS;EACT,UAAU,EAAA;EAHZ;IAKI,cAAc,EAAA;EALlB;IAQI,eAAe;IACf,gBAAgB;IAChB,czGyFa;IyGxFb,eAAe,EAAA;;ACpBnB;EAEQ,wCAA6D;EAC7D,oD1Gg8BmG;E0G/7BnG,YAAY,EAAA;EAJpB;IAMY,aAAa,EAAA;EANzB;IAUY,iBAAiB;IACjB,qB1Gq0BwB;I0Gp0BxB,gCAAwD,EAAA;EAZpE;IAiBY,YAAY;IACZ,WAAW;IACX,UAAU,EAAA;IAnBtB;MAsBgB,oEAAqF;MACrF,2BAA2B,EAAA;EAvB3C;IA4BY,2BAA8C,EAAA;;ArHs/tC1D;EqH/+tCQ,eAAe,EAAA;;AAKvB;EAIgB,+EAAgG;EAChG,sCAAsC,EAAA;;AAMtD;EAEQ,aAAa;EACb,wCAA6D,EAAA;EAHrE;IAKY,oDAAqF;IACrF,wCAA6D;IAC7D,gCAAwD;IACxD,aAAa,EAAA;;AARzB;EAYQ,yB1GyCS,EAAA;;A0GrDjB;EAeQ,iCAA+C;EAC/C,+BAAsD;EACtD,SAAS;EACT,eAAe,EAAA;EAlBvB;IAoBY,yB1GiCK;I0GhCL,W1GEG,EAAA;;A0GvBf;EA2BY,kBAAkB;EAClB,+BAAsD,EAAA;;AAKlE;EACI,iBAAiB,EAAA;;AAErB;EACI,qB1GwvBgC,EAAA;;A0GrvBpC;EACI,wCAA6D;EAC7D,wCAA6D;EAC7D,mD1GohB6D,EAAA;;A0GjhBjE;EAEQ,wCAA6D,EAAA;;AAIrE;EAEQ,gBAAgB;EAChB,wCAA6D;EAC7D,+DAAgG,EAAA;EAJxG;IAOY,oB1GkuBwB,EAAA;E0GzuBpC;IAUY,SAAS;IACT,4BAAgD,EAAA;IAX5D;MAagB,gCAAwD,EAAA;EAbxE;IAiBY,uCAA2D;IAC3D,wCAA6D;IAC7D,kBAAkB;IAClB,cAAc,EAAA;EApB1B;IAuBY,UAAU,EAAA;;AAKtB;EAGY,gDAAiF,EAAA;;AAH7F;EAQQ,gB1GuiByB,EAAA;;A0G/iBjC;EAaY,kBAAkB,EAAA;;AAO9B;EACI,WAAW;EACX,WAAW;EACX,kBAAkB,EAAA;EAHtB;IAKQ,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAA;;AAI1B;EACI,eAAe,EAAA;;AAGnB;;;EAGI,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,yBAA0C,EAAA;EAN9C;;;IASQ,iBAAiB,EAAA;IATzB;;;MAagB,gBAAgB;MAChB,kCAAkC,EAAA;;AAMlD;;;EAIQ,+B1GpHO,EAAA;;A0GwHf;EACI,gBAAgB,EAAA;;AAKpB;EACI,iBAAiB;EACjB,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,uCAA2D,EAAA;;AlHnN/D;;;EHgpuCE;AG5ouCF;;;;;;EAME,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc,EAAA;;AAEhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB,EAAA;;AAE1B;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,eAAe,EAAA;;AAEjB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe,EAAA;;AACf;EACE,kBAAkB,EAAA;;AAEtB;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAEtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB,EAAA;;AAE3B;EACE,WAAW,EAAA;;AAEb;EACE,YAAY,EAAA;;AAEd;;;;;EAKE,kBAAkB,EAAA;;AAEpB;;;;;EAKE,iBAAiB,EAAA;;AAEnB;EAEU,qCAAqC,EAAA;;AAE/C;EAEU,uCAAuC,EAAA;;AAUjD;EACE;IAEU,uBAAuB,EAAA;EACjC;IAEU,yBAAyB,EAAA,EAAA;;AAErC;EACE,sEAAsE;EAE9D,wBAAwB,EAAA;;AAElC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,wBAAwB,EAAA;;AAElC;;;;;;EAOU,YAAY,EAAA;;AAEtB;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAA;;AAEd;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,oBAAoB,EAAA;;AAEtB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;gEH+ouCgE;AG7ouChE;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU,EAAA;;AAEZ;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAA;;AACb;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA+C;EAC/C,iTAAiV,EAAA;;AAEnV;EACE,oCAAoC;EACpC,gBAAgB,EAAA;;AAClB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAAgD;EAChD,iTAAsV,EAAA;;AAExV;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAClB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA8C;EAC9C,iTAA4U,EAAA;;AAE9U;;EAEE,kCAAkC;EAClC,gBAAgB,EAAA;;AmHv8IlB,eAAA;AACA;EACE,aAAa,EAAA;EADf;IAGI,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yB3GsEc;I2GrEd,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gB3GiqB6B;I2GhqB7B,gCAAgC,EAAA;IAhBpC;MAkBM,c3G+DY;M2G9DZ,6BAA6B;MAC7B,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,SAAS;MACT,kBAAkB;MAClB,qBAAqB;MACrB,gBAAgB;MAChB,gCAAgC,EAAA;IAhCtC;MAoCM,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,yB3GoCY;M2GnCZ,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,QAAQ;MACR,gCAAgC,EAAA;EA7CtC;IAkDI,yB3GqDa,EAAA;;A2GvGjB;EAuDE,yB3GgDe,EAAA;E2GjDjB;IAGI,W3GgBW;I2GfX,4BAA4B;IAC5B,WAAW;IACX,SAAS,EAAA;EANb;IAUI,UAAU;IACV,yB3GUc,EAAA;;A2GNlB;EACE,yB3GqCe,EAAA;;A2GnCjB;;EAEE,W3GDa,EAAA;;A2GIf;EACE,yB3GgCe,EAAA;;A2G7BjB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yB3GiBe,EAAA;;A2GdjB;EACE,yB3GoBe,EAAA;;A2GjBjB;EACE,yB3GkBe,EAAA;;A2GfjB;EACE,yB3GWe,EAAA;;A2GRjB;EACE,yB3GKe,EAAA;;A2GFjB;EACE,yB3GzBgB,EAAA;E2GwBlB;IAGI,c3GjCc,EAAA;;A2GqClB;EACE,iBAAiB,EAAA;EADnB;IAGI,kBAAkB,EAAA;;ACnHtB;EACE,wC5GgxC6E,EAAA;E4GjxC/E;IAGI,qBAAqB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,c5G0EY,EAAA;I4GjFlB;MAUQ,yB5GiEU,EAAA;I4G3ElB;MAcQ,yB5GgGS;M4G/FT,gBAAgB;MAChB,eAAe,EAAA;;AAKvB;EACE,+B5GqDgB,EAAA;;A4GlDlB;EACE,wC5Gk6BiF;E4Gj6BjF,2DAA4C;EAC5C,+B5Gq6BqF,EAAA;E4Gx6BvF;IAKI,aAAa,EAAA;;AvHqr3CjB;EuH7q3CI,cAAc,EAAA;;AvHgr3ClB;EuH3q3CM,qCAAoC;EACpC,wCAAuC;EACvC,sCAAqC;EACrC,yCAAwC,EAAA;;AvH8q3C9C;EuHzq3CI,oD5G+4BuG;E4G94BvG,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,gD5G+4BiF;E4G94BjF,mD5G84BiF,EAAA;;A6Gz8BrF,eAAA;AACA;EAIQ,+B7G+7B+E,EAAA;E6Gn8BvF;IAMU,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,c7GgGO;I6G/FP,qBAAqB,EAAA;;AAV/B;EAcQ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2BAA8C;EAC9C,wCAA6D;EAC7D,wC7G26B2E,EAAA;;A6G97BnF;EA0BI,uCAAwD,EAAA;;AA1B5D;EA6BI,oCAAqD,EAAA;;AAKzD;EACE,wEAA6B,EAAA;;AAG/B;EACE,oBAAoB;EACpB,2EAAgC,EAAA;;AAGlC;EACE,kBAAkB;EAClB,sBAAsB,EAAA;;AAIxB;EAGM,SAAS;EACT,WAAW,EAAA;;AAJjB;EAQM,SAAS;EACT,WAAW,EAAA;;ACxDjB;EACE,wCAA6D;EAC7D,YAAY;EACZ,uBAAuB,EAAA;EAHzB;IASQ,gBAAgB,EAAA;EATxB;;IAgBU,oCAAqC;IACrC,sBAAsB;IACtB,gBAAgB;IAChB,sBAAwB,EAAA;EAnBlC;;;IA0BY,2BAAyC,EAAA;EA1BrD;;;IAiCY,yBAA0C;IAC1C,YAAY,EAAA;EAlCxB;IAsCU,uCAA2D,EAAA;;AAOrE;EAEI,YAAY,EAAA;;AAIhB;EAEI,sBAAsB;EACtB,qBAAqB,EAAA;;AAOzB;EACE,wCAA6D;EAC7D,gBAAgB;EAChB,wC9GitC6E,EAAA;E8GptC/E;IAMI,YAAY,EAAA;;AAnEhB;EAwEE,gCAAwD,EAAA;EAD1D;IAGM,2BAAyC,EAAA;;AAK/C;EAIM,wC9G8rCyE;E8G7rCzE,kBAAkB,EAAA;EALxB;IAQQ,0C9GgBS;I8GfT,c9GeS,EAAA;E8GxBjB;IAaQ,yB9GWS;I8GVT,W9GpBO,EAAA;E8GMf;IAmBQ,yBAA0C;IAC1C,YAAY,EAAA;;AApBpB;EA4BQ,gB9GqkByB,EAAA;;A8GjmBjC;EAgCQ,wC9GkqCuE,EAAA;;A+GlxC/E;;EAMQ,0BAA0B;EAC1B,6BAA6B,EAAA;;AAPrC;;EAiBQ,yBAAyB;EACzB,4BAA4B,EAAA;;AChBpC;EACI,+DAAgD,EAAA;;AAGpD;EACI,2BAA8C,EAAA;;AAGlD;EACI,2BAA8C,EAAA;EADlD;IAGQ,sCAAsC,EAAA;EAH9C;;;IASQ,8DAAqC;IACrC,wCAAwC;IACxC,mCAAmC;IACnC,oCAAoC;IACpC,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;IACxB,4BAA4B;IAC5B,mDAAwE;IACxE,iDAA2F;IAC3F,iCAAiC,EAAA;EAnBzC;IAuBQ,+CAAoE,EAAA;EAvB5E;IA4BY,0CAA4C;IAC5C,kDAAoD,EAAA;EA7BhE;IAkCQ,0CAA4C;IAC5C,kDAAoD,EAAA;EAnC5D;IAuCQ,qDAAwE,EAAA;EAvChF;;;IA6CQ,mDAAwE;IACxE,2BAA2B,EAAA;EA9CnC;IAkDQ,oCAAqD,EAAA;IAlD7D;MAqDY,4CAA0D,EAAA;EArDtE;IA2DY,wCAAwC,EAAA;EA3DpD;;;IAkEQ,sCAAoD,EAAA;EAlE5D;IAsEQ,4CAA0D,EAAA;EAtElE;IAyEQ,kCAAkC,EAAA;EAzE1C;IA4EQ,kCAAkC,EAAA;EA5E1C;IA+EQ,6BAA6B,EAAA;IA/ErC;MAkFY,mCAAoD,EAAA;EAlFhE;IAuFQ,mDAAwE,EAAA;EAvFhF;;;IA6FQ,oCAAqD,EAAA;EA7F7D;IAiGQ,yDAA8E,EAAA;EAjGtF;IAqGQ,mDAAwE,EAAA;EArGhF;IAyGY,oCAAqC;IACrC,iCAAiC;IACjC,gCAAiC;IACjC,2BAA2B,EAAA;EA5GvC;IAkHY,+CAAgE,EAAA;EAlH5E;IAuHQ,mDAAwE,EAAA;EAvHhF;IA0HQ,mDAAwE,EAAA;EA1HhF;IA6HQ,gCAA6C,EAAA;EA7HrD;IAyIQ,mDAAsC;IACtC,0CAA8B,EAAA;;AAItC;;EAEI,yBAA0C,EAAA;;AAK9C;EAEQ,qBAAqB,EAAA;;AAI7B;EACI,gBAAgB,EAAA;EADpB;IAIQ,gBAAgB,EAAA;;ACxKxB,aAAA;AACA;EACE,iBAAiB;EACjB,yCAA8D;EAC9D,kCAAuD;EACvD,kBAAkB,EAAA;EAJpB;IAQI,eAAe;IACf,WAAW;IACX,cAAc,EAAA;;AAVlB;EAeE,SAAS,EAAA;;AChBX;EAEI,eAAe;EACf,iBAAiB,EAAA;;AAIrB;EAKM,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAEhB;IAXN;MAYQ,sBAAsB,EAAA,EA2BzB;EAvCL;IAgBQ,aAAa;IACb,YAAY,EAAA;EAjBpB;IAqBQ,WAAW,EAAA;IArBnB;MAwBU,cAAc;MACd,mBAAmB;MACnB,gCAAwD;MACxD,gBlH8oBuB;MkH5oBvB,yClHmEO,EAAA;EkHhGjB;IAkCQ,kBAAkB;IAClB,YAAY,EAAA;;AAnCpB;EA0CM,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBlHkDW;EkHjDX,clHiDW;EkHhDX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAA;;AAlDzB;EAuDQ,yClHyCS;EkHxCT,+BAAsD,EAAA;EAxD9D;IA0DU,yBlHsCO;IkHrCP,WlHOK,EAAA;;AkHlEf;EAmEI,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,iBAAiB,EAAA;EAvErB;IAyEM,kBAAkB;IAClB,YAAY,EAAA;EA1ElB;IA6EM,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBACF,EAAA;;AAjFJ;EAuFI,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW,EAAA;EA1Ff;IA4FQ,cAAc;IACd,iBAAiB;IACjB,eAAe,EAAA;IA9FvB;MAgGY,qBAAqB;MACrB,eAAe,EAAA;EAjG3B;IAsGQ,yBlHNS;IkHOT,kBAAkB;IAClB,iBAAiB;IACjB,WlHvCO,EAAA;EkHlEf;IA8GU,YAAY;IACZ,yBlHfO;IkHgBP,WlH9CK;IkH+CL,mBAAmB,EAAA;;AAjH7B;EAwHI,aAAa;EACb,eAAe,EAAA;EAzHnB;IA8HQ,sBAAsB,EAAA;IA9H9B;MAiIY,sBAAsB,EAAA;EAjIlC;IAwIM,WAAW,EAAA;EAIT;IA5IR;MA6IU,UAAU,EAAA,EAEf;EA/IL;IAkJQ,aAAa,EAAA;IACb;MAnJR;QAoJU,UAAU;QACV,kBAAkB,EAAA,EAOvB;IA5JL;MAyJQ,UAAU,EAAA;;ACrKlB;;C9Huj4CC;A8Hjj4CD;EAEI,iBAAiB,EAAA;EAEjB;IAJJ;MAKM,kBAAkB,EAAA,EAQrB;EAbH;IAUM,kBAAkB;IAClB,eAAe,EAAA;;AAKrB;;EAGI,oCAAoC,EAAA;EAHxC;;IAKM,kBAAkB,EAAA;IALxB;;MAQQ,kBAAkB,EAAA;MAR1B;;QAWU,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,WnHsCK;QmHrCL,sBnHqCK;QmHpCL,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;QACjB,YAAY;QACZ,yBnH4DO,EAAA;;AoHvGjB;EAEI,cAAc,EAAA;;AAFlB;EAKI,uBAAuB,EAAA;;AAL3B;EASM,yBpHsEY;EoHrEZ,cpHiEY;EoHhEZ,yBpHoEY,EAAA;EoH/ElB;IAaU,yBpH0FO;IoHzFP,qBpHyFO;IoHxFP,WpH0DK;IoHzDL,6CpHuFO,EAAA;;AoHvGjB;EAoBM,YAAY,EAAA;EApBlB;IAsBQ,QAAQ;IACR,0BAA0B;IAC1B,oBAAoB,EAAA;;AAxB5B;EA8BM,eAAe;EACf,mBAAmB,EAAA;;AA/BzB;EAoCI,kBAAkB;EAClB,sCAAiC,EAAA;EArCrC;IAwCM,oCAAmD,EAAA;EAxCzD;IA4CM,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB,EAAA;IA9CxB;MAgDQ,+BAA+B;MAC/B,oCAAoC;MACpC,sBpHuBO;MoHtBP,kBAAkB;MAClB,yBpHwBU;MoHvBV,WAAW;MACX,qBAAqB;MACrB,YAAY;MACZ,OAAO;MACP,kBAAkB;MAClB,kBAAkB;MAClB,4BAA4B;MAC5B,WAAW;MACX,wBAAwB,EAAA;IA7DhC;MAgEQ,cpHWU;MoHVV,qBAAqB;MACrB,eAAe;MACf,YAAY;MACZ,OAAO;MACP,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAA;EA1EnB;IA8EM,eAAe;IACf,UAAU;IACV,UAAU;IACV,wBAAwB,EAAA;IAjF9B;MAoFQ,aAAa,EAAA;EApFrB;IAyFQ,oBAAoB;IACpB,aAAa,EAAA;EA1FrB;IA+FQ,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB,EAAA;EAjGxB;IAsGQ,yBpH5BU;IoH6BV,mBAAmB,EAAA;EAvG3B;IA4GQ,yBpHLS;IoHMT,qBpHNS,EAAA;EoHvGjB;IAgHQ,WpHvCO,EAAA;;AoHzEf;EAuHM,oBAA8B;EAC9B,yBpHjBW,EAAA;EoHvGjB;IA0HQ,WpHjDO,EAAA;;AoHzEf;;;EAkIM,mBpH3BW;EoH4BX,qBpH5BW;EoH6BX,WpH3DS,EAAA;EoHzEf;;;IAuIU,WpH9DK,EAAA;;AoHzEf;;;;EA+IM,2BAA8C,EAAA;;AAKlD;EADF;IAIQ,qBAAqC,EAAA,EACtC;;ACxJP;EAEI,+DvGmO4D;EuGlO5D,uBrHw1B+B;EqHv1B/B,oDrH87BuG;EqH77BvG,wCrHu7B+E;EqHt7B/E,+BrH27BmF;EqH17BnF,sCrH+7BiF,EAAA;EqHt8BrF;IASM,aAAa;IACb,iDrHi8B4F,EAAA;;AsH58BlG;EACI,2BAA2B,EAAA;EAD/B;IAGQ,iDAAyC;IACzC,wBAAyC,EAAA;EAJjD;IAOQ,cAAc,EAAA;;AAItB;;EAEI,iDAAyC,EAAA;;AAG7C;EACI,gBtHgqB6B,EAAA;;AsH7pBjC;EACI,oBAAoB;EACpB,8BtHqC2F,EAAA;;AsHlC/F;EACI,yBAAyB;EACzB,iDAAyC;EACzC,0BAA0B,EAAA;;AAG9B;EACI,qBAAuB,EAAA;;AAG3B;;EAGQ,iDAAyC;EACzC,+BAAuD,EAAA;;AAnB/D;EAwBI,8BAAmD,EAAA;;AAGvD;EAEQ,8BAAmD,EAAA;;AAI3D;EACI,mDAAwE;EACxE,mDAAwE,EAAA;EAF5E;IAKQ,mDAAwE;IACxE,0DAA+E,EAAA;;AA5BvF;EAiCI,gCAA8C,EAAA;;AAGlD;EACI,8BAAmD,EAAA;;ACnEvD;EACI,aAAa,EAAA;;ACJjB,eAAA;AACA;EACE,aAAa,EAAA;;AAGf;EACE,iBAAiB;EACjB,uCxH6EgB;EwH5EhB,YAAY;EACZ,cxHoEgB;EwHnEhB,mDxH0mB+D;EwHzmB/D,kBAAkB,EAAA;;AAGpB;EACE,cxHkEgB,EAAA;;AyH/ElB;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAsC;EACtC,4CzH+Ea;EyH9Eb,4BAA4B;EAC5B,kBAAkB;EAClB,gCAAkC,EAAA;;AAGpC;EACE,yBAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,iDAAyC;EACzC,2BAA2C,EAAA;;ACf7C;EACE,wBAAwB;EACxB,mB1HwEgB;E0HvEhB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,kBAAkB;EAClB,W1HgEa;E0H/Db,eAAe;EACf,iBAAiB;EACjB,mB1H2Fe;E0H1Ff,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB,EAAA;EALpB;IAOI,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,8B1H4Ea,EAAA;E0HtFjB;IAaI,UAAU;IACV,mCAAmC;IACnC,oCAAoC;IACpC,iC1HsEa,EAAA;;A2HxGjB;EACI,YAAY;EACZ,mB3HgFc;E2H/Ed,c3HwEc;E2HvEd,sC3HgqB2E;E2H/pB3E,oB3HqqBmC;E2HpqBnC,gBAAgB,EAAA;;ACNpB;EACI,aAAa,EAAA;EADjB;IAGQ,WAAW,EAAA;;ACDnB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAA;;AAKf;EAEQ,gCAAsD,EAAA;;AAF9D;EAKQ,+BAAoD,EAAA;;AAI5D;EACI,wCAA6D,EAAA;;AAMjE;EAGY,iBAAiB,EAAA;;AAO7B;EACI,0C7HmEa;E6HlEb,aAAa,EAAA;EAEb;IAJJ;MAKQ,aAAa,EAAA,EAkBpB;EAvBD;IAUQ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB,EAAA;EAd1B;IAkBQ,oDAAsD;IACtD,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;;AAInC;EACI,aAAa,EAAA;EAEb;IAHJ;MAIQ,iBAAiB,EAAA,EAExB;;AAED;EAKoB,0C7H8BH,EAAA;;A6HnCjB;EASwB,yB7H0BP,EAAA;;A8HtGjB;EAGQ,kBAAkB;EAClB,kBAAkB,EAAA;;AAJ1B;EAQQ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,iBAAiB,EAAA;;AAIzB;EAGY,cAAc;EACd,gBAAgB;EAChB,2BAA8C,EAAA;;AAK1D;EAGY,gBAAgB,EAAA;;AAH5B;EAOY,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAA;;AAK9B;EACI,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAA;;AAKZ;EAGY,eAAe,EAAA;EAH3B;IAMgB,uCAA2D,EAAA;;AAM3E;EAEQ,qBAAqB;EACrB,kBAAkB;EAClB,2BAA8C,EAAA;EAJtD;IAOY,WAAW,EAAA;EAPvB;IAYY,c9H0BK,EAAA;I8HtCjB;MAegB,gCAAiC,EAAA;;AAQjD;EAEQ,gBAAgB,EAAA;;AAFxB;EAMQ,kBAAkB;EAClB,gBAAgB;EAChB,gC9HvBO;E8HwBP,gBAAgB;EAChB,UAAU;EACV,WAAW,EAAA;;AAOnB;EAGY,mBAAmB;EACnB,kBAAkB;EAClB,wCAA6D;EAC7D,mD9HigBqD,EAAA;E8HvgBjE;IASgB,yB9HZC,EAAA;E8HGjB;IAagB,eAAe,EAAA;;AC5H/B;;oB1Im94CoB;A0Ih94CpB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAGpB;EAEI,+BAAsD;EACtD,gBAAgB,EAAA;;AAHpB;EAMI,eAAe,EAAA;;AAInB;EArBA;IAuBI,WAAW;IACX,WAAW,EAAA;EAjBf;IAoBI,SAAS,EAAA,EACV;;AAIH;EAEI,cAAc;EACd,gCAAwD;EACxD,iBAAiB;EACjB,gBAAgB,EAAA;EALpB;IAOM,c/HsEW;I+HrEX,gBAAgB,EAAA;;AAKtB;EACE,cAAc;EACd,eAAe,EAAA;EAFjB;IAKI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,wBAAwB,EAAA;IAV5B;MAaM,gCAAwD,EAAA;IAb9D;MAiBM,iCAAqD;MACrD,yBAAyB,EAAA;IAlB/B;MAsBM,WAAW;MACX,kBAAkB,EAAA;IAvBxB;MA2BM,YAAY,EAAA;MA3BlB;;;QAgCQ,cAAc;QACd,WAAW,EAAA;MAjCnB;QAqCQ,6BAA6B;QAC7B,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,cAAc;QACd,YAAY,EAAA;MA3CpB;QA+CQ,wBAAwB,EAAA;MA/ChC;QAmDQ,gBAAgB;QAChB,gBAAgB,EAAA;MApDxB;QAwDQ,kBAAkB;QAClB,MAAM;QACN,WAAW;QACX,QAAQ;QACR,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB,EAAA;IA/DxB;MAoEM,kBAAkB;MAClB,MAAM;MACN,WAAW;MACX,QAAQ;MACR,SAAS,EAAA;MAxEf;;QA4EQ,kBAAkB;QAClB,MAAM,EAAA;MA7Ed;QAiFQ,OAAO;QACP,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB,EAAA;MArF3B;QAyFQ,QAAQ;QACR,YAAY;QACZ,kBAAkB,EAAA;IA3F1B;MAiGM,iC/HrCW,EAAA;I+H5DjB;MAsGI,uCAA2D;MAC3D,gBAAgB;MAChB,2BAA8C,EAAA;MAxGlD;QA0GQ,2BAA8C;QAC9C,gBAAgB,EAAA;EA3GxB;IAkHI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,wCAA6D;IAC7D,8DAA+F;IAC/F,kBAAkB,EAAA;IAzHtB;MA4HM,UAAU;MACV,eAAe,EAAA;IA7HrB;MAgIM,UAAU,EAAA;IAhIhB;MAoIM,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,OAAO;MACP,eAAe;MACf,UAAU;MACV,gBAAgB;MAChB,yBAAyB;MACzB,MAAM,EAAA;MA5IZ;QA8IQ,iBAAiB;QACjB,oCAAoC;QACpC,MAAM;QACN,YAAY;QACZ,2BAA8C;QAC9C,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,SAAS;QACT,eAAe,EAAA;;AAMvB;EA7JA;IA+JM,YAAY,EAAA,EACf;;ACxMC;EAFJ;IAGQ,gBAAgB;IAChB,gBAAgB,EAAA,EAQvB;;AALG;EAPJ;IAQQ,gBAAgB;IAChB,gBAAgB,EAAA,EAGvB;;AAED;EACI,cAAc,EAAA;EADlB;IAIY,cAAc;IACd,iBAAiB;IACjB,2BAA8C;IAC9C,gBhI0pBqB,EAAA;EgIjqBjC;IAYgB,chI4EC,EAAA;EgIxFjB;IAiBY,kBAAkB,EAAA;IAjB9B;MAoBoB,iBAAiB;MACjB,gCAAwD;MACxD,eAAe;MACf,gBhIyoBa,EAAA;;AiI/qB7B;EADJ;IAEQ,gBAAgB,EAAA,EAgBvB;;AAbG;EALJ;IAMQ,gBAAgB,EAAA,EAYvB;;AAlBD;EAWY,wCAA6D,EAAA;;AAXzE;EAeY,iBAAiB,EAAA;;AAK7B;EAGY,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBjIiFK;EiIhFL,kBAAkB;EAClB,QAAQ,EAAA;;AATpB;EAcQ,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;;AAIvB;EAEQ,SAAS,EAAA;;AAIjB;EACI,SAAS,EAAA;EADb;IAKgB,wCAA6D;IAC7D,yBAAyB;IACzB,mDjI6jBiD,EAAA;EiIpkBjE;IAWY,cAAc;IACd,kBAAkB;IAClB,gCAAwD;IACxD,oBAAoB;IACpB,4CAAiE;IACjE,kBAAkB,EAAA;IAhB9B;MAkBgB,wCAA6D;MAC7D,yBAAyB;MACzB,mDjIgjBiD,EAAA;;AiI1iBjE;EAGY,2BAA8C;EAC9C,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iCAA+C;EAC/C,kBAAkB;EAClB,YAAY,EAAA;;AAZxB;EAgBY,mDjI0hBqD;EiIzhBrD,wCAA6D,EAAA;;AAKzE;EAEQ,WAAW,EAAA;;AAFnB;EAMQ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAA;EAR3B;IAWY,wCAA6D;IAC7D,kBAAkB;IAClB,UAAU;IACV,iBAAiB,EAAA;EAd7B;IAkBY,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,QAAQ;IACR,wCAA6D;IAC7D,SAAS,EAAA;EAzBrB;IA4BY,eAAe,EAAA;;AA5B3B;EAgCQ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB,EAAA;EAlC1B;IAqCY,kBAAkB;IAClB,yCjI5BK;IiI6BL,8BAA8B;IAC9B,gBAAgB,EAAA;IAxC5B;MA2CgB,gBjIyiBiB;MiIxiBjB,cjIlCC;MiImCD,kBAAkB,EAAA;EA7ClC;IAkDY,YAAY,EAAA;IAlDxB;MAoDgB,eAAe;MACf,YAAY;MACZ,gCAAwD,EAAA;MACxD;QAvDhB;UAwDoB,aAAa,EAAA,EAEpB;IA1Db;MA6DgB,mDjIudiD;MiItdjD,wCAA6D,EAAA;EA9D7E;IAmEY,eAAe,EAAA;;AAnE3B;EAyEY,YAAY,EAAA;EAzExB;IA2EgB,iCAA+C;IAC/C,iBAAiB;IACjB,8BAA8B,EAAA;EA7E9C;IAgFgB,WAAW,EAAA;EAhF3B;IAsFwB,QAAQ;IACR,UAAU,EAAA;;AAvFlC;EAiGgB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,cjI1FC;EiI2FD,QAAQ;EACR,SAAS;EACT,eAAe,EAAA;EAEf;IAzGhB;MA0GoB,aAAa,EAAA,EAEpB;;AAKb;EACI,4CAAiE,EAAA;;AAGrE;EACI,mBAAmB;EACnB,4CAA0D;EAC1D,wCAAsD;EACtD,oBAAoB,EAAA;;AAGxB;EACI,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B,EAAA;EAJ/B;IAOY,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB,EAAA;;AAM7B;EADJ;IAEQ,eAAe,EAAA,EAEtB;;AC3OD;EACE,yBAAyB;EACzB,sBAAsB,EAAA;EAFxB;IAKI,wCAA6D,EAAA;;ACPjE;EAEI,2BAA8C,EAAA;;AAMlD;EACE,iBAAiB,EAAA;;ACTnB;EACI;IACI,kBAAkB,EAAA;IADtB;MAGQ,iBAAiB;MACjB,oCAAoC;MACpC,eAAe;MACf,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,2BAA2B;MAC3B,yBpIwFK;MoIvFL,WpIyDG;MoIxDH,UAAU;MACV,YAAY,EAAA,EACf;;AAKT;EACI,wCAA6D;EAC7D,aAAa,EAAA;;AAMjB;EAEQ,iBAAiB,EAAA;EAFzB;IAIY,gBAAgB,EAAA;;AAM5B;;mB/Iqy5CmB;A+Ijy5CnB;EACI,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB,EAAA;EAHxB;IAMQ,mDAAwE,EAAA;;AAIhF;EACI,gCAAwD;EACxD,kBAAkB,EAAA;;AAMtB;EACI,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,iDpIGW,EAAA;EoIDX;IARJ;MASQ,qCAAuD,EAAA,EA8E9D;EAvFD;IAaQ,iBAAiB;IACjB,oBAAoB,EAAA;IAd5B;MAgBY,aAAa,EAAA;MACb;QAjBZ;UAkBgB,cAAc,EAAA,EAErB;IApBT;MAsBY,cAAc,EAAA;MACd;QAvBZ;UAwBgB,aAAa,EAAA,EAEpB;EA1BT;IAiCgB,+BpIxBD;IoIyBC,iBAAiB;IACjB,iBAAiB;IACjB,gBpI4kBiB;IoI3kBjB,oBAAoB,EAAA;IAEpB;MAvChB;QAwCoB,kCAA4D,EAAA,EAenE;IAvDb;MA6CoB,+BpIpCL,EAAA;MoIsCK;QA/CpB;UAgDwB,cpITP,EAAA,EoIWA;IAED;MApDhB;QAqDoB,4BAA4B,EAAA,EAEnC;EAvDb;IA4DQ,qCAAuD;IACvD,mDpIofyD,EAAA;IoIjjBjE;MA+DY,iBAAiB,EAAA;MA/D7B;QAkEgB,gCAAsD,EAAA;MAlEtE;QAqEgB,+BAAoD,EAAA;IArEpE;MA4EoB,iBAAiB;MACjB,kCAA4D,EAAA;MA7EhF;QAiFwB,cpI1CP,EAAA;;AoIkDjB;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sBpI/EW,EAAA;;AoIkFf;EACI,kBAAkB;EAClB,qBAAqB,EAAA;EAFzB;IAKQ,0DAA+D;IAC/D,sBAAsB;IACtB,wBAAwB,EAAA;EAG5B;IAVJ;MAWQ,kBAAkB;MAClB,oBAAoB,EAAA,EAwD3B;EApED;IAgBQ,eAAe,EAAA;IACf;MAjBR;QAkBY,eAAe,EAAA,EAEtB;EApBL;IAuBQ,eAAe;IACf,mBAAmB;IACnB,kBAAkB,EAAA;IAClB;MA1BR;QA2BY,cAAc,EAAA,EAuBrB;IAlDL;MA8BY,kBAAkB;MAClB,iBAAiB;MACjB,wCAA6D;MAC7D,kBAAkB;MAClB,YAAY;MACZ,wCAA6D,EAAA;MAE7D;QArCZ;UAsCgB,qBAAqB;UACrB,UAAU;UACV,mBAAmB,EAAA,EAS1B;MAjDT;QA4CgB,iCAA+C;QAC/C,eAAe;QACf,YAAY;QACZ,eAAe,EAAA;EA/C/B;IAqDQ,iBAAiB,EAAA;IArDzB;MAwDY,iBAAiB,EAAA;IAxD7B;MA4DY,kBAAkB;MAClB,iBAAiB;MACjB,2BAA8C;MAC9C,YAAY;MACZ,eAAe;MACf,gBpI0cqB,EAAA;;AoIlcjC;EACI,kBAAkB;EAClB,YAAY,EAAA;;AAMhB;EAEQ,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB,EAAA;;AAO5B;EACI,YAAY,EAAA;;AAMhB;EAGY,2BAA8C;EAC9C,eAAe,EAAA;;AAO3B;EAEQ,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAA;;AAMnB;EACI,oBAAoB;EACpB,yBpIpRyD;EoIqRzD,+BpIzNW,EAAA;EoIsNf;IAMQ,+BpI5NO,EAAA;EoIsNf;IAYgB,cAAc;IACd,+BpInOD;IoIoOC,mBAAmB;IACnB,oBAAoB,EAAA;IAfpC;MAiBoB,+BpIvOL,EAAA;EoIsNf;IA0BY,cAAc;IACd,+BpIjPG;IoIkPH,iBAAiB;IACjB,iDpInPG,EAAA;IoIsNf;MA+BgB,+BpIrPD;MoIsPC,eAAe,EAAA;IAhC/B;MAoCgB,cAAc,EAAA;IApC9B;MAwCgB,iBAAiB;MACjB,gBAAgB,EAAA;EAzChC;IA+CQ,sCpIrQO,EAAA;;AqI1Ef;EACI,eAAe;EACf,gBrIgrB6B;EqI/qB7B,kBAAkB;EAClB,aAAa,EAAA;EAJjB;IAMQ,eAAe;IACf,gBrIyqByB;IqIxqBzB,cAAc;IACd,gBAAgB,EAAA;;AAIxB;EACI,UAAU,EAAA;;ACdd,kDAAA;AAGA;EAGY,kBAAkB;EAClB,cAAc,EAAA;EAJ1B;IAOgB,kBAAkB,EAAA;IAPlC;MASoB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,OAAO;MACP,QAAQ;MACR,gDAAqE,EAAA;IAfzF;MAkBoB,kBAAkB;MAClB,gDAAqE;MACrE,YAAY,EAAA;EApBhC;IA0BoB,yCAAyC,EAAA;EA1B7D;IAgCoB,yCAAyC,EAAA;IAhC7D;MAkCwB,gBAAgB,EAAA;;AASxC,gDAAA;AAEA;EACI,8CAAmE;EACnE,cAAc,EAAA;EAFlB;IAIQ,kBAAkB;IAClB,0BAA0B,EAAA;IALlC;MAQY,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,UAAU;MACV,eAAe,EAAA;IAZ3B;MAeY,kBAAkB;MAClB,wCAA6D;MAC7D,kBAAkB,EAAA;IAjB9B;MAsBgB,ctIkCC,EAAA;IsIxDjB;MA2BY,mBAAmB,EAAA;;ACvE/B;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kCAAuD;IACvD,SAAS;IACT,UAAU;IACV,SAAS,EAAA;;AAOrB;EACI,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB,EAAA;;AAGpB;EACI,cAAc,EAAA;;AAGlB;EACI,aAAa,EAAA;;AlJwj6CjB;EkJnj6CQ,aAAa,EAAA;;AlJsj6CrB;EkJlj6CQ,cAAc,EAAA;;AC9CtB;EAEQ,2BAA8C;EAC9C,yBAAyB,EAAA;EAHjC;IAKY,cxImGK,EAAA;;AX3FjB;EAEI,aAAa,EAAA;;A+FoDjB;E/F3CU,eAAe,EAAA;;AAOzB;EACE,UAAU,EAAA;;AAGZ;EACE,0BAA0B,EAAA;;AAG5B;;EAEE,YAAY,EAAA;;AAGd;EACE,yBWgCgB;EX/BhB,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAIf;EACE,2BAA2B,EAAA;EAD7B;IAII,sBWcW;IXbX,gBAAgB,EAAA;IALpB;MASQ,yBAAyB,EAAA;EATjC;IAeI,aAAa;IACb,uBAAuB;IACvB,SAAS,EAAA;IAET;MAnBJ;QAoBM,sBAAsB,EAAA;QApB5B;UAuBQ,WAAW,EAAA,EACZ;;AAKP;EACE,aAAa,EAAA;;AAGf;EACE,yBAAyB,EAAA;;AAG3B;;EAEE,mDAAqC;EACrC,6BAA6B,EAAA;;A8G/F/B;E9GmGE,yBWxBgB,EAAA;;AX2BlB;EACE,sBAAsB,EAAA;;AAGxB;EACE,wBAAwB,EAAA;;AAG1B;EAEI,eAAe,EAAA;;AU6HnB;EVxHE,eAAe,EAAA;;AAGjB;EACE,wCAAwC,EAAA;;AAG1C;EACE,UAAU,EAAA;;AAGZ;EACE,0CAA8B,EAAA;;AAGhC;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,oCAAqC,EAAA;;AuC3CnC;EvC+CF,qBAAqB;EACrB,mBAAmB,EAAA;;AAGrB;EACE,8BAA+B,EAAA;;AAGjC;EACE,8BAA+B,EAAA;;AAGjC;EACE,8BAA+B,EAAA;;AAGjC;EACE,8BAA+B,EAAA;;AALjC;EASE,sBAAwB,EAAA;;AAG1B;EACE,8BAA+B,EAAA;;AAGjC;EACE,sBAAsB,EAAA;;AAIxB;EAEI,gBAAgB,EAAA;;AAKpB;EAEI,2BAA2B,EAAA;;AAF/B;;;EAQI,wBAAwB,EAAA;;AAI5B;EAEI,gBAAgB,EAAA;;AAFpB;EAMI,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB,EAAA;;AAK1B;EAGM,YAAY;EACZ,wBAAwB,EAAA;;AAK9B;EACE;IAEI,sBAAsB,EAAA,EACvB;;AAIL;EAPE;IAUI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B,EAAA,EAC3B;;AAKL;EAGM,YAAY;EACZ,wBAAwB,EAAA;;AAK9B;EACE;IAEI,sBAAsB;IACtB,eAAe,EAAA,EAChB;;AAIL;EARE;IAWI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B,EAAA,EAC3B;;AAKL;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB,EAAA;;AmBrMf;E0FwBJ;I7GkLI,yBAAyB;IACzB,kBAAkB,EAAA;IAFpB;;;MAOI,WAAW;MACX,cAAc;MACd,WAAW;MACX,cAAc,EAAA;E6GlRpB;I7G0RU,WAAW,EAAA;EAMnB;IACE,aAAa,EAAA,EACd;;AAIH;EACE,0BAA0B,EAAA;;AAG5B;EACE,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,0FAA0F;EAC1F,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU,EAAA;EAZZ;IAeI,aAAa,EAAA;;AAQjB;EAEI,mBW8P8B,EAAA;;AQ/gB9B;EnB+QJ;IAMI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,SAAS,EAAA;IATb;MAYM,qBAAqB;MACrB,WAAW,EAAA,EACZ;;AAIL,WAAA;AACA;EACE,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,oBAAoB,EAAA;;AAGtB;EACE,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;;AAGtB;EACE,sBAAsB;EACtB,oCAAoC,EAAA;;AAnRtC;EAuRE,wBAAwB,EAAA;;AAG1B;EACE,aAAa,EAAA;;AAIf;EACE,uBAAuB,EAAA;;AAGzB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAKf;EAIQ,cAAc,EAAA;;AAMtB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B,EAAA;;AAI/B;EACE,mCAAmC,EAAA;;AAGrC;EACE,0CAA0C,EAAA;;AAI5C;EAKU,gBAAgB,EAAA;;AAL1B;EAWM,uBAAuB,EAAA;;AAK7B;EACE,aAAa,EAAA;;AA2Bf;EACE,2BAA2B,EAAA;;AAG7B;EACE;IACE,yBAAyB,EAAA;IAD3B;MAII,WAAW;MACX,WAAW,EAAA;MALf;QAQM,iCAAiC,EAAA,EAClC;;AAOP;;EAEE,mDAAsC;EACtC,2DAA4C,EAAA;;AAG9C;EACE,2CAA0C,EAAA;;AAG5C;EACE,2BAA2B;EAC3B,+DAAgD,EAAA;;AAGlD;EACE,mDAAwE;EACxE,6BAA6B,EAAA;;AAG/B;EACE,0CAA8B,EAAA;;AAGhC;EACE,0CAA8B,EAAA;;AAGhC;;EAEE,oCAAqC;EACrC,sBAAwB,EAAA;;AAM1B;;;EAGE,2DAA4C;EAC5C,mDAAwE,EAAA;;AAG1E;EACE,uBAAuB;EACvB,2BAA2B,EAAA;;AAG7B;EACE,mDAAsC;EACtC,2DAA4C;EAC5C,2BAA2B,EAAA;;AAG7B;EACE,sCAAyD,EAAA;;AAg55C3D;;EAx45CM,4BAA4B,EAAA;;AAOlC;EACE,4CAA0D;EAC1D,+DAAgD,EAAA;;AAGlD;;EAEE,sCAAyD,EAAA;;AAG3D;EACE,mDAAwE;EACxE,sCAAyD;EACzD,wBAAwB,EAAA;;AAG1B;EACE,2DAA4C,EAAA;;AAG9C;;;;EAIE,4CAA0D,EAAA;;AAG5D;EACE,yDAA0C,EAAA;;AAG5C;EACE,aAAa,EAAA;;AAIf;;EAEE,uBAAuB,EAAA;;AAGzB,kCAAA;AACA;;;;EAIE,sEAA2F;EAC3F,mDAAwE;EACxE,sCAAyD;EACzD,wDAA2E,EAAA;;AAO7E;;;;EAIE,mDAAsC;EACtC,2DAA4C,EAAA;;AAG9C;;;EAGE,8CAA8D;EAC9D,0FACiE,EAAA;;AAGnE;;;EAGE,oCAAqC;EACrC,sBAAwB,EAAA;;AAG1B;;;EAQI,wCAA6D;EAC7D,2BAA8C;EAC9C,oCAAyD,EAAA;EAV7D;;;;;IAcM,+BAA+C,EAAA;EAdrD;;;IAmBM,sBAAoC;IACpC,mCAAmD,EAAA;IApBzD;;;MAuBQ,iCAA+C,EAAA;IAvBvD;;;MA2BQ,sBAAoC,EAAA;IA3B5C;;;MA+BQ,oCAAyD,EAAA;;AA/BjE;;;EAqCI,oCAAqD;EACrD,YAAY,EAAA;;AAIhB;EACE,gCAAwC,EAAA;;AAG1C;;;;;EAKE,sCAAyD,EAAA;;AAG3D;;EAEE,4CAA0D;EAC1D,sCAAyD,EAAA;;AA625C3D;EAr25CM,cAAc,EAAA;;AAw25CpB;EAp25CM,aAAa,EAAA;;AAKnB;EACE,sBAAsB,EAAA;;AAGxB;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB,EAAA;;AAGxB;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB,EAAA;;AAGxB;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B,EAAA;;AAI7B;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,YAAY,EAAA;;AA+15Cd;EA315CE,uBAAuB;EACvB,sBAAsB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;EAClB,yCAAwC,EAAA","sourcesContent":["/*\r\nTemplate Name: Skote - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 4.1.0.\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Icons Css File\r\n*/\r\n\r\n// Plugins\r\n@import \"custom/plugins/icons\";","@import \"./icons.scss\";\n\n// Light Theme\n@import \"./bootstrap.scss\";\n@import \"./app.scss\";\n\n// RTL Mode\n// @import \"./rtl/bootstrap-rtl\";\n// @import \"./rtl/components-rtl\";\n// @import \"./rtl/float-rtl\";\n// @import \"./rtl/general-rtl\";\n// @import \"./rtl/pages-rtl\";\n// @import \"./rtl/plugins-rtl\";\n// @import \"./rtl/spacing-rtl\";\n// @import \"./rtl/structure-rtl\";\n// @import \"./rtl/text-rtl\";\n\nbody {\n  * {\n    outline: none;\n  }\n}\n\n#sidebar-menu {\n  ul {\n    li {\n      a {\n        i {\n          min-width: 2rem;\n        }\n      }\n    }\n  }\n}\n\n.leaflet-pane {\n  z-index: 1;\n}\n\nsvg>rect:first-child {\n  fill-opacity: 0 !important;\n}\n\n.dataTables_filter,\n.dataTables_paginate {\n  float: right;\n}\n\n.rdw-editor-main {\n  border: 1px solid $gray-300;\n  height: 239px;\n  padding-left: 15px;\n}\n\n.dz-message {\n  text-align: center;\n  padding: 30px;\n}\n\n// kanban board\n.react-kanban-board {\n  display: inherit !important;\n\n  .react-kanban-column {\n    background-color: $white;\n    padding: 1.25rem;\n\n    [data-rbd-draggable-context-id] {\n      >div {\n        display: block !important;\n      }\n    }\n  }\n\n  >div {\n    display: flex;\n    justify-content: center;\n    gap: 25px;\n\n    @media (max-width: 991.98px) {\n      flex-direction: column;\n\n      .react-kanban-column {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.react-kanban-column {\n  width: 33.33%;\n}\n\n.react-kanban-column>div {\n  display: block !important;\n}\n\n.fcYNFc,\n.sc-AxmLO.gmtmqV {\n  background-color: $card-bg !important;\n  margin: 0 20px 0 0 !important;\n}\n\n.task-box {\n  border: 1px solid $border-color;\n}\n\n.react-datepicker-wrapper {\n  width: 100% !important;\n}\n\n.ReactModal__Overlay {\n  z-index: 1001 !important;\n}\n\n.external-event {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\na:hover {\n  cursor: pointer;\n}\n\n.rating-container {\n  background-color: transparent !important;\n}\n\n.input-group-append {\n  z-index: 0;\n}\n\n.input-color {\n  color: $input-color !important;\n}\n\n.sketch-picker {\n  position: absolute;\n  z-index: 1;\n}\n\n.rangeslider__fill {\n  background-color: $primary !important;\n}\n\n.dropdown-menu-end {\n  left: auto !important;\n  right: 0 !important;\n}\n\n.flatpickr-months .flatpickr-month {\n  background: $primary !important;\n}\n\n.flatpickr-weekdays {\n  background: $primary !important;\n}\n\nspan.flatpickr-weekday {\n  background: $primary !important;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months {\n  background: $primary !important;\n}\n\nspan.flatpickr-weekday {\n  color: $white !important;\n}\n\n.flatpickr-day.selected {\n  background: $primary !important;\n}\n\n.bs-select select {\n  width: auto !important;\n}\n\n//File-manager\n.file-manager {\n  .table td {\n    padding: 0.35rem;\n  }\n}\n\n//Authenication carousel\n.slider_css {\n  .slide {\n    background: none !important;\n  }\n\n  .carousel-status,\n  .control-next,\n  .control-prev {\n    display: none !important;\n  }\n}\n\n.carousel {\n  .control-dots {\n    margin: -5px 0px;\n  }\n\n  .dot {\n    background: #556ee6 !important;\n    width: 9px !important;\n    height: 9px !important;\n  }\n}\n\n//Two verification Page\n.verification {\n  input {\n    &:focus {\n      border: none;\n      outline: none !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .verification {\n    input {\n      width: 40px !important;\n    }\n  }\n}\n\n@media (max-width: 320px) {\n  .verification {\n    input {\n      width: 30px !important;\n      height: 30px !important;\n      font-size: 15px !important;\n    }\n  }\n}\n\n//Two verification Page - 2\n.verification-2 {\n  input {\n    &:focus {\n      border: none;\n      outline: none !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .verification-2 {\n    input {\n      width: 40px !important;\n      font-size: 14px;\n    }\n  }\n}\n\n@media (max-width: 320px) {\n  .verification-2 {\n    input {\n      width: 30px !important;\n      height: 35px !important;\n      font-size: 15px !important;\n    }\n  }\n}\n\n//Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n\n  .fc {\n    .fc-toolbar {\n      >* {\n        >* {\n          float: none;\n        }\n      }\n    }\n  }\n\n  .fc-today-button {\n    display: none;\n  }\n}\n\n//Chat Scrollbar\n.ps__rail-y {\n  z-index: 999999 !important;\n}\n\n.close {\n  background: transparent;\n  border: 0;\n  font-size: 10px;\n  padding: 1.35rem 1.25rem;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  width: 1em;\n  height: 1em;\n  z-index: 2;\n\n  span {\n    display: none;\n  }\n}\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $grid-gutter-width;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n/* drawer */\n.react-drawer-drawer {\n  z-index: 9999;\n  background: #fff;\n}\n\n.drawer-main-menu {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.drawer-menu a i {\n  min-width: 2rem;\n  display: inline-block;\n  min-width: 1.75rem;\n  padding-bottom: 0.125em;\n  font-size: 1.25rem;\n  line-height: 1.40625rem;\n  vertical-align: middle;\n  color: #7f8387;\n  transition: all 0.4s;\n}\n\n.drawer-menu a {\n  display: block;\n  padding: 0.625rem 1.5rem;\n  color: #545a6d;\n  position: relative;\n  font-size: 13px;\n  transition: all 0.4s;\n}\n\n.drawer-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.ReactModal__Overlay {\n  z-index: 5000 !important;\n}\n\n.rangeslider__handle:focus {\n  outline: none;\n}\n\n// React Table next css\n.react-bootstrap-table-page-btns-ul {\n  float: right !important;\n}\n\n.search-label {\n  float: right;\n}\n\n.react-drawer-overlay {\n  z-index: 9999;\n}\n\n// datatable\n\n.react-bs-table-sizePerPage-dropdown {\n  .dropdown-menu {\n    .dropdown-item {\n      a {\n        display: block;\n      }\n    }\n  }\n}\n\n.rightbar-title .right-bar-toggle {\n  background-color: #444c54 !important;\n  height: 24px !important;\n  width: 24px !important;\n  line-height: 24px !important;\n  display: block !important;\n  color: #eff2f7 !important;\n  text-align: center !important;\n  border-radius: 50% !important;\n}\n\n//rightbar drawer\n.css-sourceMap-modules-importLoaders-1-localIdentName-animate__animated___2O131 {\n  animation-duration: 0.6s !important;\n}\n\n.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n\n//react-table\n.custom-header-css {\n  thead {\n    tr {\n      th {\n        div:last-child {\n          min-height: 38px;\n        }\n      }\n    }\n\n    td:nth-last-child(2) {\n      width: 150px !important;\n    }\n  }\n}\n\n.editor_email .ck-content {\n  height: 200px;\n}\n\n// .my-masonry-grid {\n//   display: -webkit-box;\n//   /* Not needed if autoprefixing */\n//   display: -ms-flexbox;\n//   /* Not needed if autoprefixing */\n//   display: flex;\n//   margin-left: -25px;\n//   /* gutter size offset */\n//   width: auto;\n// }\n\n// .my-masonry-grid_column {\n//   padding-left: 25px;\n//   /* gutter size */\n//   background-clip: padding-box;\n// }\n\n// /* Style your items */\n// .my-masonry-grid_column>div {\n//   /* change div to reference your elements you put in <Masonry> */\n//   background: transparent;\n//   margin-bottom: 20px;\n// }\n\n.jobs-categories .card-body a:last-child {\n  margin-bottom: 0 !important;\n}\n\n@media (max-width: 991.98px) {\n  .search-box {\n    display: block !important;\n\n    .search-label {\n      float: none;\n      width: 100%;\n\n      .form-control {\n        border-radius: 0.25rem !important;\n      }\n    }\n  }\n}\n\n// select\n\n.css-1s2u09g-control,\n.css-1pahdxg-control {\n  background-color: $input-bg !important;\n  border-color: $input-border-color !important;\n}\n\n.css-14el2xx-placeholder {\n  color: $input-placeholder-color !important;\n}\n\n.css-26l3qy-menu {\n  box-shadow: none !important;\n  border: 1px solid $input-border-color !important;\n}\n\n.css-4ljt47-MenuList {\n  background-color: var(--#{$prefix}custom-white) !important;\n  border-radius: 4px !important;\n}\n\n.css-319lph-ValueContainer .css-qc6sy-singleValue {\n  color: $input-color !important;\n}\n\n.select2-selection .css-b62m3t-container {\n  color: $input-color !important;\n}\n\n.css-1n7v3ny-option,\n.css-9gakcf-option {\n  background-color: $primary !important;\n  color: $white !important;\n}\n\n\n// rdw-editor\n\n.rdw-editor-toolbar,\n.rdw-option-wrapper,\n.rdw-editor-main {\n  border-color: $input-border-color !important;\n  background-color: var(--#{$prefix}custom-white) !important;\n}\n\n.rdw-option-wrapper {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.rdw-dropdown-wrapper {\n  background-color: $input-bg !important;\n  border-color: $input-border-color !important;\n  box-shadow: none !important;\n}\n\n.rdw-dropdown-selectedtext {\n  color: var(--#{$prefix}body-color) !important;\n}\n\n[data-layout-mode=\"dark\"] {\n\n  .rdw-option-wrapper,\n  .rdw-dropdown-selectedtext {\n    img {\n      filter: invert(1) !important;\n    }\n  }\n}\n\n// ck editor\n\n.ck.ck-toolbar {\n  background-color: var(--#{$prefix}light) !important;\n  border: 1px solid $input-border-color !important;\n}\n\n.ck-reset_all :not(.ck-reset_all-excluded *),\n.ck.ck-reset_all {\n  color: var(--#{$prefix}body-color) !important;\n}\n\n.ck.ck-editor__main>.ck-editor__editable {\n  background-color: var(--#{$prefix}custom-white) !important;\n  color: var(--#{$prefix}body-color) !important;\n  height: 300px !important;\n}\n\n.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {\n  border-color: $input-border-color !important;\n}\n\n.ck.ck-button:not(.ck-disabled):hover,\na.ck.ck-button:not(.ck-disabled):hover,\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background-color: var(--#{$prefix}light) !important;\n}\n\n.ck.ck-toolbar .ck.ck-toolbar__separator {\n  background: $input-border-color !important;\n}\n\n.selectall.checkbox-wrapper-mail label:before {\n  margin-top: 0;\n}\n\n// scroll\n.ps__rail-y,\n.ps__rail-x {\n  z-index: 999 !important;\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px var(--#{$prefix}custom-white) inset !important;\n  background-color: var(--#{$prefix}custom-white) !important;\n  color: var(--#{$prefix}body-color) !important;\n  -webkit-text-fill-color: var(--#{$prefix}body-color) !important;\n}\n\n\n\n// Select2\n\n.select2-selection__control,\n.select__control,\n.select2-selection .css-13cymwt-control,\n.css-t3ipsp-control {\n  background-color: $input-bg !important;\n  border-color: $input-border-color !important;\n}\n\n.select2-selection__menu,\n.select__menu,\n.css-1nmdiq5-menu {\n  background-color: var(--#{$prefix}card-bg) !important;\n  box-shadow: 0 0 0 1px var(--#{$prefix}border-color),\n  0 4px 11px var(--#{$prefix}border-color) !important;\n}\n\n.select2-selection__option--is-focused,\n.select__option--is-focused,\n.css-d7l1ni-option {\n  background-color: $primary !important;\n  color: $white !important;\n}\n\n.select__multi-value,\n.select2-selection__multi-value,\n// .css-1p3m7a8-multiValue {\n//   background-color: var(--#{$prefix}light) !important;\n// }\n\n.css-b62m3t-container {\n  .css-13cymwt-control {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    &:hover,\n    &:focus {\n      border-color: var(--#{$prefix}primary);\n\n    }\n\n    .css-1p3m7a8-multiValue {\n      color: var(--#{$prefix}white);\n      background-color: var(--#{$prefix}primary);\n\n      .css-wsp0cs-MultiValueGeneric {\n        color: var(--#{$prefix}white) !important;\n      }\n\n      .css-9jq23d {\n        color: var(--#{$prefix}white);\n      }\n\n      .css-1u9des2-indicatorSeparator {\n        border-color: var(--#{$prefix}border-color);\n      }\n    }\n  }\n\n  .css-tr4s17-option {\n    background-color: var(--#{$prefix}gray-400);\n    color: black;\n  }\n}\n\n.css-13cymwt-control {\n  border-color: hsl(0, 0%, 80%) !important\n}\n\n.select__multi-value__label,\n.select2-selection__multi-value__label,\n.css-qbdosj-Input,\n.css-1dimb5e-singleValue,\n.css-wsp0cs-MultiValueGeneric {\n  color: var(--#{$prefix}body-color) !important;\n}\n\n.select__multi-value__remove,\n.select2-selection__multi-value__remove {\n  background-color: var(--#{$prefix}light) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n\n// auth-logo\n\n[data-layout-mode=\"dark\"] {\n  .auth-logo {\n    .auth-logo-light {\n      display: block;\n    }\n\n    .auth-logo-dark {\n      display: none;\n    }\n  }\n}\n\n.noUi-connect {\n  height: 2px !important;\n}\n\n.noUi-horizontal .noUi-handle {\n  border-radius: 50% !important;\n  height: 16px !important;\n  right: -10px !important;\n  top: -7px !important;\n  width: 16px !important;\n}\n\n.noUi-target {\n  background: #fafafa !important;\n  background-color: #f3f6f9 !important;\n  background-color: #f3f6f9 !important;\n  border: 1px solid #f3f6f9 !important;\n  border-color: #f3f6f9 !important;\n  border-radius: 4px !important;\n  box-shadow: none !important;\n  height: 4px !important;\n}\n\n.noUi-handle {\n  background: #0ab39c !important;\n  border: 2px solid #fff !important;\n  box-shadow: none !important;\n}\n\n// emoji\naside.EmojiPickerReact.epr-main {\n  position: absolute !important;\n  bottom: 69px;\n  z-index: 2;\n  right: 110px;\n}\n\n[dir=\"rtl\"] .EmojiPickerReact.epr-main {\n  right: unset !important;\n  left: 116px !important;\n}\n\n\n.replymessage-block {\n  padding: 12px 20px;\n  text-align: left;\n  border-left: 2px solid rgba(var(--tb-success-rgb), 1);\n  border-radius: 4px;\n  background-color: rgba(29, 207, 122, .1);\n}","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.8.55\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.8.55\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.8.55\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.8.55\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.8.55\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-adobe::before {\n  content: \"\\F0936\";\n}\n\n.mdi-adobe-acrobat::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-amazon::before {\n  content: \"\\F002D\";\n}\n\n.mdi-amazon-alexa::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-auto::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-android-debug-bridge::before {\n  content: \"\\F0033\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-airplay::before {\n  content: \"\\F001F\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F1555\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bandcamp::before {\n  content: \"\\F0675\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-battlenet::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blogger::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolnisi-cross::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buddhism::before {\n  content: \"\\F094B\";\n}\n\n.mdi-buffer::before {\n  content: \"\\F0619\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cash-usd::before {\n  content: \"\\F1176\";\n}\n\n.mdi-cash-usd-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-android::before {\n  content: \"\\F011D\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-erase::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-iphone::before {\n  content: \"\\F0120\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-celtic-cross::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-box-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-check-box-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-christianity::before {\n  content: \"\\F0953\";\n}\n\n.mdi-christianity-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-concourse-ci::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-circle::before {\n  content: \"\\F116B\";\n}\n\n.mdi-currency-usd-circle-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-do-not-disturb::before {\n  content: \"\\F0698\";\n}\n\n.mdi-do-not-disturb-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-douban::before {\n  content: \"\\F069A\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-profile-woman::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-pdf-box-outline::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-file-pdf-outline::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gif::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-photos::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-hinduism::before {\n  content: \"\\F0973\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-currency-usd::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-iframe::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-iframe-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-iframe-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-iframe-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-iframe-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-iframe-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-iframe-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-iframe-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-iframe-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-iframe-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-islam::before {\n  content: \"\\F0979\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-judaism::before {\n  content: \"\\F097A\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-chromebook::before {\n  content: \"\\F0323\";\n}\n\n.mdi-laptop-mac::before {\n  content: \"\\F0324\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laptop-windows::before {\n  content: \"\\F0325\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-edge-legacy::before {\n  content: \"\\F1250\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microsoft-yammer::before {\n  content: \"\\F0789\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-clean::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-pdf-box::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-pharmacy::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-one::before {\n  content: \"\\F041B\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-poll-box::before {\n  content: \"\\F0420\";\n}\n\n.mdi-poll-box-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-sparkles::before {\n  content: \"\\F1545\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-tablet-ipad::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teach::before {\n  content: \"\\F0890\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-telegram::before {\n  content: \"\\F0501\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-clean::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-subject::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-twitter-retweet::before {\n  content: \"\\F0547\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-untappd::before {\n  content: \"\\F0551\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vk::before {\n  content: \"\\F0579\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xamarin-outline::before {\n  content: \"\\F0846\";\n}\n\n.mdi-xing::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-y-combinator::before {\n  content: \"\\F0624\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","@font-face\n{\n    font-family: 'boxicons';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('../../../../fonts/boxicons.eot');\n    src: url('../../../../fonts/boxicons.eot') format('embedded-opentype'),\n    url('../../../../fonts/boxicons.woff2') format('woff2'),\n    url('../../../../fonts/boxicons.woff') format('woff'),\n    url('../../../../fonts/boxicons.ttf') format('truetype'),\n    url('../../../../fonts/boxicons.svg?#boxicons') format('svg');\n}\n.bx\n{\n    font-family: 'boxicons' !important;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n\n    display: inline-block;\n\n    text-transform: none;\n\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.bx-ul\n{\n    margin-left: 2em;\n    padding-left: 0;\n\n    list-style: none;\n}\n.bx-ul > li\n{\n    position: relative;\n}\n.bx-ul .bx\n{\n    font-size: inherit;\n    line-height: inherit;\n\n    position: absolute;\n    left: -2em;\n\n    width: 2em;\n\n    text-align: center;\n}\n@-webkit-keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@-webkit-keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@-webkit-keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n                transform: rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n.bx-spin\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n.bx-spin-hover:hover\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n\n.bx-tada\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n.bx-tada-hover:hover\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n\n.bx-flashing\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n.bx-flashing-hover:hover\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n\n.bx-burst\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-burst-hover:hover\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-fade-up\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-up-hover:hover\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-down\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-down-hover:hover\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-left\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-left-hover:hover\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-right\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-fade-right-hover:hover\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-xs\n{\n    font-size: 1rem!important;\n}\n.bx-sm\n{\n    font-size: 1.55rem!important;\n}\n.bx-md\n{\n    font-size: 2.25rem!important;\n}\n.bx-fw\n{\n    font-size: 1.2857142857em;\n    line-height: .8em;\n\n    width: 1.2857142857em;\n    height: .8em;\n    margin-top: -.2em!important;\n\n    vertical-align: middle;\n}\n\n.bx-lg\n{\n    font-size: 3.0rem!important;\n}\n.bx-pull-left\n{\n    float: left;\n\n    margin-right: .3em!important;\n}\n\n.bx-pull-right\n{\n    float: right;\n\n    margin-left: .3em!important;\n}\n.bx-rotate-90\n{\n    transform: rotate(90deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n}\n.bx-rotate-180\n{\n    transform: rotate(180deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n}\n.bx-rotate-270\n{\n    transform: rotate(270deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n}\n.bx-flip-horizontal\n{\n    transform: scaleX(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n}\n.bx-flip-vertical\n{\n    transform: scaleY(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.bx-border\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n.bx-border-circle\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n\n.bxl-adobe:before {\n  content: \"\\e900\";\n}\n.bxl-algolia:before {\n  content: \"\\e901\";\n}\n.bxl-audible:before {\n  content: \"\\e902\";\n}\n.bxl-figma:before {\n  content: \"\\e903\";\n}\n.bxl-redbubble:before {\n  content: \"\\e904\";\n}\n.bxl-etsy:before {\n  content: \"\\e905\";\n}\n.bxl-gitlab:before {\n  content: \"\\e906\";\n}\n.bxl-patreon:before {\n  content: \"\\e907\";\n}\n.bxl-facebook-circle:before {\n  content: \"\\e908\";\n}\n.bxl-imdb:before {\n  content: \"\\e909\";\n}\n.bxl-jquery:before {\n  content: \"\\e90a\";\n}\n.bxl-pinterest-alt:before {\n  content: \"\\e90b\";\n}\n.bxl-500px:before {\n  content: \"\\e90c\";\n}\n.bxl-airbnb:before {\n  content: \"\\e90d\";\n}\n.bxl-amazon:before {\n  content: \"\\e90e\";\n}\n.bxl-android:before {\n  content: \"\\e90f\";\n}\n.bxl-angular:before {\n  content: \"\\e910\";\n}\n.bxl-apple:before {\n  content: \"\\e911\";\n}\n.bxl-baidu:before {\n  content: \"\\e912\";\n}\n.bxl-behance:before {\n  content: \"\\e913\";\n}\n.bxl-bing:before {\n  content: \"\\e914\";\n}\n.bxl-bitcoin:before {\n  content: \"\\e915\";\n}\n.bxl-blogger:before {\n  content: \"\\e916\";\n}\n.bxl-bootstrap:before {\n  content: \"\\e917\";\n}\n.bxl-chrome:before {\n  content: \"\\e918\";\n}\n.bxl-codepen:before {\n  content: \"\\e919\";\n}\n.bxl-creative-commons:before {\n  content: \"\\e91a\";\n}\n.bxl-css3:before {\n  content: \"\\e91b\";\n}\n.bxl-dailymotion:before {\n  content: \"\\e91c\";\n}\n.bxl-deviantart:before {\n  content: \"\\e91d\";\n}\n.bxl-digg:before {\n  content: \"\\e91e\";\n}\n.bxl-digitalocean:before {\n  content: \"\\e91f\";\n}\n.bxl-discord:before {\n  content: \"\\e920\";\n}\n.bxl-discourse:before {\n  content: \"\\e921\";\n}\n.bxl-dribbble:before {\n  content: \"\\e922\";\n}\n.bxl-dropbox:before {\n  content: \"\\e923\";\n}\n.bxl-drupal:before {\n  content: \"\\e924\";\n}\n.bxl-ebay:before {\n  content: \"\\e925\";\n}\n.bxl-edge:before {\n  content: \"\\e926\";\n}\n.bxl-facebook:before {\n  content: \"\\e927\";\n}\n.bxl-facebook-square:before {\n  content: \"\\e928\";\n}\n.bxl-firefox:before {\n  content: \"\\e929\";\n}\n.bxl-flickr:before {\n  content: \"\\e92a\";\n}\n.bxl-flickr-square:before {\n  content: \"\\e92b\";\n}\n.bxl-foursquare:before {\n  content: \"\\e92c\";\n}\n.bxl-git:before {\n  content: \"\\e92d\";\n}\n.bxl-github:before {\n  content: \"\\e92e\";\n}\n.bxl-google:before {\n  content: \"\\e92f\";\n}\n.bxl-google-plus:before {\n  content: \"\\e930\";\n}\n.bxl-google-plus-circle:before {\n  content: \"\\e931\";\n}\n.bxl-html5:before {\n  content: \"\\e932\";\n}\n.bxl-instagram:before {\n  content: \"\\e933\";\n}\n.bxl-instagram-alt:before {\n  content: \"\\e934\";\n}\n.bxl-internet-explorer:before {\n  content: \"\\e935\";\n}\n.bxl-invision:before {\n  content: \"\\e936\";\n}\n.bxl-javascript:before {\n  content: \"\\e937\";\n}\n.bxl-joomla:before {\n  content: \"\\e938\";\n}\n.bxl-jsfiddle:before {\n  content: \"\\e939\";\n}\n.bxl-kickstarter:before {\n  content: \"\\e93a\";\n}\n.bxl-less:before {\n  content: \"\\e93b\";\n}\n.bxl-linkedin:before {\n  content: \"\\e93c\";\n}\n.bxl-linkedin-square:before {\n  content: \"\\e93d\";\n}\n.bxl-magento:before {\n  content: \"\\e93e\";\n}\n.bxl-mailchimp:before {\n  content: \"\\e93f\";\n}\n.bxl-mastercard:before {\n  content: \"\\e940\";\n}\n.bxl-medium:before {\n  content: \"\\e941\";\n}\n.bxl-medium-old:before {\n  content: \"\\e942\";\n}\n.bxl-medium-square:before {\n  content: \"\\e943\";\n}\n.bxl-messenger:before {\n  content: \"\\e944\";\n}\n.bxl-microsoft:before {\n  content: \"\\e945\";\n}\n.bxl-nodejs:before {\n  content: \"\\e946\";\n}\n.bxl-opera:before {\n  content: \"\\e947\";\n}\n.bxl-paypal:before {\n  content: \"\\e948\";\n}\n.bxl-periscope:before {\n  content: \"\\e949\";\n}\n.bxl-pinterest:before {\n  content: \"\\e94a\";\n}\n.bxl-play-store:before {\n  content: \"\\e94b\";\n}\n.bxl-pocket:before {\n  content: \"\\e94c\";\n}\n.bxl-product-hunt:before {\n  content: \"\\e94d\";\n}\n.bxl-quora:before {\n  content: \"\\e94e\";\n}\n.bxl-react:before {\n  content: \"\\e94f\";\n}\n.bxl-reddit:before {\n  content: \"\\e950\";\n}\n.bxl-redux:before {\n  content: \"\\e951\";\n}\n.bxl-sass:before {\n  content: \"\\e952\";\n}\n.bxl-shopify:before {\n  content: \"\\e953\";\n}\n.bxl-skype:before {\n  content: \"\\e954\";\n}\n.bxl-slack:before {\n  content: \"\\e955\";\n}\n.bxl-slack-old:before {\n  content: \"\\e956\";\n}\n.bxl-snapchat:before {\n  content: \"\\e957\";\n}\n.bxl-soundcloud:before {\n  content: \"\\e958\";\n}\n.bxl-spotify:before {\n  content: \"\\e959\";\n}\n.bxl-squarespace:before {\n  content: \"\\e95a\";\n}\n.bxl-stack-overflow:before {\n  content: \"\\e95b\";\n}\n.bxl-stripe:before {\n  content: \"\\e95c\";\n}\n.bxl-telegram:before {\n  content: \"\\e95d\";\n}\n.bxl-trello:before {\n  content: \"\\e95e\";\n}\n.bxl-tumblr:before {\n  content: \"\\e95f\";\n}\n.bxl-twitch:before {\n  content: \"\\e960\";\n}\n.bxl-twitter:before {\n  content: \"\\e961\";\n}\n.bxl-unsplash:before {\n  content: \"\\e962\";\n}\n.bxl-vimeo:before {\n  content: \"\\e963\";\n}\n.bxl-visa:before {\n  content: \"\\e964\";\n}\n.bxl-vk:before {\n  content: \"\\e965\";\n}\n.bxl-vuejs:before {\n  content: \"\\e966\";\n}\n.bxl-whatsapp:before {\n  content: \"\\e967\";\n}\n.bxl-whatsapp-square:before {\n  content: \"\\e968\";\n}\n.bxl-wikipedia:before {\n  content: \"\\e969\";\n}\n.bxl-windows:before {\n  content: \"\\e96a\";\n}\n.bxl-wix:before {\n  content: \"\\e96b\";\n}\n.bxl-wordpress:before {\n  content: \"\\e96c\";\n}\n.bxl-yahoo:before {\n  content: \"\\e96d\";\n}\n.bxl-yelp:before {\n  content: \"\\e96e\";\n}\n.bxl-youtube:before {\n  content: \"\\e96f\";\n}\n.bx-accessibility:before {\n  content: \"\\e970\";\n}\n.bx-add-to-queue:before {\n  content: \"\\e971\";\n}\n.bx-adjust:before {\n  content: \"\\e972\";\n}\n.bx-alarm:before {\n  content: \"\\e973\";\n}\n.bx-alarm-add:before {\n  content: \"\\e974\";\n}\n.bx-alarm-off:before {\n  content: \"\\e975\";\n}\n.bx-album:before {\n  content: \"\\e976\";\n}\n.bx-align-justify:before {\n  content: \"\\e977\";\n}\n.bx-align-left:before {\n  content: \"\\e978\";\n}\n.bx-align-middle:before {\n  content: \"\\e979\";\n}\n.bx-align-right:before {\n  content: \"\\e97a\";\n}\n.bx-analyse:before {\n  content: \"\\e97b\";\n}\n.bx-anchor:before {\n  content: \"\\e97c\";\n}\n.bx-angry:before {\n  content: \"\\e97d\";\n}\n.bx-aperture:before {\n  content: \"\\e97e\";\n}\n.bx-archive:before {\n  content: \"\\e97f\";\n}\n.bx-archive-in:before {\n  content: \"\\e980\";\n}\n.bx-archive-out:before {\n  content: \"\\e981\";\n}\n.bx-area:before {\n  content: \"\\e982\";\n}\n.bx-arrow-back:before {\n  content: \"\\e983\";\n}\n.bx-at:before {\n  content: \"\\e984\";\n}\n.bx-award:before {\n  content: \"\\e985\";\n}\n.bx-badge:before {\n  content: \"\\e986\";\n}\n.bx-badge-check:before {\n  content: \"\\e987\";\n}\n.bx-ball:before {\n  content: \"\\e988\";\n}\n.bx-band-aid:before {\n  content: \"\\e989\";\n}\n.bx-bar-chart:before {\n  content: \"\\e98a\";\n}\n.bx-bar-chart-alt:before {\n  content: \"\\e98b\";\n}\n.bx-bar-chart-alt-2:before {\n  content: \"\\e98c\";\n}\n.bx-bar-chart-square:before {\n  content: \"\\e98d\";\n}\n.bx-barcode:before {\n  content: \"\\e98e\";\n}\n.bx-basket:before {\n  content: \"\\e98f\";\n}\n.bx-basketball:before {\n  content: \"\\e990\";\n}\n.bx-bath:before {\n  content: \"\\e991\";\n}\n.bx-battery:before {\n  content: \"\\e992\";\n}\n.bx-bed:before {\n  content: \"\\e993\";\n}\n.bx-bell:before {\n  content: \"\\e994\";\n}\n.bx-bell-minus:before {\n  content: \"\\e995\";\n}\n.bx-bell-off:before {\n  content: \"\\e996\";\n}\n.bx-bell-plus:before {\n  content: \"\\e997\";\n}\n.bx-bitcoin:before {\n  content: \"\\e998\";\n}\n.bx-block:before {\n  content: \"\\e999\";\n}\n.bx-bluetooth:before {\n  content: \"\\e99a\";\n}\n.bx-body:before {\n  content: \"\\e99b\";\n}\n.bx-bold:before {\n  content: \"\\e99c\";\n}\n.bx-bolt-circle:before {\n  content: \"\\e99d\";\n}\n.bx-book:before {\n  content: \"\\e99e\";\n}\n.bx-book-bookmark:before {\n  content: \"\\e99f\";\n}\n.bx-book-content:before {\n  content: \"\\e9a0\";\n}\n.bx-bookmark:before {\n  content: \"\\e9a1\";\n}\n.bx-bookmark-minus:before {\n  content: \"\\e9a2\";\n}\n.bx-bookmark-plus:before {\n  content: \"\\e9a3\";\n}\n.bx-bookmarks:before {\n  content: \"\\e9a4\";\n}\n.bx-book-open:before {\n  content: \"\\e9a5\";\n}\n.bx-border-all:before {\n  content: \"\\e9a6\";\n}\n.bx-border-bottom:before {\n  content: \"\\e9a7\";\n}\n.bx-border-left:before {\n  content: \"\\e9a8\";\n}\n.bx-border-radius:before {\n  content: \"\\e9a9\";\n}\n.bx-border-right:before {\n  content: \"\\e9aa\";\n}\n.bx-border-top:before {\n  content: \"\\e9ab\";\n}\n.bx-bot:before {\n  content: \"\\e9ac\";\n}\n.bx-bowling-ball:before {\n  content: \"\\e9ad\";\n}\n.bx-box:before {\n  content: \"\\e9ae\";\n}\n.bx-briefcase:before {\n  content: \"\\e9af\";\n}\n.bx-briefcase-alt:before {\n  content: \"\\e9b0\";\n}\n.bx-briefcase-alt-2:before {\n  content: \"\\e9b1\";\n}\n.bx-brightness:before {\n  content: \"\\e9b2\";\n}\n.bx-brightness-half:before {\n  content: \"\\e9b3\";\n}\n.bx-broadcast:before {\n  content: \"\\e9b4\";\n}\n.bx-brush:before {\n  content: \"\\e9b5\";\n}\n.bx-brush-alt:before {\n  content: \"\\e9b6\";\n}\n.bx-bug:before {\n  content: \"\\e9b7\";\n}\n.bx-bug-alt:before {\n  content: \"\\e9b8\";\n}\n.bx-building:before {\n  content: \"\\e9b9\";\n}\n.bx-building-house:before {\n  content: \"\\e9ba\";\n}\n.bx-buildings:before {\n  content: \"\\e9bb\";\n}\n.bx-bulb:before {\n  content: \"\\e9bc\";\n}\n.bx-bullseye:before {\n  content: \"\\e9bd\";\n}\n.bx-buoy:before {\n  content: \"\\e9be\";\n}\n.bx-bus:before {\n  content: \"\\e9bf\";\n}\n.bx-cake:before {\n  content: \"\\e9c0\";\n}\n.bx-calculator:before {\n  content: \"\\e9c1\";\n}\n.bx-calendar:before {\n  content: \"\\e9c2\";\n}\n.bx-calendar-alt:before {\n  content: \"\\e9c3\";\n}\n.bx-calendar-check:before {\n  content: \"\\e9c4\";\n}\n.bx-calendar-event:before {\n  content: \"\\e9c5\";\n}\n.bx-calendar-minus:before {\n  content: \"\\e9c6\";\n}\n.bx-calendar-plus:before {\n  content: \"\\e9c7\";\n}\n.bx-calendar-x:before {\n  content: \"\\e9c8\";\n}\n.bx-camera:before {\n  content: \"\\e9c9\";\n}\n.bx-camera-off:before {\n  content: \"\\e9ca\";\n}\n.bx-captions:before {\n  content: \"\\e9cb\";\n}\n.bx-car:before {\n  content: \"\\e9cc\";\n}\n.bx-card:before {\n  content: \"\\e9cd\";\n}\n.bx-caret-down:before {\n  content: \"\\e9ce\";\n}\n.bx-caret-left:before {\n  content: \"\\e9cf\";\n}\n.bx-caret-right:before {\n  content: \"\\e9d0\";\n}\n.bx-caret-up:before {\n  content: \"\\e9d1\";\n}\n.bx-carousel:before {\n  content: \"\\e9d2\";\n}\n.bx-cart:before {\n  content: \"\\e9d3\";\n}\n.bx-cart-alt:before {\n  content: \"\\e9d4\";\n}\n.bx-cast:before {\n  content: \"\\e9d5\";\n}\n.bx-certification:before {\n  content: \"\\e9d6\";\n}\n.bx-chalkboard:before {\n  content: \"\\e9d7\";\n}\n.bx-chart:before {\n  content: \"\\e9d8\";\n}\n.bx-chat:before {\n  content: \"\\e9d9\";\n}\n.bx-check:before {\n  content: \"\\e9da\";\n}\n.bx-checkbox:before {\n  content: \"\\e9db\";\n}\n.bx-checkbox-checked:before {\n  content: \"\\e9dc\";\n}\n.bx-checkbox-square:before {\n  content: \"\\e9dd\";\n}\n.bx-check-circle:before {\n  content: \"\\e9de\";\n}\n.bx-check-double:before {\n  content: \"\\e9df\";\n}\n.bx-check-shield:before {\n  content: \"\\e9e0\";\n}\n.bx-check-square:before {\n  content: \"\\e9e1\";\n}\n.bx-chevron-down:before {\n  content: \"\\e9e2\";\n}\n.bx-chevron-left:before {\n  content: \"\\e9e3\";\n}\n.bx-chevron-right:before {\n  content: \"\\e9e4\";\n}\n.bx-chevrons-down:before {\n  content: \"\\e9e5\";\n}\n.bx-chevrons-left:before {\n  content: \"\\e9e6\";\n}\n.bx-chevrons-right:before {\n  content: \"\\e9e7\";\n}\n.bx-chevrons-up:before {\n  content: \"\\e9e8\";\n}\n.bx-chevron-up:before {\n  content: \"\\e9e9\";\n}\n.bx-chip:before {\n  content: \"\\e9ea\";\n}\n.bx-circle:before {\n  content: \"\\e9eb\";\n}\n.bx-clinic:before {\n  content: \"\\e9ec\";\n}\n.bx-clipboard:before {\n  content: \"\\e9ed\";\n}\n.bx-closet:before {\n  content: \"\\e9ee\";\n}\n.bx-cloud:before {\n  content: \"\\e9ef\";\n}\n.bx-cloud-download:before {\n  content: \"\\e9f0\";\n}\n.bx-cloud-drizzle:before {\n  content: \"\\e9f1\";\n}\n.bx-cloud-lightning:before {\n  content: \"\\e9f2\";\n}\n.bx-cloud-light-rain:before {\n  content: \"\\e9f3\";\n}\n.bx-cloud-rain:before {\n  content: \"\\e9f4\";\n}\n.bx-cloud-snow:before {\n  content: \"\\e9f5\";\n}\n.bx-cloud-upload:before {\n  content: \"\\e9f6\";\n}\n.bx-code:before {\n  content: \"\\e9f7\";\n}\n.bx-code-alt:before {\n  content: \"\\e9f8\";\n}\n.bx-code-block:before {\n  content: \"\\e9f9\";\n}\n.bx-code-curly:before {\n  content: \"\\e9fa\";\n}\n.bx-coffee:before {\n  content: \"\\e9fb\";\n}\n.bx-cog:before {\n  content: \"\\e9fc\";\n}\n.bx-collapse:before {\n  content: \"\\e9fd\";\n}\n.bx-collection:before {\n  content: \"\\e9fe\";\n}\n.bx-columns:before {\n  content: \"\\e9ff\";\n}\n.bx-command:before {\n  content: \"\\ea00\";\n}\n.bx-comment:before {\n  content: \"\\ea01\";\n}\n.bx-comment-dots:before {\n  content: \"\\ea02\";\n}\n.bx-compass:before {\n  content: \"\\ea03\";\n}\n.bx-confused:before {\n  content: \"\\ea04\";\n}\n.bx-conversation:before {\n  content: \"\\ea05\";\n}\n.bx-cool:before {\n  content: \"\\ea06\";\n}\n.bx-copy:before {\n  content: \"\\ea07\";\n}\n.bx-copy-alt:before {\n  content: \"\\ea08\";\n}\n.bx-copyright:before {\n  content: \"\\ea09\";\n}\n.bx-credit-card:before {\n  content: \"\\ea0a\";\n}\n.bx-credit-card-alt:before {\n  content: \"\\ea0b\";\n}\n.bx-crop:before {\n  content: \"\\ea0c\";\n}\n.bx-crosshair:before {\n  content: \"\\ea0d\";\n}\n.bx-crown:before {\n  content: \"\\ea0e\";\n}\n.bx-cube:before {\n  content: \"\\ea0f\";\n}\n.bx-cube-alt:before {\n  content: \"\\ea10\";\n}\n.bx-cuboid:before {\n  content: \"\\ea11\";\n}\n.bx-customize:before {\n  content: \"\\ea12\";\n}\n.bx-cut:before {\n  content: \"\\ea13\";\n}\n.bx-cycling:before {\n  content: \"\\ea14\";\n}\n.bx-cylinder:before {\n  content: \"\\ea15\";\n}\n.bx-data:before {\n  content: \"\\ea16\";\n}\n.bx-desktop:before {\n  content: \"\\ea17\";\n}\n.bx-detail:before {\n  content: \"\\ea18\";\n}\n.bx-devices:before {\n  content: \"\\ea19\";\n}\n.bx-dialpad:before {\n  content: \"\\ea1a\";\n}\n.bx-dialpad-alt:before {\n  content: \"\\ea1b\";\n}\n.bx-diamond:before {\n  content: \"\\ea1c\";\n}\n.bx-directions:before {\n  content: \"\\ea1d\";\n}\n.bx-disc:before {\n  content: \"\\ea1e\";\n}\n.bx-dish:before {\n  content: \"\\ea1f\";\n}\n.bx-dislike:before {\n  content: \"\\ea20\";\n}\n.bx-dizzy:before {\n  content: \"\\ea21\";\n}\n.bx-dna:before {\n  content: \"\\ea22\";\n}\n.bx-dock-bottom:before {\n  content: \"\\ea23\";\n}\n.bx-dock-left:before {\n  content: \"\\ea24\";\n}\n.bx-dock-right:before {\n  content: \"\\ea25\";\n}\n.bx-dock-top:before {\n  content: \"\\ea26\";\n}\n.bx-dollar:before {\n  content: \"\\ea27\";\n}\n.bx-dollar-circle:before {\n  content: \"\\ea28\";\n}\n.bx-dots-horizontal:before {\n  content: \"\\ea29\";\n}\n.bx-dots-horizontal-rounded:before {\n  content: \"\\ea2a\";\n}\n.bx-dots-vertical:before {\n  content: \"\\ea2b\";\n}\n.bx-dots-vertical-rounded:before {\n  content: \"\\ea2c\";\n}\n.bx-doughnut-chart:before {\n  content: \"\\ea2d\";\n}\n.bx-down-arrow:before {\n  content: \"\\ea2e\";\n}\n.bx-down-arrow-alt:before {\n  content: \"\\ea2f\";\n}\n.bx-down-arrow-circle:before {\n  content: \"\\ea30\";\n}\n.bx-download:before {\n  content: \"\\ea31\";\n}\n.bx-downvote:before {\n  content: \"\\ea32\";\n}\n.bx-droplet:before {\n  content: \"\\ea33\";\n}\n.bx-dumbbell:before {\n  content: \"\\ea34\";\n}\n.bx-duplicate:before {\n  content: \"\\ea35\";\n}\n.bx-edit:before {\n  content: \"\\ea36\";\n}\n.bx-edit-alt:before {\n  content: \"\\ea37\";\n}\n.bx-envelope:before {\n  content: \"\\ea38\";\n}\n.bx-equalizer:before {\n  content: \"\\ea39\";\n}\n.bx-error:before {\n  content: \"\\ea3a\";\n}\n.bx-error-alt:before {\n  content: \"\\ea3b\";\n}\n.bx-error-circle:before {\n  content: \"\\ea3c\";\n}\n.bx-euro:before {\n  content: \"\\ea3d\";\n}\n.bx-exit:before {\n  content: \"\\ea3e\";\n}\n.bx-exit-fullscreen:before {\n  content: \"\\ea3f\";\n}\n.bx-expand:before {\n  content: \"\\ea40\";\n}\n.bx-export:before {\n  content: \"\\ea41\";\n}\n.bx-extension:before {\n  content: \"\\ea42\";\n}\n.bx-face:before {\n  content: \"\\ea43\";\n}\n.bx-fast-forward:before {\n  content: \"\\ea44\";\n}\n.bx-fast-forward-circle:before {\n  content: \"\\ea45\";\n}\n.bx-female:before {\n  content: \"\\ea46\";\n}\n.bx-female-sign:before {\n  content: \"\\ea47\";\n}\n.bx-file:before {\n  content: \"\\ea48\";\n}\n.bx-file-blank:before {\n  content: \"\\ea49\";\n}\n.bx-file-find:before {\n  content: \"\\ea4a\";\n}\n.bx-film:before {\n  content: \"\\ea4b\";\n}\n.bx-filter:before {\n  content: \"\\ea4c\";\n}\n.bx-filter-alt:before {\n  content: \"\\ea4d\";\n}\n.bx-fingerprint:before {\n  content: \"\\ea4e\";\n}\n.bx-first-aid:before {\n  content: \"\\ea4f\";\n}\n.bx-first-page:before {\n  content: \"\\ea50\";\n}\n.bx-flag:before {\n  content: \"\\ea51\";\n}\n.bx-folder:before {\n  content: \"\\ea52\";\n}\n.bx-folder-minus:before {\n  content: \"\\ea53\";\n}\n.bx-folder-open:before {\n  content: \"\\ea54\";\n}\n.bx-folder-plus:before {\n  content: \"\\ea55\";\n}\n.bx-font:before {\n  content: \"\\ea56\";\n}\n.bx-font-color:before {\n  content: \"\\ea57\";\n}\n.bx-font-family:before {\n  content: \"\\ea58\";\n}\n.bx-font-size:before {\n  content: \"\\ea59\";\n}\n.bx-food-menu:before {\n  content: \"\\ea5a\";\n}\n.bx-food-tag:before {\n  content: \"\\ea5b\";\n}\n.bx-football:before {\n  content: \"\\ea5c\";\n}\n.bx-fridge:before {\n  content: \"\\ea5d\";\n}\n.bx-fullscreen:before {\n  content: \"\\ea5e\";\n}\n.bx-gas-pump:before {\n  content: \"\\ea5f\";\n}\n.bx-ghost:before {\n  content: \"\\ea60\";\n}\n.bx-gift:before {\n  content: \"\\ea61\";\n}\n.bx-git-branch:before {\n  content: \"\\ea62\";\n}\n.bx-git-commit:before {\n  content: \"\\ea63\";\n}\n.bx-git-compare:before {\n  content: \"\\ea64\";\n}\n.bx-git-merge:before {\n  content: \"\\ea65\";\n}\n.bx-git-pull-request:before {\n  content: \"\\ea66\";\n}\n.bx-git-repo-forked:before {\n  content: \"\\ea67\";\n}\n.bx-globe:before {\n  content: \"\\ea68\";\n}\n.bx-globe-alt:before {\n  content: \"\\ea69\";\n}\n.bx-grid:before {\n  content: \"\\ea6a\";\n}\n.bx-grid-alt:before {\n  content: \"\\ea6b\";\n}\n.bx-grid-horizontal:before {\n  content: \"\\ea6c\";\n}\n.bx-grid-small:before {\n  content: \"\\ea6d\";\n}\n.bx-grid-vertical:before {\n  content: \"\\ea6e\";\n}\n.bx-group:before {\n  content: \"\\ea6f\";\n}\n.bx-handicap:before {\n  content: \"\\ea70\";\n}\n.bx-happy:before {\n  content: \"\\ea71\";\n}\n.bx-happy-alt:before {\n  content: \"\\ea72\";\n}\n.bx-happy-beaming:before {\n  content: \"\\ea73\";\n}\n.bx-happy-heart-eyes:before {\n  content: \"\\ea74\";\n}\n.bx-hash:before {\n  content: \"\\ea75\";\n}\n.bx-hdd:before {\n  content: \"\\ea76\";\n}\n.bx-heading:before {\n  content: \"\\ea77\";\n}\n.bx-headphone:before {\n  content: \"\\ea78\";\n}\n.bx-health:before {\n  content: \"\\ea79\";\n}\n.bx-heart:before {\n  content: \"\\ea7a\";\n}\n.bx-help-circle:before {\n  content: \"\\ea7b\";\n}\n.bx-hide:before {\n  content: \"\\ea7c\";\n}\n.bx-highlight:before {\n  content: \"\\ea7d\";\n}\n.bx-history:before {\n  content: \"\\ea7e\";\n}\n.bx-hive:before {\n  content: \"\\ea7f\";\n}\n.bx-home:before {\n  content: \"\\ea80\";\n}\n.bx-home-alt:before {\n  content: \"\\ea81\";\n}\n.bx-home-circle:before {\n  content: \"\\ea82\";\n}\n.bx-horizontal-center:before {\n  content: \"\\ea83\";\n}\n.bx-hotel:before {\n  content: \"\\ea84\";\n}\n.bx-hourglass:before {\n  content: \"\\ea85\";\n}\n.bx-id-card:before {\n  content: \"\\ea86\";\n}\n.bx-image:before {\n  content: \"\\ea87\";\n}\n.bx-image-add:before {\n  content: \"\\ea88\";\n}\n.bx-image-alt:before {\n  content: \"\\ea89\";\n}\n.bx-images:before {\n  content: \"\\ea8a\";\n}\n.bx-import:before {\n  content: \"\\ea8b\";\n}\n.bx-infinite:before {\n  content: \"\\ea8c\";\n}\n.bx-info-circle:before {\n  content: \"\\ea8d\";\n}\n.bx-italic:before {\n  content: \"\\ea8e\";\n}\n.bx-joystick:before {\n  content: \"\\ea8f\";\n}\n.bx-joystick-alt:before {\n  content: \"\\ea90\";\n}\n.bx-joystick-button:before {\n  content: \"\\ea91\";\n}\n.bx-key:before {\n  content: \"\\ea92\";\n}\n.bx-label:before {\n  content: \"\\ea93\";\n}\n.bx-landscape:before {\n  content: \"\\ea94\";\n}\n.bx-laptop:before {\n  content: \"\\ea95\";\n}\n.bx-last-page:before {\n  content: \"\\ea96\";\n}\n.bx-laugh:before {\n  content: \"\\ea97\";\n}\n.bx-layer:before {\n  content: \"\\ea98\";\n}\n.bx-layout:before {\n  content: \"\\ea99\";\n}\n.bx-left-arrow:before {\n  content: \"\\ea9a\";\n}\n.bx-left-arrow-alt:before {\n  content: \"\\ea9b\";\n}\n.bx-left-arrow-circle:before {\n  content: \"\\ea9c\";\n}\n.bx-left-down-arrow-circle:before {\n  content: \"\\ea9d\";\n}\n.bx-left-indent:before {\n  content: \"\\ea9e\";\n}\n.bx-left-top-arrow-circle:before {\n  content: \"\\ea9f\";\n}\n.bx-like:before {\n  content: \"\\eaa0\";\n}\n.bx-line-chart:before {\n  content: \"\\eaa1\";\n}\n.bx-link:before {\n  content: \"\\eaa2\";\n}\n.bx-link-alt:before {\n  content: \"\\eaa3\";\n}\n.bx-link-external:before {\n  content: \"\\eaa4\";\n}\n.bx-lira:before {\n  content: \"\\eaa5\";\n}\n.bx-list-check:before {\n  content: \"\\eaa6\";\n}\n.bx-list-minus:before {\n  content: \"\\eaa7\";\n}\n.bx-list-ol:before {\n  content: \"\\eaa8\";\n}\n.bx-list-plus:before {\n  content: \"\\eaa9\";\n}\n.bx-list-ul:before {\n  content: \"\\eaaa\";\n}\n.bx-loader:before {\n  content: \"\\eaab\";\n}\n.bx-loader-alt:before {\n  content: \"\\eaac\";\n}\n.bx-loader-circle:before {\n  content: \"\\eaad\";\n}\n.bx-lock:before {\n  content: \"\\eaae\";\n}\n.bx-lock-alt:before {\n  content: \"\\eaaf\";\n}\n.bx-lock-open:before {\n  content: \"\\eab0\";\n}\n.bx-lock-open-alt:before {\n  content: \"\\eab1\";\n}\n.bx-log-in:before {\n  content: \"\\eab2\";\n}\n.bx-log-in-circle:before {\n  content: \"\\eab3\";\n}\n.bx-log-out:before {\n  content: \"\\eab4\";\n}\n.bx-log-out-circle:before {\n  content: \"\\eab5\";\n}\n.bx-magnet:before {\n  content: \"\\eab6\";\n}\n.bx-mail-send:before {\n  content: \"\\eab7\";\n}\n.bx-male:before {\n  content: \"\\eab8\";\n}\n.bx-male-sign:before {\n  content: \"\\eab9\";\n}\n.bx-map:before {\n  content: \"\\eaba\";\n}\n.bx-map-alt:before {\n  content: \"\\eabb\";\n}\n.bx-map-pin:before {\n  content: \"\\eabc\";\n}\n.bx-meh:before {\n  content: \"\\eabd\";\n}\n.bx-meh-alt:before {\n  content: \"\\eabe\";\n}\n.bx-meh-blank:before {\n  content: \"\\eabf\";\n}\n.bx-memory-card:before {\n  content: \"\\eac0\";\n}\n.bx-menu:before {\n  content: \"\\eac1\";\n}\n.bx-menu-alt-left:before {\n  content: \"\\eac2\";\n}\n.bx-menu-alt-right:before {\n  content: \"\\eac3\";\n}\n.bx-message:before {\n  content: \"\\eac4\";\n}\n.bx-message-alt:before {\n  content: \"\\eac5\";\n}\n.bx-message-alt-dots:before {\n  content: \"\\eac6\";\n}\n.bx-message-dots:before {\n  content: \"\\eac7\";\n}\n.bx-message-rounded:before {\n  content: \"\\eac8\";\n}\n.bx-message-rounded-dots:before {\n  content: \"\\eac9\";\n}\n.bx-message-square:before {\n  content: \"\\eaca\";\n}\n.bx-message-square-dots:before {\n  content: \"\\eacb\";\n}\n.bx-microphone:before {\n  content: \"\\eacc\";\n}\n.bx-microphone-off:before {\n  content: \"\\eacd\";\n}\n.bx-minus:before {\n  content: \"\\eace\";\n}\n.bx-minus-circle:before {\n  content: \"\\eacf\";\n}\n.bx-mobile:before {\n  content: \"\\ead0\";\n}\n.bx-mobile-alt:before {\n  content: \"\\ead1\";\n}\n.bx-mobile-landscape:before {\n  content: \"\\ead2\";\n}\n.bx-mobile-vibration:before {\n  content: \"\\ead3\";\n}\n.bx-money:before {\n  content: \"\\ead4\";\n}\n.bx-moon:before {\n  content: \"\\ead5\";\n}\n.bx-mouse:before {\n  content: \"\\ead6\";\n}\n.bx-mouse-alt:before {\n  content: \"\\ead7\";\n}\n.bx-move:before {\n  content: \"\\ead8\";\n}\n.bx-move-horizontal:before {\n  content: \"\\ead9\";\n}\n.bx-move-vertical:before {\n  content: \"\\eada\";\n}\n.bx-movie:before {\n  content: \"\\eadb\";\n}\n.bx-music:before {\n  content: \"\\eadc\";\n}\n.bx-navigation:before {\n  content: \"\\eadd\";\n}\n.bx-news:before {\n  content: \"\\eade\";\n}\n.bx-no-entry:before {\n  content: \"\\eadf\";\n}\n.bx-note:before {\n  content: \"\\eae0\";\n}\n.bx-notepad:before {\n  content: \"\\eae1\";\n}\n.bx-notification:before {\n  content: \"\\eae2\";\n}\n.bx-notification-off:before {\n  content: \"\\eae3\";\n}\n.bx-package:before {\n  content: \"\\eae4\";\n}\n.bx-paint:before {\n  content: \"\\eae5\";\n}\n.bx-paint-roll:before {\n  content: \"\\eae6\";\n}\n.bx-palette:before {\n  content: \"\\eae7\";\n}\n.bx-paperclip:before {\n  content: \"\\eae8\";\n}\n.bx-paper-plane:before {\n  content: \"\\eae9\";\n}\n.bx-paragraph:before {\n  content: \"\\eaea\";\n}\n.bx-paste:before {\n  content: \"\\eaeb\";\n}\n.bx-pause:before {\n  content: \"\\eaec\";\n}\n.bx-pause-circle:before {\n  content: \"\\eaed\";\n}\n.bx-pen:before {\n  content: \"\\eaee\";\n}\n.bx-pencil:before {\n  content: \"\\eaef\";\n}\n.bx-phone:before {\n  content: \"\\eaf0\";\n}\n.bx-phone-call:before {\n  content: \"\\eaf1\";\n}\n.bx-phone-incoming:before {\n  content: \"\\eaf2\";\n}\n.bx-phone-outgoing:before {\n  content: \"\\eaf3\";\n}\n.bx-photo-album:before {\n  content: \"\\eaf4\";\n}\n.bx-pie-chart:before {\n  content: \"\\eaf5\";\n}\n.bx-pie-chart-alt:before {\n  content: \"\\eaf6\";\n}\n.bx-pie-chart-alt-2:before {\n  content: \"\\eaf7\";\n}\n.bx-pin:before {\n  content: \"\\eaf8\";\n}\n.bx-planet:before {\n  content: \"\\eaf9\";\n}\n.bx-play:before {\n  content: \"\\eafa\";\n}\n.bx-play-circle:before {\n  content: \"\\eafb\";\n}\n.bx-plug:before {\n  content: \"\\eafc\";\n}\n.bx-plus:before {\n  content: \"\\eafd\";\n}\n.bx-plus-circle:before {\n  content: \"\\eafe\";\n}\n.bx-plus-medical:before {\n  content: \"\\eaff\";\n}\n.bx-poll:before {\n  content: \"\\eb00\";\n}\n.bx-polygon:before {\n  content: \"\\eb01\";\n}\n.bx-pound:before {\n  content: \"\\eb02\";\n}\n.bx-power-off:before {\n  content: \"\\eb03\";\n}\n.bx-printer:before {\n  content: \"\\eb04\";\n}\n.bx-pulse:before {\n  content: \"\\eb05\";\n}\n.bx-purchase-tag:before {\n  content: \"\\eb06\";\n}\n.bx-purchase-tag-alt:before {\n  content: \"\\eb07\";\n}\n.bx-pyramid:before {\n  content: \"\\eb08\";\n}\n.bx-question-mark:before {\n  content: \"\\eb09\";\n}\n.bx-radar:before {\n  content: \"\\eb0a\";\n}\n.bx-radio:before {\n  content: \"\\eb0b\";\n}\n.bx-radio-circle:before {\n  content: \"\\eb0c\";\n}\n.bx-radio-circle-marked:before {\n  content: \"\\eb0d\";\n}\n.bx-receipt:before {\n  content: \"\\eb0e\";\n}\n.bx-rectangle:before {\n  content: \"\\eb0f\";\n}\n.bx-redo:before {\n  content: \"\\eb10\";\n}\n.bx-rename:before {\n  content: \"\\eb11\";\n}\n.bx-repeat:before {\n  content: \"\\eb12\";\n}\n.bx-reply:before {\n  content: \"\\eb13\";\n}\n.bx-reply-all:before {\n  content: \"\\eb14\";\n}\n.bx-repost:before {\n  content: \"\\eb15\";\n}\n.bx-reset:before {\n  content: \"\\eb16\";\n}\n.bx-restaurant:before {\n  content: \"\\eb17\";\n}\n.bx-revision:before {\n  content: \"\\eb18\";\n}\n.bx-rewind:before {\n  content: \"\\eb19\";\n}\n.bx-rewind-circle:before {\n  content: \"\\eb1a\";\n}\n.bx-right-arrow:before {\n  content: \"\\eb1b\";\n}\n.bx-right-arrow-alt:before {\n  content: \"\\eb1c\";\n}\n.bx-right-arrow-circle:before {\n  content: \"\\eb1d\";\n}\n.bx-right-down-arrow-circle:before {\n  content: \"\\eb1e\";\n}\n.bx-right-indent:before {\n  content: \"\\eb1f\";\n}\n.bx-right-top-arrow-circle:before {\n  content: \"\\eb20\";\n}\n.bx-rocket:before {\n  content: \"\\eb21\";\n}\n.bx-rotate-left:before {\n  content: \"\\eb22\";\n}\n.bx-rotate-right:before {\n  content: \"\\eb23\";\n}\n.bx-rss:before {\n  content: \"\\eb24\";\n}\n.bx-ruble:before {\n  content: \"\\eb25\";\n}\n.bx-ruler:before {\n  content: \"\\eb26\";\n}\n.bx-run:before {\n  content: \"\\eb27\";\n}\n.bx-rupee:before {\n  content: \"\\eb28\";\n}\n.bx-sad:before {\n  content: \"\\eb29\";\n}\n.bx-save:before {\n  content: \"\\eb2a\";\n}\n.bx-screenshot:before {\n  content: \"\\eb2b\";\n}\n.bx-search:before {\n  content: \"\\eb2c\";\n}\n.bx-search-alt:before {\n  content: \"\\eb2d\";\n}\n.bx-search-alt-2:before {\n  content: \"\\eb2e\";\n}\n.bx-selection:before {\n  content: \"\\eb2f\";\n}\n.bx-select-multiple:before {\n  content: \"\\eb30\";\n}\n.bx-send:before {\n  content: \"\\eb31\";\n}\n.bx-server:before {\n  content: \"\\eb32\";\n}\n.bx-shape-circle:before {\n  content: \"\\eb33\";\n}\n.bx-shape-square:before {\n  content: \"\\eb34\";\n}\n.bx-shape-triangle:before {\n  content: \"\\eb35\";\n}\n.bx-share:before {\n  content: \"\\eb36\";\n}\n.bx-share-alt:before {\n  content: \"\\eb37\";\n}\n.bx-shekel:before {\n  content: \"\\eb38\";\n}\n.bx-shield:before {\n  content: \"\\eb39\";\n}\n.bx-shield-alt:before {\n  content: \"\\eb3a\";\n}\n.bx-shield-alt-2:before {\n  content: \"\\eb3b\";\n}\n.bx-shield-quarter:before {\n  content: \"\\eb3c\";\n}\n.bx-shocked:before {\n  content: \"\\eb3d\";\n}\n.bx-shopping-bag:before {\n  content: \"\\eb3e\";\n}\n.bx-show:before {\n  content: \"\\eb3f\";\n}\n.bx-show-alt:before {\n  content: \"\\eb40\";\n}\n.bx-shuffle:before {\n  content: \"\\eb41\";\n}\n.bx-sidebar:before {\n  content: \"\\eb42\";\n}\n.bx-sitemap:before {\n  content: \"\\eb43\";\n}\n.bx-skip-next:before {\n  content: \"\\eb44\";\n}\n.bx-skip-next-circle:before {\n  content: \"\\eb45\";\n}\n.bx-skip-previous:before {\n  content: \"\\eb46\";\n}\n.bx-skip-previous-circle:before {\n  content: \"\\eb47\";\n}\n.bx-sleepy:before {\n  content: \"\\eb48\";\n}\n.bx-slider:before {\n  content: \"\\eb49\";\n}\n.bx-slider-alt:before {\n  content: \"\\eb4a\";\n}\n.bx-slideshow:before {\n  content: \"\\eb4b\";\n}\n.bx-smile:before {\n  content: \"\\eb4c\";\n}\n.bx-sort:before {\n  content: \"\\eb4d\";\n}\n.bx-sort-a-z:before {\n  content: \"\\eb4e\";\n}\n.bx-sort-down:before {\n  content: \"\\eb4f\";\n}\n.bx-sort-up:before {\n  content: \"\\eb50\";\n}\n.bx-sort-z-a:before {\n  content: \"\\eb51\";\n}\n.bx-spa:before {\n  content: \"\\eb52\";\n}\n.bx-space-bar:before {\n  content: \"\\eb53\";\n}\n.bx-spreadsheet:before {\n  content: \"\\eb54\";\n}\n.bx-square:before {\n  content: \"\\eb55\";\n}\n.bx-square-rounded:before {\n  content: \"\\eb56\";\n}\n.bx-star:before {\n  content: \"\\eb57\";\n}\n.bx-station:before {\n  content: \"\\eb58\";\n}\n.bx-stats:before {\n  content: \"\\eb59\";\n}\n.bx-sticker:before {\n  content: \"\\eb5a\";\n}\n.bx-stop:before {\n  content: \"\\eb5b\";\n}\n.bx-stop-circle:before {\n  content: \"\\eb5c\";\n}\n.bx-stopwatch:before {\n  content: \"\\eb5d\";\n}\n.bx-store:before {\n  content: \"\\eb5e\";\n}\n.bx-store-alt:before {\n  content: \"\\eb5f\";\n}\n.bx-street-view:before {\n  content: \"\\eb60\";\n}\n.bx-strikethrough:before {\n  content: \"\\eb61\";\n}\n.bx-subdirectory-left:before {\n  content: \"\\eb62\";\n}\n.bx-subdirectory-right:before {\n  content: \"\\eb63\";\n}\n.bx-sun:before {\n  content: \"\\eb64\";\n}\n.bx-support:before {\n  content: \"\\eb65\";\n}\n.bx-swim:before {\n  content: \"\\eb66\";\n}\n.bx-sync:before {\n  content: \"\\eb67\";\n}\n.bx-tab:before {\n  content: \"\\eb68\";\n}\n.bx-table:before {\n  content: \"\\eb69\";\n}\n.bx-tag:before {\n  content: \"\\eb6a\";\n}\n.bx-target-lock:before {\n  content: \"\\eb6b\";\n}\n.bx-task:before {\n  content: \"\\eb6c\";\n}\n.bx-taxi:before {\n  content: \"\\eb6d\";\n}\n.bx-tennis-ball:before {\n  content: \"\\eb6e\";\n}\n.bx-terminal:before {\n  content: \"\\eb6f\";\n}\n.bx-test-tube:before {\n  content: \"\\eb70\";\n}\n.bx-text:before {\n  content: \"\\eb71\";\n}\n.bx-time:before {\n  content: \"\\eb72\";\n}\n.bx-time-five:before {\n  content: \"\\eb73\";\n}\n.bx-timer:before {\n  content: \"\\eb74\";\n}\n.bx-tired:before {\n  content: \"\\eb75\";\n}\n.bx-toggle-left:before {\n  content: \"\\eb76\";\n}\n.bx-toggle-right:before {\n  content: \"\\eb77\";\n}\n.bx-tone:before {\n  content: \"\\eb78\";\n}\n.bx-train:before {\n  content: \"\\eb79\";\n}\n.bx-transfer:before {\n  content: \"\\eb7a\";\n}\n.bx-transfer-alt:before {\n  content: \"\\eb7b\";\n}\n.bx-trash:before {\n  content: \"\\eb7c\";\n}\n.bx-trash-alt:before {\n  content: \"\\eb7d\";\n}\n.bx-trending-down:before {\n  content: \"\\eb7e\";\n}\n.bx-trending-up:before {\n  content: \"\\eb7f\";\n}\n.bx-trophy:before {\n  content: \"\\eb80\";\n}\n.bx-tv:before {\n  content: \"\\eb81\";\n}\n.bx-underline:before {\n  content: \"\\eb82\";\n}\n.bx-undo:before {\n  content: \"\\eb83\";\n}\n.bx-unlink:before {\n  content: \"\\eb84\";\n}\n.bx-up-arrow:before {\n  content: \"\\eb85\";\n}\n.bx-up-arrow-alt:before {\n  content: \"\\eb86\";\n}\n.bx-up-arrow-circle:before {\n  content: \"\\eb87\";\n}\n.bx-upload:before {\n  content: \"\\eb88\";\n}\n.bx-upside-down:before {\n  content: \"\\eb89\";\n}\n.bx-upvote:before {\n  content: \"\\eb8a\";\n}\n.bx-usb:before {\n  content: \"\\eb8b\";\n}\n.bx-user:before {\n  content: \"\\eb8c\";\n}\n.bx-user-check:before {\n  content: \"\\eb8d\";\n}\n.bx-user-circle:before {\n  content: \"\\eb8e\";\n}\n.bx-user-minus:before {\n  content: \"\\eb8f\";\n}\n.bx-user-pin:before {\n  content: \"\\eb90\";\n}\n.bx-user-plus:before {\n  content: \"\\eb91\";\n}\n.bx-user-voice:before {\n  content: \"\\eb92\";\n}\n.bx-user-x:before {\n  content: \"\\eb93\";\n}\n.bx-vertical-center:before {\n  content: \"\\eb94\";\n}\n.bx-video:before {\n  content: \"\\eb95\";\n}\n.bx-video-off:before {\n  content: \"\\eb96\";\n}\n.bx-video-plus:before {\n  content: \"\\eb97\";\n}\n.bx-video-recording:before {\n  content: \"\\eb98\";\n}\n.bx-voicemail:before {\n  content: \"\\eb99\";\n}\n.bx-volume:before {\n  content: \"\\eb9a\";\n}\n.bx-volume-full:before {\n  content: \"\\eb9b\";\n}\n.bx-volume-low:before {\n  content: \"\\eb9c\";\n}\n.bx-volume-mute:before {\n  content: \"\\eb9d\";\n}\n.bx-walk:before {\n  content: \"\\eb9e\";\n}\n.bx-wallet:before {\n  content: \"\\eb9f\";\n}\n.bx-wallet-alt:before {\n  content: \"\\eba0\";\n}\n.bx-water:before {\n  content: \"\\eba1\";\n}\n.bx-wifi:before {\n  content: \"\\eba2\";\n}\n.bx-wifi-off:before {\n  content: \"\\eba3\";\n}\n.bx-wind:before {\n  content: \"\\eba4\";\n}\n.bx-window:before {\n  content: \"\\eba5\";\n}\n.bx-window-close:before {\n  content: \"\\eba6\";\n}\n.bx-window-open:before {\n  content: \"\\eba7\";\n}\n.bx-windows:before {\n  content: \"\\eba8\";\n}\n.bx-wink-smile:before {\n  content: \"\\eba9\";\n}\n.bx-wink-tongue:before {\n  content: \"\\ebaa\";\n}\n.bx-won:before {\n  content: \"\\ebab\";\n}\n.bx-world:before {\n  content: \"\\ebac\";\n}\n.bx-wrench:before {\n  content: \"\\ebad\";\n}\n.bx-x:before {\n  content: \"\\ebae\";\n}\n.bx-x-circle:before {\n  content: \"\\ebaf\";\n}\n.bx-yen:before {\n  content: \"\\ebb0\";\n}\n.bx-zoom-in:before {\n  content: \"\\ebb1\";\n}\n.bx-zoom-out:before {\n  content: \"\\ebb2\";\n}\n.bxs-add-to-queue:before {\n  content: \"\\ebb3\";\n}\n.bxs-adjust:before {\n  content: \"\\ebb4\";\n}\n.bxs-adjust-alt:before {\n  content: \"\\ebb5\";\n}\n.bxs-alarm:before {\n  content: \"\\ebb6\";\n}\n.bxs-alarm-add:before {\n  content: \"\\ebb7\";\n}\n.bxs-alarm-off:before {\n  content: \"\\ebb8\";\n}\n.bxs-album:before {\n  content: \"\\ebb9\";\n}\n.bxs-ambulance:before {\n  content: \"\\ebba\";\n}\n.bxs-analyse:before {\n  content: \"\\ebbb\";\n}\n.bxs-angry:before {\n  content: \"\\ebbc\";\n}\n.bxs-archive:before {\n  content: \"\\ebbd\";\n}\n.bxs-archive-in:before {\n  content: \"\\ebbe\";\n}\n.bxs-archive-out:before {\n  content: \"\\ebbf\";\n}\n.bxs-area:before {\n  content: \"\\ebc0\";\n}\n.bxs-award:before {\n  content: \"\\ebc1\";\n}\n.bxs-baby-carriage:before {\n  content: \"\\ebc2\";\n}\n.bxs-badge:before {\n  content: \"\\ebc3\";\n}\n.bxs-badge-check:before {\n  content: \"\\ebc4\";\n}\n.bxs-ball:before {\n  content: \"\\ebc5\";\n}\n.bxs-band-aid:before {\n  content: \"\\ebc6\";\n}\n.bxs-bank:before {\n  content: \"\\ebc7\";\n}\n.bxs-bar-chart-alt-2:before {\n  content: \"\\ebc8\";\n}\n.bxs-bar-chart-square:before {\n  content: \"\\ebc9\";\n}\n.bxs-barcode:before {\n  content: \"\\ebca\";\n}\n.bxs-basket:before {\n  content: \"\\ebcb\";\n}\n.bxs-bath:before {\n  content: \"\\ebcc\";\n}\n.bxs-battery:before {\n  content: \"\\ebcd\";\n}\n.bxs-battery-charging:before {\n  content: \"\\ebce\";\n}\n.bxs-battery-full:before {\n  content: \"\\ebcf\";\n}\n.bxs-battery-low:before {\n  content: \"\\ebd0\";\n}\n.bxs-bed:before {\n  content: \"\\ebd1\";\n}\n.bxs-bell:before {\n  content: \"\\ebd2\";\n}\n.bxs-bell-minus:before {\n  content: \"\\ebd3\";\n}\n.bxs-bell-off:before {\n  content: \"\\ebd4\";\n}\n.bxs-bell-plus:before {\n  content: \"\\ebd5\";\n}\n.bxs-bell-ring:before {\n  content: \"\\ebd6\";\n}\n.bxs-bolt:before {\n  content: \"\\ebd7\";\n}\n.bxs-bolt-circle:before {\n  content: \"\\ebd8\";\n}\n.bxs-book:before {\n  content: \"\\ebd9\";\n}\n.bxs-book-bookmark:before {\n  content: \"\\ebda\";\n}\n.bxs-book-content:before {\n  content: \"\\ebdb\";\n}\n.bxs-bookmark:before {\n  content: \"\\ebdc\";\n}\n.bxs-bookmark-minus:before {\n  content: \"\\ebdd\";\n}\n.bxs-bookmark-plus:before {\n  content: \"\\ebde\";\n}\n.bxs-bookmarks:before {\n  content: \"\\ebdf\";\n}\n.bxs-bookmark-star:before {\n  content: \"\\ebe0\";\n}\n.bxs-book-open:before {\n  content: \"\\ebe1\";\n}\n.bxs-bot:before {\n  content: \"\\ebe2\";\n}\n.bxs-bowling-ball:before {\n  content: \"\\ebe3\";\n}\n.bxs-box:before {\n  content: \"\\ebe4\";\n}\n.bxs-briefcase:before {\n  content: \"\\ebe5\";\n}\n.bxs-briefcase-alt:before {\n  content: \"\\ebe6\";\n}\n.bxs-briefcase-alt-2:before {\n  content: \"\\ebe7\";\n}\n.bxs-brightness:before {\n  content: \"\\ebe8\";\n}\n.bxs-brightness-half:before {\n  content: \"\\ebe9\";\n}\n.bxs-brush:before {\n  content: \"\\ebea\";\n}\n.bxs-brush-alt:before {\n  content: \"\\ebeb\";\n}\n.bxs-bug:before {\n  content: \"\\ebec\";\n}\n.bxs-bug-alt:before {\n  content: \"\\ebed\";\n}\n.bxs-building:before {\n  content: \"\\ebee\";\n}\n.bxs-building-house:before {\n  content: \"\\ebef\";\n}\n.bxs-buildings:before {\n  content: \"\\ebf0\";\n}\n.bxs-bulb:before {\n  content: \"\\ebf1\";\n}\n.bxs-buoy:before {\n  content: \"\\ebf2\";\n}\n.bxs-bus:before {\n  content: \"\\ebf3\";\n}\n.bxs-business:before {\n  content: \"\\ebf4\";\n}\n.bxs-cake:before {\n  content: \"\\ebf5\";\n}\n.bxs-calculator:before {\n  content: \"\\ebf6\";\n}\n.bxs-calendar:before {\n  content: \"\\ebf7\";\n}\n.bxs-calendar-alt:before {\n  content: \"\\ebf8\";\n}\n.bxs-calendar-check:before {\n  content: \"\\ebf9\";\n}\n.bxs-calendar-event:before {\n  content: \"\\ebfa\";\n}\n.bxs-calendar-minus:before {\n  content: \"\\ebfb\";\n}\n.bxs-calendar-plus:before {\n  content: \"\\ebfc\";\n}\n.bxs-calendar-x:before {\n  content: \"\\ebfd\";\n}\n.bxs-camera:before {\n  content: \"\\ebfe\";\n}\n.bxs-camera-off:before {\n  content: \"\\ebff\";\n}\n.bxs-camera-plus:before {\n  content: \"\\ec00\";\n}\n.bxs-capsule:before {\n  content: \"\\ec01\";\n}\n.bxs-captions:before {\n  content: \"\\ec02\";\n}\n.bxs-car:before {\n  content: \"\\ec03\";\n}\n.bxs-card:before {\n  content: \"\\ec04\";\n}\n.bxs-caret-down-circle:before {\n  content: \"\\ec05\";\n}\n.bxs-caret-left-circle:before {\n  content: \"\\ec06\";\n}\n.bxs-caret-right-circle:before {\n  content: \"\\ec07\";\n}\n.bxs-caret-up-circle:before {\n  content: \"\\ec08\";\n}\n.bxs-carousel:before {\n  content: \"\\ec09\";\n}\n.bxs-cart:before {\n  content: \"\\ec0a\";\n}\n.bxs-cart-alt:before {\n  content: \"\\ec0b\";\n}\n.bxs-certification:before {\n  content: \"\\ec0c\";\n}\n.bxs-chalkboard:before {\n  content: \"\\ec0d\";\n}\n.bxs-chart:before {\n  content: \"\\ec0e\";\n}\n.bxs-chat:before {\n  content: \"\\ec0f\";\n}\n.bxs-checkbox:before {\n  content: \"\\ec10\";\n}\n.bxs-checkbox-checked:before {\n  content: \"\\ec11\";\n}\n.bxs-check-circle:before {\n  content: \"\\ec12\";\n}\n.bxs-check-shield:before {\n  content: \"\\ec13\";\n}\n.bxs-check-square:before {\n  content: \"\\ec14\";\n}\n.bxs-chip:before {\n  content: \"\\ec15\";\n}\n.bxs-circle:before {\n  content: \"\\ec16\";\n}\n.bxs-city:before {\n  content: \"\\ec17\";\n}\n.bxs-clinic:before {\n  content: \"\\ec18\";\n}\n.bxs-cloud:before {\n  content: \"\\ec19\";\n}\n.bxs-cloud-download:before {\n  content: \"\\ec1a\";\n}\n.bxs-cloud-lightning:before {\n  content: \"\\ec1b\";\n}\n.bxs-cloud-rain:before {\n  content: \"\\ec1c\";\n}\n.bxs-cloud-upload:before {\n  content: \"\\ec1d\";\n}\n.bxs-coffee:before {\n  content: \"\\ec1e\";\n}\n.bxs-coffee-alt:before {\n  content: \"\\ec1f\";\n}\n.bxs-cog:before {\n  content: \"\\ec20\";\n}\n.bxs-collection:before {\n  content: \"\\ec21\";\n}\n.bxs-color-fill:before {\n  content: \"\\ec22\";\n}\n.bxs-comment:before {\n  content: \"\\ec23\";\n}\n.bxs-comment-add:before {\n  content: \"\\ec24\";\n}\n.bxs-comment-detail:before {\n  content: \"\\ec25\";\n}\n.bxs-comment-dots:before {\n  content: \"\\ec26\";\n}\n.bxs-comment-error:before {\n  content: \"\\ec27\";\n}\n.bxs-compass:before {\n  content: \"\\ec28\";\n}\n.bxs-component:before {\n  content: \"\\ec29\";\n}\n.bxs-confused:before {\n  content: \"\\ec2a\";\n}\n.bxs-contact:before {\n  content: \"\\ec2b\";\n}\n.bxs-conversation:before {\n  content: \"\\ec2c\";\n}\n.bxs-cool:before {\n  content: \"\\ec2d\";\n}\n.bxs-copy:before {\n  content: \"\\ec2e\";\n}\n.bxs-copy-alt:before {\n  content: \"\\ec2f\";\n}\n.bxs-coupon:before {\n  content: \"\\ec30\";\n}\n.bxs-credit-card:before {\n  content: \"\\ec31\";\n}\n.bxs-credit-card-alt:before {\n  content: \"\\ec32\";\n}\n.bxs-crown:before {\n  content: \"\\ec33\";\n}\n.bxs-cube:before {\n  content: \"\\ec34\";\n}\n.bxs-cube-alt:before {\n  content: \"\\ec35\";\n}\n.bxs-cuboid:before {\n  content: \"\\ec36\";\n}\n.bxs-customize:before {\n  content: \"\\ec37\";\n}\n.bxs-cylinder:before {\n  content: \"\\ec38\";\n}\n.bxs-dashboard:before {\n  content: \"\\ec39\";\n}\n.bxs-data:before {\n  content: \"\\ec3a\";\n}\n.bxs-detail:before {\n  content: \"\\ec3b\";\n}\n.bxs-devices:before {\n  content: \"\\ec3c\";\n}\n.bxs-direction-left:before {\n  content: \"\\ec3d\";\n}\n.bxs-direction-right:before {\n  content: \"\\ec3e\";\n}\n.bxs-directions:before {\n  content: \"\\ec3f\";\n}\n.bxs-disc:before {\n  content: \"\\ec40\";\n}\n.bxs-discount:before {\n  content: \"\\ec41\";\n}\n.bxs-dish:before {\n  content: \"\\ec42\";\n}\n.bxs-dislike:before {\n  content: \"\\ec43\";\n}\n.bxs-dizzy:before {\n  content: \"\\ec44\";\n}\n.bxs-dock-bottom:before {\n  content: \"\\ec45\";\n}\n.bxs-dock-left:before {\n  content: \"\\ec46\";\n}\n.bxs-dock-right:before {\n  content: \"\\ec47\";\n}\n.bxs-dock-top:before {\n  content: \"\\ec48\";\n}\n.bxs-dollar-circle:before {\n  content: \"\\ec49\";\n}\n.bxs-doughnut-chart:before {\n  content: \"\\ec4a\";\n}\n.bxs-down-arrow:before {\n  content: \"\\ec4b\";\n}\n.bxs-down-arrow-circle:before {\n  content: \"\\ec4c\";\n}\n.bxs-down-arrow-square:before {\n  content: \"\\ec4d\";\n}\n.bxs-download:before {\n  content: \"\\ec4e\";\n}\n.bxs-downvote:before {\n  content: \"\\ec4f\";\n}\n.bxs-drink:before {\n  content: \"\\ec50\";\n}\n.bxs-droplet:before {\n  content: \"\\ec51\";\n}\n.bxs-droplet-half:before {\n  content: \"\\ec52\";\n}\n.bxs-duplicate:before {\n  content: \"\\ec53\";\n}\n.bxs-edit:before {\n  content: \"\\ec54\";\n}\n.bxs-edit-alt:before {\n  content: \"\\ec55\";\n}\n.bxs-eject:before {\n  content: \"\\ec56\";\n}\n.bxs-envelope:before {\n  content: \"\\ec57\";\n}\n.bxs-eraser:before {\n  content: \"\\ec58\";\n}\n.bxs-error:before {\n  content: \"\\ec59\";\n}\n.bxs-error-alt:before {\n  content: \"\\ec5a\";\n}\n.bxs-error-circle:before {\n  content: \"\\ec5b\";\n}\n.bxs-exit:before {\n  content: \"\\ec5c\";\n}\n.bxs-extension:before {\n  content: \"\\ec5d\";\n}\n.bxs-eyedropper:before {\n  content: \"\\ec5e\";\n}\n.bxs-face:before {\n  content: \"\\ec5f\";\n}\n.bxs-factory:before {\n  content: \"\\ec60\";\n}\n.bxs-fast-forward-circle:before {\n  content: \"\\ec61\";\n}\n.bxs-file:before {\n  content: \"\\ec62\";\n}\n.bxs-file-blank:before {\n  content: \"\\ec63\";\n}\n.bxs-file-css:before {\n  content: \"\\ec64\";\n}\n.bxs-file-doc:before {\n  content: \"\\ec65\";\n}\n.bxs-file-find:before {\n  content: \"\\ec66\";\n}\n.bxs-file-gif:before {\n  content: \"\\ec67\";\n}\n.bxs-file-html:before {\n  content: \"\\ec68\";\n}\n.bxs-file-image:before {\n  content: \"\\ec69\";\n}\n.bxs-file-jpg:before {\n  content: \"\\ec6a\";\n}\n.bxs-file-js:before {\n  content: \"\\ec6b\";\n}\n.bxs-file-json:before {\n  content: \"\\ec6c\";\n}\n.bxs-file-md:before {\n  content: \"\\ec6d\";\n}\n.bxs-file-pdf:before {\n  content: \"\\ec6e\";\n}\n.bxs-file-plus:before {\n  content: \"\\ec6f\";\n}\n.bxs-file-png:before {\n  content: \"\\ec70\";\n}\n.bxs-file-txt:before {\n  content: \"\\ec71\";\n}\n.bxs-film:before {\n  content: \"\\ec72\";\n}\n.bxs-filter-alt:before {\n  content: \"\\ec73\";\n}\n.bxs-first-aid:before {\n  content: \"\\ec74\";\n}\n.bxs-flag:before {\n  content: \"\\ec75\";\n}\n.bxs-flag-alt:before {\n  content: \"\\ec76\";\n}\n.bxs-flame:before {\n  content: \"\\ec77\";\n}\n.bxs-flask:before {\n  content: \"\\ec78\";\n}\n.bxs-folder:before {\n  content: \"\\ec79\";\n}\n.bxs-folder-minus:before {\n  content: \"\\ec7a\";\n}\n.bxs-folder-open:before {\n  content: \"\\ec7b\";\n}\n.bxs-folder-plus:before {\n  content: \"\\ec7c\";\n}\n.bxs-food-menu:before {\n  content: \"\\ec7d\";\n}\n.bxs-fridge:before {\n  content: \"\\ec7e\";\n}\n.bxs-gas-pump:before {\n  content: \"\\ec7f\";\n}\n.bxs-ghost:before {\n  content: \"\\ec80\";\n}\n.bxs-gift:before {\n  content: \"\\ec81\";\n}\n.bxs-graduation:before {\n  content: \"\\ec82\";\n}\n.bxs-grid:before {\n  content: \"\\ec83\";\n}\n.bxs-grid-alt:before {\n  content: \"\\ec84\";\n}\n.bxs-group:before {\n  content: \"\\ec85\";\n}\n.bxs-hand-down:before {\n  content: \"\\ec86\";\n}\n.bxs-hand-left:before {\n  content: \"\\ec87\";\n}\n.bxs-hand-right:before {\n  content: \"\\ec88\";\n}\n.bxs-hand-up:before {\n  content: \"\\ec89\";\n}\n.bxs-happy:before {\n  content: \"\\ec8a\";\n}\n.bxs-happy-alt:before {\n  content: \"\\ec8b\";\n}\n.bxs-happy-beaming:before {\n  content: \"\\ec8c\";\n}\n.bxs-happy-heart-eyes:before {\n  content: \"\\ec8d\";\n}\n.bxs-hdd:before {\n  content: \"\\ec8e\";\n}\n.bxs-heart:before {\n  content: \"\\ec8f\";\n}\n.bxs-help-circle:before {\n  content: \"\\ec90\";\n}\n.bxs-hide:before {\n  content: \"\\ec91\";\n}\n.bxs-home:before {\n  content: \"\\ec92\";\n}\n.bxs-home-circle:before {\n  content: \"\\ec93\";\n}\n.bxs-hot:before {\n  content: \"\\ec94\";\n}\n.bxs-hotel:before {\n  content: \"\\ec95\";\n}\n.bxs-hourglass:before {\n  content: \"\\ec96\";\n}\n.bxs-hourglass-bottom:before {\n  content: \"\\ec97\";\n}\n.bxs-hourglass-top:before {\n  content: \"\\ec98\";\n}\n.bxs-id-card:before {\n  content: \"\\ec99\";\n}\n.bxs-image:before {\n  content: \"\\ec9a\";\n}\n.bxs-image-add:before {\n  content: \"\\ec9b\";\n}\n.bxs-image-alt:before {\n  content: \"\\ec9c\";\n}\n.bxs-inbox:before {\n  content: \"\\ec9d\";\n}\n.bxs-info-circle:before {\n  content: \"\\ec9e\";\n}\n.bxs-institution:before {\n  content: \"\\ec9f\";\n}\n.bxs-joystick:before {\n  content: \"\\eca0\";\n}\n.bxs-joystick-alt:before {\n  content: \"\\eca1\";\n}\n.bxs-joystick-button:before {\n  content: \"\\eca2\";\n}\n.bxs-key:before {\n  content: \"\\eca3\";\n}\n.bxs-keyboard:before {\n  content: \"\\eca4\";\n}\n.bxs-label:before {\n  content: \"\\eca5\";\n}\n.bxs-landmark:before {\n  content: \"\\eca6\";\n}\n.bxs-landscape:before {\n  content: \"\\eca7\";\n}\n.bxs-laugh:before {\n  content: \"\\eca8\";\n}\n.bxs-layer:before {\n  content: \"\\eca9\";\n}\n.bxs-layout:before {\n  content: \"\\ecaa\";\n}\n.bxs-left-arrow:before {\n  content: \"\\ecab\";\n}\n.bxs-left-arrow-circle:before {\n  content: \"\\ecac\";\n}\n.bxs-left-arrow-square:before {\n  content: \"\\ecad\";\n}\n.bxs-left-down-arrow-circle:before {\n  content: \"\\ecae\";\n}\n.bxs-left-top-arrow-circle:before {\n  content: \"\\ecaf\";\n}\n.bxs-like:before {\n  content: \"\\ecb0\";\n}\n.bxs-lock:before {\n  content: \"\\ecb1\";\n}\n.bxs-lock-alt:before {\n  content: \"\\ecb2\";\n}\n.bxs-lock-open:before {\n  content: \"\\ecb3\";\n}\n.bxs-lock-open-alt:before {\n  content: \"\\ecb4\";\n}\n.bxs-log-in:before {\n  content: \"\\ecb5\";\n}\n.bxs-log-in-circle:before {\n  content: \"\\ecb6\";\n}\n.bxs-log-out:before {\n  content: \"\\ecb7\";\n}\n.bxs-log-out-circle:before {\n  content: \"\\ecb8\";\n}\n.bxs-magic-wand:before {\n  content: \"\\ecb9\";\n}\n.bxs-magnet:before {\n  content: \"\\ecba\";\n}\n.bxs-map:before {\n  content: \"\\ecbb\";\n}\n.bxs-map-alt:before {\n  content: \"\\ecbc\";\n}\n.bxs-map-pin:before {\n  content: \"\\ecbd\";\n}\n.bxs-megaphone:before {\n  content: \"\\ecbe\";\n}\n.bxs-meh:before {\n  content: \"\\ecbf\";\n}\n.bxs-meh-alt:before {\n  content: \"\\ecc0\";\n}\n.bxs-meh-blank:before {\n  content: \"\\ecc1\";\n}\n.bxs-memory-card:before {\n  content: \"\\ecc2\";\n}\n.bxs-message:before {\n  content: \"\\ecc3\";\n}\n.bxs-message-alt:before {\n  content: \"\\ecc4\";\n}\n.bxs-message-alt-dots:before {\n  content: \"\\ecc5\";\n}\n.bxs-message-dots:before {\n  content: \"\\ecc6\";\n}\n.bxs-message-rounded:before {\n  content: \"\\ecc7\";\n}\n.bxs-message-rounded-dots:before {\n  content: \"\\ecc8\";\n}\n.bxs-message-square:before {\n  content: \"\\ecc9\";\n}\n.bxs-message-square-dots:before {\n  content: \"\\ecca\";\n}\n.bxs-microphone:before {\n  content: \"\\eccb\";\n}\n.bxs-microphone-alt:before {\n  content: \"\\eccc\";\n}\n.bxs-microphone-off:before {\n  content: \"\\eccd\";\n}\n.bxs-minus-circle:before {\n  content: \"\\ecce\";\n}\n.bxs-minus-square:before {\n  content: \"\\eccf\";\n}\n.bxs-mobile:before {\n  content: \"\\ecd0\";\n}\n.bxs-mobile-vibration:before {\n  content: \"\\ecd1\";\n}\n.bxs-moon:before {\n  content: \"\\ecd2\";\n}\n.bxs-mouse:before {\n  content: \"\\ecd3\";\n}\n.bxs-mouse-alt:before {\n  content: \"\\ecd4\";\n}\n.bxs-movie:before {\n  content: \"\\ecd5\";\n}\n.bxs-music:before {\n  content: \"\\ecd6\";\n}\n.bxs-navigation:before {\n  content: \"\\ecd7\";\n}\n.bxs-news:before {\n  content: \"\\ecd8\";\n}\n.bxs-no-entry:before {\n  content: \"\\ecd9\";\n}\n.bxs-note:before {\n  content: \"\\ecda\";\n}\n.bxs-notepad:before {\n  content: \"\\ecdb\";\n}\n.bxs-notification:before {\n  content: \"\\ecdc\";\n}\n.bxs-notification-off:before {\n  content: \"\\ecdd\";\n}\n.bxs-offer:before {\n  content: \"\\ecde\";\n}\n.bxs-package:before {\n  content: \"\\ecdf\";\n}\n.bxs-paint:before {\n  content: \"\\ece0\";\n}\n.bxs-paint-roll:before {\n  content: \"\\ece1\";\n}\n.bxs-palette:before {\n  content: \"\\ece2\";\n}\n.bxs-paper-plane:before {\n  content: \"\\ece3\";\n}\n.bxs-parking:before {\n  content: \"\\ece4\";\n}\n.bxs-paste:before {\n  content: \"\\ece5\";\n}\n.bxs-pen:before {\n  content: \"\\ece6\";\n}\n.bxs-pencil:before {\n  content: \"\\ece7\";\n}\n.bxs-phone:before {\n  content: \"\\ece8\";\n}\n.bxs-phone-call:before {\n  content: \"\\ece9\";\n}\n.bxs-phone-incoming:before {\n  content: \"\\ecea\";\n}\n.bxs-phone-outgoing:before {\n  content: \"\\eceb\";\n}\n.bxs-photo-album:before {\n  content: \"\\ecec\";\n}\n.bxs-pie-chart:before {\n  content: \"\\eced\";\n}\n.bxs-pie-chart-alt:before {\n  content: \"\\ecee\";\n}\n.bxs-pie-chart-alt-2:before {\n  content: \"\\ecef\";\n}\n.bxs-pin:before {\n  content: \"\\ecf0\";\n}\n.bxs-plane:before {\n  content: \"\\ecf1\";\n}\n.bxs-plane-alt:before {\n  content: \"\\ecf2\";\n}\n.bxs-plane-land:before {\n  content: \"\\ecf3\";\n}\n.bxs-planet:before {\n  content: \"\\ecf4\";\n}\n.bxs-plane-take-off:before {\n  content: \"\\ecf5\";\n}\n.bxs-playlist:before {\n  content: \"\\ecf6\";\n}\n.bxs-plug:before {\n  content: \"\\ecf7\";\n}\n.bxs-plus-circle:before {\n  content: \"\\ecf8\";\n}\n.bxs-plus-square:before {\n  content: \"\\ecf9\";\n}\n.bxs-polygon:before {\n  content: \"\\ecfa\";\n}\n.bxs-printer:before {\n  content: \"\\ecfb\";\n}\n.bxs-purchase-tag:before {\n  content: \"\\ecfc\";\n}\n.bxs-purchase-tag-alt:before {\n  content: \"\\ecfd\";\n}\n.bxs-pyramid:before {\n  content: \"\\ecfe\";\n}\n.bxs-quote-alt-left:before {\n  content: \"\\ecff\";\n}\n.bxs-quote-alt-right:before {\n  content: \"\\ed00\";\n}\n.bxs-quote-left:before {\n  content: \"\\ed01\";\n}\n.bxs-quote-right:before {\n  content: \"\\ed02\";\n}\n.bxs-quote-single-left:before {\n  content: \"\\ed03\";\n}\n.bxs-quote-single-right:before {\n  content: \"\\ed04\";\n}\n.bxs-radio:before {\n  content: \"\\ed05\";\n}\n.bxs-receipt:before {\n  content: \"\\ed06\";\n}\n.bxs-rectangle:before {\n  content: \"\\ed07\";\n}\n.bxs-rename:before {\n  content: \"\\ed08\";\n}\n.bxs-report:before {\n  content: \"\\ed09\";\n}\n.bxs-rewind-circle:before {\n  content: \"\\ed0a\";\n}\n.bxs-right-arrow:before {\n  content: \"\\ed0b\";\n}\n.bxs-right-arrow-circle:before {\n  content: \"\\ed0c\";\n}\n.bxs-right-arrow-square:before {\n  content: \"\\ed0d\";\n}\n.bxs-right-down-arrow-circle:before {\n  content: \"\\ed0e\";\n}\n.bxs-right-top-arrow-circle:before {\n  content: \"\\ed0f\";\n}\n.bxs-rocket:before {\n  content: \"\\ed10\";\n}\n.bxs-ruler:before {\n  content: \"\\ed11\";\n}\n.bxs-sad:before {\n  content: \"\\ed12\";\n}\n.bxs-save:before {\n  content: \"\\ed13\";\n}\n.bxs-school:before {\n  content: \"\\ed14\";\n}\n.bxs-search:before {\n  content: \"\\ed15\";\n}\n.bxs-search-alt-2:before {\n  content: \"\\ed16\";\n}\n.bxs-select-multiple:before {\n  content: \"\\ed17\";\n}\n.bxs-send:before {\n  content: \"\\ed18\";\n}\n.bxs-server:before {\n  content: \"\\ed19\";\n}\n.bxs-share:before {\n  content: \"\\ed1a\";\n}\n.bxs-share-alt:before {\n  content: \"\\ed1b\";\n}\n.bxs-shield:before {\n  content: \"\\ed1c\";\n}\n.bxs-shield-alt-2:before {\n  content: \"\\ed1d\";\n}\n.bxs-ship:before {\n  content: \"\\ed1e\";\n}\n.bxs-shocked:before {\n  content: \"\\ed1f\";\n}\n.bxs-shopping-bag:before {\n  content: \"\\ed20\";\n}\n.bxs-shopping-bag-alt:before {\n  content: \"\\ed21\";\n}\n.bxs-show:before {\n  content: \"\\ed22\";\n}\n.bxs-skip-next-circle:before {\n  content: \"\\ed23\";\n}\n.bxs-skip-previous-circle:before {\n  content: \"\\ed24\";\n}\n.bxs-skull:before {\n  content: \"\\ed25\";\n}\n.bxs-sleepy:before {\n  content: \"\\ed26\";\n}\n.bxs-slideshow:before {\n  content: \"\\ed27\";\n}\n.bxs-smile:before {\n  content: \"\\ed28\";\n}\n.bxs-sort-alt:before {\n  content: \"\\ed29\";\n}\n.bxs-spa:before {\n  content: \"\\ed2a\";\n}\n.bxs-spreadsheet:before {\n  content: \"\\ed2b\";\n}\n.bxs-square:before {\n  content: \"\\ed2c\";\n}\n.bxs-square-rounded:before {\n  content: \"\\ed2d\";\n}\n.bxs-star:before {\n  content: \"\\ed2e\";\n}\n.bxs-star-half:before {\n  content: \"\\ed2f\";\n}\n.bxs-stopwatch:before {\n  content: \"\\ed30\";\n}\n.bxs-store:before {\n  content: \"\\ed31\";\n}\n.bxs-store-alt:before {\n  content: \"\\ed32\";\n}\n.bxs-sun:before {\n  content: \"\\ed33\";\n}\n.bxs-tag:before {\n  content: \"\\ed34\";\n}\n.bxs-tag-x:before {\n  content: \"\\ed35\";\n}\n.bxs-taxi:before {\n  content: \"\\ed36\";\n}\n.bxs-tennis-ball:before {\n  content: \"\\ed37\";\n}\n.bxs-terminal:before {\n  content: \"\\ed38\";\n}\n.bxs-time:before {\n  content: \"\\ed39\";\n}\n.bxs-time-five:before {\n  content: \"\\ed3a\";\n}\n.bxs-timer:before {\n  content: \"\\ed3b\";\n}\n.bxs-tired:before {\n  content: \"\\ed3c\";\n}\n.bxs-toggle-left:before {\n  content: \"\\ed3d\";\n}\n.bxs-toggle-right:before {\n  content: \"\\ed3e\";\n}\n.bxs-tone:before {\n  content: \"\\ed3f\";\n}\n.bxs-torch:before {\n  content: \"\\ed40\";\n}\n.bxs-to-top:before {\n  content: \"\\ed41\";\n}\n.bxs-traffic:before {\n  content: \"\\ed42\";\n}\n.bxs-traffic-barrier:before {\n  content: \"\\ed43\";\n}\n.bxs-train:before {\n  content: \"\\ed44\";\n}\n.bxs-trash:before {\n  content: \"\\ed45\";\n}\n.bxs-trash-alt:before {\n  content: \"\\ed46\";\n}\n.bxs-tree:before {\n  content: \"\\ed47\";\n}\n.bxs-trophy:before {\n  content: \"\\ed48\";\n}\n.bxs-truck:before {\n  content: \"\\ed49\";\n}\n.bxs-t-shirt:before {\n  content: \"\\ed4a\";\n}\n.bxs-up-arrow:before {\n  content: \"\\ed4b\";\n}\n.bxs-up-arrow-circle:before {\n  content: \"\\ed4c\";\n}\n.bxs-up-arrow-square:before {\n  content: \"\\ed4d\";\n}\n.bxs-upside-down:before {\n  content: \"\\ed4e\";\n}\n.bxs-upvote:before {\n  content: \"\\ed4f\";\n}\n.bxs-user:before {\n  content: \"\\ed50\";\n}\n.bxs-user-badge:before {\n  content: \"\\ed51\";\n}\n.bxs-user-check:before {\n  content: \"\\ed52\";\n}\n.bxs-user-circle:before {\n  content: \"\\ed53\";\n}\n.bxs-user-detail:before {\n  content: \"\\ed54\";\n}\n.bxs-user-minus:before {\n  content: \"\\ed55\";\n}\n.bxs-user-pin:before {\n  content: \"\\ed56\";\n}\n.bxs-user-plus:before {\n  content: \"\\ed57\";\n}\n.bxs-user-rectangle:before {\n  content: \"\\ed58\";\n}\n.bxs-user-voice:before {\n  content: \"\\ed59\";\n}\n.bxs-user-x:before {\n  content: \"\\ed5a\";\n}\n.bxs-vial:before {\n  content: \"\\ed5b\";\n}\n.bxs-video:before {\n  content: \"\\ed5c\";\n}\n.bxs-video-off:before {\n  content: \"\\ed5d\";\n}\n.bxs-video-plus:before {\n  content: \"\\ed5e\";\n}\n.bxs-video-recording:before {\n  content: \"\\ed5f\";\n}\n.bxs-videos:before {\n  content: \"\\ed60\";\n}\n.bxs-volume:before {\n  content: \"\\ed61\";\n}\n.bxs-volume-full:before {\n  content: \"\\ed62\";\n}\n.bxs-volume-low:before {\n  content: \"\\ed63\";\n}\n.bxs-volume-mute:before {\n  content: \"\\ed64\";\n}\n.bxs-wallet:before {\n  content: \"\\ed65\";\n}\n.bxs-wallet-alt:before {\n  content: \"\\ed66\";\n}\n.bxs-watch:before {\n  content: \"\\ed67\";\n}\n.bxs-watch-alt:before {\n  content: \"\\ed68\";\n}\n.bxs-widget:before {\n  content: \"\\ed69\";\n}\n.bxs-wine:before {\n  content: \"\\ed6a\";\n}\n.bxs-wink-smile:before {\n  content: \"\\ed6b\";\n}\n.bxs-wink-tongue:before {\n  content: \"\\ed6c\";\n}\n.bxs-wrench:before {\n  content: \"\\ed6d\";\n}\n.bxs-x-circle:before {\n  content: \"\\ed6e\";\n}\n.bxs-x-square:before {\n  content: \"\\ed6f\";\n}\n.bxs-yin-yang:before {\n  content: \"\\ed70\";\n}\n.bxs-zap:before {\n  content: \"\\ed71\";\n}\n.bxs-zoom-in:before {\n  content: \"\\ed72\";\n}\n.bxs-zoom-out:before {\n  content: \"\\ed73\";\n}\n","/*!\n * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n.fa,\n.fas,\n.far,\n.fal,\n.fad,\n.fab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.fa-500px:before {\n  content: \"\\f26e\"; }\n\n.fa-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.fa-accusoft:before {\n  content: \"\\f369\"; }\n\n.fa-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.fa-ad:before {\n  content: \"\\f641\"; }\n\n.fa-address-book:before {\n  content: \"\\f2b9\"; }\n\n.fa-address-card:before {\n  content: \"\\f2bb\"; }\n\n.fa-adjust:before {\n  content: \"\\f042\"; }\n\n.fa-adn:before {\n  content: \"\\f170\"; }\n\n.fa-adobe:before {\n  content: \"\\f778\"; }\n\n.fa-adversal:before {\n  content: \"\\f36a\"; }\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.fa-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.fa-airbnb:before {\n  content: \"\\f834\"; }\n\n.fa-algolia:before {\n  content: \"\\f36c\"; }\n\n.fa-align-center:before {\n  content: \"\\f037\"; }\n\n.fa-align-justify:before {\n  content: \"\\f039\"; }\n\n.fa-align-left:before {\n  content: \"\\f036\"; }\n\n.fa-align-right:before {\n  content: \"\\f038\"; }\n\n.fa-alipay:before {\n  content: \"\\f642\"; }\n\n.fa-allergies:before {\n  content: \"\\f461\"; }\n\n.fa-amazon:before {\n  content: \"\\f270\"; }\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.fa-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.fa-amilia:before {\n  content: \"\\f36d\"; }\n\n.fa-anchor:before {\n  content: \"\\f13d\"; }\n\n.fa-android:before {\n  content: \"\\f17b\"; }\n\n.fa-angellist:before {\n  content: \"\\f209\"; }\n\n.fa-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.fa-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.fa-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.fa-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.fa-angle-down:before {\n  content: \"\\f107\"; }\n\n.fa-angle-left:before {\n  content: \"\\f104\"; }\n\n.fa-angle-right:before {\n  content: \"\\f105\"; }\n\n.fa-angle-up:before {\n  content: \"\\f106\"; }\n\n.fa-angry:before {\n  content: \"\\f556\"; }\n\n.fa-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.fa-angular:before {\n  content: \"\\f420\"; }\n\n.fa-ankh:before {\n  content: \"\\f644\"; }\n\n.fa-app-store:before {\n  content: \"\\f36f\"; }\n\n.fa-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.fa-apper:before {\n  content: \"\\f371\"; }\n\n.fa-apple:before {\n  content: \"\\f179\"; }\n\n.fa-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.fa-apple-pay:before {\n  content: \"\\f415\"; }\n\n.fa-archive:before {\n  content: \"\\f187\"; }\n\n.fa-archway:before {\n  content: \"\\f557\"; }\n\n.fa-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.fa-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.fa-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.fa-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.fa-arrow-down:before {\n  content: \"\\f063\"; }\n\n.fa-arrow-left:before {\n  content: \"\\f060\"; }\n\n.fa-arrow-right:before {\n  content: \"\\f061\"; }\n\n.fa-arrow-up:before {\n  content: \"\\f062\"; }\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.fa-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.fa-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.fa-artstation:before {\n  content: \"\\f77a\"; }\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.fa-asterisk:before {\n  content: \"\\f069\"; }\n\n.fa-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.fa-at:before {\n  content: \"\\f1fa\"; }\n\n.fa-atlas:before {\n  content: \"\\f558\"; }\n\n.fa-atlassian:before {\n  content: \"\\f77b\"; }\n\n.fa-atom:before {\n  content: \"\\f5d2\"; }\n\n.fa-audible:before {\n  content: \"\\f373\"; }\n\n.fa-audio-description:before {\n  content: \"\\f29e\"; }\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.fa-avianex:before {\n  content: \"\\f374\"; }\n\n.fa-aviato:before {\n  content: \"\\f421\"; }\n\n.fa-award:before {\n  content: \"\\f559\"; }\n\n.fa-aws:before {\n  content: \"\\f375\"; }\n\n.fa-baby:before {\n  content: \"\\f77c\"; }\n\n.fa-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.fa-backspace:before {\n  content: \"\\f55a\"; }\n\n.fa-backward:before {\n  content: \"\\f04a\"; }\n\n.fa-bacon:before {\n  content: \"\\f7e5\"; }\n\n.fa-bahai:before {\n  content: \"\\f666\"; }\n\n.fa-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.fa-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.fa-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.fa-ban:before {\n  content: \"\\f05e\"; }\n\n.fa-band-aid:before {\n  content: \"\\f462\"; }\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.fa-barcode:before {\n  content: \"\\f02a\"; }\n\n.fa-bars:before {\n  content: \"\\f0c9\"; }\n\n.fa-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.fa-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.fa-bath:before {\n  content: \"\\f2cd\"; }\n\n.fa-battery-empty:before {\n  content: \"\\f244\"; }\n\n.fa-battery-full:before {\n  content: \"\\f240\"; }\n\n.fa-battery-half:before {\n  content: \"\\f242\"; }\n\n.fa-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.fa-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.fa-battle-net:before {\n  content: \"\\f835\"; }\n\n.fa-bed:before {\n  content: \"\\f236\"; }\n\n.fa-beer:before {\n  content: \"\\f0fc\"; }\n\n.fa-behance:before {\n  content: \"\\f1b4\"; }\n\n.fa-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.fa-bell:before {\n  content: \"\\f0f3\"; }\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.fa-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.fa-bible:before {\n  content: \"\\f647\"; }\n\n.fa-bicycle:before {\n  content: \"\\f206\"; }\n\n.fa-biking:before {\n  content: \"\\f84a\"; }\n\n.fa-bimobject:before {\n  content: \"\\f378\"; }\n\n.fa-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.fa-biohazard:before {\n  content: \"\\f780\"; }\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.fa-bitbucket:before {\n  content: \"\\f171\"; }\n\n.fa-bitcoin:before {\n  content: \"\\f379\"; }\n\n.fa-bity:before {\n  content: \"\\f37a\"; }\n\n.fa-black-tie:before {\n  content: \"\\f27e\"; }\n\n.fa-blackberry:before {\n  content: \"\\f37b\"; }\n\n.fa-blender:before {\n  content: \"\\f517\"; }\n\n.fa-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.fa-blind:before {\n  content: \"\\f29d\"; }\n\n.fa-blog:before {\n  content: \"\\f781\"; }\n\n.fa-blogger:before {\n  content: \"\\f37c\"; }\n\n.fa-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.fa-bluetooth:before {\n  content: \"\\f293\"; }\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.fa-bold:before {\n  content: \"\\f032\"; }\n\n.fa-bolt:before {\n  content: \"\\f0e7\"; }\n\n.fa-bomb:before {\n  content: \"\\f1e2\"; }\n\n.fa-bone:before {\n  content: \"\\f5d7\"; }\n\n.fa-bong:before {\n  content: \"\\f55c\"; }\n\n.fa-book:before {\n  content: \"\\f02d\"; }\n\n.fa-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.fa-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.fa-book-open:before {\n  content: \"\\f518\"; }\n\n.fa-book-reader:before {\n  content: \"\\f5da\"; }\n\n.fa-bookmark:before {\n  content: \"\\f02e\"; }\n\n.fa-bootstrap:before {\n  content: \"\\f836\"; }\n\n.fa-border-all:before {\n  content: \"\\f84c\"; }\n\n.fa-border-none:before {\n  content: \"\\f850\"; }\n\n.fa-border-style:before {\n  content: \"\\f853\"; }\n\n.fa-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.fa-box:before {\n  content: \"\\f466\"; }\n\n.fa-box-open:before {\n  content: \"\\f49e\"; }\n\n.fa-box-tissue:before {\n  content: \"\\f95b\"; }\n\n.fa-boxes:before {\n  content: \"\\f468\"; }\n\n.fa-braille:before {\n  content: \"\\f2a1\"; }\n\n.fa-brain:before {\n  content: \"\\f5dc\"; }\n\n.fa-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.fa-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.fa-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.fa-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.fa-broom:before {\n  content: \"\\f51a\"; }\n\n.fa-brush:before {\n  content: \"\\f55d\"; }\n\n.fa-btc:before {\n  content: \"\\f15a\"; }\n\n.fa-buffer:before {\n  content: \"\\f837\"; }\n\n.fa-bug:before {\n  content: \"\\f188\"; }\n\n.fa-building:before {\n  content: \"\\f1ad\"; }\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.fa-bullseye:before {\n  content: \"\\f140\"; }\n\n.fa-burn:before {\n  content: \"\\f46a\"; }\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.fa-bus:before {\n  content: \"\\f207\"; }\n\n.fa-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.fa-business-time:before {\n  content: \"\\f64a\"; }\n\n.fa-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.fa-buysellads:before {\n  content: \"\\f20d\"; }\n\n.fa-calculator:before {\n  content: \"\\f1ec\"; }\n\n.fa-calendar:before {\n  content: \"\\f133\"; }\n\n.fa-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.fa-calendar-check:before {\n  content: \"\\f274\"; }\n\n.fa-calendar-day:before {\n  content: \"\\f783\"; }\n\n.fa-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.fa-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.fa-calendar-times:before {\n  content: \"\\f273\"; }\n\n.fa-calendar-week:before {\n  content: \"\\f784\"; }\n\n.fa-camera:before {\n  content: \"\\f030\"; }\n\n.fa-camera-retro:before {\n  content: \"\\f083\"; }\n\n.fa-campground:before {\n  content: \"\\f6bb\"; }\n\n.fa-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.fa-candy-cane:before {\n  content: \"\\f786\"; }\n\n.fa-cannabis:before {\n  content: \"\\f55f\"; }\n\n.fa-capsules:before {\n  content: \"\\f46b\"; }\n\n.fa-car:before {\n  content: \"\\f1b9\"; }\n\n.fa-car-alt:before {\n  content: \"\\f5de\"; }\n\n.fa-car-battery:before {\n  content: \"\\f5df\"; }\n\n.fa-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.fa-car-side:before {\n  content: \"\\f5e4\"; }\n\n.fa-caravan:before {\n  content: \"\\f8ff\"; }\n\n.fa-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.fa-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.fa-caret-right:before {\n  content: \"\\f0da\"; }\n\n.fa-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.fa-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.fa-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.fa-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.fa-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.fa-carrot:before {\n  content: \"\\f787\"; }\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.fa-cart-plus:before {\n  content: \"\\f217\"; }\n\n.fa-cash-register:before {\n  content: \"\\f788\"; }\n\n.fa-cat:before {\n  content: \"\\f6be\"; }\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.fa-centercode:before {\n  content: \"\\f380\"; }\n\n.fa-centos:before {\n  content: \"\\f789\"; }\n\n.fa-certificate:before {\n  content: \"\\f0a3\"; }\n\n.fa-chair:before {\n  content: \"\\f6c0\"; }\n\n.fa-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.fa-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.fa-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.fa-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.fa-chart-bar:before {\n  content: \"\\f080\"; }\n\n.fa-chart-line:before {\n  content: \"\\f201\"; }\n\n.fa-chart-pie:before {\n  content: \"\\f200\"; }\n\n.fa-check:before {\n  content: \"\\f00c\"; }\n\n.fa-check-circle:before {\n  content: \"\\f058\"; }\n\n.fa-check-double:before {\n  content: \"\\f560\"; }\n\n.fa-check-square:before {\n  content: \"\\f14a\"; }\n\n.fa-cheese:before {\n  content: \"\\f7ef\"; }\n\n.fa-chess:before {\n  content: \"\\f439\"; }\n\n.fa-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.fa-chess-board:before {\n  content: \"\\f43c\"; }\n\n.fa-chess-king:before {\n  content: \"\\f43f\"; }\n\n.fa-chess-knight:before {\n  content: \"\\f441\"; }\n\n.fa-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.fa-chess-queen:before {\n  content: \"\\f445\"; }\n\n.fa-chess-rook:before {\n  content: \"\\f447\"; }\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.fa-chevron-down:before {\n  content: \"\\f078\"; }\n\n.fa-chevron-left:before {\n  content: \"\\f053\"; }\n\n.fa-chevron-right:before {\n  content: \"\\f054\"; }\n\n.fa-chevron-up:before {\n  content: \"\\f077\"; }\n\n.fa-child:before {\n  content: \"\\f1ae\"; }\n\n.fa-chrome:before {\n  content: \"\\f268\"; }\n\n.fa-chromecast:before {\n  content: \"\\f838\"; }\n\n.fa-church:before {\n  content: \"\\f51d\"; }\n\n.fa-circle:before {\n  content: \"\\f111\"; }\n\n.fa-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.fa-city:before {\n  content: \"\\f64f\"; }\n\n.fa-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.fa-clipboard:before {\n  content: \"\\f328\"; }\n\n.fa-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.fa-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.fa-clock:before {\n  content: \"\\f017\"; }\n\n.fa-clone:before {\n  content: \"\\f24d\"; }\n\n.fa-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.fa-cloud:before {\n  content: \"\\f0c2\"; }\n\n.fa-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.fa-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.fa-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.fa-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.fa-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.fa-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.fa-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.fa-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.fa-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.fa-cloudscale:before {\n  content: \"\\f383\"; }\n\n.fa-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.fa-cloudversify:before {\n  content: \"\\f385\"; }\n\n.fa-cocktail:before {\n  content: \"\\f561\"; }\n\n.fa-code:before {\n  content: \"\\f121\"; }\n\n.fa-code-branch:before {\n  content: \"\\f126\"; }\n\n.fa-codepen:before {\n  content: \"\\f1cb\"; }\n\n.fa-codiepie:before {\n  content: \"\\f284\"; }\n\n.fa-coffee:before {\n  content: \"\\f0f4\"; }\n\n.fa-cog:before {\n  content: \"\\f013\"; }\n\n.fa-cogs:before {\n  content: \"\\f085\"; }\n\n.fa-coins:before {\n  content: \"\\f51e\"; }\n\n.fa-columns:before {\n  content: \"\\f0db\"; }\n\n.fa-comment:before {\n  content: \"\\f075\"; }\n\n.fa-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.fa-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.fa-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.fa-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.fa-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.fa-comments:before {\n  content: \"\\f086\"; }\n\n.fa-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.fa-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.fa-compass:before {\n  content: \"\\f14e\"; }\n\n.fa-compress:before {\n  content: \"\\f066\"; }\n\n.fa-compress-alt:before {\n  content: \"\\f422\"; }\n\n.fa-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.fa-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.fa-confluence:before {\n  content: \"\\f78d\"; }\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.fa-contao:before {\n  content: \"\\f26d\"; }\n\n.fa-cookie:before {\n  content: \"\\f563\"; }\n\n.fa-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.fa-copy:before {\n  content: \"\\f0c5\"; }\n\n.fa-copyright:before {\n  content: \"\\f1f9\"; }\n\n.fa-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.fa-couch:before {\n  content: \"\\f4b8\"; }\n\n.fa-cpanel:before {\n  content: \"\\f388\"; }\n\n.fa-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.fa-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.fa-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.fa-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.fa-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.fa-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.fa-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.fa-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.fa-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.fa-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.fa-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.fa-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.fa-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.fa-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.fa-credit-card:before {\n  content: \"\\f09d\"; }\n\n.fa-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.fa-crop:before {\n  content: \"\\f125\"; }\n\n.fa-crop-alt:before {\n  content: \"\\f565\"; }\n\n.fa-cross:before {\n  content: \"\\f654\"; }\n\n.fa-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.fa-crow:before {\n  content: \"\\f520\"; }\n\n.fa-crown:before {\n  content: \"\\f521\"; }\n\n.fa-crutch:before {\n  content: \"\\f7f7\"; }\n\n.fa-css3:before {\n  content: \"\\f13c\"; }\n\n.fa-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.fa-cube:before {\n  content: \"\\f1b2\"; }\n\n.fa-cubes:before {\n  content: \"\\f1b3\"; }\n\n.fa-cut:before {\n  content: \"\\f0c4\"; }\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.fa-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.fa-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.fa-dailymotion:before {\n  content: \"\\f952\"; }\n\n.fa-dashcube:before {\n  content: \"\\f210\"; }\n\n.fa-database:before {\n  content: \"\\f1c0\"; }\n\n.fa-deaf:before {\n  content: \"\\f2a4\"; }\n\n.fa-delicious:before {\n  content: \"\\f1a5\"; }\n\n.fa-democrat:before {\n  content: \"\\f747\"; }\n\n.fa-deploydog:before {\n  content: \"\\f38e\"; }\n\n.fa-deskpro:before {\n  content: \"\\f38f\"; }\n\n.fa-desktop:before {\n  content: \"\\f108\"; }\n\n.fa-dev:before {\n  content: \"\\f6cc\"; }\n\n.fa-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.fa-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.fa-dhl:before {\n  content: \"\\f790\"; }\n\n.fa-diagnoses:before {\n  content: \"\\f470\"; }\n\n.fa-diaspora:before {\n  content: \"\\f791\"; }\n\n.fa-dice:before {\n  content: \"\\f522\"; }\n\n.fa-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.fa-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.fa-dice-five:before {\n  content: \"\\f523\"; }\n\n.fa-dice-four:before {\n  content: \"\\f524\"; }\n\n.fa-dice-one:before {\n  content: \"\\f525\"; }\n\n.fa-dice-six:before {\n  content: \"\\f526\"; }\n\n.fa-dice-three:before {\n  content: \"\\f527\"; }\n\n.fa-dice-two:before {\n  content: \"\\f528\"; }\n\n.fa-digg:before {\n  content: \"\\f1a6\"; }\n\n.fa-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.fa-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.fa-directions:before {\n  content: \"\\f5eb\"; }\n\n.fa-discord:before {\n  content: \"\\f392\"; }\n\n.fa-discourse:before {\n  content: \"\\f393\"; }\n\n.fa-disease:before {\n  content: \"\\f7fa\"; }\n\n.fa-divide:before {\n  content: \"\\f529\"; }\n\n.fa-dizzy:before {\n  content: \"\\f567\"; }\n\n.fa-dna:before {\n  content: \"\\f471\"; }\n\n.fa-dochub:before {\n  content: \"\\f394\"; }\n\n.fa-docker:before {\n  content: \"\\f395\"; }\n\n.fa-dog:before {\n  content: \"\\f6d3\"; }\n\n.fa-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.fa-dolly:before {\n  content: \"\\f472\"; }\n\n.fa-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.fa-donate:before {\n  content: \"\\f4b9\"; }\n\n.fa-door-closed:before {\n  content: \"\\f52a\"; }\n\n.fa-door-open:before {\n  content: \"\\f52b\"; }\n\n.fa-dot-circle:before {\n  content: \"\\f192\"; }\n\n.fa-dove:before {\n  content: \"\\f4ba\"; }\n\n.fa-download:before {\n  content: \"\\f019\"; }\n\n.fa-draft2digital:before {\n  content: \"\\f396\"; }\n\n.fa-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.fa-dragon:before {\n  content: \"\\f6d5\"; }\n\n.fa-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.fa-dribbble:before {\n  content: \"\\f17d\"; }\n\n.fa-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.fa-dropbox:before {\n  content: \"\\f16b\"; }\n\n.fa-drum:before {\n  content: \"\\f569\"; }\n\n.fa-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.fa-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.fa-drupal:before {\n  content: \"\\f1a9\"; }\n\n.fa-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.fa-dumpster:before {\n  content: \"\\f793\"; }\n\n.fa-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.fa-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.fa-dyalog:before {\n  content: \"\\f399\"; }\n\n.fa-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.fa-ebay:before {\n  content: \"\\f4f4\"; }\n\n.fa-edge:before {\n  content: \"\\f282\"; }\n\n.fa-edit:before {\n  content: \"\\f044\"; }\n\n.fa-egg:before {\n  content: \"\\f7fb\"; }\n\n.fa-eject:before {\n  content: \"\\f052\"; }\n\n.fa-elementor:before {\n  content: \"\\f430\"; }\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.fa-ello:before {\n  content: \"\\f5f1\"; }\n\n.fa-ember:before {\n  content: \"\\f423\"; }\n\n.fa-empire:before {\n  content: \"\\f1d1\"; }\n\n.fa-envelope:before {\n  content: \"\\f0e0\"; }\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.fa-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.fa-envelope-square:before {\n  content: \"\\f199\"; }\n\n.fa-envira:before {\n  content: \"\\f299\"; }\n\n.fa-equals:before {\n  content: \"\\f52c\"; }\n\n.fa-eraser:before {\n  content: \"\\f12d\"; }\n\n.fa-erlang:before {\n  content: \"\\f39d\"; }\n\n.fa-ethereum:before {\n  content: \"\\f42e\"; }\n\n.fa-ethernet:before {\n  content: \"\\f796\"; }\n\n.fa-etsy:before {\n  content: \"\\f2d7\"; }\n\n.fa-euro-sign:before {\n  content: \"\\f153\"; }\n\n.fa-evernote:before {\n  content: \"\\f839\"; }\n\n.fa-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.fa-exclamation:before {\n  content: \"\\f12a\"; }\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.fa-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.fa-expand:before {\n  content: \"\\f065\"; }\n\n.fa-expand-alt:before {\n  content: \"\\f424\"; }\n\n.fa-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.fa-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.fa-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.fa-eye:before {\n  content: \"\\f06e\"; }\n\n.fa-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.fa-eye-slash:before {\n  content: \"\\f070\"; }\n\n.fa-facebook:before {\n  content: \"\\f09a\"; }\n\n.fa-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.fa-facebook-square:before {\n  content: \"\\f082\"; }\n\n.fa-fan:before {\n  content: \"\\f863\"; }\n\n.fa-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.fa-fast-backward:before {\n  content: \"\\f049\"; }\n\n.fa-fast-forward:before {\n  content: \"\\f050\"; }\n\n.fa-faucet:before {\n  content: \"\\f905\"; }\n\n.fa-fax:before {\n  content: \"\\f1ac\"; }\n\n.fa-feather:before {\n  content: \"\\f52d\"; }\n\n.fa-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.fa-fedex:before {\n  content: \"\\f797\"; }\n\n.fa-fedora:before {\n  content: \"\\f798\"; }\n\n.fa-female:before {\n  content: \"\\f182\"; }\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.fa-figma:before {\n  content: \"\\f799\"; }\n\n.fa-file:before {\n  content: \"\\f15b\"; }\n\n.fa-file-alt:before {\n  content: \"\\f15c\"; }\n\n.fa-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.fa-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.fa-file-code:before {\n  content: \"\\f1c9\"; }\n\n.fa-file-contract:before {\n  content: \"\\f56c\"; }\n\n.fa-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.fa-file-download:before {\n  content: \"\\f56d\"; }\n\n.fa-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.fa-file-export:before {\n  content: \"\\f56e\"; }\n\n.fa-file-image:before {\n  content: \"\\f1c5\"; }\n\n.fa-file-import:before {\n  content: \"\\f56f\"; }\n\n.fa-file-invoice:before {\n  content: \"\\f570\"; }\n\n.fa-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.fa-file-medical:before {\n  content: \"\\f477\"; }\n\n.fa-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.fa-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.fa-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.fa-file-prescription:before {\n  content: \"\\f572\"; }\n\n.fa-file-signature:before {\n  content: \"\\f573\"; }\n\n.fa-file-upload:before {\n  content: \"\\f574\"; }\n\n.fa-file-video:before {\n  content: \"\\f1c8\"; }\n\n.fa-file-word:before {\n  content: \"\\f1c2\"; }\n\n.fa-fill:before {\n  content: \"\\f575\"; }\n\n.fa-fill-drip:before {\n  content: \"\\f576\"; }\n\n.fa-film:before {\n  content: \"\\f008\"; }\n\n.fa-filter:before {\n  content: \"\\f0b0\"; }\n\n.fa-fingerprint:before {\n  content: \"\\f577\"; }\n\n.fa-fire:before {\n  content: \"\\f06d\"; }\n\n.fa-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.fa-firefox:before {\n  content: \"\\f269\"; }\n\n.fa-firefox-browser:before {\n  content: \"\\f907\"; }\n\n.fa-first-aid:before {\n  content: \"\\f479\"; }\n\n.fa-first-order:before {\n  content: \"\\f2b0\"; }\n\n.fa-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.fa-fish:before {\n  content: \"\\f578\"; }\n\n.fa-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.fa-flag:before {\n  content: \"\\f024\"; }\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.fa-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.fa-flask:before {\n  content: \"\\f0c3\"; }\n\n.fa-flickr:before {\n  content: \"\\f16e\"; }\n\n.fa-flipboard:before {\n  content: \"\\f44d\"; }\n\n.fa-flushed:before {\n  content: \"\\f579\"; }\n\n.fa-fly:before {\n  content: \"\\f417\"; }\n\n.fa-folder:before {\n  content: \"\\f07b\"; }\n\n.fa-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.fa-folder-open:before {\n  content: \"\\f07c\"; }\n\n.fa-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.fa-font:before {\n  content: \"\\f031\"; }\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.fa-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.fa-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.fa-fonticons:before {\n  content: \"\\f280\"; }\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.fa-football-ball:before {\n  content: \"\\f44e\"; }\n\n.fa-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.fa-forumbee:before {\n  content: \"\\f211\"; }\n\n.fa-forward:before {\n  content: \"\\f04e\"; }\n\n.fa-foursquare:before {\n  content: \"\\f180\"; }\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.fa-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.fa-frog:before {\n  content: \"\\f52e\"; }\n\n.fa-frown:before {\n  content: \"\\f119\"; }\n\n.fa-frown-open:before {\n  content: \"\\f57a\"; }\n\n.fa-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.fa-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.fa-futbol:before {\n  content: \"\\f1e3\"; }\n\n.fa-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.fa-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.fa-gamepad:before {\n  content: \"\\f11b\"; }\n\n.fa-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.fa-gavel:before {\n  content: \"\\f0e3\"; }\n\n.fa-gem:before {\n  content: \"\\f3a5\"; }\n\n.fa-genderless:before {\n  content: \"\\f22d\"; }\n\n.fa-get-pocket:before {\n  content: \"\\f265\"; }\n\n.fa-gg:before {\n  content: \"\\f260\"; }\n\n.fa-gg-circle:before {\n  content: \"\\f261\"; }\n\n.fa-ghost:before {\n  content: \"\\f6e2\"; }\n\n.fa-gift:before {\n  content: \"\\f06b\"; }\n\n.fa-gifts:before {\n  content: \"\\f79c\"; }\n\n.fa-git:before {\n  content: \"\\f1d3\"; }\n\n.fa-git-alt:before {\n  content: \"\\f841\"; }\n\n.fa-git-square:before {\n  content: \"\\f1d2\"; }\n\n.fa-github:before {\n  content: \"\\f09b\"; }\n\n.fa-github-alt:before {\n  content: \"\\f113\"; }\n\n.fa-github-square:before {\n  content: \"\\f092\"; }\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.fa-gitlab:before {\n  content: \"\\f296\"; }\n\n.fa-gitter:before {\n  content: \"\\f426\"; }\n\n.fa-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.fa-glass-martini:before {\n  content: \"\\f000\"; }\n\n.fa-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.fa-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.fa-glasses:before {\n  content: \"\\f530\"; }\n\n.fa-glide:before {\n  content: \"\\f2a5\"; }\n\n.fa-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.fa-globe:before {\n  content: \"\\f0ac\"; }\n\n.fa-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.fa-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.fa-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.fa-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.fa-gofore:before {\n  content: \"\\f3a7\"; }\n\n.fa-golf-ball:before {\n  content: \"\\f450\"; }\n\n.fa-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.fa-google:before {\n  content: \"\\f1a0\"; }\n\n.fa-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.fa-google-play:before {\n  content: \"\\f3ab\"; }\n\n.fa-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.fa-gopuram:before {\n  content: \"\\f664\"; }\n\n.fa-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.fa-gratipay:before {\n  content: \"\\f184\"; }\n\n.fa-grav:before {\n  content: \"\\f2d6\"; }\n\n.fa-greater-than:before {\n  content: \"\\f531\"; }\n\n.fa-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.fa-grimace:before {\n  content: \"\\f57f\"; }\n\n.fa-grin:before {\n  content: \"\\f580\"; }\n\n.fa-grin-alt:before {\n  content: \"\\f581\"; }\n\n.fa-grin-beam:before {\n  content: \"\\f582\"; }\n\n.fa-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.fa-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.fa-grin-squint:before {\n  content: \"\\f585\"; }\n\n.fa-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.fa-grin-stars:before {\n  content: \"\\f587\"; }\n\n.fa-grin-tears:before {\n  content: \"\\f588\"; }\n\n.fa-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.fa-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.fa-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.fa-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.fa-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.fa-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.fa-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.fa-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.fa-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.fa-grunt:before {\n  content: \"\\f3ad\"; }\n\n.fa-guitar:before {\n  content: \"\\f7a6\"; }\n\n.fa-gulp:before {\n  content: \"\\f3ae\"; }\n\n.fa-h-square:before {\n  content: \"\\f0fd\"; }\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.fa-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.fa-hamburger:before {\n  content: \"\\f805\"; }\n\n.fa-hammer:before {\n  content: \"\\f6e3\"; }\n\n.fa-hamsa:before {\n  content: \"\\f665\"; }\n\n.fa-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.fa-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.fa-hand-holding-medical:before {\n  content: \"\\f95c\"; }\n\n.fa-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.fa-hand-holding-water:before {\n  content: \"\\f4c1\"; }\n\n.fa-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.fa-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.fa-hand-paper:before {\n  content: \"\\f256\"; }\n\n.fa-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.fa-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.fa-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.fa-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.fa-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.fa-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.fa-hand-rock:before {\n  content: \"\\f255\"; }\n\n.fa-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.fa-hand-sparkles:before {\n  content: \"\\f95d\"; }\n\n.fa-hand-spock:before {\n  content: \"\\f259\"; }\n\n.fa-hands:before {\n  content: \"\\f4c2\"; }\n\n.fa-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.fa-hands-wash:before {\n  content: \"\\f95e\"; }\n\n.fa-handshake:before {\n  content: \"\\f2b5\"; }\n\n.fa-handshake-alt-slash:before {\n  content: \"\\f95f\"; }\n\n.fa-handshake-slash:before {\n  content: \"\\f960\"; }\n\n.fa-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.fa-hard-hat:before {\n  content: \"\\f807\"; }\n\n.fa-hashtag:before {\n  content: \"\\f292\"; }\n\n.fa-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.fa-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.fa-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.fa-hdd:before {\n  content: \"\\f0a0\"; }\n\n.fa-head-side-cough:before {\n  content: \"\\f961\"; }\n\n.fa-head-side-cough-slash:before {\n  content: \"\\f962\"; }\n\n.fa-head-side-mask:before {\n  content: \"\\f963\"; }\n\n.fa-head-side-virus:before {\n  content: \"\\f964\"; }\n\n.fa-heading:before {\n  content: \"\\f1dc\"; }\n\n.fa-headphones:before {\n  content: \"\\f025\"; }\n\n.fa-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.fa-headset:before {\n  content: \"\\f590\"; }\n\n.fa-heart:before {\n  content: \"\\f004\"; }\n\n.fa-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.fa-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.fa-helicopter:before {\n  content: \"\\f533\"; }\n\n.fa-highlighter:before {\n  content: \"\\f591\"; }\n\n.fa-hiking:before {\n  content: \"\\f6ec\"; }\n\n.fa-hippo:before {\n  content: \"\\f6ed\"; }\n\n.fa-hips:before {\n  content: \"\\f452\"; }\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.fa-history:before {\n  content: \"\\f1da\"; }\n\n.fa-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.fa-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.fa-home:before {\n  content: \"\\f015\"; }\n\n.fa-hooli:before {\n  content: \"\\f427\"; }\n\n.fa-hornbill:before {\n  content: \"\\f592\"; }\n\n.fa-horse:before {\n  content: \"\\f6f0\"; }\n\n.fa-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.fa-hospital:before {\n  content: \"\\f0f8\"; }\n\n.fa-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.fa-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.fa-hospital-user:before {\n  content: \"\\f80d\"; }\n\n.fa-hot-tub:before {\n  content: \"\\f593\"; }\n\n.fa-hotdog:before {\n  content: \"\\f80f\"; }\n\n.fa-hotel:before {\n  content: \"\\f594\"; }\n\n.fa-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.fa-hourglass:before {\n  content: \"\\f254\"; }\n\n.fa-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.fa-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.fa-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.fa-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.fa-house-user:before {\n  content: \"\\f965\"; }\n\n.fa-houzz:before {\n  content: \"\\f27c\"; }\n\n.fa-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.fa-html5:before {\n  content: \"\\f13b\"; }\n\n.fa-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.fa-i-cursor:before {\n  content: \"\\f246\"; }\n\n.fa-ice-cream:before {\n  content: \"\\f810\"; }\n\n.fa-icicles:before {\n  content: \"\\f7ad\"; }\n\n.fa-icons:before {\n  content: \"\\f86d\"; }\n\n.fa-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.fa-id-card:before {\n  content: \"\\f2c2\"; }\n\n.fa-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.fa-ideal:before {\n  content: \"\\f913\"; }\n\n.fa-igloo:before {\n  content: \"\\f7ae\"; }\n\n.fa-image:before {\n  content: \"\\f03e\"; }\n\n.fa-images:before {\n  content: \"\\f302\"; }\n\n.fa-imdb:before {\n  content: \"\\f2d8\"; }\n\n.fa-inbox:before {\n  content: \"\\f01c\"; }\n\n.fa-indent:before {\n  content: \"\\f03c\"; }\n\n.fa-industry:before {\n  content: \"\\f275\"; }\n\n.fa-infinity:before {\n  content: \"\\f534\"; }\n\n.fa-info:before {\n  content: \"\\f129\"; }\n\n.fa-info-circle:before {\n  content: \"\\f05a\"; }\n\n.fa-instagram:before {\n  content: \"\\f16d\"; }\n\n.fa-instagram-square:before {\n  content: \"\\f955\"; }\n\n.fa-intercom:before {\n  content: \"\\f7af\"; }\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.fa-invision:before {\n  content: \"\\f7b0\"; }\n\n.fa-ioxhost:before {\n  content: \"\\f208\"; }\n\n.fa-italic:before {\n  content: \"\\f033\"; }\n\n.fa-itch-io:before {\n  content: \"\\f83a\"; }\n\n.fa-itunes:before {\n  content: \"\\f3b4\"; }\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.fa-java:before {\n  content: \"\\f4e4\"; }\n\n.fa-jedi:before {\n  content: \"\\f669\"; }\n\n.fa-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.fa-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.fa-jira:before {\n  content: \"\\f7b1\"; }\n\n.fa-joget:before {\n  content: \"\\f3b7\"; }\n\n.fa-joint:before {\n  content: \"\\f595\"; }\n\n.fa-joomla:before {\n  content: \"\\f1aa\"; }\n\n.fa-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.fa-js:before {\n  content: \"\\f3b8\"; }\n\n.fa-js-square:before {\n  content: \"\\f3b9\"; }\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.fa-kaaba:before {\n  content: \"\\f66b\"; }\n\n.fa-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.fa-key:before {\n  content: \"\\f084\"; }\n\n.fa-keybase:before {\n  content: \"\\f4f5\"; }\n\n.fa-keyboard:before {\n  content: \"\\f11c\"; }\n\n.fa-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.fa-khanda:before {\n  content: \"\\f66d\"; }\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.fa-kiss:before {\n  content: \"\\f596\"; }\n\n.fa-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.fa-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.fa-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.fa-korvue:before {\n  content: \"\\f42f\"; }\n\n.fa-landmark:before {\n  content: \"\\f66f\"; }\n\n.fa-language:before {\n  content: \"\\f1ab\"; }\n\n.fa-laptop:before {\n  content: \"\\f109\"; }\n\n.fa-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.fa-laptop-house:before {\n  content: \"\\f966\"; }\n\n.fa-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.fa-laravel:before {\n  content: \"\\f3bd\"; }\n\n.fa-lastfm:before {\n  content: \"\\f202\"; }\n\n.fa-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.fa-laugh:before {\n  content: \"\\f599\"; }\n\n.fa-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.fa-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.fa-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.fa-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.fa-leaf:before {\n  content: \"\\f06c\"; }\n\n.fa-leanpub:before {\n  content: \"\\f212\"; }\n\n.fa-lemon:before {\n  content: \"\\f094\"; }\n\n.fa-less:before {\n  content: \"\\f41d\"; }\n\n.fa-less-than:before {\n  content: \"\\f536\"; }\n\n.fa-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.fa-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.fa-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.fa-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.fa-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.fa-line:before {\n  content: \"\\f3c0\"; }\n\n.fa-link:before {\n  content: \"\\f0c1\"; }\n\n.fa-linkedin:before {\n  content: \"\\f08c\"; }\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.fa-linode:before {\n  content: \"\\f2b8\"; }\n\n.fa-linux:before {\n  content: \"\\f17c\"; }\n\n.fa-lira-sign:before {\n  content: \"\\f195\"; }\n\n.fa-list:before {\n  content: \"\\f03a\"; }\n\n.fa-list-alt:before {\n  content: \"\\f022\"; }\n\n.fa-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.fa-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.fa-location-arrow:before {\n  content: \"\\f124\"; }\n\n.fa-lock:before {\n  content: \"\\f023\"; }\n\n.fa-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.fa-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.fa-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.fa-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.fa-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.fa-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.fa-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.fa-lungs:before {\n  content: \"\\f604\"; }\n\n.fa-lungs-virus:before {\n  content: \"\\f967\"; }\n\n.fa-lyft:before {\n  content: \"\\f3c3\"; }\n\n.fa-magento:before {\n  content: \"\\f3c4\"; }\n\n.fa-magic:before {\n  content: \"\\f0d0\"; }\n\n.fa-magnet:before {\n  content: \"\\f076\"; }\n\n.fa-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.fa-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.fa-male:before {\n  content: \"\\f183\"; }\n\n.fa-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.fa-map:before {\n  content: \"\\f279\"; }\n\n.fa-map-marked:before {\n  content: \"\\f59f\"; }\n\n.fa-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.fa-map-marker:before {\n  content: \"\\f041\"; }\n\n.fa-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.fa-map-pin:before {\n  content: \"\\f276\"; }\n\n.fa-map-signs:before {\n  content: \"\\f277\"; }\n\n.fa-markdown:before {\n  content: \"\\f60f\"; }\n\n.fa-marker:before {\n  content: \"\\f5a1\"; }\n\n.fa-mars:before {\n  content: \"\\f222\"; }\n\n.fa-mars-double:before {\n  content: \"\\f227\"; }\n\n.fa-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.fa-mask:before {\n  content: \"\\f6fa\"; }\n\n.fa-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.fa-maxcdn:before {\n  content: \"\\f136\"; }\n\n.fa-mdb:before {\n  content: \"\\f8ca\"; }\n\n.fa-medal:before {\n  content: \"\\f5a2\"; }\n\n.fa-medapps:before {\n  content: \"\\f3c6\"; }\n\n.fa-medium:before {\n  content: \"\\f23a\"; }\n\n.fa-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.fa-medkit:before {\n  content: \"\\f0fa\"; }\n\n.fa-medrt:before {\n  content: \"\\f3c8\"; }\n\n.fa-meetup:before {\n  content: \"\\f2e0\"; }\n\n.fa-megaport:before {\n  content: \"\\f5a3\"; }\n\n.fa-meh:before {\n  content: \"\\f11a\"; }\n\n.fa-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.fa-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.fa-memory:before {\n  content: \"\\f538\"; }\n\n.fa-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.fa-menorah:before {\n  content: \"\\f676\"; }\n\n.fa-mercury:before {\n  content: \"\\f223\"; }\n\n.fa-meteor:before {\n  content: \"\\f753\"; }\n\n.fa-microblog:before {\n  content: \"\\f91a\"; }\n\n.fa-microchip:before {\n  content: \"\\f2db\"; }\n\n.fa-microphone:before {\n  content: \"\\f130\"; }\n\n.fa-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.fa-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.fa-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.fa-microscope:before {\n  content: \"\\f610\"; }\n\n.fa-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.fa-minus:before {\n  content: \"\\f068\"; }\n\n.fa-minus-circle:before {\n  content: \"\\f056\"; }\n\n.fa-minus-square:before {\n  content: \"\\f146\"; }\n\n.fa-mitten:before {\n  content: \"\\f7b5\"; }\n\n.fa-mix:before {\n  content: \"\\f3cb\"; }\n\n.fa-mixcloud:before {\n  content: \"\\f289\"; }\n\n.fa-mixer:before {\n  content: \"\\f956\"; }\n\n.fa-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.fa-mobile:before {\n  content: \"\\f10b\"; }\n\n.fa-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.fa-modx:before {\n  content: \"\\f285\"; }\n\n.fa-monero:before {\n  content: \"\\f3d0\"; }\n\n.fa-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.fa-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.fa-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.fa-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.fa-money-check:before {\n  content: \"\\f53c\"; }\n\n.fa-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.fa-monument:before {\n  content: \"\\f5a6\"; }\n\n.fa-moon:before {\n  content: \"\\f186\"; }\n\n.fa-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.fa-mosque:before {\n  content: \"\\f678\"; }\n\n.fa-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.fa-mountain:before {\n  content: \"\\f6fc\"; }\n\n.fa-mouse:before {\n  content: \"\\f8cc\"; }\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.fa-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.fa-music:before {\n  content: \"\\f001\"; }\n\n.fa-napster:before {\n  content: \"\\f3d2\"; }\n\n.fa-neos:before {\n  content: \"\\f612\"; }\n\n.fa-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.fa-neuter:before {\n  content: \"\\f22c\"; }\n\n.fa-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.fa-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.fa-node:before {\n  content: \"\\f419\"; }\n\n.fa-node-js:before {\n  content: \"\\f3d3\"; }\n\n.fa-not-equal:before {\n  content: \"\\f53e\"; }\n\n.fa-notes-medical:before {\n  content: \"\\f481\"; }\n\n.fa-npm:before {\n  content: \"\\f3d4\"; }\n\n.fa-ns8:before {\n  content: \"\\f3d5\"; }\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.fa-object-group:before {\n  content: \"\\f247\"; }\n\n.fa-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.fa-oil-can:before {\n  content: \"\\f613\"; }\n\n.fa-old-republic:before {\n  content: \"\\f510\"; }\n\n.fa-om:before {\n  content: \"\\f679\"; }\n\n.fa-opencart:before {\n  content: \"\\f23d\"; }\n\n.fa-openid:before {\n  content: \"\\f19b\"; }\n\n.fa-opera:before {\n  content: \"\\f26a\"; }\n\n.fa-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.fa-orcid:before {\n  content: \"\\f8d2\"; }\n\n.fa-osi:before {\n  content: \"\\f41a\"; }\n\n.fa-otter:before {\n  content: \"\\f700\"; }\n\n.fa-outdent:before {\n  content: \"\\f03b\"; }\n\n.fa-page4:before {\n  content: \"\\f3d7\"; }\n\n.fa-pagelines:before {\n  content: \"\\f18c\"; }\n\n.fa-pager:before {\n  content: \"\\f815\"; }\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.fa-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.fa-palette:before {\n  content: \"\\f53f\"; }\n\n.fa-palfed:before {\n  content: \"\\f3d8\"; }\n\n.fa-pallet:before {\n  content: \"\\f482\"; }\n\n.fa-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.fa-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.fa-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.fa-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.fa-parking:before {\n  content: \"\\f540\"; }\n\n.fa-passport:before {\n  content: \"\\f5ab\"; }\n\n.fa-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.fa-paste:before {\n  content: \"\\f0ea\"; }\n\n.fa-patreon:before {\n  content: \"\\f3d9\"; }\n\n.fa-pause:before {\n  content: \"\\f04c\"; }\n\n.fa-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.fa-paw:before {\n  content: \"\\f1b0\"; }\n\n.fa-paypal:before {\n  content: \"\\f1ed\"; }\n\n.fa-peace:before {\n  content: \"\\f67c\"; }\n\n.fa-pen:before {\n  content: \"\\f304\"; }\n\n.fa-pen-alt:before {\n  content: \"\\f305\"; }\n\n.fa-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.fa-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.fa-pen-square:before {\n  content: \"\\f14b\"; }\n\n.fa-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.fa-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.fa-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.fa-people-arrows:before {\n  content: \"\\f968\"; }\n\n.fa-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.fa-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.fa-percent:before {\n  content: \"\\f295\"; }\n\n.fa-percentage:before {\n  content: \"\\f541\"; }\n\n.fa-periscope:before {\n  content: \"\\f3da\"; }\n\n.fa-person-booth:before {\n  content: \"\\f756\"; }\n\n.fa-phabricator:before {\n  content: \"\\f3db\"; }\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.fa-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.fa-phone:before {\n  content: \"\\f095\"; }\n\n.fa-phone-alt:before {\n  content: \"\\f879\"; }\n\n.fa-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.fa-phone-square:before {\n  content: \"\\f098\"; }\n\n.fa-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.fa-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.fa-photo-video:before {\n  content: \"\\f87c\"; }\n\n.fa-php:before {\n  content: \"\\f457\"; }\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.fa-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.fa-pied-piper-square:before {\n  content: \"\\f91e\"; }\n\n.fa-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.fa-pills:before {\n  content: \"\\f484\"; }\n\n.fa-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.fa-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.fa-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.fa-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.fa-plane:before {\n  content: \"\\f072\"; }\n\n.fa-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.fa-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.fa-plane-slash:before {\n  content: \"\\f969\"; }\n\n.fa-play:before {\n  content: \"\\f04b\"; }\n\n.fa-play-circle:before {\n  content: \"\\f144\"; }\n\n.fa-playstation:before {\n  content: \"\\f3df\"; }\n\n.fa-plug:before {\n  content: \"\\f1e6\"; }\n\n.fa-plus:before {\n  content: \"\\f067\"; }\n\n.fa-plus-circle:before {\n  content: \"\\f055\"; }\n\n.fa-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.fa-podcast:before {\n  content: \"\\f2ce\"; }\n\n.fa-poll:before {\n  content: \"\\f681\"; }\n\n.fa-poll-h:before {\n  content: \"\\f682\"; }\n\n.fa-poo:before {\n  content: \"\\f2fe\"; }\n\n.fa-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.fa-poop:before {\n  content: \"\\f619\"; }\n\n.fa-portrait:before {\n  content: \"\\f3e0\"; }\n\n.fa-pound-sign:before {\n  content: \"\\f154\"; }\n\n.fa-power-off:before {\n  content: \"\\f011\"; }\n\n.fa-pray:before {\n  content: \"\\f683\"; }\n\n.fa-praying-hands:before {\n  content: \"\\f684\"; }\n\n.fa-prescription:before {\n  content: \"\\f5b1\"; }\n\n.fa-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.fa-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.fa-print:before {\n  content: \"\\f02f\"; }\n\n.fa-procedures:before {\n  content: \"\\f487\"; }\n\n.fa-product-hunt:before {\n  content: \"\\f288\"; }\n\n.fa-project-diagram:before {\n  content: \"\\f542\"; }\n\n.fa-pump-medical:before {\n  content: \"\\f96a\"; }\n\n.fa-pump-soap:before {\n  content: \"\\f96b\"; }\n\n.fa-pushed:before {\n  content: \"\\f3e1\"; }\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.fa-python:before {\n  content: \"\\f3e2\"; }\n\n.fa-qq:before {\n  content: \"\\f1d6\"; }\n\n.fa-qrcode:before {\n  content: \"\\f029\"; }\n\n.fa-question:before {\n  content: \"\\f128\"; }\n\n.fa-question-circle:before {\n  content: \"\\f059\"; }\n\n.fa-quidditch:before {\n  content: \"\\f458\"; }\n\n.fa-quinscape:before {\n  content: \"\\f459\"; }\n\n.fa-quora:before {\n  content: \"\\f2c4\"; }\n\n.fa-quote-left:before {\n  content: \"\\f10d\"; }\n\n.fa-quote-right:before {\n  content: \"\\f10e\"; }\n\n.fa-quran:before {\n  content: \"\\f687\"; }\n\n.fa-r-project:before {\n  content: \"\\f4f7\"; }\n\n.fa-radiation:before {\n  content: \"\\f7b9\"; }\n\n.fa-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.fa-rainbow:before {\n  content: \"\\f75b\"; }\n\n.fa-random:before {\n  content: \"\\f074\"; }\n\n.fa-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.fa-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.fa-react:before {\n  content: \"\\f41b\"; }\n\n.fa-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.fa-readme:before {\n  content: \"\\f4d5\"; }\n\n.fa-rebel:before {\n  content: \"\\f1d0\"; }\n\n.fa-receipt:before {\n  content: \"\\f543\"; }\n\n.fa-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.fa-recycle:before {\n  content: \"\\f1b8\"; }\n\n.fa-red-river:before {\n  content: \"\\f3e3\"; }\n\n.fa-reddit:before {\n  content: \"\\f1a1\"; }\n\n.fa-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.fa-redhat:before {\n  content: \"\\f7bc\"; }\n\n.fa-redo:before {\n  content: \"\\f01e\"; }\n\n.fa-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.fa-registered:before {\n  content: \"\\f25d\"; }\n\n.fa-remove-format:before {\n  content: \"\\f87d\"; }\n\n.fa-renren:before {\n  content: \"\\f18b\"; }\n\n.fa-reply:before {\n  content: \"\\f3e5\"; }\n\n.fa-reply-all:before {\n  content: \"\\f122\"; }\n\n.fa-replyd:before {\n  content: \"\\f3e6\"; }\n\n.fa-republican:before {\n  content: \"\\f75e\"; }\n\n.fa-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.fa-resolving:before {\n  content: \"\\f3e7\"; }\n\n.fa-restroom:before {\n  content: \"\\f7bd\"; }\n\n.fa-retweet:before {\n  content: \"\\f079\"; }\n\n.fa-rev:before {\n  content: \"\\f5b2\"; }\n\n.fa-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.fa-ring:before {\n  content: \"\\f70b\"; }\n\n.fa-road:before {\n  content: \"\\f018\"; }\n\n.fa-robot:before {\n  content: \"\\f544\"; }\n\n.fa-rocket:before {\n  content: \"\\f135\"; }\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.fa-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.fa-route:before {\n  content: \"\\f4d7\"; }\n\n.fa-rss:before {\n  content: \"\\f09e\"; }\n\n.fa-rss-square:before {\n  content: \"\\f143\"; }\n\n.fa-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.fa-ruler:before {\n  content: \"\\f545\"; }\n\n.fa-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.fa-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.fa-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.fa-running:before {\n  content: \"\\f70c\"; }\n\n.fa-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.fa-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.fa-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.fa-safari:before {\n  content: \"\\f267\"; }\n\n.fa-salesforce:before {\n  content: \"\\f83b\"; }\n\n.fa-sass:before {\n  content: \"\\f41e\"; }\n\n.fa-satellite:before {\n  content: \"\\f7bf\"; }\n\n.fa-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.fa-save:before {\n  content: \"\\f0c7\"; }\n\n.fa-schlix:before {\n  content: \"\\f3ea\"; }\n\n.fa-school:before {\n  content: \"\\f549\"; }\n\n.fa-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.fa-scribd:before {\n  content: \"\\f28a\"; }\n\n.fa-scroll:before {\n  content: \"\\f70e\"; }\n\n.fa-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.fa-search:before {\n  content: \"\\f002\"; }\n\n.fa-search-dollar:before {\n  content: \"\\f688\"; }\n\n.fa-search-location:before {\n  content: \"\\f689\"; }\n\n.fa-search-minus:before {\n  content: \"\\f010\"; }\n\n.fa-search-plus:before {\n  content: \"\\f00e\"; }\n\n.fa-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.fa-seedling:before {\n  content: \"\\f4d8\"; }\n\n.fa-sellcast:before {\n  content: \"\\f2da\"; }\n\n.fa-sellsy:before {\n  content: \"\\f213\"; }\n\n.fa-server:before {\n  content: \"\\f233\"; }\n\n.fa-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.fa-shapes:before {\n  content: \"\\f61f\"; }\n\n.fa-share:before {\n  content: \"\\f064\"; }\n\n.fa-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.fa-share-square:before {\n  content: \"\\f14d\"; }\n\n.fa-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.fa-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.fa-shield-virus:before {\n  content: \"\\f96c\"; }\n\n.fa-ship:before {\n  content: \"\\f21a\"; }\n\n.fa-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.fa-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.fa-shopify:before {\n  content: \"\\f957\"; }\n\n.fa-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.fa-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.fa-shopware:before {\n  content: \"\\f5b5\"; }\n\n.fa-shower:before {\n  content: \"\\f2cc\"; }\n\n.fa-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.fa-sign:before {\n  content: \"\\f4d9\"; }\n\n.fa-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.fa-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.fa-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.fa-signal:before {\n  content: \"\\f012\"; }\n\n.fa-signature:before {\n  content: \"\\f5b7\"; }\n\n.fa-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.fa-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.fa-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.fa-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.fa-sith:before {\n  content: \"\\f512\"; }\n\n.fa-skating:before {\n  content: \"\\f7c5\"; }\n\n.fa-sketch:before {\n  content: \"\\f7c6\"; }\n\n.fa-skiing:before {\n  content: \"\\f7c9\"; }\n\n.fa-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.fa-skull:before {\n  content: \"\\f54c\"; }\n\n.fa-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.fa-skyatlas:before {\n  content: \"\\f216\"; }\n\n.fa-skype:before {\n  content: \"\\f17e\"; }\n\n.fa-slack:before {\n  content: \"\\f198\"; }\n\n.fa-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.fa-slash:before {\n  content: \"\\f715\"; }\n\n.fa-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.fa-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.fa-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.fa-smile:before {\n  content: \"\\f118\"; }\n\n.fa-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.fa-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.fa-smog:before {\n  content: \"\\f75f\"; }\n\n.fa-smoking:before {\n  content: \"\\f48d\"; }\n\n.fa-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.fa-sms:before {\n  content: \"\\f7cd\"; }\n\n.fa-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.fa-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.fa-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.fa-snowman:before {\n  content: \"\\f7d0\"; }\n\n.fa-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.fa-soap:before {\n  content: \"\\f96e\"; }\n\n.fa-socks:before {\n  content: \"\\f696\"; }\n\n.fa-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.fa-sort:before {\n  content: \"\\f0dc\"; }\n\n.fa-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.fa-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.fa-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.fa-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.fa-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.fa-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.fa-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.fa-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.fa-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.fa-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.fa-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.fa-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.fa-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.fa-sort-up:before {\n  content: \"\\f0de\"; }\n\n.fa-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.fa-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.fa-spa:before {\n  content: \"\\f5bb\"; }\n\n.fa-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.fa-speakap:before {\n  content: \"\\f3f3\"; }\n\n.fa-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.fa-spell-check:before {\n  content: \"\\f891\"; }\n\n.fa-spider:before {\n  content: \"\\f717\"; }\n\n.fa-spinner:before {\n  content: \"\\f110\"; }\n\n.fa-splotch:before {\n  content: \"\\f5bc\"; }\n\n.fa-spotify:before {\n  content: \"\\f1bc\"; }\n\n.fa-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.fa-square:before {\n  content: \"\\f0c8\"; }\n\n.fa-square-full:before {\n  content: \"\\f45c\"; }\n\n.fa-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.fa-squarespace:before {\n  content: \"\\f5be\"; }\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.fa-stackpath:before {\n  content: \"\\f842\"; }\n\n.fa-stamp:before {\n  content: \"\\f5bf\"; }\n\n.fa-star:before {\n  content: \"\\f005\"; }\n\n.fa-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.fa-star-half:before {\n  content: \"\\f089\"; }\n\n.fa-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.fa-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.fa-star-of-life:before {\n  content: \"\\f621\"; }\n\n.fa-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.fa-steam:before {\n  content: \"\\f1b6\"; }\n\n.fa-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.fa-step-backward:before {\n  content: \"\\f048\"; }\n\n.fa-step-forward:before {\n  content: \"\\f051\"; }\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.fa-sticky-note:before {\n  content: \"\\f249\"; }\n\n.fa-stop:before {\n  content: \"\\f04d\"; }\n\n.fa-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.fa-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.fa-stopwatch-20:before {\n  content: \"\\f96f\"; }\n\n.fa-store:before {\n  content: \"\\f54e\"; }\n\n.fa-store-alt:before {\n  content: \"\\f54f\"; }\n\n.fa-store-alt-slash:before {\n  content: \"\\f970\"; }\n\n.fa-store-slash:before {\n  content: \"\\f971\"; }\n\n.fa-strava:before {\n  content: \"\\f428\"; }\n\n.fa-stream:before {\n  content: \"\\f550\"; }\n\n.fa-street-view:before {\n  content: \"\\f21d\"; }\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.fa-stripe:before {\n  content: \"\\f429\"; }\n\n.fa-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.fa-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.fa-subscript:before {\n  content: \"\\f12c\"; }\n\n.fa-subway:before {\n  content: \"\\f239\"; }\n\n.fa-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.fa-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.fa-sun:before {\n  content: \"\\f185\"; }\n\n.fa-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.fa-superscript:before {\n  content: \"\\f12b\"; }\n\n.fa-supple:before {\n  content: \"\\f3f9\"; }\n\n.fa-surprise:before {\n  content: \"\\f5c2\"; }\n\n.fa-suse:before {\n  content: \"\\f7d6\"; }\n\n.fa-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.fa-swift:before {\n  content: \"\\f8e1\"; }\n\n.fa-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.fa-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.fa-symfony:before {\n  content: \"\\f83d\"; }\n\n.fa-synagogue:before {\n  content: \"\\f69b\"; }\n\n.fa-sync:before {\n  content: \"\\f021\"; }\n\n.fa-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.fa-syringe:before {\n  content: \"\\f48e\"; }\n\n.fa-table:before {\n  content: \"\\f0ce\"; }\n\n.fa-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.fa-tablet:before {\n  content: \"\\f10a\"; }\n\n.fa-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.fa-tablets:before {\n  content: \"\\f490\"; }\n\n.fa-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.fa-tag:before {\n  content: \"\\f02b\"; }\n\n.fa-tags:before {\n  content: \"\\f02c\"; }\n\n.fa-tape:before {\n  content: \"\\f4db\"; }\n\n.fa-tasks:before {\n  content: \"\\f0ae\"; }\n\n.fa-taxi:before {\n  content: \"\\f1ba\"; }\n\n.fa-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.fa-teeth:before {\n  content: \"\\f62e\"; }\n\n.fa-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.fa-telegram:before {\n  content: \"\\f2c6\"; }\n\n.fa-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.fa-temperature-high:before {\n  content: \"\\f769\"; }\n\n.fa-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.fa-tenge:before {\n  content: \"\\f7d7\"; }\n\n.fa-terminal:before {\n  content: \"\\f120\"; }\n\n.fa-text-height:before {\n  content: \"\\f034\"; }\n\n.fa-text-width:before {\n  content: \"\\f035\"; }\n\n.fa-th:before {\n  content: \"\\f00a\"; }\n\n.fa-th-large:before {\n  content: \"\\f009\"; }\n\n.fa-th-list:before {\n  content: \"\\f00b\"; }\n\n.fa-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.fa-theater-masks:before {\n  content: \"\\f630\"; }\n\n.fa-themeco:before {\n  content: \"\\f5c6\"; }\n\n.fa-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.fa-thermometer:before {\n  content: \"\\f491\"; }\n\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.fa-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.fa-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.fa-think-peaks:before {\n  content: \"\\f731\"; }\n\n.fa-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.fa-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.fa-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.fa-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.fa-times:before {\n  content: \"\\f00d\"; }\n\n.fa-times-circle:before {\n  content: \"\\f057\"; }\n\n.fa-tint:before {\n  content: \"\\f043\"; }\n\n.fa-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.fa-tired:before {\n  content: \"\\f5c8\"; }\n\n.fa-toggle-off:before {\n  content: \"\\f204\"; }\n\n.fa-toggle-on:before {\n  content: \"\\f205\"; }\n\n.fa-toilet:before {\n  content: \"\\f7d8\"; }\n\n.fa-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.fa-toilet-paper-slash:before {\n  content: \"\\f972\"; }\n\n.fa-toolbox:before {\n  content: \"\\f552\"; }\n\n.fa-tools:before {\n  content: \"\\f7d9\"; }\n\n.fa-tooth:before {\n  content: \"\\f5c9\"; }\n\n.fa-torah:before {\n  content: \"\\f6a0\"; }\n\n.fa-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.fa-tractor:before {\n  content: \"\\f722\"; }\n\n.fa-trade-federation:before {\n  content: \"\\f513\"; }\n\n.fa-trademark:before {\n  content: \"\\f25c\"; }\n\n.fa-traffic-light:before {\n  content: \"\\f637\"; }\n\n.fa-trailer:before {\n  content: \"\\f941\"; }\n\n.fa-train:before {\n  content: \"\\f238\"; }\n\n.fa-tram:before {\n  content: \"\\f7da\"; }\n\n.fa-transgender:before {\n  content: \"\\f224\"; }\n\n.fa-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.fa-trash:before {\n  content: \"\\f1f8\"; }\n\n.fa-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.fa-trash-restore:before {\n  content: \"\\f829\"; }\n\n.fa-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.fa-tree:before {\n  content: \"\\f1bb\"; }\n\n.fa-trello:before {\n  content: \"\\f181\"; }\n\n.fa-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.fa-trophy:before {\n  content: \"\\f091\"; }\n\n.fa-truck:before {\n  content: \"\\f0d1\"; }\n\n.fa-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.fa-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.fa-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.fa-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.fa-tshirt:before {\n  content: \"\\f553\"; }\n\n.fa-tty:before {\n  content: \"\\f1e4\"; }\n\n.fa-tumblr:before {\n  content: \"\\f173\"; }\n\n.fa-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.fa-tv:before {\n  content: \"\\f26c\"; }\n\n.fa-twitch:before {\n  content: \"\\f1e8\"; }\n\n.fa-twitter:before {\n  content: \"\\f099\"; }\n\n.fa-twitter-square:before {\n  content: \"\\f081\"; }\n\n.fa-typo3:before {\n  content: \"\\f42b\"; }\n\n.fa-uber:before {\n  content: \"\\f402\"; }\n\n.fa-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.fa-uikit:before {\n  content: \"\\f403\"; }\n\n.fa-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.fa-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.fa-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.fa-underline:before {\n  content: \"\\f0cd\"; }\n\n.fa-undo:before {\n  content: \"\\f0e2\"; }\n\n.fa-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.fa-uniregistry:before {\n  content: \"\\f404\"; }\n\n.fa-unity:before {\n  content: \"\\f949\"; }\n\n.fa-universal-access:before {\n  content: \"\\f29a\"; }\n\n.fa-university:before {\n  content: \"\\f19c\"; }\n\n.fa-unlink:before {\n  content: \"\\f127\"; }\n\n.fa-unlock:before {\n  content: \"\\f09c\"; }\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.fa-untappd:before {\n  content: \"\\f405\"; }\n\n.fa-upload:before {\n  content: \"\\f093\"; }\n\n.fa-ups:before {\n  content: \"\\f7e0\"; }\n\n.fa-usb:before {\n  content: \"\\f287\"; }\n\n.fa-user:before {\n  content: \"\\f007\"; }\n\n.fa-user-alt:before {\n  content: \"\\f406\"; }\n\n.fa-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.fa-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.fa-user-check:before {\n  content: \"\\f4fc\"; }\n\n.fa-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.fa-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.fa-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.fa-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.fa-user-friends:before {\n  content: \"\\f500\"; }\n\n.fa-user-graduate:before {\n  content: \"\\f501\"; }\n\n.fa-user-injured:before {\n  content: \"\\f728\"; }\n\n.fa-user-lock:before {\n  content: \"\\f502\"; }\n\n.fa-user-md:before {\n  content: \"\\f0f0\"; }\n\n.fa-user-minus:before {\n  content: \"\\f503\"; }\n\n.fa-user-ninja:before {\n  content: \"\\f504\"; }\n\n.fa-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.fa-user-plus:before {\n  content: \"\\f234\"; }\n\n.fa-user-secret:before {\n  content: \"\\f21b\"; }\n\n.fa-user-shield:before {\n  content: \"\\f505\"; }\n\n.fa-user-slash:before {\n  content: \"\\f506\"; }\n\n.fa-user-tag:before {\n  content: \"\\f507\"; }\n\n.fa-user-tie:before {\n  content: \"\\f508\"; }\n\n.fa-user-times:before {\n  content: \"\\f235\"; }\n\n.fa-users:before {\n  content: \"\\f0c0\"; }\n\n.fa-users-cog:before {\n  content: \"\\f509\"; }\n\n.fa-usps:before {\n  content: \"\\f7e1\"; }\n\n.fa-ussunnah:before {\n  content: \"\\f407\"; }\n\n.fa-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.fa-utensils:before {\n  content: \"\\f2e7\"; }\n\n.fa-vaadin:before {\n  content: \"\\f408\"; }\n\n.fa-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.fa-venus:before {\n  content: \"\\f221\"; }\n\n.fa-venus-double:before {\n  content: \"\\f226\"; }\n\n.fa-venus-mars:before {\n  content: \"\\f228\"; }\n\n.fa-viacoin:before {\n  content: \"\\f237\"; }\n\n.fa-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.fa-vial:before {\n  content: \"\\f492\"; }\n\n.fa-vials:before {\n  content: \"\\f493\"; }\n\n.fa-viber:before {\n  content: \"\\f409\"; }\n\n.fa-video:before {\n  content: \"\\f03d\"; }\n\n.fa-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.fa-vihara:before {\n  content: \"\\f6a7\"; }\n\n.fa-vimeo:before {\n  content: \"\\f40a\"; }\n\n.fa-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.fa-vine:before {\n  content: \"\\f1ca\"; }\n\n.fa-virus:before {\n  content: \"\\f974\"; }\n\n.fa-virus-slash:before {\n  content: \"\\f975\"; }\n\n.fa-viruses:before {\n  content: \"\\f976\"; }\n\n.fa-vk:before {\n  content: \"\\f189\"; }\n\n.fa-vnv:before {\n  content: \"\\f40b\"; }\n\n.fa-voicemail:before {\n  content: \"\\f897\"; }\n\n.fa-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.fa-volume-down:before {\n  content: \"\\f027\"; }\n\n.fa-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.fa-volume-off:before {\n  content: \"\\f026\"; }\n\n.fa-volume-up:before {\n  content: \"\\f028\"; }\n\n.fa-vote-yea:before {\n  content: \"\\f772\"; }\n\n.fa-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.fa-vuejs:before {\n  content: \"\\f41f\"; }\n\n.fa-walking:before {\n  content: \"\\f554\"; }\n\n.fa-wallet:before {\n  content: \"\\f555\"; }\n\n.fa-warehouse:before {\n  content: \"\\f494\"; }\n\n.fa-water:before {\n  content: \"\\f773\"; }\n\n.fa-wave-square:before {\n  content: \"\\f83e\"; }\n\n.fa-waze:before {\n  content: \"\\f83f\"; }\n\n.fa-weebly:before {\n  content: \"\\f5cc\"; }\n\n.fa-weibo:before {\n  content: \"\\f18a\"; }\n\n.fa-weight:before {\n  content: \"\\f496\"; }\n\n.fa-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.fa-weixin:before {\n  content: \"\\f1d7\"; }\n\n.fa-whatsapp:before {\n  content: \"\\f232\"; }\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.fa-wheelchair:before {\n  content: \"\\f193\"; }\n\n.fa-whmcs:before {\n  content: \"\\f40d\"; }\n\n.fa-wifi:before {\n  content: \"\\f1eb\"; }\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.fa-wind:before {\n  content: \"\\f72e\"; }\n\n.fa-window-close:before {\n  content: \"\\f410\"; }\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.fa-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.fa-windows:before {\n  content: \"\\f17a\"; }\n\n.fa-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.fa-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.fa-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.fa-wix:before {\n  content: \"\\f5cf\"; }\n\n.fa-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.fa-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.fa-won-sign:before {\n  content: \"\\f159\"; }\n\n.fa-wordpress:before {\n  content: \"\\f19a\"; }\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.fa-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.fa-wpforms:before {\n  content: \"\\f298\"; }\n\n.fa-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.fa-wrench:before {\n  content: \"\\f0ad\"; }\n\n.fa-x-ray:before {\n  content: \"\\f497\"; }\n\n.fa-xbox:before {\n  content: \"\\f412\"; }\n\n.fa-xing:before {\n  content: \"\\f168\"; }\n\n.fa-xing-square:before {\n  content: \"\\f169\"; }\n\n.fa-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.fa-yahoo:before {\n  content: \"\\f19e\"; }\n\n.fa-yammer:before {\n  content: \"\\f840\"; }\n\n.fa-yandex:before {\n  content: \"\\f413\"; }\n\n.fa-yandex-international:before {\n  content: \"\\f414\"; }\n\n.fa-yarn:before {\n  content: \"\\f7e3\"; }\n\n.fa-yelp:before {\n  content: \"\\f1e9\"; }\n\n.fa-yen-sign:before {\n  content: \"\\f157\"; }\n\n.fa-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.fa-yoast:before {\n  content: \"\\f2b1\"; }\n\n.fa-youtube:before {\n  content: \"\\f167\"; }\n\n.fa-youtube-square:before {\n  content: \"\\f431\"; }\n\n.fa-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-brands-400.eot\");\n  src: url(\"../../../../fonts/fa-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-brands-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-brands-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-brands-400.svg#fontawesome\") format(\"svg\"); }\n\n.fab {\n  font-family: 'Font Awesome 5 Brands';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-regular-400.eot\");\n  src: url(\"../../../../fonts/fa-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-regular-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-regular-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-regular-400.svg#fontawesome\") format(\"svg\"); }\n\n.far {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-solid-900.eot\");\n  src: url(\"../../../../fonts/fa-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-solid-900.woff\") format(\"woff\"), url(\"../../../../fonts/fa-solid-900.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-solid-900.svg#fontawesome\") format(\"svg\"); }\n\n.fa,\n.fas {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900; }\n","@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"dripicons-v2\";\n  src:url(\"../../../../fonts/dripicons-v2.eot\");\n  src:url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"dripicons-\"]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dripicons-alarm:before {\n  content: \"\\61\";\n}\n.dripicons-align-center:before {\n  content: \"\\62\";\n}\n.dripicons-align-justify:before {\n  content: \"\\63\";\n}\n.dripicons-align-left:before {\n  content: \"\\64\";\n}\n.dripicons-align-right:before {\n  content: \"\\65\";\n}\n.dripicons-anchor:before {\n  content: \"\\66\";\n}\n.dripicons-archive:before {\n  content: \"\\67\";\n}\n.dripicons-arrow-down:before {\n  content: \"\\68\";\n}\n.dripicons-arrow-left:before {\n  content: \"\\69\";\n}\n.dripicons-arrow-right:before {\n  content: \"\\6a\";\n}\n.dripicons-arrow-thin-down:before {\n  content: \"\\6b\";\n}\n.dripicons-arrow-thin-left:before {\n  content: \"\\6c\";\n}\n.dripicons-arrow-thin-right:before {\n  content: \"\\6d\";\n}\n.dripicons-arrow-thin-up:before {\n  content: \"\\6e\";\n}\n.dripicons-arrow-up:before {\n  content: \"\\6f\";\n}\n.dripicons-article:before {\n  content: \"\\70\";\n}\n.dripicons-backspace:before {\n  content: \"\\71\";\n}\n.dripicons-basket:before {\n  content: \"\\72\";\n}\n.dripicons-basketball:before {\n  content: \"\\73\";\n}\n.dripicons-battery-empty:before {\n  content: \"\\74\";\n}\n.dripicons-battery-full:before {\n  content: \"\\75\";\n}\n.dripicons-battery-low:before {\n  content: \"\\76\";\n}\n.dripicons-battery-medium:before {\n  content: \"\\77\";\n}\n.dripicons-bell:before {\n  content: \"\\78\";\n}\n.dripicons-blog:before {\n  content: \"\\79\";\n}\n.dripicons-bluetooth:before {\n  content: \"\\7a\";\n}\n.dripicons-bold:before {\n  content: \"\\41\";\n}\n.dripicons-bookmark:before {\n  content: \"\\42\";\n}\n.dripicons-bookmarks:before {\n  content: \"\\43\";\n}\n.dripicons-box:before {\n  content: \"\\44\";\n}\n.dripicons-briefcase:before {\n  content: \"\\45\";\n}\n.dripicons-brightness-low:before {\n  content: \"\\46\";\n}\n.dripicons-brightness-max:before {\n  content: \"\\47\";\n}\n.dripicons-brightness-medium:before {\n  content: \"\\48\";\n}\n.dripicons-broadcast:before {\n  content: \"\\49\";\n}\n.dripicons-browser:before {\n  content: \"\\4a\";\n}\n.dripicons-browser-upload:before {\n  content: \"\\4b\";\n}\n.dripicons-brush:before {\n  content: \"\\4c\";\n}\n.dripicons-calendar:before {\n  content: \"\\4d\";\n}\n.dripicons-camcorder:before {\n  content: \"\\4e\";\n}\n.dripicons-camera:before {\n  content: \"\\4f\";\n}\n.dripicons-card:before {\n  content: \"\\50\";\n}\n.dripicons-cart:before {\n  content: \"\\51\";\n}\n.dripicons-checklist:before {\n  content: \"\\52\";\n}\n.dripicons-checkmark:before {\n  content: \"\\53\";\n}\n.dripicons-chevron-down:before {\n  content: \"\\54\";\n}\n.dripicons-chevron-left:before {\n  content: \"\\55\";\n}\n.dripicons-chevron-right:before {\n  content: \"\\56\";\n}\n.dripicons-chevron-up:before {\n  content: \"\\57\";\n}\n.dripicons-clipboard:before {\n  content: \"\\58\";\n}\n.dripicons-clock:before {\n  content: \"\\59\";\n}\n.dripicons-clockwise:before {\n  content: \"\\5a\";\n}\n.dripicons-cloud:before {\n  content: \"\\30\";\n}\n.dripicons-cloud-download:before {\n  content: \"\\31\";\n}\n.dripicons-cloud-upload:before {\n  content: \"\\32\";\n}\n.dripicons-code:before {\n  content: \"\\33\";\n}\n.dripicons-contract:before {\n  content: \"\\34\";\n}\n.dripicons-contract-2:before {\n  content: \"\\35\";\n}\n.dripicons-conversation:before {\n  content: \"\\36\";\n}\n.dripicons-copy:before {\n  content: \"\\37\";\n}\n.dripicons-crop:before {\n  content: \"\\38\";\n}\n.dripicons-cross:before {\n  content: \"\\39\";\n}\n.dripicons-crosshair:before {\n  content: \"\\21\";\n}\n.dripicons-cutlery:before {\n  content: \"\\22\";\n}\n.dripicons-device-desktop:before {\n  content: \"\\23\";\n}\n.dripicons-device-mobile:before {\n  content: \"\\24\";\n}\n.dripicons-device-tablet:before {\n  content: \"\\25\";\n}\n.dripicons-direction:before {\n  content: \"\\26\";\n}\n.dripicons-disc:before {\n  content: \"\\27\";\n}\n.dripicons-document:before {\n  content: \"\\28\";\n}\n.dripicons-document-delete:before {\n  content: \"\\29\";\n}\n.dripicons-document-edit:before {\n  content: \"\\2a\";\n}\n.dripicons-document-new:before {\n  content: \"\\2b\";\n}\n.dripicons-document-remove:before {\n  content: \"\\2c\";\n}\n.dripicons-dot:before {\n  content: \"\\2d\";\n}\n.dripicons-dots-2:before {\n  content: \"\\2e\";\n}\n.dripicons-dots-3:before {\n  content: \"\\2f\";\n}\n.dripicons-download:before {\n  content: \"\\3a\";\n}\n.dripicons-duplicate:before {\n  content: \"\\3b\";\n}\n.dripicons-enter:before {\n  content: \"\\3c\";\n}\n.dripicons-exit:before {\n  content: \"\\3d\";\n}\n.dripicons-expand:before {\n  content: \"\\3e\";\n}\n.dripicons-expand-2:before {\n  content: \"\\3f\";\n}\n.dripicons-experiment:before {\n  content: \"\\40\";\n}\n.dripicons-export:before {\n  content: \"\\5b\";\n}\n.dripicons-feed:before {\n  content: \"\\5d\";\n}\n.dripicons-flag:before {\n  content: \"\\5e\";\n}\n.dripicons-flashlight:before {\n  content: \"\\5f\";\n}\n.dripicons-folder:before {\n  content: \"\\60\";\n}\n.dripicons-folder-open:before {\n  content: \"\\7b\";\n}\n.dripicons-forward:before {\n  content: \"\\7c\";\n}\n.dripicons-gaming:before {\n  content: \"\\7d\";\n}\n.dripicons-gear:before {\n  content: \"\\7e\";\n}\n.dripicons-graduation:before {\n  content: \"\\5c\";\n}\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n","/*\r\nTemplate Name: Skote - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 4.0.0.\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Custom Bootstrap Css File\r\n*/\r\n\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"variables-dark\";\r\n@import \"./node_modules/bootstrap/scss/bootstrap\";\r\n\r\n@import \"custom/components/root\";\r\n@import \"custom/components/reboot\";\r\n@import \"custom/components/badge\";\r\n@import \"custom/components/buttons\";\r\n@import \"custom/components/breadcrumb\";\r\n@import \"custom/components/card\";\r\n@import \"custom/components/dropdown\";\r\n@import \"custom/components/nav\";\r\n@import \"custom/components/table\";\r\n@import \"custom/components/pagination\";\r\n@import \"custom/components/progress\";","// Dark color mode variables\r\n//\r\n// Custom variables for the `[data-bs-theme=\"dark\"]` theme. Use this as a starting point for your own custom color modes by creating a new theme-specific file like `_variables-dark.scss` and adding the variables you need.\r\n\r\n//\r\n// Global colors\r\n//\r\n\r\n// scss-docs-start sass-dark-mode-vars\r\n// scss-docs-start theme-text-dark-variables\r\n$primary-text-emphasis-dark:        tint-color($primary, 40%);\r\n$secondary-text-emphasis-dark:      tint-color($secondary, 40%);\r\n$success-text-emphasis-dark:        tint-color($success, 40%);\r\n$info-text-emphasis-dark:           tint-color($info, 40%);\r\n$warning-text-emphasis-dark:        tint-color($warning, 40%);\r\n$danger-text-emphasis-dark:         tint-color($danger, 40%);\r\n$light-text-emphasis-dark:          $gray-100;\r\n$dark-text-emphasis-dark:           $gray-300;\r\n// scss-docs-end theme-text-dark-variables\r\n\r\n// scss-docs-start theme-bg-subtle-dark-variables\r\n$primary-bg-subtle-dark:            rgba($primary, 0.25);\r\n$secondary-bg-subtle-dark:          rgba($secondary, 0.25);\r\n$success-bg-subtle-dark:            rgba($success, 0.25);\r\n$info-bg-subtle-dark:               rgba($info, 0.25);\r\n$warning-bg-subtle-dark:            rgba($warning, 0.25);\r\n$danger-bg-subtle-dark:             rgba($danger, 0.25);\r\n$light-bg-subtle-dark:              $gray-800;\r\n$dark-bg-subtle-dark:               rgba($dark, 0.25);\r\n// scss-docs-end theme-bg-subtle-dark-variables\r\n\r\n// scss-docs-start theme-border-subtle-dark-variables\r\n$primary-border-subtle-dark:        shade-color($primary, 40%);\r\n$secondary-border-subtle-dark:      shade-color($secondary, 40%);\r\n$success-border-subtle-dark:        shade-color($success, 40%);\r\n$info-border-subtle-dark:           shade-color($info, 40%);\r\n$warning-border-subtle-dark:        shade-color($warning, 40%);\r\n$danger-border-subtle-dark:         shade-color($danger, 40%);\r\n$light-border-subtle-dark:          $gray-700;\r\n$dark-border-subtle-dark:           $gray-800;\r\n// scss-docs-end theme-border-subtle-dark-variables\r\n\r\n$body-color-dark:                   #a6b0cf;\r\n$body-bg-dark:                      #222736;\r\n$body-secondary-color-dark:         #c3cbe4;\r\n$body-secondary-bg-dark:            #2a3042;\r\n$body-tertiary-color-dark:          #f6f6f6;\r\n$body-tertiary-bg-dark:             #32394e;\r\n$body-emphasis-color-dark:          $white;\r\n$border-color-dark:                 #32394e;\r\n$border-color-translucent-dark:     #353d55;\r\n$headings-color-dark:               #f6f6f6;\r\n$link-color-dark:                   $primary;\r\n$link-hover-color-dark:             shift-color($link-color-dark, -$link-shade-percentage);\r\n$code-color-dark:                   $code-color;\r\n\r\n\r\n//\r\n// Forms\r\n//\r\n\r\n$form-select-indicator-color-dark:  $body-color-dark;\r\n$form-select-indicator-dark:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\");\r\n\r\n$form-switch-color-dark:            rgba($white, .25);\r\n$form-switch-bg-image-dark:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\");\r\n\r\n// scss-docs-start form-validation-colors-dark\r\n$form-valid-color-dark:             $green-300;\r\n$form-valid-border-color-dark:      $green-300;\r\n$form-invalid-color-dark:           $red-300;\r\n$form-invalid-border-color-dark:    $red-300;\r\n// scss-docs-end form-validation-colors-dark\r\n\r\n\r\n//\r\n// Accordion\r\n//\r\n\r\n$accordion-icon-color-dark:         $primary-text-emphasis-dark;\r\n$accordion-icon-active-color-dark:  $primary-text-emphasis-dark;\r\n\r\n$accordion-button-icon-dark:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon-dark:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n// scss-docs-end sass-dark-mode-vars\r\n\r\n/* =============================Custom Variables========================== */\r\n\r\n$header-bg-dark:                        #262b3c;\r\n$header-item-color-dark:                #a6b0cf;\r\n\r\n//topbra dark\r\n$header-dark-bg-dark:                   $primary;\r\n$header-dark-item-color-dark:           #e9ecef;\r\n$topbar-search-bg-dark:                 #2a3042;\r\n\r\n// Footer\r\n$footer-bg-dark:                        #262b3c;\r\n$footer-color-dark:                     #a6b0cf;\r\n\r\n// Horizontal nav\r\n$topnav-bg-dark:                        #282e3f;\r\n$menu-item-color-dark:                  #a6b0cf;\r\n$menu-item-active-color-dark:           #556ee6;\r\n\r\n$boxed-body-bg-dark:                    #32394f;\r\n\r\n\r\n// Display\r\n$display-none-dark:                                        block;\r\n$display-block-dark:                                       none;","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.0 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Vertical Sidebar  Light\n$sidebar-bg:                                          #ffffff;\n$sidebar-menu-item-color:                             #545a6d;\n$sidebar-menu-sub-item-color:                         #545a6d;\n$sidebar-menu-item-icon-color:                        #7f8387;\n$sidebar-menu-item-hover-color:                       #383c40;\n$sidebar-menu-item-active-color:                      #556ee6;\n$sidebar-width:                                       250px;\n$sidebar-collapsed-width:                             70px;\n$sidebar-width-sm:                                    160px;\n\n// Vertical Sidebar - Dark\n$sidebar-dark-bg:                                     #2a3042; //2c313a\n$sidebar-dark-menu-item-color:                        #a6b0cf;\n$sidebar-dark-menu-sub-item-color:                    #79829c;\n$sidebar-dark-menu-item-icon-color:                   #6a7187;\n$sidebar-dark-menu-item-hover-color:                  #ffffff;\n$sidebar-dark-menu-item-active-color:                 #ffffff;\n\n// Topbar - Default Light\n$header-height:                                       70px;\n$header-bg:                                           $white;\n$header-item-color:                                   #555b6d;\n\n// Topbar - Dark\n$header-dark-bg:                                      #2a3042;\n$header-dark-item-color:                              #e9ecef;\n\n// Topbar Search\n$topbar-search-bg:                                    #f3f3f9;\n\n// Footer\n$footer-height:                                       60px;\n$footer-bg:                                           #f2f2f5;\n$footer-color:                                        #74788d;\n\n// Horizontal nav\n$topnav-bg:                                           $white;\n\n$menu-item-color:                                     #545a6d;\n$menu-item-active-color:                              #556ee6;\n\n// Right Sidebar\n$rightbar-width:                                      280px;\n\n// Display\n$display-none:                                        none;\n$display-block:                                       block;\n\n// Brand \n$navbar-brand-box-width:                             250px;\n\n// Boxed layout width\n$boxed-layout-width:                                 1300px;\n$boxed-body-bg:                                     #ebebf4;\n\n// apex charts\n$apex-grid-color:                                   var(--#{$prefix}border-color);\n\n// table\n$table-head-bg:                                     $gray-100;\n$table-dark-border-color:                           tint-color($gray-800, 7.5%);\n\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff;\n$gray-100: #f8f9fa;\n$gray-200: #eff2f7;\n$gray-300: #f6f6f6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #74788d;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black:    #000;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #556ee6;\n$indigo:  #564ab1;\n$purple:  #6f42c1;\n$pink:    #e83e8c;\n$red:     #f46a6a;\n$orange:  #f1734f;\n$yellow:  #f1b44c;\n$green:   #34c38f;\n$teal:    #050505;\n$cyan:    #50a5f1;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"black\":      $black,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue;\n$secondary:     $gray-600;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-200;\n$dark:          $gray-800;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"pink\":       $pink,\n    \"light\":      $light,\n    \"dark\":       $dark\n);\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%);\n$secondary-text-emphasis: shade-color($secondary, 60%);\n$success-text-emphasis:   shade-color($success, 60%);\n$info-text-emphasis:      shade-color($info, 60%);\n$warning-text-emphasis:   shade-color($warning, 60%);\n$danger-text-emphasis:    shade-color($danger, 60%);\n$light-text-emphasis:     $gray-700;\n$dark-text-emphasis:      $gray-700;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       rgba($primary, 0.25);\n$secondary-bg-subtle:     rgba($secondary, 0.25);\n$success-bg-subtle:       rgba($success, 0.25);\n$info-bg-subtle:          rgba($info, 0.25);\n$warning-bg-subtle:       rgba($warning, 0.25);\n$danger-bg-subtle:        rgba($danger, 0.25);\n$light-bg-subtle:         mix($gray-100, $white);\n$dark-bg-subtle:          rgba($dark, 0.25);\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%);\n$secondary-border-subtle: tint-color($secondary, 60%);\n$success-border-subtle:   tint-color($success, 60%);\n$info-border-subtle:      tint-color($info, 60%);\n$warning-border-subtle:   tint-color($warning, 60%);\n$danger-border-subtle:    tint-color($danger, 60%);\n$light-border-subtle:     $gray-200;\n$dark-border-subtle:      $gray-500;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-container-classes:    true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n$enable-dark-mode:            true;\n$color-mode-type:             data; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs-; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #f8f8fb;\n$body-color:                $gray-700;\n$body-text-align:           null;\n\n$body-secondary-color:      $gray-600;\n$body-secondary-bg:         $white;\n\n$body-tertiary-color:       rgba($body-color, .5);\n$body-tertiary-bg:          $gray-100;\n\n$body-emphasis-color:       $gray-800;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary;\n$link-decoration:                         none;\n$link-shade-percentage:                   20%;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage);\n$link-hover-decoration:                   underline;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem;\n$icon-link-underline-offset:  .25em;\n$icon-link-icon-size:         1em;\n$icon-link-icon-transition:   .2s ease-in-out transform;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0);\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           24px;\n$grid-row-columns:            6;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * 0.5;\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-style:                solid;\n$border-color:                $gray-200;\n$border-color-translucent:    $gray-400;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .4rem;\n$border-radius-xl:            1rem;\n$border-radius-xxl:           2rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\n$box-shadow:                  0 0.75rem 1.5rem rgba(18,38,63,.03);\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .15rem;\n$focus-ring-opacity:    .25;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity);\n$focus-ring-blur:       0;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      'Poppins', sans-serif;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif);\n$font-family-code:            var(--#{$prefix}font-monospace);\n\n// $font-size-root effects the value of `rem`, which is used for as well font sizes, paddings and margins\n// $font-size-base effects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.8125rem;\n$font-size-sm:                $font-size-base * .875;\n$font-size-lg:                $font-size-base * 1.25;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-medium:          500;\n$font-weight-semibold:        600;\n$font-weight-bold:            600;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                $font-size-base * 2.5;\n$h2-font-size:                $font-size-base * 2;\n$h3-font-size:                $font-size-base * 1.75;\n$h4-font-size:                $font-size-base * 1.5;\n$h5-font-size:                $font-size-base * 1.25;\n$h6-font-size:                $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.2;\n$headings-color:              inherit;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 6rem,\n  2: 5.5rem,\n  3: 4.5rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-family: null;\n$display-font-style:  null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             80%;\n\n$sub-sup-font-size:           .75em;\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color); // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.25;\n$blockquote-footer-color:     var(--#{$prefix}secondary-color);\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    inherit;\n// fusv-disable\n$hr-bg-color:                 null; // Deprecated in v5.2.0\n$hr-height:                   null; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             var(--#{$prefix}border-color); // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width);\n$hr-opacity:                  0.8;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$dt-font-weight:              $font-weight-bold;\n\n$list-inline-padding:         .5rem;\n\n$mark-padding:                .2em;\n$mark-bg:                     #fcf8e3;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .75rem;\n$table-cell-padding-x:        .75rem;\n$table-cell-padding-y-sm:     .3rem;\n$table-cell-padding-x-sm:     .3rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 var(--#{$prefix}body-color);\n$table-bg:                    var(--#{$prefix}secondary-bg);\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     1;\n$table-striped-bg:            rgba(var(--#{$prefix}tertiary-bg-rgb), $table-striped-bg-factor);\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      1;\n$table-active-bg:             rgba(var(--#{$prefix}tertiary-bg-rgb), $table-active-bg-factor);\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       1;\n$table-hover-bg:              rgba(var(--#{$prefix}tertiary-bg-rgb), $table-hover-bg-factor);\n\n$table-border-factor:         .1;\n$table-border-width:          var(--#{$prefix}border-width);\n$table-border-color:          var(--#{$prefix}border-color);\n\n$table-striped-order:         odd;\n$table-striped-columns-order: even;\n$table-group-separator-color: currentcolor;\n\n$table-caption-color:         var(--#{$prefix}secondary-color);\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .47rem;\n$input-btn-padding-x:         .75rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         $focus-ring-width;\n$input-btn-focus-color-opacity: $focus-ring-opacity;\n$input-btn-focus-color:         $focus-ring-color;\n$input-btn-focus-blur:          $focus-ring-blur;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow;\n\n$input-btn-padding-y-sm:      .25rem;\n$input-btn-padding-x-sm:      .5rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      var(--#{$prefix}border-width);\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color);\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        0 0 0 0.15rem rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              var(--#{$prefix}link-color);\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color);\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius);\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm);\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg);\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       var(--#{$prefix}secondary-color);\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              var(--#{$prefix}secondary-bg);\n$input-disabled-color:                  null;\n$input-disabled-bg:                     var(--#{$prefix}body-bg);\n$input-disabled-border-color:           null;\n\n$input-color:                           var(--#{$prefix}emphasis-color);\n$input-border-color:                    var(--#{$prefix}border-color-translucent);\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      $box-shadow-inset;\n\n$input-border-radius:                   var(--#{$prefix}border-radius);\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm);\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg);\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              rgba(var(--#{$prefix}body-color-rgb), 0.2);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color);\n$input-plaintext-color:                 var(--#{$prefix}body-color);\n\n$input-height-border:                   calc(#{$input-border-width} * 2); // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                .125rem;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     $input-bg;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color-translucent);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($gray-600, 0.55);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         rgba($gray-600, 0.55);\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg);\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y;\n$form-select-padding-x:             $input-padding-x;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     1.75rem; // Extra padding to account for the presence of the background-image based indicator\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-color:        null;\n$form-select-disabled-bg:           $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $input-border-radius;\n$form-select-box-shadow:          $box-shadow-inset;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg);\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     $box-shadow-inset;\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color);\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg);\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-height:            1.5em;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-label-disabled-color:    $gray-600;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color;\n$form-valid-border-color:           $form-feedback-valid-color;\n$form-invalid-color:                $form-feedback-invalid-color;\n$form-invalid-border-color:         $form-feedback-invalid-color;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n$zindex-toast:                      1090;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n);\n// scss-docs-end zindex-levels-map\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    var(--#{$prefix}link-color);\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color);\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color);\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color);\n$nav-tabs-border-width:             var(--#{$prefix}border-width);\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius);\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color);\n$nav-tabs-link-active-bg:           var(--#{$prefix}secondary-bg);\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius);\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n\n$nav-underline-gap:                 1rem;\n$nav-underline-border-width:        .125rem;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color);\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * 0.5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * 0.5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65);\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8);\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1);\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3);\n$navbar-light-icon-color:           rgba($body-color, .75);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15);\n$navbar-light-brand-color:          $navbar-light-active-color;\n$navbar-light-brand-hover-color:    $navbar-light-active-color;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n$navbar-dark-brand-color:           $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .5rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    var(--#{$prefix}body-color);\n$dropdown-bg:                       var(--#{$prefix}secondary-bg);\n$dropdown-border-color:             var(--#{$prefix}border-color);\n$dropdown-border-radius:            var(--#{$prefix}border-radius);\n$dropdown-border-width:             0;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width});\n$dropdown-divider-bg:               $dropdown-border-color;\n$dropdown-divider-margin-y:         $spacer * .5;\n$dropdown-box-shadow:               $box-shadow;\n\n$dropdown-link-color:               var(--#{$prefix}body-color);\n$dropdown-link-hover-color:         var(--#{$prefix}emphasis-color);\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-active-color:        var(--#{$prefix}emphasis-color);\n$dropdown-link-active-bg:           var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color);\n\n$dropdown-item-padding-y:           .35rem;\n$dropdown-item-padding-x:           1.5rem;\n\n$dropdown-header-color:             $gray-600;\n$dropdown-header-padding-x: $dropdown-item-padding-x ;\n$dropdown-header-padding-y: $dropdown-padding-y ;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .5rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n\n$pagination-font-size:              $font-size-base ;\n\n$pagination-color:                  var(--#{$prefix}secondary-color);\n$pagination-bg:                     var(--#{$prefix}secondary-bg);\n$pagination-border-radius:          var(--#{$prefix}border-radius);\n$pagination-border-width:           var(--#{$prefix}border-width);\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1); // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color);\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color);\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg);\n$pagination-focus-box-shadow:       $focus-ring-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color);\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg);\n$pagination-hover-border-color:     var(--#{$prefix}border-color); // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $component-active-bg;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color);\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg);\n$pagination-disabled-border-color:  var(--#{$prefix}border-color);\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm);\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg);\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     1.25rem;\n$card-spacer-x:                     1.25rem;\n$card-title-spacer-y:               $spacer * .5;\n$card-title-color:                  var(--#{$prefix}emphasis-color);\n$card-subtitle-color:               null;\n$card-border-width:                 0;\n$card-border-color:                 var(--#{$prefix}border-color);\n$card-border-radius:                var(--#{$prefix}border-radius);\n$card-box-shadow:                   null;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y * .5;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       var(--#{$prefix}tertiary-bg);\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           var(--#{$prefix}secondary-bg);\n$card-img-overlay-padding:          $spacer;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         var(--#{$prefix}body-color);\n$accordion-bg:                            var(--#{$prefix}secondary-bg);\n$accordion-border-width:                  var(--#{$prefix}border-width);\n$accordion-border-color:                  var(--#{$prefix}border-color);\n$accordion-border-radius:                 var(--#{$prefix}border-radius);\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  var(--#{$prefix}body-color);\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg);\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle);\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow;\n\n$accordion-icon-width:                    16px;\n$accordion-icon-color:                    $body-color;\n$accordion-icon-active-color:             $primary-text-emphasis;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(-180deg);\n\n$accordion-button-icon:                   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     var(--#{$prefix}secondary-bg);\n$tooltip-bg:                        var(--#{$prefix}emphasis-color);\n$tooltip-border-radius:             var(--#{$prefix}border-radius);\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .4rem;\n$tooltip-padding-x:                 .7rem;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n// fusv-disable\n$tooltip-arrow-color:               null; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   $line-height-base;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        var(--#{$prefix}secondary-bg);\n$popover-max-width:                 276px;\n$popover-border-width:              var(--#{$prefix}border-width);\n$popover-border-color:              var(--#{$prefix}border-color);\n$popover-border-radius:             var(--#{$prefix}border-radius-lg);\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}); // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2);\n\n$popover-header-font-size:          $font-size-base;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg);\n$popover-header-color:              $headings-color;\n$popover-header-padding-y:          .5rem;\n$popover-header-padding-x:          $spacer;\n\n$popover-body-color:                var(--#{$prefix}body-color);\n$popover-body-padding-y:            $spacer;\n$popover-body-padding-x:            $spacer;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color);\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .25rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            var(--#{$prefix}secondary-bg);\n$toast-border-width:                var(--#{$prefix}border-width);\n$toast-border-color:                var(--#{$prefix}border-color);\n$toast-border-radius:               .25rem;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow-lg);\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                var(--#{$prefix}secondary-color);\n$toast-header-background-color:     var(--#{$prefix}secondary-bg);\n$toast-header-border-color:         $toast-border-color;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   75%;\n$badge-font-weight:                 $font-weight-medium;\n$badge-color:                       $white;\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               var(--#{$prefix}border-radius);\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               1rem;\n\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  var(--#{$prefix}secondary-bg);\n$modal-content-border-color:        var(--#{$prefix}border-color);\n$modal-content-border-width:        var(--#{$prefix}border-width);\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg);\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       $box-shadow-sm;\n$modal-content-box-shadow-sm-up:    $box-shadow;\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n\n$modal-header-border-color:         var(--#{$prefix}border-color);\n$modal-header-border-width:         $modal-content-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:                   .75rem;\n$alert-padding-x:                   1.25rem;\n$alert-margin-bottom:               1rem;\n$alert-border-radius:               var(--#{$prefix}border-radius);\n$alert-link-font-weight:            $font-weight-bold;\n$alert-border-width:                var(--#{$prefix}border-width);\n\n$alert-bg-scale:                    -80%;\n$alert-border-scale:                -70%;\n$alert-color-scale:                 40%;\n\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80%; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70%; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40%; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   .625rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       var(--#{$prefix}tertiary-bg);\n$progress-border-radius:            var(--#{$prefix}border-radius);\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset);\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}emphasis-color);\n$list-group-bg:                     var(--#{$prefix}secondary-bg);\n$list-group-border-color:           var(--#{$prefix}border-color);\n$list-group-border-width:           var(--#{$prefix}border-width);\n$list-group-border-radius:          var(--#{$prefix}border-radius);\n\n$list-group-item-padding-y:         .75rem;\n$list-group-item-padding-x:         1.25rem;\n// fusv-disable\n$list-group-item-bg-scale:          -80%; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40%; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg);\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         var(--#{$prefix}tertiary-color);\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color);\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color);\n\n$list-group-action-active-color:    var(--#{$prefix}body-color);\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg);\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      var(--#{$prefix}body-bg);\n$thumbnail-border-width:            var(--#{$prefix}border-width);\n$thumbnail-border-color:            var(--#{$prefix}border-color);\n$thumbnail-border-radius:           var(--#{$prefix}border-radius);\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm);\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              var(--#{$prefix}secondary-color);\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              .75rem;\n$breadcrumb-padding-x:              1rem;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color);\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color);\n$breadcrumb-divider:                quote(\"/\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-dark-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\");\n$btn-close-focus-shadow:     none;\n$btn-close-opacity:          .5;\n$btn-close-hover-opacity:    .75;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                var(--#{$prefix}secondary-bg);\n$offcanvas-color:                   var(--#{$prefix}body-color);\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         var(--#{$prefix}body-bg);\n$kbd-bg:                            var(--#{$prefix}body-color);\n$nested-kbd-font-weight:            null; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.1 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .04045, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label {\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($link-color), $link-color, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// \r\n// root.scss\r\n//\r\n\r\n//theme-light\r\n:root {\r\n    // Topbar - Default Light\r\n    --#{$prefix}header-bg:                              #{$header-bg}; \r\n    --#{$prefix}header-item-color:                      #{$header-item-color}; \r\n\r\n    // Topbar - Dark\r\n    --#{$prefix}header-dark-bg:                         #{$header-dark-bg}; \r\n    --#{$prefix}header-dark-item-color:                 #{$header-dark-item-color}; \r\n    \r\n    --#{$prefix}topbar-search-bg:                       #{$topbar-search-bg}; \r\n\r\n    // Footer\r\n    --#{$prefix}footer-bg:                              #{$footer-bg}; \r\n    --#{$prefix}footer-color:                           #{$footer-color}; \r\n\r\n    // Horizontal nav\r\n    --#{$prefix}topnav-bg:                              #{$topnav-bg}; \r\n    --#{$prefix}menu-item-color:                        #{$menu-item-color}; \r\n    --#{$prefix}menu-item-active-color:                 #{$menu-item-active-color}; \r\n\r\n    // Boxed layout width\r\n    --#{$prefix}boxed-body-bg:                          #{$boxed-body-bg}; \r\n\r\n    --#{$prefix}display-none:                           #{$display-none};\r\n    --#{$prefix}display-block:                          #{$display-block};\r\n}\r\n\r\n//theme dark\r\n@if $enable-dark-mode {\r\n    @include color-mode(dark, true) { \r\n        // Topbar - Default Light\r\n        --#{$prefix}header-bg:                              #{$header-bg-dark}; \r\n        --#{$prefix}header-item-color:                      #{$header-item-color-dark}; \r\n\r\n        // Topbar - Dark\r\n        --#{$prefix}header-dark-bg:                         #{$header-dark-bg-dark}; \r\n        --#{$prefix}header-dark-item-color:                 #{$header-dark-item-color-dark}; \r\n        --#{$prefix}topbar-search-bg:                       #{$topbar-search-bg-dark}; \r\n\r\n        // Footer\r\n        --#{$prefix}footer-bg:                              #{$footer-bg-dark}; \r\n        --#{$prefix}footer-color:                           #{$footer-color-dark}; \r\n\r\n        // Horizontal nav\r\n        --#{$prefix}topnav-bg:                              #{$topnav-bg-dark}; \r\n        --#{$prefix}menu-item-color:                        #{$menu-item-color-dark}; \r\n        --#{$prefix}menu-item-active-color:                 #{$menu-item-active-color-dark}; \r\n\r\n        // Boxed layout width\r\n        --#{$prefix}boxed-body-bg:                          #{$boxed-body-bg-dark};\r\n\r\n        // component variable\r\n        --#{$prefix}light:                                      #{$body-tertiary-bg-dark};\r\n        --#{$prefix}light-rgb:                                  #{to-rgb($body-tertiary-bg-dark)};\r\n        --#{$prefix}dark:                                       #{$body-tertiary-color-dark};\r\n        --#{$prefix}dark-rgb:                                   #{to-rgb($body-tertiary-color-dark)};\r\n\r\n        --#{$prefix}display-none:                           #{$display-none-dark};\r\n        --#{$prefix}display-block:                          #{$display-block-dark};\r\n\r\n        .btn-light {\r\n            --#{$prefix}btn-color:                                         #{$body-secondary-color-dark};\r\n            --#{$prefix}btn-bg:                                            #{$body-tertiary-bg-dark};\r\n            --#{$prefix}btn-border-color:                                  #{$body-tertiary-bg-dark};\r\n        }\r\n\r\n        .btn-outline-light {\r\n            --#{$prefix}btn-color:                                         #{$body-secondary-color-dark};\r\n            --#{$prefix}btn-border-color:                                  #{$body-tertiary-bg-dark};\r\n        }\r\n\r\n        .btn-light,\r\n        .btn-outline-light {\r\n            --#{$prefix}btn-hover-color:                        #{$body-secondary-color-dark};\r\n            --#{$prefix}btn-hover-bg:                           #{$body-tertiary-bg-dark};\r\n            --#{$prefix}btn-hover-border-color:                 #{$body-tertiary-bg-dark};\r\n            --#{$prefix}btn-active-color:                       #{$body-secondary-color-dark};\r\n            --#{$prefix}btn-active-bg:                          #{$body-tertiary-bg-dark};\r\n            --#{$prefix}btn-active-border-color:                #{$body-tertiary-bg-dark};\r\n            --#{$prefix}btn-focus-shadow-rgb:                   #{to-rgb($body-tertiary-bg-dark)};\r\n        }\r\n\r\n        .btn-dark {\r\n            --#{$prefix}btn-bg:                                 #{$body-color-dark};\r\n            --#{$prefix}btn-border-color:                       #{$body-color-dark};\r\n            --#{$prefix}btn-hover-bg:                           #{$body-color-dark};\r\n        }\r\n\r\n        .btn-outline-dark {\r\n            --#{$prefix}btn-color:                              #{$body-color-dark};\r\n            --#{$prefix}btn-border-color:                       #{$body-color-dark};\r\n        }\r\n\r\n        .dropdown-menu { \r\n            --#{$prefix}dropdown-border-width:                  1px;\r\n        }\r\n\r\n        .table-light {\r\n            --bs-table-color:                                   #a6b0cf;\r\n            --bs-table-bg:                                      #32394e;\r\n            --bs-table-border-color:                            #32394e;\r\n        }\r\n\r\n        .table-dark {\r\n            --bs-table-color:                                   #a6b0cf;\r\n            --bs-table-bg:                                      #32394e;\r\n            --bs-table-border-color:                            #3a425a;\r\n        }\r\n\r\n    }\r\n}","/* =============\r\n   General\r\n============= */\r\n\r\nhtml {\r\n  position: relative;\r\n  min-height: 100%;\r\n}\r\n\r\n// .h1,.h2,.h3,.h4,.h5,.h6,\r\n// h1,h2,h3,h4,h5,h6 {\r\n//   color: $gray-700;\r\n// }\r\n\r\na {\r\n  text-decoration: none !important;\r\n}\r\n\r\nlabel {\r\n  font-weight: 500;\r\n  margin-bottom: $form-label-margin-bottom;\r\n}\r\n\r\n// blockquote\r\n\r\n.blockquote {\r\n  padding: 10px 20px;\r\n  border-left: 4px solid var(--#{$variable-prefix}border-color);\r\n}\r\n\r\n.blockquote-reverse {\r\n  border-left: 0;\r\n  border-right: 4px solid var(--#{$variable-prefix}border-color);\r\n  text-align: right;\r\n}\r\n\r\n// container\r\n\r\n.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl{\r\n  @media (min-width: 1200px){\r\n      max-width: 1140px;\r\n  }\r\n}\r\n\r\n// row\r\n\r\n.row{\r\n  > * {\r\n      position: relative;\r\n  }\r\n}\r\n","// \r\n// _badge.scss\r\n// \r\n\r\n\r\n.badge {\r\n  &[href] {\r\n    &:hover,\r\n    &:focus {\r\n      color: var(--#{$prefix}secondary-bg);\r\n    }\r\n  }\r\n}\r\n\r\n// Soft badge\r\n@mixin badge-variant-soft($bg) {\r\n  color: $bg;\r\n  background-color: rgba($bg, 0.18) !important;\r\n\r\n  &[href] {\r\n    &:hover,\r\n    &:focus {\r\n      color: $bg;\r\n      text-decoration: none;\r\n      background-color: rgba($bg, 0.4);\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .badge {\r\n  &.bg-#{$color} {\r\n    &[href] {\r\n      &:hover,\r\n      &:focus {\r\n        background-color: darken($value, 4%) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.badge{\r\n  &.bg-light{\r\n    color: var(--#{$prefix}body-color);\r\n\r\n    &[href] {\r\n      &:hover,\r\n      &:focus {\r\n        color: var(--#{$prefix}body-color);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.badge-soft-#{$color} {\r\n      @include badge-variant-soft($value);\r\n  }\r\n  \r\n}\r\n\r\n.rounded-pill{\r\n   padding-right: .6em;\r\n    padding-left: .6em;\r\n}\r\n\r\n// Dark badge\r\n\r\n.badge.bg-dark{\r\n  color: var(--#{$prefix}light);\r\n}","//\r\n// _buttons.scss\r\n//\r\n\r\nbutton,\r\na {\r\n    outline: none !important;\r\n}\r\n\r\n.btn-primary {\r\n   background-color: #18293F;\r\n\r\n    &:hover {\r\n        background-color: #31537e;\r\n    }\r\n}\r\n\r\n    // Rounded Buttons\r\n.btn-rounded {\r\n    border-radius: 30px;\r\n}\r\n\r\n.btn {\r\n    &:focus {\r\n        box-shadow: $btn-focus-box-shadow;\r\n    }\r\n}\r\n\r\n// example 1\r\n\r\n.btn-group-example {\r\n    .btn {\r\n        position: relative;\r\n\r\n        &:first-child {\r\n            &::before {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        &:before {\r\n            content: \"OR\";\r\n            position: absolute;\r\n            font-size: 10px;\r\n            width: 24px;\r\n            height: 24px;\r\n            line-height: 24px;\r\n            border-radius: 50%;\r\n            background-color: var(--#{$prefix}secondary-color);\r\n            color: var(--#{$prefix}secondary-bg);\r\n            border: 1px solid var(--#{$prefix}secondary-bg);\r\n            left: -12px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            z-index: 1;\r\n        }\r\n    }\r\n}\r\n\r\n// Example 2\r\n\r\n.btn-label {\r\n    position: relative;\r\n    padding-left: 44px;\r\n    .label-icon {\r\n        position: absolute;\r\n        width: 32px;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        background-color: rgba($white, 0.1);\r\n        border-right: 1px solid rgba($white, 0.1);\r\n        font-size: 16px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    &.btn-light {\r\n        .label-icon {\r\n            background-color: rgba($dark, 0.1);\r\n            border-right: 1px solid rgba($dark, 0.2);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.btn-group-vertical{\r\n    label {\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n\r\n\r\n//\r\n// Soft Buttons\r\n// \r\n\r\n@mixin button-variant-soft($bg) {\r\n    color: $bg;\r\n    background-color: rgba($bg, 0.1);\r\n    border-color: transparent;\r\n    transition: all 0.5s ease;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $white;\r\n        background-color: $bg;\r\n        border-color: transparent;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-soft-#{$color} {\r\n        @include button-variant-soft($value);\r\n    }\r\n}\r\n\r\n.like-btn {\r\n    &.active {\r\n        .bx-heart {\r\n            color: $danger;\r\n            &:before {\r\n                content: \"\\ec8f\";\r\n            }\r\n        }\r\n    }\r\n}","\r\n// \r\n// breadcrumb.scss\r\n//\r\n\r\n\r\n// Breadcrumb item arrow\r\n.breadcrumb-item {\r\n    > a {\r\n        color: var(--#{$prefix}emphasis-color);\r\n    }\r\n    +.breadcrumb-item {\r\n        &::before {\r\n            font-family: \"Material Design Icons\";\r\n        }\r\n    }\r\n}\r\n  ","// \r\n// _card.scss\r\n// \r\n\r\n.card {\r\n  margin-bottom: $grid-gutter-width;\r\n  box-shadow: $box-shadow;\r\n}\r\n\r\n.card-drop {\r\n  color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.card-title {\r\n  font-size: 15px;\r\n  margin: 0 0 7px 0;\r\n  font-weight: $font-weight-semibold;\r\n  color: var(--#{$prefix}emphasis-color);\r\n}\r\n\r\n.card-title-desc {\r\n  color: var(--#{$prefix}secondary-color);\r\n  margin-bottom: 24px;\r\n}","//\n// _dropdown.scss\n//\n\n.dropdown-menu {\n  box-shadow: $box-shadow-lg;\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  margin: 0;\n  position: absolute;\n  z-index: 1000;\n\n  &.show {\n    top: 100% !important;\n  }\n\n}\n\n\n\n.dropdown-menu-end[style] {\n  left: auto !important;\n  right: 0 !important;\n}\n\n.dropdown-menu[data-popper-placement^=\"right\"],\n.dropdown-menu[data-popper-placement^=\"top\"],\n.dropdown-menu[data-popper-placement^=\"left\"] {\n  top: auto !important;\n  animation: none !important;\n}\n\n@keyframes DropDownSlide {\n  100% {\n    transform: translateY(0);\n  }\n  0% {\n    transform: translateY(10px);\n  }\n}\n\n@media (min-width: 600px) {\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n  position: static !important;\n}\n\n.dropdown-megamenu[style] {\n  padding: 20px;\n  left: 20px !important;\n  right: 20px !important;\n}\n\n// Dropdown size\n\n.dropdown-mega-menu-xl {\n  width: 40rem;\n}\n\n.dropdown-mega-menu-lg {\n  width: 26rem;\n}\n\n.dropdown-toggle {\n  &:after {\n    display: none !important;\n  }\n}\n.dropstart {\n  .dropdown-toggle {\n    &:before {\n      display: none !important;\n    }\n  }\n}\n","// \r\n// _nav.scss\r\n// \r\n\r\n.nav-tabs,.nav-pills {\r\n  > li {\r\n      > a {\r\n        color: var(--#{$prefix}emphasis-color);\r\n        font-weight: $font-weight-medium;\r\n      }\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  > a {\r\n    color: var(--#{$prefix}emphasis-color);  \r\n    font-weight: $font-weight-medium;\r\n  }\r\n}\r\n\r\n\r\n.nav-tabs-custom {\r\n  border-bottom: 2px solid var(--#{$prefix}border-color);\r\n\r\n  .nav-item {\r\n    position: relative;\r\n    color: var(--#{$prefix}body-color);\r\n    .nav-link {\r\n      border: none;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        background: $primary;\r\n        height: 2px;\r\n        position: absolute;\r\n        width: 100%;\r\n        left: 0;\r\n        bottom: -1px;\r\n        transition: all 250ms ease 0s;\r\n        transform: scale(0);\r\n      }\r\n\r\n      &.active{\r\n        color: $primary;\r\n        &:after{\r\n          transform: scale(1);\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// vertical nav\r\n\r\n.vertical-nav{\r\n  .nav{\r\n      .nav-link{\r\n          padding: 24px 16px;\r\n          text-align: center;\r\n          margin-bottom: 8px;\r\n          .nav-icon{\r\n              font-size: 24px;\r\n          }\r\n      }\r\n  }\r\n}","// \r\n// _table.scss\r\n// \r\n\r\n.table {\r\n  th {\r\n      font-weight: $font-weight-bold;\r\n  }\r\n}\r\n\r\n.table-dark>:not(:last-child)>:last-child>*{\r\n  border-bottom-color:  $table-dark-border-color;\r\n}\r\n\r\n\r\n.table-bordered {\r\n  border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n.table-nowrap {\r\n  th, td {\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.table>:not(:first-child) {\r\n    border-top: 0;\r\n}\r\n","// \r\n// _pagination.scss\r\n// \r\n\r\n// Pagination rounded (Custom)\r\n.pagination-rounded {\r\n    .page-link {\r\n        border-radius: 30px !important;\r\n        margin: 0 3px !important;\r\n        border: none;\r\n        width: 32px;\r\n        height: 32px;\r\n        padding: 0;\r\n        text-align: center;\r\n        line-height: 32px;\r\n    }\r\n  }","// \r\n// _progress.scss\r\n// \r\n\r\n// Progress height small\r\n.progress-sm {\r\n  height: 5px;\r\n}\r\n\r\n\r\n// Progress height medium\r\n.progress-md {\r\n  height: 8px;\r\n}\r\n\r\n\r\n// Progress height large\r\n.progress-lg {\r\n  height: 12px;\r\n}\r\n\r\n// Progress height Extra large\r\n.progress-xl {\r\n  height: 16px;\r\n}\r\n\r\n.custom-progess{\r\n  position: relative;\r\n  .progress-icon{\r\n      position: absolute;\r\n      top: -12px;\r\n      .avatar-title{\r\n        background: var(--#{$prefix}secondary-bg);\r\n      }\r\n  }\r\n}\r\n\r\n// animated-progess\r\n\r\n.animated-progess{\r\n  position: relative;\r\n  .progress-bar {\r\n    position: relative;\r\n    border-radius: 6px;\r\n    animation: animate-positive 2s;\r\n  }\r\n}\r\n\r\n@keyframes animate-positive {\r\n  0% {\r\n      width: 0;\r\n  }\r\n}\r\n","/*\r\nTemplate Name: Skote - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 4.1.0.\r\nWebsite: https://themesbrand.com/\r\nContact: themesbrand@gmail.com\r\nFile: Main Css File\r\n*/\r\n\r\n//Fonts\r\n@import \"custom/fonts/fonts\";\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"variables-dark\";\r\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\r\n\r\n\r\n// Structure\r\n@import \"custom/structure/general\";\r\n@import \"custom/structure/topbar\";\r\n@import \"custom/structure/page-head\";\r\n@import \"custom/structure/footer\";\r\n@import \"custom/structure/right-sidebar\";\r\n@import \"custom/structure/vertical\";\r\n@import \"custom/structure/horizontal-nav\";\r\n@import \"custom/structure/layouts\";\r\n\r\n// Components\r\n@import \"custom/components/waves\";\r\n@import \"custom/components/avatar\";\r\n@import \"custom/components/accordion\";\r\n@import \"custom/components/helper\";\r\n@import \"custom/components/preloader\";\r\n@import \"custom/components/forms\";\r\n@import \"custom/components/widgets\";\r\n@import \"custom/components/demos\";\r\n@import \"custom/components/print\";\r\n@import \"custom/components/badge\";\r\n\r\n// Plugins\r\n@import \"custom/plugins/custom-scrollbar\";\r\n@import \"custom/plugins/calendar\";\r\n@import \"custom/plugins/calendar-full\";\r\n@import \"custom/plugins/dragula\";\r\n@import \"custom/plugins/session-timeout\";\r\n@import \"custom/plugins/range-slider\";\r\n@import \"custom/plugins/sweatalert2\";\r\n@import \"custom/plugins/rating\";\r\n@import \"custom/plugins/toastr\";\r\n@import \"custom/plugins/parsley\";\r\n@import \"custom/plugins/select2\";\r\n@import \"custom/plugins/icons/fontawesome-all\";\r\n@import \"custom/plugins/switch\";\r\n@import \"custom/plugins/colorpicker\";\r\n@import \"custom/plugins/timepicker\";\r\n@import \"custom/plugins/datepicker\";\r\n@import \"custom/plugins/bootstrap-touchspin\";\r\n@import \"custom/plugins/form-editors\";\r\n@import \"custom/plugins/form-upload\";\r\n@import \"custom/plugins/form-wizard\";\r\n@import \"custom/plugins/datatable\";\r\n@import \"custom/plugins/responsive-table\";\r\n@import \"custom/plugins/table-editable\";\r\n@import \"custom/plugins/apexcharts\";\r\n@import \"custom/plugins/echarts\";\r\n@import \"custom/plugins/flot\";\r\n@import \"custom/plugins/sparkline-chart\";\r\n@import \"custom/plugins/google-map\";\r\n@import \"custom/plugins/vector-maps\";\r\n@import \"custom/plugins/leaflet-maps\";\r\n\r\n\r\n// Pages\r\n@import \"custom/pages/authentication\";\r\n@import \"custom/pages/ecommerce\";\r\n@import \"custom/pages/email\";\r\n@import \"custom/pages/file-manager\";\r\n@import \"custom/pages/chat\";\r\n@import \"custom/pages/projects\";\r\n@import \"custom/pages/contacts\";\r\n@import \"custom/pages/crypto\";\r\n@import \"custom/pages/coming-soon\";\r\n@import \"custom/pages/timeline\";\r\n@import \"custom/pages/extras-pages\";\r\n@import \"custom/pages/jobs\";\r\n","// \r\n// _header.scss\r\n// \r\n\r\n#page-topbar {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: $sidebar-width;\r\n  z-index: 1002;\r\n  background-color: var(--#{$prefix}header-bg);\r\n  box-shadow: $box-shadow;\r\n  @media (max-width: 992.98px) {\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.navbar-header {\r\n    display: flex;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 0 auto;\r\n    height: $header-height;\r\n    padding: 0 calc(#{$grid-gutter-width} * 0.5) 0 0 /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */;\r\n\r\n    .dropdown .show {\r\n        &.header-item {\r\n            background-color: var(--#{$prefix}tertiary-bg);\r\n        }\r\n    }\r\n}\r\n\r\n.navbar-brand-box {\r\n    padding: 0 1.5rem;\r\n    text-align: center;\r\n    width: $navbar-brand-box-width;\r\n}\r\n\r\n.logo {\r\n    line-height: 70px;\r\n\r\n    .logo-sm {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.logo-light {\r\n    display: none;\r\n}\r\n\r\n/* Search */\r\n\r\n.app-search {\r\n    padding: calc(#{$header-height - 38px} * 0.5) 0;\r\n\r\n    .form-control {\r\n        border: none;\r\n        height: 38px;\r\n        padding-left: 40px;\r\n        padding-right: 20px;\r\n        background-color: var(--#{$prefix}topbar-search-bg);\r\n        box-shadow: none;\r\n        border-radius: 30px;\r\n    }\r\n    span {\r\n        position: absolute;\r\n        z-index: 10;\r\n        font-size: 16px;\r\n        line-height: 38px;\r\n        left: 13px;\r\n        top: 0;\r\n        color: var(--#{$prefix}secondary-color);\r\n    }\r\n}\r\n\r\n// Mega menu\r\n\r\n.megamenu-list {\r\n    li{\r\n        position: relative;\r\n        padding: 5px 0px;\r\n        a{\r\n            color: var(--#{$prefix}body-color);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .navbar-brand-box {\r\n        width: auto;\r\n    }\r\n\r\n    .logo {\r\n\r\n        span.logo-lg {\r\n            display: none;\r\n        }\r\n\r\n        span.logo-sm {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n.page-content {\r\n    padding: calc(#{$header-height} + #{$grid-gutter-width}) calc(#{$grid-gutter-width} * 0.75) $footer-height calc(#{$grid-gutter-width} * 0.75);\r\n}\r\n\r\n.header-item {\r\n    height: $header-height;\r\n    box-shadow: none !important;\r\n    color: var(--#{$prefix}header-item-color);\r\n    border: 0;\r\n    border-radius: 0px;\r\n\r\n    &:hover {\r\n        color: var(--#{$prefix}header-item-color);\r\n    }\r\n}\r\n\r\n.header-profile-user {\r\n    height: 36px;\r\n    width: 36px;\r\n    background-color: var(--#{$prefix}tertiary-bg);\r\n    padding: 3px;\r\n}\r\n\r\n.noti-icon {\r\n    i {\r\n        font-size: 22px;\r\n        color: var(--#{$prefix}header-item-color);\r\n    }\r\n\r\n    .badge {\r\n        position: absolute;\r\n        top: 12px;\r\n        right: 4px;\r\n    }\r\n}\r\n\r\n.notification-item {\r\n    .d-flex {\r\n        padding: 0.75rem 1rem;\r\n\r\n        &:hover {\r\n            background-color: var(--#{$prefix}tertiary-bg);\r\n        }\r\n    }\r\n}\r\n\r\n// Dropdown with Icons\r\n.dropdown-icon-item {\r\n    display: block;\r\n    border-radius: 3px;\r\n    line-height: 34px;\r\n    text-align: center;\r\n    padding: 15px 0 9px;\r\n    display: block;\r\n    border: 1px solid transparent;\r\n    color: var(--#{$prefix}secondary-color);\r\n\r\n    img {\r\n        height: 24px;\r\n    }\r\n\r\n    span {\r\n        display: block;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &:hover {\r\n        // background-color: var(--#{$prefix}header-dark-bg);\r\n        border-color: var(--#{$prefix}border-color);\r\n\r\n    }\r\n}\r\n\r\n// Full Screen\r\n.fullscreen-enable {\r\n    [data-bs-toggle=\"fullscreen\"] {\r\n        .bx-fullscreen::before {\r\n            content: \"\\ea3f\";\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-topbar=\"dark\"] {\r\n    #page-topbar { \r\n        background-color: $header-dark-bg;\r\n    }\r\n    .navbar-header {\r\n        .dropdown .show {\r\n            &.header-item {\r\n                background-color: rgba($white, 0.05);\r\n            }\r\n        }\r\n\r\n        .waves-effect .waves-ripple {\r\n            background: rgba($white, 0.4);\r\n        }\r\n    }\r\n\r\n    .header-item {\r\n        color: var(--#{$prefix}header-dark-item-color);\r\n    \r\n        &:hover {\r\n            color: var(--#{$prefix}header-dark-item-color);\r\n        }\r\n    }\r\n\r\n    .header-profile-user {\r\n        background-color: rgba($white, 0.25);\r\n    }\r\n    \r\n    .noti-icon {\r\n        i {\r\n            color: var(--#{$prefix}header-dark-item-color);\r\n        }\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: block;\r\n    }\r\n\r\n    .app-search {\r\n    \r\n        .form-control {\r\n            background-color: rgba(var(--#{$prefix}topbar-search-bg),0.07);\r\n            color: $white;\r\n        }\r\n        span,\r\n        input.form-control::-webkit-input-placeholder {\r\n            color: rgba($white,0.5);\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-sidebar=\"dark\"] {\r\n    .navbar-brand-box {\r\n        background: $sidebar-dark-bg;\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .navbar-header {\r\n        .dropdown {\r\n            position: static;\r\n\r\n            .dropdown-menu {\r\n                left: 10px !important;\r\n                right: 10px !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n    .navbar-brand-box {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .navbar-brand-box {\r\n        width: auto;\r\n    }\r\n    .page-content {\r\n        margin-top: $header-height;\r\n        padding: calc(55px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} * 0.5) $footer-height calc(#{$grid-gutter-width} * 0.5);\r\n    }    \r\n}\r\n\r\n@media (max-width: 992px) { \r\n    body[data-layout=\"horizontal\"] {\r\n        .page-content {\r\n            margin-top: 15px;\r\n        }    \r\n    }\r\n}","// \r\n// Page-title\r\n// \r\n\r\n.page-title-box {\r\n    padding-bottom: $grid-gutter-width;\r\n\r\n    .breadcrumb {\r\n        background-color: transparent;\r\n        padding: 0;\r\n    }\r\n\r\n    h4 {\r\n        text-transform: uppercase;\r\n        font-weight: 600;\r\n        font-size: 16px !important;\r\n    }\r\n}","// \r\n// _footer.scss\r\n// \r\n\r\n.footer {\r\n    bottom: 0;\r\n    padding: 20px calc(#{$grid-gutter-width} * 0.75);\r\n    position: absolute;\r\n    right: 0;\r\n    color: var(--#{$prefix}footer-color);\r\n    left: 250px;\r\n    height: $footer-height;\r\n    background-color: var(--#{$prefix}footer-bg);\r\n\r\n    @media (max-width: 991.98px) {\r\n        left: 0;\r\n    }\r\n}\r\n  \r\n// Enlarge menu\r\n.vertical-collpsed {\r\n    .footer {\r\n        left: $sidebar-collapsed-width;\r\n\r\n        @media (max-width: 991.98px) {\r\n            left: 0;\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .footer {\r\n        left: 0 !important;\r\n    }  \r\n}","//\r\n// right-sidebar.scss\r\n//\r\n\r\n.right-bar {\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\r\n    display: block;\r\n    position: fixed;\r\n    transition: all 200ms ease-out;\r\n    width: $rightbar-width;\r\n    z-index: 9999;\r\n    float: right !important;\r\n    right: -($rightbar-width + 10px);\r\n    top: 0;\r\n    bottom: 0;\r\n\r\n    .right-bar-toggle {\r\n        background-color: var(--#{$prefix}dark);\r\n        height: 24px;\r\n        width: 24px;\r\n        line-height: 24px;\r\n        display: block;\r\n        color: var(--#{$prefix}gray-200);\r\n        text-align: center;\r\n        border-radius: 50%;\r\n\r\n        &:hover {\r\n            background-color: var(--#{$prefix}dark);\r\n        }\r\n    }\r\n}\r\n\r\n// Rightbar overlay\r\n.rightbar-overlay {\r\n    background-color: rgba($dark, 0.55);\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: none;\r\n    z-index: 9998;\r\n    transition: all .2s ease-out;\r\n}\r\n\r\n.right-bar-enabled {\r\n    .right-bar {\r\n        right: 0;\r\n    }\r\n    .rightbar-overlay {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@include media-breakpoint-down(md) {\r\n    .right-bar {\r\n        overflow: auto;\r\n        .slimscroll-menu {\r\n            height: auto !important;\r\n        }\r\n    }\r\n}","//\r\n// _menu.scss\r\n// \r\n\r\n.metismenu {\r\n    margin: 0;\r\n\r\n    li {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n    .mm-collapse {\r\n        display: none;\r\n\r\n        &:not(.mm-show) {\r\n            display: none;\r\n        }\r\n\r\n        &.mm-show {\r\n            display: block\r\n        }\r\n    }\r\n\r\n    .mm-collapsing {\r\n        position: relative;\r\n        height: 0;\r\n        overflow: hidden;\r\n        transition-timing-function: ease;\r\n        transition-duration: .35s;\r\n        transition-property: height, visibility;\r\n    }\r\n}\r\n\r\n\r\n.vertical-menu {\r\n  width: $sidebar-width;\r\n  z-index: 1001;\r\n  background: $sidebar-bg;\r\n  bottom: 0;\r\n  margin-top: 0;\r\n  position: fixed;\r\n  top: 0;\r\n  padding-top: $header-height;\r\n  box-shadow: $box-shadow;\r\n  @media (max-width: 991.98px) {\r\n    top: $header-height;\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .navbar-brand-box {\r\n    position: fixed;\r\n    top: 0px;\r\n    z-index: 99;\r\n    @media (max-width: 991.98px) {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.main-content {\r\n    margin-left: $sidebar-width;\r\n    overflow: hidden;\r\n\r\n    .content {\r\n        padding: 0 15px 10px 15px;\r\n        margin-top: $header-height;\r\n    }\r\n}\r\n\r\n\r\n#sidebar-menu {\r\n    padding: 10px 0 30px 0;\r\n\r\n    .mm-active {\r\n        >.has-arrow {\r\n            &:after {\r\n                transform: rotate(-180deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .has-arrow {\r\n        &:after {\r\n            content: \"\\F0140\";\r\n            font-family: 'Material Design Icons';\r\n            display: block;\r\n            float: right;\r\n            transition: transform .2s;\r\n            font-size: 1rem;\r\n        }\r\n    }\r\n\r\n    ul {\r\n        li {\r\n            a {\r\n                display: block;\r\n                padding: .625rem 1.5rem;\r\n                color: $sidebar-menu-item-color;\r\n                position: relative;\r\n                font-size: 13px;\r\n                transition: all .4s;\r\n\r\n                i {\r\n                    display: inline-block;\r\n                    min-width: 1.75rem;\r\n                    padding-bottom: .125em;\r\n                    font-size: 1.25rem;\r\n                    line-height: 1.40625rem;\r\n                    vertical-align: middle;\r\n                    color: $sidebar-menu-item-icon-color;\r\n                    transition: all .4s;\r\n                }\r\n\r\n                &:hover {\r\n                    color: $sidebar-menu-item-hover-color;\r\n\r\n                    i {\r\n                        color: $sidebar-menu-item-hover-color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .badge {\r\n                margin-top: 4px;\r\n            }\r\n\r\n            ul.sub-menu {\r\n                padding: 0;\r\n\r\n                li {\r\n\r\n                    a {\r\n                        padding: .4rem 1.5rem .4rem 3.5rem;\r\n                        font-size: 13px;\r\n                        color: $sidebar-menu-sub-item-color;\r\n                        &:hover {\r\n                            color: $sidebar-menu-item-hover-color;\r\n                        }\r\n                    }\r\n\r\n                    ul.sub-menu {\r\n                        padding: 0;\r\n\r\n                        li {\r\n                            a {\r\n                                padding: .4rem 1.5rem .4rem 4.5rem;\r\n                                font-size: 13px;\r\n\r\n                                \r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.menu-title {\r\n    padding: 12px 20px !important;\r\n    letter-spacing: .05em;\r\n    pointer-events: none;\r\n    cursor: default;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    color: $sidebar-menu-item-icon-color;\r\n    font-weight: $font-weight-semibold;\r\n}\r\n\r\n.mm-active {\r\n    color: $sidebar-menu-item-active-color !important;\r\n    > a{\r\n        color: $sidebar-menu-item-active-color !important;\r\n        i {\r\n            color: $sidebar-menu-item-active-color !important;\r\n        }\r\n    }\r\n    .active {\r\n        color: $sidebar-menu-item-active-color !important;\r\n\r\n        i {\r\n            color: $sidebar-menu-item-active-color !important;\r\n        }\r\n    }\r\n    > i {\r\n        color: $sidebar-menu-item-active-color !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .vertical-menu {\r\n        display: none;\r\n    }\r\n\r\n    .main-content {\r\n        margin-left: 0 !important;\r\n    }\r\n\r\n    body.sidebar-enable {\r\n        .vertical-menu {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n// Enlarge menu\r\n.vertical-collpsed {\r\n\r\n    .main-content {\r\n        margin-left: $sidebar-collapsed-width;\r\n    }\r\n\r\n  .navbar-brand-box {\r\n    width: $sidebar-collapsed-width !important;\r\n  }\r\n\r\n  #page-topbar {\r\n    left: $sidebar-collapsed-width;\r\n    @media (max-width: 991.98px) {\r\n      left: 0;\r\n    }\r\n  }\r\n\r\n    .logo {\r\n        span.logo-lg {\r\n            display: none;\r\n        }\r\n\r\n        span.logo-sm {\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    // Side menu\r\n    .vertical-menu {\r\n        position: absolute;\r\n        width: $sidebar-collapsed-width !important;\r\n        z-index: 5;\r\n\r\n        .simplebar-mask,\r\n        .simplebar-content-wrapper {\r\n            overflow: visible !important;\r\n        }\r\n\r\n        .simplebar-scrollbar {\r\n            display: none !important;\r\n        }\r\n\r\n        .simplebar-offset {\r\n            bottom: 0 !important;\r\n        }\r\n\r\n        // Sidebar Menu\r\n        #sidebar-menu {\r\n\r\n            .menu-title,\r\n            .badge,\r\n            .collapse.in {\r\n                display: none !important;\r\n            }\r\n\r\n            .nav.collapse {\r\n                height: inherit !important;\r\n            }\r\n\r\n            .has-arrow {\r\n                &:after {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            > ul {\r\n                > li {\r\n                    position: relative;\r\n                    white-space: nowrap;\r\n\r\n                    > a {\r\n                        padding: 15px 20px;\r\n                        min-height: 55px;\r\n                        transition: none;\r\n                        \r\n                        &:hover,\r\n                        &:active,\r\n                        &:focus {\r\n                            color: $sidebar-menu-item-hover-color;\r\n                        }\r\n\r\n                        i {\r\n                            font-size: 1.45rem;\r\n                            margin-left: 4px;\r\n                        }\r\n\r\n                        span {\r\n                            display: none;\r\n                            padding-left: 25px;\r\n                        }\r\n                    }\r\n\r\n                    &:hover {\r\n                        > a {\r\n                            position: relative;\r\n                            width: calc(190px + #{$sidebar-collapsed-width});\r\n                            color: $primary;\r\n                            background-color: darken($sidebar-bg, 4%);\r\n                            transition: none;\r\n\r\n                            i{\r\n                                color: $primary;\r\n                            }\r\n\r\n                            span {\r\n                                display: inline;\r\n                            }\r\n                        }\r\n\r\n            > ul {\r\n              display: block;\r\n              left: $sidebar-collapsed-width;\r\n              position: absolute;\r\n              width: 190px;\r\n              height: auto !important;\r\n              box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);\r\n\r\n              ul {\r\n                box-shadow: 3px 5px 10px 0 rgba(54, 61, 71, 0.1);\r\n              }\r\n\r\n                            a {\r\n                                box-shadow: none;\r\n                                padding: 8px 20px;\r\n                                position: relative;\r\n                                width: 190px;\r\n                                z-index: 6;\r\n                                color: $sidebar-menu-sub-item-color;\r\n\r\n                                &:hover {\r\n                                    color: $sidebar-menu-item-hover-color;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul {\r\n                    padding: 5px 0;\r\n                    z-index: 9999;\r\n                    display: none;\r\n                    background-color: $sidebar-bg;\r\n\r\n                    li {\r\n                        &:hover {\r\n                            >ul {\r\n                                display: block;\r\n                                left: 190px;\r\n                                height: auto !important;\r\n                                margin-top: -36px;\r\n                                position: absolute;\r\n                                width: 190px;\r\n                            }\r\n                        }\r\n\r\n                        >a {\r\n                            span.pull-right {\r\n                                position: absolute;\r\n                                right: 20px;\r\n                                top: 12px;\r\n                                transform: rotate(270deg);\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    li.active {\r\n                        a {\r\n                            color: $gray-100;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n\r\nbody[data-sidebar=\"dark\"] {\r\n    .vertical-menu {\r\n        background: $sidebar-dark-bg;\r\n    }\r\n\r\n    #sidebar-menu {\r\n    \r\n        ul {\r\n            li {\r\n                a {\r\n                    color: $sidebar-dark-menu-item-color;\r\n\r\n                    i {\r\n                        color: $sidebar-dark-menu-item-icon-color;\r\n                    }\r\n    \r\n                    &:hover {\r\n                        color: $sidebar-dark-menu-item-hover-color;\r\n\r\n                        i {\r\n                            color: $sidebar-dark-menu-item-hover-color;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul.sub-menu {\r\n                    li {\r\n\r\n                        a {\r\n                            color: $sidebar-dark-menu-sub-item-color;\r\n\r\n              &:hover {\r\n                color: $sidebar-dark-menu-item-hover-color;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  // Enlarge menu\r\n  &.vertical-collpsed {\r\n    min-height: 1760px;\r\n\r\n    // Side menu\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background: $sidebar-dark-bg;\r\n      }\r\n      // Sidebar Menu\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover {\r\n              > a {\r\n                background: lighten($sidebar-dark-bg, 2%);\r\n                color: $sidebar-dark-menu-item-hover-color;\r\n                i {\r\n                  color: $sidebar-dark-menu-item-hover-color;\r\n                }\r\n              }\r\n\r\n                            >ul {\r\n                                a{\r\n                                    color: $sidebar-dark-menu-sub-item-color;\r\n                                    &:hover{\r\n                                        color: $sidebar-dark-menu-item-hover-color;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    ul{\r\n                        background-color: $sidebar-dark-bg;\r\n                    }\r\n                    \r\n                }\r\n\r\n                ul{\r\n                    \r\n                    li{\r\n                        &.mm-active .active{\r\n                            color: $sidebar-dark-menu-item-active-color !important;\r\n                            i{\r\n                                color: $sidebar-dark-menu-item-active-color !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n            }\r\n\r\n\r\n        }\r\n    }\r\n    .mm-active {\r\n        color: $sidebar-dark-menu-item-active-color !important;\r\n        > a{\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n            i {\r\n                color: $sidebar-dark-menu-item-active-color !important;\r\n            }\r\n        }\r\n        > i {\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n        }\r\n        .active {\r\n            color: $sidebar-dark-menu-item-active-color !important;\r\n\r\n            i {\r\n                color: $sidebar-dark-menu-item-active-color !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-title {\r\n        color: $sidebar-dark-menu-item-icon-color;\r\n    }\r\n}\r\n\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    .main-content {\r\n        margin-left: 0 !important;\r\n    }\r\n}\r\n\r\n// Compact Sidebar\r\n\r\nbody[data-sidebar-size=\"small\"] {\r\n    .navbar-brand-box{\r\n        width: $sidebar-width-sm;\r\n    }\r\n    .vertical-menu{\r\n        width: $sidebar-width-sm;\r\n        text-align: center;\r\n\r\n        .has-arrow:after,\r\n        .badge {\r\n            display: none !important;\r\n        }\r\n    }\r\n    .main-content {\r\n        margin-left: $sidebar-width-sm;\r\n    }\r\n    .footer {\r\n        left: $sidebar-width-sm;\r\n        @media (max-width: 991.98px) {\r\n            left: 0;\r\n        }\r\n    }\r\n\r\n  #page-topbar {\r\n    left: $sidebar-width-sm;\r\n    @media (max-width: 991.98px) {\r\n      left: 0;\r\n\r\n      .navbar-header {\r\n        .navbar-brand-box {\r\n          width: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  #sidebar-menu {\r\n    ul li {\r\n      a {\r\n        i {\r\n          display: block;\r\n        }\r\n      }\r\n      ul.sub-menu {\r\n        li {\r\n          a {\r\n            padding-left: 1.5rem;\r\n          }\r\n\r\n                    ul.sub-menu li a {\r\n                        padding-left: 1.5rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.vertical-collpsed {\r\n        .main-content {\r\n            margin-left: $sidebar-collapsed-width;\r\n        }\r\n        .vertical-menu {\r\n            #sidebar-menu{\r\n                text-align: left;\r\n                >ul{\r\n                    >li{\r\n                        >a {\r\n                            i{\r\n                                display: inline-block;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .footer {\r\n            left: $sidebar-collapsed-width;\r\n        }\r\n    }\r\n}\r\n\r\n// colored sidebar\r\n\r\nbody[data-sidebar=\"colored\"],\r\nbody[data-sidebar=\"winter\"],\r\nbody[data-sidebar=\"ladylip\"],\r\nbody[data-sidebar=\"plumplate\"],\r\nbody[data-sidebar=\"strongbliss\"],\r\nbody[data-sidebar=\"greatwhale\"] {\r\n  .navbar-brand-box {\r\n    .logo-dark {\r\n      display: none;\r\n    }\r\n    .logo-light {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .mm-active {\r\n    color: $white !important;\r\n    > a {\r\n      color: $white !important;\r\n      i {\r\n        color: $white !important;\r\n      }\r\n    }\r\n    > i,\r\n    .active {\r\n      color: $white !important;\r\n    }\r\n  }\r\n\r\n    #sidebar-menu {\r\n        ul {\r\n            li {\r\n                &.menu-title{\r\n                    color: rgba($white, 0.6);\r\n                }\r\n\r\n                a{\r\n                    color: rgba($white, 0.6);\r\n                    i{\r\n                        color: rgba($white, 0.6);\r\n                    }\r\n                    &.waves-effect {\r\n                        .waves-ripple {\r\n                          background: rgba($white, 0.1);\r\n                        }\r\n                    }\r\n\r\n                    &:hover {\r\n                        color: $white;\r\n    \r\n                        i {\r\n                            color: $white;\r\n                        }\r\n                    }\r\n                }\r\n\r\n        ul.sub-menu {\r\n          li {\r\n            a {\r\n              color: rgba($white, 0.5);\r\n              &:hover {\r\n                color: $white;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n    &.vertical-collpsed {\r\n        .vertical-menu {\r\n            #sidebar-menu{\r\n                >ul{\r\n                    >li{\r\n                        &:hover>a{\r\n                            background-color: lighten($primary, 2%);\r\n                            color: $white;\r\n                            i{\r\n                                color: $white;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                ul{\r\n                    li{\r\n                        &.mm-active {\r\n                            .active{\r\n                                color: $sidebar-menu-item-active-color !important;\r\n                            }\r\n                        }\r\n\r\n                        ul.sub-menu {\r\n                            li {\r\n                                a{\r\n                                    &:hover {\r\n                                        color: $sidebar-menu-item-active-color;\r\n                                    }\r\n                                }\r\n                                &.mm-active {\r\n                                    color: $sidebar-menu-item-active-color !important;\r\n                                    > a{\r\n                                        color: $sidebar-menu-item-active-color !important;\r\n                                        i {\r\n                                            color: $sidebar-menu-item-active-color !important;\r\n                                        }\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// colored sidebar\r\n.bg-colored {\r\n  background-color: $primary !important;\r\n}\r\nbody[data-sidebar=\"colored\"] {\r\n  .vertical-menu {\r\n    background-color: $primary;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-color: lighten($primary, 2%);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-color: $primary;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-color: lighten($primary, 2%);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background: transparent;\r\n    }\r\n  }\r\n}\r\n\r\n.vertical-menu {\r\n  [data-simplebar] {\r\n    z-index: 9;\r\n  }\r\n}\r\n\r\n// winter sidebar\r\n\r\nbody[data-sidebar=\"winter\"] {\r\n  .vertical-menu {\r\n    background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n    background-repeat: repeat-x;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n        background-repeat: repeat-x;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n              background-repeat: repeat-x;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n    }\r\n  }\r\n}\r\n\r\n// ladylip sidebar\r\n\r\nbody[data-sidebar=\"ladylip\"] {\r\n  .vertical-menu {\r\n    background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n    background-repeat: repeat-x;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n        background-repeat: repeat-x;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n              background-repeat: repeat-x;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n    }\r\n  }\r\n}\r\n\r\n// plumplate sidebar\r\n\r\nbody[data-sidebar=\"plumplate\"] {\r\n  .vertical-menu {\r\n    background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n    background-repeat: repeat-x;\r\n  }\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n        background-repeat: repeat-x;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n              background-repeat: repeat-x;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n    }\r\n  }\r\n}\r\n\r\n// strongbliss sidebar\r\n\r\nbody[data-sidebar=\"strongbliss\"] {\r\n  .vertical-menu {\r\n    background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n    background-repeat: repeat-x;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n        background-repeat: repeat-x;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n              background-repeat: repeat-x;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n    }\r\n  }\r\n}\r\n\r\n//greatwhale\r\nbody[data-sidebar=\"greatwhale\"] {\r\n  .vertical-menu {\r\n    background-image: linear-gradient(to right, darken($primary, 15%), #50a5f1);\r\n    background-repeat: repeat-x;\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    .navbar-brand-box {\r\n      background-image: linear-gradient(to right, #556ee6, #50a5f1);\r\n      background-repeat: repeat-x;\r\n    }\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .vertical-menu {\r\n      .navbar-brand-box {\r\n        background-image: linear-gradient(\r\n          to right,\r\n          darken($primary, 15%),\r\n          #50a5f1\r\n        );\r\n        background-repeat: repeat-x;\r\n      }\r\n      #sidebar-menu {\r\n        > ul {\r\n          > li {\r\n            &:hover > a {\r\n              background-image: linear-gradient(\r\n                to right,\r\n                darken($primary, 15%),\r\n                #50a5f1\r\n              );\r\n              background-repeat: repeat-x;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &[data-sidebar-size=\"small\"] {\r\n    .menu-title {\r\n      background-image: linear-gradient(to right, #556ee6, #50a5f1);\r\n    }\r\n  }\r\n}\r\n\r\n.themesideimage {\r\n  height: 80px;\r\n  width: 40px;\r\n}\r\n\r\nbody[data-sidebar-image] {\r\n  .vertical-menu {\r\n    &:before {\r\n      opacity: 0.33;\r\n      display: block;\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 100%;\r\n      top: 0;\r\n      left: 0;\r\n      z-index: 2;\r\n    }\r\n\r\n    &:after {\r\n      opacity: 0.77;\r\n      display: block;\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 100%;\r\n      top: 0;\r\n      left: 0;\r\n      z-index: 2;\r\n    }\r\n  }\r\n\r\n  .sidebar-background {\r\n    position: absolute;\r\n    z-index: 1;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: block;\r\n    top: 0;\r\n    left: 0;\r\n    background-size: cover;\r\n    background-position: 50%;\r\n    opacity: 0.07;\r\n  }\r\n}\r\n\r\nbody[data-sidebar-image=\"img1\"] {\r\n  .sidebar-background {\r\n    background-image: url(\"../../../images/sidebar/img1.jpg\");\r\n  }\r\n}\r\n\r\nbody[data-sidebar-image=\"img2\"] {\r\n  .sidebar-background {\r\n    background-image: url(\"../../../images/sidebar/img2.jpg\");\r\n  }\r\n}\r\n\r\nbody[data-sidebar-image=\"img3\"] {\r\n  .sidebar-background {\r\n    background-image: url(\"../../../images/sidebar/img3.jpg\");\r\n  }\r\n}\r\n\r\nbody[data-sidebar-image=\"img4\"] {\r\n  .sidebar-background {\r\n    background-image: url(\"../../../images/sidebar/img4.jpg\");\r\n  }\r\n}\r\n\r\n.verticalcontent {\r\n  writing-mode: vertical-rl;\r\n  text-orientation: upright;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: $dark !important;\r\n}\r\n\r\n.wh-30 {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n.gradient-colored {\r\n  background-color: $primary;\r\n}\r\n.gradient-winter {\r\n  background-image: linear-gradient(to right, #556ee6, #34c38f);\r\n  background-repeat: repeat-x;\r\n}\r\n.gradient-lady-lip {\r\n  background-image: linear-gradient(to right, #556ee6, #f46a6a);\r\n  background-repeat: repeat-x;\r\n}\r\n.gradient-plum-plate {\r\n  background-image: linear-gradient(to right, #556ee6, #f1b44c);\r\n}\r\n.gradient-strong-bliss {\r\n  background-image: linear-gradient(to right, #f46a6a, #f1b44c);\r\n}\r\n.gradient-strong-great-whale {\r\n  background-image: linear-gradient(to right, darken($primary, 10%), #50a5f1);\r\n}\r\n","// \r\n// _horizontal.scss\r\n// \r\n\r\n.topnav {\r\n    background: var(--#{$prefix}topnav-bg);\r\n    padding: 0 calc(#{$grid-gutter-width} * 0.5);\r\n    box-shadow: $box-shadow;\r\n    margin-top: $header-height;\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 100;\r\n    \r\n    .topnav-menu {\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .navbar-nav {\r\n        \r\n        .nav-link {\r\n            font-size: 14px;\r\n            position: relative;\r\n            padding: 1rem 1.3rem;\r\n            color: var(--#{$prefix}menu-item-color);\r\n            i{\r\n                font-size: 15px;\r\n            }\r\n            &:focus, &:hover{\r\n                color: var(--#{$prefix}menu-item-active-color);\r\n                background-color: transparent;\r\n            }\r\n        }\r\n        \r\n        .dropdown-item{\r\n            color: var(--#{$prefix}menu-item-color);\r\n            &.active, &:hover{\r\n                color: var(--#{$prefix}menu-item-active-color);\r\n            }\r\n        }\r\n        \r\n        .nav-item{\r\n            .nav-link.active{\r\n                color: var(--#{$prefix}menu-item-active-color);\r\n            }\r\n        }\r\n\r\n        .dropdown{\r\n            &.active{\r\n              >a {\r\n                    color: var(--#{$prefix}menu-item-active-color);\r\n                    background-color: transparent;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n    #page-topbar{\r\n        left: 0;\r\n    }\r\n}\r\n\r\n@include media-breakpoint-up(xl) {\r\n\r\n    body[data-layout=\"horizontal\"] {\r\n        .container-fluid,\r\n        .navbar-header {\r\n            max-width: 85%;\r\n        }\r\n    }\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n    .topnav {\r\n        .navbar-nav {\r\n            .nav-item {\r\n                &:first-of-type {\r\n                    .nav-link {\r\n                        padding-left: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .dropdown-item {\r\n            padding: .5rem 1.5rem;\r\n            min-width: 180px;\r\n        }\r\n\r\n        .dropdown {\r\n            &.mega-dropdown{\r\n                // position: static;\r\n                .mega-dropdown-menu{\r\n                    left: 0px;\r\n                    right: auto;\r\n                }\r\n            }\r\n            .dropdown-menu {\r\n                margin-top: 0;\r\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\r\n\r\n                .arrow-down {\r\n                    &::after {\r\n                        right: 15px;\r\n                        transform: rotate(-135deg) translateY(-50%);\r\n                        position: absolute;\r\n                    }\r\n                }\r\n\r\n                .dropdown {\r\n                    .dropdown-menu {\r\n                        position: absolute;\r\n                        top: 0 !important;\r\n                        left: 100%;\r\n                        display: none\r\n                    }\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                >.dropdown-menu {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n\r\n        .dropdown:hover>.dropdown-menu>.dropdown:hover>.dropdown-menu {\r\n            display: block\r\n        }\r\n    }\r\n\r\n    .navbar-toggle {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.arrow-down {\r\n    display: inline-block;\r\n\r\n    &:after {\r\n        border-color: initial;\r\n        border-style: solid;\r\n        border-width: 0 0 1px 1px;\r\n        content: \"\";\r\n        height: .4em;\r\n        display: inline-block;\r\n        right: 5px;\r\n        top: 50%;\r\n        margin-left: 10px;\r\n        transform: rotate(-45deg) translateY(-50%);\r\n        transform-origin: top;\r\n        transition: all .3s ease-out;\r\n        width: .4em;\r\n    }\r\n}\r\n\r\n\r\n@include media-breakpoint-down(xl) {\r\n    .topnav-menu {\r\n        .navbar-nav {\r\n            li {\r\n                &:last-of-type {\r\n                    .dropdown {\r\n                        .dropdown-menu {\r\n                            right: 100%;\r\n                            left: auto;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n\r\n    .navbar-brand-box{\r\n        .logo-dark {\r\n            display: var(--#{$prefix}display-block);\r\n            span.logo-sm{\r\n                display: var(--#{$prefix}display-block);\r\n            }\r\n        }\r\n    \r\n        .logo-light {\r\n            display: var(--#{$prefix}display-none);\r\n        }\r\n    }\r\n    \r\n    .topnav {\r\n        max-height: 360px;\r\n        overflow-y: auto;\r\n        padding: 0;\r\n        .navbar-nav {\r\n            .nav-link {\r\n                padding: 0.75rem 1.1rem;\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            .dropdown-menu {\r\n                background-color: transparent;\r\n                border: none;\r\n                box-shadow: none;\r\n                padding-left: 15px;\r\n                &.dropdown-mega-menu-xl{\r\n                    width: auto;\r\n    \r\n                    .row{\r\n                        margin: 0px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .dropdown-item {\r\n                position: relative;\r\n                background-color: transparent;\r\n\r\n                &.active,\r\n                &:active {\r\n                    color: $primary;\r\n                }\r\n            }\r\n        }\r\n\r\n        .arrow-down {\r\n            &::after {\r\n                right: 15px;\r\n                position: absolute;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media-breakpoint-up(lg) {\r\n\r\n    body[data-layout=\"horizontal\"][data-topbar=\"light\"] {\r\n        .navbar-brand-box{\r\n            .logo-dark {\r\n                display: var(--#{$prefix}display-block);\r\n            }\r\n        \r\n            .logo-light {\r\n                display: var(--#{$prefix}display-none);\r\n            }\r\n        }\r\n\r\n        .topnav{\r\n            background-color: $primary;\r\n            .navbar-nav {\r\n        \r\n                .nav-link {\r\n                    color: rgba($white, 0.6);\r\n                    \r\n                    &:focus, &:hover{\r\n                        color: rgba($white, 0.9);\r\n                    }\r\n                }\r\n        \r\n                > .dropdown{\r\n                    &.active{\r\n                    >a {\r\n                            color: rgba($white, 0.9) !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Colored Topbar \r\n\r\nbody[data-layout=\"horizontal\"][data-topbar=\"colored\"] {\r\n    #page-topbar{\r\n        background-color: $primary;\r\n        box-shadow: none;\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: block;\r\n    }\r\n\r\n    .app-search {\r\n    \r\n        .form-control {\r\n            background-color: rgba(var(--#{$prefix}topbar-search-bg),0.07);\r\n            color: $white;\r\n        }\r\n        span,\r\n        input.form-control::-webkit-input-placeholder {\r\n            color: rgba($white,0.5);\r\n        }\r\n    }\r\n    .header-item {\r\n        color: var(--#{$prefix}header-dark-item-color);\r\n    \r\n        &:hover {\r\n            color: var(--#{$prefix}header-dark-item-color);\r\n        }\r\n    }\r\n\r\n    .navbar-header {\r\n        .dropdown .show {\r\n            &.header-item{\r\n                background-color: rgba($white,0.1);\r\n            }\r\n        }\r\n\r\n        .waves-effect .waves-ripple {\r\n            background: rgba($white, 0.4);\r\n        }\r\n    }\r\n\r\n    .noti-icon {\r\n        i {\r\n            color: var(--#{$prefix}header-dark-item-color);\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        .topnav{\r\n            background-color: $primary;\r\n            .navbar-nav {\r\n        \r\n                .nav-link {\r\n                    color: rgba($white, 0.6);\r\n                    \r\n                    &:focus, &:hover{\r\n                        color: rgba($white, 0.9);\r\n                    }\r\n                }\r\n        \r\n                > .dropdown{\r\n                    &.active{\r\n                      >a {\r\n                            color: rgba($white, 0.9) !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","// \r\n// _layouts.scss\r\n// \r\n\r\nbody[data-layout-size=\"boxed\"] {\r\n    background-color: var(--#{$prefix}boxed-body-bg);\r\n    #layout-wrapper {\r\n        background-color: var(--#{$prefix}body-bg);\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        box-shadow: $box-shadow;\r\n    }\r\n\r\n  #page-topbar {\r\n    max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .footer {\r\n    margin: 0 auto;\r\n    max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\r\n}\r\n\r\n&.vertical-collpsed {\r\n    .footer {\r\n        max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\r\n    }\r\n\r\n  }\r\n\r\n  &[data-sidebar-size=\"small\"] {\r\n    #page-topbar {\r\n      max-width: calc(#{$boxed-layout-width} - #{$sidebar-width-sm});\r\n      // left: $sidebar-width-sm;\r\n      @media (max-width: 991.98px) {\r\n        left: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n    .footer {\r\n        margin: 0 auto;\r\n        max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\r\n    }\r\n\r\n    &.vertical-collpsed {\r\n        .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Horizontal Boxed Layout\r\n\r\nbody[data-layout=\"horizontal\"][data-layout-size=\"boxed\"] {\r\n  #page-topbar,\r\n  #layout-wrapper,\r\n  .footer {\r\n    max-width: 100%;\r\n  }\r\n  .container-fluid,\r\n  .navbar-header {\r\n    max-width: $boxed-layout-width;\r\n  }\r\n\r\n  &.vertical-collpsed {\r\n    .main-content{\r\n      min-height: auto;\r\n    }\r\n  }\r\n}\r\n\r\n// Scrollable layout\r\n\r\nbody[data-layout-scrollable=\"true\"] {\r\n  @media (min-width: 992px) {\r\n    #page-topbar,\r\n    .vertical-menu,\r\n    .navbar-brand-box {\r\n      position: absolute;\r\n    }\r\n  }\r\n\r\n  &[data-layout=\"horizontal\"] {\r\n    @media (min-width: 992px) {\r\n      #page-topbar,\r\n      .topnav {\r\n        position: absolute;\r\n      }\r\n      .navbar-brand-box {\r\n        position: relative;\r\n      }\r\n    }\r\n  }\r\n}\r\n","\r\n/*!\r\n * Waves v0.7.6\r\n * http://fian.my.id/Waves \r\n * \r\n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \r\n * Released under the MIT license \r\n * https://github.com/fians/Waves/blob/master/LICENSE */\r\n .waves-effect {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n  }\r\n  .waves-effect .waves-ripple {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-top: -50px;\r\n    margin-left: -50px;\r\n    opacity: 0;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    -webkit-transition: all 0.5s ease-out;\r\n    -moz-transition: all 0.5s ease-out;\r\n    -o-transition: all 0.5s ease-out;\r\n    transition: all 0.5s ease-out;\r\n    -webkit-transition-property: -webkit-transform, opacity;\r\n    -moz-transition-property: -moz-transform, opacity;\r\n    -o-transition-property: -o-transform, opacity;\r\n    transition-property: transform, opacity;\r\n    -webkit-transform: scale(0) translate(0, 0);\r\n    -moz-transform: scale(0) translate(0, 0);\r\n    -ms-transform: scale(0) translate(0, 0);\r\n    -o-transform: scale(0) translate(0, 0);\r\n    transform: scale(0) translate(0, 0);\r\n    pointer-events: none;\r\n  }\r\n  .waves-effect.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n  }\r\n  .waves-effect.waves-classic .waves-ripple {\r\n    background: rgba(0, 0, 0, 0.2);\r\n  }\r\n  .waves-effect.waves-classic.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n  }\r\n  .waves-notransition {\r\n    -webkit-transition: none !important;\r\n    -moz-transition: none !important;\r\n    -o-transition: none !important;\r\n    transition: none !important;\r\n  }\r\n  .waves-button,\r\n  .waves-circle {\r\n    -webkit-transform: translateZ(0);\r\n    -moz-transform: translateZ(0);\r\n    -ms-transform: translateZ(0);\r\n    -o-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\r\n  }\r\n  .waves-button,\r\n  .waves-button:hover,\r\n  .waves-button:visited,\r\n  .waves-button-input {\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    border: none;\r\n    outline: none;\r\n    color: inherit;\r\n    background-color: rgba(0, 0, 0, 0);\r\n    font-size: 1em;\r\n    line-height: 1em;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    z-index: 1;\r\n  }\r\n  .waves-button {\r\n    padding: 0.85em 1.1em;\r\n    border-radius: 0.2em;\r\n  }\r\n  .waves-button-input {\r\n    margin: 0;\r\n    padding: 0.85em 1.1em;\r\n  }\r\n  .waves-input-wrapper {\r\n    border-radius: 0.2em;\r\n    vertical-align: bottom;\r\n  }\r\n  .waves-input-wrapper.waves-button {\r\n    padding: 0;\r\n  }\r\n  .waves-input-wrapper .waves-button-input {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n  }\r\n  .waves-circle {\r\n    text-align: center;\r\n    width: 2.5em;\r\n    height: 2.5em;\r\n    line-height: 2.5em;\r\n    border-radius: 50%;\r\n  }\r\n  .waves-float {\r\n    -webkit-mask-image: none;\r\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    -webkit-transition: all 300ms;\r\n    -moz-transition: all 300ms;\r\n    -o-transition: all 300ms;\r\n    transition: all 300ms;\r\n  }\r\n  .waves-float:active {\r\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n  }\r\n  .waves-block {\r\n    display: block;\r\n  }\r\n\r\n.waves-effect.waves-light {\r\n    .waves-ripple {\r\n        background-color: rgba($white, 0.4);\r\n    }\r\n}\r\n\r\n.waves-effect.waves-primary {\r\n    .waves-ripple {\r\n        background-color: rgba($primary, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-success {\r\n    .waves-ripple {\r\n        background-color: rgba($success, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-info {\r\n    .waves-ripple {\r\n        background-color: rgba($info, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-warning {\r\n    .waves-ripple {\r\n        background-color: rgba($warning, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-danger {\r\n    .waves-ripple {\r\n        background-color: rgba($danger, 0.4);\r\n    }\r\n}","//\n// avatar.scss\n//\n\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem !important;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $font-weight-medium;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n// avatar group\n.avatar-group {\n  padding-left: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  .avatar-group-item {\n    margin-left: -12px;\n    border: 2px solid var(--#{$prefix}secondary-bg);\n    border-radius: 50%;\n    transition: all 0.2s;\n    &:hover{\n      position: relative;\n      transform: translateY(-2px);\n    }\n  }\n}","\r\n//\r\n// accordion.scss\r\n//\r\n\r\n.custom-accordion {\r\n    .accordion-list {\r\n        display: flex;\r\n        border-radius: 7px;\r\n        background-color: var(--#{$prefix}tertiary-bg);\r\n        padding: 12px 20px;\r\n        color: var(--#{$prefix}body-color);\r\n        font-weight: $font-weight-semibold;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        &.collapsed {\r\n            i.accor-plus-icon {\r\n                &:before {\r\n                    content: \"\\F0415\";\r\n                }\r\n            }\r\n        }\r\n\r\n        .accor-plus-icon{\r\n            display: inline-block;\r\n            font-size: 16px;\r\n            height: 24px;\r\n            width: 24px;\r\n            line-height: 22px;\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n            text-align: center;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n\r\n    \r\n    a {\r\n\r\n        &.collapsed {\r\n            i.accor-down-icon {\r\n                &:before {\r\n                    content: \"\\F0140\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .card-body {\r\n        color: var(--#{prefix}secondary-color);\r\n    }\r\n}","//\n// _helper.scss\n//\n\n.font-size-10 {\n    font-size: 10px !important;\n}\n\n.font-size-11 {\n    font-size: 11px !important;\n}\n\n.font-size-12 {\n    font-size: 12px !important;\n}\n\n.font-size-13 {\n    font-size: 13px !important;\n}\n\n.font-size-14 {\n    font-size: 14px !important;\n}\n\n.font-size-15 {\n    font-size: 15px !important;\n}\n\n.font-size-16 {\n    font-size: 16px !important;\n}\n\n.font-size-17 {\n    font-size: 17px !important;\n}\n\n.font-size-18 {\n    font-size: 18px !important;\n}\n\n.font-size-20 {\n    font-size: 20px !important;\n}\n\n.font-size-22 {\n    font-size: 22px !important;\n}\n\n.font-size-24 {\n    font-size: 24px !important;\n}\n\n\n\n// Social\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 4px);\n    display: block;\n    border: 2px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n    text-align: center;\n    transition: all 0.4s;\n\n    &:hover {\n        color: var(--#{$prefix}secondary-color);\n        background-color: $gray-200;\n    }\n}\n\n\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.w-xl {\n    min-width: 160px;\n}\n\n\n// alert\n\n.alert-dismissible {\n    .btn-close {\n        font-size: 10px;\n        padding: $alert-padding-y * 1.4 $alert-padding-x;\n    }\n}\n\n.chartjs-chart {\n    max-height: 300px;\n}    ","// \r\n// preloader.scss\r\n//\r\n\r\n#preloader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n    z-index: 9999;\r\n}\r\n\r\n#status {\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -20px 0 0 -20px;\r\n}\r\n\r\n.spinner-chase {\r\n    margin: 0 auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n    animation: spinner-chase 2.5s infinite linear both;\r\n}\r\n\r\n.chase-dot {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0; \r\n    animation: chase-dot 2.0s infinite ease-in-out both; \r\n    &:before {\r\n        content: '';\r\n        display: block;\r\n        width: 25%;\r\n        height: 25%;\r\n        background-color: $primary;\r\n        border-radius: 100%;\r\n        animation: chase-dot-before 2.0s infinite ease-in-out both; \r\n    }\r\n\r\n    &:nth-child(1) { \r\n        animation-delay: -1.1s; \r\n        &:before{\r\n            animation-delay: -1.1s;\r\n        }\r\n    }\r\n    &:nth-child(2) { \r\n        animation-delay: -1.0s;\r\n        &:before{\r\n            animation-delay: -1.0s;\r\n        }\r\n    }\r\n    &:nth-child(3) { \r\n        animation-delay: -0.9s;\r\n        &:before{\r\n            animation-delay: -0.9s;\r\n        } \r\n    }\r\n    &:nth-child(4) { \r\n        animation-delay: -0.8s; \r\n        &:before{\r\n            animation-delay: -0.8s;\r\n        } \r\n    }\r\n    &:nth-child(5) { \r\n        animation-delay: -0.7s; \r\n        &:before{\r\n            animation-delay: -0.7s;\r\n        } \r\n    }\r\n    &:nth-child(6) { \r\n        animation-delay: -0.6s; \r\n        &:before{\r\n            animation-delay: -0.6s;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes spinner-chase {\r\n    100% { \r\n        transform: rotate(360deg); \r\n    } \r\n}\r\n\r\n@keyframes chase-dot {\r\n    80%, 100% { \r\n        transform: rotate(360deg); \r\n    } \r\n}\r\n\r\n@keyframes chase-dot-before {\r\n    50% {\r\n        transform: scale(0.4); \r\n    } \r\n    100%, 0% {\r\n        transform: scale(1.0); \r\n    } \r\n}","//\r\n// Forms.scss\r\n//\r\n\r\n\r\n\r\n\r\n[type=\"tel\"],\r\n[type=\"url\"],\r\n[type=\"email\"],\r\n[type=\"number\"] {\r\n  &::placeholder {\r\n    text-align: left\r\n      /*rtl: right*/\r\n    ;\r\n  }\r\n}\r\n\r\n.form-check {\r\n  position: relative;\r\n  text-align: left\r\n    /*rtl: right*/\r\n  ;\r\n}\r\n\r\n\r\n// checkbox input right\r\n\r\n.form-check-right {\r\n  padding-left: 0;\r\n  display: inline-block;\r\n  padding-right: $form-check-padding-start;\r\n\r\n  .form-check-input {\r\n    float: right;\r\n    margin-left: 0;\r\n    margin-right: $form-check-padding-start * -1;\r\n  }\r\n\r\n  .form-check-label {\r\n    display: block;\r\n  }\r\n}\r\n\r\n\r\n\r\n// checkbox\r\n\r\n.form-checkbox-outline {\r\n\r\n  .form-check-input {\r\n    border-width: 2px;\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n\r\n    &:active {\r\n      filter: none;\r\n    }\r\n\r\n    &:checked {\r\n      background-color: var(--#{$prefix}secondary-bg)  !important;\r\n\r\n      &[type=checkbox] {\r\n        background-image: none;\r\n\r\n      }\r\n\r\n      &:after {\r\n        position: absolute;\r\n        content: '\\F012C';\r\n        font-family: \"Material Design Icons\";\r\n        top: -4px !important;\r\n        left: 1px;\r\n        /*rtl: -4px */\r\n        font-size: 16px;\r\n        color: var(--#{$prefix}body-color);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// radio\r\n\r\n.form-radio-outline {\r\n  .form-check-input {\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n    position: relative;\r\n\r\n    &:active {\r\n      filter: none;\r\n    }\r\n\r\n    &:checked {\r\n      background-color: var(--#{$prefix}secondary-bg)  !important;\r\n\r\n      &[type=checkbox] {\r\n        background-image: none;\r\n\r\n      }\r\n\r\n      &:after {\r\n        position: absolute;\r\n        content: '';\r\n        top: 3px !important;\r\n        left: 3px;\r\n        width: 5px;\r\n        height: 5px;\r\n        border-radius: 50%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n// checkbox color\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n  .form-check-#{$color} {\r\n    .form-check-input {\r\n      &:checked {\r\n        background-color: $value;\r\n        border-color: $value;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-radio-#{$color} {\r\n    .form-check-input {\r\n      &:checked {\r\n        border-color: $value;\r\n        background-color: $value;\r\n\r\n        &:after {\r\n          background-color: $value;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.form-check,\r\n.form-check-input,\r\n.form-check-label {\r\n  cursor: pointer;\r\n  margin-bottom: 0;\r\n}\r\n\r\n// Switch sizes\r\n\r\n.form-switch-md {\r\n  padding-left: 2.5rem;\r\n  min-height: 24px;\r\n  line-height: 24px;\r\n\r\n  .form-check-input {\r\n    width: 40px;\r\n    height: 20px;\r\n    left: -0.5rem;\r\n    position: relative;\r\n  }\r\n\r\n  .form-check-label {\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n\r\n.form-switch-lg {\r\n  padding-left: 2.75rem;\r\n  min-height: 28px;\r\n  line-height: 28px;\r\n\r\n  .form-check-input {\r\n    width: 48px;\r\n    height: 24px;\r\n    left: -0.75rem;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.input-group-text {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n// transfer list\r\n\r\n.rdl-filter,\r\n.rdl-control {\r\n  background-color: $input-bg;\r\n  border-color: $input-border-color;\r\n  color: $input-color;\r\n}\r\n\r\n.react-dual-listbox {\r\n  button {\r\n    color: $dark;\r\n    border-color: $border-color;\r\n    background-color: $light;\r\n  }\r\n\r\n  input,\r\n  select {\r\n    &:disabled {\r\n      background-color: $input-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n.rdl-move {\r\n\r\n    .form-check-input,\r\n    .form-check-input:focus {\r\n      background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$gray-400}'/></svg>\"));\r\n    }\r\n  }\r\n","// \r\n// Widgets.scss\r\n// \r\n\r\n.mini-stats-wid{\r\n    .mini-stat-icon{\r\n        overflow: hidden;\r\n        position: relative;\r\n        &:before, &:after{\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 8px;\r\n            height: 54px;\r\n            background-color: rgba($white,.1);\r\n            left: 16px;\r\n            transform: rotate(32deg);\r\n            top: -5px;\r\n            transition: all 0.4s;\r\n        }\r\n\r\n        &::after{\r\n            left: -12px;\r\n            width: 12px;\r\n            transition: all 0.2s;\r\n        }\r\n    }\r\n\r\n    &:hover{\r\n        .mini-stat-icon{\r\n            &::after{\r\n                left: 60px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n","// \r\n// _demos.scss\r\n// \r\n\r\n// Lightbox \r\n\r\n.mfp-popup-form {\r\n    max-width: 1140px;\r\n}\r\n.mfp-close{\r\n  color: var(--#{$prefix}body-color) !important;\r\n}\r\n\r\n// Modals\r\n\r\n.bs-example-modal {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    bottom: auto;\r\n    left: auto;\r\n    z-index: 1;\r\n    display: block;\r\n  }\r\n\r\n[dir=\"rtl\"]{\r\n  .modal-open{\r\n    padding-left: 0px !important;\r\n  }\r\n}\r\n\r\n// Icon demo ( Demo only )\r\n.icon-demo-content {\r\n    text-align: center;\r\n    color: $gray-500;\r\n  \r\n    i{\r\n      display: block;\r\n      font-size: 24px;\r\n      margin-bottom: 16px;\r\n      color: var(--#{prefix}secondary-color);\r\n      transition: all 0.4s;\r\n    }\r\n  \r\n    .col-lg-4 {\r\n      margin-top: 24px;\r\n  \r\n      &:hover {\r\n        i {\r\n          color: $primary;\r\n          transform: scale(1.5);\r\n        }\r\n      }\r\n    }\r\n}\r\n\r\n\r\n// Grid\r\n\r\n.grid-structure {\r\n    .grid-container {\r\n        background-color: var(--#{$prefix}gray-100);\r\n        margin-top: 10px;\r\n        font-size: .8rem;\r\n        font-weight: $font-weight-medium;\r\n        padding: 10px 20px;\r\n    }\r\n}\r\n\r\n\r\n// card radio\r\n\r\n.card-radio{\r\n  background-color: var(--#{$prefix}secondary-bg);\r\n  border: 2px solid var(--#{$prefix}border-color);\r\n  border-radius: var(--#{$prefix}border-radius);\r\n  padding: 1rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n\r\n  &:hover{\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.card-radio-label{\r\n  display: block;\r\n}\r\n\r\n\r\n.card-radio-input{\r\n  display: none;\r\n  &:checked + .card-radio {\r\n    border-color: $primary !important;\r\n  }\r\n}\r\n\r\n.navs-carousel{\r\n  .owl-nav{\r\n      margin-top: 16px;\r\n      button{\r\n          width: 30px;\r\n          height: 30px;\r\n          line-height: 28px !important;\r\n          font-size: 20px !important;\r\n          border-radius: 50% !important;\r\n          background-color: rgba($primary, 0.25) !important;\r\n          color: $primary !important;\r\n          margin: 4px 8px !important;\r\n      }\r\n  }\r\n}\r\n\r\n\r\n","// \r\n// print.scss\r\n//\r\n\r\n// Used invoice page\r\n@media print {\r\n    .vertical-menu,\r\n    .right-bar,\r\n    .page-title-box,\r\n    .navbar-header,\r\n    .footer {\r\n        display: none !important;\r\n    }\r\n    .card-body,\r\n    .main-content,\r\n    .right-bar,\r\n    .page-content,\r\n    body {\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    .card{\r\n        border: 0;\r\n    }\r\n}","[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 4px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}","/* ==============\r\n  Calendar\r\n===================*/\r\n\r\n.lnb-calendars-item {\r\n    display: inline-block;\r\n    margin-right: 7px\r\n        /*rtl: margin-left: 7px*/\r\n    ;\r\n}\r\n\r\ninput[type=\"checkbox\"].tui-full-calendar-checkbox-round+span {\r\n    margin-right: 4px\r\n        /*rtl: 0*/\r\n    ;\r\n    margin-left: 0\r\n        /*rtl: 4px*/\r\n    ;\r\n}\r\n\r\n.tui-full-calendar-layout,\r\n.tui-full-calendar-timegrid-timezone {\r\n    background-color: var(--#{$prefix}secondary-bg) !important;\r\n}\r\n\r\n.tui-full-calendar-dayname-container,\r\n.tui-full-calendar-left,\r\n.tui-full-calendar-splitter,\r\n.tui-full-calendar-time-date,\r\n.tui-full-calendar-weekday-grid-line,\r\n.tui-full-calendar-timegrid-timezone,\r\n.tui-full-calendar-timegrid-gridline {\r\n    border-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-weekday-exceed-in-week {\r\n    text-align: center;\r\n    width: 30px;\r\n    height: 30px;\r\n    line-height: 28px;\r\n    border-radius: 4px;\r\n    background-color: var(--#{$prefix}custom-white);\r\n    color: var(--#{$prefix}body-color);\r\n    border-color: var(--#{$prefix}border-color);\r\n}\r\n\r\n.tui-full-calendar-timegrid-hour {\r\n    color: var(--#{$prefix}body-color) !important;\r\n}\r\n\r\n.tui-full-calendar-weekday-schedule-title {\r\n    color: var(--#{$prefix}emphasis-color) !important;\r\n\r\n    .tui-full-calendar-time-schedule {\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n}\r\n\r\n.tui-full-calendar-popup-container {\r\n    background-color: var(--#{$prefix}custom-white) !important;\r\n    border-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-dropdown {\r\n    &:hover {\r\n        .tui-full-calendar-dropdown-button {\r\n            border-color: var(--#{$prefix}border-color)\r\n        }\r\n    }\r\n}\r\n\r\n.tui-full-calendar-popup-section-item {\r\n    &:hover, &:focus {\r\n        border-color: var(--#{$prefix}border-color);\r\n    }\r\n}\r\n\r\n.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-fill {\r\n    border-top-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-arrow-top .tui-full-calendar-popup-arrow-fill {\r\n    border-bottom-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-borde {\r\n    border-bottom-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-button {\r\n    color: $input-color;\r\n    background-color: $input-bg  !important;\r\n    border-color: var(--#{$prefix}border-color);\r\n}\r\n\r\n.tui-full-calendar-popup-section-item {\r\n    border-color: var(--#{$prefix}border-color);\r\n}\r\n\r\n.tui-full-calendar-month-dayname,\r\n.tui-full-calendar-weekday-border {\r\n    border-top-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-arrow-top .tui-full-calendar-popup-arrow-border {\r\n    border-bottom-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-dropdown-menu {\r\n    border-color: var(--#{$prefix}border-color) !important;\r\n}\r\n\r\n.tui-full-calendar-dropdown-menu-item,\r\n.tui-full-calendar-dropdown-menu {\r\n    background-color: $input-bg  !important;\r\n}\r\n\r\n.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-border {\r\n    border-top-color: var(--#{$prefix}border-color);\r\n}\r\n\r\n.tui-full-calendar-content {\r\n    background-color: $input-bg  !important;\r\n    color: $input-color  !important;\r\n}\r\n\r\n.tui-full-calendar-confirm {\r\n    background-color: $danger  !important;\r\n    color: $white  !important;\r\n\r\n    &:hover {\r\n        background-color: $red-600  !important;\r\n        color: $white  !important;\r\n    }\r\n}\r\n\r\n.tui-full-calendar-month-dayname-item {\r\n    span {\r\n        color: var(--#{$prefix}emphasis-color) !important;\r\n    }\r\n}\r\n\r\n.tui-full-calendar-weekday-grid-line {\r\n    &.tui-full-calendar-near-month-day {\r\n        &.tui-full-calendar-extra-date {\r\n            .tui-full-calendar-weekday-grid-header {\r\n                .tui-full-calendar-weekday-grid-date {\r\n                    color: var(--#{$prefix}secondary-color) !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.tui-full-calendar-weekday-grid-line {\r\n    &.tui-full-calendar-near-month-day {\r\n        .tui-full-calendar-weekday-grid-header {\r\n            .tui-full-calendar-weekday-grid-date {\r\n                color: var(--#{$prefix}emphasis-color) !important;\r\n            }\r\n        }\r\n    }\r\n}","/* ==============\r\n  Calendar\r\n===================*/\r\n\r\n\r\n.fc td,\r\n.fc th {\r\n  border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n\r\n\r\n\r\n.fc {\r\n  .fc-toolbar {\r\n      h2 {\r\n          font-size: 16px;\r\n          line-height: 30px;\r\n          text-transform: uppercase;\r\n      }\r\n\r\n      @media (max-width: 767.98px) {\r\n\r\n          .fc-left,\r\n          .fc-right,\r\n          .fc-center {\r\n              float: none;\r\n              display: block;\r\n              text-align: center;\r\n              clear: both;\r\n              margin: 10px 0;\r\n          }\r\n\r\n          >*>* {\r\n              float: none;\r\n          }\r\n\r\n          .fc-today-button {\r\n              display: none;\r\n          }\r\n      }\r\n\r\n      .btn {\r\n          text-transform: capitalize;\r\n      }\r\n\r\n  }\r\n  .fc-col-header-cell-cushion {\r\n    color: var(--#{$prefix}body-color);\r\n  }\r\n\r\n  .fc-daygrid-day-number {\r\n    color: var(--#{$prefix}body-color);\r\n  }\r\n}\r\n\r\n.fc-daygrid-event-dot {\r\n  display: none;\r\n}\r\n\r\n.fc-prev-button,\r\n.fc-next-button {\r\n  position: relative;\r\n  padding: 6px 8px !important;\r\n}\r\n\r\n\r\n.fc-toolbar-chunk {\r\n  .fc-button-group {\r\n    .fc-button {\r\n      background-color: var(--#{$prefix}primary);\r\n      border-color: var(--#{$prefix}primary);\r\n      ;\r\n      box-shadow: none;\r\n\r\n      &:hover,\r\n      &.active {\r\n        color: $white;\r\n        background-color: var(--#{$prefix}primary);\r\n        border-color: var(--#{$prefix}primary);\r\n      }\r\n    }\r\n  }\r\n\r\n  .fc-today-button {\r\n    background-color: var(--#{$prefix}primary) !important;\r\n    border-color: var(--#{$prefix}primary) !important;\r\n  }\r\n}\r\n\r\n.fc {\r\n\r\n  .fc-button-primary:not(:disabled).fc-button-active,\r\n  .fc-button-primary:not(:disabled):active {\r\n    background-color: var(--#{$prefix}primary) !important;\r\n    border-color: var(--#{$prefix}primary) !important;\r\n    color: $white !important;\r\n  }\r\n}\r\n\r\n.fc-toolbar {\r\n  @media (max-width: 575.98px) {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n}\r\n\r\n.fc {\r\n  th.fc-widget-header {\r\n      background: $gray-300;\r\n      color: $gray-700;\r\n      line-height: 20px;\r\n      padding: 10px 0;\r\n      text-transform: uppercase;\r\n      font-weight: $font-weight-bold;\r\n  }\r\n}\r\n\r\n.fc-unthemed {\r\n\r\n  .fc-content,\r\n  .fc-divider,\r\n  .fc-list-heading td,\r\n  .fc-list-view,\r\n  .fc-popover,\r\n  .fc-row,\r\n  tbody,\r\n  td,\r\n  th,\r\n  thead {\r\n      border-color: $gray-300;\r\n  }\r\n\r\n  td.fc-today {\r\n      background: lighten($gray-200, 2%);\r\n  }\r\n}\r\n\r\n.fc-button {\r\n  background: var(--#{$prefix}secondary-bg);\r\n  border-color: var(--#{$prefix}border-color);\r\n  color: $gray-700;\r\n  text-transform: capitalize;\r\n  box-shadow: none;\r\n  padding: 6px 12px !important;\r\n  height: auto !important;\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n  background-color: $primary;\r\n  color: $white;\r\n  text-shadow: none;\r\n}\r\n\r\n.fc-event {\r\n  border-radius: 2px;\r\n  border: none;\r\n  cursor: move;\r\n  font-size: 0.8125rem;\r\n  margin: 5px 7px;\r\n  padding: 5px 5px;\r\n  text-align: center;\r\n  color: $white;\r\n\r\n  &.bg-dark {\r\n    .fc-event-time {\r\n      color: var(--#{$prefix}secondary-bg) !important;\r\n    }\r\n    background-color: var(--#{$prefix}secondary-color) !important;\r\n    .fc-event-title {\r\n      color: var(--#{$prefix}secondary-bg) !important;\r\n    }\r\n  }\r\n}\r\n\r\n.fc-event,\r\n.fc-event-dot {\r\n  background-color: $primary;\r\n}\r\n\r\n.fc-event .fc-content {\r\n  color: $white;\r\n}\r\n\r\n#external-events {\r\n  .external-event {\r\n      text-align: left;\r\n      padding: 8px 16px;\r\n      margin-left: 0;\r\n      margin-right: 0;\r\n  }\r\n}\r\n\r\n\r\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\r\n  .fc-content{\r\n    color: $light;  \r\n  }\r\n}\r\n\r\n\r\n// RTL\r\n[dir=\"rtl\"]{\r\n  .fc-header-toolbar {\r\n      direction: ltr !important;\r\n  }\r\n\r\n  .fc-toolbar>*>:not(:first-child) {\r\n      margin-left: .75em;\r\n  }\r\n}\r\n\r\n.fc-theme-standard .fc-scrollgrid {\r\n  border-color: var(--#{$prefix}border-color);\r\n}\r\n\r\n.fc .fc-daygrid-week-number {\r\n  background-color: var(--#{$prefix}body-bg);\r\n  color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.fc .fc-daygrid-more-link {\r\n  padding: 5px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n.fc .fc-daygrid-more-link:hover {\r\n  background-color: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n}\r\n\r\n.fc .fc-popover-header {\r\n  padding: 6px 12px;\r\n}\r\n\r\n.fc-theme-standard .fc-popover-header {\r\n  background: var(--#{$prefix}body-bg);\r\n}\r\n\r\n.fc-theme-standard .fc-popover {\r\n    background: var(--#{$prefix}secondary-bg);\r\n    border: 1px solid var(--#{$prefix}border-color);\r\n}\r\n","/* ==============\r\n  Druafula\r\n===================*/\r\n\r\n\r\n.task-box {\r\n\r\n  border: 1px solid var(--#{$prefix}border-color);\r\n}\r\n\r\n[data-bs-theme=dark] .card .task-box {\r\n  border: 1px solid var(--bs-gray-dark) !important;\r\n}\r\n\r\n.gu-transit {\r\n  border: 1px dashed var(--#{$prefix}border-color) !important;\r\n  background-color: var(--#{$prefix}gray-200) !important;\r\n}","//\r\n// session-timeout.scss\r\n//\r\n\r\n#session-timeout-dialog {\r\n    .close {\r\n        display: none;\r\n    }\r\n\r\n    .countdown-holder {\r\n        color: $danger;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .btn-default {\r\n        background-color: $white;\r\n        color: $danger;\r\n        box-shadow: none;\r\n    }\r\n}","//\r\n// Range slider\r\n//\r\n\r\n.irs {\r\n  font-family: $font-family-base;\r\n}\r\n\r\n.irs--square {\r\n  cursor: pointer;\r\n\r\n  .irs-bar,\r\n  .irs-to,\r\n  .irs-from,\r\n  .irs-single {\r\n    background: $primary  !important;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .irs-to,\r\n  .irs-from,\r\n  .irs-single {\r\n    &:before {\r\n      border-top-color: $primary;\r\n    }\r\n  }\r\n\r\n  .irs-line {\r\n    background: var(--#{$prefix}tertiary-bg);\r\n    border-color: var(--#{$prefix}tertiary-bg);\r\n  }\r\n\r\n  .irs-grid-text {\r\n    font-size: 11px;\r\n    color: var(--#{$prefix}secondary-color);\r\n  }\r\n\r\n  .irs-min,\r\n  .irs-max {\r\n    color: var(--#{$prefix}secondary-color);\r\n    background: var(--#{$prefix}tertiary-bg);\r\n    font-size: 11px;\r\n  }\r\n\r\n  .irs-handle {\r\n    border: 2px solid $primary;\r\n    width: 12px;\r\n    height: 12px;\r\n    top: 26px;\r\n    background-color: var(--#{$prefix}secondary-bg) !important;\r\n    cursor: pointer;\r\n\r\n    &:active {\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  .irs-grid-pol {\r\n    background-color: var(--#{$prefix}secondary-color);\r\n  }\r\n}","//\r\n//  Sweetalert2\r\n//\r\n\r\n.swal2-container {\r\n    .swal2-title {\r\n        font-size: 20px;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n}\r\n\r\n.swal2-modal {\r\n    font-size: 14px;\r\n}\r\n\r\n.swal2-icon {\r\n    &.swal2-question {\r\n        border-color: $info;\r\n        color: $info;\r\n    }\r\n    &.swal2-success {\r\n        [class^=\"swal2-success-line\"] {\r\n            background-color: $success;\r\n        }\r\n\r\n        .swal2-success-ring {\r\n            border-color: rgba($success, 0.3);\r\n        }\r\n    }\r\n    &.swal2-warning {\r\n        border-color: $warning;\r\n        color: $warning;\r\n    }\r\n}\r\n\r\n.swal2-styled {\r\n    &:focus {\r\n        box-shadow: none;\r\n    }\r\n}\r\n\r\n.swal2-progress-steps {\r\n    .swal2-progress-step {\r\n        background: $primary;\r\n        &.swal2-active-progress-step {\r\n            background: $primary;\r\n            & ~ .swal2-progress-step,\r\n            & ~ .swal2-progress-step-line {\r\n                background: rgba($primary, 0.3);\r\n            }\r\n        }\r\n    }\r\n\r\n    .swal2-progress-step-line {\r\n        background: $primary;\r\n    }\r\n}\r\n\r\n.swal2-loader {\r\n    border-color: $primary transparent $primary transparent;\r\n}\r\n.swal2-popup {\r\n    background: var(--#{$prefix}secondary-bg);\r\n}\r\n\r\n.swal2-title, .swal2-html-container{\r\n    color: var(--#{$prefix}emphasis-color);\r\n}\r\n\r\n.swal2-file,\r\n.swal2-input,\r\n.swal2-textarea {\r\n    border-color: var(--#{$prefix}border-color);\r\n    color: var(--#{$prefix}body-color);\r\n    &:focus {\r\n        box-shadow: none;\r\n        border-color: var(--#{$prefix}border-color);\r\n    }\r\n}\r\n\r\ndiv:where(.swal2-container) div:where(.swal2-popup) {\r\n    color: var(--#{$prefix}secondary-color);\r\n}","\r\n//\r\n// Rating\r\n//\r\n\r\n.symbol{\r\n  border-color: var(--#{$prefix}secondary-bg);\r\n}\r\n\r\n.rating-symbol-background, .rating-symbol-foreground {\r\n  font-size: 24px;\r\n}\r\n\r\n.symbol-empty {\r\n  background-color: var(--#{$prefix}gray-400);\r\n}\r\n\r\n.rating-symbol-foreground {\r\n  top: 0px;\r\n}\r\n\r\n.rating-star{\r\n  > span{\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n\r\n    &.badge{\r\n      margin-left: 4px;\r\n    }\r\n  }\r\n}","\r\n//\r\n// toastr.scss\r\n//\r\n\r\n\r\n/* =============\r\n   Notification\r\n============= */\r\n#toast-container {\r\n    > div {\r\n        box-shadow: $box-shadow;\r\n        opacity: 1;\r\n        &:hover {\r\n            box-shadow: $box-shadow;\r\n            opacity: 0.9;\r\n        }\r\n    }\r\n\r\n    &.toast-top-full-width, &.toast-bottom-full-width{\r\n        > div{\r\n          min-width: 96%;\r\n          margin: 4px auto;\r\n        }\r\n      }\r\n\r\n}\r\n\r\n\r\n@each $color, $value in $theme-colors {\r\n    .toast-#{$color} {\r\n        border: 2px solid $value !important;\r\n        background-color: rgba(($value), 0.8) !important;\r\n    }\r\n}\r\n\r\n\r\n// for error\r\n\r\n.toast-error {\r\n    background-color: rgba($danger,0.8);\r\n    border: 2px solid $danger;\r\n}\r\n\r\n.toastr-options{\r\n    padding: 24px;\r\n    background-color: var(--#{$prefix}tertiary-bg);\r\n    margin-bottom: 0;\r\n    border: 1px solid var(--#{$prefix}border-color);\r\n}","\r\n//\r\n// Parsley\r\n//\r\n\r\n.error {\r\n  color: $danger;\r\n}\r\n\r\n.parsley-error {\r\n  border-color: $danger;\r\n}\r\n\r\n.parsley-errors-list {\r\n  display: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  &.filled {\r\n    display: block;\r\n  }\r\n  > li {\r\n    font-size: 12px;\r\n    list-style: none;\r\n    color: $danger;\r\n    margin-top: 5px;\r\n  }\r\n}","//\r\n// Select 2\r\n//\r\n\r\n.select2-container {\r\n    .select2-selection--single {\r\n        background-color: var(--#{$prefix}secondary-bg);\r\n        border: 1px solid $input-border-color;\r\n        height: 38px;\r\n        &:focus {\r\n            outline: none;\r\n        }\r\n\r\n        .select2-selection__rendered {\r\n            line-height: 36px;\r\n            padding-left: $input-padding-x;\r\n            color: var(--#{$prefix}secondary-color);\r\n        }\r\n        \r\n\r\n        .select2-selection__arrow {\r\n            height: 34px;\r\n            width: 34px;\r\n            right: 3px;\r\n\r\n            b {\r\n                border-color: var(--#{$prefix}gray-500) transparent transparent transparent;\r\n                border-width: 6px 6px 0 6px;\r\n            }\r\n        }\r\n\r\n        .select2-selection__placeholder {\r\n            color: var(--#{$prefix}body-color);\r\n        }\r\n    }\r\n}\r\n\r\n[dir=\"rtl\"]{\r\n    .select2-selection__rendered {\r\n        text-align: end;\r\n    }\r\n}\r\n\r\n\r\n.select2-container--open {\r\n    .select2-selection--single {\r\n        .select2-selection__arrow {\r\n            b {\r\n                border-color: transparent transparent var(--#{$prefix}gray-500) transparent !important;\r\n                border-width: 0 6px 6px 6px !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.select2-container--default {\r\n    .select2-search--dropdown {\r\n        padding: 10px;\r\n        background-color: var(--#{$prefix}secondary-bg);\r\n        .select2-search__field {\r\n            border: 1px solid var(--#{$prefix}border-color-translucent);\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n            color: var(--#{$prefix}secondary-color);\r\n            outline: none;\r\n        }\r\n    }\r\n    .select2-results__option--highlighted[aria-selected] {\r\n        background-color: $primary;\r\n    }\r\n    .select2-results__option[aria-selected=\"true\"] {\r\n        background-color: var(--#{$prefix}light);\r\n        color: var(--#{$prefix}emphasis-color);\r\n        margin: 0;\r\n        margin-top: 7px;\r\n        &:hover {\r\n            background-color: $primary;\r\n            color: $white;\r\n        }\r\n    }\r\n\r\n    .select2-selection--multiple {\r\n        .select2-selection__choice__remove {\r\n            border-right: none;\r\n            color: var(--#{$prefix}emphasis-color);\r\n        }\r\n    }\r\n}\r\n\r\n.select2-results__option {\r\n    padding: 6px 12px;\r\n}\r\n.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered {\r\n    padding-left: $input-padding-x;\r\n}\r\n\r\n.select2-dropdown {\r\n    border: 1px solid var(--#{$prefix}border-color);\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n    box-shadow: $box-shadow;\r\n}\r\n\r\n.select2-search {\r\n    input {\r\n        border: 1px solid var(--#{$prefix}border-color);\r\n    }\r\n}\r\n\r\n.select2-container {\r\n    .select2-selection--multiple {\r\n        min-height: 38px;\r\n        background-color: var(--#{$prefix}secondary-bg);\r\n        border: 1px solid var(--#{$prefix}border-color-translucent) !important;\r\n\r\n        .select2-selection__rendered {\r\n            padding: 2px $input-padding-x;\r\n        }\r\n        .select2-search__field {\r\n            border: 0;\r\n            color: var(--#{$prefix}input-color);\r\n            &::placeholder {\r\n                color: var(--#{$prefix}secondary-color);\r\n            }\r\n        }\r\n        .select2-selection__choice {\r\n            background-color: var(--#{$prefix}tertiary-bg);\r\n            border: 1px solid var(--#{$prefix}border-color);\r\n            border-radius: 1px;\r\n            padding: 0 7px;\r\n        }\r\n        .select2-selection__rendered {\r\n            padding: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.select2-container--default {\r\n    &.select2-container--focus {\r\n        .select2-selection--multiple {\r\n            border-color: var(--#{$prefix}border-color-translucent);\r\n        }\r\n    }\r\n\r\n    .select2-results__group {\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n\r\n    .select2-selection--multiple {\r\n        .select2-selection__choice__display {\r\n            padding-left: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n// ajax select\r\n\r\n.select2-result-repository__avatar {\r\n    float: left;\r\n    width: 60px;\r\n    margin-right: 10px;\r\n    img {\r\n        width: 100%;\r\n        height: auto;\r\n        border-radius: 2px;\r\n    }\r\n}\r\n\r\n.select2-result-repository__statistics {\r\n    margin-top: 7px;\r\n}\r\n\r\n.select2-result-repository__forks,\r\n.select2-result-repository__stargazers,\r\n.select2-result-repository__watchers {\r\n    display: inline-block;\r\n    font-size: 11px;\r\n    margin-right: 1em;\r\n    color: var(--#{$prefix}gray-500);\r\n\r\n    .fa {\r\n        margin-right: 4px;\r\n\r\n        &.fa-flash {\r\n            &::before {\r\n                content: \"\\f0e7\";\r\n                font-family: \"Font Awesome 5 Free\";\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.select2-results__option--highlighted {\r\n    .select2-result-repository__forks,\r\n    .select2-result-repository__stargazers,\r\n    .select2-result-repository__watchers {\r\n        color: rgba($white, 0.8);\r\n    }\r\n}\r\n\r\n.select2-result-repository__meta {\r\n    overflow: hidden;\r\n}\r\n\r\n// templating-select\r\n\r\n.img-flag {\r\n    margin-right: 7px;\r\n    height: 15px;\r\n    width: 18px;\r\n}\r\n\r\n.select2-container--default .select2-results__option--selected {\r\n    background-color: var(--#{$prefix}tertiary-bg);\r\n}","//\r\n//  Sweetalert2\r\n//\r\n\r\n/* CSS Switch */\r\ninput.switch {\r\n  display: none;\r\n  + label {\r\n    font-size: 1em;\r\n    line-height: 1;\r\n    width: 56px;\r\n    height: 24px;\r\n    background-color: $gray-400;\r\n    background-image: none;\r\n    border-radius: 2rem;\r\n    padding: 0.16667rem;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    text-align: center;\r\n    position: relative;\r\n    font-weight: $font-weight-medium;\r\n    transition: all 0.1s ease-in-out;\r\n    &:before {\r\n      color: $dark;\r\n      content: attr(data-off-label);\r\n      display: block;\r\n      font-family: inherit;\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 21px;\r\n      position: absolute;\r\n      right: 1px;\r\n      margin: 3px;\r\n      top: -2px;\r\n      text-align: center;\r\n      min-width: 1.66667rem;\r\n      overflow: hidden;\r\n      transition: all 0.1s ease-in-out;\r\n    }\r\n\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 3px;\r\n      background-color: $gray-200;\r\n      box-shadow: none;\r\n      border-radius: 2rem;\r\n      height: 20px;\r\n      width: 20px;\r\n      top: 2px;\r\n      transition: all 0.1s ease-in-out;\r\n    }\r\n  }\r\n\r\n  &:checked + label {\r\n    background-color: $primary;\r\n  }\r\n}\r\n\r\ninput.switch:checked + label {\r\n  background-color: $primary;\r\n  &:before {\r\n    color: $white;\r\n    content: attr(data-on-label);\r\n    right: auto;\r\n    left: 3px;\r\n  }\r\n\r\n  &:after {\r\n    left: 33px;\r\n    background-color: $gray-200;\r\n  }\r\n}\r\n\r\ninput.switch-bool + label {\r\n  background-color: $danger;\r\n}\r\ninput.switch-bool + label:before,input.switch-bool:checked + label:before,\r\ninput[switch=\"default\"]:checked + label:before{\r\n  color: $white;\r\n}\r\n\r\ninput.switch-bool:checked + label {\r\n  background-color: $success;\r\n}\r\n\r\ninput.switch-default:checked + label {\r\n  background-color: #a2a2a2;\r\n}\r\n\r\ninput.switch-primary:checked + label {\r\n  background-color: $primary;\r\n}\r\n\r\ninput.switch-success:checked + label {\r\n  background-color: $success;\r\n}\r\n\r\ninput.switch-info:checked + label {\r\n  background-color: $info;\r\n}\r\n\r\ninput.switch-warning:checked + label {\r\n  background-color: $warning;\r\n}\r\n\r\ninput.switch-danger:checked + label {\r\n  background-color: $danger;\r\n}\r\n\r\ninput.switch-dark:checked + label {\r\n  background-color: $dark;\r\n  &:before {\r\n    color: $light;\r\n  }\r\n}\r\n\r\n.square-switch{\r\n  margin-right: 7px;\r\n  input.switch+label, input.switch+label:after{\r\n    border-radius: 4px;\r\n  }\r\n}\r\n","\r\n//\r\n// colorpicker.scss\r\n//\r\n\r\n.sp-container{\r\n  background-color: $dropdown-bg;\r\n  button{\r\n    padding: .25rem .5rem;\r\n      font-size: .71094rem;\r\n      border-radius: .2rem;\r\n      font-weight: 400;\r\n      color: $dark;\r\n  \r\n      &.sp-palette-toggle{\r\n        background-color: $light;\r\n      }\r\n      \r\n      &.sp-choose{\r\n        background-color: $success;\r\n        margin-left: 5px;\r\n        margin-right: 0;\r\n      }\r\n  }\r\n}\r\n\r\n.sp-palette-container{\r\n  border-right: 1px solid $border-color;\r\n}\r\n\r\n.sp-input{\r\n  background-color: $input-bg;\r\n  border-color: $input-border-color !important;\r\n  color: $input-color;\r\n  &:focus{\r\n    outline: none;\r\n  }\r\n}\r\n\r\n\r\n[dir=\"rtl\"]{\r\n\r\n  .sp-alpha{\r\n    direction: ltr;\r\n  }\r\n\r\n  .sp-original-input-container {\r\n    .sp-add-on{\r\n      border-top-right-radius: 0!important;\r\n      border-bottom-right-radius: 0!important;\r\n      border-top-left-radius: 4px!important;\r\n      border-bottom-left-radius: 4px!important\r\n    }\r\n  } \r\n\r\n  input.spectrum.with-add-on{\r\n    border: 1px solid $input-border-color;\r\n    border-left: 0;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: $input-border-radius;\r\n    border-bottom-right-radius: $input-border-radius;\r\n\r\n  }\r\n}","\r\n\r\n/* Timepicker */\r\n.bootstrap-timepicker-widget {\r\n  table {\r\n    td {\r\n      a {\r\n        color: $input-color;\r\n        &:hover {\r\n          background-color: transparent;\r\n          border-color: transparent;\r\n          border-radius: 4px;\r\n          color: $primary;\r\n          text-decoration: none;\r\n        }\r\n      }\r\n      input {\r\n        width: 32px;\r\n        height: 32px;\r\n        border: 0;\r\n        color: var(--#{$prefix}body-color);\r\n        border: 1px solid var(--#{$prefix}border-color);\r\n        background-color: $input-bg;\r\n\r\n      }\r\n    }\r\n  }\r\n\r\n  &.dropdown-menu:after{\r\n    border-bottom-color: var(--#{$prefix}gray-200);\r\n  }\r\n  &.timepicker-orient-bottom:after{\r\n    border-top-color: var(--#{$prefix}gray-200);\r\n  }\r\n}\r\n\r\n\r\n.timepicker-orient-top{\r\n  top: $input-height !important;\r\n}\r\n\r\n.timepicker-orient-bottom{\r\n  top: auto !important;\r\n  bottom: $input-height !important;\r\n}\r\n\r\n.bootstrap-timepicker-widget{\r\n  left: 0 !important;\r\n  right: auto !important;\r\n}\r\n\r\n\r\n.bootstrap-timepicker-widget{\r\n  &.timepicker-orient-left{\r\n    &:before{\r\n      left: 6px;\r\n      right: auto;\r\n    }\r\n\r\n    &::after{\r\n      left: 7px;\r\n      right: auto;\r\n    }\r\n  }\r\n}","\r\n//\r\n// Datepicker\r\n//\r\n\r\n.datepicker {\r\n  border: 1px solid var(--#{$prefix}border-color);\r\n  padding: 8px;\r\n  z-index: 999 !important;\r\n  \r\n\r\n  table{\r\n    tr{\r\n      th{\r\n        font-weight: 500;\r\n      }\r\n      td{\r\n        &.active, &.active:hover, .active.disabled, &.active.disabled:hover,\r\n        &.today,  &.today:hover, &.today.disabled, &.today.disabled:hover, \r\n        &.selected, &.selected:hover, &.selected.disabled, &.selected.disabled:hover,\r\n        span.active.active, span.active:hover.active{\r\n          background-color: $primary !important;\r\n          background-image: none;\r\n          box-shadow: none;\r\n          color: $white !important;\r\n        }\r\n\r\n        &.day.focused,\r\n        &.day:hover,\r\n        span.focused,\r\n        span:hover {\r\n            background: var(--#{$prefix}light);\r\n        }\r\n\r\n        &.new,\r\n        &.old,\r\n        span.new,\r\n        span.old {\r\n            color: var(--#{$prefix}gray-500);\r\n            opacity: 0.6;\r\n        }\r\n\r\n        &.range, &.range.disabled, &.range.disabled:hover, &.range:hover{\r\n          background-color: var(--#{$prefix}tertiary-bg);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.table-condensed{\r\n  >thead>tr>th, >tbody>tr>td {\r\n    padding: 7px;\r\n  }\r\n}\r\n\r\n.bootstrap-datepicker-inline{\r\n  .datepicker-inline{\r\n    width: auto !important;\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n\r\n// DATEPICKER\r\n\r\n.datepicker-container{\r\n  border: 1px solid var(--#{$prefix}border-color);\r\n  box-shadow: none;\r\n  background-color: $dropdown-bg;\r\n\r\n  &.datepicker-inline{\r\n    width: 212px;\r\n  }\r\n}\r\n\r\n.datepicker{\r\n  color: var(--#{$prefix}secondary-color);\r\n    .datepicker-switch:hover,.next:hover,.prev:hover,  tfoot tr th:hover {\r\n      background: var(--#{$prefix}light);\r\n    } \r\n  }\r\n\r\n\r\n.datepicker-panel{\r\n  \r\n  >ul{\r\n    >li{\r\n      background-color: $dropdown-bg;\r\n      border-radius: 4px;\r\n\r\n      &.picked, &.picked:hover{\r\n        background-color: rgba($primary, 0.25);\r\n        color: $primary;\r\n      }\r\n\r\n      &.highlighted, &.highlighted:hover, &:hover{\r\n        background-color: $primary;\r\n        color: $white;\r\n      }\r\n\r\n      \r\n      &.muted, &.muted:hover{\r\n        color: var(--#{$prefix}gray-500);\r\n        opacity: 0.6;\r\n      }\r\n    }\r\n\r\n    \r\n\r\n    &[data-view=week]{\r\n      >li{\r\n        font-weight: $font-weight-medium;\r\n      }\r\n\r\n      >li, >li:hover{\r\n        background-color: $dropdown-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Bootstrap touchspin\r\n//\r\n\r\n.bootstrap-touchspin {\r\n  &.input-group {\r\n    &>.input-group-prepend {\r\n\r\n      &>.btn,\r\n      &>.input-group-text {\r\n        border-top-right-radius: 0;\r\n        border-bottom-right-radius: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.input-group {\r\n    &>.input-group-append {\r\n\r\n      &>.btn,\r\n      &>.input-group-text {\r\n        border-top-left-radius: 0;\r\n        border-bottom-left-radius: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n}","//\r\n// Form editors.scss\r\n//\r\n\r\n// Tinymce\r\n\r\n.tox-tinymce {\r\n    border: 1px solid $input-border-color !important;\r\n}\r\n\r\n.tox :not(svg):not(rect) {\r\n    color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.tox {\r\n    color: var(--#{$prefix}body-color);\r\n    .tox-collection__item {\r\n        color: $dropdown-link-color !important;\r\n    }\r\n\r\n    .tox-menu.tox-collection.tox-collection--list.tox-selected-menu,\r\n    .tox-collection--toolbar.tox-collection--toolbar-lg.tox-selected-menu,\r\n    .tox-swatches-menu.tox-selected-menu {\r\n        box-shadow: $box-shadow-sm !important;\r\n        animation-name: DropDownSlide !important;\r\n        animation-duration: 0.3s !important;\r\n        animation-fill-mode: both !important;\r\n        margin: 0 !important;\r\n        position: absolute !important;\r\n        z-index: 1000 !important;\r\n        padding: 0.5rem 0 !important;\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n        border: $dropdown-border-width solid var(--#{$prefix}border-color) !important;\r\n        border-radius: 0.25rem !important;\r\n    }\r\n\r\n    .tox-collection--list .tox-collection__group {\r\n        border-color: var(--#{$prefix}border-color) !important;\r\n    }\r\n\r\n    .tox-collection--list {\r\n        .tox-collection__item--active {\r\n            color: $dropdown-link-hover-color !important;\r\n            background-color: $dropdown-link-hover-bg !important;\r\n        }\r\n    }\r\n\r\n    .tox-collection__group-heading {\r\n        color: $dropdown-link-hover-color !important;\r\n        background-color: $dropdown-link-hover-bg !important;\r\n    }\r\n\r\n    .tox-statusbar {\r\n        border-top: 1px solid var(--#{$prefix}border-top) !important;\r\n    }\r\n\r\n    .tox-menubar,\r\n    .tox-edit-area__iframe,\r\n    .tox-statusbar {\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n        background: none !important;\r\n    }\r\n\r\n    .tox-mbtn {\r\n        color: var(--#{$prefix}gray-600) !important;\r\n\r\n        &:hover:not(:disabled):not(.tox-mbtn--active) {\r\n            background-color: var(--#{$prefix}light) !important;\r\n        }\r\n    }\r\n\r\n    .tox-tbtn {\r\n        &:hover {\r\n            background-color: transparent !important;\r\n        }\r\n    }\r\n\r\n    .tox-toolbar,\r\n    .tox-toolbar__overflow,\r\n    .tox-toolbar__primary {\r\n        background: var(--#{$prefix}light) !important;\r\n    }\r\n\r\n    .tox-toolbar__primary {\r\n        border-top-color: var(--#{$prefix}light) !important;\r\n    }\r\n    .tox-tbtn--enabled {\r\n        background: transparent !important;\r\n    }\r\n    tox-split-button:focus {\r\n        background: transparent !important;\r\n    }\r\n    .tox-tbtn {\r\n        color: transparent !important;\r\n\r\n        svg {\r\n            fill: var(--#{$prefix}gray-700) !important;\r\n        }\r\n    }\r\n\r\n    .tox-edit-area__iframe {\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n    }\r\n\r\n    .tox-statusbar a,\r\n    .tox-statusbar__path-item,\r\n    .tox-statusbar__wordcount {\r\n        color: var(--#{$prefix}gray-700) !important;\r\n    }\r\n\r\n    &:not([dir=\"rtl\"]) .tox-toolbar__group:not(:last-of-type) {\r\n        border-right: 1px solid var(--#{$prefix}border-color) !important;\r\n    }\r\n\r\n    .tox-dialog {\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n    }\r\n    .tox-button {\r\n        &:hover {\r\n            background-color: $primary !important;\r\n            background-image: none !important;\r\n            border-color: $primary !important;\r\n            box-shadow: none !important;\r\n        }\r\n    }\r\n\r\n    .tox-collection--toolbar {\r\n        .tox-collection__item--active {\r\n            background-color: var(--#{$prefix}gray-300) !important;\r\n        }\r\n    }\r\n\r\n    .tox-dialog__header {\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n    }\r\n    .tox-dialog__footer {\r\n        background-color: var(--#{$prefix}custom-white) !important;\r\n    }\r\n    .tox-icon {\r\n        color: var(--#{$prefix}dark) !important;\r\n    }\r\n    // .tox-dialog__title {\r\n    //     color: $card-title-desc !important;\r\n    // }\r\n    // .tox-dialog__body-nav-item {\r\n    //     color: $card-title-desc !important;\r\n    // }\r\n    // .tox-label {\r\n    //     color: $card-title-desc !important;\r\n    // }\r\n    .tox-textfield {\r\n        background-color: $input-bg !important;\r\n        color: $input-color !important;\r\n    }\r\n}\r\n\r\n.tox .tox-collection__item-checkmark svg,\r\n.tox .tox-collection__item-icon svg {\r\n    color: var(--#{$prefix}gray-800);\r\n}\r\n\r\n// x editable\r\n\r\n.editable-input {\r\n    .form-control {\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.editable-buttons {\r\n    margin-left: 7px;\r\n\r\n    .editable-cancel {\r\n        margin-left: 7px;\r\n    }\r\n}\r\n","\r\n//\r\n// Form-Upload\r\n//\r\n\r\n/* Dropzone */\r\n.dropzone {\r\n  min-height: 230px;\r\n  border: 2px dashed var(--#{$prefix}border-color);\r\n  background: var(--#{$prefix}secondary-bg);\r\n  border-radius: 6px;\r\n\r\n\r\n  .dz-message {\r\n    font-size: 24px;\r\n    width: 100%;\r\n    margin: 3rem 0;\r\n  }\r\n}\r\n\r\n.dropzone .dz-message{\r\n  margin: 0;\r\n}","//\r\n// Form Wizard\r\n//\r\n\r\n\r\n.form-wizard-wrapper {\r\n  label {\r\n    font-size: 14px;\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n.wizard{\r\n\r\n  // step\r\n  .steps{\r\n    >ul{\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      padding-left: 0;\r\n      margin-bottom: 0;\r\n      list-style: none;\r\n\r\n      @media (max-width: 1199.98px) {\r\n        flex-direction: column;\r\n      }\r\n\r\n      > a, > li{\r\n        flex-basis: 0;\r\n        flex-grow: 1;\r\n      }\r\n\r\n      >li{\r\n        width: 100%;\r\n\r\n        a{\r\n          display: block;\r\n          padding: .5rem 1rem;\r\n          color: var(--#{$prefix}secondary-color);\r\n          font-weight: $font-weight-medium;\r\n\r\n          background-color: rgba($primary, 0.1);\r\n        }\r\n      }\r\n\r\n      .current-info{\r\n        position: absolute;\r\n        left: -999em;\r\n    }\r\n\r\n    \r\n    }\r\n\r\n    .number {\r\n      display: inline-block;\r\n      width: 38px;\r\n      height: 38px;\r\n      line-height: 34px;\r\n      border: 2px solid $primary;\r\n      color: $primary;\r\n      text-align: center;\r\n      border-radius: 50%;\r\n      margin-right: .5rem;\r\n    }\r\n\r\n    .current {\r\n      a, a:active, a:hover {\r\n        background-color: rgba($primary, 0.2);\r\n        color: var(--#{$prefix}emphasis-color);\r\n        .number {\r\n          background-color: $primary;\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // content\r\n  >.content {\r\n    background-color: transparent;\r\n    padding: 14px;\r\n    margin-top: 0;\r\n    border-radius: 0;\r\n    min-height: 150px;\r\n    > .title{\r\n      position: absolute;\r\n      left: -999em;\r\n    }\r\n    >.body {\r\n      width: 100%;\r\n      height: 100%;\r\n      padding: 14px 0 0;\r\n      position: static\r\n    }\r\n  }\r\n\r\n  // actions\r\n\r\n  >.actions {\r\n    position: relative;\r\n    display: block;\r\n    text-align: right;\r\n    width: 100%;\r\n    > ul {\r\n        display: block;\r\n        text-align: right;\r\n        padding-left: 0;\r\n          > li{\r\n            display: inline-block;\r\n            margin: 0 0.5em;\r\n\r\n          }\r\n      }\r\n      a, a:active, a:hover {\r\n        background-color: $primary;\r\n        border-radius: 4px;\r\n        padding: 8px 15px;\r\n        color: $white;\r\n      }\r\n\r\n      .disabled {\r\n        a, a:active, a:hover {\r\n          opacity: .65;\r\n          background-color: $primary;\r\n          color: $white;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n  }\r\n\r\n  // verticl wixard\r\n  &.vertical-wizard{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n    // step\r\n    .steps{\r\n      >ul{\r\n        flex-direction: column;\r\n\r\n        >li{\r\n            width: 100% !important;\r\n        }\r\n        \r\n      }\r\n    }\r\n\r\n    .steps, .content, .actions{\r\n      width: 100%;\r\n    }\r\n\r\n    .steps{\r\n        @media (min-width: 1200px) {\r\n          width: 25%;\r\n      }\r\n    }\r\n\r\n      .content{\r\n        padding: 24px;\r\n        @media (min-width: 1200px) {\r\n          width: 75%;\r\n          padding: 12px 24px;\r\n      }\r\n\r\n      >.body{\r\n        padding: 0;\r\n      }\r\n      \r\n    }\r\n  }\r\n}\r\n","/* \r\nDatatable\r\n*/\r\n\r\n// datatable\r\n\r\ndiv.dataTables_wrapper {\r\n  div.dataTables_filter {\r\n    text-align: right;\r\n\r\n    @media (max-width: 767px) {\r\n      text-align: center;\r\n    }\r\n\r\n\r\n    input {\r\n      margin-left: 0.5em;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.table,\r\ntable {\r\n  &.dataTable {\r\n    border-collapse: collapse !important;\r\n    &.dtr-inline.collapsed>tbody>tr>td {\r\n      position: relative;\r\n\r\n      &.dtr-control {\r\n        padding-left: 30px;\r\n\r\n        &:before {\r\n          top: 50%;\r\n          left: 5px;\r\n          height: 14px;\r\n          width: 14px;\r\n          margin-top: -9px;\r\n          display: block;\r\n          position: absolute;\r\n          color: $white;\r\n          border: 2px solid $white;\r\n          border-radius: 14px;\r\n          box-sizing: content-box;\r\n          text-align: center;\r\n          text-indent: 0 !important;\r\n          line-height: 14px;\r\n          content: '+';\r\n          background-color: $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","\r\n//\r\n// Responsive Table\r\n//\r\n\r\n.table-rep-plugin {\r\n  .btn-toolbar {\r\n    display: block;\r\n  }\r\n  .table-responsive {\r\n    border: none !important;\r\n  }\r\n  .btn-group{\r\n    .btn-default {\r\n      background-color: $secondary;\r\n      color: $light;\r\n      border: 1px solid $secondary;\r\n      &.btn-primary {\r\n          background-color: $primary;\r\n          border-color: $primary;\r\n          color: $white;\r\n          box-shadow: 0 0 0 2px rgba($primary, .5);\r\n      }\r\n  }\r\n    &.pull-right {\r\n      float: right;\r\n      .dropdown-menu {\r\n        right: 0;\r\n        transform: none !important;\r\n        top: 100% !important;\r\n      }\r\n    }\r\n  }\r\n  tbody {\r\n    th {\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n    }\r\n  }\r\n\r\n  .checkbox-row {\r\n    padding-left: 40px;\r\n    color: $dropdown-color !important;\r\n\r\n    &:hover{\r\n      background-color: lighten($gray-200, 2%) !important;\r\n    }\r\n\r\n    label {\r\n      display: inline-block;\r\n      padding-left: 5px;\r\n      position: relative;\r\n      &::before {\r\n        -o-transition: 0.3s ease-in-out;\r\n        -webkit-transition: 0.3s ease-in-out;\r\n        background-color: $white;\r\n        border-radius: 3px;\r\n        border: 1px solid $gray-300;\r\n        content: \"\";\r\n        display: inline-block;\r\n        height: 17px;\r\n        left: 0;\r\n        margin-left: -20px;\r\n        position: absolute;\r\n        transition: 0.3s ease-in-out;\r\n        width: 17px;\r\n        outline: none !important;\r\n      }\r\n      &::after {\r\n        color: $gray-200;\r\n        display: inline-block;\r\n        font-size: 11px;\r\n        height: 16px;\r\n        left: 0;\r\n        margin-left: -20px;\r\n        padding-left: 3px;\r\n        padding-top: 1px;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 16px;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"] {\r\n      cursor: pointer;\r\n      opacity: 0;\r\n      z-index: 1;\r\n      outline: none !important;\r\n\r\n      &:disabled + label {\r\n        opacity: 0.65;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:focus + label {\r\n      &::before {\r\n        outline-offset: -2px;\r\n        outline: none;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:checked + label {\r\n      &::after {\r\n        content: \"\\f00c\";\r\n        font-family: 'Font Awesome 5 Free';\r\n        font-weight: 900;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:disabled + label {\r\n      &::before {\r\n        background-color: $gray-100;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:checked + label {\r\n      &::before {\r\n        background-color: $primary;\r\n        border-color: $primary;\r\n      }\r\n      &::after {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fixed-solution {\r\n    .sticky-table-header{\r\n      top: $header-height !important;\r\n      background-color: $primary;\r\n      table{\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  table.focus-on tbody tr.focused th,\r\n  table.focus-on tbody tr.focused td,\r\n  .sticky-table-header {\r\n      background: $primary;\r\n      border-color: $primary;\r\n      color: $white;\r\n\r\n      table {\r\n          color: $white;\r\n      }\r\n  }\r\n\r\n    table.focus-on tbody tr.unfocused th,\r\n    table.focus-on tfoot tr.unfocused th,\r\n    table.focus-on tbody tr.unfocused td,\r\n    table.focus-on tfoot tr.unfocused td {\r\n      color: var(--#{$prefix}body-color);\r\n    }\r\n}\r\n\r\nbody[data-layout=\"horizontal\"] {\r\n  @media (min-width: 992px) {\r\n    .fixed-solution {\r\n      .sticky-table-header{\r\n        top: $header-height + 50px !important;;\r\n      }\r\n    }\r\n  }\r\n}","\r\n//\r\n// Table editable\r\n//\r\n\r\n.table-edits{\r\n  input, select{\r\n    height: $input-height-sm;\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    border: 1px solid $input-border-color;\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    border-radius: $input-border-radius;\r\n    &:focus{\r\n      outline: none;\r\n      border-color: $input-focus-border-color;\r\n    }\r\n  }\r\n}","\r\n//\r\n// apexcharts.scss\r\n//\r\n.apex-charts {\r\n    min-height: 10px !important;\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: var(--#{$prefix}gray-500);\r\n    }\r\n    .apexcharts-canvas {\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip-title,\r\n.apexcharts-tooltip-text {\r\n    font-family: $font-family-base !important;\r\n}\r\n\r\n.apexcharts-legend-series {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.apexcharts-gridline {\r\n    pointer-events: none;\r\n    stroke: $apex-grid-color;\r\n}\r\n\r\n.apexcharts-legend-text {\r\n    color: #74788d !important;\r\n    font-family: $font-family-base !important;\r\n    font-size: 13px !important;\r\n}\r\n\r\n.apexcharts-pie-label {\r\n    fill: $white !important;\r\n}\r\n\r\n.apexcharts-yaxis,\r\n.apexcharts-xaxis {\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: var(--#{$prefix}secondary-color);\r\n    }\r\n}\r\n\r\n.apexcharts-gridline {\r\n    stroke: var(--#{$prefix}border-color);\r\n}\r\n\r\n.apexcharts-radialbar-track.apexcharts-track {\r\n    path {\r\n        stroke: var(--#{$prefix}border-color);\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip {\r\n    background-color: var(--#{$prefix}secondary-bg) !important;\r\n    border: 1px solid var(--#{$prefix}border-color) !important;\r\n\r\n    .apexcharts-tooltip-title {\r\n        background-color: var(--#{$prefix}border-color) !important;\r\n        border-bottom: 1px solid var(--#{$prefix}border-color) !important;\r\n    }\r\n}\r\n\r\n.apexcharts-pie-label {\r\n    fill: var(--#{$prefix}white) !important;\r\n}\r\n\r\n.apexcharts-xaxis-tick {\r\n    stroke: var(--#{$prefix}border-color);\r\n}","\r\n//\r\n// echarts.scss\r\n//\r\n\r\n.e-charts{\r\n    height: 350px;\r\n}","\r\n\r\n/* Flot chart */\r\n.flot-charts-height {\r\n  height: 320px;\r\n}\r\n\r\n.flotTip {\r\n  padding: 8px 12px;\r\n  background-color: rgba($dark, 0.9);\r\n  z-index: 100;\r\n  color: $gray-100;\r\n  box-shadow: $box-shadow;\r\n  border-radius: 4px;\r\n}\r\n\r\n.legendLabel{\r\n  color: $gray-500;\r\n}","//\r\n// sparkline.scss\r\n//\r\n\r\n.jqstooltip {\r\n  box-sizing: content-box;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  background-color: $gray-800 !important;\r\n  box-shadow: $box-shadow-lg;\r\n  padding: 5px 10px !important;\r\n  border-radius: 3px;\r\n  border-color: $gray-900 !important;\r\n}\r\n\r\n.jqsfield {\r\n  color: $gray-200 !important;\r\n  font-size: 12px !important;\r\n  line-height: 18px !important;\r\n  font-family: $font-family-base !important;\r\n  font-weight: $font-weight-medium !important;\r\n}\r\n","\r\n//\r\n// Google map\r\n//\r\n\r\n.gmaps, .gmaps-panaroma {\r\n  height: 300px !important;\r\n  background: $gray-100;\r\n  border-radius: 3px;\r\n}\r\n\r\n.gmaps-overlay {\r\n  display: block;\r\n  text-align: center;\r\n  color: $white;\r\n  font-size: 16px;\r\n  line-height: 40px;\r\n  background: $primary;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.gmaps-overlay_arrow {\r\n  left: 50%;\r\n  margin-left: -16px;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  &.above {\r\n    bottom: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-top: 16px solid $primary;\r\n  }\r\n  &.below {\r\n    top: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-bottom: 16px solid $primary;\r\n  }\r\n  \r\n}","//\r\n// vector-maps.scss\r\n//\r\n\r\n.jvectormap-label {\r\n    border: none;\r\n    background: $gray-800;\r\n    color: $gray-100;\r\n    font-family: $font-family-base;\r\n    font-size: $font-size-base;\r\n    padding: 5px 8px;\r\n}","//\r\n// leaflet-maps.scss\r\n//\r\n\r\n.leaflet-map {\r\n    height: 300px;\r\n    &.leaflet-container{\r\n        z-index: 99;\r\n    }\r\n}","// \r\n// authentication.scss\r\n//\r\n\r\n\r\n// authentication home icon\r\n.home-btn {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 25px;\r\n}\r\n\r\n// auth 2\r\n\r\n.auth-logo{\r\n    .auth-logo-dark{\r\n        display: var(--#{$prefix}display-block);\r\n    }\r\n    .auth-logo-light{\r\n        display: var(--#{$prefix}display-none);\r\n    }\r\n}\r\n\r\n.auth-body-bg{\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n}\r\n\r\n\r\n// auth-pass-inputgroup\r\n\r\n.auth-pass-inputgroup{\r\n    input[type=\"input\"] + .btn .mdi-eye-outline{\r\n        &:before{\r\n            content: \"\\F06D1\";\r\n        }\r\n    }\r\n}\r\n\r\n// authentication full page\r\n\r\n.auth-full-bg{\r\n    background-color: rgba($primary, 0.25);\r\n    display: flex;\r\n\r\n    @media (min-width: 1200px){\r\n        height: 100vh;\r\n    }\r\n    \r\n\r\n    &::before{\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 300px;\r\n        height: 300px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .bg-overlay{\r\n        background: url(\"../../../images/bg-auth-overlay.png\");\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n    }\r\n}\r\n\r\n.auth-full-page-content{\r\n    display: flex;\r\n\r\n    @media (min-width: 1200px){\r\n        min-height: 100vh;\r\n    }\r\n}\r\n\r\n.auth-review-carousel{\r\n    &.owl-theme {\r\n        .owl-dots {\r\n            .owl-dot{\r\n                span{\r\n                    background-color: rgba($primary, 0.25);\r\n                }\r\n                &.active, &:hover{\r\n                    span{\r\n                        background-color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// ecommerce.scss\r\n//\r\n\r\n// product\r\n\r\n.search-box {\r\n    .form-control {\r\n        // border-radius: 30px;\r\n        border-radius: 0px;\r\n        padding-left: 40px;\r\n    }\r\n\r\n    .search-icon {\r\n        font-size: 16px;\r\n        position: absolute;\r\n        left: 13px;\r\n        top: 0;\r\n        line-height: 38px;\r\n    }\r\n}\r\n\r\n.product-list {\r\n    li {\r\n        a {\r\n            display: block;\r\n            padding: 4px 0px;\r\n            color: var(--#{$prefix}body-color);\r\n        }\r\n    }\r\n}\r\n\r\n.product-view-nav {\r\n    &.nav-pills {\r\n        .nav-item {\r\n            margin-left: 4px;\r\n        }\r\n\r\n        .nav-link {\r\n            width: 36px;\r\n            height: 36px;\r\n            font-size: 16px;\r\n            padding: 0;\r\n            line-height: 36px;\r\n            text-align: center;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.product-ribbon {\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n}\r\n\r\n// Product Details\r\n\r\n.product-detai-imgs {\r\n    .nav {\r\n        .nav-link {\r\n            margin: 7px 0px;\r\n\r\n            &.active {\r\n                background-color: var(--#{$prefix}tertiary-bg);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.product-color {\r\n    a {\r\n        display: inline-block;\r\n        text-align: center;\r\n        color: var(--#{$prefix}body-color);\r\n\r\n        .product-color-item {\r\n            margin: 7px;\r\n        }\r\n\r\n        &.active,\r\n        &:hover {\r\n            color: $primary;\r\n\r\n            .product-color-item {\r\n                border-color: $primary !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// ecommerce cart\r\n\r\n.visa-card {\r\n    .visa-logo {\r\n        line-height: 0.5;\r\n    }\r\n\r\n    .visa-pattern {\r\n        position: absolute;\r\n        font-size: 385px;\r\n        color: rgba($white, 0.05);\r\n        line-height: 0.4;\r\n        right: 0px;\r\n        bottom: 0px;\r\n    }\r\n}\r\n\r\n\r\n// checkout\r\n\r\n.checkout-tabs {\r\n    .nav-pills {\r\n        .nav-link {\r\n            margin-bottom: 24px;\r\n            text-align: center;\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n            box-shadow: $box-shadow;\r\n\r\n            &.active {\r\n                background-color: $primary;\r\n            }\r\n\r\n            .check-nav-icon {\r\n                font-size: 36px;\r\n            }\r\n        }\r\n    }\r\n}","/* ==============\r\n  Email\r\n===================*/\r\n.email-leftbar {\r\n  width: 236px;\r\n  float: left;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.email-rightbar {\r\n  margin-left: 260px;\r\n}\r\n\r\n.chat-user-box {\r\n  p.user-title {\r\n    color: var(--#{$prefix}emphasis-color);\r\n    font-weight: 500;\r\n  }\r\n  p {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .email-leftbar {\r\n    float: none;\r\n    width: 100%;\r\n  }\r\n  .email-rightbar {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n\r\n.mail-list {\r\n  a {\r\n    display: block;\r\n    color: var(--#{$prefix}secondary-color);\r\n    line-height: 24px;\r\n    padding: 8px 5px;\r\n    &.active {\r\n      color: $danger;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.message-list {\r\n  display: block;\r\n  padding-left: 0;\r\n\r\n  li {\r\n    position: relative;\r\n    display: block;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    cursor: default;\r\n    transition-duration: .3s;\r\n\r\n    a{\r\n      color: var(--#{$prefix}secondary-color);\r\n    }\r\n\r\n    &:hover {\r\n      background: var(--#{$prefix}tertiary-bg);\r\n      transition-duration: .05s;\r\n    }\r\n\r\n    .col-mail {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n\r\n    .col-mail-1 {\r\n      width: 320px;\r\n\r\n      .star-toggle,\r\n      .checkbox-wrapper-mail,\r\n      .dot {\r\n        display: block;\r\n        float: left;\r\n      }\r\n\r\n      .dot {\r\n        border: 4px solid transparent;\r\n        border-radius: 100px;\r\n        margin: 22px 26px 0;\r\n        height: 0;\r\n        width: 0;\r\n        line-height: 0;\r\n        font-size: 0;\r\n      }\r\n\r\n      .checkbox-wrapper-mail {\r\n        margin: 15px 10px 0 20px;\r\n      }\r\n\r\n      .star-toggle {\r\n        margin-top: 18px;\r\n        margin-left: 5px;\r\n      }\r\n\r\n      .title {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 110px;\r\n        right: 0;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n\r\n    .col-mail-2 {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 320px;\r\n      right: 0;\r\n      bottom: 0;\r\n\r\n      .subject,\r\n      .date {\r\n        position: absolute;\r\n        top: 0;\r\n      }\r\n\r\n      .subject {\r\n        left: 0;\r\n        right: 200px;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n      }\r\n\r\n      .date {\r\n        right: 0;\r\n        width: 170px;\r\n        padding-left: 80px;\r\n      }\r\n    }\r\n\r\n    &.active,\r\n    &.active:hover {\r\n      box-shadow: inset 3px 0 0 $primary;\r\n    }\r\n\r\n    \r\n  &.unread  {\r\n    background-color: var(--#{$prefix}tertiary-bg);\r\n    font-weight: 500;\r\n    color: var(--#{$prefix}body-color);\r\n      a{\r\n        color: var(--#{$prefix}body-color);\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  .checkbox-wrapper-mail {\r\n    cursor: pointer;\r\n    height: 20px;\r\n    width: 20px;\r\n    position: relative;\r\n    display: inline-block;\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n    box-shadow: inset 0 0 0 1px var(--#{$prefix}border-color-translucent);\r\n    border-radius: 1px;\r\n\r\n    input {\r\n      opacity: 0;\r\n      cursor: pointer;\r\n    }\r\n    input:checked ~ label {\r\n      opacity: 1;\r\n    }\r\n\r\n    label {\r\n      position: absolute;\r\n      height: 20px;\r\n      width: 20px;\r\n      left: 0;\r\n      cursor: pointer;\r\n      opacity: 0;\r\n      margin-bottom: 0;\r\n      transition-duration: .05s;\r\n      top: 0;\r\n      &:before {\r\n        content: \"\\F012C\";\r\n        font-family: \"Material Design Icons\";\r\n        top: 0;\r\n        height: 20px;\r\n        color: var(--#{$prefix}body-color);\r\n        width: 20px;\r\n        position: absolute;\r\n        margin-top: -16px;\r\n        left: 4px;\r\n        font-size: 13px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) { \r\n  .message-list li .col-mail-1 {\r\n      width: 200px;\r\n  }\r\n}","// \r\n// File manager.scss\r\n//\r\n\r\n// file manager\r\n\r\n.filemanager-sidebar{\r\n    \r\n    @media (min-width: 1200px){\r\n        min-width: 230px;\r\n        max-width: 230px;\r\n    }\r\n\r\n    @media (min-width: 1366px){\r\n        min-width: 280px;\r\n        max-width: 280px;\r\n    }\r\n\r\n}\r\n\r\n.categories-list{\r\n    padding: 4px 0;\r\n    li{\r\n        a{\r\n            display: block;\r\n            padding: 8px 12px;\r\n            color: var(--#{$prefix}body-color);\r\n            font-weight: $font-weight-medium;\r\n        }\r\n\r\n        &.active{\r\n            a{\r\n                color: $primary;\r\n            }\r\n        }\r\n\r\n        ul{\r\n            padding-left: 16px;\r\n            li{\r\n                a{\r\n                    padding: 4px 12px;\r\n                    color: var(--#{$prefix}secondary-color);\r\n                    font-size: 13px;\r\n                    font-weight: $font-weight-normal;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n","//\r\n// Chat.scss\r\n//\r\n\r\n.chat-leftsidebar {\r\n    @media (min-width: 992px) {\r\n        min-width: 260px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n        min-width: 380px;\r\n    }\r\n\r\n    .chat-leftsidebar-nav {\r\n        .nav {\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n        }\r\n\r\n        .tab-content {\r\n            min-height: 488px;\r\n        }\r\n    }\r\n}\r\n\r\n.chat-noti-dropdown {\r\n    &.active {\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 8px;\r\n            height: 8px;\r\n            background-color: $danger;\r\n            border-radius: 50%;\r\n            right: 0;\r\n        }\r\n    }\r\n\r\n    .btn {\r\n        padding: 6px;\r\n        box-shadow: none;\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n.chat-search-box {\r\n    .form-control {\r\n        border: 0;\r\n    }\r\n}\r\n\r\n.chat-list {\r\n    margin: 0;\r\n    li {\r\n        &.active {\r\n            a {\r\n                background-color: var(--#{$prefix}secondary-bg);\r\n                border-color: transparent;\r\n                box-shadow: $box-shadow;\r\n            }\r\n        }\r\n        a {\r\n            display: block;\r\n            padding: 14px 16px;\r\n            color: var(--#{$prefix}secondary-color);\r\n            transition: all 0.4s;\r\n            border-top: 1px solid var(--#{$prefix}border-color);\r\n            border-radius: 4px;\r\n            &:hover {\r\n                background-color: var(--#{$prefix}secondary-bg);\r\n                border-color: transparent;\r\n                box-shadow: $box-shadow;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.user-chat-nav {\r\n    .dropdown {\r\n        .nav-btn {\r\n            color: var(--#{$prefix}body-color);\r\n            height: 40px;\r\n            width: 40px;\r\n            line-height: 42px;\r\n            box-shadow: none;\r\n            padding: 0;\r\n            font-size: 16px;\r\n            background-color: var(--#{$prefix}light);\r\n            border-radius: 50%;\r\n            border: none;\r\n        }\r\n\r\n        .dropdown-menu {\r\n            box-shadow: $box-shadow;\r\n            border: 1px solid var(--#{$prefix}border-color);\r\n        }\r\n    }\r\n}\r\n\r\n.chat-conversation {\r\n    li {\r\n        clear: both;\r\n    }\r\n\r\n    .chat-day-title {\r\n        position: relative;\r\n        text-align: center;\r\n        margin-bottom: 24px;\r\n\r\n        .title {\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n            position: relative;\r\n            z-index: 1;\r\n            padding: 6px 24px;\r\n        }\r\n\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 1px;\r\n            left: 0;\r\n            right: 0;\r\n            background-color: var(--#{$prefix}border-color);\r\n            top: 10px;\r\n        }\r\n        .badge {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    .conversation-list {\r\n        margin-bottom: 24px;\r\n        display: inline-block;\r\n        position: relative;\r\n\r\n        .ctext-wrap {\r\n            padding: 12px 24px;\r\n            background-color: rgba($primary, 0.1);\r\n            border-radius: 8px 8px 8px 0px;\r\n            overflow: hidden;\r\n\r\n            .conversation-name {\r\n                font-weight: $font-weight-semibold;\r\n                color: $primary;\r\n                margin-bottom: 4px;\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            float: right;\r\n            .dropdown-toggle {\r\n                font-size: 18px;\r\n                padding: 4px;\r\n                color: var(--#{$prefix}secondary-color);\r\n                @media (max-width: 575.98px) {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .dropdown-menu {\r\n                box-shadow: $box-shadow;\r\n                border: 1px solid var(--#{$prefix}border-color);\r\n            }\r\n        }\r\n\r\n        .chat-time {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n\r\n    .right {\r\n        .conversation-list {\r\n            float: right;\r\n            .ctext-wrap {\r\n                background-color: var(--#{$prefix}light);\r\n                text-align: right;\r\n                border-radius: 8px 8px 0px 8px;\r\n            }\r\n            .dropdown {\r\n                float: left;\r\n            }\r\n\r\n            &.last-chat {\r\n                .conversation-list {\r\n                    &:before {\r\n                        right: 0;\r\n                        left: auto;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .last-chat {\r\n        .conversation-list {\r\n            &:before {\r\n                content: \"\\F0009\";\r\n                font-family: \"Material Design Icons\";\r\n                position: absolute;\r\n                color: $primary;\r\n                right: 0;\r\n                bottom: 0;\r\n                font-size: 16px;\r\n\r\n                @media (max-width: 575.98px) {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.chat-input-section {\r\n    border-top: 1px solid var(--#{$prefix}border-color);\r\n}\r\n\r\n.chat-input {\r\n    border-radius: 30px;\r\n    background-color: var(--#{$prefix}light) !important;\r\n    border-color: var(--#{$prefix}light) !important;\r\n    padding-right: 120px;\r\n}\r\n\r\n.chat-input-links {\r\n    position: absolute;\r\n    right: 16px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    li {\r\n        a {\r\n            font-size: 16px;\r\n            line-height: 36px;\r\n            padding: 0px 4px;\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n.chat-send {\r\n    @media (max-width: 575.98px) {\r\n        min-width: auto;\r\n    }\r\n}\r\n","// \r\n// projects.scss\r\n//\r\n\r\n// project list\r\n\r\n.project-list-table {\r\n  border-collapse: separate;\r\n  border-spacing: 0 12px;\r\n\r\n  tr {\r\n    background-color: var(--#{$prefix}secondary-bg);\r\n  }\r\n}","// \r\n// Contacts.scss\r\n//\r\n\r\n.contact-links{\r\n  a{\r\n    color: var(--#{$prefix}body-color);\r\n  }\r\n}\r\n\r\n// profile\r\n\r\n.profile-user-wid{\r\n  margin-top: -26px;\r\n}","// \r\n// crypto.scss\r\n//\r\n\r\n@media (min-width: 576px){\r\n    .currency-value{\r\n        position: relative;\r\n        &:after{\r\n            content: \"\\F04E1\";\r\n            font-family: \"Material Design Icons\";\r\n            font-size: 24px;\r\n            position: absolute;\r\n            width: 45px;\r\n            height: 45px;\r\n            line-height: 45px;\r\n            border-radius: 50%;\r\n            text-align: center;\r\n            right: 0;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            background-color: $primary;\r\n            color: $white;\r\n            z-index: 9;\r\n            right: -34px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.crypto-buy-sell-nav-content{\r\n    border: 2px solid var(--#{$prefix}border-color);\r\n    border-top: 0;\r\n}\r\n\r\n\r\n// KYC Application\r\n\r\n.kyc-doc-verification{\r\n    .dropzone{\r\n        min-height: 180px;\r\n        .dz-message{\r\n            margin: 24px 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/******************\r\n    Ico Landing\r\n*******************/\r\n\r\n.section{\r\n    position: relative;\r\n    padding-top: 80px;\r\n    padding-bottom: 80px;\r\n\r\n    &.bg-white{\r\n        background-color: var(--#{$prefix}secondary-bg) !important;\r\n    }\r\n}\r\n\r\n.small-title{\r\n    color: var(--#{$prefix}secondary-color);\r\n    margin-bottom: 8px;\r\n}\r\n\r\n\r\n// Navigation\r\n\r\n.navigation {\r\n    padding: 0 16px;\r\n    width: 100%;\r\n    z-index: 999;\r\n    margin-bottom: 0px;\r\n    transition: all 0.5s ease-in-out;\r\n    border-bottom: 1px solid rgba($white, 0.1);\r\n\r\n    @media (max-width: 991.98px) {\r\n        background-color: var(--#{$prefix}topnav-bg);\r\n    }\r\n    \r\n    .navbar-logo{\r\n        line-height: 70px;\r\n        transition: all 0.4s;\r\n        .logo-dark{\r\n            display: none;\r\n            @media (max-width: 991.98px) {\r\n                display: block;\r\n            }\r\n        }\r\n        .logo-light{\r\n            display: block;\r\n            @media (max-width: 991.98px) {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n    \r\n\r\n    .navbar-nav{\r\n        .nav-item{\r\n            .nav-link{\r\n                color: rgba($white, 0.6);\r\n                line-height: 58px;\r\n                padding: 6px 16px;\r\n                font-weight: $font-weight-medium;\r\n                transition: all 0.4s;\r\n\r\n                @media (max-width: 991.98px) {\r\n                    color: var(--#{$prefix}header-item-color);\r\n                }\r\n\r\n                &:hover,\r\n                &.active {\r\n                    color: rgba($white, 0.9);\r\n\r\n                    @media (max-width: 991.98px) {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n\r\n                @media (max-width: 991.98px) {\r\n                    line-height: 28px !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-sticky{\r\n        background-color: var(--#{$prefix}topnav-bg);\r\n        box-shadow: $box-shadow;\r\n        .navbar-logo{\r\n            line-height: 60px;\r\n\r\n            .logo-dark{\r\n                display: var(--#{$prefix}display-block);\r\n            }\r\n            .logo-light{\r\n                display: var(--#{$prefix}display-none);\r\n            }\r\n        }\r\n\r\n        .navbar-nav {\r\n            .nav-item {\r\n                .nav-link {\r\n                    line-height: 48px;\r\n                    color: var(--#{$prefix}header-item-color);\r\n\r\n                    &:hover,\r\n                    &.active {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.bg-overlay{\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    top: 0;\r\n    opacity: 0.7;\r\n    background-color: $black;\r\n}\r\n\r\n.hero-section{\r\n    padding-top: 220px;\r\n    padding-bottom: 190px;\r\n\r\n    &.bg-ico-hero{\r\n        background-image: url(\"../../../images/crypto/bg-ico-hero.jpg\");\r\n        background-size: cover;\r\n        background-position: top;\r\n    }\r\n\r\n    @media (max-width: 575.98px) {\r\n        padding-top: 140px;\r\n        padding-bottom: 80px;\r\n    }\r\n\r\n    .hero-title{\r\n        font-size: 42px;\r\n        @media (max-width: 575.98px) {\r\n            font-size: 26px;\r\n        }\r\n    }\r\n\r\n    .ico-countdown{\r\n        font-size: 22px;\r\n        margin-right: -12px;\r\n        margin-left: -12px;\r\n        @media (max-width: 575.98px) {\r\n            display: block;\r\n        }\r\n        .coming-box{\r\n            margin-right: 12px;\r\n            margin-left: 12px;\r\n            border: 1px solid var(--#{$prefix}border-color);\r\n            border-radius: 4px;\r\n            padding: 8px;\r\n            background-color: var(--#{$prefix}secondary-bg);\r\n\r\n            @media (max-width: 575.98px) {\r\n                display: inline-block;\r\n                width: 40%;\r\n                margin-bottom: 24px;\r\n            }\r\n\r\n            span{\r\n                background-color: var(--#{$prefix}light);\r\n                font-size: 12px;\r\n                padding: 4px;\r\n                margin-top: 8px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .softcap-progress{\r\n        overflow: visible;\r\n\r\n        .progress-bar{\r\n            overflow: visible;\r\n        }\r\n\r\n        .progress-label{\r\n            position: relative;\r\n            text-align: right;\r\n            color: var(--#{$prefix}body-color);\r\n            bottom: 20px;\r\n            font-size: 12px;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// currency price\r\n\r\n.currency-price{\r\n    position: relative;\r\n    bottom: 40px;\r\n}\r\n\r\n\r\n// Clients\r\n\r\n.client-images {\r\n    img {\r\n        max-height: 34px;\r\n        width: auto !important;\r\n        margin: 12px auto;\r\n        opacity: 0.7;\r\n        transition: all 0.4s;\r\n    }\r\n}\r\n\r\n\r\n// Features\r\n\r\n.features-number{\r\n    opacity: 0.1;\r\n}\r\n\r\n\r\n// Team\r\n\r\n.team-box{\r\n    .team-social-links{\r\n        a{\r\n            color: var(--#{$prefix}body-color);\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n\r\n// Blog\r\n\r\n.blog-box{\r\n    .blog-badge{\r\n        position: absolute;\r\n        top: 12px;\r\n        right: 12px;\r\n    }\r\n}\r\n\r\n// landing footer\r\n\r\n.landing-footer{\r\n    padding: 80px 0 40px;\r\n    background-color: $sidebar-dark-bg;\r\n    color: rgba($white, 0.5);\r\n\r\n    .footer-list-title{\r\n        color: rgba($white, 0.9);\r\n    }\r\n\r\n    .footer-list-menu {\r\n        li {\r\n            a {\r\n                display: block;\r\n                color: rgba($white, 0.5);\r\n                margin-bottom: 14px;\r\n                transition: all 0.4s;\r\n                &:hover{\r\n                    color: rgba($white, 0.8);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .blog-post{\r\n\r\n        .post{\r\n            display: block;\r\n            color: rgba($white, 0.5);\r\n            padding: 16px 0px;\r\n            border-bottom: 1px solid rgba($white, 0.1);\r\n            .post-title{\r\n                color: rgba($white, 0.8);\r\n                font-size: 14px;\r\n            }\r\n\r\n            &:first-of-type{\r\n                padding-top: 0;\r\n            }\r\n\r\n            &:last-of-type{\r\n                padding-bottom: 0;\r\n                border-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .footer-border{\r\n        border-color: rgba($white, 0.1);\r\n    }\r\n}\r\n\r\n","// \r\n// coming-soon.scss\r\n//\r\n\r\n.counter-number {\r\n    font-size: 32px;\r\n    font-weight: $font-weight-semibold;\r\n    text-align: center;\r\n    display: flex;\r\n    span {\r\n        font-size: 16px;\r\n        font-weight: $font-weight-normal;\r\n        display: block;\r\n        padding-top: 5px;\r\n    }\r\n}\r\n\r\n.coming-box {\r\n    width: 25%;\r\n}\r\n","// \r\n// timeline.scss\r\n//\r\n\r\n/************** Horizontal timeline **************/ \r\n\r\n\r\n.hori-timeline{\r\n    .events{\r\n        .event-list{\r\n            text-align: center;\r\n            display: block;\r\n\r\n            .event-down-icon{\r\n                position: relative;\r\n                &::before{\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    width: 100%;\r\n                    top: 16px;\r\n                    left: 0;\r\n                    right: 0;\r\n                    border-bottom: 3px dashed var(--#{$prefix}border-color);\r\n                }\r\n                .down-arrow-icon{\r\n                    position: relative;\r\n                    border-bottom: 3px dashed var(--#{$prefix}border-color);\r\n                    padding: 4px;\r\n                }\r\n            }\r\n\r\n            &:hover{\r\n                .down-arrow-icon{\r\n                    animation: fade-down 1.5s infinite linear;\r\n                }\r\n            }\r\n\r\n            &.active{\r\n                .down-arrow-icon{\r\n                    animation: fade-down 1.5s infinite linear;\r\n                    &:before {\r\n                        content: \"\\ec4c\";\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/************** vertical timeline **************/ \r\n\r\n.verti-timeline{\r\n    border-left: 3px dashed var(--#{$prefix}border-color);\r\n    margin: 0 10px;\r\n    .event-list{\r\n        position: relative;\r\n        padding: 0px 0px 40px 30px;\r\n\r\n        .event-timeline-dot{\r\n            position: absolute;\r\n            left: -9px;\r\n            top: 0px;\r\n            z-index: 9;\r\n            font-size: 16px;\r\n        }\r\n        .event-content{\r\n            position: relative;\r\n            border: 2px solid var(--#{$prefix}border-color);\r\n            border-radius: 7px;\r\n        }\r\n\r\n        &.active{\r\n            .event-timeline-dot{\r\n                color: $primary;\r\n            }\r\n        }\r\n\r\n        &:last-child{\r\n            padding-bottom: 0px;\r\n        }\r\n    }\r\n}","// \r\n// Extras pages.scss\r\n//\r\n\r\n\r\n// pricing\r\n\r\n\r\n.plan-box{\r\n    .plan-btn{\r\n        position: relative;\r\n\r\n        &::before{\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 2px;\r\n            background: var(--#{$prefix}border-color);\r\n            left: 0px;\r\n            right: 0px;\r\n            top: 12px;\r\n        }\r\n    }\r\n}\r\n\r\n// blog\r\n\r\n.blog-play-icon{\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    margin: 0px auto;\r\n}\r\n\r\n.logo-dark-element{\r\n    display: block;\r\n}\r\n\r\n.logo-light-element{\r\n    display: none;\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .logo-dark-element{\r\n        display: none;\r\n    }\r\n    \r\n    .logo-light-element{\r\n        display: block;\r\n    }\r\n}","//\r\n// _jobs.scss\r\n//\r\n\r\n.jobs-categories {\r\n    a {\r\n        color: var(--#{$prefix}body-color); \r\n        transition: all 0.5s ease;\r\n        &:hover  {\r\n            color: $primary;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
